(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92888],{

/***/ 666222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ OTPInput; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);



const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const StyledInput = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].input`
  width: 42.5px;
  height: 42.5px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  outline: none;
  margin-top: 40px;
  margin-bottom: 25px;
  &:focus {
    border: 1px solid #eb1f3a;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const OptWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  justify-content: space-between;
`;
const OTPInput = ({
  className,
  onChange
}) => {
  const [otp, setOtp] = react__WEBPACK_IMPORTED_MODULE_0__.useState(["", "", "", "", "", ""]);
  const otpRefs = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var _a;
    if ((_a = otpRefs.current) == null ? void 0 : _a[0])
      otpRefs.current[0].focus();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (onChange)
      onChange(otp.join(""));
  }, [JSON.stringify(otp)]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(OptWrapper, {
    className
  }, otp.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "number",
    key: index,
    value: item,
    onChange: (e) => {
      var _a;
      const length = e.target.value.length;
      const value = e.target.value.slice(length - 1, length);
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (index !== otp.length - 1)
        (_a = otpRefs.current) == null ? void 0 : _a[index + 1].focus();
    },
    ref: (e) => {
      if (!otpRefs.current)
        otpRefs.current = [];
      otpRefs.current[index] = e;
    },
    onKeyDown: (e) => {
      var _a, _b;
      const handleDelete = (e2) => {
        var _a2;
        e2.preventDefault();
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
        if (index !== 0)
          (_a2 = otpRefs.current) == null ? void 0 : _a2[index - 1].focus();
      };
      switch (e.keyCode) {
        case BACKSPACE:
        case DELETE:
          handleDelete(e);
          break;
        case LEFT_ARROW:
          if (index !== 0)
            (_a = otpRefs.current) == null ? void 0 : _a[index - 1].focus();
          break;
        case RIGHT_ARROW:
          if (index !== otp.length - 1)
            (_b = otpRefs.current) == null ? void 0 : _b[index + 1].focus();
          break;
      }
    }
  })));
};




/***/ }),

/***/ 843687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ UpdatePhoneNumberModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(312388);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(849114);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(217452);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(927307);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(886786);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(141291);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(432054);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(610508);
/* harmony import */ var _OTPInput_OPTInput_es_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(666222);







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledPhoneInput = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .I)`
  margin-top: 20px;
`;
const ResendOtpBtn = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)`
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  text-align: center;
`;
const SendOtpBtn = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z)`
  height: 32px;
  padding: 0 30px;
  margin-bottom: 0.5rem;
  text-align: center;
`;
const StyledNoti = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  color: #eb1f3a;
  text-align: center;
  margin: 1rem auto;
`;
const Center = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  display: flex;
  justify-content: center;
`;
const defaultCountdown = 60;
const UpdatePhoneNumberModal = (props) => {
  const {
    visible,
    setVisible,
    authService,
    user,
    setUser,
    callbackConfirmOtp,
    otpRequestCountDown: totalCountdown
  } = props;
  const [, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
  const [phone, setPhone] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const [isSentOTP, setSentOTP] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [countDown, setCountDown] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(totalCountdown || defaultCountdown);
  const [intervalId, setIntervalId] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const [noti, setNoti] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    show: false,
    message: ""
  });
  const updatePhone = async (otp) => {
    var _a, _b, _c, _d;
    setLoading(true);
    try {
      const data = await authService.updatePhone(phone, otp);
      setUser(__spreadProps(__spreadValues({}, user), { telephone: data.phone_number }));
      setVisible(false);
    } catch (error) {
      _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error);
      if (((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.error) == null ? void 0 : _b.code) === 1041) {
        setNoti({
          show: true,
          message: "M\xE3 x\xE1c nh\u1EADn kh\xF4ng \u0111\xFAng. Vui l\xF2ng th\u1EED l\u1EA1i"
        });
      } else {
        setNoti({ show: true, message: (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.error) == null ? void 0 : _d.message });
      }
    } finally {
      setLoading(false);
    }
  };
  const sendOTP = async () => {
    var _a, _b, _c, _d;
    setLoading(true);
    try {
      await authService.verifyPhone(phone != null ? phone : "");
      setSentOTP(true);
      setCountDown(totalCountdown || defaultCountdown);
      const handle = setInterval(() => {
        setCountDown((countdown) => countdown === 0 ? countdown : countdown - 1);
      }, 1e3);
      setIntervalId(handle);
    } catch (error) {
      _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error);
      if (((_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.error) == null ? void 0 : _b.code) === 1019) {
        setNoti({
          show: true,
          message: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c"
        });
      } else {
        setNoti({ show: true, message: (_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.error) == null ? void 0 : _d.message });
      }
    } finally {
      setLoading(false);
    }
  };
  const handlePhoneChange = (number) => {
    setPhone(number);
    setNoti((0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .isValidPhoneFormat */ .Ew)(number) ? { show: false, message: "" } : { show: true, message: "Vui l\xF2ng nh\u1EADp \u0111\xFAng \u0111\u1ECBnh d\u1EA1ng s\u1ED1 \u0111i\u1EC7n tho\u1EA1i" });
  };
  const checkEnterOnPhoneInput = (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      sendOTP();
    }
  };
  const handleResendOtp = async () => {
    if (countDown === 0) {
      clearInterval(intervalId);
      setNoti({ show: false, message: "" });
      sendOTP();
    }
  };
  const handleOtpChange = async (otp) => {
    if (otp.length === 6) {
      await updatePhone(otp);
      callbackConfirmOtp == null ? void 0 : callbackConfirmOtp();
    }
  };
  const onClose = () => {
    setVisible(false);
    authService.logout();
  };
  const countDownDisplay = (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_6__/* .getCountDownDisplay */ .lt)(countDown);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Modal */ .u, {
    visible: visible && !isSentOTP,
    footer: false,
    onClose,
    centeredTitle: true,
    disableEscClose: true,
    title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .SubTitle */ .DK, {
      level: 1,
      color: "textTitle"
    }, "B\u1ED5 sung th\xF4ng tin"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
      level: 1,
      marginTop: "s8"
    }, "Vui l\xF2ng cung c\u1EA5p th\xF4ng tin s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EC3 kh\xF4ng b\u1ECF l\u1EE1 c\xE1c ch\u01B0\u01A1ng tr\xECnh khuy\u1EBFn m\xE3i \u0111\u1EB7c bi\u1EC7t t\u1EDBi t\u1EEB Co-op Online"))
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .ModalBody */ .f, {
    padding: ["s0", "s0"]
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .SubTitle */ .DK, null, "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i"), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPhoneInput, {
    value: phone,
    onChange: handlePhoneChange,
    onKeyUp: checkEnterOnPhoneInput,
    placeholder: "Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i"
  }), noti.show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNoti, null, noti.message)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .k, {
    justify: "center"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SendOtpBtn, {
    marginTop: "s16",
    variant: "primary",
    disabled: !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_5__/* .isValidPhoneFormat */ .Ew)(phone),
    onClick: () => sendOTP()
  }, "Ti\u1EBFp t\u1EE5c"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Modal */ .u, {
    visible: visible && isSentOTP,
    footer: false,
    showCloseIcon: false,
    centeredTitle: true,
    title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .SubTitle */ .DK, {
      level: 1,
      color: "textTitle"
    }, "M\xE3 x\xE1c th\u1EF1c")
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .ModalBody */ .f, {
    padding: ["s0", "s0"]
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
    level: 1,
    marginTop: "s8"
  }, `Vui l\xF2ng nh\u1EADp m\xE3 x\xE1c nh\u1EADn OTP \u0111\xE3 \u0111\u01B0\u1EE3c g\u1EEDi v\u1EC1 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i ${phone}`), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_OTPInput_OPTInput_es_js__WEBPACK_IMPORTED_MODULE_11__/* .OTPInput */ .u, {
    onChange: (otp) => handleOtpChange(otp)
  }), noti.show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNoti, null, noti.message), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Center, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ResendOtpBtn, {
    disabled: countDown > 0,
    onClick: handleResendOtp,
    variant: "link"
  }, countDownDisplay)))));
};




/***/ }),

/***/ 983546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "HD": function() { return /* binding */ AuthContextProvider; },
  "g6": function() { return /* binding */ RELOAD_DUE_TO_MISSING_ACCESS_TOKEN; },
  "aC": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ../../packages/auth/dist/user.es.js
var user_es = __webpack_require__(799002);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(927307);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(886786);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CheckOutlined.es.js
var CheckOutlined_es = __webpack_require__(4247);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/MinusOutlined.es.js
var MinusOutlined_es = __webpack_require__(957518);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(160827);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Checkbox/Checkbox.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const displayColor = props.checked || props.partSelected;
  switch (type) {
    case "border": {
      if (props.disabled) {
        if (displayColor)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.divider;
      } else {
        if (displayColor)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.border;
      }
    }
    case "inner":
    default: {
      if (props.disabled) {
        if (displayColor)
          return (_e = props.theme) == null ? void 0 : _e.colors.primary100;
        return (_f = props.theme) == null ? void 0 : _f.colors.background;
      } else {
        if (displayColor)
          return (_g = props.theme) == null ? void 0 : _g.colors.primary500;
        return (_h = props.theme) == null ? void 0 : _h.colors.white;
      }
    }
  }
};
const Checkbox = (_a) => {
  var _b = _a, {
    checked = false,
    partSelected,
    disabled,
    onChange,
    children,
    className
  } = _b, rest = __objRest(_b, [
    "checked",
    "partSelected",
    "disabled",
    "onChange",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react.createElement(CheckboxWrapper, __spreadProps(__spreadValues({}, rest), {
    className: "check-box"
  }), /* @__PURE__ */ react.createElement(StyledCheckbox, null, /* @__PURE__ */ react.createElement(StyledInput, {
    type: "checkbox",
    checked,
    disabled,
    partSelected,
    onChange: () => !disabled && onChange && onChange(!checked),
    className
  }), /* @__PURE__ */ react.createElement(CheckboxInner, {
    checked,
    partSelected,
    disabled,
    className: "checkbox-inner"
  }, partSelected ? /* @__PURE__ */ react.createElement(StyledMinusIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }) : /* @__PURE__ */ react.createElement(StyledCheckIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }))), children && /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    line: 1,
    marginLeft: "s4",
    level: 1,
    weight: "regular",
    style: { flex: 1 },
    className: "checkbox-label"
  }, children));
};
const CheckboxWrapper = emotion_styled_browser_esm["default"].label`
  display: inline-flex;
  align-items: center;
  line-height: unset;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  ${BaseProps_index_es/* CommonStyles */.F}
`;
const StyledCheckIcon = (0,emotion_styled_browser_esm["default"])(CheckOutlined_es/* CheckOutlined */.b)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 5;
  }
`;
const StyledMinusIcon = (0,emotion_styled_browser_esm["default"])(MinusOutlined_es/* MinusOutlined */.l)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 4;
    stroke: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const StyledCheckbox = emotion_styled_browser_esm["default"].div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
`;
const CheckboxInner = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 1px solid ${(p) => getColor(p, "border")};
  border-radius: 2px;
  background-color: ${(p) => getColor(p, "inner")};
`;
const StyledInput = emotion_styled_browser_esm["default"].input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin: auto;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
  ${(p) => !p.disabled && !p.checked && !p.partSelected ? `
      &:hover + .checkbox-inner {
        border-color: ${p.theme.colors.placeholder};
      }
    ` : ""}
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 3 modules
var Modal_es = __webpack_require__(217452);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../packages/tracking/dist/api.es.js
var api_es = __webpack_require__(683383);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var utils_dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ../../packages/utils/dist/url.es.js
var url_es = __webpack_require__(987900);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/helper.es.js
var dist_helper_es = __webpack_require__(610508);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/types.es.js
var types_es = __webpack_require__(195459);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/components/UpdatePhoneNumberModal/UpdatePhoneNumberModal.es.js
var UpdatePhoneNumberModal_es = __webpack_require__(843687);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js










var context_es_defProp = Object.defineProperty;
var context_es_defProps = Object.defineProperties;
var context_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var context_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var context_es_hasOwnProp = Object.prototype.hasOwnProperty;
var context_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var context_es_defNormalProp = (obj, key, value) => key in obj ? context_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var context_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (context_es_hasOwnProp.call(b, prop))
      context_es_defNormalProp(a, prop, b[prop]);
  if (context_es_getOwnPropSymbols)
    for (var prop of context_es_getOwnPropSymbols(b)) {
      if (context_es_propIsEnum.call(b, prop))
        context_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var context_es_spreadProps = (a, b) => context_es_defProps(a, context_es_getOwnPropDescs(b));
var context_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (context_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && context_es_getOwnPropSymbols)
    for (var prop of context_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && context_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const IBANKING_LOGIN_DATA = "ibanking_login_data";
const FEDERATION_PARTNER = "federation";
const CONSUMERAPP_PARTNER = "consumerapp";
const LOCALSTORAGE_REFRESH_TOKEN = "REFRESH_TOKEN";
const LOCALSTORAGE_BACK_APP_URL = "BACK_APP_URL";
const RELOAD_DUE_TO_MISSING_ACCESS_TOKEN = "reload-due-to-missing-access-token";
const mergeInfo = (login, profile) => {
  return context_es_spreadProps(context_es_spreadValues(context_es_spreadValues({}, login), profile), {
    userId: login.userId || profile.userId,
    name: profile.name || login.name,
    telephone: profile.telephone || login.phone,
    avatar: login.picture || profile.avatar
  });
};
const AuthContext = react.createContext(null);
const AuthContextProvider = ({
  children,
  userService,
  authService,
  partner,
  scopes,
  router,
  showConfirmModalAfterLogin = false,
  forceUpdatePhoneNumber = false,
  isNeedToUpdateProfile = false,
  otpRequestCountDown
}) => {
  const [loading, setLoading] = (0,react.useState)(true);
  const [user, setUser] = (0,react.useState)(null);
  const [show, setShow] = (0,react.useState)(false);
  const [showUpdatePhoneNumberModal, setShowUpdatePhoneNumberModal] = (0,react.useState)(false);
  const [showProfileModal, setShowProfileModal] = (0,react.useState)(false);
  const [reCaptchaConfig, setReCaptchaConfig] = (0,react.useState)({
    enabled: false,
    site_key: ""
  });
  const lastRenewTokenTime = (0,react.useRef)(0);
  const [agreePrivacyAndPolicy, setAgreePrivacyAndPolicy] = (0,react.useState)((0,dist_helper_es/* isSacombankmbPartner */.bh)(partner) ? true : false);
  const updateProfile = async (profileInput) => {
    const profile = await userService.updateProfile(profileInput);
    const updatedProfile = context_es_spreadValues(context_es_spreadValues({}, user), (0,utils_dist_index_es.cleanObject)(profile));
    setUser(updatedProfile);
    return updatedProfile;
  };
  const fetchProfile = async (params = {}, infoToMerged) => {
    var _a;
    if (!!user_es/* userManager.getAccessToken */.Z.getAccessToken()) {
      try {
        setLoading(true);
        const profile = await userService.myProfile(params);
        setUser(mergeInfo(infoToMerged || authService.getLoginInfo() || {}, profile));
        if (forceUpdatePhoneNumber && !(infoToMerged == null ? void 0 : infoToMerged.phone) && !((_a = authService.getLoginInfo()) == null ? void 0 : _a.phone) && !profile.telephone) {
          setShowUpdatePhoneNumberModal(true);
        }
      } catch (e) {
        setUser(null);
        dist_index_es/* logger.error */.k.error(e);
      } finally {
        setLoading(false);
      }
    }
  };
  const _loginWithConsumerApp = async (userInfo) => {
    const loginInfo = await authService.loginWithTerra(userInfo);
    await fetchProfile({}, loginInfo);
  };
  const _loginWithIBanking = async (queries) => {
    const isSacombankMb = partner === "sacombankmb";
    if (isSacombankMb) {
      queries.signature = queries.signature || queries.data;
      queries.partner_code = queries.partner_code || "12901";
    }
    const body = await authService.loginWithIBanking(queries);
    const { partner_code, token: partner_token } = body.ibanking_info || {};
    await fetchProfile(partner_code && partner_token ? {
      partnerCode: partner_code,
      partnerToken: partner_token
    } : {});
  };
  const _loginWithFederation = async (queries) => {
    const terraIdToken = queries.terraIdToken;
    const authorizer = queries.authorizer;
    if (!terraIdToken || !authorizer) {
      throw new Error("Missing federarion login config");
    }
    const { refresh_token } = await authService.loginWithFederation(terraIdToken, authorizer);
    localStorage == null ? void 0 : localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, refresh_token);
    await fetchProfile({});
  };
  const _refreshToken = async () => {
    const refreshToken = localStorage == null ? void 0 : localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN);
    if (!refreshToken) {
      return;
    }
    const { refresh_token } = await authService.refreshToken(refreshToken);
    localStorage == null ? void 0 : localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, refresh_token);
    await fetchProfile({});
  };
  const _getPartnerType = (partnerType) => {
    switch (partnerType) {
      case CONSUMERAPP_PARTNER:
        return types_es/* Partner.CONSUMERAPP */.k.CONSUMERAPP;
      case FEDERATION_PARTNER:
        return types_es/* Partner.FEDERATION */.k.FEDERATION;
      default:
        return types_es/* Partner.IBANKING */.k.IBANKING;
    }
  };
  (0,react.useEffect)(() => {
    window.addEventListener("storage", async ({ key, newValue, oldValue }) => {
      if (key == null ? void 0 : key.includes("tekoid.user")) {
        if (!newValue && oldValue) {
          setUser(null);
        } else if (newValue && !oldValue) {
          await fetchProfile();
        }
      }
    });
    return () => {
      window.removeEventListener("storage", () => null);
    };
  }, [user == null ? void 0 : user.userId]);
  const loginWithPartner = async (queries, autoRenew = true, autoRedirect = true) => {
    const _a = queries, { redirect_uri, backAppUrl } = _a, storeData = context_es_objRest(_a, ["redirect_uri", "backAppUrl"]);
    sessionStorage.setItem(IBANKING_LOGIN_DATA, JSON.stringify(storeData));
    if (backAppUrl) {
      localStorage.setItem(LOCALSTORAGE_BACK_APP_URL, backAppUrl);
    }
    const _loginWithPartner = async () => {
      var _a2;
      try {
        const partnerType = _getPartnerType(queries.partnerType);
        switch (partnerType) {
          case types_es/* Partner.FEDERATION */.k.FEDERATION: {
            await _loginWithFederation(queries);
            break;
          }
          case types_es/* Partner.IBANKING */.k.IBANKING: {
            await _loginWithIBanking(queries);
            break;
          }
          case types_es/* Partner.CONSUMERAPP */.k.CONSUMERAPP: {
            await _loginWithConsumerApp(queries.userInfo);
            break;
          }
        }
        if (router) {
          if (queries == null ? void 0 : queries.redirect_uri) {
            const extractLink = (0,url_es/* extractFromPath */.FY)(queries.redirect_uri);
            typeof extractLink === "object" ? router.push(extractLink, queries.redirect_uri) : router.push(extractLink);
            return;
          }
          if (autoRedirect) {
            if (partnerType === types_es/* Partner.IBANKING */.k.IBANKING && (0,dist_helper_es/* checkShowConfirmPolicyModal */.S8)((_a2 = authService.getLoginInfo()) == null ? void 0 : _a2.userId) && (!(0,dist_helper_es/* isSacombankmbPartner */.bh)(partner) && !agreePrivacyAndPolicy && showConfirmModalAfterLogin || (0,dist_helper_es/* isSacombankmbPartner */.bh)(partner))) {
              return setShow(true);
            } else {
              router.push("/");
            }
          }
        } else {
          dist_index_es/* logger.error */.k.error("auth-react: router is not set");
        }
      } catch (e) {
        dist_index_es/* logger.error */.k.error(e);
        window.track("customEvent", "loginWithPartnerFailed", {
          action: "loginWithPartnerFailed",
          category: "customer",
          label: JSON.stringify({
            errorStacktrace: (e == null ? void 0 : e.stacktrace) || "unknown",
            errorMessage: (e == null ? void 0 : e.message) || "unknown"
          })
        });
        if (window.location.pathname.includes("/login"))
          alert("\u0110\u0103ng nh\u1EADp th\u1EA5t b\u1EA1i!");
      }
    };
    await _loginWithPartner();
    if (autoRenew) {
      const startTime = new Date().getTime();
      lastRenewTokenTime.current = startTime;
      setInterval(async () => {
        const now = new Date().getTime();
        const diff = now - lastRenewTokenTime.current;
        if (diff > 3e6) {
          lastRenewTokenTime.current = now;
          const partnerType = _getPartnerType(queries.partnerType);
          switch (partnerType) {
            case types_es/* Partner.FEDERATION */.k.FEDERATION: {
              await _refreshToken();
              break;
            }
            case types_es/* Partner.IBANKING */.k.IBANKING: {
              await _loginWithPartner();
              break;
            }
          }
        }
      }, 3e3);
    }
  };
  const initIam = async () => {
    if (partner)
      return;
    const startTime = Math.round(performance.now());
    await authService.initialize(scopes);
    sessionStorage.setItem(RELOAD_DUE_TO_MISSING_ACCESS_TOKEN, "0");
    const loggedInUser = authService.getLoginInfo();
    const endTime = Math.round(performance.now());
    const duration = endTime - startTime;
    (0,api_es/* trackResponseTimeAsync */.j3)("initIAM", duration);
    if (loggedInUser == null ? void 0 : loggedInUser.userId) {
      await fetchProfile();
    } else {
      setLoading(false);
    }
  };
  (0,react.useEffect)(() => {
    const queries = sessionStorage.getItem(IBANKING_LOGIN_DATA);
    if (queries) {
      const reloginWithPartner = async () => {
        try {
          const queriesObj = JSON.parse(queries);
          if (!window.location.pathname.includes("/login") && Object.keys(queriesObj).length) {
            if (queriesObj.partnerType === FEDERATION_PARTNER) {
              await _refreshToken();
            } else {
              await loginWithPartner(queriesObj, true, false);
            }
            sessionStorage.setItem(RELOAD_DUE_TO_MISSING_ACCESS_TOKEN, "0");
          }
        } catch (e) {
          dist_index_es/* logger.error */.k.error("Relogin ibanking false", e);
        } finally {
          setLoading(false);
        }
      };
      reloginWithPartner();
    } else {
      initIam().finally(() => {
        setLoading(false);
      });
    }
  }, []);
  return /* @__PURE__ */ react.createElement(AuthContext.Provider, {
    value: {
      user,
      loading,
      loginWithPartner,
      authService,
      userService,
      updateProfile,
      fetchProfile,
      initIam,
      setUser,
      isShowConfirmModal: show,
      reCaptchaConfig,
      setReCaptchaConfig,
      showProfileModal,
      setShowProfileModal
    }
  }, /* @__PURE__ */ react.createElement(StyledModal, {
    visible: show,
    onCancel: () => {
      if ((0,dist_helper_es/* isSacombankmbPartner */.bh)(partner)) {
        window.location.href = "/?action=backtoapp";
      } else {
        window.location.href = "/vnpayshop/backapp";
      }
    },
    onOk: () => {
      var _a;
      const userId = (_a = authService.getLoginInfo()) == null ? void 0 : _a.userId;
      if (userId) {
        (0,dist_helper_es/* userConfirmedPolicy */.U6)(userId);
      }
      router == null ? void 0 : router.push("/");
      setShow(false);
    },
    okButtonProps: {
      disabled: !agreePrivacyAndPolicy
    },
    okText: "\u0110\u1ED3ng \xFD",
    cancelText: "Quay l\u1EA1i",
    showCloseIcon: false,
    title: partner !== "sacombankmb" && /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
      level: 1,
      color: "textTitle"
    }, "Th\xF4ng b\xE1o x\u1EED l\xFD d\u1EEF li\u1EC7u"), /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
      level: 1,
      color: "textPrimary",
      marginTop: "s8"
    }, "Vui l\xF2ng \u0111\u1ED3ng \xFD v\u1EDBi c\xE1c \u0111i\u1EC1u kho\u1EA3n v\xE0 \u0111i\u1EC1u ki\u1EC7n d\u1ECBch v\u1EE5 \u0111\u1EC3 ti\u1EBFp t\u1EE5c")),
    centeredTitle: true
  }, /* @__PURE__ */ react.createElement(ModalBody_es/* ModalBody */.f, {
    padding: ["s0", "s0"]
  }, (0,dist_helper_es/* isSacombankmbPartner */.bh)(partner) ? /* @__PURE__ */ react.createElement(react.Fragment, null, "D\u1ECBch v\u1EE5 Mua s\u1EAFm VNSHOP \u0111\u01B0\u1EE3c cung c\u1EA5p b\u1EDFi VNPAY. Chi ti\u1EBFt li\xEAn h\u1EC7 hotline VNPAY: 1900555577 \u0111\u1EC3 \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3.") : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(context_es_CheckboxWrapper, null, /* @__PURE__ */ react.createElement(Checkbox, context_es_spreadProps(context_es_spreadValues({}, (0,helper_es/* getTrackingData */.O5)({
    isTrackContent: true,
    regionName: "ConfirmationPrivacy",
    contentName: "checkboxAgreePrivacy"
  })), {
    checked: agreePrivacyAndPolicy,
    onChange: setAgreePrivacyAndPolicy
  }), /* @__PURE__ */ react.createElement(StyledPrivacyAndPolicyText, null, "B\u1EB1ng vi\u1EC7c \u0111\xE1nh d\u1EA5u v\xE0o \xF4 n\xE0y, t\xF4i \u0111\xE3 bi\u1EBFt r\xF5 v\xE0 \u0111\u1ED3ng \xFD to\xE0n b\u1ED9 v\u1EDBi", " ", /* @__PURE__ */ react.createElement("a", {
    href: "/chinh-sach-bao-mat-thong-tin-ca-nhan"
  }, "N\u1ED9i dung th\xF4ng b\xE1o x\u1EED l\xFD d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a C\xF4ng ty VNIS (VNSHOP)"), " ", "li\xEAn quan t\u1EDBi vi\u1EC7c x\u1EED l\xFD d\u1EEF li\u1EC7u c\xE1 nh\xE2n c\u1EE7a t\xF4i, bao g\u1ED3m c\u1EA3 c\xE1c ho\u1EA1t \u0111\u1ED9ng ch\u1EC9nh s\u1EEDa, ti\u1EBFt l\u1ED9, x\xF3a, h\u1EE7y d\u1EEF li\u1EC7u c\xE1 nh\xE2n.")))))), /* @__PURE__ */ react.createElement(UpdatePhoneNumberModal_es/* UpdatePhoneNumberModal */.n, {
    visible: showUpdatePhoneNumberModal,
    setVisible: setShowUpdatePhoneNumberModal,
    authService,
    user,
    setUser,
    callbackConfirmOtp: () => {
      if (isNeedToUpdateProfile) {
        setShowProfileModal(true);
      }
    },
    otpRequestCountDown
  }), children);
};
function useAuth() {
  const context = (0,react.useContext)(AuthContext);
  if (!context) {
    throw new Error("useAuth must be inside a AuthContextProvider with a state value");
  }
  return context;
}
const StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)`
  width: 400px;
  @media (max-width: 576px) {
    width: 80%;
  }
`;
const context_es_CheckboxWrapper = emotion_styled_browser_esm["default"].div`
  text-align: center;
  .check-box {
    display: flex;
    align-items: flex-start;
    column-gap: 0.375rem;
    .checkbox-inner {
      top: 4px;
    }
    .checkbox-label {
      -webkit-line-clamp: unset;
    }
  }
`;
const StyledPrivacyAndPolicyText = emotion_styled_browser_esm["default"].div`
  text-align: justify;
`;




/***/ }),

/***/ 610508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S8": function() { return /* binding */ checkShowConfirmPolicyModal; },
/* harmony export */   "U6": function() { return /* binding */ userConfirmedPolicy; },
/* harmony export */   "bh": function() { return /* binding */ isSacombankmbPartner; },
/* harmony export */   "lt": function() { return /* binding */ getCountDownDisplay; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(682653);



const LS_POLICIES_CONFIRMED_USER_IDS = "policiesConfirmedUserIds";
const isSacombankmbPartner = (partner) => {
  return partner === "sacombankmb";
};
const checkShowConfirmPolicyModal = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      return !(userIds == null ? void 0 : userIds.includes(userId || ""));
    } catch (e) {
      _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
    }
  }
  return true;
};
const userConfirmedPolicy = (userId) => {
  const stringUserIds = localStorage == null ? void 0 : localStorage.getItem(LS_POLICIES_CONFIRMED_USER_IDS);
  if (stringUserIds) {
    try {
      const userIds = JSON.parse(stringUserIds);
      if (userIds && !userIds.includes(userId)) {
        userIds.push(userId);
        localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, JSON.stringify(userIds));
        return;
      }
    } catch (e) {
      _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
    }
  }
  localStorage == null ? void 0 : localStorage.setItem(LS_POLICIES_CONFIRMED_USER_IDS, `["${userId}"]`);
};
const getCountDownDisplay = (countdown) => {
  if (countdown === 0) {
    return (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_1__.t)("G\u1EEDi l\u1EA1i m\xE3");
  }
  if (countdown <= 60) {
    return (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_1__.t)("G\u1EEDi l\u1EA1i m\xE3 sau {{countdown}}s", { countdown });
  }
  const countdownMin = Math.floor(countdown / 60);
  const countdownSec = countdown % 60;
  if (countdownSec === 0) {
    return (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_1__.t)("G\u1EEDi l\u1EA1i m\xE3 sau {{countdownMin}}p", { countdownMin });
  }
  return (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_1__.t)("G\u1EEDi l\u1EA1i m\xE3 sau {{countdownMin}}p:{{countdownSec}}s", {
    countdownMin,
    countdownSec
  });
};




/***/ }),

/***/ 682653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/lang/en.es.js
var enLang = {
	"Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn": "Login or Registration with your phone number",
	"Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập": "Please input OTP sent to your phone number {{phone}} to login",
	"Đã gửi mã OTP": "Sent OTP code",
	"Đã gửi lại mã OTP": "Resent OTP code",
	"Nhập số điện thoại": "Input phone number",
	"Gửi": "Send",
	"Gửi lại mã": "Resend code",
	"Gửi lại mã sau {{countDownTime}}s": "Resend code after {{countDownTime}}s",
	"Gửi lại mã sau {{countdownMin}}p": "Resend code after {{countdownMin}}m",
	"Gửi lại mã sau {{countdownMin}}p{{countdownSec}}s": "Resend code after {{countdownMin}}m{{countdownSec}}s",
	"Bạn đã yêu cầu OTP vượt quá số lần quy định": "You have requested OTP more than the allowed limit"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/lang/vi.es.js
var viLang = {
	"Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn": "Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn",
	"Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập": "Vui lòng nhập số OTP đã được gửi về số điện thoại {{phone}} để thực hiện đăng nhập",
	"Đã gửi mã OTP": "Đã gửi mã OTP",
	"Đã gửi lại mã OTP": "Đã gửi lại mã OTP",
	"Nhập số điện thoại": "Nhập số điện thoại",
	"Gửi": "Gửi",
	"Gửi lại mã": "Gửi lại mã",
	"Gửi lại mã sau {{countDownTime}}s": "Gửi lại mã sau {{countDownTime}}s",
	"Bạn đã yêu cầu OTP vượt quá số lần quy định": "Bạn đã yêu cầu OTP vượt quá số lần quy định"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "auth-react";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 195459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Partner; }
/* harmony export */ });
var Partner = /* @__PURE__ */ ((Partner2) => {
  Partner2[Partner2["IBANKING"] = 0] = "IBANKING";
  Partner2[Partner2["FEDERATION"] = 1] = "FEDERATION";
  Partner2[Partner2["CONSUMERAPP"] = 2] = "CONSUMERAPP";
  return Partner2;
})(Partner || {});




/***/ }),

/***/ 77829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BR": function() { return /* binding */ cookFilter; },
/* harmony export */   "FW": function() { return /* binding */ getParamsFromUrl; },
/* harmony export */   "jG": function() { return /* binding */ getKeyAPI; },
/* harmony export */   "nS": function() { return /* binding */ normalizePageBuilderToDiscoveryParams; }
/* harmony export */ });
/* unused harmony exports getObjFromQueryString, paramToUrl */
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(775002);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);



var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const paramToUrl = (params, baseUrl, key) => {
  const url = new URL(`${baseUrl}/${key || "search"}`);
  if (params) {
    Object.keys(params).forEach((key2) => {
      if (Array.isArray(params[key2]) && !params[key2].length)
        return;
      return url.searchParams.append(key2, params[key2]);
    });
  }
  return url;
};
const getParamsFromUrl = (url, key) => {
  if (!url) {
    return void 0;
  }
  const params = url.indexOf("?") >= 0 ? url.substring(url.indexOf("?")) : "";
  const param = new URLSearchParams(params).get(key);
  return param;
};
const getObjFromQueryString = (str) => {
  const urlParams = new URLSearchParams(str);
  const result = {};
  for (const pair of urlParams.entries()) {
    result[pair[0]] = pair[1];
  }
  return result;
};
const cookFilterOption = (el, filterCode, filterName, params) => {
  var _a, _b, _c;
  const optionName = el.name || el.value || "";
  const optionCode = el.code || ((_a = el.optionId) == null ? void 0 : _a.toString()) || ((_b = el.id) == null ? void 0 : _b.toString()) || "";
  if (!params || !((_c = params[filterCode]) == null ? void 0 : _c.toString().split(",").includes(optionCode))) {
    return {
      optionName,
      optionCode,
      filterCode,
      filterName
    };
  }
  return {
    optionName: "",
    optionCode: "",
    filterCode: "",
    filterName: ""
  };
};
const cookFilter = (filter, params, categories) => {
  var _a, _b, _c;
  const newFilter = [];
  if (!filter)
    return newFilter;
  if (categories == null ? void 0 : categories.length) {
    newFilter.push({
      code: "masterCategories",
      name: "Danh m\u1EE5c s\u1EA3n ph\u1EA9m",
      options: categories.map((val) => cookFilterOption(val, "masterCategories", "Danh m\u1EE5c s\u1EA3n ph\u1EA9m", params)).filter(Boolean)
    });
  }
  if ((_a = filter == null ? void 0 : filter.brands) == null ? void 0 : _a.length) {
    newFilter.push({
      code: "brands",
      name: "Th\u01B0\u01A1ng hi\u1EC7u",
      options: filter.brands.map((val) => cookFilterOption(val, "brands", "Th\u01B0\u01A1ng hi\u1EC7u", params)).filter(Boolean)
    });
  }
  if ((_b = filter == null ? void 0 : filter.clearanceTypes) == null ? void 0 : _b.length) {
    newFilter.push({
      code: "clearanceTypeIds",
      name: "T\xECnh tr\u1EA1ng s\u1EA3n ph\u1EA9m",
      options: filter.clearanceTypes.map((val) => cookFilterOption(val, "clearanceTypeIds", "T\xECnh tr\u1EA1ng s\u1EA3n ph\u1EA9m", params)).filter(Boolean)
    });
  }
  (_c = filter == null ? void 0 : filter.attributes) == null ? void 0 : _c.forEach((el) => {
    newFilter.push({
      code: `attributes.${el.code}`,
      name: el.name,
      options: el.values.map((val) => cookFilterOption(val, `attributes.${el.code}`, el.name, params)).filter(Boolean)
    });
  });
  return newFilter.filter((filter2) => !!filter2.options.length);
};
const normalizePageBuilderToDiscoveryParams = (params) => {
  var _a, _b, _c, _d;
  if (!params)
    return {};
  const attributes = params["attributes"] || [];
  const priceGteFromPageBuilder = (_b = (_a = params == null ? void 0 : params.prices) == null ? void 0 : _a[0]) == null ? void 0 : _b.from;
  const priceLteFromPageBuilder = (_d = (_c = params == null ? void 0 : params.prices) == null ? void 0 : _c[0]) == null ? void 0 : _d.to;
  if (!params["price_gte"] && priceGteFromPageBuilder)
    params["price_gte"] = priceGteFromPageBuilder;
  if (!params["price_lte"] && priceLteFromPageBuilder)
    params["price_lte"] = priceLteFromPageBuilder;
  attributes.forEach((element) => {
    const key = `attributes.${element.code}`;
    const value = element.optionIds && element.optionIds.toString();
    params[key] = value;
  });
  params["attributes"] = [];
  return (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)(params);
};
const getKeyAPI = (params, baseUrl) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const normalizedParams = normalizePageBuilderToDiscoveryParams(searchParams);
  const terminalCode = normalizedParams == null ? void 0 : normalizedParams.terminalCode;
  const pos365StoreCode = normalizedParams == null ? void 0 : normalizedParams.pos365StoreCode;
  return (0,swr__WEBPACK_IMPORTED_MODULE_0__/* .unstable_serialize */ .wE)(params && Object.keys(params).length && (!!terminalCode || !pos365StoreCode) ? [normalizedParams, baseUrl + "/search"] : null);
};




/***/ }),

/***/ 875663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ PageTypeEnum; },
/* harmony export */   "Nc": function() { return /* binding */ BlockItemType; },
/* harmony export */   "kH": function() { return /* binding */ BlockType; }
/* harmony export */ });
var PageTypeEnum = /* @__PURE__ */ ((PageTypeEnum2) => {
  PageTypeEnum2["HOME"] = "PAGE_TYPE_HOME";
  PageTypeEnum2["CATEGORY"] = "PAGE_TYPE_CATEGORY";
  PageTypeEnum2["NOTIFICATION"] = "PAGE_TYPE_NOTIFICATION";
  PageTypeEnum2["SELLER"] = "PAGE_TYPE_SELLER";
  PageTypeEnum2["BRAND"] = "PAGE_TYPE_BRAND";
  return PageTypeEnum2;
})(PageTypeEnum || {});
var BlockItemType = /* @__PURE__ */ ((BlockItemType2) => {
  BlockItemType2["BANNER"] = "BANNER";
  BlockItemType2["MENU"] = "MENU";
  BlockItemType2["SKU"] = "SKU";
  BlockItemType2["LOCAL"] = "LOCAL";
  return BlockItemType2;
})(BlockItemType || {});
var BlockType = /* @__PURE__ */ ((BlockType2) => {
  BlockType2["SLIDE_BANNER"] = "SLIDE_BANNER";
  BlockType2["WIDE_THIN_BANNER"] = "WIDE_THIN_BANNER";
  BlockType2["WIDE_THICK_BANNER"] = "WIDE_THICK_BANNER";
  BlockType2["VERTICAL_2_BANNER"] = "VERTICAL_2_BANNER";
  BlockType2["HORIZONTAL_4_BANNER"] = "HORIZONTAL_4_BANNER";
  BlockType2["HORIZONTAL_BODY_BANNER"] = "HORIZONTAL_BODY_BANNER";
  BlockType2["HORIZONTAL_BODY_2_BANNER"] = "HORIZONTAL_BODY_2_BANNER";
  BlockType2["HORIZONTAL_BODY_3_BANNER"] = "HORIZONTAL_BODY_3_BANNER";
  BlockType2["HORIZONTAL_2_BANNER_MOBILE"] = "HORIZONTAL_2_BANNER_MOBILE";
  BlockType2["POPUP_BANNER"] = "POPUP_BANNER";
  BlockType2["POPUP_BANNER_MOBILE"] = "POPUP_BANNER_MOBILE";
  BlockType2["LEFT_STICKY_BANNER"] = "LEFT_STICKY_BANNER";
  BlockType2["RIGHT_STICKY_BANNER"] = "RIGHT_STICKY_BANNER";
  BlockType2["PROMOTE_CATEGORY_MENU"] = "PROMOTE_CATEGORY_MENU";
  BlockType2["RECOMMENDED_BRANDS"] = "RECOMMENDED_BRANDS";
  BlockType2["RECOMMENDED_CATEGORY"] = "RECOMMENDED_CATEGORY";
  BlockType2["LISTING_TAB"] = "LISTING_TAB";
  BlockType2["HORIZONTAL_HIGHLIGHTED_BANNER"] = "HORIZONTAL_HIGHLIGHTED_BANNER";
  BlockType2["COUNT_DOWN_PROMO_BIG_SKU"] = "COUNT_DOWN_PROMO_BIG_SKU";
  BlockType2["COUNT_DOWN_PROMO_TAB_MOBILE"] = "COUNT_DOWN_PROMO_TAB_MOBILE";
  BlockType2["MIX_BANNER"] = "MIX_BANNER";
  BlockType2["MEDIUM_ICON_MENU_MOBILE"] = "MEDIUM_ICON_MENU_MOBILE";
  BlockType2["NAVIGATION_BAR"] = "NAVIGATION_BAR";
  BlockType2["PROMOTE_SELLER"] = "PROMOTE_SELLER";
  BlockType2["BEST_SELLING_PRODUCT"] = "BEST_SELLING_PRODUCT";
  BlockType2["FLASH_SALE"] = "FLASH_SALE";
  BlockType2["COUNT_DOWN_PROMO_SKU"] = "COUNT_DOWN_PROMO_SKU";
  BlockType2["HORIZONTAL_SKU_LIST"] = "HORIZONTAL_SKU_LIST";
  BlockType2["MAIN_SKU_LIST"] = "MAIN_SKU_LIST";
  BlockType2["LIST_SKU_MOBILE"] = "LIST_SKU_MOBILE";
  BlockType2["POS365_LIST_SKU"] = "POS365_LIST_SKU";
  BlockType2["PRODUCT_LINE_MENU"] = "PRODUCT_LINE_MENU";
  BlockType2["LOCATION"] = "LOCATION";
  BlockType2["PENDING_PAYMENT"] = "PENDING_PAYMENT";
  BlockType2["LEFT_OFF_ITEMS"] = "LEFT_OFF_ITEMS";
  BlockType2["RECENT_PRODUCT"] = "RECENT_PRODUCT";
  BlockType2["RECENT_SEARCH"] = "RECENT_SEARCH";
  BlockType2["MEGA_MENU"] = "MEGA_MENU";
  BlockType2["YOUTUBE"] = "YOUTUBE";
  BlockType2["PERSONALIZATION_PLACEHOLDER"] = "PERSONALIZATION_PLACEHOLDER";
  BlockType2["SMALL_MIX_NEWS"] = "SMALL_MIX_NEWS";
  return BlockType2;
})(BlockType || {});




/***/ }),

/***/ 912885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jk": function() { return /* binding */ ARRAY_OF_STRING_PAYLOAD_FILTER; },
/* harmony export */   "O1": function() { return /* binding */ EXTENDED_RETURN_FILTERABLE; },
/* harmony export */   "O4": function() { return /* binding */ ARRAY_OF_NUMBER_PAYLOAD_FILTER; },
/* harmony export */   "ct": function() { return /* binding */ PRIMITIVE_PAYLOAD_FILTER; },
/* harmony export */   "rA": function() { return /* binding */ ORDER_PAYLOAD_SORTING; },
/* harmony export */   "wC": function() { return /* binding */ DEFAULT_RETURN_FILTERABLE; }
/* harmony export */ });
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(243846);


const DEFAULT_RETURN_FILTERABLE = [
  "FILTER_TYPE_ATTRIBUTE",
  "FILTER_TYPE_BRAND",
  "FILTER_TYPE_PRICE",
  "FILTER_TYPE_CLEARANCE"
];
const EXTENDED_RETURN_FILTERABLE = [
  "FILTER_TYPE_ATTRIBUTE",
  "FILTER_TYPE_BRAND",
  "FILTER_TYPE_PRICE",
  "FILTER_TYPE_CLEARANCE",
  "FILTER_TYPE_CATEGORY"
];
const PRIMITIVE_PAYLOAD_FILTER = [
  "hasPromotions",
  "inStockOnly",
  "returnAllVariants",
  "priceLte",
  "priceGte"
];
const ARRAY_OF_NUMBER_PAYLOAD_FILTER = [
  "clearanceTypeIds",
  "masterCategoryIds"
];
const ARRAY_OF_STRING_PAYLOAD_FILTER = [
  "skus",
  "excludedSkus",
  "tags",
  "providerIds",
  "sellerIds",
  "brands",
  "categories"
];
const ORDER_PAYLOAD_SORTING = {
  desc: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_DESCENDING */ .l.ORDER_BY_DESCENDING,
  asc: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_ASCENDING */ .l.ORDER_BY_ASCENDING,
  DESC: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_DESCENDING */ .l.ORDER_BY_DESCENDING,
  ASC: _types_es_js__WEBPACK_IMPORTED_MODULE_0__/* .OrderEnum.ORDER_BY_ASCENDING */ .l.ORDER_BY_ASCENDING
};




/***/ }),

/***/ 243846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SortEnum; },
/* harmony export */   "l": function() { return /* binding */ OrderEnum; }
/* harmony export */ });
var SortEnum = /* @__PURE__ */ ((SortEnum2) => {
  SortEnum2["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
  SortEnum2["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
  SortEnum2["SORT_BY_PRICE"] = "SORT_BY_PRICE";
  SortEnum2["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
  SortEnum2["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
  SortEnum2["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
  SortEnum2["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
  SortEnum2["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
  SortEnum2["SORT_BY_SCORE"] = "SORT_BY_SCORE";
  SortEnum2["SORT_BY_NAME"] = "SORT_BY_NAME";
  return SortEnum2;
})(SortEnum || {});
var OrderEnum = /* @__PURE__ */ ((OrderEnum2) => {
  OrderEnum2["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
  OrderEnum2["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
  OrderEnum2["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
  return OrderEnum2;
})(OrderEnum || {});




/***/ }),

/***/ 232771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useDiscoverySearchV2; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearchV2 = (discoveryService, params, configs, searchAlgoHeaderValue) => {
  const _a = configs || {}, { transform = (data2) => data2 } = _a, swrConfigs = __objRest(_a, ["transform"]);
  const { data, error } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(params && Object.keys(params).length ? [params, "discovery-search-v2"] : null, async (params2) => {
    const response = await discoveryService.search(params2, searchAlgoHeaderValue);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  return {
    result: data,
    error,
    loading: params && Object.keys(params).length ? !error && !data : false
  };
};




/***/ }),

/***/ 14643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useInfiniteDiscoverySearchV2; }
/* harmony export */ });
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(382725);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useInfiniteDiscoverySearchV2 = (discoveryService, params, configs) => {
  var _b, _c;
  const _a = configs || {}, {
    transform = (data2) => data2
  } = _a, swrConfigs = __objRest(_a, [
    "transform"
  ]);
  const { data, size, setSize, isValidating, error } = (0,swr_infinite__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((page) => [
    __spreadProps(__spreadValues({}, params), { page: page + 1 }),
    "discovery-search-v2"
  ], async (payload) => {
    const response = await discoveryService.search(payload);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  const isEmpty = data && ((_b = data[0].products) == null ? void 0 : _b.length) === 0;
  const hasMore = (((_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.total) || 0) > size * ((params == null ? void 0 : params.pageSize) || 10);
  const loadmore = () => {
    setSize((page) => page + 1);
  };
  return {
    loading: isValidating,
    hasMore,
    data,
    loadmore,
    size,
    isEmpty: !!isEmpty,
    error
  };
};




/***/ }),

/***/ 691568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ListContent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListContentWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  return [
    `
  background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  padding: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12} ${(_c = props.theme) == null ? void 0 : _c.spacing.s16};
  display: flex;
  align-items: center;
  position: relative;
  &.focused {
    background: ${(_d = props.theme) == null ? void 0 : _d.colors.background};
  }
  ${props.hover ? `
    background-color: ${(_e = props.theme) == null ? void 0 : _e.colors.background};
  ` : ""}
  ${props.active && !props.hover ? `
      background-color: ${(_f = props.theme) == null ? void 0 : _f.colors.primary500};
      color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
      ` : ""}
 ${props.hasDivider ? ` &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: ${(_h = props.theme) == null ? void 0 : _h.spacing.s16};
      bottom: 0;
      left: ${(_i = props.theme) == null ? void 0 : _i.spacing.s16};
      border-bottom: ${(_j = props.theme) == null ? void 0 : _j.borderWeight.m} solid ${(_k = props.theme) == null ? void 0 : _k.colors.divider};
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }` : ``}
`,
    _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F
  ];
});
const ListContent = (_a) => {
  var _b = _a, {
    label,
    icon,
    hasDivider = false,
    active = false,
    onClick
  } = _b, rest = __objRest(_b, [
    "label",
    "icon",
    "hasDivider",
    "active",
    "onClick"
  ]);
  var _a2, _b2;
  const [hover, setHover] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListContentWrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    },
    hasDivider,
    active,
    hover,
    onMouseEnter: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, rest), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b, {
    marginRight: "s12"
  }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(icon, __spreadValues({
    size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? 24 : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size
  }, active && !hover ? { color: "white" } : {}))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    level: 1,
    line: 1
  }, label));
};




/***/ }),

/***/ 296200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(725643);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19840);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(252661);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(228680);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4247);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(988315);
/* harmony import */ var use_event_callback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(101359);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Item = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return `
    height: 2.5rem;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    align-items: center;
    background: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
    padding-left: ${(_b = props.theme) == null ? void 0 : _b.spacing.s16};
    padding-right: ${(_c = props.theme) == null ? void 0 : _c.spacing.s16};
    border-radius: ${(_d = props.theme) == null ? void 0 : _d.borderRadius.s};
    cursor: pointer;
    &:hover,
    &.focused {
      background: ${(_e = props.theme) == null ? void 0 : _e.colors.background};
    }
    ${props.hasDivider ? ` &:after {
         position: absolute;
         box-sizing: border-box;
         content: ' ';
         pointer-events: none;
         right: ${(_f = props.theme) == null ? void 0 : _f.spacing.s16};
         bottom: 0;
         left: ${(_g = props.theme) == null ? void 0 : _g.spacing.s16};
         border-bottom: ${(_h = props.theme) == null ? void 0 : _h.borderWeight.m} solid ${(_i = props.theme) == null ? void 0 : _i.colors.divider};
         -webkit-transform: scaleY(0.5);
         transform: scaleY(0.5);
       }` : ``}
`;
});
const LeftContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  flex: 1;
  text-align: left;
`;
const RightContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  width: 1.5rem;
  text-align: right;
`;
const optionHeight = 2.5;
const ItemsWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ theme, maxPerView }) => `
    background: ${theme == null ? void 0 : theme.colors.white};
		box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
    overflow: hidden;
    position: absolute;
    top: 2.75rem;
    width: 100%;
    z-index: 1000;
    ${maxPerView ? `height: ${maxPerView * optionHeight}rem; 
          overflow-y: scroll;
          scrollbar-gutter: stable;
          ::-webkit-scrollbar {
            width: 8px;
          }
          ::-webkit-scrollbar-thumb {
            background: #888; 
            border-radius: 4px;
          }
          ::-webkit-scrollbar-thumb:hover {
            background: #555; 
          }` : ""}
`);
const SelectWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  position: relative;
`;
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F}
`;
const Field = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return `
  background: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  height: ${optionHeight}rem;
  border-radius: ${(_b = props.theme) == null ? void 0 : _b.spacing.s4};
  display: flex;
  align-items: center;
  border: ${(_c = props.theme) == null ? void 0 : _c.borderWeight.m} solid ${(_d = props.theme) == null ? void 0 : _d.colors.divider};
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  ${props.disabled ? `
    cursor: not-allowed;
    background: ${(_e = props.theme) == null ? void 0 : _e.colors.background};
  ` : ""}
  ${!props.active ? `&:hover {
    border: ${(_f = props.theme) == null ? void 0 : _f.borderWeight.m} solid ${(_g = props.theme) == null ? void 0 : _g.colors.placeholder};` : ""}
  }
  ${props.active ? `
    border: ${(_h = props.theme) == null ? void 0 : _h.borderWeight.m} solid ${props.activeColor || ((_i = props.theme) == null ? void 0 : _i.colors.link500)};
  ` : ""}
`;
});
const Backdrop = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ active }) => `
    position: absolute;
    animation-duration: 0.2s;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    ${active ? `
      visibility: visible;
      z-index: 990;
    ` : ""}
    transition: transform 0.3s;
    background: transparent;
`);
const InputSearch = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Input */ .I)`
  width: 100%;
  .input-container {
    border-style: none !important;
  }
`;
const findOptionByValue = (options, value) => {
  const index = options.findIndex((option) => option.value === value);
  return { option: options[index], index };
};
const scrollToFocusedOption = (list, focusedOption) => {
  if (list && focusedOption) {
    const optionTop = focusedOption.offsetTop;
    const optionBottom = optionTop + focusedOption.clientHeight;
    const listHeight = list.clientHeight;
    const listTop = list.scrollTop;
    const listBottom = listTop + listHeight;
    if (optionBottom > listBottom) {
      list.scrollTop = optionBottom - listHeight;
    } else if (optionTop < listTop) {
      list.scrollTop = optionTop;
    }
    focusedOption.classList.add("focused");
  }
};
const DropdownControl = (_a) => {
  var _b = _a, {
    selectedIndex,
    show,
    options,
    children,
    onClickOutside,
    onSelectOption,
    getDropdownContainer
  } = _b, restProps = __objRest(_b, [
    "selectedIndex",
    "show",
    "options",
    "children",
    "onClickOutside",
    "onSelectOption",
    "getDropdownContainer"
  ]);
  const [focusedIndex, setFocusedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(selectedIndex);
  const lastFocusedItem = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setFocusedIndex(selectedIndex);
  }, [show, selectedIndex, setFocusedIndex]);
  const focusSelectedOption = (0,use_event_callback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    var _a2;
    const container = getDropdownContainer();
    if (!container)
      return;
    const focusedItem = container.children[focusedIndex];
    (_a2 = lastFocusedItem.current) == null ? void 0 : _a2.classList.remove("focused");
    scrollToFocusedOption(container, focusedItem);
    lastFocusedItem.current = focusedItem;
  });
  const onKeyDown = (e) => {
    const { key } = e;
    switch (key) {
      case "Enter": {
        onSelectOption(options[focusedIndex]);
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        e.preventDefault();
        setFocusedIndex((current) => {
          if (key === "ArrowUp") {
            return current <= 0 ? options.length - 1 : current - 1;
          } else if (key === "ArrowDown") {
            return current >= options.length - 1 ? 0 : current + 1;
          }
          return current;
        });
        break;
      }
      case "Tab":
      case "Escape": {
        onClickOutside();
        break;
      }
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (show && focusedIndex > -1) {
      focusSelectedOption();
    }
  }, [show, focusedIndex, focusSelectedOption]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectWrapper, __spreadValues({
    onKeyDown
  }, restProps), children);
};
const Select = (_c) => {
  var _d = _c, {
    value,
    title,
    options = [],
    maxPerView,
    disabled = false,
    hasDivider = false,
    activeColor,
    selectValue,
    className,
    titleProps = {},
    placeholder,
    onDelete,
    allowDelete = true
  } = _d, rest = __objRest(_d, [
    "value",
    "title",
    "options",
    "maxPerView",
    "disabled",
    "hasDivider",
    "activeColor",
    "selectValue",
    "className",
    "titleProps",
    "placeholder",
    "onDelete",
    "allowDelete"
  ]);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const optionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [activeOption, setActiveOption] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const [onHover, setOnHover] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [filteredOptions, setFilteredOptions] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(options);
  const [keyword, setKeyword] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const selectedOption = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => findOptionByValue(options, value), [value, options]);
  const isDisabled = disabled || !options.length;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const { option } = selectedOption;
    setActiveOption(option);
  }, [selectedOption]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setFilteredOptions(options);
  }, [JSON.stringify(options)]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    let filteredOptions2 = [];
    if (keyword.length)
      filteredOptions2 = options.filter((item) => item.text.toLowerCase().indexOf(keyword.toLowerCase()) >= 0);
    else
      filteredOptions2 = options;
    setFilteredOptions(filteredOptions2);
  }, [keyword]);
  const onClickItem = (option) => {
    selectValue(option == null ? void 0 : option.value);
    setKeyword("");
    setShow(false);
  };
  const onClickOutside = (0,use_event_callback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(() => {
    setShow(false);
    if (!(activeOption == null ? void 0 : activeOption.value)) {
      setKeyword("");
      setActiveOption(void 0);
      if (value)
        selectValue("");
    }
  });
  (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_5__/* .useClickOutside */ .O8)(optionRef, onClickOutside);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, rest), {
    onKeyDown: (e) => {
      if (show) {
        e.stopPropagation();
      }
    },
    tabIndex: -1
  }), title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_6__/* .SubTitle */ .DK, __spreadValues({
    level: 4,
    line: 1,
    marginBottom: "s4"
  }, titleProps), title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownControl, {
    selectedIndex: selectedOption.index,
    show,
    options: filteredOptions,
    onClickOutside,
    getDropdownContainer: () => optionRef.current,
    onSelectOption: onClickItem,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Field, {
    disabled: isDisabled,
    activeColor: activeColor || "",
    onClick: (e) => {
      e.stopPropagation();
      if (!disabled)
        setShow(!show);
    },
    onFocus: () => {
      if (!disabled) {
        setShow(true);
      }
    },
    active: show,
    onMouseEnter: () => setOnHover(true),
    onMouseLeave: () => setOnHover(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputSearch, {
    disabled: isDisabled,
    placeholder: placeholder || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("Ch\u1ECDn"),
    onChange: (keyword2) => {
      setKeyword(keyword2);
      setActiveOption(void 0);
      setShow(true);
    },
    suffix: allowDelete && ((activeOption == null ? void 0 : activeOption.text) && onHover || keyword) && !isDisabled ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .DeleteCircleFilled */ .N, {
      color: "textSecondary",
      size: 16,
      onClick: (e) => {
        e.stopPropagation();
        setKeyword("");
        setActiveOption(void 0);
        selectValue("");
        onDelete == null ? void 0 : onDelete();
      }
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .ArrowDownFilled */ .O, {
      color: "textSecondary",
      size: 20
    }),
    value: (activeOption == null ? void 0 : activeOption.text) || keyword
  })), show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemsWrapper, {
    ref: optionRef,
    maxPerView: (maxPerView != null ? maxPerView : Number.MAX_SAFE_INTEGER) < filteredOptions.length ? maxPerView : void 0
  }, filteredOptions.length ? filteredOptions.map((option, index) => {
    var _a, _b, _c2, _d2;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
      key: index,
      onClick: () => onClickItem(option),
      hasDivider: index === options.length - 1 ? false : hasDivider
    }, option.icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_10__/* .Shape */ .b, {
      marginRight: "s12"
    }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(option.icon, {
      size: !((_b = (_a = option.icon) == null ? void 0 : _a.props) == null ? void 0 : _b.size) ? 24 : (_d2 = (_c2 = option.icon) == null ? void 0 : _c2.props) == null ? void 0 : _d2.size
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LeftContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
      level: 1,
      line: 1
    }, option.text)), value === option.value && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .CheckOutlined */ .b, {
      size: 24,
      color: activeColor || "primary500"
    })));
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    hasDivider: false
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LeftContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
    level: 1,
    line: 1,
    color: "textSecondary"
  }, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)("NoData")))))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Backdrop, {
    onClick: () => setShow(false),
    active: show
  }));
};




/***/ }),

/***/ 314408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92840);



const useToast = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__/* .ToastContextDesktop */ .hX);
};




/***/ }),

/***/ 988315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/lang/en.es.js
var NoData = "No data";
var enLang = {
	"Chọn": "Select",
	NoData: NoData
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/lang/vi.es.js
var vi_es_NoData = "Không có dữ liệu";
var viLang = {
	NoData: vi_es_NoData
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ds-desktop";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 160827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CommonStyles; }
/* harmony export */ });
/* unused harmony export getDimension */
const getDimension = (value, prefix = "", suffix = "") => {
  if (!value)
    return "";
  return prefix + (typeof value === "number" ? `${value}px` : value) + suffix;
};
const jsToCss = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
const getSpacing = (props) => {
  const dimension = [
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft"
  ];
  return dimension.reduce((prev, curr) => {
    var _a;
    const currentProp = props[curr];
    if (currentProp) {
      if (typeof currentProp === "string") {
        return `${prev}
${jsToCss(curr)}: ${(_a = props.theme) == null ? void 0 : _a.spacing[currentProp]};`;
      }
      return `${prev}
${jsToCss(curr)}: ${currentProp.map((c) => {
        var _a2;
        return (_a2 = props.theme) == null ? void 0 : _a2.spacing[c];
      }).join(" ")};`;
    }
    return prev;
  }, "");
};
const getItemSpacing = (props) => {
  var _a, _b;
  return `
    ${props.itemHorizontalSpacing ? `
      > *:not(:first-of-type) {
        margin-left: ${(_a = props.theme) == null ? void 0 : _a.spacing[props.itemHorizontalSpacing]};
      }
    ` : ""}
    ${props.itemVerticalSpacing ? `
      > *:not(:first-of-type) {
        margin-top: ${(_b = props.theme) == null ? void 0 : _b.spacing[props.itemVerticalSpacing]};
      }
    ` : ""}`;
};
const replaceColor = (value, colors) => {
  const values = value.split(" ").map((i) => colors[i] ? colors[i] : i);
  return values.join(" ");
};
const CommonStyles = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return `
  border-style: ${props.borderStyle ? props.borderStyle : "none"};
  ${!!props.borderRadius && ` border-radius: ${props.borderRadius ? (_a = props.theme) == null ? void 0 : _a.borderRadius[props.borderRadius] : "0px"};`};

  border-width: ${props.borderWeight ? (_b = props.theme) == null ? void 0 : _b.borderWeight[props.borderWeight] : "1px"};
  border-color: ${props.borderColor ? (_c = props.theme) == null ? void 0 : _c.colors[props.borderColor] : "unset"};
  ${props.border ? `border: ${replaceColor(props.border, ((_d = props.theme) == null ? void 0 : _d.colors) || {})};` : ""};
  ${props.borderTop ? `border-top: ${replaceColor(props.borderTop, ((_e = props.theme) == null ? void 0 : _e.colors) || {})};` : ""};
  ${props.borderRight ? `border-right: ${replaceColor(props.borderRight, ((_f = props.theme) == null ? void 0 : _f.colors) || {})};` : ""};
  ${props.borderBottom ? `border-bottom: ${replaceColor(props.borderBottom, ((_g = props.theme) == null ? void 0 : _g.colors) || {})};` : ""};
  ${props.borderLeft ? `border-left: ${replaceColor(props.borderLeft, ((_h = props.theme) == null ? void 0 : _h.colors) || {})};` : ""};
  opacity: ${props.opacity ? (_i = props.theme) == null ? void 0 : _i.opacity[props.opacity] : 1};
  box-shadow: ${(p) => {
    var _a2;
    return (_a2 = p.theme) == null ? void 0 : _a2.shadow(p, props.shadow || "", props.shadowColor);
  }};
  ${props.backgroundColor && `background-color: ${((_j = props.theme) == null ? void 0 : _j.colors[props.backgroundColor]) || props.backgroundColor};
  `};
  ${getDimension(props.width || "", "width: ", ";")}
  ${getDimension(props.maxWidth || "", "max-width: ", ";")}
  ${getDimension(props.height || "", "height: ", ";")}
  ${getDimension(props.maxHeight || "", "max-height: ", ";")}
  ${getSpacing(props)}
  ${getItemSpacing(props)}

`;
};




/***/ }),

/***/ 849114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/helpers/IconBase.es.js
var IconBase_es = __webpack_require__(404334);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var index_es = __webpack_require__(285212);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(368156);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(160827);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(927307);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/constants/index.es.js
var constants_index_es = __webpack_require__(766633);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Button/constant.es.js


const BUTTON_CONFIG = {
  height: {
    xs: constants_index_es/* CORE_SIZE.s24 */.y.s24,
    s: constants_index_es/* CORE_SIZE.s32 */.y.s32,
    m: constants_index_es/* CORE_SIZE.s40 */.y.s40,
    l: constants_index_es/* CORE_SIZE.s48 */.y.s48
  },
  textColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textPrimary",
    link: "link500",
    "white-ghost": "primary500"
  },
  iconColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textSecondary",
    link: "link500",
    "white-ghost": "primary500"
  },
  disabled: {
    textColor: {
      primary: "placeholder",
      secondary: "placeholder",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    },
    iconColor: {
      primary: "border",
      secondary: "border",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    }
  }
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/cache/@emotion-cache-npm-11.5.0-713285e054-8b3fac281e.zip/node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var emotion_cache_browser_esm = __webpack_require__(715763);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Ripple/Ripple.es.js





const Wrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  span {
    transform: scale(0);
    border-radius: 100%;
    position: absolute;
    opacity: 0.75;
    background-color: rgba(255, 255, 255, 0.6);
    animation: ripple;
    animation-duration: 696ms;
  }
  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(2);
    }
  }
`;
const useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction) => {
  const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;
  useIsomorphicLayoutEffect(() => {
    let bounce;
    if (rippleCount > 0) {
      clearTimeout(bounce);
      bounce = setTimeout(() => {
        cleanUpFunction();
        clearTimeout(bounce);
      }, duration * 4);
    }
    return () => clearTimeout(bounce);
  }, [rippleCount, duration, cleanUpFunction]);
};
const Ripple = ({
  duration = 600,
  color = "rgba(255,255,255,0.6)"
}) => {
  const [rippleArray, setRippleArray] = (0,react.useState)([]);
  useDebouncedRippleCleanUp(rippleArray.length, duration, () => {
    setRippleArray([]);
  });
  const addRipple = (event) => {
    const rippleContainer = event.currentTarget.getBoundingClientRect();
    const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
    const x = event.clientX - rippleContainer.x - size / 2;
    const y = event.clientY - rippleContainer.y - size / 2;
    const newRipple = {
      x,
      y,
      size
    };
    setRippleArray([...rippleArray, newRipple]);
  };
  return /* @__PURE__ */ react.createElement(Wrapper, {
    onMouseDown: addRipple
  }, rippleArray.map((ripple, index) => {
    return /* @__PURE__ */ react.createElement("span", {
      key: "span" + index,
      style: {
        top: ripple.y,
        left: ripple.x,
        width: ripple.size,
        height: ripple.size,
        backgroundColor: color,
        animationDuration: `${duration}ms`
      }
    });
  }));
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(75537);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Button/Button.es.js











var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonStyleByVariant = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  switch (props.variant) {
    case "default": {
      return emotion_react_browser_esm.css`
        background-color: transparent;
        border: 1px solid
          ${props.disabled ? (_a = props.theme) == null ? void 0 : _a.colors.disable : (_b = props.theme) == null ? void 0 : _b.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_c = props.theme) == null ? void 0 : _c.colors.textSecondary};
        }
        &:active {
          border-color: ${(_d = props.theme) == null ? void 0 : _d.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_e = props.theme) == null ? void 0 : _e.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_f = props.theme) == null ? void 0 : _f.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
        border: 1px solid
          ${props.disabled ? (_h = props.theme) == null ? void 0 : _h.colors.disable : (_i = props.theme) == null ? void 0 : _i.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_j = props.theme) == null ? void 0 : _j.colors.textSecondary};
        }
        &:active {
          border-color: ${(_k = props.theme) == null ? void 0 : _k.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_l = props.theme) == null ? void 0 : _l.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_m = props.theme) == null ? void 0 : _m.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "secondary": {
      return emotion_react_browser_esm.css`
        background-color: ${(_n = props.theme) == null ? void 0 : _n.colors.white};
        border: 1px solid
          ${props.disabled ? (_o = props.theme) == null ? void 0 : _o.colors.disable : (_p = props.theme) == null ? void 0 : _p.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            border-color: ${(_q = props.theme) == null ? void 0 : _q.colors.primary600};
            div[type=body] {
              color: ${(_r = props.theme) == null ? void 0 : _r.colors.primary600};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_s = props.theme) == null ? void 0 : _s.colors.primary600};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_t = props.theme) == null ? void 0 : _t.colors.primary600};
            }
          }
          &:active {
            border-color: ${(_u = props.theme) == null ? void 0 : _u.colors.primary700};
            div[type=body] {
              color: ${(_v = props.theme) == null ? void 0 : _v.colors.primary700};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_w = props.theme) == null ? void 0 : _w.colors.primary700};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_x = props.theme) == null ? void 0 : _x.colors.primary700};
            }
          }
        ` : ""}
      `;
    }
    case "white-ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_y = props.theme) == null ? void 0 : _y.colors.white};
        border: none;
        ${props.disabled ? `
          background-color: ${(_z = props.theme) == null ? void 0 : _z.colors.disable};
          ` : `
          &:hover {
            background-color: ${(_A = props.theme) == null ? void 0 : _A.colors.tableHeader};
          }
          &:active {
            background-color: ${(_B = props.theme) == null ? void 0 : _B.colors.background};
          }
        `}
      `;
    }
    case "primary":
    default:
      return emotion_react_browser_esm.css`
        background-color: ${props.disabled ? (_C = props.theme) == null ? void 0 : _C.colors.disable : (_D = props.theme) == null ? void 0 : _D.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            background-color: ${(_E = props.theme) == null ? void 0 : _E.colors.primary600};
          }
          &:active {
            background-color: ${(_F = props.theme) == null ? void 0 : _F.colors.primary700};
          }
        ` : ""}
      `;
  }
};
const buttonShapeStyle = ({
  theme,
  shape,
  size,
  borderRadius
}) => {
  switch (shape) {
    case index_es/* ButtonShapeEnum.round */.Vz.round:
      return emotion_react_browser_esm.css`
        border-radius: ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem
          ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem;
      `;
    case index_es/* ButtonShapeEnum.circle */.Vz.circle:
      return emotion_react_browser_esm.css`
        border-radius: 50%;
      `;
    default:
      return emotion_react_browser_esm.css`
        border-radius: ${theme == null ? void 0 : theme.borderRadius[borderRadius || "s"]};
      `;
  }
};
const Button = (_a) => {
  var _b = _a, {
    children,
    block = false,
    shape,
    size: customizeSize,
    variant = "default",
    prefix,
    suffix,
    disabled,
    onClick,
    className,
    href,
    type = "button",
    backgroundColor
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "shape",
    "size",
    "variant",
    "prefix",
    "suffix",
    "disabled",
    "onClick",
    "className",
    "href",
    "type",
    "backgroundColor"
  ]);
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  const mergeSize = customizeSize || size || "m";
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick == null ? void 0 : onClick(e);
  };
  if (variant === "link") {
    return /* @__PURE__ */ react.createElement(StyledLink, __spreadValues({
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      className,
      itemHorizontalSpacing: "s4",
      color: disabled ? BUTTON_CONFIG.disabled.iconColor.link : BUTTON_CONFIG.iconColor.link,
      onClick: handleClick,
      disabled: !!disabled
    }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? mergeSize === "m" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : /* @__PURE__ */ react.createElement(Typography_index_es/* Caption */.YS, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0);
  }
  return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
    height: BUTTON_CONFIG.height[mergeSize],
    padding: shape !== "circle" ? ["s0", "s20"] : void 0,
    itemHorizontalSpacing: "s8",
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.iconColor[variant] : BUTTON_CONFIG.iconColor[variant],
    backgroundColor,
    variant,
    disabled: !!disabled,
    block,
    shape,
    size: mergeSize,
    onClick: handleClick,
    className,
    type
  }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    className: "button-text",
    level: mergeSize === "s" ? 2 : 1,
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.textColor[variant] : BUTTON_CONFIG.textColor[variant]
  }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0, /* @__PURE__ */ react.createElement("span", {
    style: { marginLeft: 0 }
  }, /* @__PURE__ */ react.createElement(Ripple, null)));
};
const Spacer = emotion_styled_browser_esm["default"].span`
  width: 0.5rem;
`;
const StyledButton = emotion_styled_browser_esm["default"].button(({
  height,
  theme,
  color,
  block,
  disabled,
  backgroundColor
}) => {
  var _a;
  return [
    BaseProps_index_es/* CommonStyles */.F,
    IconBase_es/* SvgCss */.uL,
    buttonShapeStyle,
    buttonStyleByVariant,
    `position: relative;
display: flex;
align-items: center;
justify-content: center;
outline: none;
min-width: ${height};
${color ? `color: ${((_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a[color]) || color};` : ""}
${block ? `width: 100%;` : ""}
cursor: ${disabled ? "not-allowed" : "pointer"};
${backgroundColor ? `background-color: ${(theme == null ? void 0 : theme.colors[backgroundColor]) || backgroundColor} !important;` : ""}
transition-duration: 80ms;
transition-property: background-color;
&:focus {
  outline: none;
}
`
  ];
});
const StyledLink = emotion_styled_browser_esm["default"].a`
  ${BaseProps_index_es/* CommonStyles */.F}
  ${IconBase_es/* SvgCss */.uL}
  display: inline;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  ${(p) => {
  var _a;
  return p.color ? `color: ${((_a = p.theme) == null ? void 0 : _a.colors[p.color]) || p.color}!important;` : "";
}}
  text-decoration: none;
  ${(p) => !p.disabled ? `
    &:hover {
      text-decoration: underline;
    }

  div {
    display: inline;
  }
  ` : ""}
`;




/***/ }),

/***/ 141291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(160827);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledFlex = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div((_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  return [
    (0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F)(__spreadValues({ theme }, props)),
    {
      display: "flex",
      flexDirection: props.direction,
      gap: theme.spacing[props.gap || "s0"],
      columnGap: theme.spacing[props.gapX || props.gap || "s0"],
      rowGap: theme.spacing[props.gapY || props.gap || "s0"],
      justifyContent: buildVariant(props.justify || ""),
      alignItems: buildVariant(props.align || ""),
      flexWrap: props.flexWrap
    }
  ];
});
const buildVariant = (variant) => {
  switch (variant) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return variant;
  }
};
StyledFlex.defaultProps = {
  direction: "row",
  justify: "start",
  align: "baseline",
  flexWrap: "nowrap"
};
const Flex = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlex, __spreadValues({}, props));




/***/ }),

/***/ 312388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(927307);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(160827);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Shape/index.es.js



const Shape = emotion_styled_browser_esm["default"].div`
  ${BaseProps_index_es/* CommonStyles */.F};
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DeleteCircleColored.es.js
var DeleteCircleColored_es = __webpack_require__(379126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CautionOutlined.es.js
var CautionOutlined_es = __webpack_require__(47649);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/constants/index.es.js
var constants_index_es = __webpack_require__(766633);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(368156);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Input/Input.es.js









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Input = (0,react.forwardRef)((_a, ref) => {
  var _b = _a, {
    title,
    value,
    defaultValue,
    autoFocus,
    type = "text",
    placeholder,
    caption,
    showCaptionIcon = true,
    error,
    disabled,
    readonly,
    prefix,
    suffix,
    maxLength = 255,
    className,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    size: customizeSize,
    id,
    allowClear = false
  } = _b, rest = __objRest(_b, [
    "title",
    "value",
    "defaultValue",
    "autoFocus",
    "type",
    "placeholder",
    "caption",
    "showCaptionIcon",
    "error",
    "disabled",
    "readonly",
    "prefix",
    "suffix",
    "maxLength",
    "className",
    "onChange",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "size",
    "id",
    "allowClear"
  ]);
  var _a2, _b2;
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  const mergeSize = customizeSize || size || "m";
  const handleFocus = (e) => {
    onFocus && onFocus(e);
  };
  const handleBlur = (e) => {
    onBlur && onBlur(e);
  };
  const colorState = disabled ? "disable" : error ? "error500" : void 0;
  const handleClear = () => {
    onChange == null ? void 0 : onChange("");
  };
  return /* @__PURE__ */ react.createElement(StyledInput, __spreadValues({
    className
  }, rest), title && /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 4,
    color: "textPrimary",
    marginBottom: "s4"
  }, title), /* @__PURE__ */ react.createElement(InputContainer, {
    className: "input-container",
    padding: ["s0", "s12"],
    borderWeight: "m",
    borderRadius: "s",
    borderStyle: "solid",
    height: constants_index_es/* MAPPING_SIZE */.v[mergeSize],
    colorState: colorState || "primary500",
    readonly: !!readonly,
    disabled: !!disabled
  }, prefix && /* @__PURE__ */ react.createElement(StyledSpace, {
    height: constants_index_es/* MAPPING_SIZE */.v[mergeSize],
    marginRight: "s4"
  }, typeof prefix === "string" ? /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 2,
    color: disabled ? "border" : "textPrimary"
  }, prefix) : react.cloneElement(prefix, {
    size: ((_a2 = prefix == null ? void 0 : prefix.props) == null ? void 0 : _a2.size) || 20
  })), /* @__PURE__ */ react.createElement(StyledBaseInput, {
    ref,
    id,
    type,
    value,
    defaultValue,
    autoFocus,
    placeholder,
    onChange: (event) => onChange && onChange(event.target.value),
    onFocus: handleFocus,
    onBlur: handleBlur,
    maxLength,
    disabled,
    readOnly: readonly,
    backgroundColor: rest.backgroundColor || "",
    onKeyDown: (event) => {
      if (onKeyDown)
        onKeyDown(event);
    }
  }), allowClear && !!value && /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, {
    name: "circle-close",
    onClick: handleClear,
    size: 20,
    cursor: "pointer"
  }), suffix && /* @__PURE__ */ react.createElement(StyledSpace, {
    height: constants_index_es/* MAPPING_SIZE */.v[mergeSize],
    marginLeft: "s4"
  }, typeof suffix === "string" ? /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 2,
    color: disabled ? "border" : "textPrimary"
  }, suffix) : react.cloneElement(suffix, {
    size: ((_b2 = suffix == null ? void 0 : suffix.props) == null ? void 0 : _b2.size) || 20
  }))), caption && /* @__PURE__ */ react.createElement(StyledSpace, {
    marginTop: "s8"
  }, showCaptionIcon && /* @__PURE__ */ react.createElement(CautionOutlined_es/* CautionOutlined */.s, {
    size: 16,
    color: colorState || "textSecondary"
  }), /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 1,
    color: colorState || "textSecondary",
    marginLeft: "s4"
  }, caption)));
});
Input.displayName = "Input";
const StyledInput = emotion_styled_browser_esm["default"].div`
  ${BaseProps_index_es/* CommonStyles */.F}
`;
const StyledBaseInput = emotion_styled_browser_esm["default"].input`
  flex-grow: 1;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor + " !important" : "inherit"};
`;
const StyledSpace = (0,emotion_styled_browser_esm["default"])(Shape)`
  display: flex;
  align-items: center;
`;
const InputContainer = (0,emotion_styled_browser_esm["default"])(Shape)`
  display: flex;
  align-items: center;
  border-color: ${(p) => p.disabled ? p.theme.colors.background : p.theme.colors.inputBorder};
  gap: 0.25rem;

  :focus,
  :focus-within {
    border-color: ${(p) => p.theme.colors[p.colorState]};
  }

  ${(p) => p.disabled || p.readonly ? `background-color: ${p.theme.colors.background};` : p.theme.colors.white}
  overflow: hidden;
  input {
    flex: 1;
    width: 100%;
    border: none;
    font-size: 13px;
    color: ${(p) => p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary};

    &::placeholder {
      color: ${(p) => p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder};
    }
    &:focus {
      outline: none;
    }
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;




/***/ }),

/***/ 217452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal_es_Modal; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(255878);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(927307);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-dom-virtual-d2a5f90a4a/0/cache/react-dom-npm-18.2.0-dd675bca1c-7d323310be.zip/node_modules/react-dom/index.js
var react_dom = __webpack_require__(926759);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js



const Overlay = ({
  show,
  children,
  parent,
  onEscPressed,
  id,
  zIndex,
  justifyContent,
  alignItems
}) => {
  const elmRef = (0,react.useRef)();
  const [, setValue] = (0,react.useState)(0);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    if (id)
      elm.id = id;
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = `${zIndex || 1051}`;
    elm.style.display = "flex";
    elm.style.justifyContent = justifyContent || "center";
    elm.style.alignItems = alignItems || "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    parentElement == null ? void 0 : parentElement.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      parentElement == null ? void 0 : parentElement.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  };
  (0,react.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom.createPortal(children, elmRef.current);
};



// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(285212);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/helpers/utils.es.js





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const formatDateTime = (date, type) => {
  const dateStr = date.toLocaleDateString("en-GB");
  const timeStr = date.toLocaleTimeString("vi-VN").slice(0, 5);
  switch (type) {
    case "date":
      return dateStr;
    case "time":
      return timeStr;
    default:
      return `${dateStr} ${timeStr}`;
  }
};
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      const refs = Array.isArray(ref) ? ref : [ref];
      if (!refs.some((ref2) => ref2.current) || refs.some((e) => {
        var _a;
        return (_a = e.current) == null ? void 0 : _a.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    document.addEventListener("click", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("click", listener);
    };
  }, [ref, handler]);
};
const generateTheme = (baseColor) => {
  return __spreadProps(__spreadValues({}, defaultTheme), {
    colors: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, themeColor), generate(baseColor.primary, "primary")), generate(baseColor.secondary, "secondary")), baseColor.link && generate(baseColor.link, "link"))
  });
};
const pixelParse = (value) => {
  if (typeof value === "number")
    return `${value}px`;
  return value;
};
const getScrollbarWidth = () => {
  var _a;
  let width = 0;
  if (typeof window !== "undefined") {
    if (document.body.scrollHeight <= window.innerHeight)
      return 0;
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    (_a = outer.parentNode) == null ? void 0 : _a.removeChild(outer);
  }
  return width;
};
const toArray = (candidate) => {
  if (candidate === void 0 || candidate === false)
    return [];
  return Array.isArray(candidate) ? candidate : [candidate];
};
const omit = (obj, fields) => {
  const clone = __spreadValues({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach((key) => {
      delete clone[key];
    });
  }
  return clone;
};
const mergeCls = (...cls) => {
  return cls.filter(Boolean).join(" ");
};
const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
const getElementOffset = (elem) => {
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top, left };
};
const isNotNullOrUndefinedElement = (val) => !!val;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Modal/OldModal.es.js






var OldModal_es_defProp = Object.defineProperty;
var OldModal_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var OldModal_es_hasOwnProp = Object.prototype.hasOwnProperty;
var OldModal_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var OldModal_es_defNormalProp = (obj, key, value) => key in obj ? OldModal_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var OldModal_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (OldModal_es_hasOwnProp.call(b, prop))
      OldModal_es_defNormalProp(a, prop, b[prop]);
  if (OldModal_es_getOwnPropSymbols)
    for (var prop of OldModal_es_getOwnPropSymbols(b)) {
      if (OldModal_es_propIsEnum.call(b, prop))
        OldModal_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (OldModal_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && OldModal_es_getOwnPropSymbols)
    for (var prop of OldModal_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && OldModal_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal = (_a) => {
  var _b = _a, {
    show,
    onHide,
    children,
    size = ds_index_es/* SizeEnum.m */.mO.m,
    backDropStyle,
    parent
  } = _b, props = __objRest(_b, [
    "show",
    "onHide",
    "children",
    "size",
    "backDropStyle",
    "parent"
  ]);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react.useEffect)(() => {
    if (!parentElement || !show) {
      return;
    }
    parentElement.style.overflow = "hidden";
    parentElement.style.paddingRight = `${getScrollbarWidth()}px`;
    return () => {
      parentElement.style.overflow = "unset";
      parentElement.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react.createElement(Overlay, {
    parent: parentElement || void 0,
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react.createElement(Backdrop, {
    onClick: onHide,
    style: backDropStyle
  }), /* @__PURE__ */ react.createElement(ModalContent, OldModal_es_spreadValues({
    size
  }, props), children));
};
const Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  [ds_index_es/* SizeEnum.s */.mO.s]: "400px",
  [ds_index_es/* SizeEnum.m */.mO.m]: "700px",
  [ds_index_es/* SizeEnum.l */.mO.l]: "960px"
};
const ModalContent = emotion_styled_browser_esm["default"].div(({
  theme,
  size,
  width,
  maxHeight,
  borderRadius,
  backgroundColor
}) => `
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.white)};
    display: flex;
    flex-direction: column;
    width: ${width !== void 0 ? pixelParse(width) : sizeMaps[size || "m"]};
    border-radius: ${borderRadius || (theme == null ? void 0 : theme.borderRadius.m)};
    max-height: ${maxHeight || "90%"};
    z-index: 1060;
    position: relative;
    overflow-y: auto;
  `);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Button/Button.es.js + 2 modules
var Button_es = __webpack_require__(849114);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Modal/Modal.es.js










var Modal_es_defProp = Object.defineProperty;
var Modal_es_defProps = Object.defineProperties;
var Modal_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Modal_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Modal_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Modal_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Modal_es_defNormalProp = (obj, key, value) => key in obj ? Modal_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Modal_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Modal_es_hasOwnProp.call(b, prop))
      Modal_es_defNormalProp(a, prop, b[prop]);
  if (Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(b)) {
      if (Modal_es_propIsEnum.call(b, prop))
        Modal_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Modal_es_spreadProps = (a, b) => Modal_es_defProps(a, Modal_es_getOwnPropDescs(b));
var Modal_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Modal_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Modal_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal_es_Modal = (_a) => {
  var _b = _a, {
    onClose,
    onBackDrop,
    visible,
    title,
    children,
    footer = true,
    width,
    maxWidth,
    style,
    contentStyle,
    onOk,
    onCancel,
    okText,
    cancelText,
    okButtonProps,
    cancelButtonProps,
    showCloseIcon = true,
    centeredTitle = false,
    centeredBody = false,
    alignFooter = "right",
    fullWidthFooter = false,
    closable = true,
    overlayRef,
    zIndex,
    disableEscClose = true,
    overlayAlignItems,
    overlayJustifyContent
  } = _b, rest = Modal_es_objRest(_b, [
    "onClose",
    "onBackDrop",
    "visible",
    "title",
    "children",
    "footer",
    "width",
    "maxWidth",
    "style",
    "contentStyle",
    "onOk",
    "onCancel",
    "okText",
    "cancelText",
    "okButtonProps",
    "cancelButtonProps",
    "showCloseIcon",
    "centeredTitle",
    "centeredBody",
    "alignFooter",
    "fullWidthFooter",
    "closable",
    "overlayRef",
    "zIndex",
    "disableEscClose",
    "overlayAlignItems",
    "overlayJustifyContent"
  ]);
  const onCloseModal = () => {
    if (!closable)
      return;
    if (typeof onClose === "function") {
      onClose == null ? void 0 : onClose();
    }
    if (typeof onBackDrop === "function") {
      onBackDrop == null ? void 0 : onBackDrop();
    }
  };
  const closeOnEscapeKeyDown = (e) => {
    if (!closable || disableEscClose)
      return;
    if ((e.charCode || e.keyCode) === 27) {
      onCloseModal();
    }
  };
  const transitions = (0,react_spring_esm.useTransition)(visible, {
    from: { opacity: 0, transform: "translateY(-40px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    leave: { opacity: 0, transform: "translateY(-40px)" }
  });
  (0,react.useEffect)(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);
  (0,react.useEffect)(() => {
    if (typeof document !== "undefined") {
      const currentModals = document.querySelectorAll('*[id^="teko-modal"]');
      if (currentModals.length) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${getScrollbarWidth()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [visible]);
  const renderFooter = () => {
    if (footer === false || footer === null || footer === void 0) {
      return null;
    }
    const footerCls = mergeCls("teko-modal-footer", `teko-modal-footer-${alignFooter}`);
    if (footer === true) {
      const style2 = fullWidthFooter ? { flex: 1 } : {};
      return /* @__PURE__ */ react.createElement("div", {
        className: footerCls
      }, cancelText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, Modal_es_spreadProps(Modal_es_spreadValues({
        marginRight: okText !== "" ? "s12" : "s0",
        onClick: () => onCancel == null ? void 0 : onCancel()
      }, cancelButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, cancelButtonProps == null ? void 0 : cancelButtonProps.style), style2)
      }), cancelText || "Cancel"), okText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, Modal_es_spreadProps(Modal_es_spreadValues({
        variant: "primary",
        onClick: () => onOk == null ? void 0 : onOk()
      }, okButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, okButtonProps == null ? void 0 : okButtonProps.style), style2)
      }), okText || "OK"));
    }
    return /* @__PURE__ */ react.createElement("div", {
      className: footerCls
    }, footer);
  };
  const modalCls = mergeCls("teko-modal", visible ? "teko-modal-show" : "", rest.className || "");
  const modalTitleCls = mergeCls("teko-modal-title", centeredTitle ? "teko-modal-title-centered" : "");
  const modalBodyCls = mergeCls("teko-modal-body", centeredBody ? "teko-modal-body-centered" : "");
  if (typeof (rest == null ? void 0 : rest.show) !== "undefined") {
    const oldModalProps = Modal_es_spreadProps(Modal_es_spreadValues({}, rest), {
      children,
      width
    });
    return /* @__PURE__ */ react.createElement(Modal, Modal_es_spreadValues({}, oldModalProps));
  }
  return /* @__PURE__ */ react.createElement(Overlay, {
    show: !!visible,
    onEscPressed: () => {
      if (!disableEscClose)
        onCloseModal();
    },
    id: `teko-modal-${uid()}`,
    zIndex,
    alignItems: overlayAlignItems,
    justifyContent: overlayJustifyContent
  }, /* @__PURE__ */ react.createElement(Modal_es_Backdrop, {
    onClick: onCloseModal
  }), transitions((styles, item) => item && /* @__PURE__ */ react.createElement(AnimatedModal, Modal_es_spreadProps(Modal_es_spreadValues({
    className: modalCls,
    style: Modal_es_spreadValues(Modal_es_spreadValues(Modal_es_spreadValues({}, styles), !!width ? { width } : {}), style)
  }, rest), {
    ref: overlayRef,
    maxWidth
  }), /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-content",
    style: Modal_es_spreadValues({}, contentStyle),
    onClick: (e) => e.stopPropagation()
  }, showCloseIcon && /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    className: "teko-modal-close",
    size: 24,
    color: "#000000",
    onClick: onCloseModal
  }), title && /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-header"
  }, typeof title === "string" ? /* @__PURE__ */ react.createElement(index_es/* Title */.Dx, {
    level: 1,
    className: modalTitleCls
  }, title) : /* @__PURE__ */ react.createElement("div", {
    className: modalTitleCls
  }, title)), /* @__PURE__ */ react.createElement("div", {
    className: modalBodyCls
  }, children, renderFooter())))));
};
const Modal_es_Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const StyledModal = emotion_styled_browser_esm["default"].div`
  width: ${({ size }) => modalSizes[size || "m"]};
  max-width: ${({ maxWidth }) => !!maxWidth ? maxWidth : "95%"};
  &.teko-modal-show {
    opacity: 1 !important;
    pointer-events: visible;
  }

  &.teko-modal-show .teko-modal-content {
    transform: translateY(0);
    z-index: 1050;
  }

  .teko-modal-content {
    padding: 24px;
    transition: all 0.2s ease-in-out;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05),
      0px 8px 16px rgba(0, 0, 0, 0.05);
    position: relative;
    border-radius: 8px;
    position: relative;

    .teko-modal-close {
      position: absolute;
      z-index: 1000;
      top: 24px;
      right: 24px;
      cursor: pointer;
    }

    .teko-modal-header {
      .teko-modal-title {
        margin-bottom: 24px;
        color: #1b1d29;
        &.teko-modal-title-centered {
          text-align: center;
        }
      }
    }

    .teko-modal-body {
      font-size: 13px;
      line-height: 20px;
      word-wrap: break-word;
      &.teko-modal-body-centered {
        text-align: center;
      }
    }

    .teko-modal-footer {
      margin-top: 24px;
      &.teko-modal-footer-right {
        display: flex;
        justify-content: flex-end;
      }
      &.teko-modal-footer-left {
        display: flex;
        justify-content: flex-start;
      }
      &.teko-modal-footer-center {
        display: flex;
        justify-content: center;
      }
    }
  }
`;
const AnimatedModal = (0,react_spring_esm.animated)(StyledModal);
AnimatedModal.defaultProps = {
  size: "m"
};
const modalSizes = {
  xs: "320px",
  s: "420px",
  m: "520px",
  l: "720px"
};




/***/ }),

/***/ 886786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(160827);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F);
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 927307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* binding */ Body; },
  "YS": function() { return /* binding */ Caption; },
  "DK": function() { return /* binding */ SubTitle; },
  "Dx": function() { return /* binding */ Title; }
});

// UNUSED EXPORTS: Heading

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Typography/helper.es.js
const TYPOGRAPHY_SIZE = {
  heading: [
    {
      fontSize: "48px",
      lineHeight: "64px",
      fontWeight: "bold"
    },
    {
      fontSize: "40px",
      lineHeight: "56px",
      fontWeight: "medium"
    },
    {
      fontSize: "36px",
      lineHeight: "48px",
      fontWeight: "medium"
    },
    {
      fontSize: "32px",
      lineHeight: "40px",
      fontWeight: "bold"
    }
  ],
  title: [
    {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: "bold"
    },
    {
      fontSize: "20px",
      lineHeight: "28px",
      fontWeight: "bold"
    },
    {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  subtitle: [
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "medium"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  body: [
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "regular"
    },
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "medium"
    }
  ],
  caption: [
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "regular"
    },
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "medium"
    },
    {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "medium"
    }
  ]
};
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const getTypographySize = (type, level = 1, attr) => {
  const tagAttrs = TYPOGRAPHY_SIZE[type][level - 1] || TYPOGRAPHY_SIZE[type][0];
  return tagAttrs[attr];
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(160827);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-596956ade8/1/packages/ds-foundation/dist/components/Typography/index.es.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledTypography = emotion_styled_browser_esm["default"].div`
  margin: 0;
  padding: 0;
  ${index_es/* CommonStyles */.F}
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => (p.weight ? FONT_WEIGHT_MAP[p.weight] : FONT_WEIGHT_MAP[getTypographySize(p.type, p.level, "fontWeight")]) || 500};
  text-decoration: ${(p) => p.decoration || "unset"};
  font-size: ${(p) => getTypographySize(p.type, p.level, "fontSize")};
  line-height: ${(p) => getTypographySize(p.type, p.level, "lineHeight")};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(p) => p.line || "unset"};
  max-width: ${(p) => p.maxWidth ? `${p.maxWidth}px` : "unset"};
  min-width: ${(p) => p.minWidth ? `${p.minWidth}px` : "unset"};
  transition: color 0.3s ease;
  ${(p) => p.hoverColor ? `&:hover {
    color: ${p.theme.colors[p.hoverColor] || p.hoverColor};
  }` : ""};
  ${(p) => p.textTransform ? `
        text-transform: ${p.textTransform};
      ` : ""}
`;
const Heading = (_a) => {
  var _b = _a, { level = 4 } = _b, props = __objRest(_b, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "heading",
    as: `h${level}`,
    level
  }, props));
};
const Title = (_c) => {
  var _d = _c, { level = 2 } = _d, props = __objRest(_d, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "title",
    level
  }, props));
};
const SubTitle = (_e) => {
  var _f = _e, { level = 4 } = _f, props = __objRest(_f, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "subtitle",
    level
  }, props));
};
const Body = (_g) => {
  var _h = _g, { level = 2 } = _h, props = __objRest(_h, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "body",
    level
  }, props));
};
const Caption = (_i) => {
  var _j = _i, { level = 3 } = _j, props = __objRest(_j, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "caption",
    level
  }, props));
};




/***/ }),

/***/ 766633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ MAPPING_SIZE; },
/* harmony export */   "y": function() { return /* binding */ CORE_SIZE; }
/* harmony export */ });
const CORE_SIZE = {
  s0: "0rem",
  s4: "0.25rem",
  s8: "0.5rem",
  s12: "0.75rem",
  s16: "1rem",
  s20: "1.25rem",
  s24: "1.5rem",
  s28: "1.75rem",
  s32: "2rem",
  s36: "2.25rem",
  s40: "2.5rem",
  s44: "2.75rem",
  s48: "3rem",
  s52: "3.25rem",
  s56: "3.5rem",
  s60: "3.75rem",
  s64: "4rem",
  s68: "4.25rem",
  s72: "4.5rem",
  s76: "4.75rem",
  s80: "5rem"
};
const MAPPING_SIZE = {
  s: 32,
  m: 40,
  l: 48,
  xl: 56
};




/***/ }),

/***/ 368156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SizeContext; }
/* harmony export */ });
/* unused harmony export SizeContextProvider */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const SizeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0);
const SizeContextProvider = ({
  children,
  size
}) => /* @__PURE__ */ React__default.createElement(SizeContext.Consumer, null, (originSize) => /* @__PURE__ */ React__default.createElement(SizeContext.Provider, {
  value: size || originSize
}, children));




/***/ }),

/***/ 640128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ CommonStyles; },
/* harmony export */   "L": function() { return /* binding */ getDimension; }
/* harmony export */ });
const getDimension = (value, prefix = "", suffix = "") => {
  if (!value)
    return "";
  return prefix + (typeof value === "number" ? `${value}px` : value) + suffix;
};
const jsToCss = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
const getSpacing = (props) => {
  const dimension = [
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft"
  ];
  return dimension.reduce((prev, curr) => {
    var _a;
    const currentProp = props[curr];
    if (currentProp) {
      if (typeof currentProp === "string") {
        return `${prev}
${jsToCss(curr)}: ${(_a = props.theme) == null ? void 0 : _a.spacing[currentProp]};`;
      }
      return `${prev}
${jsToCss(curr)}: ${currentProp.map((c) => {
        var _a2;
        return (_a2 = props.theme) == null ? void 0 : _a2.spacing[c];
      }).join(" ")};`;
    }
    return prev;
  }, "");
};
const getItemSpacing = (props) => {
  var _a, _b;
  return `
    ${props.itemHorizontalSpacing ? `
      > *:not(:first-of-type) {
        margin-left: ${(_a = props.theme) == null ? void 0 : _a.spacing[props.itemHorizontalSpacing]};
      }
    ` : ""}
    ${props.itemVerticalSpacing ? `
      > *:not(:first-of-type) {
        margin-top: ${(_b = props.theme) == null ? void 0 : _b.spacing[props.itemVerticalSpacing]};
      }
    ` : ""}`;
};
const replaceColor = (value, colors) => {
  const values = value.split(" ").map((i) => colors[i] ? colors[i] : i);
  return values.join(" ");
};
const CommonStyles = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return `
  border-style: ${props.borderStyle ? props.borderStyle : "none"};
  ${!!props.borderRadius && ` border-radius: ${props.borderRadius ? (_a = props.theme) == null ? void 0 : _a.borderRadius[props.borderRadius] : "0px"};`};

  border-width: ${props.borderWeight ? (_b = props.theme) == null ? void 0 : _b.borderWeight[props.borderWeight] : "1px"};
  border-color: ${props.borderColor ? (_c = props.theme) == null ? void 0 : _c.colors[props.borderColor] : "unset"};
  ${props.border ? `border: ${replaceColor(props.border, ((_d = props.theme) == null ? void 0 : _d.colors) || {})};` : ""};
  ${props.borderTop ? `border-top: ${replaceColor(props.borderTop, ((_e = props.theme) == null ? void 0 : _e.colors) || {})};` : ""};
  ${props.borderRight ? `border-right: ${replaceColor(props.borderRight, ((_f = props.theme) == null ? void 0 : _f.colors) || {})};` : ""};
  ${props.borderBottom ? `border-bottom: ${replaceColor(props.borderBottom, ((_g = props.theme) == null ? void 0 : _g.colors) || {})};` : ""};
  ${props.borderLeft ? `border-left: ${replaceColor(props.borderLeft, ((_h = props.theme) == null ? void 0 : _h.colors) || {})};` : ""};
  opacity: ${props.opacity ? (_i = props.theme) == null ? void 0 : _i.opacity[props.opacity] : 1};
  box-shadow: ${(p) => {
    var _a2;
    return (_a2 = p.theme) == null ? void 0 : _a2.shadow(p, props.shadow || "", props.shadowColor);
  }};
  ${props.backgroundColor && `background-color: ${((_j = props.theme) == null ? void 0 : _j.colors[props.backgroundColor]) || props.backgroundColor};
  `};
  ${getDimension(props.width || "", "width: ", ";")}
  ${getDimension(props.maxWidth || "", "max-width: ", ";")}
  ${getDimension(props.height || "", "height: ", ";")}
  ${getDimension(props.maxHeight || "", "max-height: ", ";")}
  ${getSpacing(props)}
  ${getItemSpacing(props)}

`;
};




/***/ }),

/***/ 806748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/helpers/IconBase.es.js
var IconBase_es = __webpack_require__(404334);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var index_es = __webpack_require__(285212);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(263008);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/constants/index.es.js
var constants_index_es = __webpack_require__(978719);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/constant.es.js


const BUTTON_CONFIG = {
  height: {
    xs: constants_index_es/* CORE_SIZE.s24 */.y.s24,
    s: constants_index_es/* CORE_SIZE.s32 */.y.s32,
    m: constants_index_es/* CORE_SIZE.s40 */.y.s40,
    l: constants_index_es/* CORE_SIZE.s48 */.y.s48
  },
  textColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textPrimary",
    link: "link500",
    "white-ghost": "primary500"
  },
  iconColor: {
    primary: "white",
    secondary: "primary500",
    ghost: "textSecondary",
    link: "link500",
    "white-ghost": "primary500"
  },
  disabled: {
    textColor: {
      primary: "placeholder",
      secondary: "placeholder",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    },
    iconColor: {
      primary: "border",
      secondary: "border",
      ghost: "disable",
      link: "disable",
      "white-ghost": "placeholder"
    }
  }
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Ripple/Ripple.es.js
var Ripple_es = __webpack_require__(768384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-react-virtual-fce7dbd44e/0/cache/@emotion-react-npm-11.5.0-7e3b735976-4188b664cc.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(75537);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js











var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonStyleByVariant = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  switch (props.variant) {
    case "default": {
      return emotion_react_browser_esm.css`
        background-color: transparent;
        border: 1px solid
          ${props.disabled ? (_a = props.theme) == null ? void 0 : _a.colors.disable : (_b = props.theme) == null ? void 0 : _b.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_c = props.theme) == null ? void 0 : _c.colors.textSecondary};
        }
        &:active {
          border-color: ${(_d = props.theme) == null ? void 0 : _d.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_e = props.theme) == null ? void 0 : _e.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_f = props.theme) == null ? void 0 : _f.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
        border: 1px solid
          ${props.disabled ? (_h = props.theme) == null ? void 0 : _h.colors.disable : (_i = props.theme) == null ? void 0 : _i.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_j = props.theme) == null ? void 0 : _j.colors.textSecondary};
        }
        &:active {
          border-color: ${(_k = props.theme) == null ? void 0 : _k.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_l = props.theme) == null ? void 0 : _l.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_m = props.theme) == null ? void 0 : _m.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "secondary": {
      return emotion_react_browser_esm.css`
        background-color: ${(_n = props.theme) == null ? void 0 : _n.colors.white};
        border: 1px solid
          ${props.disabled ? (_o = props.theme) == null ? void 0 : _o.colors.disable : (_p = props.theme) == null ? void 0 : _p.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            border-color: ${(_q = props.theme) == null ? void 0 : _q.colors.primary600};
            div[type=body] {
              color: ${(_r = props.theme) == null ? void 0 : _r.colors.primary600};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_s = props.theme) == null ? void 0 : _s.colors.primary600};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_t = props.theme) == null ? void 0 : _t.colors.primary600};
            }
          }
          &:active {
            border-color: ${(_u = props.theme) == null ? void 0 : _u.colors.primary700};
            div[type=body] {
              color: ${(_v = props.theme) == null ? void 0 : _v.colors.primary700};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_w = props.theme) == null ? void 0 : _w.colors.primary700};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_x = props.theme) == null ? void 0 : _x.colors.primary700};
            }
          }
        ` : ""}
      `;
    }
    case "white-ghost": {
      return emotion_react_browser_esm.css`
        background-color: ${(_y = props.theme) == null ? void 0 : _y.colors.white};
        border: none;
        ${props.disabled ? `
          background-color: ${(_z = props.theme) == null ? void 0 : _z.colors.disable};
          ` : `
          &:hover {
            background-color: ${(_A = props.theme) == null ? void 0 : _A.colors.tableHeader};
          }
          &:active {
            background-color: ${(_B = props.theme) == null ? void 0 : _B.colors.background};
          }
        `}
      `;
    }
    case "primary":
    default:
      return emotion_react_browser_esm.css`
        background-color: ${props.disabled ? (_C = props.theme) == null ? void 0 : _C.colors.disable : (_D = props.theme) == null ? void 0 : _D.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            background-color: ${(_E = props.theme) == null ? void 0 : _E.colors.primary600};
          }
          &:active {
            background-color: ${(_F = props.theme) == null ? void 0 : _F.colors.primary700};
          }
        ` : ""}
      `;
  }
};
const buttonShapeStyle = ({
  theme,
  shape,
  size,
  borderRadius
}) => {
  switch (shape) {
    case index_es/* ButtonShapeEnum.round */.Vz.round:
      return emotion_react_browser_esm.css`
        border-radius: ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem
          ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem;
      `;
    case index_es/* ButtonShapeEnum.circle */.Vz.circle:
      return emotion_react_browser_esm.css`
        border-radius: 50%;
      `;
    default:
      return emotion_react_browser_esm.css`
        border-radius: ${theme == null ? void 0 : theme.borderRadius[borderRadius || "s"]};
      `;
  }
};
const Button = (_a) => {
  var _b = _a, {
    children,
    block = false,
    shape,
    size: customizeSize,
    variant = "default",
    prefix,
    suffix,
    disabled,
    onClick,
    className,
    href,
    type = "button",
    backgroundColor
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "shape",
    "size",
    "variant",
    "prefix",
    "suffix",
    "disabled",
    "onClick",
    "className",
    "href",
    "type",
    "backgroundColor"
  ]);
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  const mergeSize = customizeSize || size || "m";
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick == null ? void 0 : onClick(e);
  };
  if (variant === "link") {
    return /* @__PURE__ */ react.createElement(StyledLink, __spreadValues({
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      className,
      itemHorizontalSpacing: "s4",
      color: disabled ? BUTTON_CONFIG.disabled.iconColor.link : BUTTON_CONFIG.iconColor.link,
      onClick: handleClick,
      disabled: !!disabled
    }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? mergeSize === "m" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : /* @__PURE__ */ react.createElement(Typography_index_es/* Caption */.YS, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0);
  }
  return /* @__PURE__ */ react.createElement(StyledButton, __spreadValues({
    height: BUTTON_CONFIG.height[mergeSize],
    padding: shape !== "circle" ? ["s0", "s20"] : void 0,
    itemHorizontalSpacing: "s8",
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.iconColor[variant] : BUTTON_CONFIG.iconColor[variant],
    backgroundColor,
    variant,
    disabled: !!disabled,
    block,
    shape,
    size: mergeSize,
    onClick: handleClick,
    className,
    type
  }, rest), prefix ? /* @__PURE__ */ react.createElement(react.Fragment, null, prefix, /* @__PURE__ */ react.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? /* @__PURE__ */ react.createElement(Typography_index_es/* Body */.uT, {
    className: "button-text",
    level: mergeSize === "s" ? 2 : 1,
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.textColor[variant] : BUTTON_CONFIG.textColor[variant]
  }, children) : children, suffix ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Spacer, null), suffix) : void 0, /* @__PURE__ */ react.createElement("span", {
    style: { marginLeft: 0 }
  }, /* @__PURE__ */ react.createElement(Ripple_es/* Ripple */.H, null)));
};
const Spacer = emotion_styled_browser_esm["default"].span`
  width: 0.5rem;
`;
const StyledButton = emotion_styled_browser_esm["default"].button(({
  height,
  theme,
  color,
  block,
  disabled,
  backgroundColor
}) => {
  var _a;
  return [
    BaseProps_index_es/* CommonStyles */.F,
    IconBase_es/* SvgCss */.uL,
    buttonShapeStyle,
    buttonStyleByVariant,
    `position: relative;
display: flex;
align-items: center;
justify-content: center;
outline: none;
min-width: ${height};
${color ? `color: ${((_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a[color]) || color};` : ""}
${block ? `width: 100%;` : ""}
cursor: ${disabled ? "not-allowed" : "pointer"};
${backgroundColor ? `background-color: ${(theme == null ? void 0 : theme.colors[backgroundColor]) || backgroundColor} !important;` : ""}
transition-duration: 80ms;
transition-property: background-color;
&:focus {
  outline: none;
}
`
  ];
});
const StyledLink = emotion_styled_browser_esm["default"].a`
  ${BaseProps_index_es/* CommonStyles */.F}
  ${IconBase_es/* SvgCss */.uL}
  display: inline;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  ${(p) => {
  var _a;
  return p.color ? `color: ${((_a = p.theme) == null ? void 0 : _a.colors[p.color]) || p.color}!important;` : "";
}}
  text-decoration: none;
  ${(p) => !p.disabled ? `
    &:hover {
      text-decoration: underline;
    }

  div {
    display: inline;
  }
  ` : ""}
`;




/***/ }),

/***/ 115869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4247);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(957518);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const displayColor = props.checked || props.partSelected;
  switch (type) {
    case "border": {
      if (props.disabled) {
        if (displayColor)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.divider;
      } else {
        if (displayColor)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.border;
      }
    }
    case "inner":
    default: {
      if (props.disabled) {
        if (displayColor)
          return (_e = props.theme) == null ? void 0 : _e.colors.primary100;
        return (_f = props.theme) == null ? void 0 : _f.colors.background;
      } else {
        if (displayColor)
          return (_g = props.theme) == null ? void 0 : _g.colors.primary500;
        return (_h = props.theme) == null ? void 0 : _h.colors.white;
      }
    }
  }
};
const Checkbox = (_a) => {
  var _b = _a, {
    checked = false,
    partSelected,
    disabled,
    onChange,
    children,
    className
  } = _b, rest = __objRest(_b, [
    "checked",
    "partSelected",
    "disabled",
    "onChange",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxWrapper, __spreadProps(__spreadValues({}, rest), {
    className: "check-box"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckbox, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "checkbox",
    checked,
    disabled,
    partSelected,
    onChange: () => !disabled && onChange && onChange(!checked),
    className
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CheckboxInner, {
    checked,
    partSelected,
    disabled,
    className: "checkbox-inner"
  }, partSelected ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledMinusIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckIcon, {
    size: 12,
    color: checked ? disabled ? "primary50" : "white" : "transparent"
  }))), children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    line: 1,
    marginLeft: "s4",
    level: 1,
    weight: "regular",
    style: { flex: 1 },
    className: "checkbox-label"
  }, children));
};
const CheckboxWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].label`
  display: inline-flex;
  align-items: center;
  line-height: unset;
  cursor: pointer;
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F}
`;
const StyledCheckIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CheckOutlined */ .b)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 5;
  }
`;
const StyledMinusIcon = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .MinusOutlined */ .l)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  path {
    stroke-width: 4;
    stroke: ${({ theme }) => theme == null ? void 0 : theme.colors.white};
  }
`;
const StyledCheckbox = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
`;
const CheckboxInner = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 16px;
  height: 16px;
  margin: auto;
  border: 1px solid ${(p) => getColor(p, "border")};
  border-radius: 2px;
  background-color: ${(p) => getColor(p, "inner")};
`;
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 16px;
  height: 16px;
  margin: auto;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
  ${(p) => !p.disabled && !p.checked && !p.partSelected ? `
      &:hover + .checkbox-inner {
        border-color: ${p.theme.colors.placeholder};
      }
    ` : ""}
`;




/***/ }),

/***/ 853675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "tk": function() { return /* binding */ thoundsandDelimiter; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(value) {
  if (!value) {
    return "0";
  } else {
    const valueInNumber = typeof value === "number" ? value : parseInt(value);
    if (isNaN(valueInNumber)) {
      return "";
    } else {
      return valueInNumber.toLocaleString("de-DE", { maximumFractionDigits: 2 }).toString();
    }
  }
}
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const StyledCurrency = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  width: max-content;
  display: inline-block;
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => p.weight ? FONT_WEIGHT_MAP[p.weight] : "inherit"};
`;
const formatCurrency = (value, {
  hideCurrencySymbol,
  space,
  underline,
  currencyLabel
}) => {
  const formatted = thoundsandDelimiter(value);
  return hideCurrencySymbol ? formatted : `${formatted}${space ? " " : ""}${currencyLabel || (underline ? "\u20AB" : "\u0111")}`;
};
const Currency = (_a) => {
  var _b = _a, {
    value,
    formattedValue,
    hideCurrency = false,
    space = false,
    underline = false,
    currencyLabel
  } = _b, props = __objRest(_b, [
    "value",
    "formattedValue",
    "hideCurrency",
    "space",
    "underline",
    "currencyLabel"
  ]);
  if (!!formattedValue) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), hideCurrency ? formattedValue : `${formattedValue}${space ? " " : ""}${currencyLabel || (underline ? "\u20AB" : "\u0111")}`);
  }
  if (value === 0 || !!value) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), formatCurrency(value, {
      space,
      underline,
      hideCurrencySymbol: hideCurrency,
      currencyLabel
    }));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
};




/***/ }),

/***/ 618428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(350495);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CustomLink = (_a) => {
  var _b = _a, {
    href,
    children,
    passHref = true,
    target = "_self",
    prefetch = false,
    as
  } = _b, others = __objRest(_b, [
    "href",
    "children",
    "passHref",
    "target",
    "prefetch",
    "as"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  const _a2 = newState, { as: newAs } = _a2, newHref = __objRest(_a2, ["as"]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_1___default()), __spreadProps(__spreadValues({
    href: newHref,
    as: newAs
  }, others), {
    passHref,
    legacyBehavior: true,
    prefetch
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, {
    target,
    className: others.className
  }, children));
};
const Anchor = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].a`
  text-decoration: none;
  color: unset;
  &:hover {
    color: unset;
  }
  cursor: pointer;
`;




/***/ }),

/***/ 329944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(184019);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Divider = (_a) => {
  var _b = _a, {
    width = "100%",
    height = "1px",
    color = "black",
    dividerStyle = _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .DividerStyleEnum.solid */ .fd.solid,
    align,
    gap,
    alignContent,
    spacingContent,
    orientation = "horizontal",
    children
  } = _b, rest = __objRest(_b, [
    "width",
    "height",
    "color",
    "dividerStyle",
    "align",
    "gap",
    "alignContent",
    "spacingContent",
    "orientation",
    "children"
  ]);
  const renderSeparator = () => {
    if (!children) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(WrapperSeparator, {
        width,
        weight: height,
        dividerStyle,
        color,
        align,
        orientation
      });
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(WrapperSeparatorText, {
      width,
      weight: height,
      dividerStyle,
      color,
      align,
      alignContent,
      spacingContent,
      orientation
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, children));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(WrapperDivider, __spreadProps(__spreadValues({}, rest), {
    width: orientation === "horizontal" ? width : void 0,
    gap,
    orientation
  }), renderSeparator());
};
const WrapperDivider = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ gap, orientation }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
  `
      --divider-gap: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_4__/* .pixelParse */ .oJ)(gap != null ? gap : "") || "12px"};
      display: flex;
      ${orientation === "vertical" ? `
          flex-direction: column;
          writing-mode: vertical-rl;
        ` : ``}
      padding-block: var(--divider-gap)
    `
]);
const transformAlign = (align) => {
  switch (align) {
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.center */ .v2.center:
      return "margin: 0 auto;";
    case _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.right */ .v2.right:
      return `
        margin: 0 auto;
        margin-right: 0;
      `;
    default:
      return "";
  }
};
const transformAlignContent = (alignContent, orientation) => {
  if (orientation === "vertical") {
    const css = `
      {
        display: block;
        content: "";
        flex-grow: 1;
        border-left: var(--divider-border-block);
      }
    `;
    switch (alignContent) {
      case _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.left */ .v2.left:
        return `&:after ${css}`;
      case _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.right */ .v2.right:
        return `&:before ${css}`;
      default:
        return `&:before ${css}; &:after ${css}`;
    }
  } else {
    const css = `
      {
        display: block;
        content: "";
        flex-grow: 1;
        border-top: var(--divider-border-block);
      }
    `;
    switch (alignContent) {
      case _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.left */ .v2.left:
        return `&:after ${css}`;
      case _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.right */ .v2.right:
        return `&:before ${css}`;
      default:
        return `&:before ${css}; &:after ${css}`;
    }
  }
};
const WrapperSeparator = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({ width, weight, dividerStyle, color, align, theme, orientation }) => `
    display: flex;
    --divider-border-block: ${weight || "1px"} ${dividerStyle} ${(theme == null ? void 0 : theme.colors[color]) || color || (theme == null ? void 0 : theme.colors.divider)};
    ${orientation === "vertical" ? `
        height: ${width || "100%"};
        border-left: var(--divider-border-block);
      ` : `
        width: ${width || "100%"};
        border-top: ${weight || "1px"} ${dividerStyle} ${(theme == null ? void 0 : theme.colors[color]) || color || (theme == null ? void 0 : theme.colors.divider)};
      `}
    ${transformAlign(align || _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.left */ .v2.left)}
  `);
const WrapperSeparatorText = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(({
  width,
  weight,
  dividerStyle,
  color = "black",
  align,
  alignContent,
  spacingContent,
  theme,
  orientation = "horizontal"
}) => `
    --divider-border-block: ${weight || "1px"} ${dividerStyle} ${(theme == null ? void 0 : theme.colors[color]) || color || (theme == null ? void 0 : theme.colors.divider)};
    --divider-content-spacing: ${spacingContent || "10px"};
    display: flex;
    align-items: center;
    ${orientation === "vertical" ? "flex-direction: column;" : ""}
    ${orientation === "vertical" ? `height: ${width || "100%"};` : `width: ${width || "100%"};`}
    ${transformAlign(align || _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.left */ .v2.left)}
    ${transformAlignContent(alignContent || _teko_types_shared__WEBPACK_IMPORTED_MODULE_0__/* .Alignment.center */ .v2.center, orientation)}

    > span {
      display: inline-block;
      margin: ${orientation === "vertical" ? `var(--divider-content-spacing) 0` : `0 var(--divider-content-spacing)`};
    }
  `);
Divider.displayName = "Divider";




/***/ }),

/***/ 387100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ Flex; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledFlex = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div((_a) => {
  var _b = _a, { theme } = _b, props = __objRest(_b, ["theme"]);
  return [
    (0,_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F)(__spreadValues({ theme }, props)),
    {
      display: "flex",
      flexDirection: props.direction,
      gap: theme.spacing[props.gap || "s0"],
      columnGap: theme.spacing[props.gapX || props.gap || "s0"],
      rowGap: theme.spacing[props.gapY || props.gap || "s0"],
      justifyContent: buildVariant(props.justify || ""),
      alignItems: buildVariant(props.align || ""),
      flexWrap: props.flexWrap
    }
  ];
});
const buildVariant = (variant) => {
  switch (variant) {
    case "start":
      return "flex-start";
    case "end":
      return "flex-end";
    default:
      return variant;
  }
};
StyledFlex.defaultProps = {
  direction: "row",
  justify: "start",
  align: "baseline",
  flexWrap: "nowrap"
};
const Flex = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledFlex, __spreadValues({}, props));




/***/ }),

/***/ 977041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ index_es_Form; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-field-form-virtual-cd139f30f3/0/cache/rc-field-form-npm-1.21.2-781f850261-137ba7dd0e.zip/node_modules/rc-field-form/es/index.js + 16 modules
var es = __webpack_require__(963379);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/FormContext.es.js



const FormContext = react.createContext({
  labelAlign: "right",
  vertical: false,
  itemRef: () => () => {
  }
});
react.createContext(null);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(19840);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/useForm.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function toNamePathStr(name) {
  const namePath = (0,utils_es/* toArray */.qo)(name);
  return namePath.join("_");
}
function useForm(form) {
  const [rcForm] = (0,es/* useForm */.cI)();
  const itemsRef = react.useRef({});
  const wrapForm = react.useMemo(() => form != null ? form : __spreadProps(__spreadValues({}, rcForm), {
    __INTERNAL__: {
      itemRef: (name) => (node) => {
        const namePathStr = toNamePathStr(name);
        if (node) {
          itemsRef.current[namePathStr] = node;
        } else {
          delete itemsRef.current[namePathStr];
        }
      }
    },
    getFieldInstance: (name) => {
      const namePathStr = toNamePathStr(name);
      return itemsRef.current[namePathStr];
    }
  }), [form, rcForm]);
  return [wrapForm];
}



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/SizeContext.es.js
var SizeContext_es = __webpack_require__(263008);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/Form.es.js










var Form_es_defProp = Object.defineProperty;
var Form_es_defProps = Object.defineProperties;
var Form_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Form_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Form_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Form_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Form_es_defNormalProp = (obj, key, value) => key in obj ? Form_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Form_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Form_es_hasOwnProp.call(b, prop))
      Form_es_defNormalProp(a, prop, b[prop]);
  if (Form_es_getOwnPropSymbols)
    for (var prop of Form_es_getOwnPropSymbols(b)) {
      if (Form_es_propIsEnum.call(b, prop))
        Form_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Form_es_spreadProps = (a, b) => Form_es_defProps(a, Form_es_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Form_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Form_es_getOwnPropSymbols)
    for (var prop of Form_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Form_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InternalForm = (props, ref) => {
  const _a = props, {
    className = "",
    form,
    colon,
    labelAlign,
    labelCol,
    wrapperCol,
    layout = "horizontal",
    requiredMark,
    name,
    size = "m"
  } = _a, restFormProps = __objRest(_a, [
    "className",
    "form",
    "colon",
    "labelAlign",
    "labelCol",
    "wrapperCol",
    "layout",
    "requiredMark",
    "name",
    "size"
  ]);
  const mergedRequiredMark = (0,react.useMemo)(() => {
    if (requiredMark !== void 0) {
      return requiredMark;
    }
    return true;
  }, [requiredMark]);
  const [wrapForm] = useForm(form);
  const { __INTERNAL__ } = wrapForm;
  __INTERNAL__.name = name;
  const formContextValue = (0,react.useMemo)(() => ({
    name,
    labelAlign,
    labelCol,
    wrapperCol,
    vertical: layout === "vertical",
    colon,
    requiredMark: mergedRequiredMark,
    itemRef: __INTERNAL__.itemRef
  }), [name, labelAlign, labelCol, wrapperCol, layout, colon, mergedRequiredMark]);
  react.useImperativeHandle(ref, () => wrapForm);
  return /* @__PURE__ */ react.createElement(SizeContext_es/* SizeContextProvider */.q, {
    size
  }, /* @__PURE__ */ react.createElement(FormContext.Provider, {
    value: formContextValue
  }, /* @__PURE__ */ react.createElement(StyledFieldForm, Form_es_spreadProps(Form_es_spreadValues({
    id: name
  }, restFormProps), {
    name,
    form: wrapForm,
    className: (0,utils_es/* mergeCls */.c8)(className, `teko-form-${layout}`)
  }))));
};
const StyledFieldForm = (0,emotion_styled_browser_esm["default"])(es/* default */.ZP)`
  &.teko-form-vertical {
    .teko-form-item {
      flex-direction: column;
      .teko-form-item-label {
        text-align: left;
      }
    }
  }
  &.teko-form-horizontal {
    .teko-form-item-control {
      flex: 1 1 0;
    }
  }
`;
const Form = react.forwardRef(InternalForm);
var InternalForm$1 = Form;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/FormItemInput.es.js







var FormItemInput_es_defProp = Object.defineProperty;
var FormItemInput_es_defProps = Object.defineProperties;
var FormItemInput_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var FormItemInput_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FormItemInput_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FormItemInput_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FormItemInput_es_defNormalProp = (obj, key, value) => key in obj ? FormItemInput_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FormItemInput_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FormItemInput_es_hasOwnProp.call(b, prop))
      FormItemInput_es_defNormalProp(a, prop, b[prop]);
  if (FormItemInput_es_getOwnPropSymbols)
    for (var prop of FormItemInput_es_getOwnPropSymbols(b)) {
      if (FormItemInput_es_propIsEnum.call(b, prop))
        FormItemInput_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FormItemInput_es_spreadProps = (a, b) => FormItemInput_es_defProps(a, FormItemInput_es_getOwnPropDescs(b));
const FormItemInput = (props) => {
  const {
    prefixCls,
    wrapperCol,
    children,
    errors,
    _internalItemRender: formItemRender
  } = props;
  const baseClassName = `${prefixCls}-item`;
  const formContext = react.useContext(FormContext);
  const mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
  const className = (0,utils_es/* mergeCls */.c8)(`${baseClassName}-control`, mergedWrapperCol.className || "");
  const inputDom = /* @__PURE__ */ react.createElement("div", {
    className: `${baseClassName}-control-input`
  }, /* @__PURE__ */ react.createElement("div", {
    className: `${baseClassName}-control-input-content`
  }, children));
  const errorDom = !!(errors == null ? void 0 : errors.length) ? /* @__PURE__ */ react.createElement(StyledError, {
    marginTop: "s4",
    height: "auto",
    level: 1,
    color: "error500"
  }, errors[0]) : null;
  const dom = formItemRender && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorDom || /* @__PURE__ */ react.createElement(react.Fragment, null)
  }) : /* @__PURE__ */ react.createElement(react.Fragment, null, inputDom, errorDom);
  return /* @__PURE__ */ react.createElement(StyledCol, FormItemInput_es_spreadProps(FormItemInput_es_spreadValues({}, mergedWrapperCol), {
    className
  }), dom);
};
const StyledCol = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)`
  &.teko-form-item-control {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .teko-form-item-control-input {
      display: flex;
      align-items: center;
      .teko-form-item-control-input-content {
        flex: auto;
        max-width: 100%;
      }
    }
  }
`;
const StyledError = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)`
  min-height: 16px;
`;
var FormItemInput$1 = FormItemInput;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/constants/index.es.js
var constants_index_es = __webpack_require__(978719);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/FormItemLabel.es.js









var FormItemLabel_es_defProp = Object.defineProperty;
var FormItemLabel_es_defProps = Object.defineProperties;
var FormItemLabel_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var FormItemLabel_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FormItemLabel_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FormItemLabel_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FormItemLabel_es_defNormalProp = (obj, key, value) => key in obj ? FormItemLabel_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FormItemLabel_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FormItemLabel_es_hasOwnProp.call(b, prop))
      FormItemLabel_es_defNormalProp(a, prop, b[prop]);
  if (FormItemLabel_es_getOwnPropSymbols)
    for (var prop of FormItemLabel_es_getOwnPropSymbols(b)) {
      if (FormItemLabel_es_propIsEnum.call(b, prop))
        FormItemLabel_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FormItemLabel_es_spreadProps = (a, b) => FormItemLabel_es_defProps(a, FormItemLabel_es_getOwnPropDescs(b));
const FormItemLabel = ({
  label,
  htmlFor,
  labelCol,
  labelAlign,
  colon,
  prefixCls,
  required,
  requiredMark
}) => {
  const size = react.useContext(SizeContext_es/* SizeContext */.X);
  if (!label)
    return null;
  return /* @__PURE__ */ react.createElement(FormContext.Consumer, {
    key: "label"
  }, ({
    vertical,
    labelAlign: contextLabelAlign,
    labelCol: contextLabelCol,
    colon: contextColon,
    requiredMark: contextRequiredMark
  }) => {
    var _a;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0,utils_es/* mergeCls */.c8)(labelClsBasic, mergedLabelAlign === "left" ? `${labelClsBasic}-left` : "", mergedLabelCol.className || "");
    let labelChildren = label;
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    if (haveColon && typeof label === "string" && label.trim() !== "") {
      labelChildren = label.replace(/[:|：]\s*$/, "");
    }
    const computedRequiredMark = requiredMark === true || contextRequiredMark !== false && requiredMark !== false;
    const haveRequired = computedRequiredMark && required;
    const labelCls = (0,utils_es/* mergeCls */.c8)(!haveColon ? `${prefixCls}-item-no-colon` : "", haveRequired ? `${prefixCls}-item-required` : "");
    return /* @__PURE__ */ react.createElement(FormItemLabel_es_StyledCol, FormItemLabel_es_spreadProps(FormItemLabel_es_spreadValues({}, mergedLabelCol), {
      className: labelColClassName
    }), /* @__PURE__ */ react.createElement(StyledLabel, {
      style: { height: (_a = constants_index_es/* MAPPING_SIZE */.v) == null ? void 0 : _a[size] },
      htmlFor,
      className: labelCls
    }, /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
      level: 2,
      weight: "medium",
      color: "textTitle"
    }, labelChildren)));
  });
};
const FormItemLabel_es_StyledCol = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)`
  text-align: right;
  &.teko-form-item-label-left {
    text-align: left;
  }
`;
const StyledLabel = emotion_styled_browser_esm["default"].label`
  /* height: 40px; */
  display: inline-flex;
  align-items: center;
  &.teko-form-item-required {
    &:before {
      display: inline-block;
      margin-right: 4px;
      color: #ff4d4f;
      font-size: 12px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
  }
  &:after {
    content: ':';
    position: relative;
    top: -0.5px;
    margin: 0 8px 0 2px;
  }
  &.teko-form-item-no-colon {
    margin-right: 8px;
    &:after {
      display: none;
    }
  }
`;
var FormItemLabel$1 = FormItemLabel;



// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-field-form-virtual-cd139f30f3/0/cache/rc-field-form-npm-1.21.2-781f850261-137ba7dd0e.zip/node_modules/rc-field-form/lib/FieldContext.js
var FieldContext = __webpack_require__(665824);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/FormItem.es.js










var FormItem_es_defProp = Object.defineProperty;
var FormItem_es_defProps = Object.defineProperties;
var FormItem_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var FormItem_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var FormItem_es_hasOwnProp = Object.prototype.hasOwnProperty;
var FormItem_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var FormItem_es_defNormalProp = (obj, key, value) => key in obj ? FormItem_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var FormItem_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (FormItem_es_hasOwnProp.call(b, prop))
      FormItem_es_defNormalProp(a, prop, b[prop]);
  if (FormItem_es_getOwnPropSymbols)
    for (var prop of FormItem_es_getOwnPropSymbols(b)) {
      if (FormItem_es_propIsEnum.call(b, prop))
        FormItem_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var FormItem_es_spreadProps = (a, b) => FormItem_es_defProps(a, FormItem_es_getOwnPropDescs(b));
var FormItem_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (FormItem_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && FormItem_es_getOwnPropSymbols)
    for (var prop of FormItem_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && FormItem_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function hasValidName(name) {
  if (name === null) {
    dist_index_es/* logger.info */.k.info(false, "Form.Item", "`null` is passed as `name` property");
  }
  return !(name === void 0 || name === null);
}
function genEmptyMeta() {
  return {
    errors: [],
    warnings: [],
    touched: false,
    validating: false,
    name: []
  };
}
function FormItem(props) {
  const _a = props, {
    name,
    noStyle,
    dependencies,
    style,
    className = "",
    shouldUpdate,
    rules,
    children,
    required,
    label,
    messageVariables,
    trigger = "onChange",
    validateTrigger,
    hidden
  } = _a, restProps = FormItem_es_objRest(_a, [
    "name",
    "noStyle",
    "dependencies",
    "style",
    "className",
    "shouldUpdate",
    "rules",
    "children",
    "required",
    "label",
    "messageVariables",
    "trigger",
    "validateTrigger",
    "hidden"
  ]);
  const isRenderProps = typeof children === "function";
  const { validateTrigger: contextValidateTrigger } = react.useContext(FieldContext/* default */.ZP);
  const mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : contextValidateTrigger;
  const hasName = hasValidName(name);
  const [meta, setMeta] = react.useState(() => genEmptyMeta());
  const onMetaChange = (nextMeta) => {
    setMeta(nextMeta.destroy ? genEmptyMeta() : nextMeta);
  };
  const [mergedErrors, mergedWarnings] = react.useMemo(() => {
    const errorList = [...meta.errors];
    const warningList = [...meta.warnings];
    return [errorList, warningList];
  }, [meta.errors, meta.warnings]);
  function renderLayout(baseChildren, fieldId, isRequired) {
    if (noStyle && !hidden) {
      return baseChildren;
    }
    const hasHelp = mergedErrors.length || mergedWarnings.length;
    return /* @__PURE__ */ react.createElement(StyledRow, FormItem_es_spreadValues({
      className: (0,utils_es/* mergeCls */.c8)(className, "teko-form-item", hasHelp ? "teko-form-item-with-help" : ""),
      style,
      key: "row"
    }, (0,utils_es/* omit */.CE)(restProps, [
      "colon",
      "extra",
      "getValueFromEvent",
      "getValueProps",
      "htmlFor",
      "initialValue",
      "isListField",
      "labelAlign",
      "labelCol",
      "normalize",
      "preserve",
      "validateFirst",
      "valuePropName",
      "wrapperCol",
      "_internalItemRender"
    ])), /* @__PURE__ */ react.createElement(FormItemLabel$1, FormItem_es_spreadValues({
      prefixCls: "teko-form",
      htmlFor: fieldId,
      required: isRequired
    }, props)), /* @__PURE__ */ react.createElement(FormItemInput$1, FormItem_es_spreadProps(FormItem_es_spreadValues(FormItem_es_spreadValues({}, props), meta), {
      errors: mergedErrors,
      warnings: mergedWarnings,
      prefixCls: "teko-form"
    }), baseChildren));
  }
  if (!hasName && !isRenderProps && !dependencies) {
    return renderLayout(children);
  }
  let variables = {};
  if (typeof label === "string") {
    variables.label = label;
  } else if (name) {
    variables.label = String(name);
  }
  if (messageVariables) {
    variables = FormItem_es_spreadValues(FormItem_es_spreadValues({}, variables), messageVariables);
  }
  return /* @__PURE__ */ react.createElement(es/* Field */.gN, FormItem_es_spreadProps(FormItem_es_spreadValues({}, props), {
    messageVariables: variables,
    trigger,
    validateTrigger: mergedValidateTrigger,
    onMetaChange
  }), (control, renderMeta, context) => {
    const mergedName = !!name && !!renderMeta ? renderMeta.name : [];
    const fieldId = mergedName.length ? mergedName.join("_") : void 0;
    const isRequired = required !== void 0 ? required : !!(rules && rules.some((rule) => {
      if (rule && typeof rule === "object" && rule.required && !rule.warningOnly) {
        return true;
      }
      if (typeof rule === "function") {
        const ruleEntity = rule(context);
        return ruleEntity && ruleEntity.required && !ruleEntity.warningOnly;
      }
      return false;
    }));
    const mergedControl = FormItem_es_spreadValues({}, control);
    let childNode = null;
    if (Array.isArray(children) && hasName) {
      childNode = children;
    } else if (react.isValidElement(children)) {
      const childProps = FormItem_es_spreadValues(FormItem_es_spreadValues({}, children.props), mergedControl);
      if (!childProps.id) {
        childProps.id = fieldId;
      }
      const triggers = /* @__PURE__ */ new Set([
        ...(0,utils_es/* toArray */.qo)(trigger),
        ...(0,utils_es/* toArray */.qo)(mergedValidateTrigger)
      ]);
      triggers.forEach((eventName) => {
        childProps[eventName] = (...args) => {
          var _a2, _b, _c;
          (_a2 = mergedControl[eventName]) == null ? void 0 : _a2.call(mergedControl, ...args);
          (_c = (_b = children.props)[eventName]) == null ? void 0 : _c.call(_b, ...args);
        };
      });
      childNode = react.cloneElement(children, childProps);
    } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) {
      childNode = children(context);
    } else {
      childNode = children;
    }
    return renderLayout(childNode, fieldId, isRequired);
  });
}
const StyledRow = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)`
  margin-bottom: 16px;
  &.teko-form-item-with-help {
    margin-bottom: 0;
  }
`;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/index.es.js




const index_es_Form = InternalForm$1;
index_es_Form.Item = FormItem;
index_es_Form.useForm = useForm;




/***/ }),

/***/ 816519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ Glide; }
/* harmony export */ });
/* harmony import */ var _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(490400);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(593859);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Glide = (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((_a, ref) => {
  var _b = _a, {
    className,
    children,
    onSlideChange,
    style,
    showControl = true,
    showBullet = false,
    trackingArrowRight,
    trackingArrowLeft,
    customStyleLeftArrow,
    customStyleRightArrow,
    displayNewLayout
  } = _b, glideOpts = __objRest(_b, [
    "className",
    "children",
    "onSlideChange",
    "style",
    "showControl",
    "showBullet",
    "trackingArrowRight",
    "trackingArrowLeft",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "displayNewLayout"
  ]);
  const newRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const childRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
  const chooseRef = ref || newRef;
  const opts = __spreadValues(__spreadValues({}, defaultGlideOptions), glideOpts);
  if (children.length === 1) {
    opts.autoplay = false;
    showBullet = false;
    showControl = false;
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (typeof chooseRef === "function" || !chooseRef.current)
      return;
    const controller = new _glidejs_glide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(chooseRef.current, opts);
    let mounted;
    if (onSlideChange) {
      controller.on("move.after", () => {
        mounted && onSlideChange(mounted.index);
      });
    }
    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .scheduleTaskInIdleTime */ .D_)(() => {
      mounted = controller.mount();
      children.length === 1 && (mounted == null ? void 0 : mounted.disable());
      if (chooseRef.current) {
        chooseRef.current.glide = mounted;
      }
    }, 3e3);
    return () => mounted == null ? void 0 : mounted.destroy();
  }, [children.length]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, {
    ref: chooseRef,
    className: `${className || ""} glide`,
    style,
    displayNewLayout
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__track",
    "data-glide-el": "track"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__slides"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index) => {
    var _a2, _b2, _c;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      ref: (e) => childRefs.current[index] = e,
      key: child.key || index,
      className: "glide__slide",
      style: {
        height: "unset",
        marginRight: index < children.length - 1 ? ((_a2 = childRefs.current[index]) == null ? void 0 : _a2.style.marginRight) || 5 : 0,
        marginLeft: index > 0 ? ((_b2 = childRefs.current[index]) == null ? void 0 : _b2.style.marginLeft) || 5 : 0,
        width: ((_c = childRefs.current) == null ? void 0 : _c[0]) ? childRefs.current[0].style.width : `calc(100% / ${opts.perView} - 8px) `
      }
    }, child);
  }))), showControl && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    "data-glide-el": "controls",
    className: "glide__arrows"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--left",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}<`,
    style: customStyleLeftArrow
  }, trackingArrowLeft)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", __spreadValues({
    className: "glide__arrow--override glide__arrow--right",
    "data-glide-dir": `${opts.perSwipe ? "|" : ""}>`,
    style: customStyleRightArrow
  }, trackingArrowRight))), showBullet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "glide__bullets glide__bullets--override",
    "data-glide-el": "controls[nav]"
  }, react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (_, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
    className: "glide__bullet",
    key: index,
    "data-glide-dir": `=${index}`
  }))));
});
Glide.displayName = "Glide";
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div((props) => `
  &:hover {
    .glide__arrow--override {
      visibility: visible;
    }
  }

  .glide__track {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
  .glide__slides {
    height: 100%;
  }
  .glide__arrow--override {
    position: absolute;
    left: 0;
    top: 50%;
    z-index: 10;
    cursor: pointer;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    transform: translateY(-50%);
    background-color: rgba(168, 168, 168, 0.46);
    visibility: hidden;
  }

  .glide__arrow--left {
    right: auto;
    left: 0;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgNUw4LjUgMTJMMTUuNSAxOSIgc3Ryb2tlPSIjODI4NjlFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  .glide__arrow--right {
    right: 0;
    left: auto;
    border-top-left-radius: 100px;
    border-bottom-left-radius: 100px;

    &:after {
      mask: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSAxOUwxNS41IDEyTDguNSA1IiBzdHJva2U9IiM4Mjg2OUUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==');
      content: ' ';
      height: 30px;
      width: 30px;
      mask-size: contain;
      display: inline-block;
      background: #333;
    }
  }

  ${props.displayNewLayout ? `.glide__arrow--override {
    visibility: visible;
    width: 28px;
    height: 28px;
  }
  .horizontal-slider,
  .glide__track {
    margin: 0 auto;
    background-color: white;
  }
  .glide__slides {
    margin: 0 auto;
  }
  .glide__arrow--left {
    left: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }
  .glide__arrow--right {
    right: 8px !important;
    border-radius: 100px;
    background-color: #fff !important;
    box-shadow: -1px 4px 5px 2px rgba(0, 0, 0, 0.12);
    &:after {
      height: 14px !important;
      width: 14px !important;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
      box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
    }
  }` : ``}
`);
const defaultGlideOptions = {
  type: "slider",
  startAt: 0,
  perView: 2.3,
  perSwipe: "",
  focusAt: 0,
  gap: 10,
  autoplay: false,
  hoverpause: true,
  keyboard: true,
  bound: false,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  direction: "ltr",
  peek: 0,
  breakpoints: {},
  throttle: 25
};




/***/ }),

/***/ 212808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "XE": function() { return /* binding */ floorPercentage; },
/* harmony export */   "e9": function() { return /* binding */ percentage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(467085);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(956778);
/* harmony import */ var _constant_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(208984);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(640128);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75537);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function parseFlex(flex) {
  if (typeof flex === "number") {
    return `${flex} ${flex} auto`;
  }
  if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
    return `0 0 ${flex}`;
  }
  return flex;
}
const sizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
const Col = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const { gutter, wrap } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const _a = props, {
    span,
    order,
    offset,
    push,
    pull,
    className,
    children,
    flex,
    style
  } = _a, others = __objRest(_a, [
    "span",
    "order",
    "offset",
    "push",
    "pull",
    "className",
    "children",
    "flex",
    "style"
  ]);
  const prefixCls = "teko-col";
  let sizeClassObj = {};
  sizes.forEach((size) => {
    let sizeProps = {};
    const propSize = props[size];
    if (typeof propSize === "number") {
      sizeProps.span = propSize;
    } else if (typeof propSize === "object") {
      sizeProps = propSize || {};
    }
    sizeClassObj = __spreadProps(__spreadValues({}, sizeClassObj), {
      [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== void 0,
      [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
      [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
      [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
      [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0
    });
  });
  const classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, {
    [`${prefixCls}-${span}`]: span !== void 0,
    [`${prefixCls}-order-${order}`]: order,
    [`${prefixCls}-offset-${offset}`]: offset,
    [`${prefixCls}-push-${push}`]: push,
    [`${prefixCls}-pull-${pull}`]: pull
  }, className, sizeClassObj);
  let mergedStyle = __spreadValues({}, style);
  if (gutter) {
    mergedStyle = __spreadValues(__spreadValues({}, gutter[0] && gutter[0] > 0 ? {
      paddingLeft: gutter[0] / 2,
      paddingRight: gutter[0] / 2
    } : {}), mergedStyle);
  }
  if (flex) {
    mergedStyle.flex = parseFlex(flex);
    if (flex === "auto" && wrap === false && !mergedStyle.minWidth) {
      mergedStyle.minWidth = 0;
    }
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, __spreadProps(__spreadValues({}, others), {
    style: mergedStyle,
    className: classes,
    ref
  }), children);
});
Col.displayName = "Col";
const floorPercentage = (percent) => {
  return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
  return floorPercentage(x / y * 100) + "%";
};
const loopGridColumn = (_class = "") => {
  let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
  for (let i = 0.5; i <= 24; i += 0.5) {
    _css += `
      &.teko-col${_class}-${String(i).replace(".", "\\.")} {
        display: block;
        flex: 0 0 ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
        max-width: ${_class === "-lg" ? "84px" : ["-xl", "-xxl"].includes(_class) ? "104px" : percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
  }
  return _css;
};
const makeGrid = _emotion_react__WEBPACK_IMPORTED_MODULE_5__.css`
  ${loopGridColumn()}
  ${loopGridColumn("-xs")}
  ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d).map((label) => label !== "xs" ? `
    @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  ` : "").join("")}
`;
const flexStyle = (flex) => {
  if (!flex)
    return;
  return `
    flex: ${parseFlex(flex)};
    ${typeof flex === "string" ? `max-width: ${flex} !important;` : ""}
  `;
};
const makeFlexStyles = (props) => {
  var _a;
  return _emotion_react__WEBPACK_IMPORTED_MODULE_5__.css`
    ${typeof props.xs === "object" && ((_a = props.xs) == null ? void 0 : _a.flex) !== void 0 ? flexStyle(props.xs.flex) : ""}
    ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d).map((label) => {
    var _a2, _b;
    return ((_a2 = props[label]) == null ? void 0 : _a2.flex) && label !== "xs" ? `
      @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_4__/* .BREAK_POINTS */ .d[label]}) {
        ${flexStyle((_b = props[label]) == null ? void 0 : _b.flex)};
      }
    ` : "";
  }).join("")}
  `;
};
const StyledCol = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"].div(`
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .CommonStyles */ .F, makeGrid, makeFlexStyles);




/***/ }),

/***/ 408797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Row; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.1-f2ae0a8d3c-14db8889d5.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(467085);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/RowContext.es.js
var RowContext_es = __webpack_require__(956778);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/util.es.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const responsiveArray = [
  "xxl",
  "xl",
  "lg",
  "md",
  "sm",
  "xs"
];
const responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1024px)",
  xl: "(min-width: 1440px)",
  xxl: "(min-width: 1600px)"
};
const subscribers = /* @__PURE__ */ new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
  matchHandlers: {},
  dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach((func) => func(screens));
    return subscribers.size >= 1;
  },
  subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const handler = this.matchHandlers[matchMediaQuery];
      handler == null ? void 0 : handler.mql.removeListener(handler == null ? void 0 : handler.listener);
    });
    subscribers.clear();
  },
  register() {
    Object.keys(responsiveMap).forEach((screen) => {
      const matchMediaQuery = responsiveMap[screen];
      const listener = ({ matches }) => {
        this.dispatch(__spreadProps(__spreadValues({}, screens), {
          [screen]: matches
        }));
      };
      const mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      this.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/constant.es.js
var constant_es = __webpack_require__(208984);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js








var Row_es_defProp = Object.defineProperty;
var Row_es_defProps = Object.defineProperties;
var Row_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Row_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Row_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Row_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Row_es_defNormalProp = (obj, key, value) => key in obj ? Row_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Row_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Row_es_hasOwnProp.call(b, prop))
      Row_es_defNormalProp(a, prop, b[prop]);
  if (Row_es_getOwnPropSymbols)
    for (var prop of Row_es_getOwnPropSymbols(b)) {
      if (Row_es_propIsEnum.call(b, prop))
        Row_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Row_es_spreadProps = (a, b) => Row_es_defProps(a, Row_es_getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Row_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Row_es_getOwnPropSymbols)
    for (var prop of Row_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Row_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Row = react.forwardRef((props, ref) => {
  const _a = props, {
    justify,
    align,
    className,
    style,
    children,
    gutter = 0,
    wrap
  } = _a, others = __objRest(_a, [
    "justify",
    "align",
    "className",
    "style",
    "children",
    "gutter",
    "wrap"
  ]);
  const [screens, setScreens] = react.useState({
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true,
    xxl: true
  });
  const gutterRef = react.useRef(gutter);
  react.useEffect(() => {
    const token = ResponsiveObserve.subscribe((screen) => {
      const currentGutter = gutterRef.current || 0;
      if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) {
        setScreens(screen);
      }
    });
    return () => ResponsiveObserve.unsubscribe(token);
  }, []);
  const getGutter = () => {
    const results = [0, 0];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
    normalizedGutter.forEach((g, index) => {
      if (typeof g === "object") {
        for (let i = 0; i < responsiveArray.length; i++) {
          const breakpoint = responsiveArray[i];
          if (screens[breakpoint] && g[breakpoint] !== void 0) {
            results[index] = g[breakpoint];
            break;
          }
        }
      } else {
        results[index] = g || 0;
      }
    });
    return results;
  };
  const prefixCls = "teko-row";
  const gutters = getGutter();
  const classes = classnames_default()(prefixCls, {
    [`${prefixCls}-no-wrap`]: wrap === false,
    [`${prefixCls}-${justify}`]: justify,
    [`${prefixCls}-${align}`]: align
  }, className);
  const rowStyle = Row_es_spreadValues(Row_es_spreadValues(Row_es_spreadValues({}, gutters[0] && gutters[0] > 0 ? {
    marginLeft: gutters[0] / -2,
    marginRight: gutters[0] / -2
  } : {}), gutters[1] && gutters[1] > 0 ? {
    rowGap: gutters[1]
  } : {}), style);
  return /* @__PURE__ */ react.createElement(RowContext_es/* default.Provider */.Z.Provider, {
    value: { gutter: gutters, wrap }
  }, /* @__PURE__ */ react.createElement(StyledRow, Row_es_spreadProps(Row_es_spreadValues({}, others), {
    className: classes,
    style: rowStyle,
    ref
  }), children));
});
Row.displayName = "Row";
const StyledRow = emotion_styled_browser_esm["default"].div`
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${constant_es/* BREAK_POINTS.lg */.d.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }
  &.teko-row-baseline {
    align-items: baseline;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
  ${index_es/* CommonStyles */.F}
`;




/***/ }),

/***/ 956778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RowContext$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const RowContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var RowContext$1 = RowContext;




/***/ }),

/***/ 208984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BREAK_POINTS; },
/* harmony export */   "s": function() { return /* binding */ GRID_COLUMNS; }
/* harmony export */ });
const BREAK_POINTS = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  xxl: "1600px"
};
const GRID_COLUMNS = 12;




/***/ }),

/***/ 587021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(990241);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const fallbackImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
const Image = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    src,
    height,
    objectFit,
    width,
    alt,
    onClick,
    borderRadius,
    thumbnail,
    hover,
    decoding = "async",
    className,
    lazy = true,
    tracking,
    fetchPriority,
    aspectRatio,
    googleImageParams,
    customFallbackImage
  } = _a, others = __objRest(_a, [
    "src",
    "height",
    "objectFit",
    "width",
    "alt",
    "onClick",
    "borderRadius",
    "thumbnail",
    "hover",
    "decoding",
    "className",
    "lazy",
    "tracking",
    "fetchPriority",
    "aspectRatio",
    "googleImageParams",
    "customFallbackImage"
  ]);
  const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI)(src, googleImageParams || {}));
  const imgError = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setImgSrc((prevImgSrc) => {
      var _a2;
      if (((_a2 = prevImgSrc.params) == null ? void 0 : _a2.format) === "webp") {
        return (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI)(src, __spreadProps(__spreadValues({}, googleImageParams), { format: "png" }));
      } else if (!prevImgSrc.error) {
        return { src: customFallbackImage || fallbackImage, error: true };
      }
      return prevImgSrc;
    });
  }, [src]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setImgSrc((0,_helper_es_js__WEBPACK_IMPORTED_MODULE_2__/* .imageLoader */ .XI)(src, googleImageParams || {}));
  }, [src, setImgSrc, aspectRatio, JSON.stringify(googleImageParams)]);
  const imgElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", __spreadValues({
    ref,
    style: __spreadValues({
      width: width === "auto" ? width : "100%",
      height: height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)}` : aspectRatio ? "100%" : "auto",
      objectFit
    }, aspectRatio ? { position: "absolute", top: "0px", left: "0px" } : {}),
    src: imgSrc.src || customFallbackImage || fallbackImage,
    loading: lazy ? "lazy" : "eager",
    hover,
    decoding,
    alt,
    fetchpriority: fetchPriority,
    onError: imgError
  }, others));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, __spreadValues({
    height,
    width: width || "100%",
    onClick,
    borderRadius,
    thumbnail,
    className,
    hover,
    aspectRatio
  }, tracking), imgElement);
});
Image.displayName = "Image";
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({
  onClick,
  borderRadius,
  height,
  thumbnail,
  width,
  aspectRatio,
  hover
}) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? "cursor: pointer;" : ""}
  ${borderRadius ? `border-radius: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(borderRadius)};` : ""}
  ${borderRadius ? "1px solid #e0e0e0;" : ""}
  ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)};` : ""}
  ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(width)};` : aspectRatio ? "width: 100%;" : ""}
  ${aspectRatio && !height ? `padding-bottom: ${100 / aspectRatio}%;` : ""}
  ${thumbnail ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;` : ""}
  ${hover ? "transition: transform 0.3s ease 0s; &:hover { transform: scale(1.05); };" : ""}
`);




/***/ }),

/***/ 990241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gn": function() { return /* binding */ constructGoogleImageParams; },
/* harmony export */   "Nc": function() { return /* binding */ getImageUrlFromGoogleUserContent; },
/* harmony export */   "XI": function() { return /* binding */ imageLoader; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const imgAttributeMapping = {
  width: "w",
  height: "h",
  webp: "rw",
  png: "rp",
  jpg: "rj",
  stretch: "s",
  crop: "c"
};
const constructGoogleImageParams = (url, config) => {
  const baseUrl = url.indexOf("=") >= 0 ? url.substring(0, url.indexOf("=")) : url;
  const baseParams = url.indexOf("=") >= 0 ? url.substring(url.indexOf("=") + 1).split("-") : [];
  const mergedParams = {};
  baseParams.forEach((param) => {
    var _a;
    if (["rw", "rp", "rj"].includes(param)) {
      mergedParams["format"] = param;
    } else {
      const prefix = (_a = param.match(/^([a-z]+)(\w*)$/)) == null ? void 0 : _a[1];
      if (prefix) {
        mergedParams[prefix] = param;
      }
    }
  });
  if (config.width && !config.height) {
    delete mergedParams["h"];
    delete mergedParams["s"];
  }
  if (config.height && !config.width) {
    delete mergedParams["w"];
    delete mergedParams["s"];
  }
  Object.entries(config).forEach(([key, value]) => {
    if (typeof value !== "boolean" && !value)
      return;
    if (key === "format") {
      const gcsArg = imgAttributeMapping[value];
      mergedParams["format"] = gcsArg;
      return;
    }
    const gcsArgPrefix = imgAttributeMapping[key];
    if (key === "size" && value) {
      mergedParams[gcsArgPrefix] = `${gcsArgPrefix}0`;
      return;
    }
    if (gcsArgPrefix) {
      if (typeof value === "boolean") {
        mergedParams[gcsArgPrefix] = value ? gcsArgPrefix : void 0;
      } else {
        mergedParams[gcsArgPrefix] = `${gcsArgPrefix}${value}`;
      }
    }
  });
  const filterParams = Object.values(mergedParams).filter((param) => param);
  return filterParams.some((param) => param) ? `${baseUrl}=${filterParams.join("-")}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com"))
    return constructGoogleImageParams(imageUrl, config);
  return imageUrl;
};
const imageLoader = (imageUrl, config) => {
  if (imageUrl && imageUrl.includes("googleusercontent.com")) {
    const googleParams = __spreadProps(__spreadValues({}, config || {}), {
      format: (config == null ? void 0 : config.format) || "webp"
    });
    return {
      src: constructGoogleImageParams(imageUrl, googleParams),
      params: googleParams
    };
  }
  return { src: imageUrl };
};




/***/ }),

/***/ 725643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(379126);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47649);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(640128);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(978719);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(263008);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Input = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((_a, ref) => {
  var _b = _a, {
    title,
    value,
    defaultValue,
    autoFocus,
    type = "text",
    placeholder,
    caption,
    showCaptionIcon = true,
    error,
    disabled,
    readonly,
    prefix,
    suffix,
    maxLength = 255,
    className,
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
    size: customizeSize,
    id,
    allowClear = false
  } = _b, rest = __objRest(_b, [
    "title",
    "value",
    "defaultValue",
    "autoFocus",
    "type",
    "placeholder",
    "caption",
    "showCaptionIcon",
    "error",
    "disabled",
    "readonly",
    "prefix",
    "suffix",
    "maxLength",
    "className",
    "onChange",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "size",
    "id",
    "allowClear"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const handleFocus = (e) => {
    onFocus && onFocus(e);
  };
  const handleBlur = (e) => {
    onBlur && onBlur(e);
  };
  const colorState = disabled ? "disable" : error ? "error500" : void 0;
  const handleClear = () => {
    onChange == null ? void 0 : onChange("");
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadValues({
    className
  }, rest), title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SubTitle */ .DK, {
    level: 4,
    color: "textPrimary",
    marginBottom: "s4"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContainer, {
    className: "input-container",
    padding: ["s0", "s12"],
    borderWeight: "m",
    borderRadius: "s",
    borderStyle: "solid",
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    colorState: colorState || "primary500",
    readonly: !!readonly,
    disabled: !!disabled
  }, prefix && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginRight: "s4"
  }, typeof prefix === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 2,
    color: disabled ? "border" : "textPrimary"
  }, prefix) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(prefix, {
    size: ((_a2 = prefix == null ? void 0 : prefix.props) == null ? void 0 : _a2.size) || 20
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBaseInput, {
    ref,
    id,
    type,
    value,
    defaultValue,
    autoFocus,
    placeholder,
    onChange: (event) => onChange && onChange(event.target.value),
    onFocus: handleFocus,
    onBlur: handleBlur,
    maxLength,
    disabled,
    readOnly: readonly,
    backgroundColor: rest.backgroundColor || "",
    onKeyDown: (event) => {
      if (onKeyDown)
        onKeyDown(event);
    }
  }), allowClear && !!value && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .DeleteCircleColored */ .H, {
    name: "circle-close",
    onClick: handleClear,
    size: 20,
    cursor: "pointer"
  }), suffix && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s4"
  }, typeof suffix === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 2,
    color: disabled ? "border" : "textPrimary"
  }, suffix) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(suffix, {
    size: ((_b2 = suffix == null ? void 0 : suffix.props) == null ? void 0 : _b2.size) || 20
  }))), caption && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    marginTop: "s8"
  }, showCaptionIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .CautionOutlined */ .s, {
    size: 16,
    color: colorState || "textSecondary"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    level: 1,
    color: colorState || "textSecondary",
    marginLeft: "s4"
  }, caption)));
});
Input.displayName = "Input";
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_7__/* .CommonStyles */ .F}
`;
const StyledBaseInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input`
  flex-grow: 1;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor + " !important" : "inherit"};
`;
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;
const InputContainer = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
  border-color: ${(p) => p.disabled ? p.theme.colors.background : p.theme.colors.inputBorder};
  gap: 0.25rem;

  :focus,
  :focus-within {
    border-color: ${(p) => p.theme.colors[p.colorState]};
  }

  ${(p) => p.disabled || p.readonly ? `background-color: ${p.theme.colors.background};` : p.theme.colors.white}
  overflow: hidden;
  input {
    flex: 1;
    width: 100%;
    border: none;
    font-size: 13px;
    color: ${(p) => p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary};

    &::placeholder {
      color: ${(p) => p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder};
    }
    &:focus {
      outline: none;
    }
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;




/***/ }),

/***/ 248169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InputNumber; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var rc_input_number__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(241305);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(994734);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(925810);
/* harmony import */ var _Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(425336);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(978719);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(263008);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);









var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const SAVED_DECIMAL_SEPARATOR = ".";
const InputNumber = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
  var _b = _a, {
    size: customizeSize,
    addonBefore,
    addonAfter,
    bordered = true,
    disabled = false,
    readOnly = false,
    formatter,
    parser
  } = _b, props = __objRest(_b, [
    "size",
    "addonBefore",
    "addonAfter",
    "bordered",
    "disabled",
    "readOnly",
    "formatter",
    "parser"
  ]);
  var _a2, _b2;
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const { decimalSeparator } = props;
  const defaultFormatter = (value) => {
    if (!value)
      return "";
    if (typeof value === "string") {
      value = parseFloat(value);
    }
    const locale = decimalSeparator === "." ? "en-CA" : "de-DE";
    return new Intl.NumberFormat(locale, {
      maximumFractionDigits: 10
    }).format(value);
  };
  const defaultParser = (value) => {
    if (!value) {
      return "";
    }
    const thousandSeparator = decimalSeparator === "." ? "," : ".";
    return value.replace(thousandSeparator, "").replace(decimalSeparator || ".", SAVED_DECIMAL_SEPARATOR);
  };
  const prefix = addonBefore ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize]
  }, typeof addonBefore === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonBefore) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonBefore, {
    size: ((_a2 = addonBefore == null ? void 0 : addonBefore.props) == null ? void 0 : _a2.size) || 20
  })) : null;
  const suffix = addonAfter ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSpace, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    marginLeft: "s16"
  }, typeof addonAfter === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
    color: "textSecondary",
    level: 1,
    weight: "regular"
  }, addonAfter) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(addonAfter, {
    size: ((_b2 = addonAfter == null ? void 0 : addonAfter.props) == null ? void 0 : _b2.size) || 20
  })) : null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .MAPPING_SIZE */ .v[mergeSize],
    disabled,
    readOnly,
    bordered,
    paddingRight: !!suffix ? "s16" : "s0",
    className: "wrap-input-number"
  }, prefix, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(rc_input_number__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, __spreadValues({
    ref,
    upHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UpOutlined */ .X, {
      size: 12
    }),
    downHandler: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .DownOutlined */ .T, {
      size: 12
    }),
    disabled,
    readOnly,
    formatter: formatter != null ? formatter : defaultFormatter,
    parser: parser != null ? parser : defaultParser
  }, props)), suffix);
});
InputNumber.displayName = "InputNumber";
const Wrapper = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)(({ theme, disabled, readOnly, bordered }) => `
  ${disabled ? `background: ${theme == null ? void 0 : theme.colors.background}; 
         cursor: not-allowed;` : "background: white;"}
  ${bordered ? `border: 1px solid ${theme == null ? void 0 : theme.colors.border};
         border-radius: 4px;` : ""}
  &:focus-within{
    border-color: ${theme == null ? void 0 : theme.colors.link500};
  }
  display: flex;
  padding-left: 0.75rem;
  .rc-input-number {
      position: relative;
      flex: 1;
      padding: 0 1px;
      &:hover{
        .rc-input-number-handler-wrap{
            opacity: 1;
        }
      }
  }
  .rc-input-number-input-wrap{
      height: 100%;
      & input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: 0;
        &::placeholder {
          color: ${theme == null ? void 0 : theme.colors.placeholder};
        }
        ${disabled ? "cursor: not-allowed;" : ""}
    }
  }
  .rc-input-number-handler-wrap{
      opacity: 0;
      transition: opacity 0.24s linear 0.1s;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      right: 0;
      line-height: 0;
      height: 100%;
      width: 25px;
      ${bordered ? `border-left: 1px solid ${theme == null ? void 0 : theme.colors.border};
             border-right: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
      ${disabled || readOnly ? "display: none;" : ""}
  }
  .rc-input-number-handler-up, 
  .rc-input-number-handler-down{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.link500};
    }
  }
  .rc-input-number-handler-down {
    ${bordered ? `border-top: 1px solid ${theme == null ? void 0 : theme.colors.border};` : ""}
  }
  .rc-input-number-handler-up-disabled, 
  .rc-input-number-handler-down-disabled {
    cursor: not-allowed;
    background: ${theme == null ? void 0 : theme.colors.background};
    &:hover path {
      stroke: ${theme == null ? void 0 : theme.colors.textSecondary};
    }
  }
`);
const StyledSpace = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])(_Shape_index_es_js__WEBPACK_IMPORTED_MODULE_8__/* .Shape */ .b)`
  display: flex;
  align-items: center;
`;




/***/ }),

/***/ 670894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ LazyImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LazyImage = (_a) => {
  var _b = _a, {
    src,
    onClick,
    className,
    contain = false,
    cover = false,
    aspectRatio = 1,
    height,
    width,
    alt = "",
    hover = "",
    borderRadius = 0,
    imageWidth,
    thumbnail,
    decoding = "async",
    lazy = true,
    fetchPriority = "low"
  } = _b, props = __objRest(_b, [
    "src",
    "onClick",
    "className",
    "contain",
    "cover",
    "aspectRatio",
    "height",
    "width",
    "alt",
    "hover",
    "borderRadius",
    "imageWidth",
    "thumbnail",
    "decoding",
    "lazy",
    "fetchPriority"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Image_Image_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues({
    src,
    decoding,
    alt,
    hover,
    onClick,
    className,
    height,
    aspectRatio,
    width,
    thumbnail,
    borderRadius,
    objectFit: cover ? "cover" : contain ? "contain" : "inherit",
    googleImageParams: { width: imageWidth },
    fetchpriority: fetchPriority,
    lazy
  }, props));
};




/***/ }),

/***/ 80912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106454);
/* harmony import */ var _LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(670894);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Loading = ({
  children,
  style,
  isLoading = false,
  size = 80,
  roundColor = "primary",
  className
}) => {
  const { logo } = (0,_context_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useLoadingContext */ .d$)();
  const inline = !children;
  const Outermost = inline ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : ContainerLoadingWrapper;
  style = style || {};
  style = __spreadValues(__spreadValues({}, style), inline ? {} : { top: 0, left: 0, position: "fixed", zIndex: 9999 });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Outermost, null, isLoading && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadingContainer, {
    style,
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    size
  }, logo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LazyImage_LazyImage_es_js__WEBPACK_IMPORTED_MODULE_3__/* .LazyImage */ .w, {
    width: size / 2,
    height: size / 2,
    src: logo,
    contain: true
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spinner, {
    roundColor,
    size
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "teko-spinner"
  })))), children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    className: isLoading ? "loading-blur" : ""
  }, children));
};
const ContainerLoadingWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
`;
const LoadingContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
`;
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
  transition: opacity 0.3s;
  &.loading-blur {
    clear: both;
    opacity: 0.5;
    user-select: none;
    pointer-events: none;
  }
`;
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ size }) => `
  width: ${size}px;
  height: ${size}px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`);
const Spinner = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ size, roundColor, theme }) => {
  var _a;
  return `
  background: none;
  position: absolute;
  @keyframes teko-spinner {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .teko-spinner {    
    margin: auto;
    animation: teko-spinner 1s linear infinite;
    width: ${size * 0.95}px;
    height: ${size * 0.95}px;
    border-radius: 50%;
    box-shadow: 0 2px 0 0 ${((_a = theme.colors) == null ? void 0 : _a[roundColor]) || roundColor};
    box-sizing: content-box;
  }
`;
});




/***/ }),

/***/ 106454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PK": function() { return /* binding */ LoadingProvider; },
/* harmony export */   "d$": function() { return /* binding */ useLoadingContext; },
/* harmony export */   "r$": function() { return /* binding */ useLoading; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Loading_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80912);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19840);




const LoaderContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  isLoading: () => false,
  setLoading: () => false,
  loaderStateMap: /* @__PURE__ */ new Map(),
  logo: ""
});
const useLoadingContext = () => (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LoaderContext);
const LoadingProvider = ({
  children,
  customLoader: CustomLoader,
  logo
}) => {
  const [loaderStateMap, setLoadingStateMap] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(/* @__PURE__ */ new Map());
  const isLoading = (id) => {
    return (loaderStateMap.get(id) || 0) > 0;
  };
  const setLoading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((id, value) => {
    setLoadingStateMap((oldState) => {
      const newState = new Map(oldState);
      let loadingTime = newState.get(id) || 0;
      if (value) {
        loadingTime += 1;
      } else {
        loadingTime -= 1;
      }
      if (loadingTime <= 0) {
        newState.delete(id);
      } else {
        newState.set(id, loadingTime);
      }
      return newState;
    });
  }, [setLoadingStateMap]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoaderContext.Provider, {
    value: { isLoading, setLoading, loaderStateMap, logo: logo || "" }
  }, CustomLoader ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CustomLoader, {
    isLoading: loaderStateMap.size > 0
  }, children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Loading_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Loading */ .g, {
    isLoading: loaderStateMap.size > 0
  }, children));
};
function useLoading(prefix = "") {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LoaderContext);
  if (!context) {
    throw new Error("useLoading must be inside a LoadingProvider with a state value");
  }
  const [id] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => prefix ? `${prefix}_${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .uid */ .hQ)()}` : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_2__/* .uid */ .hQ)());
  const { isLoading, setLoading: setLoadingBase } = context;
  const setLoading = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((state) => {
    return setLoadingBase(id, state);
  }, [id, setLoadingBase]);
  return [isLoading(id), setLoading, id];
}




/***/ }),

/***/ 411213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ Modal_es_Modal; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(255878);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Overlay.es.js
var Overlay_es = __webpack_require__(92300);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(285212);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(19840);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/OldModal.es.js






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal = (_a) => {
  var _b = _a, {
    show,
    onHide,
    children,
    size = ds_index_es/* SizeEnum.m */.mO.m,
    backDropStyle,
    parent
  } = _b, props = __objRest(_b, [
    "show",
    "onHide",
    "children",
    "size",
    "backDropStyle",
    "parent"
  ]);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react.useEffect)(() => {
    if (!parentElement || !show) {
      return;
    }
    parentElement.style.overflow = "hidden";
    parentElement.style.paddingRight = `${(0,utils_es/* getScrollbarWidth */.np)()}px`;
    return () => {
      parentElement.style.overflow = "unset";
      parentElement.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react.createElement(Overlay_es/* Overlay */.a, {
    parent: parentElement || void 0,
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react.createElement(Backdrop, {
    onClick: onHide,
    style: backDropStyle
  }), /* @__PURE__ */ react.createElement(ModalContent, __spreadValues({
    size
  }, props), children));
};
const Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  [ds_index_es/* SizeEnum.s */.mO.s]: "400px",
  [ds_index_es/* SizeEnum.m */.mO.m]: "700px",
  [ds_index_es/* SizeEnum.l */.mO.l]: "960px"
};
const ModalContent = emotion_styled_browser_esm["default"].div(({
  theme,
  size,
  width,
  maxHeight,
  borderRadius,
  backgroundColor
}) => `
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.white)};
    display: flex;
    flex-direction: column;
    width: ${width !== void 0 ? (0,utils_es/* pixelParse */.oJ)(width) : sizeMaps[size || "m"]};
    border-radius: ${borderRadius || (theme == null ? void 0 : theme.borderRadius.m)};
    max-height: ${maxHeight || "90%"};
    z-index: 1060;
    position: relative;
    overflow-y: auto;
  `);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js










var Modal_es_defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Modal_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Modal_es_hasOwnProp = Object.prototype.hasOwnProperty;
var Modal_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var Modal_es_defNormalProp = (obj, key, value) => key in obj ? Modal_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Modal_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Modal_es_hasOwnProp.call(b, prop))
      Modal_es_defNormalProp(a, prop, b[prop]);
  if (Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(b)) {
      if (Modal_es_propIsEnum.call(b, prop))
        Modal_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var Modal_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Modal_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Modal_es_getOwnPropSymbols)
    for (var prop of Modal_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Modal_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Modal_es_Modal = (_a) => {
  var _b = _a, {
    onClose,
    onBackDrop,
    visible,
    title,
    children,
    footer = true,
    width,
    maxWidth,
    style,
    contentStyle,
    onOk,
    onCancel,
    okText,
    cancelText,
    okButtonProps,
    cancelButtonProps,
    showCloseIcon = true,
    centeredTitle = false,
    centeredBody = false,
    alignFooter = "right",
    fullWidthFooter = false,
    closable = true,
    overlayRef,
    zIndex,
    disableEscClose = true,
    overlayAlignItems,
    overlayJustifyContent
  } = _b, rest = Modal_es_objRest(_b, [
    "onClose",
    "onBackDrop",
    "visible",
    "title",
    "children",
    "footer",
    "width",
    "maxWidth",
    "style",
    "contentStyle",
    "onOk",
    "onCancel",
    "okText",
    "cancelText",
    "okButtonProps",
    "cancelButtonProps",
    "showCloseIcon",
    "centeredTitle",
    "centeredBody",
    "alignFooter",
    "fullWidthFooter",
    "closable",
    "overlayRef",
    "zIndex",
    "disableEscClose",
    "overlayAlignItems",
    "overlayJustifyContent"
  ]);
  const onCloseModal = () => {
    if (!closable)
      return;
    if (typeof onClose === "function") {
      onClose == null ? void 0 : onClose();
    }
    if (typeof onBackDrop === "function") {
      onBackDrop == null ? void 0 : onBackDrop();
    }
  };
  const closeOnEscapeKeyDown = (e) => {
    if (!closable || disableEscClose)
      return;
    if ((e.charCode || e.keyCode) === 27) {
      onCloseModal();
    }
  };
  const transitions = (0,react_spring_esm.useTransition)(visible, {
    from: { opacity: 0, transform: "translateY(-40px)" },
    enter: { opacity: 1, transform: "translateY(0px)" },
    leave: { opacity: 0, transform: "translateY(-40px)" }
  });
  (0,react.useEffect)(() => {
    document.body.addEventListener("keydown", closeOnEscapeKeyDown);
    return function cleanup() {
      document.body.removeEventListener("keydown", closeOnEscapeKeyDown);
    };
  }, []);
  (0,react.useEffect)(() => {
    if (typeof document !== "undefined") {
      const currentModals = document.querySelectorAll('*[id^="teko-modal"]');
      if (currentModals.length) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${(0,utils_es/* getScrollbarWidth */.np)()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [visible]);
  const renderFooter = () => {
    if (footer === false || footer === null || footer === void 0) {
      return null;
    }
    const footerCls = (0,utils_es/* mergeCls */.c8)("teko-modal-footer", `teko-modal-footer-${alignFooter}`);
    if (footer === true) {
      const style2 = fullWidthFooter ? { flex: 1 } : {};
      return /* @__PURE__ */ react.createElement("div", {
        className: footerCls
      }, cancelText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(Modal_es_spreadValues({
        marginRight: okText !== "" ? "s12" : "s0",
        onClick: () => onCancel == null ? void 0 : onCancel()
      }, cancelButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, cancelButtonProps == null ? void 0 : cancelButtonProps.style), style2)
      }), cancelText || "Cancel"), okText !== "" && /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(Modal_es_spreadValues({
        variant: "primary",
        onClick: () => onOk == null ? void 0 : onOk()
      }, okButtonProps), {
        style: Modal_es_spreadValues(Modal_es_spreadValues({}, okButtonProps == null ? void 0 : okButtonProps.style), style2)
      }), okText || "OK"));
    }
    return /* @__PURE__ */ react.createElement("div", {
      className: footerCls
    }, footer);
  };
  const modalCls = (0,utils_es/* mergeCls */.c8)("teko-modal", visible ? "teko-modal-show" : "", rest.className || "");
  const modalTitleCls = (0,utils_es/* mergeCls */.c8)("teko-modal-title", centeredTitle ? "teko-modal-title-centered" : "");
  const modalBodyCls = (0,utils_es/* mergeCls */.c8)("teko-modal-body", centeredBody ? "teko-modal-body-centered" : "");
  if (typeof (rest == null ? void 0 : rest.show) !== "undefined") {
    const oldModalProps = __spreadProps(Modal_es_spreadValues({}, rest), {
      children,
      width
    });
    return /* @__PURE__ */ react.createElement(Modal, Modal_es_spreadValues({}, oldModalProps));
  }
  return /* @__PURE__ */ react.createElement(Overlay_es/* Overlay */.a, {
    show: !!visible,
    onEscPressed: () => {
      if (!disableEscClose)
        onCloseModal();
    },
    id: `teko-modal-${(0,utils_es/* uid */.hQ)()}`,
    zIndex,
    alignItems: overlayAlignItems,
    justifyContent: overlayJustifyContent
  }, /* @__PURE__ */ react.createElement(Modal_es_Backdrop, {
    onClick: onCloseModal
  }), transitions((styles, item) => item && /* @__PURE__ */ react.createElement(AnimatedModal, __spreadProps(Modal_es_spreadValues({
    className: modalCls,
    style: Modal_es_spreadValues(Modal_es_spreadValues(Modal_es_spreadValues({}, styles), !!width ? { width } : {}), style)
  }, rest), {
    ref: overlayRef,
    maxWidth
  }), /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-content",
    style: Modal_es_spreadValues({}, contentStyle),
    onClick: (e) => e.stopPropagation()
  }, showCloseIcon && /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    className: "teko-modal-close",
    size: 24,
    color: "#000000",
    onClick: onCloseModal
  }), title && /* @__PURE__ */ react.createElement("div", {
    className: "teko-modal-header"
  }, typeof title === "string" ? /* @__PURE__ */ react.createElement(index_es/* Title */.Dx, {
    level: 1,
    className: modalTitleCls
  }, title) : /* @__PURE__ */ react.createElement("div", {
    className: modalTitleCls
  }, title)), /* @__PURE__ */ react.createElement("div", {
    className: modalBodyCls
  }, children, renderFooter())))));
};
const Modal_es_Backdrop = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const StyledModal = emotion_styled_browser_esm["default"].div`
  width: ${({ size }) => modalSizes[size || "m"]};
  max-width: ${({ maxWidth }) => !!maxWidth ? maxWidth : "95%"};
  &.teko-modal-show {
    opacity: 1 !important;
    pointer-events: visible;
  }

  &.teko-modal-show .teko-modal-content {
    transform: translateY(0);
    z-index: 1050;
  }

  .teko-modal-content {
    padding: 24px;
    transition: all 0.2s ease-in-out;
    background-color: #ffffff;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05),
      0px 8px 16px rgba(0, 0, 0, 0.05);
    position: relative;
    border-radius: 8px;
    position: relative;

    .teko-modal-close {
      position: absolute;
      z-index: 1000;
      top: 24px;
      right: 24px;
      cursor: pointer;
    }

    .teko-modal-header {
      .teko-modal-title {
        margin-bottom: 24px;
        color: #1b1d29;
        &.teko-modal-title-centered {
          text-align: center;
        }
      }
    }

    .teko-modal-body {
      font-size: 13px;
      line-height: 20px;
      word-wrap: break-word;
      &.teko-modal-body-centered {
        text-align: center;
      }
    }

    .teko-modal-footer {
      margin-top: 24px;
      &.teko-modal-footer-right {
        display: flex;
        justify-content: flex-end;
      }
      &.teko-modal-footer-left {
        display: flex;
        justify-content: flex-start;
      }
      &.teko-modal-footer-center {
        display: flex;
        justify-content: center;
      }
    }
  }
`;
const AnimatedModal = (0,react_spring_esm.animated)(StyledModal);
AnimatedModal.defaultProps = {
  size: "m"
};
const modalSizes = {
  xs: "320px",
  s: "420px",
  m: "520px",
  l: "720px"
};




/***/ }),

/***/ 309110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F);
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 891256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ModalHeader = (_a) => {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, children));
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  text-align: center;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const Title = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
`;




/***/ }),

/***/ 92300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(926759);



const Overlay = ({
  show,
  children,
  parent,
  onEscPressed,
  id,
  zIndex,
  justifyContent,
  alignItems
}) => {
  const elmRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  const parentElement = typeof document !== "undefined" ? parent || document.body : null;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    if (id)
      elm.id = id;
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = `${zIndex || 1051}`;
    elm.style.display = "flex";
    elm.style.justifyContent = justifyContent || "center";
    elm.style.alignItems = alignItems || "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    parentElement == null ? void 0 : parentElement.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      parentElement == null ? void 0 : parentElement.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, elmRef.current);
};




/***/ }),

/***/ 670538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ModalProvider; },
/* harmony export */   "s": function() { return /* binding */ ModalStateContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Modal_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(411213);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19840);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const initialState = { showModal: () => "" };
const ModalStateContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
const ModalProvider = ({
  children
}) => {
  const [configModals, setConfigModals] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  const showModal = (options) => {
    const _a = options, { onCancel: baseOnCancel, onOk: baseOnOk } = _a, rest = __objRest(_a, ["onCancel", "onOk"]);
    const modalId = (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_1__/* .uid */ .hQ)();
    const onClose = () => {
      setConfigModals((prev) => {
        const newConfigs = prev.map((m) => {
          if (m.modalId === modalId)
            return __spreadProps(__spreadValues({}, m), { visible: false });
          return m;
        });
        if (newConfigs.every((m) => !m.visible))
          return [];
        return newConfigs;
      });
    };
    const onCancel = () => {
      baseOnCancel == null ? void 0 : baseOnCancel();
      onClose();
    };
    const onOk = async () => {
      await (baseOnOk == null ? void 0 : baseOnOk());
      onClose();
    };
    setConfigModals((prev) => [
      ...prev,
      __spreadValues({
        modalId,
        visible: true,
        onClose,
        onCancel,
        onOk
      }, rest)
    ]);
    return modalId;
  };
  const closeAllModals = () => {
    setConfigModals([]);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalStateContext.Provider, {
    value: {
      showModal,
      closeAllModals
    }
  }, children, configModals.map((modal) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Modal_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u, __spreadValues({
    key: modal.modalId
  }, modal))));
};




/***/ }),

/***/ 339674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _context_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(670538);



function useModal() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ModalStateContext */ .s);
  if (!context) {
    throw new Error("useModal must be inside a ModalStateContext with a state value");
  }
  return context;
}




/***/ }),

/***/ 386877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(281668);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _style_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540999);
/* harmony import */ var _utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82389);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Tooltip = (_a) => {
  var _b = _a, {
    children,
    placement = "auto",
    title,
    triggerHover = true,
    show,
    backgroundColor,
    textColor,
    style,
    timeDelay = 500
  } = _b, rest = __objRest(_b, [
    "children",
    "placement",
    "title",
    "triggerHover",
    "show",
    "backgroundColor",
    "textColor",
    "style",
    "timeDelay"
  ]);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [visible, _setVisible] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const timerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const { styles, attributes, forceUpdate } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      }
    ]
  });
  const setVisible = (visible2) => {
    forceUpdate == null ? void 0 : forceUpdate();
    _setVisible(visible2);
  };
  const actionHover = triggerHover ? {
    onMouseEnter: () => timerRef.current = setTimeout(() => setVisible(true), timeDelay),
    onMouseLeave: () => {
      timerRef.current && clearTimeout(timerRef.current);
      setVisible(false);
    }
  } : {};
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!triggerHover) {
      setVisible(!!show);
    }
  }, [show]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", __spreadValues({}, actionHover), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    style: { display: "flex" },
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TooltipWrapper */ .pf, __spreadValues(__spreadValues({
    ref: tooltipRef,
    style: __spreadValues(__spreadProps(__spreadValues({}, styles.popper), {
      visibility: visible ? "visible" : "hidden",
      zIndex: 999
    }), style),
    backgroundColor
  }, attributes.popper), rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_style_es_js__WEBPACK_IMPORTED_MODULE_2__/* .StyledArrow */ .bC, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    backgroundColor,
    className: (0,_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .getArrowClassName */ .C)(attributes) || "",
    "data-placement": placement
  }), typeof title === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    level: 1,
    weight: "regular",
    color: textColor || "white"
  }, title) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(title, {
    style: __spreadValues({ color: textColor || "white" }, title == null ? void 0 : title.props)
  })));
};




/***/ }),

/***/ 540999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DD": function() { return /* binding */ PopoverWrapper; },
/* harmony export */   "bC": function() { return /* binding */ StyledArrow; },
/* harmony export */   "pf": function() { return /* binding */ TooltipWrapper; }
/* harmony export */ });
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const TooltipWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].span(({ theme, backgroundColor }) => [
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .CommonStyles */ .F,
  `
  background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.textPrimary)};
  padding-top: ${theme == null ? void 0 : theme.spacing.s8};
  padding-bottom: ${theme == null ? void 0 : theme.spacing.s8};
  padding-left: ${theme == null ? void 0 : theme.spacing.s12};
  padding-right: ${theme == null ? void 0 : theme.spacing.s12};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  max-width: 16rem;
  z-index: 100;
`
]);
const PopoverWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].span(({ visibility = true, theme }) => [
  `
  background-color: ${theme == null ? void 0 : theme.colors.textPrimary};
  padding: ${theme == null ? void 0 : theme.spacing.s12};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  max-width: 16rem;
  min-width: 12rem;
  visibility: ${visibility ? "visible" : "hidden"};
  &[data-popper-reference-hidden='true'] {
    visibility: hidden;
    pointer-events: none;
  }
`,
  _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .CommonStyles */ .F
]);
const StyledArrow = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].span(({ theme, backgroundColor }) => `
  position: absolute;
  width: 6px;
  height: 6px;
  &:after {
    content: ' ';
    position: absolute;
    pointer-events: none;
    width: 6px;
    height: 6px;
    background-color: ${backgroundColor || (theme == null ? void 0 : theme.colors.textPrimary)};
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: -3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: -3px;
  }
`);




/***/ }),

/***/ 82389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getArrowClassName; }
/* harmony export */ });
const getArrowClassName = (attributes) => {
  var _a;
  const placementForArrow = (_a = attributes == null ? void 0 : attributes.popper) == null ? void 0 : _a["data-popper-placement"];
  if (!placementForArrow)
    return "";
  if (placementForArrow.startsWith("top"))
    return "arrow-bottom";
  if (placementForArrow.startsWith("bottom"))
    return "arrow-top";
  if (placementForArrow.startsWith("left"))
    return "arrow-right";
  if (placementForArrow.startsWith("right"))
    return "arrow-left";
};




/***/ }),

/***/ 280392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Quantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(978719);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(957518);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(873834);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(248169);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const QuantitySize = {
  xs: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s28 */ .y.s28,
    width: "5.75rem"
  },
  s: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s32 */ .y.s32,
    width: "6.375rem"
  },
  m: {
    height: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s40 */ .y.s40,
    width: "6.375rem"
  }
};
const QuantityWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f;
  return [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F,
    `
  height: ${QuantitySize[props.size || "m"].height};
  width: ${props.block ? "100%" : QuantitySize[props.size || "m"].width};
  border-radius: ${(_a = props.theme) == null ? void 0 : _a.borderRadius.s};
  background: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.tableHeader};
  ${!props.disabled ? `border: ${(_d = props.theme) == null ? void 0 : _d.borderWeight.m} solid ${((_e = props.theme) == null ? void 0 : _e.colors[props.color]) || ((_f = props.theme) == null ? void 0 : _f.colors.divider)};` : ""}
  display: flex;
  align-items: center;
  overflow: hidden;
`
  ];
});
const Plus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const Minus = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].button(({ disabled }) => `
    height: 100%;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    user-select: none;
    border: none;
    background: transparent;
    &:focus {
      outline: none;
    }
    ${disabled ? "cursor: not-allowed;" : ""}
`);
const InputWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ color, theme }) => `
  flex: 1;
  .wrap-input-number {
    padding: 0;
    border: none;
    background-color: transparent;
  }
  .wrap-input-number input {
    text-align: center;
    background-color: transparent;
    font-size: 0.8125rem;
    font-weight: 500;
    color: ${color ? (theme == null ? void 0 : theme.colors[color]) || color : "rgb(67, 70, 87)"};
  }
`);
const IconButonWapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  display: inline-flex;
  align-items: center;
`;
const Quantity = (_a) => {
  var _b = _a, {
    min = 1,
    max = 999,
    quantity = 1,
    precision,
    decimalSeparator = ",",
    step = 1,
    size = "s",
    disabled,
    disableInput,
    disableMinus,
    disablePlus,
    className,
    onMinus,
    onPlus,
    setQuantity,
    color,
    block,
    blurOnEnter = false,
    formatter,
    parser
  } = _b, rest = __objRest(_b, [
    "min",
    "max",
    "quantity",
    "precision",
    "decimalSeparator",
    "step",
    "size",
    "disabled",
    "disableInput",
    "disableMinus",
    "disablePlus",
    "className",
    "onMinus",
    "onPlus",
    "setQuantity",
    "color",
    "block",
    "blurOnEnter",
    "formatter",
    "parser"
  ]);
  const inputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const onChange = (val) => {
    if (typeof val === "string") {
      val = parseFloat(val);
    }
    if (typeof val !== "number") {
      return;
    }
    setQuantity == null ? void 0 : setQuantity(val);
  };
  const onDecrease = () => {
    if (onMinus) {
      onMinus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity - step);
    }
  };
  const onIncrease = () => {
    if (onPlus) {
      onPlus();
    } else if (step) {
      setQuantity == null ? void 0 : setQuantity(quantity + step);
    }
  };
  const disableMinusButton = disabled || disableMinus || quantity - step < min;
  const disablePlusButton = disabled || disablePlus || quantity + step > max;
  const disableInputField = disabled || disableInput;
  const handleBlurOnEnter = (e) => {
    var _a2;
    const ENTER_CHAR_CODE = 13;
    if (e.charCode === ENTER_CHAR_CODE) {
      (_a2 = inputRef.current) == null ? void 0 : _a2.blur();
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const current = inputRef.current;
    if (blurOnEnter) {
      current == null ? void 0 : current.addEventListener("keypress", handleBlurOnEnter);
    }
    return () => {
      current == null ? void 0 : current.removeEventListener("keypress", handleBlurOnEnter);
    };
  }, [blurOnEnter]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(QuantityWrapper, __spreadValues({
    className,
    size,
    block,
    disabled,
    color,
    onClick: (e) => e.preventDefault()
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Minus, {
    className: "minus-btn",
    disabled: disableMinusButton,
    onClick: onDecrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .MinusOutlined */ .l, {
    color: disableMinusButton ? "disable" : color || "textPrimary",
    size: 16
  }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputWrapper, {
    className: "quantity-input-wrapper",
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InputNumber_InputNumber_es_js__WEBPACK_IMPORTED_MODULE_5__/* .InputNumber */ .R, {
    ref: inputRef,
    value: quantity,
    onFocus: (event) => event.target.select(),
    onChange,
    disabled: disableInputField,
    controls: false,
    min,
    max,
    step,
    precision,
    decimalSeparator,
    formatter,
    parser
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Plus, {
    className: "plus-btn",
    disabled: disablePlusButton,
    onClick: onIncrease,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconButonWapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .AddOutlined */ .v, {
    color: disablePlusButton ? "disable" : color || "textPrimary",
    size: 16
  }))));
};




/***/ }),

/***/ 768384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ Ripple; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(715763);





const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 0;
  border-radius: inherit;
  span {
    transform: scale(0);
    border-radius: 100%;
    position: absolute;
    opacity: 0.75;
    background-color: rgba(255, 255, 255, 0.6);
    animation: ripple;
    animation-duration: 696ms;
  }
  @keyframes ripple {
    to {
      opacity: 0;
      transform: scale(2);
    }
  }
`;
const useDebouncedRippleCleanUp = (rippleCount, duration, cleanUpFunction) => {
  const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
  useIsomorphicLayoutEffect(() => {
    let bounce;
    if (rippleCount > 0) {
      clearTimeout(bounce);
      bounce = setTimeout(() => {
        cleanUpFunction();
        clearTimeout(bounce);
      }, duration * 4);
    }
    return () => clearTimeout(bounce);
  }, [rippleCount, duration, cleanUpFunction]);
};
const Ripple = ({
  duration = 600,
  color = "rgba(255,255,255,0.6)"
}) => {
  const [rippleArray, setRippleArray] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  useDebouncedRippleCleanUp(rippleArray.length, duration, () => {
    setRippleArray([]);
  });
  const addRipple = (event) => {
    const rippleContainer = event.currentTarget.getBoundingClientRect();
    const size = rippleContainer.width > rippleContainer.height ? rippleContainer.width : rippleContainer.height;
    const x = event.clientX - rippleContainer.x - size / 2;
    const y = event.clientY - rippleContainer.y - size / 2;
    const newRipple = {
      x,
      y,
      size
    };
    setRippleArray([...rippleArray, newRipple]);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    onMouseDown: addRipple
  }, rippleArray.map((ripple, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      key: "span" + index,
      style: {
        top: ripple.y,
        left: ripple.x,
        width: ripple.size,
        height: ripple.size,
        backgroundColor: color,
        animationDuration: `${duration}ms`
      }
    });
  }));
};




/***/ }),

/***/ 425336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Shape; }
/* harmony export */ });
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);



const Shape = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .CommonStyles */ .F};
`;




/***/ }),

/***/ 71638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Switch; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(263008);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getColor = (props, type) => {
  var _a, _b, _c, _d, _e, _f, _g;
  switch (type) {
    case "bg": {
      if (props.disabled) {
        if (props.checked)
          return (_a = props.theme) == null ? void 0 : _a.colors.primary100;
        return (_b = props.theme) == null ? void 0 : _b.colors.background;
      } else {
        if (props.checked)
          return (_c = props.theme) == null ? void 0 : _c.colors.primary500;
        return (_d = props.theme) == null ? void 0 : _d.colors.divider;
      }
    }
    case "knob":
    default: {
      if (!props.disabled)
        return (_e = props.theme) == null ? void 0 : _e.colors.white;
      return props.checked ? (_f = props.theme) == null ? void 0 : _f.colors.white : (_g = props.theme) == null ? void 0 : _g.colors.divider;
    }
  }
};
const getSize = (size) => {
  switch (size) {
    case "s":
      return [36, 22, 14];
    default:
      return [48, 28, 20];
  }
};
const Switch = (_a) => {
  var _b = _a, {
    checked,
    defaultChecked,
    disabled,
    onChange,
    size: customizeSize
  } = _b, rest = __objRest(_b, [
    "checked",
    "defaultChecked",
    "disabled",
    "onChange",
    "size"
  ]);
  const size = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_contexts_SizeContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SizeContext */ .X);
  const mergeSize = customizeSize || size || "m";
  const [width, height, roundWidth] = getSize(mergeSize);
  const [initCheck, setInitCheck] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setInitCheck(checked === void 0 ? defaultChecked : checked);
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSwitch, __spreadValues({
    style: { width, height }
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "checkbox",
    checked: checked === void 0 ? initCheck : checked,
    disabled,
    onChange: (e) => !disabled && onChange && onChange(e.target.checked)
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SwitchInner, {
    roundWidth,
    switchWidth: width,
    checked: checked === void 0 ? initCheck : checked,
    disabled
  }));
};
const StyledSwitch = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F}
  display: inline-block;
  position: relative;
`;
const SwitchInner = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  transition: background-color 0.3s;
  background-color: ${(p) => getColor(p, "bg")};
  &:before {
    content: '';
    position: absolute;
    height: ${(p) => p.roundWidth}px;
    width: ${(p) => p.roundWidth}px;
    background: ${(p) => getColor(p, "knob")};
    transition: left 0.35s;
    border-radius: 50%;
    top: 4px;
    left: ${(p) => p.checked ? `${p.switchWidth - p.roundWidth - 4}px` : "4px"};
    box-shadow: ${(p) => p.disabled ? "none" : p.theme.shadow(p, "down-s", "black")};
  }
`;
const StyledInput = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  opacity: 0;
`;




/***/ }),

/***/ 991822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ Tag; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_COLOR_500 = {
  branding: "primary500",
  link: "link500",
  success: "success500",
  error: "error500",
  pending: "pending500"
};
const MAPPING_COLOR_600 = {
  branding: "primary600",
  link: "link600",
  success: "success600",
  error: "error600",
  pending: "pending600"
};
const MAPPING_COLOR_50 = {
  branding: "primary50",
  link: "link50",
  success: "success50",
  error: "error50",
  pending: "pending50"
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}` : "unset"};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
  var _b = _a, {
    variant = "branding",
    type = "primary",
    content,
    className
  } = _b, rest = __objRest(_b, [
    "variant",
    "type",
    "content",
    "className"
  ]);
  const getBgColor = () => {
    if (type === "primary") {
      if (variant === "default")
        return "white";
      return MAPPING_COLOR_500[variant];
    }
    if (type === "secondary") {
      if (variant === "default")
        return "background";
      return MAPPING_COLOR_50[variant];
    }
    if (type === "ghost") {
      return "white";
    }
  };
  const getBorderColor = () => {
    if (type === "ghost") {
      if (variant === "default")
        return "border";
      return MAPPING_COLOR_600[variant];
    }
  };
  const getColor = () => {
    if (variant === "default")
      return "textPrimary";
    if (type === "primary")
      return "white";
    return MAPPING_COLOR_600[variant];
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    backgroundColor: getBgColor() || "",
    borderColor: getBorderColor(),
    className
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
    color: getColor(),
    level: 3,
    weight: "medium",
    line: 1
  }, content));
};




/***/ }),

/***/ 92840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hX": function() { return /* binding */ ToastContextDesktop; },
  "QI": function() { return /* binding */ ToastProviderDesktop; }
});

// UNUSED EXPORTS: toastPlacement

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(255878);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SuccessColored.es.js
var SuccessColored_es = __webpack_require__(744383);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(628382);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DeleteCircleColored.es.js
var DeleteCircleColored_es = __webpack_require__(379126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Toast/desktop/Toast.es.js





const toastIcon = {
  success: /* @__PURE__ */ react.createElement(SuccessColored_es/* SuccessColored */.K, {
    size: 30
  }),
  info: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  warning: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  error: /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, {
    size: 30
  })
};
const Toast = ({
  type,
  title,
  message,
  onClose,
  duration = 5e3,
  closeable = true,
  icon,
  onClick
}) => {
  (0,react.useEffect)(() => {
    let handle;
    if (duration) {
      handle = setTimeout(() => onClose == null ? void 0 : onClose(), duration);
    }
    return () => {
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, []);
  return /* @__PURE__ */ react.createElement(StyledToast, null, closeable && /* @__PURE__ */ react.createElement(CloseOutlined_es/* CloseOutlined */.X, {
    className: "teko-toast-close",
    size: 24,
    color: "#000000",
    onClick: onClose
  }), /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-content",
    onClick,
    style: {
      cursor: onClick ? "pointer" : "default"
    }
  }, (icon || type) && /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-icon"
  }, icon ? icon : type && toastIcon[type]), /* @__PURE__ */ react.createElement("div", null, title && /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-header"
  }, typeof title === "string" ? /* @__PURE__ */ react.createElement(index_es/* SubTitle */.DK, {
    level: 2,
    className: "teko-toast-title"
  }, title) : /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-title"
  }, title)), /* @__PURE__ */ react.createElement("div", {
    className: "teko-toast-message"
  }, message))));
};
const StyledToast = emotion_styled_browser_esm["default"].div`
  width: 384px;
  max-width: calc(100vw - 24px * 2);
  position: relative;
  .teko-toast-icon {
    margin-right: 20px;
  }
  .teko-toast-close {
    position: absolute;
    z-index: 1000;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
  .teko-toast-content {
    position: relative;
    display: flex;
    padding: 16px 24px;
    border-radius: 8px;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
      0 9px 28px 8px rgb(0 0 0 / 5%);
    background: white;
    & .teko-toast-header {
      margin-right: 16px;
    }
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(19840);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Toast/desktop/context.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToastContextDesktop = react.createContext({});
const toastPlacement = [
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight"
];
const ToastProviderDesktop = ({
  children
}) => {
  const [toastPlacementState, setToastPlacementState] = (0,react.useState)({
    topLeft: [],
    topRight: [],
    bottomLeft: [],
    bottomRight: []
  });
  const transitionConfig = { tension: 125, friction: 20, precision: 0.1 };
  const toastTransitions = {
    topRight: (0,react_spring_esm.useTransition)(toastPlacementState.topRight, {
      from: { opacity: 0, transform: "translate(40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, -10px)" },
      config: transitionConfig
    }),
    bottomRight: (0,react_spring_esm.useTransition)(toastPlacementState.bottomRight, {
      from: { opacity: 0, transform: "translate(40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, 10px)" },
      config: transitionConfig
    }),
    topLeft: (0,react_spring_esm.useTransition)(toastPlacementState.topLeft, {
      from: { opacity: 0, transform: "translate(-40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, -10px)" },
      config: transitionConfig
    }),
    bottomLeft: (0,react_spring_esm.useTransition)(toastPlacementState.bottomLeft, {
      from: { opacity: 0, transform: "translate(-40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, 10px)" },
      config: transitionConfig
    })
  };
  const open = (props) => {
    const toastPlacement2 = props.placement || "topRight";
    if (toastPlacement2 === "topLeft" || toastPlacement2 === "topRight") {
      setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
        [toastPlacement2]: [...state[toastPlacement2], __spreadProps(__spreadValues({}, props), { id: (0,utils_es/* uid */.hQ)() })]
      }));
      return;
    }
    setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
      [toastPlacement2]: [__spreadProps(__spreadValues({}, props), { id: (0,utils_es/* uid */.hQ)() }), ...state[toastPlacement2]]
    }));
  };
  const onClose = (placement, item) => {
    setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
      [placement]: state[placement].filter((e) => e.id !== item.id)
    }));
  };
  const toast = {
    open
  };
  ["success", "info", "error", "warning"].forEach((type) => {
    toast[type] = (props) => open(__spreadValues({ type }, props));
  });
  return /* @__PURE__ */ react.createElement(ToastContextDesktop.Provider, {
    value: toast
  }, children, toastPlacement.map((place) => {
    var _a;
    if (!((_a = toastPlacementState[place]) == null ? void 0 : _a.length))
      return;
    const placementCls = `teko-toast teko-toast-${place}`;
    return /* @__PURE__ */ react.createElement(ToastPositionGroup, {
      key: place,
      className: placementCls
    }, toastTransitions[place]((style, item) => {
      return /* @__PURE__ */ react.createElement(AnimatedDiv, {
        key: item.id,
        style
      }, /* @__PURE__ */ react.createElement(Toast, __spreadProps(__spreadValues({}, item), {
        onClose: () => onClose(place, item)
      })));
    }));
  }));
};
const ToastPositionGroup = emotion_styled_browser_esm["default"].div`
  &.teko-toast {
    position: fixed;
    z-index: 1070;
    &.teko-toast-topRight {
      right: 24px;
      top: 24px;
    }
    &.teko-toast-topLeft {
      left: 24px;
      top: 24px;
    }
    &.teko-toast-bottomLeft {
      left: 24px;
      bottom: 24px;
    }
    &.teko-toast-bottomRight {
      right: 24px;
      bottom: 24px;
    }
  }
`;
const AnimatedDiv = (0,emotion_styled_browser_esm["default"])(react_spring_esm.animated.div)`
  margin-bottom: 16px;
`;




/***/ }),

/***/ 753625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ ToastContextMobile; },
  "E": function() { return /* binding */ ToastProviderMobile; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SuccessColored.es.js
var SuccessColored_es = __webpack_require__(744383);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/InforOutlined.es.js
var InforOutlined_es = __webpack_require__(628382);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DeleteCircleColored.es.js
var DeleteCircleColored_es = __webpack_require__(379126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Toast/mobile/Toast.es.js




const toastIcon = {
  success: /* @__PURE__ */ react.createElement(SuccessColored_es/* SuccessColored */.K, {
    size: 30
  }),
  info: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  warning: /* @__PURE__ */ react.createElement(InforOutlined_es/* InforOutlined */.l, {
    size: 30
  }),
  error: /* @__PURE__ */ react.createElement(DeleteCircleColored_es/* DeleteCircleColored */.H, {
    size: 30
  })
};
const Toast = ({
  message,
  icon,
  placement = "middle",
  type,
  duration = 5e3,
  onClose,
  customStyle
}) => {
  (0,react.useEffect)(() => {
    let handle;
    if (duration) {
      handle = setTimeout(() => onClose == null ? void 0 : onClose(), duration);
    }
    return () => {
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, []);
  const positionClass = `teko-mobile-toast teko-mobile-toast-${placement}`;
  return /* @__PURE__ */ react.createElement(StyledToast, {
    className: positionClass,
    style: customStyle
  }, (icon || type) && /* @__PURE__ */ react.createElement("div", {
    className: "teko-mobile-toast-icon"
  }, icon ? icon : type && toastIcon[type]), /* @__PURE__ */ react.createElement("div", {
    className: "teko-mobile-toast-message"
  }, message));
};
const StyledToast = emotion_styled_browser_esm["default"].div`
  &.teko-mobile-toast {
    display: flex;
    z-index: 1070;
    position: fixed;
    left: 50%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 70%;
    padding: 8px 16px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    text-align: center;
    word-break: break-word;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 8px;
    transform: translate3d(-50%, -50%, 0);
    &.teko-mobile-toast-top {
      top: 20%;
    }
    &.teko-mobile-toast-middle {
      top: 50%;
    }
    &.teko-mobile-toast-bottom {
      top: 80%;
    }
    .teko-mobile-toast-icon {
      margin-bottom: 4px;
    }
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/react-spring-virtual-58f323a72b/0/cache/react-spring-npm-9.4.3-74bd988b90-94741fde63.zip/node_modules/react-spring/dist/react-spring.esm.js
var react_spring_esm = __webpack_require__(255878);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Toast/mobile/context.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToastContextMobile = react.createContext({});
const ToastProviderMobile = ({
  children
}) => {
  const [toastProps, setToastProps] = (0,react.useState)(null);
  const open = (props) => {
    if (toastProps && JSON.stringify(toastProps) === JSON.stringify(props)) {
      return;
    }
    setToastProps(props);
  };
  const toast = {
    open
  };
  ["success", "info", "error", "warning"].forEach((type) => {
    toast[type] = (props) => open(__spreadValues({ type }, props));
  });
  const onClose = () => setToastProps(null);
  const transitions = (0,react_spring_esm.useTransition)(toastProps, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { tension: 125, friction: 20, precision: 0.1 }
  });
  return /* @__PURE__ */ react.createElement(ToastContextMobile.Provider, {
    value: toast
  }, children, toastProps && transitions((style, item) => item && /* @__PURE__ */ react.createElement(react_spring_esm.animated.div, {
    style
  }, /* @__PURE__ */ react.createElement(Toast, __spreadProps(__spreadValues({}, item), {
    onClose
  })))));
};




/***/ }),

/***/ 621655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* binding */ Body; },
  "YS": function() { return /* binding */ Caption; },
  "X6": function() { return /* binding */ Heading; },
  "DK": function() { return /* binding */ SubTitle; },
  "Dx": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/helper.es.js
const TYPOGRAPHY_SIZE = {
  heading: [
    {
      fontSize: "48px",
      lineHeight: "64px",
      fontWeight: "bold"
    },
    {
      fontSize: "40px",
      lineHeight: "56px",
      fontWeight: "medium"
    },
    {
      fontSize: "36px",
      lineHeight: "48px",
      fontWeight: "medium"
    },
    {
      fontSize: "32px",
      lineHeight: "40px",
      fontWeight: "bold"
    }
  ],
  title: [
    {
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: "bold"
    },
    {
      fontSize: "20px",
      lineHeight: "28px",
      fontWeight: "bold"
    },
    {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  subtitle: [
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "15px",
      lineHeight: "24px",
      fontWeight: "medium"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "bold"
    },
    {
      fontSize: "13px",
      lineHeight: "24px",
      fontWeight: "medium"
    }
  ],
  body: [
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "regular"
    },
    {
      fontSize: "13px",
      lineHeight: "20px",
      fontWeight: "medium"
    }
  ],
  caption: [
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "regular"
    },
    {
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "medium"
    },
    {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "medium"
    }
  ]
};
const FONT_WEIGHT_MAP = {
  bold: 700,
  medium: 500,
  regular: 400
};
const getTypographySize = (type, level = 1, attr) => {
  const tagAttrs = TYPOGRAPHY_SIZE[type][level - 1] || TYPOGRAPHY_SIZE[type][0];
  return tagAttrs[attr];
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(640128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledTypography = emotion_styled_browser_esm["default"].div`
  margin: 0;
  padding: 0;
  ${index_es/* CommonStyles */.F}
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => (p.weight ? FONT_WEIGHT_MAP[p.weight] : FONT_WEIGHT_MAP[getTypographySize(p.type, p.level, "fontWeight")]) || 500};
  text-decoration: ${(p) => p.decoration || "unset"};
  font-size: ${(p) => getTypographySize(p.type, p.level, "fontSize")};
  line-height: ${(p) => getTypographySize(p.type, p.level, "lineHeight")};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(p) => p.line || "unset"};
  max-width: ${(p) => p.maxWidth ? `${p.maxWidth}px` : "unset"};
  min-width: ${(p) => p.minWidth ? `${p.minWidth}px` : "unset"};
  transition: color 0.3s ease;
  ${(p) => p.hoverColor ? `&:hover {
    color: ${p.theme.colors[p.hoverColor] || p.hoverColor};
  }` : ""};
  ${(p) => p.textTransform ? `
        text-transform: ${p.textTransform};
      ` : ""}
`;
const Heading = (_a) => {
  var _b = _a, { level = 4 } = _b, props = __objRest(_b, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "heading",
    as: `h${level}`,
    level
  }, props));
};
const Title = (_c) => {
  var _d = _c, { level = 2 } = _d, props = __objRest(_d, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "title",
    level
  }, props));
};
const SubTitle = (_e) => {
  var _f = _e, { level = 4 } = _f, props = __objRest(_f, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "subtitle",
    level
  }, props));
};
const Body = (_g) => {
  var _h = _g, { level = 2 } = _h, props = __objRest(_h, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "body",
    level
  }, props));
};
const Caption = (_i) => {
  var _j = _i, { level = 3 } = _j, props = __objRest(_j, ["level"]);
  return /* @__PURE__ */ react.createElement(StyledTypography, __spreadValues({
    type: "caption",
    level
  }, props));
};




/***/ }),

/***/ 519379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ hex2Rgb; }
/* harmony export */ });
const hexCharacters = "a-f\\d";
const match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
const match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
const nonHexChars = new RegExp(`[^#${hexCharacters}]`, "gi");
const validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, "i");
function hex2Rgb(hex, options = {}) {
  if (typeof hex !== "string" || nonHexChars.test(hex) || !validHexSize.test(hex)) {
    throw new TypeError("Expected a valid hex string");
  }
  hex = hex.replace(/^#/, "");
  let alpha = 1;
  if (hex.length === 8) {
    alpha = Number.parseInt(hex.slice(6, 8), 16) / 255;
    hex = hex.slice(0, 6);
  }
  if (hex.length === 4) {
    alpha = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
    hex = hex.slice(0, 3);
  }
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  const number = Number.parseInt(hex, 16);
  const red = number >> 16;
  const green = number >> 8 & 255;
  const blue = number & 255;
  if (options.format === "array") {
    return [red, green, blue, alpha];
  }
  if (options.format === "css") {
    const alphaString = alpha === 1 ? "" : ` / ${Number((alpha * 100).toFixed(2))}%`;
    return `rgb(${red} ${green} ${blue}${alphaString})`;
  }
  return { red, green, blue, alpha };
}




/***/ }),

/***/ 380439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ generate; }
});

// EXTERNAL MODULE: ../../.yarn/cache/color-name-npm-1.1.4-025792b0ea-b044585952.zip/node_modules/color-name/index.js
var color_name = __webpack_require__(335410);
var color_name_default = /*#__PURE__*/__webpack_require__.n(color_name);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/regexes/index.es.js
const index_es_float = "-?\\d*(?:\\.\\d+)";
const number = `(${index_es_float}?)`;
const percentage = `(${index_es_float}?%)`;
const numberOrPercentage = `(${index_es_float}?%?)`;
const pattern1 = /^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/;
const hexRe = new RegExp(pattern1, "i");
const pattern2 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const hsl3Re = new RegExp(pattern2);
const pattern3 = `^
  hsla?\\(
    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const hsl4Re = new RegExp(pattern3);
const pattern4 = `^
  rgba?\\(
    \\s*${number}\\s*,
    \\s*${number}\\s*,
    \\s*${number}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const rgb3NumberRe = new RegExp(pattern4);
const pattern5 = `^
  rgba?\\(
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*,
    \\s*${percentage}\\s*
    (?:,\\s*${numberOrPercentage}\\s*)?
  \\)
  $
`.replace(/\n|\s/g, "");
const rgb3PercentageRe = new RegExp(pattern5);
const pattern6 = `^
  rgba?\\(
    \\s*${number}
    \\s+${number}
    \\s+${number}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, "");
const rgb4NumberRe = new RegExp(pattern6);
const pattern7 = `^
  rgba?\\(
    \\s*${percentage}
    \\s+${percentage}
    \\s+${percentage}
    \\s*(?:\\s*\\/\\s*${numberOrPercentage}\\s*)?
  \\)
$
`.replace(/\n|\s/g, "");
const rgb4PercentageRe = new RegExp(pattern7);
const pattern8 = /^transparent$/;
const transparentRe = new RegExp(pattern8, "i");



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/utils/hex-rgb.es.js
var hex_rgb_es = __webpack_require__(519379);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/utils/index.es.js


const clamp = (num, min, max) => Math.min(Math.max(min, num), max);
const parseRGB = (num) => {
  let n = num;
  if (typeof n !== "number")
    n = n.endsWith("%") ? parseFloat(n) * 255 / 100 : parseFloat(n);
  return clamp(Math.round(n), 0, 255);
};
const parsePercentage = (percentage) => clamp(parseFloat(percentage), 0, 100);
function parseAlpha(alpha) {
  let a = alpha;
  if (typeof a !== "number")
    a = a.endsWith("%") ? parseFloat(a) / 100 : parseFloat(a);
  return clamp(a, 0, 1);
}
function getHEX(hex) {
  const [r, g, b, a] = (0,hex_rgb_es/* hex2Rgb */.r)(hex, { format: "array" });
  return getRGB([null, r, g, b, a]);
}
function getHSL([, h, s, l, a = 1]) {
  let hh = h;
  if (hh.endsWith("turn")) {
    hh = parseFloat(hh) * 360 / 1;
  } else if (hh.endsWith("rad")) {
    hh = Math.round(parseFloat(hh) * 180 / Math.PI);
  } else {
    hh = parseFloat(hh);
  }
  return {
    type: "hsl",
    values: [hh, parsePercentage(s), parsePercentage(l)],
    alpha: parseAlpha(a === null ? 1 : a)
  };
}
function getRGB([, r, g, b, a = 1]) {
  return {
    type: "rgb",
    values: [r, g, b].map(parseRGB),
    alpha: parseAlpha(a === null ? 1 : a)
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/parse-css-color/index.es.js




const parseCSSColor = (str) => {
  if (typeof str !== "string")
    return null;
  const hex = hexRe.exec(str);
  if (hex)
    return getHEX(hex[0]);
  const hsl = hsl4Re.exec(str) || hsl3Re.exec(str);
  if (hsl)
    return getHSL(hsl);
  const rgb = rgb4NumberRe.exec(str) || rgb4PercentageRe.exec(str) || rgb3NumberRe.exec(str) || rgb3PercentageRe.exec(str);
  if (rgb)
    return getRGB(rgb);
  if (transparentRe.exec(str))
    return getRGB([null, 0, 0, 0, 0]);
  const cn = (color_name_default())[str.toLowerCase()];
  if (cn)
    return getRGB([null, cn[0], cn[1], cn[2], 1]);
  return null;
};
var parse = parseCSSColor;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/pure-color/index.es.js
function index_es_clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}
function hsl2rgb(hsl) {
  const h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100;
  let t2, t3, val;
  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }
  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  const t1 = 2 * l - t2;
  const rgb = [0, 0, 0];
  for (let i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * -(i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;
    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;
    rgb[i] = val * 255;
  }
  return rgb;
}
function componentToHex(c) {
  const value = Math.round(index_es_clamp(c, 0, 255));
  const hex = value.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
function rgb2hex(rgb) {
  const alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";
  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
}
function rgb2hsl(rgb) {
  const r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min;
  let h, s;
  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;
  h = Math.min((h || 0) * 60, 360);
  if (h < 0)
    h += 360;
  const l = (min + max) / 2;
  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);
  return [h, s * 100, l * 100];
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/mix-css-color/index.es.js



function parseColor(color) {
  const res = parse(color);
  if (res === null)
    return null;
  if (res.type === "hsl")
    res.values = hsl2rgb(res.values);
  return res;
}
function mix(color1, color2, percentage = 50) {
  const c1 = parseColor(color1);
  const c2 = parseColor(color2);
  if (!c1 || !c2)
    return null;
  const p = Math.min(Math.max(0, percentage), 100) / 100;
  const w = p * 2 - 1;
  const a = c1.alpha - c2.alpha;
  const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
  const w2 = 1 - w1;
  const [r, g, b] = c1.values.map((c, i) => Math.round(c1.values[i] * w1 + c2.values[i] * w2));
  const alpha = parseFloat((c1.alpha * p + c2.alpha * (1 - p)).toFixed(8));
  return {
    hex: rgb2hex([r, g, b]),
    hexa: rgb2hex([r, g, b, alpha]),
    rgba: [r, g, b, alpha],
    hsla: [...rgb2hsl([r, g, b]).map(Math.round), alpha]
  };
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/core/index.es.js




const defaultNumberParam = (v, d) => v === null || isNaN(v) || typeof v === "string" ? d : v;
class ColorCore {
  constructor(color = "#000", type = "base", weight = 0) {
    [this.rgb, this.alpha, this.type, this.weight] = [
      [0, 0, 0],
      1,
      type,
      weight
    ];
    const c = color === null ? "#000" : color;
    if (typeof c !== "string")
      throw new TypeError(`Input should be a string: ${c}`);
    const parsed = parse(c);
    if (!parsed)
      throw new Error(`Unable to parse color from string: ${c}`);
    return this[`_setFrom${parsed.type.toUpperCase()}`]([
      ...parsed.values,
      parsed.alpha
    ]);
  }
  get hex() {
    return this.hexString().replace(/^#/, "");
  }
  setColor(color) {
    const parsed = parse(color);
    if (!parsed)
      return null;
    return this[`_setFrom${parsed.type.toUpperCase()}`]([
      ...parsed.values,
      parsed.alpha
    ]);
  }
  tint(weight, w = defaultNumberParam(weight, 50)) {
    var _a;
    return new ColorCore(`rgb(${(_a = mix("#fff", this.rgbString(), w)) == null ? void 0 : _a.rgba})`, "tint", w);
  }
  shade(weight, w = defaultNumberParam(weight, 50)) {
    var _a;
    return new ColorCore(`rgb(${(_a = mix("#000", this.rgbString(), w)) == null ? void 0 : _a.rgba})`, "shade", w);
  }
  tints(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.tint((i + 1) * w));
  }
  shades(weight, w = defaultNumberParam(weight, 10)) {
    return Array.from({ length: 100 / w }, (_, i) => this.shade((i + 1) * w));
  }
  all(weight = 10) {
    return [
      ...this.tints(weight).reverse(),
      Object.assign(this),
      ...this.shades(weight)
    ];
  }
  hexString() {
    return rgb2hex(this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]);
  }
  rgbString() {
    const channels = (this.alpha >= 1 ? this.rgb : [...this.rgb, this.alpha]).join(", ");
    return `${this.alpha >= 1 ? "rgb" : "rgba"}(${channels})`;
  }
  getBrightness() {
    return Math.round(this.rgb.reduce((a, b) => a + b) / (255 * 3) * 100);
  }
  _setFromRGB([r, g, b, a]) {
    [this.rgb, this.alpha] = [[r, g, b], a];
    return this;
  }
  _setFromHSL([h, s, l, a]) {
    [this.rgb, this.alpha] = [hsl2rgb([h, s, l]).map(Math.round), a];
    return this;
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/generate.es.js


const DEFAULT_WEIGHT = 5;
const valueOptions = {
  50: 1,
  100: 2,
  200: 4,
  500: 20,
  600: 22,
  700: 24
};
function generate(color, type) {
  const patterns = { [type]: color };
  const pColors = new ColorCore(color).all(DEFAULT_WEIGHT);
  Object.keys(valueOptions).forEach((key) => {
    patterns[`${type}${key}`] = pColors[valueOptions[key]].hexString();
  });
  return patterns;
}




/***/ }),

/***/ 743126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ themeColor; }
/* harmony export */ });
/* harmony import */ var _generate_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(380439);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const functionalColors = {
  primary: "#ee112e",
  secondary: "#0674e8",
  link: "#1990ff",
  pending: "#ffa940",
  success: "#43da71",
  error: "#da4343"
};
const defaultColors = {
  white: "#FFFFFF",
  tableHeader: "#F8F8FC",
  background: "#F3F3F7",
  divider: "#E4E5F0",
  inputBorder: "#e0e0e0",
  disable: "#DCDEE9",
  border: "#BCBFD6",
  placeholder: "#A7ABC3",
  textSecondary: "#82869E",
  textPrimary: "#434657",
  textTitle: "#1B1D29",
  black: "#000000",
  neutral: "#848788",
  text: "#434657",
  primary: "#ee112e",
  secondary: "#0674e8",
  link: "#1990ff",
  pending: "#ffa940",
  success: "#43da71",
  error: "#da4343",
  support: "#FFE040"
};
let presetPalettes = {};
Object.keys(functionalColors).forEach((key) => {
  presetPalettes = __spreadValues(__spreadValues({}, presetPalettes), (0,_generate_es_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(functionalColors[key], key));
});
const themeColor = __spreadValues(__spreadValues({}, defaultColors), presetPalettes);




/***/ }),

/***/ 387948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ getRgbaFromHex; }
/* harmony export */ });
/* harmony import */ var _core_parse_css_color_utils_hex_rgb_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(519379);


function getRgbaFromHex(hex, alpha = 1) {
  const rgb = (0,_core_parse_css_color_utils_hex_rgb_es_js__WEBPACK_IMPORTED_MODULE_0__/* .hex2Rgb */ .r)(hex);
  if (!rgb) {
    return null;
  }
  return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, ${alpha})`;
}




/***/ }),

/***/ 299406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ defaultTheme; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(978719);
/* harmony import */ var _Colors_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(743126);
/* harmony import */ var _Colors_util_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(387948);




const getBoxShadow = (props, shadow, shadowColor = "black") => {
  var _a, _b, _c;
  const css = ((_a = props.theme) == null ? void 0 : _a.shadowValue[shadow]) || "none";
  return css.replace(/{{color}}/gi, (0,_Colors_util_es_js__WEBPACK_IMPORTED_MODULE_0__/* .getRgbaFromHex */ .p)(((_b = props.theme) == null ? void 0 : _b.colors[shadowColor]) || "", (_c = props.theme) == null ? void 0 : _c.shadowAlphaValue[shadow]) || "");
};
const defaultTheme = {
  colors: _Colors_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .themeColor */ .E,
  borderRadius: {
    s: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s4 */ .y.s4,
    m: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s8 */ .y.s8,
    l: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s12 */ .y.s12,
    xl: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE.s16 */ .y.s16
  },
  borderWeight: {
    s: "0.5px",
    m: "1px",
    l: "1.5px"
  },
  opacity: {
    s: 0,
    m: 0.3,
    l: 0.5,
    xl: 0.7
  },
  shadowValue: {
    "down-xs": "0 2px 2px {{color}}",
    "down-s": "0 2px 4px {{color}}",
    "down-m": "0 4px 8px {{color}}",
    "down-l": "0 4px 16px {{color}}, 0 8px 16px {{color}}",
    "up-s": "0 -2px 4px {{color}}",
    "up-m": "0 -4px 8px {{color}}",
    "up-l": "0px -4px 16px {{color}}, 0px -8px 16px {{color}};"
  },
  shadowAlphaValue: {
    "down-xs": 0.1,
    "down-s": 0.075,
    "down-m": 0.05,
    "down-l": 0.05,
    "up-s": 0.075,
    "up-m": 0.05,
    "up-l": 0.05
  },
  spacing: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CORE_SIZE */ .y,
  shadow: getBoxShadow
};




/***/ }),

/***/ 978719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ MAPPING_SIZE; },
/* harmony export */   "y": function() { return /* binding */ CORE_SIZE; }
/* harmony export */ });
const CORE_SIZE = {
  s0: "0rem",
  s4: "0.25rem",
  s8: "0.5rem",
  s12: "0.75rem",
  s16: "1rem",
  s20: "1.25rem",
  s24: "1.5rem",
  s28: "1.75rem",
  s32: "2rem",
  s36: "2.25rem",
  s40: "2.5rem",
  s44: "2.75rem",
  s48: "3rem",
  s52: "3.25rem",
  s56: "3.5rem",
  s60: "3.75rem",
  s64: "4rem",
  s68: "4.25rem",
  s72: "4.5rem",
  s76: "4.75rem",
  s80: "5rem"
};
const MAPPING_SIZE = {
  s: 32,
  m: 40,
  l: 48,
  xl: 56
};




/***/ }),

/***/ 263008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SizeContext; },
/* harmony export */   "q": function() { return /* binding */ SizeContextProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const SizeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(void 0);
const SizeContextProvider = ({
  children,
  size
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContext.Consumer, null, (originSize) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SizeContext.Provider, {
  value: size || originSize
}, children));




/***/ }),

/***/ 348855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTheme; },
/* harmony export */   "f": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(962470);
/* harmony import */ var _components_Modal_context_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(670538);
/* harmony import */ var _components_Toast_desktop_context_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92840);
/* harmony import */ var _components_Toast_mobile_context_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(753625);
/* harmony import */ var _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(299406);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ThemeProvider = (_a) => {
  var _b = _a, {
    children,
    theme = _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultTheme */ .u,
    customTheme
  } = _b, rest = __objRest(_b, [
    "children",
    "theme",
    "customTheme"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_2__.a, __spreadValues({
    theme: __spreadValues(__spreadValues({}, theme), customTheme)
  }, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Modal_context_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ModalProvider */ .D, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Toast_desktop_context_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ToastProviderDesktop */ .QI, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Toast_mobile_context_es_js__WEBPACK_IMPORTED_MODULE_5__/* .ToastProviderMobile */ .E, null, children))));
};
function useTheme() {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
  return theme;
}




/***/ }),

/***/ 19840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C4": function() { return /* binding */ isNotNullOrUndefinedElement; },
/* harmony export */   "CE": function() { return /* binding */ omit; },
/* harmony export */   "I0": function() { return /* binding */ generateTheme; },
/* harmony export */   "O8": function() { return /* binding */ useClickOutside; },
/* harmony export */   "c8": function() { return /* binding */ mergeCls; },
/* harmony export */   "hQ": function() { return /* binding */ uid; },
/* harmony export */   "np": function() { return /* binding */ getScrollbarWidth; },
/* harmony export */   "o0": function() { return /* binding */ formatDateTime; },
/* harmony export */   "oJ": function() { return /* binding */ pixelParse; },
/* harmony export */   "pW": function() { return /* binding */ getElementOffset; },
/* harmony export */   "qo": function() { return /* binding */ toArray; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(380439);
/* harmony import */ var _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(743126);
/* harmony import */ var _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(299406);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const formatDateTime = (date, type) => {
  const dateStr = date.toLocaleDateString("en-GB");
  const timeStr = date.toLocaleTimeString("vi-VN").slice(0, 5);
  switch (type) {
    case "date":
      return dateStr;
    case "time":
      return timeStr;
    default:
      return `${dateStr} ${timeStr}`;
  }
};
const useClickOutside = (ref, handler) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const listener = (event) => {
      const refs = Array.isArray(ref) ? ref : [ref];
      if (!refs.some((ref2) => ref2.current) || refs.some((e) => {
        var _a;
        return (_a = e.current) == null ? void 0 : _a.contains(event.target);
      })) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    document.addEventListener("click", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
      document.removeEventListener("click", listener);
    };
  }, [ref, handler]);
};
const generateTheme = (baseColor) => {
  return __spreadProps(__spreadValues({}, _configs_Theme_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .defaultTheme */ .u), {
    colors: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, _configs_Colors_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .themeColor */ .E), (0,_configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(baseColor.primary, "primary")), (0,_configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(baseColor.secondary, "secondary")), baseColor.link && (0,_configs_Colors_generate_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(baseColor.link, "link"))
  });
};
const pixelParse = (value) => {
  if (typeof value === "number")
    return `${value}px`;
  return value;
};
const getScrollbarWidth = () => {
  var _a;
  let width = 0;
  if (typeof window !== "undefined") {
    if (document.body.scrollHeight <= window.innerHeight)
      return 0;
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    (_a = outer.parentNode) == null ? void 0 : _a.removeChild(outer);
  }
  return width;
};
const toArray = (candidate) => {
  if (candidate === void 0 || candidate === false)
    return [];
  return Array.isArray(candidate) ? candidate : [candidate];
};
const omit = (obj, fields) => {
  const clone = __spreadValues({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach((key) => {
      delete clone[key];
    });
  }
  return clone;
};
const mergeCls = (...cls) => {
  return cls.filter(Boolean).join(" ");
};
const uid = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};
const getElementOffset = (elem) => {
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top, left };
};
const isNotNullOrUndefinedElement = (val) => !!val;




/***/ }),

/***/ 873834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ AddOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const AddOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V11.25H4C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75H11.25V20C11.25 20.4142 11.5858 20.75 12 20.75C12.4142 20.75 12.75 20.4142 12.75 20V12.75H20C20.4142 12.75 20.75 12.4142 20.75 12C20.75 11.5858 20.4142 11.25 20 11.25H12.75V4Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 228680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ArrowDownFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ArrowDownFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M16.4767 10H7.52331C7.07668 10 6.83609 10.5267 7.12731 10.867L11.208 15.6348C11.6248 16.1217 12.3752 16.1217 12.792 15.6348L16.8727 10.867C17.1639 10.5267 16.9233 10 16.4767 10Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 431529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ BackOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const BackOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.5 5L8.5 12L15.5 19",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 47649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CautionOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CautionOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-ffiukdppn", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.25 3.75C7.55558 3.75 3.75 7.55558 3.75 12.25C3.75 16.9444 7.55558 20.75 12.25 20.75C16.9444 20.75 20.75 16.9444 20.75 12.25C20.75 7.55558 16.9444 3.75 12.25 3.75ZM2.25 12.25C2.25 6.72715 6.72715 2.25 12.25 2.25C17.7728 2.25 22.25 6.72715 22.25 12.25C22.25 17.7728 17.7728 22.25 12.25 22.25C6.72715 22.25 2.25 17.7728 2.25 12.25ZM12.25 6.95459C12.6642 6.95459 13 7.29038 13 7.70459V13.1591C13 13.5733 12.6642 13.9091 12.25 13.9091C11.8358 13.9091 11.5 13.5733 11.5 13.1591V7.70459C11.5 7.29038 11.8358 6.95459 12.25 6.95459ZM13.25 16.7954C13.25 17.3477 12.8023 17.7954 12.25 17.7954C11.6977 17.7954 11.25 17.3477 11.25 16.7954C11.25 16.2431 11.6977 15.7954 12.25 15.7954C12.8023 15.7954 13.25 16.2431 13.25 16.7954Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.25 3.75C7.55558 3.75 3.75 7.55558 3.75 12.25C3.75 16.9444 7.55558 20.75 12.25 20.75C16.9444 20.75 20.75 16.9444 20.75 12.25C20.75 7.55558 16.9444 3.75 12.25 3.75ZM2.25 12.25C2.25 6.72715 6.72715 2.25 12.25 2.25C17.7728 2.25 22.25 6.72715 22.25 12.25C22.25 17.7728 17.7728 22.25 12.25 22.25C6.72715 22.25 2.25 17.7728 2.25 12.25ZM12.25 6.95459C12.6642 6.95459 13 7.29038 13 7.70459V13.1591C13 13.5733 12.6642 13.9091 12.25 13.9091C11.8358 13.9091 11.5 13.5733 11.5 13.1591V7.70459C11.5 7.29038 11.8358 6.95459 12.25 6.95459ZM13.25 16.7954C13.25 17.3477 12.8023 17.7954 12.25 17.7954C11.6977 17.7954 11.25 17.3477 11.25 16.7954C11.25 16.2431 11.6977 15.7954 12.25 15.7954C12.8023 15.7954 13.25 16.2431 13.25 16.7954Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M4.75 12.25C4.75 8.10786 8.10786 4.75 12.25 4.75V2.75C7.00329 2.75 2.75 7.00329 2.75 12.25H4.75ZM12.25 19.75C8.10786 19.75 4.75 16.3921 4.75 12.25H2.75C2.75 17.4967 7.00329 21.75 12.25 21.75V19.75ZM19.75 12.25C19.75 16.3921 16.3921 19.75 12.25 19.75V21.75C17.4967 21.75 21.75 17.4967 21.75 12.25H19.75ZM12.25 4.75C16.3921 4.75 19.75 8.10786 19.75 12.25H21.75C21.75 7.00329 17.4967 2.75 12.25 2.75V4.75ZM12.25 1.25C6.17487 1.25 1.25 6.17487 1.25 12.25H3.25C3.25 7.27944 7.27944 3.25 12.25 3.25V1.25ZM23.25 12.25C23.25 6.17487 18.3251 1.25 12.25 1.25V3.25C17.2206 3.25 21.25 7.27944 21.25 12.25H23.25ZM12.25 23.25C18.3251 23.25 23.25 18.3251 23.25 12.25H21.25C21.25 17.2206 17.2206 21.25 12.25 21.25V23.25ZM1.25 12.25C1.25 18.3251 6.17487 23.25 12.25 23.25V21.25C7.27944 21.25 3.25 17.2206 3.25 12.25H1.25ZM14 7.70459C14 6.73809 13.2165 5.95459 12.25 5.95459V7.95459C12.1119 7.95459 12 7.84266 12 7.70459H14ZM14 13.1591V7.70459H12V13.1591H14ZM12.25 14.9091C13.2165 14.9091 14 14.1256 14 13.1591H12C12 13.0211 12.1119 12.9091 12.25 12.9091V14.9091ZM10.5 13.1591C10.5 14.1256 11.2835 14.9091 12.25 14.9091V12.9091C12.3881 12.9091 12.5 13.0211 12.5 13.1591H10.5ZM10.5 7.70459V13.1591H12.5V7.70459H10.5ZM12.25 5.95459C11.2835 5.95459 10.5 6.73809 10.5 7.70459H12.5C12.5 7.84266 12.3881 7.95459 12.25 7.95459V5.95459ZM12.25 18.7954C13.3546 18.7954 14.25 17.9 14.25 16.7954H12.25V18.7954ZM10.25 16.7954C10.25 17.9 11.1454 18.7954 12.25 18.7954V16.7954H10.25ZM12.25 14.7954C11.1454 14.7954 10.25 15.6908 10.25 16.7954H12.25V14.7954ZM14.25 16.7954C14.25 15.6908 13.3546 14.7954 12.25 14.7954V16.7954H14.25Z",
          fill: "#82869E",
          mask: "url(#icon-ffiukdppn)"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 4247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CheckOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CheckOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 12.4545L9.375 17L19 7",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 676662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ CloseOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CloseOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.81304 5.75263C6.52015 5.45974 6.04528 5.45974 5.75238 5.75263C5.45949 6.04552 5.45949 6.5204 5.75238 6.81329L10.8789 11.9398L5.75241 17.0663C5.45952 17.3592 5.45952 17.8341 5.75241 18.127C6.0453 18.4199 6.52018 18.4199 6.81307 18.127L11.9396 13.0005L17.0661 18.127C17.359 18.4199 17.8339 18.4199 18.1268 18.127C18.4196 17.8341 18.4196 17.3592 18.1268 17.0663L13.0002 11.9398L18.1268 6.81329C18.4197 6.5204 18.4197 6.04552 18.1268 5.75263C17.8339 5.45974 17.359 5.45974 17.0661 5.75263L11.9396 10.8792L6.81304 5.75263Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 668809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ContactOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ContactOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_13160_9280)" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M13.1749 5.79081C12.9464 4.59089 12.368 3.444 11.4408 2.51557C8.97911 0.050801 4.98769 0.050801 2.52603 2.51557C1.77508 3.26746 1.11189 4.38045 0.821857 5.6161C0.530064 6.85924 0.610963 8.25565 1.39909 9.52545C1.43944 9.59046 1.4644 9.63071 1.48203 9.66086C1.49016 9.67478 1.49444 9.68269 1.49624 9.6861C1.49789 9.69047 1.4989 9.69347 1.49949 9.69538C1.49948 9.69763 1.49939 9.70145 1.49901 9.70725C1.49853 9.70991 1.4974 9.71585 1.4951 9.72594C1.48928 9.7518 1.4804 9.78631 1.46461 9.8473L1.46003 9.86504C1.36951 10.2147 1.29511 10.5021 1.25138 10.7343C1.20735 10.968 1.18189 11.2039 1.22871 11.4342C1.36223 12.0912 1.8751 12.6051 2.53201 12.7389C2.76246 12.7858 2.99838 12.7603 3.23188 12.7162C3.46385 12.6724 3.75093 12.5979 4.10011 12.5073L4.11782 12.5027C4.17874 12.4869 4.21322 12.478 4.23899 12.4722C4.24902 12.4699 4.25488 12.4688 4.25759 12.4683C4.26293 12.4679 4.26658 12.4678 4.26886 12.4677C4.27075 12.4684 4.27359 12.4694 4.27757 12.4708C4.28101 12.4727 4.28901 12.477 4.30303 12.4851C4.33338 12.5029 4.374 12.5279 4.43937 12.5684C4.86226 12.83 5.30241 13.0129 5.74828 13.1288C5.91369 13.3591 6.0997 13.5791 6.3062 13.7858C6.91464 14.395 7.8439 14.9479 8.87903 15.1958C9.92133 15.4454 11.1089 15.3932 12.1835 14.7283C12.2355 14.696 12.2674 14.6764 12.2909 14.6626C12.3096 14.6671 12.3354 14.6737 12.378 14.6847L12.3953 14.6892C12.6806 14.7633 12.9196 14.8253 13.1136 14.862C13.3091 14.8989 13.5175 14.9226 13.7247 14.8804C14.3013 14.7629 14.7513 14.3119 14.8685 13.7355C14.9106 13.5283 14.887 13.3201 14.8501 13.1243C14.8135 12.9301 14.7516 12.6909 14.6776 12.4052L14.6732 12.388C14.662 12.3447 14.6554 12.3189 14.6509 12.3001C14.6646 12.2767 14.6841 12.2451 14.7164 12.1931C15.3806 11.123 15.4476 9.94738 15.203 8.90542C14.9601 7.87097 14.4055 6.9396 13.7756 6.30888C13.5857 6.11885 13.3849 5.94612 13.1749 5.79081ZM10.7167 3.23867C8.6548 1.17412 5.31199 1.17412 3.25004 3.23867C2.62927 3.86022 2.06325 4.80529 1.81805 5.84993C1.5746 6.88707 1.65243 7.99322 2.2685 8.98578C2.27433 8.9952 2.28024 9.00468 2.28619 9.01423C2.34493 9.10851 2.40819 9.21008 2.44486 9.30224C2.50993 9.46583 2.53245 9.61386 2.519 9.78938C2.51144 9.88803 2.48493 9.98967 2.46165 10.079C2.45947 10.0874 2.45732 10.0956 2.45522 10.1037C2.35899 10.4754 2.29356 10.7294 2.25696 10.9236C2.21993 11.1203 2.22489 11.1981 2.23147 11.2305C2.28334 11.4856 2.48234 11.6845 2.73632 11.7362C2.76829 11.7427 2.84569 11.7478 3.04203 11.7107C3.23599 11.6741 3.48949 11.6086 3.86078 11.5122C3.86891 11.5101 3.87716 11.508 3.88552 11.5058C3.97463 11.4825 4.07621 11.4559 4.17458 11.4484C4.34993 11.4348 4.497 11.457 4.66048 11.5218C4.75247 11.5583 4.85435 11.6216 4.94909 11.6804C4.95873 11.6864 4.9683 11.6924 4.97778 11.6982C4.99643 11.7098 5.01511 11.7211 5.03383 11.7322C4.41698 9.89042 4.84074 7.77622 6.3062 6.30888C7.82493 4.78822 10.038 4.3875 11.9232 5.10602C11.6665 4.4253 11.2645 3.78702 10.7167 3.23867ZM12.4201 6.50997C10.7644 5.39025 8.49572 5.56467 7.0302 7.03196C5.57679 8.48725 5.39306 10.7341 6.48104 12.3887C6.63754 12.6267 6.8205 12.8527 7.0302 13.0627C7.50527 13.5383 8.26657 13.9969 9.11738 14.2007C9.96103 14.4027 10.8547 14.3471 11.645 13.8581C11.6529 13.8532 11.6609 13.8483 11.6692 13.8431C11.7453 13.7958 11.8367 13.739 11.9206 13.7057C12.068 13.6472 12.2029 13.6268 12.361 13.639C12.4506 13.646 12.5424 13.6701 12.6143 13.6889C12.6214 13.6907 12.6284 13.6926 12.6351 13.6943C12.9421 13.774 13.1474 13.827 13.3034 13.8564C13.4619 13.8863 13.5116 13.8795 13.5204 13.8777C13.694 13.8423 13.8303 13.7064 13.8657 13.5317C13.8676 13.5225 13.8744 13.4724 13.8445 13.3137C13.815 13.1574 13.7621 12.9517 13.6826 12.6444C13.6808 12.6377 13.679 12.6307 13.6771 12.6236C13.6583 12.5516 13.6343 12.4596 13.6274 12.3698C13.6153 12.2115 13.6359 12.0758 13.6946 11.9283C13.728 11.8443 13.7849 11.7532 13.8321 11.6774C13.8372 11.6693 13.8422 11.6613 13.847 11.6535C14.3392 10.8605 14.403 9.97521 14.2068 9.13927C14.0088 8.29583 13.5513 7.53234 13.0515 7.03196C12.8541 6.83427 12.6425 6.66038 12.4201 6.50997Z",
              fill: "#0200BC"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M8 9.36426C8.37675 9.36428 8.68262 9.67012 8.68262 10.0469C8.68247 10.4235 8.37666 10.7285 8 10.7285C7.62333 10.7285 7.31753 10.4235 7.31738 10.0469C7.31738 9.67011 7.62323 9.36426 8 9.36426ZM10.0469 9.36426C10.4235 9.36445 10.7285 9.67023 10.7285 10.0469C10.7284 10.4234 10.4234 10.7283 10.0469 10.7285C9.6702 10.7285 9.36441 10.4235 9.36426 10.0469C9.36426 9.67011 9.67011 9.36426 10.0469 9.36426ZM12.0928 9.36426C12.4695 9.36426 12.7754 9.67011 12.7754 10.0469C12.7752 10.4235 12.4694 10.7285 12.0928 10.7285C11.7162 10.7284 11.4113 10.4234 11.4111 10.0469C11.4111 9.67019 11.7161 9.36439 12.0928 9.36426Z",
              fill: "#0200BC"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_13160_9280" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 379126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ DeleteCircleColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DeleteCircleColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
          fill: "#DFDFE6"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.90045 8.64594C9.60755 8.35305 9.13268 8.35305 8.83979 8.64594C8.54689 8.93883 8.54689 9.41371 8.83979 9.7066L11.0765 11.9433L8.83997 14.1798C8.54707 14.4727 8.54707 14.9476 8.83997 15.2405C9.13286 15.5334 9.60773 15.5334 9.90063 15.2405L12.1371 13.004L14.3737 15.2405C14.6666 15.5334 15.1414 15.5334 15.4343 15.2405C15.7272 14.9476 15.7272 14.4727 15.4343 14.1798L13.1978 11.9433L15.4345 9.7066C15.7274 9.41371 15.7274 8.93883 15.4345 8.64594C15.1416 8.35305 14.6667 8.35305 14.3738 8.64594L12.1371 10.8826L9.90045 8.64594Z",
          fill: "white"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 252661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ DeleteCircleFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DeleteCircleFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM8.83979 8.64594C9.13268 8.35305 9.60755 8.35305 9.90045 8.64594L12.1371 10.8826L14.3738 8.64594C14.6667 8.35305 15.1416 8.35305 15.4345 8.64594C15.7274 8.93883 15.7274 9.41371 15.4345 9.7066L13.1978 11.9433L15.4343 14.1798C15.7272 14.4727 15.7272 14.9476 15.4343 15.2405C15.1414 15.5334 14.6666 15.5334 14.3737 15.2405L12.1371 13.004L9.90063 15.2405C9.60773 15.5334 9.13286 15.5334 8.83997 15.2405C8.54707 14.9476 8.54707 14.4727 8.83997 14.1798L11.0765 11.9433L8.83979 9.7066C8.54689 9.41371 8.54689 8.93883 8.83979 8.64594Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 925810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DownOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const DownOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M5 8.5L12 15.5L19 8.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 476127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ EditOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const EditOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.4798 5.35373C14.968 4.86557 15.7594 4.86557 16.2476 5.35373L16.6919 5.79803C17.1801 6.28618 17.1801 7.07764 16.6919 7.56579L16.1819 8.07582L13.9698 5.86375L14.4798 5.35373ZM12.9092 6.92441L6.23644 13.5971L5.68342 16.3622L8.44851 15.8092L15.1212 9.13648L12.9092 6.92441ZM16.707 9.67199L9.3486 17.0304C9.24389 17.1351 9.11055 17.2065 8.96535 17.2355L4.87444 18.0537C4.62855 18.1029 4.37434 18.0259 4.19703 17.8486C4.01971 17.6713 3.94274 17.4171 3.99192 17.1712L4.8101 13.0803C4.83914 12.9351 4.91051 12.8017 5.01521 12.697L13.4192 4.29307C14.4931 3.21912 16.2343 3.21912 17.3083 4.29307L17.7526 4.73737C18.8265 5.81131 18.8265 7.55251 17.7526 8.62645L16.7174 9.66162C16.7157 9.66336 16.714 9.6651 16.7122 9.66683C16.7105 9.66856 16.7088 9.67028 16.707 9.67199ZM3.15918 20.5908C3.15918 20.1766 3.49497 19.8408 3.90918 19.8408H20.2728C20.687 19.8408 21.0228 20.1766 21.0228 20.5908C21.0228 21.005 20.687 21.3408 20.2728 21.3408H3.90918C3.49497 21.3408 3.15918 21.005 3.15918 20.5908Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 512495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ FavouriteAlternativeOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FavouriteAlternativeOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5.75C16.6307 5.75 17.5345 6.15409 18.1899 6.80453C18.8431 7.45286 19.25 8.34674 19.25 9.33095C19.25 12.4832 14.6986 16.7712 12.6212 18.6318C12.444 18.7906 12.2221 18.8704 11.9999 18.8704C11.7775 18.8704 11.5553 18.7904 11.3778 18.6316C9.30052 16.7712 4.75 12.4832 4.75 9.33095C4.75 8.34674 5.15687 7.45286 5.81012 6.80453C6.46549 6.15409 7.36934 5.75 8.36379 5.75C9.63426 5.75 10.7192 6.417 11.3835 7.3758C11.6822 7.80686 11.8958 8.29678 12 8.8134C12.1041 8.29665 12.3178 7.80686 12.6165 7.3758C13.2808 6.417 14.365 5.75 15.6362 5.75Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 728873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ FavouriteFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const FavouriteFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.6362 5C14.1086 5 12.8 5.79411 12 6.94863C11.2 5.79411 9.89053 5 8.36379 5C5.96379 5 4 6.94863 4 9.33095C4 12.6413 8.67537 17.2181 10.8775 19.1903C11.5183 19.7638 12.4817 19.7638 13.1217 19.1903C15.3238 17.2181 20 12.6413 20 9.33095C20 6.94863 18.0362 5 15.6362 5Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 966212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ HomeLocationColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomeLocationColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_721_17546)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M16 6.48252V12.6665C15.9989 13.5503 15.6474 14.3975 15.0225 15.0224C14.3976 15.6473 13.5504 15.9988 12.6667 15.9999H12C11.8232 15.9999 11.6536 15.9296 11.5286 15.8046C11.4036 15.6796 11.3333 15.51 11.3333 15.3332C11.3333 15.1564 11.4036 14.9868 11.5286 14.8618C11.6536 14.7368 11.8232 14.6665 12 14.6665H12.6667C13.1971 14.6665 13.7058 14.4558 14.0809 14.0807C14.456 13.7057 14.6667 13.197 14.6667 12.6665V6.48252C14.6667 6.15514 14.5863 5.83275 14.4327 5.54366C14.279 5.25458 14.0567 5.00764 13.7853 4.82452L9.11867 1.67586C8.78892 1.45106 8.39909 1.33083 8 1.33083C7.60092 1.33083 7.21109 1.45106 6.88134 1.67586L2.21467 4.82452C1.94328 5.00764 1.721 5.25458 1.56733 5.54366C1.41367 5.83275 1.33332 6.15514 1.33334 6.48252V12.6665C1.33334 13.197 1.54405 13.7057 1.91912 14.0807C2.2942 14.4558 2.8029 14.6665 3.33334 14.6665H4C4.17681 14.6665 4.34638 14.7368 4.47141 14.8618C4.59643 14.9868 4.66667 15.1564 4.66667 15.3332C4.66667 15.51 4.59643 15.6796 4.47141 15.8046C4.34638 15.9296 4.17681 15.9999 4 15.9999H3.33334C2.44961 15.9988 1.60237 15.6473 0.977483 15.0224C0.352591 14.3975 0.00106118 13.5503 2.61138e-06 12.6665V6.48252C-0.000680639 5.937 0.132722 5.39967 0.388472 4.91782C0.644222 4.43596 1.01448 4.02434 1.46667 3.71919L6.13334 0.569856C6.68351 0.196491 7.3331 -0.00311279 7.998 -0.00311279C8.6629 -0.00311279 9.3125 0.196491 9.86267 0.569856L14.5293 3.71919C14.982 4.02419 15.3528 4.43566 15.6092 4.91748C15.8656 5.3993 15.9998 5.93672 16 6.48252Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.314 11.7911C12.5486 11.2248 12.6685 10.6175 12.6668 10.0045C12.6669 9.23675 12.4775 8.48084 12.1155 7.80379C11.7535 7.12673 11.23 6.54945 10.5915 6.12312C9.95299 5.69679 9.21916 5.43459 8.45505 5.35975C7.69095 5.28491 6.92018 5.39975 6.21109 5.69409C5.50199 5.98843 4.87646 6.45317 4.38997 7.04712C3.90347 7.64107 3.57103 8.34588 3.42212 9.09906C3.2732 9.85224 3.31242 10.6305 3.53629 11.3649C3.76016 12.0993 4.16176 12.7671 4.7055 13.3092L7.0435 15.5958C7.30003 15.8442 7.6431 15.9831 8.00016 15.9831C8.35723 15.9831 8.7003 15.8442 8.95683 15.5958L11.3002 13.3038C11.7348 12.8716 12.0794 12.3574 12.314 11.7911ZM11.3335 10.0045C11.3335 9.45636 11.1983 8.91667 10.9399 8.43323C10.6816 7.94979 10.3079 7.53754 9.85218 7.23298C9.39642 6.92843 8.87259 6.74097 8.32708 6.68721C7.78157 6.63345 7.23122 6.71505 6.72478 6.92478C6.21833 7.13451 5.77143 7.4659 5.42365 7.8896C5.07587 8.3133 4.83794 8.81622 4.73095 9.35383C4.62395 9.89144 4.65119 10.4471 4.81025 10.9717C4.96931 11.4963 5.25528 11.9735 5.64283 12.3612L7.97616 14.6425L10.3628 12.3558C10.6719 12.0475 10.9168 11.6809 11.0834 11.2773C11.25 10.8737 11.335 10.4411 11.3335 10.0045Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.6631 11.111C9.88287 10.7821 10.0002 10.3954 10.0002 9.99985C10.0002 9.46941 9.78945 8.96071 9.41438 8.58563C9.03931 8.21056 8.5306 7.99985 8.00016 7.99985C7.6046 7.99985 7.21792 8.11715 6.88902 8.33691C6.56012 8.55667 6.30378 8.86903 6.1524 9.23448C6.00103 9.59993 5.96142 10.0021 6.03859 10.39C6.11576 10.778 6.30624 11.1344 6.58595 11.4141C6.86565 11.6938 7.22202 11.8842 7.60998 11.9614C7.99794 12.0386 8.40008 11.999 8.76553 11.8476C9.13098 11.6962 9.44334 11.4399 9.6631 11.111Z",
              fill: "#00973C"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_721_17546" },
            child: [
              {
                tag: "rect",
                attr: { width: "16", height: "16", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 767054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ HomeLocationOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const HomeLocationOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 17", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_721_18581)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M16 7.46024V13.6442C15.9989 14.528 15.6474 15.3752 15.0225 16.0001C14.3976 16.625 13.5504 16.9765 12.6667 16.9776H12C11.8232 16.9776 11.6536 16.9073 11.5286 16.7823C11.4036 16.6573 11.3333 16.4877 11.3333 16.3109C11.3333 16.1341 11.4036 15.9645 11.5286 15.8395C11.6536 15.7145 11.8232 15.6442 12 15.6442H12.6667C13.1971 15.6442 13.7058 15.4335 14.0809 15.0585C14.456 14.6834 14.6667 14.1747 14.6667 13.6442V7.46024C14.6667 7.13286 14.5863 6.81047 14.4327 6.52139C14.279 6.2323 14.0567 5.98536 13.7853 5.80224L9.11867 2.65358C8.78892 2.42878 8.39909 2.30855 8 2.30855C7.60092 2.30855 7.21109 2.42878 6.88134 2.65358L2.21467 5.80224C1.94328 5.98536 1.721 6.2323 1.56733 6.52139C1.41367 6.81047 1.33332 7.13286 1.33334 7.46024V13.6442C1.33334 14.1747 1.54405 14.6834 1.91912 15.0585C2.2942 15.4335 2.8029 15.6442 3.33334 15.6442H4C4.17681 15.6442 4.34638 15.7145 4.47141 15.8395C4.59643 15.9645 4.66667 16.1341 4.66667 16.3109C4.66667 16.4877 4.59643 16.6573 4.47141 16.7823C4.34638 16.9073 4.17681 16.9776 4 16.9776H3.33334C2.44961 16.9765 1.60237 16.625 0.977483 16.0001C0.352591 15.3752 0.00106118 14.528 2.61138e-06 13.6442V7.46024C-0.000680639 6.91472 0.132722 6.37739 0.388472 5.89554C0.644222 5.41368 1.01448 5.00207 1.46667 4.69691L6.13334 1.54758C6.68351 1.17421 7.3331 0.974609 7.998 0.974609C8.6629 0.974609 9.3125 1.17421 9.86267 1.54758L14.5293 4.69691C14.982 5.00191 15.3528 5.41339 15.6092 5.89521C15.8656 6.37702 15.9998 6.91444 16 7.46024Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.3138 12.7685C12.5484 12.2022 12.6683 11.5949 12.6666 10.9819C12.6666 10.2142 12.4773 9.45826 12.1153 8.7812C11.7532 8.10415 11.2298 7.52687 10.5913 7.10054C9.95275 6.67421 9.21891 6.412 8.45481 6.33717C7.69071 6.26233 6.91994 6.37717 6.21084 6.67151C5.50174 6.96585 4.87622 7.43059 4.38972 8.02454C3.90322 8.61849 3.57078 9.3233 3.42187 10.0765C3.27296 10.8297 3.31218 11.6079 3.53604 12.3423C3.75991 13.0767 4.16152 13.7446 4.70525 14.2866L7.04325 16.5733C7.29978 16.8216 7.64285 16.9605 7.99992 16.9605C8.35699 16.9605 8.70006 16.8216 8.95659 16.5733L11.2999 14.2813C11.7346 13.849 12.0792 13.3349 12.3138 12.7685ZM11.3333 10.9819C11.3333 10.4338 11.1981 9.89408 10.9397 9.41065C10.6813 8.92721 10.3077 8.51496 9.85194 8.2104C9.39618 7.90584 8.87235 7.71838 8.32684 7.66462C7.78132 7.61086 7.23097 7.69246 6.72453 7.9022C6.21809 8.11193 5.77118 8.44332 5.4234 8.86702C5.07562 9.29071 4.8377 9.79364 4.7307 10.3313C4.62371 10.8689 4.65095 11.4246 4.81 11.9491C4.96906 12.4737 5.25503 12.9509 5.64259 13.3386L7.97592 15.6199L10.3626 13.3333C10.6717 13.0249 10.9166 12.6583 11.0832 12.2547C11.2498 11.8511 11.3348 11.4185 11.3333 10.9819Z",
              fill: "black"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9.66286 12.0884C9.88262 11.7595 9.99992 11.3728 9.99992 10.9773C9.99992 10.4468 9.78921 9.93812 9.41413 9.56305C9.03906 9.18798 8.53035 8.97726 7.99992 8.97726C7.60436 8.97726 7.21768 9.09456 6.88878 9.31433C6.55988 9.53409 6.30354 9.84645 6.15216 10.2119C6.00078 10.5774 5.96118 10.9795 6.03835 11.3674C6.11552 11.7554 6.306 12.1118 6.58571 12.3915C6.86541 12.6712 7.22178 12.8617 7.60974 12.9388C7.9977 13.016 8.39983 12.9764 8.76529 12.825C9.13074 12.6736 9.4431 12.4173 9.66286 12.0884Z",
              fill: "black"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_721_18581" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "16",
                  height: "16",
                  fill: "white",
                  transform: "translate(0 0.977539)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 628382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ InforOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const InforOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-jbyh1ifk0", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2954C11.5858 17.2954 11.25 16.9596 11.25 16.5454V11.0909C11.25 10.6767 11.5858 10.3409 12 10.3409C12.4142 10.3409 12.75 10.6767 12.75 11.0909V16.5454C12.75 16.9596 12.4142 17.2954 12 17.2954ZM11 7.45459C11 6.90231 11.4477 6.45459 12 6.45459C12.5523 6.45459 13 6.90231 13 7.45459C13 8.00687 12.5523 8.45459 12 8.45459C11.4477 8.45459 11 8.00687 11 7.45459Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.2954C11.5858 17.2954 11.25 16.9596 11.25 16.5454V11.0909C11.25 10.6767 11.5858 10.3409 12 10.3409C12.4142 10.3409 12.75 10.6767 12.75 11.0909V16.5454C12.75 16.9596 12.4142 17.2954 12 17.2954ZM11 7.45459C11 6.90231 11.4477 6.45459 12 6.45459C12.5523 6.45459 13 6.90231 13 7.45459C13 8.00687 12.5523 8.45459 12 8.45459C11.4477 8.45459 11 8.00687 11 7.45459Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5V21.5C17.2467 21.5 21.5 17.2467 21.5 12H19.5ZM12 4.5C16.1421 4.5 19.5 7.85786 19.5 12H21.5C21.5 6.75329 17.2467 2.5 12 2.5V4.5ZM4.5 12C4.5 7.85786 7.85786 4.5 12 4.5V2.5C6.75329 2.5 2.5 6.75329 2.5 12H4.5ZM12 19.5C7.85786 19.5 4.5 16.1421 4.5 12H2.5C2.5 17.2467 6.75329 21.5 12 21.5V19.5ZM12 23C18.0751 23 23 18.0751 23 12H21C21 16.9706 16.9706 21 12 21V23ZM1 12C1 18.0751 5.92487 23 12 23V21C7.02944 21 3 16.9706 3 12H1ZM12 1C5.92487 1 1 5.92487 1 12H3C3 7.02944 7.02944 3 12 3V1ZM23 12C23 5.92487 18.0751 1 12 1V3C16.9706 3 21 7.02944 21 12H23ZM10.25 16.5454C10.25 17.5119 11.0335 18.2954 12 18.2954V16.2954C12.1381 16.2954 12.25 16.4073 12.25 16.5454H10.25ZM10.25 11.0909V16.5454H12.25V11.0909H10.25ZM12 9.34086C11.0335 9.34086 10.25 10.1244 10.25 11.0909H12.25C12.25 11.2289 12.1381 11.3409 12 11.3409V9.34086ZM13.75 11.0909C13.75 10.1244 12.9665 9.34086 12 9.34086V11.3409C11.8619 11.3409 11.75 11.2289 11.75 11.0909H13.75ZM13.75 16.5454V11.0909H11.75V16.5454H13.75ZM12 18.2954C12.9665 18.2954 13.75 17.5119 13.75 16.5454H11.75C11.75 16.4073 11.8619 16.2954 12 16.2954V18.2954ZM12 5.45459C10.8954 5.45459 10 6.35002 10 7.45459H12V5.45459ZM14 7.45459C14 6.35002 13.1046 5.45459 12 5.45459V7.45459H14ZM12 9.45459C13.1046 9.45459 14 8.55916 14 7.45459H12V9.45459ZM10 7.45459C10 8.55916 10.8954 9.45459 12 9.45459V7.45459H10Z",
          fill: "#82869E",
          mask: "url(#icon-jbyh1ifk0)"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 149933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ LeftOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const LeftOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.5002 4.99988L8.50024 11.9999L15.5002 18.9999",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 985481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ LocationColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const LocationColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M9.32467 4.072C9.29867 4.07933 4.506 5.98133 4.506 5.98133C4.14966 6.12031 3.84548 6.36689 3.63578 6.68676C3.42607 7.00664 3.32127 7.38392 3.33593 7.76613C3.3506 8.14833 3.48401 8.51647 3.71761 8.81933C3.95121 9.1222 4.27339 9.34474 4.63934 9.456L6.20334 9.84733L6.71867 11.53C6.85578 11.8663 7.09007 12.1541 7.39158 12.3566C7.6931 12.5591 8.04815 12.667 8.41134 12.6667H8.44067C8.80937 12.6619 9.16799 12.5456 9.4693 12.3331C9.77061 12.1205 10.0005 11.8217 10.1287 11.476C10.1287 11.476 11.924 6.69933 11.9287 6.676C12.0232 6.31558 12.0217 5.93667 11.9243 5.57701C11.8269 5.21735 11.637 4.88948 11.3735 4.62603C11.1099 4.36258 10.782 4.17275 10.4223 4.07543C10.0626 3.97811 9.68374 3.9767 9.32334 4.07133L9.32467 4.072ZM10.6467 6.31133L8.88134 11.0067C8.84735 11.1019 8.78482 11.1844 8.70227 11.2429C8.61972 11.3013 8.52115 11.3329 8.42 11.3333C8.35334 11.3253 8.07 11.316 7.97 11.0813L7.36467 9.09733C7.33122 8.98729 7.26987 8.88777 7.18657 8.80845C7.10328 8.72913 7.00089 8.67271 6.88934 8.64467L5.01067 8.178C4.91179 8.14435 4.82569 8.08105 4.76409 7.99671C4.70248 7.91236 4.66838 7.81108 4.66641 7.70665C4.66444 7.60222 4.69471 7.49973 4.75309 7.41312C4.81147 7.32652 4.89513 7.26001 4.99267 7.22267L9.69934 5.356C9.82896 5.32504 9.96442 5.32844 10.0923 5.36585C10.2202 5.40327 10.3362 5.4734 10.4287 5.56933C10.5253 5.66414 10.596 5.78209 10.6342 5.91197C10.6724 6.04185 10.6767 6.17933 10.6467 6.31133ZM8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0V0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.84081 10.5512C1.33622 9.33305 1.2042 7.99261 1.46144 6.6994C1.71867 5.40619 2.35361 4.21831 3.28596 3.28596C4.21831 2.35361 5.4062 1.71867 6.6994 1.46143C7.99261 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76752 14.6647 8 14.6667Z",
          fill: "#0200BC"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 402374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ LocationOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const LocationOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.6957 2.75C9.09299 2.75 6.35871 4.72035 6.35871 8.08696C6.35871 8.84669 6.67432 9.80604 7.22598 10.8727C7.76947 11.9236 8.50271 13.0046 9.24942 13.9876C9.99415 14.968 10.7407 15.8358 11.302 16.4592C11.4469 16.6202 11.5792 16.7646 11.6957 16.8901C11.8121 16.7646 11.9444 16.6202 12.0894 16.4592C12.6506 15.8358 13.3972 14.968 14.1419 13.9876C14.8886 13.0046 15.6219 11.9236 16.1654 10.8727C16.717 9.80604 17.0326 8.84669 17.0326 8.08696C17.0326 4.72035 14.2983 2.75 11.6957 2.75ZM11.6957 17.9783C11.1633 18.5065 11.1632 18.5064 11.163 18.5063L11.1627 18.5059L11.1615 18.5048L11.1576 18.5008L11.1432 18.4862L11.0896 18.4313C11.0432 18.3835 10.9758 18.3138 10.8905 18.2241C10.72 18.0447 10.4776 17.7854 10.1872 17.4628C9.60714 16.8185 8.83197 15.9178 8.05496 14.895C7.27993 13.8747 6.49143 12.7177 5.89362 11.5618C5.30398 10.4217 4.85871 9.20548 4.85871 8.08696C4.85871 3.74922 8.41486 1.25 11.6957 1.25C14.9765 1.25 18.5326 3.74922 18.5326 8.08696C18.5326 9.20548 18.0874 10.4217 17.4977 11.5618C16.8999 12.7177 16.1114 13.8747 15.3364 14.895C14.5594 15.9178 13.7842 16.8185 13.2041 17.4628C12.9137 17.7854 12.6713 18.0447 12.5008 18.2241C12.4155 18.3138 12.3482 18.3835 12.3017 18.4313L12.2481 18.4862L12.2338 18.5008L12.2298 18.5048L12.2287 18.5059L12.2283 18.5063C12.2282 18.5064 12.2281 18.5065 11.6957 17.9783ZM11.6957 17.9783L12.2281 18.5065C12.0873 18.6484 11.8956 18.7283 11.6957 18.7283C11.4957 18.7283 11.3041 18.6484 11.1633 18.5065L11.6957 17.9783ZM17.4472 15.2423C17.8177 15.057 18.2682 15.2072 18.4534 15.5777L20.3385 19.3479C20.9203 20.5114 20.0742 21.8805 18.7733 21.8805H4.61804C3.31712 21.8805 2.47101 20.5114 3.05279 19.3479L4.93788 15.5777C5.12313 15.2072 5.57363 15.057 5.94411 15.2423C6.3146 15.4275 6.46477 15.878 6.27952 16.2485L4.39443 20.0187C4.31132 20.1849 4.4322 20.3805 4.61804 20.3805H18.7733C18.9591 20.3805 19.08 20.1849 18.9969 20.0187L17.1118 16.2485C16.9266 15.878 17.0767 15.4275 17.4472 15.2423ZM10.7065 8.08679C10.7065 7.5405 11.1494 7.09766 11.6957 7.09766C12.2419 7.09766 12.6848 7.54051 12.6848 8.08679C12.6848 8.63307 12.2419 9.07592 11.6957 9.07592C11.1494 9.07592 10.7065 8.63307 10.7065 8.08679ZM11.6957 5.59766C10.321 5.59766 9.20654 6.71208 9.20654 8.08679C9.20654 9.4615 10.321 10.5759 11.6957 10.5759C13.0704 10.5759 14.1848 9.4615 14.1848 8.08679C14.1848 6.71208 13.0704 5.59766 11.6957 5.59766Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 957518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ MinusOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const MinusOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H20C20.4142 11.25 20.75 11.5858 20.75 12C20.75 12.4142 20.4142 12.75 20 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 844452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ NavigationOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NavigationOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 17", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_721_18574)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M9.32467 5.04954C9.29867 5.05687 4.506 6.95887 4.506 6.95887C4.14966 7.09785 3.84548 7.34443 3.63578 7.6643C3.42607 7.98418 3.32127 8.36146 3.33593 8.74366C3.3506 9.12587 3.48401 9.49401 3.71761 9.79687C3.95121 10.0997 4.27339 10.3223 4.63934 10.4335L6.20334 10.8249L6.71867 12.5075C6.85578 12.8439 7.09007 13.1316 7.39158 13.3341C7.6931 13.5366 8.04815 13.6446 8.41134 13.6442H8.44067C8.80937 13.6395 9.16799 13.5232 9.4693 13.3106C9.77061 13.0981 10.0005 12.7993 10.1287 12.4535C10.1287 12.4535 11.924 7.67687 11.9287 7.65354C12.0232 7.29311 12.0217 6.91421 11.9243 6.55455C11.8269 6.19489 11.637 5.86702 11.3735 5.60357C11.1099 5.34012 10.782 5.15029 10.4223 5.05297C10.0626 4.95565 9.68374 4.95424 9.32334 5.04887L9.32467 5.04954ZM10.6467 7.28887L8.88134 11.9842C8.84735 12.0795 8.78482 12.162 8.70227 12.2204C8.61972 12.2789 8.52115 12.3105 8.42 12.3109C8.35334 12.3029 8.07 12.2935 7.97 12.0589L7.36467 10.0749C7.33122 9.96483 7.26987 9.86531 7.18657 9.78599C7.10328 9.70667 7.00089 9.65025 6.88934 9.62221L5.01067 9.15554C4.91179 9.12189 4.82569 9.05859 4.76409 8.97424C4.70248 8.8899 4.66838 8.78862 4.66641 8.68419C4.66444 8.57976 4.69471 8.47727 4.75309 8.39066C4.81147 8.30406 4.89513 8.23755 4.99267 8.20021L9.69934 6.33354C9.82896 6.30258 9.96442 6.30598 10.0923 6.34339C10.2202 6.38081 10.3362 6.45094 10.4287 6.54687C10.5253 6.64168 10.596 6.75963 10.6342 6.88951C10.6724 7.01939 10.6767 7.15687 10.6467 7.28887ZM8 0.977539C6.41775 0.977539 4.87104 1.44673 3.55544 2.32578C2.23985 3.20483 1.21447 4.45426 0.608967 5.91607C0.00346629 7.37788 -0.15496 8.98641 0.153721 10.5383C0.462403 12.0901 1.22433 13.5156 2.34315 14.6344C3.46197 15.7532 4.88743 16.5151 6.43928 16.8238C7.99113 17.1325 9.59966 16.9741 11.0615 16.3686C12.5233 15.7631 13.7727 14.7377 14.6518 13.4221C15.5308 12.1065 16 10.5598 16 8.97754C15.9977 6.85651 15.1541 4.82301 13.6543 3.32322C12.1545 1.82342 10.121 0.979833 8 0.977539V0.977539ZM8 15.6442C6.68146 15.6442 5.39253 15.2532 4.2962 14.5207C3.19987 13.7881 2.34539 12.7469 1.84081 11.5288C1.33622 10.3106 1.2042 8.97014 1.46144 7.67694C1.71867 6.38373 2.35361 5.19584 3.28596 4.26349C4.21831 3.33114 5.4062 2.69621 6.6994 2.43897C7.99261 2.18174 9.33305 2.31376 10.5512 2.81834C11.7694 3.32293 12.8106 4.17741 13.5431 5.27374C14.2757 6.37007 14.6667 7.659 14.6667 8.97754C14.6647 10.7451 13.9617 12.4396 12.7119 13.6894C11.4621 14.9393 9.76752 15.6423 8 15.6442Z",
              fill: "#0200BC"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_721_18574" },
            child: [
              {
                tag: "rect",
                attr: {
                  width: "16",
                  height: "16",
                  fill: "white",
                  transform: "translate(0 0.977539)"
                }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 319027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PenColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PenColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.2353 0.765364C14.7821 0.312828 14.1678 0.0586548 13.5273 0.0586548C12.8869 0.0586548 12.2726 0.312828 11.8193 0.765364L0.976677 11.608C0.666178 11.9168 0.419985 12.284 0.252342 12.6886C0.0846994 13.0931 -0.00106532 13.5268 9.98748e-06 13.9647V15.3334C9.98748e-06 15.5102 0.0702479 15.6797 0.195272 15.8048C0.320296 15.9298 0.489866 16 0.666677 16H2.03534C2.47319 16.0013 2.90692 15.9156 3.31145 15.7481C3.71597 15.5806 4.08325 15.3345 4.39201 15.024L15.2353 4.1807C15.6877 3.72749 15.9417 3.11334 15.9417 2.47303C15.9417 1.83272 15.6877 1.21857 15.2353 0.765364ZM3.44934 14.0814C3.07335 14.4549 2.56532 14.6652 2.03534 14.6667H1.33334V13.9647C1.33267 13.702 1.38411 13.4417 1.4847 13.199C1.58529 12.9563 1.73302 12.7359 1.91934 12.5507L10.148 4.32203L11.6813 5.85536L3.44934 14.0814ZM14.292 3.23803L12.6213 4.90936L11.088 3.37936L12.7593 1.70803C12.86 1.60757 12.9795 1.52792 13.111 1.47364C13.2424 1.41935 13.3833 1.39149 13.5255 1.39164C13.6678 1.3918 13.8086 1.41997 13.9399 1.47454C14.0712 1.52911 14.1905 1.60902 14.291 1.7097C14.3915 1.81038 14.4711 1.92986 14.5254 2.06132C14.5797 2.19278 14.6076 2.33365 14.6074 2.47588C14.6072 2.6181 14.5791 2.75891 14.5245 2.89025C14.4699 3.02159 14.39 3.1409 14.2893 3.24136L14.292 3.23803Z",
          fill: "#0200BC"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 181466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PencilOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const PencilOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.2353 0.742842C14.7821 0.290306 14.1678 0.0361328 13.5273 0.0361328C12.8869 0.0361328 12.2726 0.290306 11.8193 0.742842L0.976677 11.5855C0.666178 11.8943 0.419985 12.2615 0.252342 12.666C0.0846994 13.0706 -0.00106532 13.5043 9.98748e-06 13.9422V15.3108C9.98748e-06 15.4877 0.0702479 15.6572 0.195272 15.7822C0.320296 15.9073 0.489866 15.9775 0.666677 15.9775H2.03534C2.47319 15.9787 2.90692 15.8931 3.31145 15.7256C3.71597 15.5581 4.08325 15.3119 4.39201 15.0015L15.2353 4.15817C15.6877 3.70497 15.9417 3.09082 15.9417 2.45051C15.9417 1.8102 15.6877 1.19604 15.2353 0.742842ZM3.44934 14.0588C3.07335 14.4323 2.56532 14.6426 2.03534 14.6442H1.33334V13.9422C1.33267 13.6794 1.38411 13.4192 1.4847 13.1765C1.58529 12.9338 1.73302 12.7134 1.91934 12.5282L10.148 4.29951L11.6813 5.83284L3.44934 14.0588ZM14.292 3.21551L12.6213 4.88684L11.088 3.35684L12.7593 1.68551C12.86 1.58505 12.9795 1.5054 13.111 1.45111C13.2424 1.39683 13.3833 1.36897 13.5255 1.36912C13.6678 1.36928 13.8086 1.39744 13.9399 1.45202C14.0712 1.50659 14.1905 1.58649 14.291 1.68717C14.3915 1.78785 14.4711 1.90734 14.5254 2.0388C14.5797 2.17026 14.6076 2.31112 14.6074 2.45335C14.6072 2.59558 14.5791 2.73639 14.5245 2.86773C14.4699 2.99907 14.39 3.11838 14.2893 3.21884L14.292 3.21551Z",
          fill: "#0200BC"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 825078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RatingFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RatingFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.1958 18.4749C12.0707 18.4217 11.9293 18.4217 11.8042 18.4749L6.58683 20.6947C6.23942 20.8425 5.8598 20.5667 5.89302 20.1906L6.39193 14.5426C6.40389 14.4072 6.36021 14.2728 6.27095 14.1703L2.5475 9.89418C2.29956 9.60945 2.44457 9.16318 2.81251 9.07856L8.33827 7.80772C8.47074 7.77725 8.58509 7.69417 8.655 7.5776L11.5712 2.715C11.7654 2.39121 12.2346 2.39121 12.4288 2.715L15.345 7.5776C15.4149 7.69417 15.5293 7.77725 15.6617 7.80772L21.1875 9.07856C21.5554 9.16318 21.7004 9.60945 21.4525 9.89419L17.729 14.1703C17.6398 14.2728 17.5961 14.4072 17.6081 14.5426L18.107 20.1906C18.1402 20.5667 17.7606 20.8425 17.4132 20.6947L12.1958 18.4749Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 877936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ SearchOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const SearchOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.5 10.5508C5.5 7.7613 7.7613 5.5 10.5507 5.5C13.3402 5.5 15.6015 7.7613 15.6015 10.5508C15.6015 11.9258 15.052 13.1725 14.1607 14.0832C14.147 14.0951 14.1336 14.1076 14.1206 14.1206C14.1075 14.1336 14.0951 14.147 14.0832 14.1607C13.1724 15.0521 11.9258 15.6015 10.5507 15.6015C7.7613 15.6015 5.5 13.3402 5.5 10.5508ZM14.6222 15.6829C13.5042 16.571 12.0894 17.1015 10.5507 17.1015C6.93286 17.1015 4 14.1686 4 10.5508C4 6.93288 6.93286 4 10.5507 4C14.1686 4 17.1015 6.93288 17.1015 10.5508C17.1015 12.0895 16.571 13.5043 15.6829 14.6222L19.7812 18.7206C20.0741 19.0135 20.0741 19.4884 19.7812 19.7813C19.4883 20.0741 19.0134 20.0741 18.7205 19.7813L14.6222 15.6829Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 744383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ SuccessColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const SuccessColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "9", fill: "#30CD60" } },
      {
        tag: "path",
        attr: {
          d: "M15.371 9.20702L11.047 13.291L9.15068 11.499C8.85739 11.222 8.38306 11.222 8.08977 11.499C7.79755 11.775 7.79755 12.223 8.08977 12.5L10.5186 14.792C10.8098 15.068 11.2841 15.068 11.5774 14.792L16.4319 10.208C16.7242 9.93102 16.7242 9.48302 16.4319 9.20702C16.2858 9.06802 16.0931 8.99902 15.9015 8.99902C15.7098 8.99902 15.5182 9.06802 15.371 9.20702Z",
          fill: "white"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 994734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ UpOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UpOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M19 15.5L12 8.5L5 15.5",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 280114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ UsaColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UsaColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M24 4C24 3.4475 23.5525 3 23 3H10V13H0V20C0 20.5525 0.4475 21 1 21H23C23.5525 21 24 20.5525 24 20V4Z",
          fill: "#F83142"
        }
      },
      { tag: "path", attr: { d: "M24 5H10V7H24V5Z", fill: "white" } },
      { tag: "path", attr: { d: "M24 9H10V11H24V9Z", fill: "white" } },
      { tag: "path", attr: { d: "M0 13V15H24V13H10H0Z", fill: "white" } },
      { tag: "path", attr: { d: "M24 17H0V19H24V17Z", fill: "white" } },
      {
        tag: "path",
        attr: { d: "M10 13H0V4C0 3.4475 0.4475 3 1 3H10V13Z", fill: "#1435C3" }
      },
      {
        tag: "path",
        attr: {
          d: "M5.00008 6.96094L4.68358 7.64494H3.93158L4.48158 8.21494L4.27858 9.03894L5.00008 8.62994L5.72158 9.03894L5.51858 8.21494L6.06858 7.64494H5.31558L5.00008 6.96094Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.55341 4.5144L2.23741 5.1984H1.48541L2.03491 5.7684L1.83191 6.5924L2.55341 6.1834L3.27541 6.5924L3.07191 5.7684L3.62191 5.1984H2.86891L2.55341 4.5144Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.44655 4.5144L7.76255 5.1984H8.51455L7.96505 5.7684L8.16805 6.5924L7.44655 6.1834L6.72455 6.5924L6.92805 5.7684L6.37805 5.1984H7.13105L7.44655 4.5144Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.55341 11.4855L2.23741 10.8015H1.48541L2.03491 10.2315L1.83191 9.40747L2.55341 9.81647L3.27541 9.40747L3.07191 10.2315L3.62191 10.8015H2.86891L2.55341 11.4855Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.44655 11.4855L7.76255 10.8015H8.51455L7.96505 10.2315L8.16805 9.40747L7.44655 9.81647L6.72455 9.40747L6.92805 10.2315L6.37805 10.8015H7.13105L7.44655 11.4855Z",
          fill: "white"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 718024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ VietnamColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VietnamColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M24 20C24 20.5525 23.5525 21 23 21H1C0.4475 21 0 20.5525 0 20V4C0 3.4475 0.4475 3 1 3H23C23.5525 3 24 3.4475 24 4V20Z",
          fill: "#F83142"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.1803 10.5205H13.2348L11.9998 7.84204L10.7633 10.5205H7.81885L9.97035 12.747L9.17535 15.9735L11.9998 14.369L14.8238 15.9735L14.0288 12.747L16.1803 10.5205Z",
          fill: "#FFE040"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 404334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A0": function() { return /* binding */ IconBase; },
/* harmony export */   "uL": function() { return /* binding */ SvgCss; },
/* harmony export */   "w_": function() { return /* binding */ GenIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(310127);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Tree2Element(tree) {
  return tree && tree.map((node, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(node.tag, __spreadValues({ key: i }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  const IconWrapper = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconBase, __spreadValues({
    attr: __spreadValues({}, data.attr)
  }, props), Tree2Element(data.child));
  return IconWrapper;
}
function IconBase(props) {
  const elem = (conf) => {
    const computedSize = props.size || conf.size || "1em";
    let className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    const _a = props, { attr, color } = _a, svgProps = __objRest(_a, ["attr", "color"]);
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSVG, __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      fill: "currentColor",
      strokeWidth: props.strokeWidth ? typeof computedSize === "number" && computedSize >= 24 ? computedSize <= 40 ? 1.5 : 2 : 1 : void 0
    }, conf.attr), attr), svgProps), {
      className,
      style: __spreadValues(__spreadValues({}, conf.style), props.style),
      color,
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), props.children);
  };
  return _IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P !== void 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .IconContext.Consumer */ .P.Consumer, null, (conf) => elem(conf)) : elem(_IconContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .DefaultContext */ .x);
}
const SvgCss = ({ color, theme }) => {
  var _a, _b;
  return `
  path[stroke],
  rect[stroke],
  line {
    stroke: ${color ? ((_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a[color]) || color : ""};
  }
  path:not([stroke]),
  rect:not([stroke]) {
    fill: ${color ? ((_b = theme == null ? void 0 : theme.colors) == null ? void 0 : _b[color]) || color : ""};
  }
`;
};
const StyledSVG = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].svg`
  ${SvgCss};
`;




/***/ }),

/***/ 310127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ IconContext; },
/* harmony export */   "x": function() { return /* binding */ DefaultContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
const IconContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext && react__WEBPACK_IMPORTED_MODULE_0__.createContext(DefaultContext);




/***/ }),

/***/ 291692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ BottomActionBar; },
/* harmony export */   "S": function() { return /* binding */ BottomNavigationBar; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledNavigation = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F};
  display: flex;
  flex-direction: row;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: env(safe-area-inset-bottom);
  transition: bottom 0.4s;
  z-index: ${(p) => p.zIndex || 1060};
`;
const BottomNavigationBar = (_a) => {
  var _b = _a, {
    zIndex,
    children
  } = _b, rest = __objRest(_b, [
    "zIndex",
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledNavigation, __spreadValues({
    zIndex
  }, rest), children);
};
const BottomActionBar = (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"])(BottomNavigationBar)`
  min-height: 60px;
  padding-left: 16px;
  padding-right: 16px;
  border-top: 1px solid #ddd;
  -webkit-backface-visibility: hidden;
  align-items: center;
  justify-content: space-between;
`;




/***/ }),

/***/ 811495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ BottomSheet; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(676662);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(255878);





const BottomSheet = ({
  show,
  title,
  extra,
  closeBottomSheet,
  className,
  children,
  position,
  zIndex,
  contentHeight,
  wrapperHeight,
  filterNode,
  keys,
  forceRender = false,
  closeIconPosition = "left",
  showBottomSheetHeader = false
}) => {
  const options = {
    top: {
      opacity: 0,
      transform: `translateY(-100%)`,
      height: "100%"
    },
    left: {
      opacity: 0,
      transform: `translateX(-100%)`,
      height: "100%"
    },
    right: {
      opacity: 0,
      transform: `translateX(100%)`,
      height: "100%"
    },
    bottom: {
      opacity: 0,
      transform: `translateY(100%)`,
      height: "100%"
    },
    show: {
      opacity: 1,
      transform: ["left", "right"].includes(position || "") ? "translateX(0%)" : "translateY(0%)",
      height: "100%"
    }
  };
  const entrancePosition = position || "bottom";
  const [styles, set] = (0,react_spring__WEBPACK_IMPORTED_MODULE_1__.useSpring)(() => options[entrancePosition]);
  const transition = (0,react_spring__WEBPACK_IMPORTED_MODULE_1__.useTransition)(show, {
    from: options[entrancePosition],
    enter: options["show"],
    leave: options[entrancePosition],
    keys: !!keys ? keys : null
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (forceRender) {
      if (!show) {
        set(options[entrancePosition]);
      } else {
        set(options["show"]);
      }
    }
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show, forceRender]);
  const renderContent = (styles2) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_spring__WEBPACK_IMPORTED_MODULE_1__.animated.div, {
      style: styles2
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Mask, {
      onClick: closeBottomSheet
    }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
      wrapperHeight
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBottomSheet, {
      className: `${className ? ` ${className}` : ""}`
    }, (!!title || showBottomSheetHeader) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetHeader, {
      className: "bottom-sheet-header"
    }, closeBottomSheet && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSvgIcon, {
      position: closeIconPosition
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .CloseOutlined */ .X, {
      size: 28,
      onClick: closeBottomSheet
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetTitle, null, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetExtra, null, extra), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetFilter, null, filterNode)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BottomSheetContent, {
      contentHeight,
      className: "bottom-sheet-content"
    }, children))));
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, {
    zIndex,
    show,
    forceRender
  }, forceRender ? renderContent(styles) : transition((styles2, item) => item ? renderContent(styles2) : null));
};
const StyledSvgIcon = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: absolute;
  top: 12px;
  ${({ position }) => `${position}: 12px;`}
`;
const StyledBottomSheet = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  background: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  bottom: 0;
  position: fixed;
`;
const BottomSheetHeader = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: relative;
  text-align: center;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
`;
const BottomSheetTitle = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`;
const BottomSheetExtra = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  position: absolute;
  right: 15px;
`;
const BottomSheetContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  ${({ contentHeight }) => contentHeight ? `height: ${contentHeight}` : "max-height: 75vh"};
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;
const Container = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ show, zIndex, forceRender }) => `
    top: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    pointer-events: none;
    transition: transform 0.3s ease-out;
    ${forceRender && !show ? `display: none;` : ``}
    ${show ? ` z-index: ${zIndex ? zIndex : 1050};
    background-color: rgba(0, 0, 0, 0.3);
    will-change: transform;
    pointer-events: all;` : ""}

  `);
const BottomSheetFilter = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  width: 100%;
`;
const Mask = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  ${({ wrapperHeight }) => wrapperHeight ? `height: ${wrapperHeight}` : "height: 0vh"};
  width: 100vw;
  bottom: 0px;
  position: inherit;
  overflow: auto;
`;




/***/ }),

/***/ 500689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(753625);



const useToast = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__/* .ToastContextMobile */ .g);
};




/***/ }),

/***/ 525369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AK": function() { return /* binding */ getComboName; },
/* harmony export */   "B1": function() { return /* binding */ getComboImageUrl; },
/* harmony export */   "f2": function() { return /* binding */ removeAccent; },
/* harmony export */   "nJ": function() { return /* binding */ formatCurrencyFull; },
/* harmony export */   "pW": function() { return /* binding */ getElementOffset; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(334751);



const getElementOffset = (elem) => {
  const box = elem.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top, left };
};
const formatCurrency = (money) => {
  return money ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : `${money}`;
};
const formatCurrencyFull = (money) => `${formatCurrency(money)}\u20AB`;
const removeAccent = (string) => {
  let str = string;
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/ + /g, " ");
  str = str.trim();
  return str;
};
const sortItems = (childItems) => {
  return childItems.sort((left, right) => left.displayPriority > right.displayPriority ? 1 : -1);
};
const getComboName = (childItems) => {
  if (childItems.length === 0)
    return "";
  const primary = sortItems(childItems)[0];
  const comboLength = childItems.length;
  return comboLength === 1 ? primary.name : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_0__.t)("{{PrimaryName}} v\xE0 {{var0}} s\u1EA3n ph\u1EA9m kh\xE1c", {
    PrimaryName: primary.name,
    var0: comboLength - 1
  });
};
const getComboImageUrl = (childItems) => {
  if (childItems.length === 0)
    return [];
  return sortItems(childItems).map((item) => {
    var _a, _b;
    return item.imageUrl || ((_b = (_a = item.product) == null ? void 0 : _a.productInfo) == null ? void 0 : _b.imageUrl);
  });
};




/***/ }),

/***/ 334751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ NAMESPACE; },
/* harmony export */   "t": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(396556);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ecommerce";
const t = (keys, options) => {
  const text = i18next__WEBPACK_IMPORTED_MODULE_0__["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};




/***/ }),

/***/ 916034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46610);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(525369);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAX_PRICE = 1e11;
const StyledInput = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.input */ .z.input(({ error, allowClear, prefixIcon, disabled, theme: { colors } }) => `
    //Remove input shadow on IOS Safari
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 10px;
    color: ${colors.text};
    font-size: 14px;
    line-height: 1.5715;
    background-image: none;
    border: 1px solid
      ${!!error ? colors.error : colors.border} !important;
    border-radius: 4px;
    transition: all 0.3s;
    ${allowClear ? "padding-right: 32px" : ""};
    ${prefixIcon ? "padding-left: 36px" : ""};
    ${!disabled ? "background-color: #fff" : ""};

    &:hover {
      border-color: ${!!error ? colors.error : "#40a9ff"};
    }

    &:focus {
      border-color: ${!!error ? colors.error : "#40a9ff"};
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: 0 0 0 2px
        ${!!error ? "rgba(255,77,79,.2)" : "rgba(24, 144, 255, 0.2)"};
    }
  `);
const InputContainer = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
`;
const ClearIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
  background-color: #bbb;
`;
const StyleSuffix = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  top: 6px;
  right: 10px;
  cursor: pointer;
  z-index: 1;
`;
const Label = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.label */ .z.label(({ required, theme: { colors } }) => `
    margin-bottom: 0.4rem;
    font-weight: 500;
    &::before {
      content: '*';
      display: ${required ? "inline-block" : "none"};
      margin-right: 4px;
      color: ${colors.error};
      font-size: 14px;
      width: max-content;
    }
  `);
const Error2 = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme: { colors } }) => `
    padding-top: 0;
    color: ${colors.error500};
    font-size: 0.75rem;
    line-height: 1rem;
    transition: color 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    margin-top: 0.5rem;
  `);
const PrefixIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .SvgIcon */ .l)`
  position: absolute;
  top: 5px;
  left: 10px;
  cursor: pointer;
  z-index: 1;
`;
const Currency = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
`;
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  margin-bottom: 1rem;
`;
function resolveOnChange(target, e, onChange) {
  if (onChange) {
    let event = e;
    if (e.type === "click") {
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      const originalInputValue = target.value;
      target.value = "";
      onChange(event);
      target.value = originalInputValue;
      return;
    }
    onChange(event);
  }
}
const Input = (_a) => {
  var _b = _a, {
    value,
    allowClear = true,
    label,
    required,
    error,
    name,
    prefixIcon,
    isFocused,
    allowFocus,
    inputType,
    currency,
    className,
    onChange,
    suffix
  } = _b, restProps = __objRest(_b, [
    "value",
    "allowClear",
    "label",
    "required",
    "error",
    "name",
    "prefixIcon",
    "isFocused",
    "allowFocus",
    "inputType",
    "currency",
    "className",
    "onChange",
    "suffix"
  ]);
  const [internalValue, setInternalValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const textInputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (inputType === "price") {
      setInternalValue((0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .formatCurrency */ .xG)(String(value)));
    } else {
      setInternalValue(value);
    }
  }, [value]);
  const handlePriceInput = (value2) => {
    value2 = value2.replace(/\./g, "");
    if (/^\d*$/.test(value2))
      return value2;
    return null;
  };
  const handleChange = (e) => {
    let value2 = e.target.value;
    if (inputType === "price") {
      value2 = handlePriceInput(value2);
      if (value2 !== null) {
        if (Number(value2) > MAX_PRICE)
          value2 = String(MAX_PRICE);
        e.target.value = value2;
        resolveOnChange(textInputRef.current, e, onChange);
      }
    } else {
      setInternalValue(value2);
      resolveOnChange(textInputRef.current, e, onChange);
    }
  };
  const handleClear = (e) => {
    setInternalValue("");
    textInputRef.current.focus();
    resolveOnChange(textInputRef.current, e, onChange);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    isFocused && textInputRef.current.focus();
  }, [isFocused]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, label && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: "input__label",
    required
  }, label), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContainer, null, prefixIcon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PrefixIcon, {
    name: prefixIcon,
    size: 22
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, __spreadProps(__spreadValues({
    name,
    label,
    value: internalValue,
    allowClear,
    onChange: handleChange,
    ref: textInputRef,
    error,
    prefixIcon
  }, restProps), {
    className: "input__input"
  })), allowClear && !!internalValue && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ClearIcon, {
    name: "circle-close",
    onClick: handleClear
  }), !!suffix && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyleSuffix, null, suffix), !!currency && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Currency, null, currency)), !!error && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Error2, {
    className: "input__error"
  }, error));
};




/***/ }),

/***/ 646807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ListItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var _Text_Text_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(327513);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  background: #ffffff;
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Left = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  margin-right: 12px;
`;
const Right = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  margin-left: 12px;
`;
const Content = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  flex: 1;
  overflow: hidden;
`;
const SubTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  font-size: 13px;
  color: #82869e;
`;
const ListItem = (_a) => {
  var _b = _a, {
    left,
    title,
    subTitle,
    right,
    regionName,
    contentName,
    target,
    onClick,
    payload
  } = _b, props = __objRest(_b, [
    "left",
    "title",
    "subTitle",
    "right",
    "regionName",
    "contentName",
    "target",
    "onClick",
    "payload"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues(__spreadProps(__spreadValues({}, props), {
    onClick: () => {
      if (onClick)
        onClick();
    }
  }), (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName,
    contentName,
    target,
    payload
  })), left && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Left, null, left), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, null, typeof title === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
    fontWeight: "500"
  }, title) : title, subTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubTitle, null, subTitle)), right && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Right, null, right));
};




/***/ }),

/***/ 644797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(912841);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46610);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(811495);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(525369);
/* harmony import */ var _Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(916034);
/* harmony import */ var _ListItem_ListItem_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(646807);
/* harmony import */ var _Text_Text_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(327513);








const Select = ({
  value,
  items,
  type = "text",
  title,
  selectKey,
  popupTitle,
  placeholder,
  disabled,
  required,
  className,
  haveFilter,
  contentFixedHeight = true,
  onSelectChange,
  paddingBottom,
  isFilterSticky = false,
  error,
  wrapperBottomSheetHeight
}) => {
  const [keyword, setKeyword] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  const [filteredItems, setFilteredItems] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(items);
  const [showBottomSheet, setShowBottomSheet] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const onClickItem = (item) => {
    onSelectChange(item);
    setShowBottomSheet(false);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const normalizeKeyword = keyword && (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .removeAccent */ .f2)(keyword.toLowerCase());
    if (normalizeKeyword) {
      const fItems = items.filter((item) => (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_1__/* .removeAccent */ .f2)(item[selectKey].toLowerCase()).includes(normalizeKeyword));
      setFilteredItems(fItems);
    } else {
      setFilteredItems(items);
    }
  }, [keyword, items]);
  const filterBlock = haveFilter && popupTitle && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FilterWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I, {
    value: keyword,
    placeholder: popupTitle,
    prefixIcon: "search",
    onChange: (e) => setKeyword(e.target.value)
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i, null)) || null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSelect, {
    className
  }, title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: "select__label",
    required
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputContainer, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type,
    value,
    disabled,
    placeholder,
    onClick: () => !disabled && setShowBottomSheet(true),
    readOnly: true,
    className: "select__input"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
    name: "chevron-forward",
    size: 14,
    className: "select__icon"
  })), !!error && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Error, null, error), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .BottomSheet */ .R, {
    show: showBottomSheet,
    title: popupTitle,
    closeBottomSheet: () => setShowBottomSheet(false),
    contentHeight: contentFixedHeight ? "75vh" : void 0,
    filterNode: isFilterSticky && filterBlock,
    wrapperHeight: wrapperBottomSheetHeight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ContentWrapper, {
    paddingBottom
  }, !isFilterSticky && filterBlock, filteredItems.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ListItem_ListItem_es_js__WEBPACK_IMPORTED_MODULE_5__/* .ListItem */ .H, {
    title: /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Text_Text_es_js__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, null, item[selectKey]),
    onClick: () => onClickItem(item)
  }), index !== items.length - 1 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i, null))))));
};
const StyledSelect = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div((props) => {
  var _a;
  return `
    width: 100%;
    background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  `;
});
const Label = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.label */ .z.label(({ required, theme }) => `
    margin-bottom: 0.4rem;
    font-weight: 500;
    &::before {
      content: '*';
      display: ${required ? "inline-block" : "none"};
      margin-right: 4px;
      color: ${theme == null ? void 0 : theme.colors.error};
      font-size: 14px;
      background-color: ${theme == null ? void 0 : theme.colors.white};
    }
  `);
const InputContainer = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div`
  cursor: pointer;
  font-size: 13px;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
`;
const StyledInput = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.input */ .z.input((props) => {
  var _a, _b, _c, _d;
  return `
    //Remove input shadow on IOS Safari
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    outline: none;
    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    padding: 4px 10px;
    color: ${(_a = props.theme) == null ? void 0 : _a.colors.text};
    font-size: 14px;
    line-height: 1.5715;
    background-color: ${props.disabled ? (_b = props.theme) == null ? void 0 : _b.colors.background : (_c = props.theme) == null ? void 0 : _c.colors.white};
    background-image: none;
    border: 1px solid ${(_d = props.theme) == null ? void 0 : _d.colors.border};
    border-radius: 2px;
    transition: all 0.3s;
    padding-right: 32px;
    &:hover {
      border-color: #40a9ff;
    }
  `;
});
const ContentWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div(({ paddingBottom }) => `
    width: 100vw;
    padding-bottom: ${paddingBottom || `0`};
  `);
const FilterWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div((props) => {
  var _a;
  return `
    padding: 1.75rem 1rem 0 1rem;
    input {
      border: none;
      background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.background};
    }
  `;
});
const StyledIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .SvgIcon */ .l)`
  position: absolute;
  right: 0;
  cursor: pointer;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(0, 0, 0, 0.25);
  pointer-event: none;
  &:hover {
    color: rgba(0, 0, 0, 0.45);
  }
`;
const Error = _teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .styled.div */ .z.div(({ theme }) => `
    padding-top: 0;
    color: ${theme == null ? void 0 : theme.colors.error500};
    font-size: 0.75rem;
    line-height: 1rem;
    transition: color 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    margin-top: 0.5rem;
  `);




/***/ }),

/***/ 327513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getColor = (props) => {
  const { color, theme } = props;
  return color && ((theme == null ? void 0 : theme.brand[color]) || (theme == null ? void 0 : theme.colors[color])) || color || (theme == null ? void 0 : theme.colors.dark) || "";
};
const StyledText = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => {
  return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || "400"};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ""}
    text-align: ${props.textAlign || "left"};
    overflow: hidden;
    ${props.maxLines ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};` : ""}
    ${props.textTransform ? `
      text-transform: ${props.textTransform};
    ` : ""}
  `;
});
const Text = (props) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, __spreadProps(__spreadValues({}, props), {
    maxLines: props.maxLines || 0
  }));
};




/***/ }),

/***/ 883578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ CountdownTime; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(649771);
/* harmony import */ var _helpers_time_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(487319);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29921);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addPaddingNumber = (number) => number.toString().padStart(2, "0");
const SIZE = {
  s: {
    level: 3
  },
  m: {
    level: 1
  }
};
const CountdownTime = (_a) => {
  var _b = _a, {
    endAt,
    renderDaysCountdownText
  } = _b, others = __objRest(_b, [
    "endAt",
    "renderDaysCountdownText"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const size = (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .getComponentSize */ .Z)(isMobile);
  const [duration, setDuration] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_3__/* .calculateTimeDelta */ .m)(new Date(), endAt));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const intervalId = setInterval(() => {
      if (duration.milliseconds !== 0) {
        setDuration((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_3__/* .calculateTimeDelta */ .m)(new Date(), endAt));
      }
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const displayCountdown = () => {
    if (duration.days !== 0) {
      return !!renderDaysCountdownText ? renderDaysCountdownText(duration) : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("C\xF2n {{DurationDays}} ng\xE0y", { DurationDays: duration.days });
    }
    return `${addPaddingNumber(duration.hours)}:${addPaddingNumber(duration.minutes)}:${addPaddingNumber(duration.seconds)}`;
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Timer, __spreadValues({
    level: SIZE[size].level,
    weight: "bold",
    color: "white"
  }, others), displayCountdown());
};
const Timer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Caption */ .YS)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 488924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ index_es_FlashSaleBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/CountdownTime/CountdownTime.es.js
var CountdownTime_es = __webpack_require__(883578);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/mobile/FlashSaleBar.es.js




const background = "data:image/svg+xml;base64,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";
const FlashSaleBar = ({
  text,
  endAt
}) => {
  return /* @__PURE__ */ react.createElement(Wrapper, {
    background
  }, /* @__PURE__ */ react.createElement(StyledCaption, {
    level: 3,
    weight: "bold",
    color: "white"
  }, text), endAt && /* @__PURE__ */ react.createElement(CountdownTime_es/* CountdownTime */.v, {
    level: 3,
    endAt: typeof endAt === "number" ? new Date(endAt) : endAt
  }));
};
const Wrapper = emotion_styled_browser_esm["default"].div(({ background: background2, theme }) => `
    background: url("${background2}");
    padding: 2px ${theme == null ? void 0 : theme.spacing.s8};
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    border-radius: ${theme == null ? void 0 : theme.borderRadius.xl};
`);
const StyledCaption = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)`
  text-transform: uppercase;
  flex: 1 0 auto;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/desktop/FlashSaleBar.es.js




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FlashSaleBar_es_background = "data:image/svg+xml;base64,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";
const FlashSaleBar_es_FlashSaleBar = (_a) => {
  var _b = _a, {
    text,
    endAt
  } = _b, rest = __objRest(_b, [
    "text",
    "endAt"
  ]);
  return /* @__PURE__ */ react.createElement(FlashSaleBar_es_Wrapper, __spreadValues({
    background: FlashSaleBar_es_background
  }, rest), /* @__PURE__ */ react.createElement(FlashSaleBar_es_StyledCaption, {
    level: 3,
    weight: "bold",
    color: "white"
  }, text), endAt && /* @__PURE__ */ react.createElement(CountdownTime_es/* CountdownTime */.v, {
    level: 3,
    endAt: typeof endAt === "number" ? new Date(endAt) : endAt
  }));
};
const FlashSaleBar_es_Wrapper = emotion_styled_browser_esm["default"].div(({ background: background2, theme }) => `
    background: url("${background2}");
    padding: ${theme == null ? void 0 : theme.spacing.s4} ${theme == null ? void 0 : theme.spacing.s4};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
`, BaseProps_index_es/* CommonStyles */.F, "border-radius: 999px;");
const FlashSaleBar_es_StyledCaption = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)`
  text-transform: uppercase;
  flex: 1 0 auto;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/index.es.js





var index_es_defProp = Object.defineProperty;
var index_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var index_es_hasOwnProp = Object.prototype.hasOwnProperty;
var index_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var index_es_defNormalProp = (obj, key, value) => key in obj ? index_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var index_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (index_es_hasOwnProp.call(b, prop))
      index_es_defNormalProp(a, prop, b[prop]);
  if (index_es_getOwnPropSymbols)
    for (var prop of index_es_getOwnPropSymbols(b)) {
      if (index_es_propIsEnum.call(b, prop))
        index_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const index_es_FlashSaleBar = (props) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  if (isMobile)
    return /* @__PURE__ */ react.createElement(FlashSaleBar, index_es_spreadValues({}, props));
  return /* @__PURE__ */ react.createElement(FlashSaleBar_es_FlashSaleBar, index_es_spreadValues({}, props));
};




/***/ }),

/***/ 784241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ HorizontalSlider; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const HorizontalSlider = (_a) => {
  var _b = _a, {
    slidesPerView,
    children
  } = _b, props = __objRest(_b, [
    "slidesPerView",
    "children"
  ]);
  if (!Array.isArray(children)) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), Array.isArray(children) && children.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
    slidesPerView,
    key: index
  }, item)));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F, () => `
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  };
  transform: translate3d(0,0,0);
  `);
const Item = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a;
  return `
    width: ${100 / ((_a = props.slidesPerView) != null ? _a : 1)}%;
    flex-shrink: 0;
    margin-right: 8px;
  `;
});




/***/ }),

/***/ 922859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(991822);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RatingFilled.es.js
var RatingFilled_es = __webpack_require__(825078);
// EXTERNAL MODULE: ../../packages/utils/dist/storage.es.js
var storage_es = __webpack_require__(653028);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-3.2.5-d9af707abe-bd3b40810c.zip/node_modules/dompurify/dist/purify.es.mjs
var purify_es = __webpack_require__(629078);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/index.es.js
var helpers_index_es = __webpack_require__(649771);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/index.es.js + 2 modules
var FlashSaleBar_index_es = __webpack_require__(488924);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/assets/images/gift.es.js


var img = "data:image/svg+xml,%3csvg width='42' height='40' viewBox='0 0 42 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='42' height='40' fill='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M29.9375 14.7495H27.9916C28.1874 14.3922 28.2969 13.9999 28.3125 13.5998C28.2843 12.8923 27.9563 12.2234 27.399 11.7371C26.8417 11.2507 26.0998 10.9859 25.3331 10.9995C24.4198 11.0358 23.5343 11.3004 22.7711 11.765C22.008 12.2295 21.3958 12.8767 21 13.6373C20.6084 12.8788 20.0009 12.2327 19.2424 11.7682C18.484 11.3036 17.6031 11.0379 16.6937 10.9995H16.6011C15.8453 11.0006 15.1195 11.2722 14.5761 11.7571C14.0327 12.2421 13.7142 12.9026 13.6875 13.5998V13.6493C13.7034 14.0322 13.8084 14.4074 13.9954 14.7495H12.0625C11.847 14.7495 11.6403 14.8285 11.488 14.9692C11.3356 15.1098 11.25 15.3006 11.25 15.4995V17.7495C11.25 17.9484 11.3356 18.1392 11.488 18.2799C11.6403 18.4205 11.847 18.4995 12.0625 18.4995H29.9375C30.153 18.4995 30.3597 18.4205 30.512 18.2799C30.6644 18.1392 30.75 17.9484 30.75 17.7495V15.4995C30.75 15.3006 30.6644 15.1098 30.512 14.9692C30.3597 14.8285 30.153 14.7495 29.9375 14.7495ZM25.3583 12.4995C25.6901 12.4916 26.0127 12.6011 26.2598 12.8057C26.507 13.0103 26.66 13.2944 26.6875 13.5998C26.676 13.9068 26.5364 14.1978 26.298 14.412C26.0595 14.6263 25.7406 14.7472 25.4078 14.7495H22.2009C22.7063 13.8053 23.7113 12.4995 25.3583 12.4995ZM15.3125 13.6245C15.3333 13.3176 15.4809 13.0298 15.725 12.8205C15.969 12.6111 16.2908 12.4962 16.6239 12.4995C18.3049 12.5055 19.2897 13.7978 19.8007 14.7495H16.632C16.2984 14.7518 15.9763 14.6368 15.7312 14.4279C15.4862 14.2189 15.3364 13.9317 15.3125 13.6245ZM22.625 19.9997V28.9997H26.6875C27.334 28.9997 27.9539 28.7626 28.4111 28.3407C28.8682 27.9187 29.125 27.3464 29.125 26.7497V19.9997H22.625ZM12.875 19.9997H19.375V28.9997H15.3125C14.666 28.9997 14.046 28.7626 13.5889 28.3407C13.1318 27.9187 12.875 27.3464 12.875 26.7497V19.9997Z' fill='%23F5222D'/%3e%3c/svg%3e";
var giftImg = img;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductGiftItem.es.js




const ProductGiftItem = (props) => {
  const { gift } = props;
  return /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    width: 40,
    height: 40,
    borderRadius: "m",
    borderWeight: "m",
    borderColor: "divider",
    borderStyle: "solid",
    backgroundColor: "white",
    onClick: (e) => e.preventDefault()
  }, /* @__PURE__ */ react.createElement(StyledLazyImage, {
    src: gift.src,
    customFallbackImage: giftImg,
    height: 38,
    width: 38,
    imageWidth: 76,
    borderRadius: 8,
    alt: gift.alt,
    contain: true,
    aspectRatio: 1,
    draggable: false
  }));
};
var ProductGiftItem$1 = ProductGiftItem;
const StyledLazyImage = (0,emotion_styled_browser_esm["default"])(LazyImage_es/* LazyImage */.w)`
  & > img {
    border-radius: 0.5rem;
    display: block;
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductGifts.es.js





const ProductGifts = (props) => {
  var _a;
  const { gifts, hasGift } = props;
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const containerRef = (0,react.useRef)(null);
  const startPos = (0,react.useRef)({
    startX: 0,
    scrollLeft: 0,
    isMouseDown: false
  });
  (0,react.useEffect)(() => {
    const container = containerRef.current;
    const handleMouseDown = (e) => {
      if (!container) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const startX = e.pageX - container.offsetLeft;
      const scrollLeft = container.scrollLeft;
      startPos.current = {
        startX,
        scrollLeft,
        isMouseDown: true
      };
      document.body.style.cursor = "grabbing";
    };
    const handleMouseMove = (e) => {
      if (!startPos.current.isMouseDown || !container) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walkX = x - startPos.current.startX;
      container.scrollLeft = startPos.current.scrollLeft - walkX;
    };
    const handleMouseUp = () => {
      if (!container) {
        return;
      }
      startPos.current.isMouseDown = false;
      document.body.style.cursor = "default";
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleMouseDown);
    container == null ? void 0 : container.addEventListener("mousemove", handleMouseMove);
    container == null ? void 0 : container.addEventListener("mouseup", handleMouseUp);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleMouseDown);
      container == null ? void 0 : container.removeEventListener("mousemove", handleMouseMove);
      container == null ? void 0 : container.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);
  if (!hasGift || !((_a = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a.length))
    return null;
  return /* @__PURE__ */ react.createElement(Container, {
    ref: containerRef,
    padding: "s4",
    borderRadius: "m",
    backgroundColor: "background",
    marginBottom: isMobile ? "s12" : void 0,
    onClick: (e) => e.preventDefault()
  }, gifts.images.map((image, index) => {
    return /* @__PURE__ */ react.createElement(ProductGiftItem$1, {
      key: index,
      gift: image
    });
  }));
};
var ProductGifts$1 = ProductGifts;
const Container = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  overflow: auto hidden;
  gap: 4px;
  display: flex;
  flex-direction: row;
  ::-webkit-scrollbar {
    //Hide scrollbar for Chrome, Safari and Opera
    display: none;
  }
  // Hide scrollbar for IE and Edge
  -ms-overflow-style: none;
  // Hide scrollbar for Firefox
  scrollbar-width: none;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/hooks/useQuantity.es.js
var useQuantity_es = __webpack_require__(194446);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBadge/FlashSaleBadge.es.js






const background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzNkMzOC4yMDkxIDAgNDAgMS43OTA4NiA0MCA0VjM1LjgzODdDNDAgMzcuNTE1OCAzOC4wNjAxIDM4LjQ0ODEgMzYuNzUwNiAzNy40MDA1TDM2LjI0OTQgMzYuOTk5NUMzNS41MTkgMzYuNDE1MiAzNC40ODEgMzYuNDE1MiAzMy43NTA2IDM2Ljk5OTVMMzEuMjQ5NCAzOS4wMDA1QzMwLjUxOSAzOS41ODQ4IDI5LjQ4MSAzOS41ODQ4IDI4Ljc1MDYgMzkuMDAwNUwyNi4yNDk0IDM2Ljk5OTVDMjUuNTE5IDM2LjQxNTIgMjQuNDgxIDM2LjQxNTIgMjMuNzUwNiAzNi45OTk1TDIxLjI0OTQgMzkuMDAwNUMyMC41MTkgMzkuNTg0OCAxOS40ODEgMzkuNTg0OCAxOC43NTA2IDM5LjAwMDVMMTYuMjQ5NCAzNi45OTk1QzE1LjUxOSAzNi40MTUyIDE0LjQ4MSAzNi40MTUyIDEzLjc1MDYgMzYuOTk5NUwxMS4yNDk0IDM5LjAwMDVDMTAuNTE5IDM5LjU4NDggOS40ODEwNSAzOS41ODQ4IDguNzUwNjEgMzkuMDAwNUw2LjI0OTM5IDM2Ljk5OTVDNS41MTg5NSAzNi40MTUyIDQuNDgxMDUgMzYuNDE1MiAzLjc1MDYxIDM2Ljk5OTVMMy4yNDkzOSAzNy40MDA1QzEuOTM5ODYgMzguNDQ4MSAwIDM3LjUxNTggMCAzNS44Mzg3VjRaIgogICAgZmlsbD0iI0ZGREU2NyIgLz4KPC9zdmc+";
const SIZE = {
  s: {
    badge: 36,
    discountText: 8,
    percentText: 13
  },
  m: {
    badge: 40,
    discountText: 10,
    percentText: 15
  }
};
const FlashSaleBadge = ({
  discountPercent
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const size = (0,helpers_index_es/* getComponentSize */.Z)(isMobile);
  return discountPercent ? /* @__PURE__ */ react.createElement(DiscountInfo, {
    size,
    background
  }, /* @__PURE__ */ react.createElement(DiscountText, {
    size
  }, (0,i18n_es.t)("GI\u1EA2M")), /* @__PURE__ */ react.createElement(PercentText, {
    size
  }, discountPercent, "%")) : null;
};
const DiscountText = emotion_styled_browser_esm["default"].div(({ size }) => `
    font-weight: 700;
    color: #663009;
    line-height: 12px;
    font-size: ${SIZE[size].discountText}px;
`);
const PercentText = emotion_styled_browser_esm["default"].div(({ size }) => `
    font-weight: 700;
    font-size: ${SIZE[size].percentText}px;
    line-height: 18px;
    color: #ee112e;
`);
const DiscountInfo = emotion_styled_browser_esm["default"].div(({ size, background: background2 }) => `
    width: ${SIZE[size].badge}px;
    height: ${SIZE[size].badge}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("${background2}");
    background-repeat: no-repeat;
    background-size: cover;
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(54230);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SavingBadge/SavingBadge.es.js






const SavingBadge_es_background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA5NiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHJ4PSI0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIiAvPgogIDxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjQwIj4KICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI0MCIgcng9IjQiIGZpbGw9IndoaXRlIiAvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiCiAgICAgIGQ9Ik03NC4yNDQ2IC05LjAyODY5TDY1Ljg3NjcgOC45MTYyMUw3MC43NzA4IDExLjE5ODNMNjMuOTI0NCAyNS44ODA1TDg0LjQ3MjQgMTEuNjI5M0w3Ny45NDcgOC41ODY0Mkw5MC41NTgxIC0xLjQyMTU2TDc0LjI0NDYgLTkuMDI4NjlaIgogICAgICBmaWxsPSIjMUIxRDI5IiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1LjcyMDkiIHkxPSIxLjY2NTQ0ZS0wNiIgeDI9IjU3Ljg4ODYiIHkyPSI0MC4wODczIgogICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNBQTIwRkYiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQxM0VGRiIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4=";
const SavingBadge_es_SIZE = {
  s: {
    titleFont: 8,
    discountFont: 12,
    discountLineHeight: 16
  },
  m: {
    titleFont: 10,
    discountFont: 13,
    discountLineHeight: 18
  }
};
const SavingBadge = ({
  savingAmount,
  numberDisplayFormat
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const size = isMobile ? "s" : "m";
  const formattedSavingAmount = (0,number_es/* formatCurrency */.xG)(savingAmount, numberDisplayFormat);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    background: SavingBadge_es_background
  }, /* @__PURE__ */ react.createElement(Title, {
    size
  }, (0,i18n_es.t)("TI\u1EBET KI\u1EC6M")), /* @__PURE__ */ react.createElement(DiscountAmount, {
    size
  }, formattedSavingAmount));
};
const Wrapper = emotion_styled_browser_esm["default"].div(({ background: background2, theme }) => `
  height: 36px;
  line-height: 12px;
  background: url("${background2}");
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${theme == null ? void 0 : theme.spacing.s4} ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  background-size: cover;
`);
const Title = emotion_styled_browser_esm["default"].div(({ size }) => `
    font-size: ${SavingBadge_es_SIZE[size].titleFont}px;
    font-weight: 700;
    color: #ffd591;
`);
const DiscountAmount = emotion_styled_browser_esm["default"].div(({ size, theme }) => `
    font-size: ${SavingBadge_es_SIZE[size].discountFont}px;
    line-height: ${SavingBadge_es_SIZE[size].discountLineHeight}px;
    font-weight: 700;
    color: ${theme == null ? void 0 : theme.colors.white};
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(788925);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductCard.es.js



















var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FreeShippingColored = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod) => mod.FreeShippingColored));
const ProductCard_es_SIZE = {
  s: {
    padding: "s12"
  },
  m: {
    padding: "s16"
  }
};
const ProductCard = (_a) => {
  var _b = _a, {
    name,
    link,
    imageUrl,
    price,
    freeship,
    hasGift,
    gifts = {},
    infoTags,
    titleTag,
    ctaButton,
    ctaButtons,
    wishlistButton,
    contactButton,
    stockQuantity,
    flashSale,
    addToCart,
    textColor,
    brand,
    tracking,
    ctaTracking,
    needConfirmAge,
    type,
    uom,
    precisionToDisplayDecimalQuantity: precision,
    bestComboDiscount,
    benefitLabel,
    requiredQuantity,
    numberDisplayFormat,
    selectPromotionId,
    showNewProductGift = false,
    highlight,
    materials,
    showCtaButtonsWithQuantity = false,
    showCtaButtonsRelevantProducts = false,
    showContact,
    averageRating,
    onWrapperAuxClick,
    onWrapperClick,
    customButtons
  } = _b, props = __objRest(_b, [
    "name",
    "link",
    "imageUrl",
    "price",
    "freeship",
    "hasGift",
    "gifts",
    "infoTags",
    "titleTag",
    "ctaButton",
    "ctaButtons",
    "wishlistButton",
    "contactButton",
    "stockQuantity",
    "flashSale",
    "addToCart",
    "textColor",
    "brand",
    "tracking",
    "ctaTracking",
    "needConfirmAge",
    "type",
    "uom",
    "precisionToDisplayDecimalQuantity",
    "bestComboDiscount",
    "benefitLabel",
    "requiredQuantity",
    "numberDisplayFormat",
    "selectPromotionId",
    "showNewProductGift",
    "highlight",
    "materials",
    "showCtaButtonsWithQuantity",
    "showCtaButtonsRelevantProducts",
    "showContact",
    "averageRating",
    "onWrapperAuxClick",
    "onWrapperClick",
    "customButtons"
  ]);
  var _a2, _b2, _c;
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const { showModal } = (0,hook_es/* useModal */.d)();
  const router = (0,next_router.useRouter)();
  const {
    quantity,
    setQuantity,
    handleUpdateQuantity,
    onIncrease,
    onDecrease,
    loading
  } = (0,useQuantity_es/* useQuantity */.R)({
    addToCart,
    precision,
    shouldRoundValue: !numberDisplayFormat
  });
  const handleClickCtaButton = (e) => {
    var _a3;
    e.preventDefault();
    if (needConfirmAge) {
      showModal == null ? void 0 : showModal({
        title: isMobile ? (0,i18n_es.t)("C\u1EA3nh b\xE1o") : "",
        children: isMobile ? /* @__PURE__ */ react.createElement(index_es/* Body */.uT, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")) : /* @__PURE__ */ react.createElement(ModalConfirmWrap, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")),
        okText: (0,i18n_es.t)("T\xF4i tr\xEAn 18 tu\u1ED5i"),
        cancelText: (0,i18n_es.t)("T\xF4i d\u01B0\u1EDBi 18 tu\u1ED5i"),
        onOk: () => {
          (0,storage_es/* setCookieOver18YearOld */.zr)(true);
          addToCart == null ? void 0 : addToCart.onAddToCart();
        },
        width: isMobile ? "90%" : "400px",
        okButtonProps: { block: isMobile, size: "s" },
        cancelButtonProps: { block: isMobile, size: "s" },
        alignFooter: "center",
        showCloseIcon: isMobile
      });
    } else
      (_a3 = ctaButton == null ? void 0 : ctaButton.onClick) == null ? void 0 : _a3.call(ctaButton, e);
  };
  const size = (0,helpers_index_es/* getComponentSize */.Z)(isMobile);
  const renderCtaButtons = (quantityInCart) => {
    if (quantityInCart > 0 && !showCtaButtonsWithQuantity) {
      return null;
    }
    return /* @__PURE__ */ react.createElement(react.Fragment, null, !!(ctaButtons == null ? void 0 : ctaButtons.length) && ctaButtons.map((ctaButton2, index) => typeof ctaButton2.children === "string" ? /* @__PURE__ */ react.createElement(StyleButton, __spreadProps(__spreadValues(__spreadValues({
      key: index
    }, ctaButton2), ctaTracking), {
      size: "s",
      block: true,
      padding: "s0"
    })) : /* @__PURE__ */ react.createElement(react.Fragment, {
      key: index
    }, ctaButton2.children)), !(ctaButtons == null ? void 0 : ctaButtons.length) ? !!ctaButton ? /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, ctaButton), {
      onClick: (e) => {
        ctaButton.onClick && handleClickCtaButton(e);
      }
    }), ctaTracking), {
      size: "s",
      block: true,
      padding: "s0"
    })) : !!contactButton ? /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadValues({}, contactButton), ctaTracking), {
      size: "s",
      block: true,
      padding: "s0"
    })) : null : null);
  };
  const renderButton = () => {
    const { quantityInCart = 0 } = addToCart || {};
    return /* @__PURE__ */ react.createElement(react.Fragment, null, renderCtaButtons(quantityInCart), (quantityInCart != null ? quantityInCart : 0) > 0 ? /* @__PURE__ */ react.createElement(Quantity_es/* Quantity */.h, __spreadProps(__spreadValues({
      block: true,
      quantity,
      setQuantity,
      onMinus: onDecrease,
      onPlus: onIncrease,
      min: 0,
      max: Math.min(stockQuantity, 999),
      color: "primary500",
      size: "s",
      onBlur: handleUpdateQuantity,
      onKeyPress: (e) => {
        if (e.key === "Enter")
          handleUpdateQuantity();
      },
      decimalSeparator: !!numberDisplayFormat ? (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || "," : "."
    }, !!numberDisplayFormat ? {
      formatter: (value) => (0,number_es/* numberFormatter */.V2)(value, numberDisplayFormat),
      parser: (value) => (0,number_es/* numberParser */.kX)(value, numberDisplayFormat)
    } : {}), {
      precision,
      disabled: loading
    })) : null);
  };
  const productVisualWrapper = /* @__PURE__ */ react.createElement(ProductVisualWrapper, null, /* @__PURE__ */ react.createElement(ProductImageWrapper, null, !!showContact && !!showCtaButtonsRelevantProducts && !!ctaButtons && /* @__PURE__ */ react.createElement(OutOfStockLabel, null, (0,i18n_es.t)("T\u1EA1m h\u1EBFt h\xE0ng")), /* @__PURE__ */ react.createElement(ProductImage, {
    hover: "zoom",
    height: "100%",
    objectFit: "contain",
    src: imageUrl,
    googleImageParams: {
      width: 230
    },
    aspectRatio: 1,
    alt: name
  }), !!requiredQuantity ? /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    width: 40,
    height: 40
  }, requiredQuantity) : null), ((_a2 = infoTags == null ? void 0 : infoTags.length) != null ? _a2 : 0) > 0 ? /* @__PURE__ */ react.createElement(InfoTagsWrapper, null, infoTags == null ? void 0 : infoTags.map((tag, index) => /* @__PURE__ */ react.createElement(InfoTag, __spreadValues({
    key: index
  }, tag)))) : null, flashSale ? /* @__PURE__ */ react.createElement(react.Fragment, null, flashSale.discountPercent && /* @__PURE__ */ react.createElement(FlashSaleBadgeWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBadge, {
    discountPercent: flashSale.discountPercent
  })), /* @__PURE__ */ react.createElement(FlashSaleTimerWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBar_index_es/* FlashSaleBar */.P, __spreadProps(__spreadValues({}, flashSale), {
    endAt: typeof flashSale.endAt === "number" ? new Date(flashSale.endAt) : flashSale.endAt
  })))) : null, (price == null ? void 0 : price.discountAmount) ? /* @__PURE__ */ react.createElement(SavingBadgeWrapper, null, /* @__PURE__ */ react.createElement(SavingBadge, {
    savingAmount: price.discountAmount,
    numberDisplayFormat
  })) : null);
  const productName = /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    align: "center",
    justify: "space-between"
  }, brand && /* @__PURE__ */ react.createElement(Brand, null, /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 2,
    line: 1,
    color: "textSecondary",
    hoverColor: "primary500",
    style: { textTransform: "uppercase" },
    onClick: (event) => {
      event.preventDefault();
      brand.code && router.push({
        pathname: "/brands/[brandId]",
        query: {
          brandId: brand.code
        }
      }, `/${brand.code}-brand.${brand.code}`);
    },
    className: "product-brand-name"
  }, brand.name)), wishlistButton && /* @__PURE__ */ react.createElement(Brand, null, /* @__PURE__ */ react.createElement(react.Fragment, null, wishlistButton.children))), /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ProductNameWrapper, null, /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    className: "att-product-card-title",
    level: 1,
    line: bestComboDiscount && Number(bestComboDiscount) !== 0 || !!benefitLabel ? 2 : 3,
    color: textColor || "textPrimary"
  }, titleTag && /* @__PURE__ */ react.createElement(TitleTag, __spreadValues({}, titleTag)), /* @__PURE__ */ react.createElement(StyledH3, {
    title: name
  }, name))), uom && /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 1,
    color: "textSecondary",
    style: { marginTop: "0.25rem" }
  }, (0,i18n_es.t)("\u0110\u01A1n v\u1ECB t\xEDnh"), ": ", uom), bestComboDiscount && Number(bestComboDiscount) !== 0 ? /* @__PURE__ */ react.createElement(Tag_es/* Tag */.V, {
    type: "ghost",
    variant: "branding",
    content: `${(0,i18n_es.t)("Combo gi\u1EA3m ~").toLocaleUpperCase()} ${(0,number_es/* formatCurrency */.xG)(Number(bestComboDiscount), numberDisplayFormat)}`,
    style: { wordBreak: "break-all" }
  }) : !!benefitLabel ? /* @__PURE__ */ react.createElement(Tag_es/* Tag */.V, {
    type: "ghost",
    variant: "branding",
    content: benefitLabel,
    style: { wordBreak: "break-all" }
  }) : null, /* @__PURE__ */ react.createElement(ProductSaleInfo, {
    freeship: !!freeship
  }, freeship && /* @__PURE__ */ react.createElement(StyledIconWrapper, null, /* @__PURE__ */ react.createElement(FreeShippingColored, {
    size: 24
  })), !!price ? /* @__PURE__ */ react.createElement(ProductPrice_es/* ProductPrice */.j, __spreadProps(__spreadValues({}, price), {
    numberDisplayFormat
  })) : null)));
  const highlightAttribute = highlight ? /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    padding: "s8",
    borderRadius: "m",
    backgroundColor: "background"
  }, /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    dangerouslySetInnerHTML: {
      __html: (_c = (_b2 = purify_es/* default */.Z) == null ? void 0 : _b2.sanitize) == null ? void 0 : _c.call(_b2, highlight)
    },
    style: { fontSize: "10px", lineHeight: "10px" }
  })) : null;
  const linkWithSelectPromotionId = (0,react.useMemo)(() => {
    var _a3;
    if (!selectPromotionId || !link || !(link == null ? void 0 : link.as) || typeof link.as === "string" || !link.as.query || typeof link.as.query !== "object") {
      return link;
    }
    return __spreadProps(__spreadValues({}, link), {
      as: __spreadProps(__spreadValues({}, link.as), { query: __spreadProps(__spreadValues({}, (_a3 = link == null ? void 0 : link.as) == null ? void 0 : _a3.query), { selectPromotionId }) })
    });
  }, [link, selectPromotionId]);
  const productGift = () => {
    var _a3;
    if (!hasGift || !((_a3 = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a3.length))
      return;
    const images = gifts.images.slice(0, 2);
    const more = gifts.images.length - 2;
    return /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
      align: "center",
      gap: "s4"
    }, images.map((image, index) => /* @__PURE__ */ react.createElement(StyledGift, {
      width: 24,
      height: 24,
      key: index
    }, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
      src: image.src,
      height: "100%",
      width: "100%",
      borderRadius: 4,
      alt: image.alt,
      contain: true
    }))), more > 0 && /* @__PURE__ */ react.createElement(MoreGift, {
      width: 24,
      height: 24
    }, "+", more));
  };
  const card = type === "list" ? /* @__PURE__ */ react.createElement("div", __spreadValues({
    style: { display: "flex", padding: "12px" },
    className: "product-card",
    onAuxClick: onWrapperAuxClick,
    onClick: onWrapperClick
  }, tracking), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 3 }
  }, productVisualWrapper), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 7, marginLeft: "12px", maxWidth: "70%" }
  }, productName, /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    marginBottom: "s8"
  }, highlightAttribute), showNewProductGift ? /* @__PURE__ */ react.createElement(ProductGifts$1, {
    gifts,
    hasGift
  }) : productGift(), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: "column",
    gap: "s4",
    justify: "end",
    align: "start",
    width: "100%"
  }, !!averageRating && averageRating > 1 && /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    backgroundColor: "#FFE7BA",
    borderRadius: "s",
    maxWidth: "fit-content"
  }, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    maxWidth: "fit-content",
    align: "middle",
    padding: ["s0", "s4"]
  }, /* @__PURE__ */ react.createElement(RatingFilled_es/* RatingFilled */.A, {
    color: "pending",
    size: "13px"
  }), /* @__PURE__ */ react.createElement(AverageRating, null, averageRating.toFixed(1)))), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: showCtaButtonsRelevantProducts || !isMobile ? "row" : "column",
    gap: "s8",
    width: "100%",
    align: "center"
  }, customButtons ? customButtons : renderButton())))) : /* @__PURE__ */ react.createElement(ProductCard_es_Wrapper, __spreadValues({
    size,
    className: "product-card",
    onAuxClick: onWrapperAuxClick,
    onClick: onWrapperClick
  }, tracking), /* @__PURE__ */ react.createElement(ProductLink, __spreadValues(__spreadValues({}, linkWithSelectPromotionId), props), /* @__PURE__ */ react.createElement(ProductCardContent, null, productVisualWrapper, productName, !!highlightAttribute && /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    marginBottom: "s8"
  }, highlightAttribute), showNewProductGift ? /* @__PURE__ */ react.createElement(ProductGifts$1, {
    gifts,
    hasGift
  }) : productGift())), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: "column",
    gap: "s4",
    justify: "end",
    align: "start",
    width: "100%"
  }, !!averageRating && averageRating > 1 && /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    backgroundColor: "#FFE7BA",
    borderRadius: "s",
    maxWidth: "fit-content"
  }, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    maxWidth: "fit-content",
    align: "middle",
    padding: ["s0", "s4"]
  }, /* @__PURE__ */ react.createElement(RatingFilled_es/* RatingFilled */.A, {
    color: "pending",
    size: "13px"
  }), /* @__PURE__ */ react.createElement(AverageRating, null, averageRating.toFixed(1)))), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: showCtaButtonsRelevantProducts || !isMobile ? "row" : "column",
    align: "center",
    gap: "s8",
    width: "100%"
  }, customButtons ? customButtons : renderButton())));
  return card;
};
const ProductLink = (0,emotion_styled_browser_esm["default"])(CustomLink_es/* CustomLink */.x)`
  display: block;
`;
const ProductCard_es_Wrapper = emotion_styled_browser_esm["default"].div(({ theme, size }) => `
    position: relative;
    width: 100%;
    height: 100%;
    padding: ${theme == null ? void 0 : theme.spacing[ProductCard_es_SIZE[size].padding]};
    display: flex;
    flex-direction: column;
    background-color: #fff;
    justify-content: space-between;
   `);
const StyledIconWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
`;
const ProductCardContent = emotion_styled_browser_esm["default"].div(({ theme }) => `
    position: relative;
    flex: 1 0 auto;
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s8};
`);
const ProductVisualWrapper = emotion_styled_browser_esm["default"].div(({ theme }) => `
    position: relative;
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
`);
const ProductSaleInfo = emotion_styled_browser_esm["default"].div(({ theme, freeship }) => `
    position: relative;
    margin-top: ${theme.spacing.s4};
    padding-right: ${freeship ? "1.5rem" : "unset"} ;
    margin-bottom: ${theme.spacing.s4}
`);
const Brand = emotion_styled_browser_esm["default"].div(({ theme }) => `
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
`);
const TitleTag = (0,emotion_styled_browser_esm["default"])(Tag_es/* Tag */.V)(({ theme }) => `
  margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const InfoTag = (0,emotion_styled_browser_esm["default"])(Tag_es/* Tag */.V)(({ theme }) => `
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
  `);
const InfoTagsWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 0;
  left: 0;
`;
const FlashSaleBadgeWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
`;
const FlashSaleTimerWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
const SavingBadgeWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  bottom: 0;
  left: 0;
`;
const ProductImageWrapper = emotion_styled_browser_esm["default"].div`
  position: relative;
  padding-bottom: 100%;
`;
const ProductImage = (0,emotion_styled_browser_esm["default"])(EnhancedImage_es/* EnhancedImage */.N)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  object-fit: contain;
`;
const ProductNameWrapper = emotion_styled_browser_esm["default"].div`
  height: 3rem;
`;
const ModalConfirmWrap = emotion_styled_browser_esm["default"].h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
  text-align: center;
`;
const StyledH3 = emotion_styled_browser_esm["default"].h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;
const StyledGift = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.secondary50};
`;
const MoreGift = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.secondary50};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;
const AverageRating = emotion_styled_browser_esm["default"].div`
  line-height: 16px;
  font-size: 12px;
  margin-left: 4px;
  font-weight: 400;
`;
const StyleButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)`
  .button-text {
    line-height: 14px;
  }
`;
const OutOfStockLabel = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);

  width: max-content;
  height: 30px;
  padding: 0 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;
  font-size: 12px;
  color: #fff;
  font-weight: 600;

  background: rgba(0, 0, 0, 0.7);
  z-index: 2;
`;




/***/ }),

/***/ 414562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ ProductCarousel; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(816519);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77322);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(428247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(875547);
/* harmony import */ var _HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(784241);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(922859);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductCarousel = (_a) => {
  var _b = _a, {
    products = [],
    productsPerRow,
    className,
    regionName,
    hideCtaButton,
    border,
    customStyleLeftArrow,
    customStyleRightArrow,
    desktopProps
  } = _b, props = __objRest(_b, [
    "products",
    "productsPerRow",
    "className",
    "regionName",
    "hideCtaButton",
    "border",
    "customStyleLeftArrow",
    "customStyleRightArrow",
    "desktopProps"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const trackViewProductListData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return products.map((product) => {
      var _a2, _b2;
      return {
        sku: product.sku || "",
        category: ((_b2 = (_a2 = product.categories) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.name) || ""
      };
    });
  }, [products]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (trackViewProductListData.length > 0) {
      (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackViewProductList */ .u)(trackViewProductListData);
    }
  }, [JSON.stringify(trackViewProductListData)]);
  if (isMobile) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "wrapper-horizontal-slider"
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HorizontalSlider_HorizontalSlider_es_js__WEBPACK_IMPORTED_MODULE_3__/* .HorizontalSlider */ .r, {
      slidesPerView: productsPerRow || 2.3,
      className: "horizontal-slider"
    }, products.map((product, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
      key: product.sku,
      border: !!border
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, product), {
      tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
        regionName,
        isTrackContent: true,
        contentName: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .REGION_CONTENT_MAPPING */ .Rx[regionName] || product.sku,
        target: "productDetail",
        index: index + 1,
        payload: product.bestComboDiscount && Number(product.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
      }) : {},
      addToCart: hideCtaButton ? void 0 : product.addToCart
    }))))));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Glide */ .A, __spreadValues(__spreadProps(__spreadValues({
    perView: productsPerRow || 5,
    perSwipe: "|",
    className,
    customStyleLeftArrow,
    customStyleRightArrow
  }, props), {
    showControl: products.length > (productsPerRow || 5),
    swipeThreshold: products.length > (productsPerRow || 5),
    dragThreshold: products.length > (productsPerRow || 5)
  }), desktopProps), products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, {
    key: item.sku,
    border: !!border
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_4__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getTrackingData */ .O5)({
      regionName,
      isTrackContent: true,
      contentName: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_6__/* .REGION_CONTENT_MAPPING */ .Rx[regionName || ""] || item.sku,
      target: "productDetail",
      index: index + 1,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }),
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Card = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div`
  background: white;
  border-radius: 0.5rem;
`;
const StyledCard = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])(Card)(({ theme, border }) => __spreadValues({
  height: "100%"
}, border ? {
  border: "1px solid",
  borderColor: theme.colors.divider,
  borderRadius: theme.spacing.s8,
  overflow: "hidden"
} : {}));




/***/ }),

/***/ 480219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ ProductGrid; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(212951);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(875547);
/* harmony import */ var _ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(922859);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(917709);








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductGrid = ({
  products,
  productsPerRow = 5,
  regionName,
  contactLink,
  type = "grid",
  hideCtaButton,
  itemsPerPage,
  className
}) => {
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useDevice */ .F)();
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  const page = router.query.page ? Number(router.query.page) : 1;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Wrapper, {
    isMobile,
    className
  }, products == null ? void 0 : products.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Grid, {
    isMobile,
    key: index,
    productsPerRow,
    type
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_ProductCard_ProductCard_es_js__WEBPACK_IMPORTED_MODULE_3__/* .ProductCard */ .I, __spreadProps(__spreadValues({}, item), {
    tracking: regionName ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName,
      contentName: _constants_index_es_js__WEBPACK_IMPORTED_MODULE_5__/* .REGION_CONTENT_MAPPING */ .Rx[regionName] || item.sku,
      target: "productDetail",
      index: itemsPerPage ? index + (page - 1) * itemsPerPage : index,
      payload: item.bestComboDiscount && Number(item.bestComboDiscount) !== 0 ? JSON.stringify({ promotionType: "combo" }) : void 0
    }) : {},
    ctaTracking: regionName && contactLink ? (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName,
      contentName: "contactSale",
      target: contactLink,
      payload: JSON.stringify({ sku: item.sku })
    }) : {},
    type,
    addToCart: hideCtaButton ? void 0 : item.addToCart
  })))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ theme, isMobile }) => `
display: flex;
flex-wrap: wrap;
column-gap: 2px;
place-content: flex-start space-between;
background: ${theme == null ? void 0 : theme.colors.background};
padding: 2px 0;
&::after{
  content: "";
  flex: auto;
}
${isMobile ? "padding: 5px;" : ""}
`);
const Grid = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__["default"].div(({ productsPerRow, type, isMobile }) => `
  background: white;
  margin-bottom: 2px;
  ${type === "grid" ? `width: calc(${100 / productsPerRow}% - 2px);` : "width: 100%;"}
  ${isMobile ? "border-radius: 8px;" : ""}
  }`);




/***/ }),

/***/ 591007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54230);




const isShowRetailPrice = (supplierRetailPrice, latestPrice) => {
  let newSupplierRetailPrice = supplierRetailPrice;
  let newLatestPrice = latestPrice;
  if (typeof supplierRetailPrice === "string") {
    newSupplierRetailPrice = supplierRetailPrice.replace(/[₫đ.]/g, "");
  }
  if (typeof latestPrice === "string") {
    newLatestPrice = latestPrice.replace(/[₫đ.]/g, "");
  }
  return Number(newSupplierRetailPrice) > Number(newLatestPrice);
};
const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  discountPercent,
  textColor = "primary500",
  align = "start",
  size = "m",
  className,
  priceRange,
  numberDisplayFormat
}) => {
  const formattedRetailPrice = typeof supplierRetailPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(supplierRetailPrice, numberDisplayFormat) : supplierRetailPrice;
  const formattedLatestPrice = typeof latestPrice === "number" ? (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(latestPrice, numberDisplayFormat) : latestPrice;
  let renderedRetailPrice, renderedDiscount;
  const renderedLatestPrice = () => {
    if (!priceRange) {
      return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
        className: "att-product-detail-latest-price",
        level: 2,
        color: textColor,
        weight: "bold"
      }, formattedLatestPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
        className: "att-product-detail-latest-price",
        level: 1,
        color: textColor
      }, formattedLatestPrice);
    }
    const formattedMinPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.min, numberDisplayFormat, false);
    const formattedMaxPrice = (0,_helpers_number_es_js__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(priceRange.max, numberDisplayFormat);
    return size === "l" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTitle, {
      level: 2,
      color: textColor,
      weight: "bold",
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSubTitle, {
      level: 1,
      color: textColor,
      line: 1
    }, formattedMinPrice, " - ", formattedMaxPrice);
  };
  switch (size) {
    case "l":
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
    default:
      renderedRetailPrice = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRetailPrice, {
        className: "att-product-detail-retail-price",
        level: 1,
        color: "textSecondary"
      }, formattedRetailPrice);
      renderedDiscount = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS, {
        level: 1,
        color: "red"
      }, discountPercent);
      break;
  }
  const showRetailPrice = supplierRetailPrice && isShowRetailPrice(supplierRetailPrice, latestPrice);
  const isShowDiscount = !!discountPercent;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductPriceWrapper, {
    align,
    className
  }, renderedLatestPrice(), (showRetailPrice || isShowDiscount) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledDiscount, null, showRetailPrice && renderedRetailPrice, isShowDiscount && renderedDiscount));
};
const ProductPriceWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
  height: 2.5rem;
`);
const StyledRetailPrice = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Caption */ .YS)(({ theme }) => `
    text-decoration: line-through;
    margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const StyledDiscount = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  display: flex;
  height: 1rem;
`;
const StyledTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx)`
  word-break: break-all;
`;
const StyledSubTitle = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK)`
  word-break: break-all;
`;




/***/ }),

/***/ 675601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TekoLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(350495);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(987900);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const serverless = typeof window !== "undefined";
const normalizeUrl = (url) => {
  if (!serverless || !url || typeof url !== "string")
    return url;
  if (url.match(/^https?:\/\/([^/]+)/)) {
    const urlObj = new URL(url);
    if (urlObj.hostname === window.location.host) {
      return `${urlObj.pathname}${urlObj.search}`;
    }
  }
  return url;
};
const TekoLink = (_a) => {
  var _b = _a, {
    children,
    href,
    as,
    prefetch = false
  } = _b, rest = __objRest(_b, [
    "children",
    "href",
    "as",
    "prefetch"
  ]);
  const [newState, setNewState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    pathname: (typeof href === "string" ? href : href == null ? void 0 : href.pathname) || "",
    query: {},
    as
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    async function init() {
      if (!href)
        return;
      href = normalizeUrl(href);
      as = normalizeUrl(as);
      if (typeof href === "string") {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)((0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .getUrlObject */ .Bi)(href));
        if (!result.pathname) {
          result.pathname = href;
        }
        setNewState(__spreadProps(__spreadValues({}, result), { as: as || href }));
      } else {
        const result = await (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .resolveTekoPathname */ .K)(href);
        if (!result.pathname && (href == null ? void 0 : href.pathname)) {
          result.pathname = href.pathname;
        }
        setNewState(__spreadProps(__spreadValues(__spreadValues({}, href), result), {
          as: as || ((href == null ? void 0 : href.pathname) ? href : null) || void 0
        }));
      }
    }
    init();
  }, [href, as, setNewState]);
  if (!href) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  }
  if (serverless) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadValues({
      "data-testid": "TekoLink",
      href: { pathname: newState.pathname, query: newState.query },
      as: newState.as,
      prefetch
    }, rest), children);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLink, __spreadProps(__spreadValues({
    "data-testid": "TekoLink",
    href: href || "",
    as
  }, rest), {
    prefetch
  }), children);
};
const StyledLink = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F}
  color: black;
  text-decoration: none;
`;




/***/ }),

/***/ 652966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TopbarButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(428247);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopbarButton = (_a) => {
  var _b = _a, {
    children,
    icon,
    href,
    tracking,
    color,
    target
  } = _b, rest = __objRest(_b, [
    "children",
    "icon",
    "href",
    "tracking",
    "color",
    "target"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, {
    href,
    target
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Button, __spreadValues(__spreadValues({}, tracking && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)(tracking)), rest), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, icon, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spacer, null)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Body */ .uT, {
    level: 1,
    color: color || "white"
  }, children)));
};
const Spacer = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].span`
  width: 0.5rem;
`;
const Button = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].button`
  padding: 0rem 1.25rem;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  height: 42px;
  &:focus {
    outline: none;
  }
`;




/***/ }),

/***/ 154686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ DropdownTheme; },
/* harmony export */   "g": function() { return /* binding */ TopbarDropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(691568);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4247);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var _TopbarButton_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(652966);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var DropdownTheme = /* @__PURE__ */ ((DropdownTheme2) => {
  DropdownTheme2[DropdownTheme2["LANGUAGE"] = 0] = "LANGUAGE";
  DropdownTheme2[DropdownTheme2["MENU"] = 1] = "MENU";
  return DropdownTheme2;
})(DropdownTheme || {});
const TopbarDropdown = ({
  value,
  selectValue,
  options,
  href,
  tracking,
  theme = 0 /* LANGUAGE */,
  icon,
  text
}) => {
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [activeOption, setActiveOption] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(options.find((option) => option.value === value));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setActiveOption(options.find((option) => option.value === value));
  }, [value, options]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .CustomLink */ .x, {
    href
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    onMouseLeave: () => setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopbarButton_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TopbarButton */ .S, __spreadProps(__spreadValues({
    icon: icon || (activeOption == null ? void 0 : activeOption.icon)
  }, tracking && (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)(tracking)), {
    onMouseOver: () => setShow(true)
  }), text || (activeOption == null ? void 0 : activeOption.text)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, {
    show,
    dropdownTheme: theme
  }, options.map((item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Option, {
    key: index
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledListContent, {
    label: item.text,
    icon: item == null ? void 0 : item.icon,
    dropdownTheme: theme,
    borderRadius: "s",
    onClick: () => selectValue(item.value),
    hasDivider: [1 /* MENU */].includes(theme)
  }), [0 /* LANGUAGE */].includes(theme) && item.value === (activeOption == null ? void 0 : activeOption.value) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .CheckOutlined */ .b, {
    size: 24,
    color: "red",
    style: { position: "absolute", right: "8px" }
  }))))));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: relative;
`;
const DropdownMenu = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  display: ${(props) => props.show ? "block" : "none"};
  position: absolute;
  background-color: white;
  z-index: 10000;

  ${({ dropdownTheme }) => {
  switch (dropdownTheme) {
    case 1 /* MENU */:
      return ``;
    default:
      return `
          padding: 4px;
          border-radius: 4px;
          right: 20px;
          top: 35px;
          box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
          min-width: 11rem;
        `;
  }
}}
`;
const Option = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  display: flex;
  align-items: center;
  position: relative;
`;
const StyledListContent = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .ListContent */ .y)`
  cursor: pointer;

  ${({ dropdownTheme, theme }) => {
  switch (dropdownTheme) {
    case 1 /* MENU */:
      return `
          background-color: ${theme.colors.primary500};
          color: white;
          border-radius: unset;
          width: max-content;
          min-width: 100%;

          &:hover {
            background-color: ${theme.colors.primary600};
          }

          &:after {
            right: 0;
            left: 0;
          }
        `;
    default:
      return `
          width: 100%;
          padding: 8px 48px 8px 12px;
        `;
  }
}}
`;




/***/ }),

/***/ 875547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gt": function() { return /* binding */ REGION_NAME; },
/* harmony export */   "Od": function() { return /* binding */ CHAR_WIDTH_RATIOS; },
/* harmony export */   "Ok": function() { return /* binding */ SOURCE_VIDEO; },
/* harmony export */   "Rx": function() { return /* binding */ REGION_CONTENT_MAPPING; },
/* harmony export */   "bM": function() { return /* binding */ defaultSlider; },
/* harmony export */   "cg": function() { return /* binding */ DEFAULT_CHAR_WIDTH_RATIO; },
/* harmony export */   "n6": function() { return /* binding */ DEFAULT_NUMBER_DISPLAY_FORMAT; }
/* harmony export */ });
const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
  thousandSeparator: ".",
  decimalSeparator: ","
};
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});
const CHAR_WIDTH_RATIOS = {
  a: 0.5439,
  b: 0.5615,
  c: 0.5234,
  d: 0.564,
  e: 0.5303,
  f: 0.3477,
  g: 0.5615,
  h: 0.5508,
  i: 0.2432,
  j: 0.2393,
  k: 0.5068,
  l: 0.2432,
  m: 0.877,
  n: 0.5522,
  o: 0.5703,
  p: 0.5615,
  q: 0.5684,
  r: 0.3389,
  s: 0.5161,
  t: 0.3271,
  u: 0.5513,
  v: 0.4844,
  w: 0.7515,
  x: 0.4961,
  y: 0.4731,
  z: 0.4961,
  A: 0.6523,
  B: 0.623,
  C: 0.6509,
  D: 0.6563,
  E: 0.5684,
  F: 0.5527,
  G: 0.6812,
  H: 0.7134,
  I: 0.272,
  J: 0.5518,
  K: 0.6274,
  L: 0.5386,
  M: 0.873,
  N: 0.7134,
  O: 0.688,
  P: 0.6309,
  Q: 0.688,
  R: 0.6162,
  S: 0.5938,
  T: 0.5967,
  U: 0.6484,
  V: 0.6367,
  W: 0.8872,
  X: 0.627,
  Y: 0.6006,
  Z: 0.5991
};
const DEFAULT_CHAR_WIDTH_RATIO = 0.5527;
const REGION_NAME = {
  SIMILAR_PRODUCTS_POPUP: "similarProductsPopup"
};
const REGION_CONTENT_MAPPING = {
  [REGION_NAME.SIMILAR_PRODUCTS_POPUP]: "addToCart"
};




/***/ }),

/***/ 917709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useDevice; },
/* harmony export */   "Y": function() { return /* binding */ DeviceProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const initialState = {
  isMobile: false
};
const DeviceContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(initialState);
const DeviceProvider = ({
  value,
  children
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DeviceContext.Provider, {
    value
  }, children);
};
function useDevice() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(DeviceContext);
  if (!context) {
    throw new Error("useDevice must be inside a DeviceProvider with a state value");
  }
  return context;
}




/***/ }),

/***/ 649771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getComponentSize; },
/* harmony export */   "b": function() { return /* binding */ estimateTextWidth; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(875547);


const getComponentSize = (isMobile) => {
  return isMobile ? "s" : "m";
};
const estimateTextWidth = (text, fontSize) => {
  var _a;
  let width = 0;
  const normalizedText = removeVietnameseAccents(text);
  for (const ch of normalizedText) {
    width += ((_a = _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .CHAR_WIDTH_RATIOS */ .Od[ch]) != null ? _a : _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_CHAR_WIDTH_RATIO */ .cg) * fontSize;
  }
  return Math.round(width * 100) / 100;
};
const removeVietnameseAccents = (text) => {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
};




/***/ }),

/***/ 54230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V2": function() { return /* binding */ numberFormatter; },
/* harmony export */   "kX": function() { return /* binding */ numberParser; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(875547);


const formatCurrency = (value, numberDisplayFormat, includeUnit = true) => {
  if (typeof value !== "number")
    return "";
  let currencyFormat;
  if (includeUnit)
    currencyFormat = new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND"
    });
  else
    currencyFormat = new Intl.NumberFormat("vi-VN");
  const valueWithCurrency = currencyFormat.format(value);
  if (!!numberDisplayFormat) {
    return valueWithCurrency.replaceAll(".", numberDisplayFormat.thousandSeparator);
  } else {
    return valueWithCurrency;
  }
};
const numberFormatter = (value, numberDisplayFormat) => {
  const strValue = String(value);
  const [integerPart, decimalPart = ""] = strValue.split(".");
  return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, (numberDisplayFormat == null ? void 0 : numberDisplayFormat.thousandSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.thousandSeparator */ .n6.thousandSeparator) + (strValue.includes(".") ? `${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}${decimalPart}` : "");
};
const numberParser = (value, numberDisplayFormat) => {
  return (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) === "." ? `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "") : `${value}`.replace(new RegExp(`[^0-9-${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}]`, "g"), "").replace(`${(numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || _constants_index_es_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT.decimalSeparator */ .n6.decimalSeparator}`, ".");
};




/***/ }),

/***/ 487319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ calculateTimeDelta; }
/* harmony export */ });
const calculateTimeDelta = (startTime, endTime) => {
  const fromTimestamp = startTime.getTime();
  const endTimestamp = endTime.getTime();
  const durationInMs = endTimestamp - fromTimestamp;
  const durationInSecond = Math.max(0, Math.round(durationInMs / 1e3));
  return {
    milliseconds: durationInMs,
    days: Math.floor(durationInSecond / (3600 * 24)),
    hours: Math.floor(durationInSecond / 3600 % 24),
    minutes: Math.floor(durationInSecond / 60 % 60),
    seconds: Math.floor(durationInSecond % 60)
  };
};




/***/ }),

/***/ 194446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useQuantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(775002);



const DELAY = 300;
const useQuantity = ({
  addToCart,
  baseQuantity = 0,
  precision = 0,
  shouldRoundValue = true
}) => {
  const [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (addToCart && !loading) {
      setQuantity(addToCart.quantityInCart || baseQuantity);
    }
  }, [addToCart]);
  const updateQuantity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (quantity2) => {
    var _a;
    setLoading(true);
    const normalizedQuantity = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.toFixed)({
      value: quantity2,
      precision,
      shouldRoundValue
    });
    if (normalizedQuantity === 0) {
      await ((_a = addToCart == null ? void 0 : addToCart.onRemoveItem) == null ? void 0 : _a.call(addToCart));
    } else {
      await (addToCart == null ? void 0 : addToCart.onChangeQuantity(normalizedQuantity));
    }
    setLoading(false);
  }, [addToCart, precision, shouldRoundValue]);
  const handleUpdateQuantity = async () => {
    if (quantity && quantity !== (addToCart == null ? void 0 : addToCart.quantityInCart)) {
      await updateQuantity(quantity);
    } else {
      setQuantity((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
    }
  };
  const debounceChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const debounceUpdate = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.debounce)(async (quantity2, onError) => {
      try {
        await updateQuantity(quantity2);
      } catch (error) {
        onError == null ? void 0 : onError(error);
      }
    }, DELAY);
    return (newQuantity) => {
      setQuantity(newQuantity);
      debounceUpdate(newQuantity, () => setQuantity((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity));
    };
  }, [addToCart == null ? void 0 : addToCart.quantityInCart, baseQuantity, updateQuantity]);
  const onIncrease = () => {
    debounceChange(quantity + 1);
  };
  const onDecrease = () => {
    debounceChange(quantity - 1);
  };
  return {
    quantity,
    setQuantity,
    handleUpdateQuantity,
    onIncrease,
    onDecrease,
    loading
  };
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~",
	"Hết hàng": "Out of stock"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 912841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .Z.span`
  width: 100%;
  height: 1px;
  background-color: #e0e0e0;
  display: block;
`;
const Divider = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props));
};




/***/ }),

/***/ 46610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ SvgIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(479690);
/* harmony import */ var _icons_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(172848);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledSvgIcon = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].span(styled_system__WEBPACK_IMPORTED_MODULE_2__.space, ({ imageUrl, color, themeColor, theme, size }) => `
    mask: url("${imageUrl}");
    display: inline-block;
    width: ${size || 50}px;
    height: ${size || 50}px;
    background-color: var(--button-icon-color, 
      ${themeColor && (theme.brand[themeColor] || theme.colors[themeColor]) || color || theme.colors.gray600});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  `);
const SvgIcon = (_a) => {
  var _b = _a, {
    name,
    onClick
  } = _b, props = __objRest(_b, [
    "name",
    "onClick"
  ]);
  const imageUrl = _icons_es_js__WEBPACK_IMPORTED_MODULE_3__/* .iconMap */ .q[name];
  if (!imageUrl) {
    return null;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSvgIcon, __spreadValues({
    onClick,
    imageUrl
  }, props));
};




/***/ }),

/***/ 172848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ iconMap; },
  "c": function() { return /* binding */ icons; }
});

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/account.es.js
var account = "https://shopfront-cdn.tekoapis.com/static/360d583357852b95.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/checklist.es.js
var checklist = "https://shopfront-cdn.tekoapis.com/static/58a618ad98de3016.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/cpu.es.js
var cpu = "https://shopfront-cdn.tekoapis.com/static/a4b4d772feed1003.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/promo.es.js
var promo = "https://shopfront-cdn.tekoapis.com/static/5f10c2b8b58ef165.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/search.es.js
var search = "https://shopfront-cdn.tekoapis.com/static/dc6de02b661eb31c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/shopping-cart.es.js
var shoppingCart = "https://shopfront-cdn.tekoapis.com/static/8ef484d2d38f9da8.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/free-shipping.es.js
var freeShipping = "https://shopfront-cdn.tekoapis.com/static/64c212730613c00d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/close.es.js
var close_es_close = "https://shopfront-cdn.tekoapis.com/static/0364832d695974bf.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-up.es.js
var chevronUp = "https://shopfront-cdn.tekoapis.com/static/5a2fda8b57935427.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-down.es.js
var chevronDown = "https://shopfront-cdn.tekoapis.com/static/c07673d71acde799.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-back.es.js
var chevronBack = "https://shopfront-cdn.tekoapis.com/static/fe7f8bf76f2b838c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/chevron-forward.es.js
var chevronForward = "https://shopfront-cdn.tekoapis.com/static/a655221bd64cacf4.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/location.es.js
var location_es_location = "https://shopfront-cdn.tekoapis.com/static/8cd2ac5f60caff4e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/add-outline.es.js
var addOutline = "https://shopfront-cdn.tekoapis.com/static/949377dd1535d300.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/home.es.js
var home = "https://shopfront-cdn.tekoapis.com/static/03ae0aa735763beb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/grid.es.js
var grid = "https://shopfront-cdn.tekoapis.com/static/bdd63e78510785e1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/notifications.es.js
var notifications = "https://shopfront-cdn.tekoapis.com/static/96f7d19e0c6e8841.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/trash.es.js
var trash = "https://shopfront-cdn.tekoapis.com/static/e0fc0c2da71993c2.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/guarantee-checked.es.js
var guarantee = "https://shopfront-cdn.tekoapis.com/static/61b88b0a6893d3b0.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/help.es.js
var help = "https://shopfront-cdn.tekoapis.com/static/a0ef8604f5a51c92.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/product.es.js
var product = "https://shopfront-cdn.tekoapis.com/static/7de71eb80b44de2e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/favorite.es.js
var favorite = "https://shopfront-cdn.tekoapis.com/static/6859bf852118defe.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/flash-sale.es.js
var flashSale = "https://shopfront-cdn.tekoapis.com/static/b0b6d87219b43554.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-facebook.es.js
var logoFacebook = "https://shopfront-cdn.tekoapis.com/static/4a245cee42ae6bbb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-youtube.es.js
var logoYoutube = "https://shopfront-cdn.tekoapis.com/static/2d3d889a92325278.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-tiktok.es.js
var logoTiktok = "https://shopfront-cdn.tekoapis.com/static/28e4a3a78ca94c96.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-instagram.es.js
var logoInstagram = "https://shopfront-cdn.tekoapis.com/static/e9acf6e5447bc6f5.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/community.es.js
var community = "https://shopfront-cdn.tekoapis.com/static/c71967f1b568ff35.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/call.es.js
var call = "https://shopfront-cdn.tekoapis.com/static/cb825a96c16aeade.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/qr-code.es.js
var qrCode = "https://shopfront-cdn.tekoapis.com/static/7534c48e46ec507e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/time.es.js
var time = "https://shopfront-cdn.tekoapis.com/static/b2c29b7046b45840.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/card.es.js
var card = "https://shopfront-cdn.tekoapis.com/static/abf02ec95226fd05.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/cash.es.js
var cash = "https://shopfront-cdn.tekoapis.com/static/0e924ede5a93187b.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/star.es.js
var star = "https://shopfront-cdn.tekoapis.com/static/6571a6180d3cbf15.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/down.es.js
var down = "https://shopfront-cdn.tekoapis.com/static/06a44350362fc960.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/up.es.js
var up = "https://shopfront-cdn.tekoapis.com/static/91d02f8bbc1b94f9.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/percentage.es.js
var percentage = "https://shopfront-cdn.tekoapis.com/static/fc6f3b4f8e2c8800.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/tag.es.js
var tag = "https://shopfront-cdn.tekoapis.com/static/08ed682a05c137e9.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/circle-close.es.js
var circleClose = "https://shopfront-cdn.tekoapis.com/static/511986a5e2d4e41e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/cash-color.es.js
var cashColor = "https://shopfront-cdn.tekoapis.com/static/fae4d10b55525aea.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/promotion-fill.es.js
var promotionFill = "https://shopfront-cdn.tekoapis.com/static/a2125525237c799e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/plus-default.es.js
var plusDefault = "https://shopfront-cdn.tekoapis.com/static/1cbd090c04c530bc.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/cash-outline.es.js
var cashOutline = "https://shopfront-cdn.tekoapis.com/static/0e924ede5a93187b.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/caution.es.js
var caution = "https://shopfront-cdn.tekoapis.com/static/a1690276bae7d213.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/edit.es.js
var edit = "https://shopfront-cdn.tekoapis.com/static/849013b6dba79f68.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/return-product.es.js
var returnProduct = "https://shopfront-cdn.tekoapis.com/static/ea6d2b8854995476.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/freeshipping-outline.es.js
var freeshippingOutline = "https://shopfront-cdn.tekoapis.com/static/cedacbcaec1a1651.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/freeshipping-color.es.js
var freeshippingColor = "https://shopfront-cdn.tekoapis.com/static/0e5c8af0b6cd0275.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/success.es.js
var success = "https://shopfront-cdn.tekoapis.com/static/16aee9ad56e6c90c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/setting.es.js
var setting = "https://shopfront-cdn.tekoapis.com/static/e9b67a3d2e93b5be.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/laptop.es.js
var laptop = "https://shopfront-cdn.tekoapis.com/static/86553a12f72c9c94.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/shape.es.js
var voucher = "https://shopfront-cdn.tekoapis.com/static/90b396a842b085f8.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-google.es.js
var logoGoogle = "https://shopfront-cdn.tekoapis.com/static/d7b3d575b3e8fc03.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/time-outline.es.js
var timeOutline = "https://shopfront-cdn.tekoapis.com/static/b2c29b7046b45840.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/trending-up-outline.es.js
var trendingUpOutline = "https://shopfront-cdn.tekoapis.com/static/f8a98e7b6265d7ec.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/promotion.es.js
var promotion = "https://shopfront-cdn.tekoapis.com/static/251a15c03b923c4b.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/menu.es.js
var menu = "https://shopfront-cdn.tekoapis.com/static/789d831c0ec23c90.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/arrow_down.es.js
var arrowDown = "https://shopfront-cdn.tekoapis.com/static/e2d2f7be6dc83ff2.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/photo.es.js
var photo = "https://shopfront-cdn.tekoapis.com/static/c486cae13baa79ad.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/excel.es.js
var excel = "https://shopfront-cdn.tekoapis.com/static/56ef3890145be03a.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/messenger-logo.es.js
var messenger = "https://shopfront-cdn.tekoapis.com/static/71a0547de8dec349.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/pdf.es.js
var pdf = "https://shopfront-cdn.tekoapis.com/static/c88ca7dfb6a0adbd.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/tick.es.js
var tick = "https://shopfront-cdn.tekoapis.com/static/df90022c2d1adbfb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/error.es.js
var error = "https://shopfront-cdn.tekoapis.com/static/0e3c0ac5500f8b8c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/bell.es.js
var bell = "https://shopfront-cdn.tekoapis.com/static/c71543de0a174eaf.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/buildpc.es.js
var buildpc = "https://shopfront-cdn.tekoapis.com/static/4c02f4e5830e527a.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/envelope.es.js
var envelope = "https://shopfront-cdn.tekoapis.com/static/a66400b1ee8416d3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/showroom.es.js
var showroom = "https://shopfront-cdn.tekoapis.com/static/b0d0161a0c69c7a1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/support.es.js
var support = "https://shopfront-cdn.tekoapis.com/static/f5ca93aa40fe18ed.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/warranty.es.js
var warranty = "https://shopfront-cdn.tekoapis.com/static/7d9576602ab21004.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/journalist.es.js
var journalist = "https://shopfront-cdn.tekoapis.com/static/fd30b8db36d9b1e3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/chat.es.js
var chat = "https://shopfront-cdn.tekoapis.com/static/aaf120a4ce138b4c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/cpu-icon.es.js
var cpuIcon = "https://shopfront-cdn.tekoapis.com/static/3d7140d43b672ba4.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/mother-board-icon.es.js
var motherBoard = "https://shopfront-cdn.tekoapis.com/static/7bf562748dccb296.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/RAM-icon.es.js
var ram = "https://shopfront-cdn.tekoapis.com/static/5a9f38ba2258d73d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/hard-disk-icon.es.js
var hdd = "https://shopfront-cdn.tekoapis.com/static/e95dec823dfc9cba.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/ssd-disk-icon.es.js
var ssd = "https://shopfront-cdn.tekoapis.com/static/f9387823f4497274.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/grphics-card-icon.es.js
var vga = "https://shopfront-cdn.tekoapis.com/static/a54a3adf0f0f78ab.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/power-icon.es.js
var power = "https://shopfront-cdn.tekoapis.com/static/8c661c8671413d6f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/chassis-icon.es.js
var chassis = "https://shopfront-cdn.tekoapis.com/static/d1303b3e3941860c.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/heat-sink-icon.es.js
var heatSink = "https://shopfront-cdn.tekoapis.com/static/d2202e2b35bcb4db.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/monitor-icon.es.js
var monitor = "https://shopfront-cdn.tekoapis.com/static/7a92580cceeadb46.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/keyboard-icon.es.js
var keyboard = "https://shopfront-cdn.tekoapis.com/static/c1839840a81c5861.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/mouse-icon.es.js
var mouse = "https://shopfront-cdn.tekoapis.com/static/56345fd3fd3da76d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/gift.es.js
var gift = "https://shopfront-cdn.tekoapis.com/static/2b8403d1ea147a23.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/dino.es.js
var dino = "https://shopfront-cdn.tekoapis.com/static/586024ada7459afb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/dino-icon.es.js
var dinoIcon = "https://shopfront-cdn.tekoapis.com/static/fc13827d222b8c0d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/more-info.es.js
var moreInfo = "https://shopfront-cdn.tekoapis.com/static/98504a319c079288.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/grid-layout.es.js
var gridLayout = "https://shopfront-cdn.tekoapis.com/static/aae8334388f296cc.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/list-layout.es.js
var listLayout = "https://shopfront-cdn.tekoapis.com/static/10a387fb698bb09d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/filter.es.js
var filter = "https://shopfront-cdn.tekoapis.com/static/fc1421026697d60f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/filter-sort-by.es.js
var filterSortBy = "https://shopfront-cdn.tekoapis.com/static/3c8bba9fb4200565.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/check.es.js
var check = "https://shopfront-cdn.tekoapis.com/static/d2123313b305a219.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/news.es.js
var news = "https://shopfront-cdn.tekoapis.com/static/3a4cd6f50be1dbbb.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/upload.es.js
var upload = "https://shopfront-cdn.tekoapis.com/static/c12fdd40ddee1ea3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/caret-down.es.js
var caretDown = "https://shopfront-cdn.tekoapis.com/static/4c1c0e464c3b7961.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/more.es.js
var more = "https://shopfront-cdn.tekoapis.com/static/8e70a9b045206df7.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/clock.es.js
var clock = "https://shopfront-cdn.tekoapis.com/static/c1ea89899161ab54.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/checkbox.es.js
var checkbox_es_checkbox = "https://shopfront-cdn.tekoapis.com/static/2325f68c1e3eab10.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/plus.es.js
var plus = "https://shopfront-cdn.tekoapis.com/static/f04b3233a3780d10.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/subtract.es.js
var subtract = "https://shopfront-cdn.tekoapis.com/static/61d838e201b3d02d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/bag_checkmark.es.js
var bag_checkmark = "https://shopfront-cdn.tekoapis.com/static/97ff32f4d297003f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/download.es.js
var download = "https://shopfront-cdn.tekoapis.com/static/1a12d49243365c56.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logout.es.js
var logout = "https://shopfront-cdn.tekoapis.com/static/ab3ea40352f63ad2.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/calendar.es.js
var calendar = "https://shopfront-cdn.tekoapis.com/static/3c2b47d8956c44b3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/phone.es.js
var phone = "https://shopfront-cdn.tekoapis.com/static/82e24372ab515af4.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/business-person.es.js
var businessPerson = "https://shopfront-cdn.tekoapis.com/static/22eb9c4eaaae04c3.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/Plus-circle.es.js
var plusCircle = "https://shopfront-cdn.tekoapis.com/static/35b9af99a5fd3532.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/letter.es.js
var letter = "https://shopfront-cdn.tekoapis.com/static/95bf036e0047e5de.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/return-vnd.es.js
var returnVnd = "https://shopfront-cdn.tekoapis.com/static/c70fd35508218057.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/report-sold.es.js
var reportSold = "https://shopfront-cdn.tekoapis.com/static/19a896d6b4db97b8.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/sellout.es.js
var sellOut = "https://shopfront-cdn.tekoapis.com/static/7efaee58ad023c8f.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/reports.es.js
var reports = "https://shopfront-cdn.tekoapis.com/static/9ac20b6cb17519be.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/minus.es.js
var minus = "https://shopfront-cdn.tekoapis.com/static/541582955daa66c1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/refresh.es.js
var refresh = "https://shopfront-cdn.tekoapis.com/static/07001edfcdc8d627.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/voucher-cash.es.js
var voucherCash = "https://shopfront-cdn.tekoapis.com/static/1217c4c74ed67be1.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/loyalty.es.js
var loyalty = "https://shopfront-cdn.tekoapis.com/static/fedbd47700ec8fe6.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/zalo.es.js
var zalo = "https://shopfront-cdn.tekoapis.com/static/20f9b470a01bcc4e.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/share.es.js
var share = "https://shopfront-cdn.tekoapis.com/static/7c85713d791fb634.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/email.es.js
var email = "https://shopfront-cdn.tekoapis.com/static/22f44138cac1453a.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/logo-zalo.es.js
var logoZalo = "https://shopfront-cdn.tekoapis.com/static/98a2b9aacbb59a62.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/linkedin.es.js
var linkedin = "https://shopfront-cdn.tekoapis.com/static/c45c0304dbe3b0ac.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/images/id-card.es.js
var idCart = "https://shopfront-cdn.tekoapis.com/static/66485d061b21552d.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/SvgIcon/icons.es.js




























































































































const iconMap = {
  account: account,
  checklist: checklist,
  cpu: cpu,
  promo: promo,
  search: search,
  "shopping-cart": shoppingCart,
  "free-shipping": freeShipping,
  close: close_es_close,
  "chevron-up": chevronUp,
  "chevron-down": chevronDown,
  location: location_es_location,
  "add-outline": addOutline,
  "chevron-back": chevronBack,
  "chevron-forward": chevronForward,
  home: home,
  grid: grid,
  notifications: notifications,
  trash: trash,
  guarantee: guarantee,
  help: help,
  product: product,
  favorite: favorite,
  "flash-sale": flashSale,
  "logo-facebook": logoFacebook,
  "logo-youtube": logoYoutube,
  community: community,
  call: call,
  "qr-code": qrCode,
  time: time,
  card: card,
  cash: cash,
  star: star,
  down: down,
  up: up,
  percentage: percentage,
  tag: tag,
  "circle-close": circleClose,
  "cash-color": cashColor,
  "promotion-fill": promotionFill,
  "plus-default": plusDefault,
  "cash-outline": cashOutline,
  caution: caution,
  edit: edit,
  "return-product": returnProduct,
  "freeshipping-outline": freeshippingOutline,
  "freeshipping-color": freeshippingColor,
  success: success,
  setting: setting,
  laptop: laptop,
  voucher: voucher,
  "logo-google": logoGoogle,
  "time-outline": timeOutline,
  "trending-up-outline": trendingUpOutline,
  promotion: promotion,
  menu: menu,
  photo: photo,
  excel: excel,
  "arrow-down": arrowDown,
  messenger: messenger,
  pdf: pdf,
  tick: tick,
  error: error,
  bell: bell,
  buildpc: buildpc,
  envelope: envelope,
  showroom: showroom,
  support: support,
  warranty: warranty,
  journalist: journalist,
  chat: chat,
  "cpu-icon": cpuIcon,
  "mother-board": motherBoard,
  ram: ram,
  hdd: hdd,
  ssd: ssd,
  vga: vga,
  power: power,
  chassis: chassis,
  "heat-sink": heatSink,
  monitor: monitor,
  keyboard: keyboard,
  mouse: mouse,
  gift: gift,
  dino: dino,
  "dino-icon": dinoIcon,
  more: more,
  "more-info": moreInfo,
  "grid-layout": gridLayout,
  "list-layout": listLayout,
  filter: filter,
  "filter-sort-by": filterSortBy,
  check: check,
  news: news,
  "caret-down": caretDown,
  upload: upload,
  clock: clock,
  checkbox: checkbox_es_checkbox,
  plus: plus,
  subtract: subtract,
  "bag-checkmark": bag_checkmark,
  download: download,
  logout: logout,
  calendar: calendar,
  phone: phone,
  "business-person": businessPerson,
  "plus-circle": plusCircle,
  letter: letter,
  "return-vnd": returnVnd,
  "report-sold": reportSold,
  sellout: sellOut,
  reports: reports,
  minus: minus,
  refresh: refresh,
  "voucher-cash": voucherCash,
  loyalty: loyalty,
  zalo: zalo,
  share: share,
  "logo-tiktok": logoTiktok,
  "logo-instagram": logoInstagram,
  email: email,
  "logo-zalo": logoZalo,
  linkedin: linkedin,
  "id-card": idCart
};
const icons = Object.keys(iconMap);




/***/ }),

/***/ 55257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Overlay; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(926759);
/* harmony import */ var _hooks_useEventCallback_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(558397);




const Overlay = ({
  show,
  children,
  onEscPressed
}) => {
  const elmRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  const [, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    const elm = document.createElement("div");
    elm.style.position = "fixed";
    elm.style.top = "0";
    elm.style.left = "0";
    elm.style.right = "0";
    elm.style.bottom = "0";
    elm.style.zIndex = "1070";
    elm.style.display = "flex";
    elm.style.justifyContent = "center";
    elm.style.alignItems = "center";
    elm.style.background = "rgba(0, 0, 0, 0.1)";
    elmRef.current = elm;
    document.body.appendChild(elm);
    setValue((value) => value + 1);
    return () => {
      document.body.removeChild(elm);
    };
  }, [show]);
  const handleDocumentKeyDown = (0,_hooks_useEventCallback_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useEventCallback */ .$)((e) => {
    if (e.keyCode === 27 && onEscPressed) {
      onEscPressed();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    document.addEventListener("keydown", handleDocumentKeyDown);
    return () => {
      document.removeEventListener("keydown", handleDocumentKeyDown);
    };
  }, [show]);
  if (!show || !elmRef.current) {
    return null;
  }
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, elmRef.current);
};




/***/ }),

/***/ 145000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46183);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _molecules_Overlay_Overlay_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55257);





const Backdrop = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
  sm: "400px",
  md: "700px",
  lg: "960px"
};
const ModalContent = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme, size, maxHeight, borderRadius }) => `
  background-color: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  width: ${sizeMaps[size]};
  border-radius: ${borderRadius ? borderRadius : theme.borderRadius};
  max-height: ${maxHeight ? maxHeight : `90%`};
  z-index: 1060;
  position: relative;
  overflow-y: auto;
`);
const Modal = ({
  show,
  onHide,
  children,
  className,
  size = "md",
  maxHeight,
  borderRadius
}) => {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (typeof document !== "undefined") {
      if (show) {
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${(0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .getScrollbarWidth */ .np)()}px`;
      }
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "unset";
    };
  }, [show]);
  if (!show)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_molecules_Overlay_Overlay_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .a, {
    show,
    onEscPressed: onHide
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Backdrop, {
    onClick: onHide
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ModalContent, {
    className,
    size,
    borderRadius,
    maxHeight
  }, children));
};




/***/ }),

/***/ 776609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ ModalBody; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ModalBody = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  flex: 1 1 auto;
  padding: 0.5rem 2rem;
  position: relative;
`;




/***/ }),

/***/ 188155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalHeader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);



const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  padding: 1rem;
  text-align: center;
  .title {
    margin-bottom: 0;
  }
`;
const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
  className
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h5", {
  className: "title"
}, children));




/***/ }),

/***/ 349055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ theme; }
/* harmony export */ });
const colors = {
  white: "#FFFFFF",
  blue: "#1435c3",
  light: "#F8F9FA",
  lightblue: "#5fe7ff",
  dark: "#333",
  success: "#53C305",
  successBg: "#F4FFF2",
  success500: "#30CD60",
  error: "#EB2101",
  error500: "#DA4343",
  errorBg: "#FFF2F2",
  neutral: "#848788",
  placeholder: "#A7ABC3",
  border: "#E4E5F0",
  background: "#F6F6F6",
  warning: "#F78212",
  warningBg: "#FCF8E3",
  link: "#047FFF",
  link500: "#1990FF",
  linkBg: "#F0F7FF",
  disable: "#D2D2D2",
  sunYellow: "#FFD125",
  text: "#434657",
  red: "#ef2741",
  black: "#000000",
  gray50: "#FAFAFA",
  gray100: "#F5F5F5",
  gray130: "#82869E",
  gray200: "#EEEEEE",
  gray300: "#E0E0E0",
  gray400: "#BDBDBD",
  gray500: "#9E9E9E",
  gray600: "#757575",
  gray700: "#616161",
  gray800: "#424242",
  gray900: "#212121",
  green50: "#E8F5E9",
  green100: "#C8E6C9",
  green200: "#A5D6A7",
  green300: "#81C784",
  green400: "#66BB6A",
  green500: "#4CAF50",
  green600: "#43A047",
  green700: "#388E3C",
  green800: "#2E7D32",
  green900: "#1B5E20",
  blue50: "#E3F2FD",
  blue100: "#BBDEFB",
  blue200: "#90CAF9",
  blue300: "#64B5F6",
  blue400: "#42A5F5",
  blue500: "#2196F3",
  blue600: "#1E88E5",
  blue700: "#1976D2",
  blue800: "#1565C0",
  blue900: "#0D47A1",
  linear: ""
};
const theme = {
  brand: {
    primary: colors.blue,
    secondary: colors.lightblue,
    tertiary: "#E6EEFF",
    background: "#f1f0f1",
    loading: colors.blue,
    linear: ""
  },
  colors,
  breakpoints: ["576px", "768px", "1024px"],
  borderRadius: "8px"
};




/***/ }),

/***/ 580871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useTheme; },
/* harmony export */   "f": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(962470);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(349055);




const ThemeProvider = ({
  theme: theme$1 = _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_1__/* .theme */ .r,
  children
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_2__.a, {
    theme: theme$1
  }, children);
};
function useTheme() {
  const theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.u)();
  return theme;
}




/***/ }),

/***/ 46183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nc": function() { return /* binding */ getImageUrlFromGoogleUserContent; },
/* harmony export */   "Nq": function() { return /* binding */ canUseDOM; },
/* harmony export */   "TH": function() { return /* binding */ getMoneyValueUnit; },
/* harmony export */   "np": function() { return /* binding */ getScrollbarWidth; }
/* harmony export */ });
const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
const getScrollbarWidth = () => {
  let width = 0;
  if (typeof window !== "undefined") {
    if (window.scrollbarWidth && document.body.scrollHeight > window.innerHeight) {
      return window.scrollbarWidth;
    }
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    width = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    window.scrollbarWidth = width;
  }
  return width;
};
const getMoneyValueUnit = (value) => {
  if (value < 1e6)
    return { value: Math.round(value / 1e3 * 1e3) / 1e3, unit: "K" };
  if (value > 1e9)
    return {
      value: Math.round(value / 1e9 * 1e3) / 1e3,
      unit: "t\u1EF7"
    };
  return { value: Math.round(value / 1e6 * 1e3) / 1e3, unit: "tr" };
};
const getImageUrlFromGoogleUserContent = (imageUrl, imageWidth) => {
  let result = imageUrl;
  if (imageUrl.includes("googleusercontent.com")) {
    if (imageWidth) {
      result = `${imageUrl}=w${imageWidth}`;
    }
  }
  return result;
};




/***/ }),

/***/ 558397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useEventCallback = (fn, deps) => {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fn);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = fn;
  }, [fn, ...deps]);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((...args) => {
    const callback = ref.current;
    callback(...args);
  }, [ref]);
};




/***/ }),

/***/ 855271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ styled$1; },
/* harmony export */   "z": function() { return /* binding */ styled; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);


const styled = _emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"];
var styled$1 = styled;




/***/ }),

/***/ 546580:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(159702);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 644525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ PrivacyPolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(329944);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(115869);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(212951);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(628382);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59181);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(446586);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(428247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 16px;\n  display: flex;\n  gap: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const PrivacyPolicies = (props)=>{
    const { policies , trackingScreenName , setPolicies , isLoggedIn , hideWarning , disableChangeApproval , originalPolicies ,  } = props;
    const { 0: selectAllOption , 1: setSelectAllOption  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(()=>policies.every((v)=>v.policyTypeId === types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1 || v.isApproved));
    const { isMobile  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const displayPolicies = [
        ...policies
    ];
    /**
   * Thêm 'Chọn tất cả' khi số lượng policies có PolicyTypeId khác TYPE_1 >= 2
   * */ if (policies.filter((policy)=>policy.policyTypeId !== types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1).length >= 2) {
        var ref;
        const policyType1Index = (ref = policies.findLastIndex) === null || ref === void 0 ? void 0 : ref.call(policies, (policy)=>policy.policyTypeId === types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1);
        const selectAllOptionIndex = policyType1Index === -1 ? 0 : policyType1Index + 1;
        displayPolicies.splice(selectAllOptionIndex, 0, {
            id: types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_ALL */ .Y.TYPE_ALL,
            policyTypeId: types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_ALL */ .Y.TYPE_ALL,
            isApprovalRequired: false,
            isApproved: selectAllOption,
            description: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Chọn tất cả"),
            language: "",
            version: 0
        });
    }
    const changePolicyApproval = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((id, state)=>{
        const newPolicies = policies.map((policy)=>{
            if (policy.id === id) {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .trackManually */ .gu)(state ? "checkPrivacy" : "uncheckPrivacy", "privacyContent", "", JSON.stringify({
                    screenName: trackingScreenName,
                    policy: policy.description
                }));
                return _objectSpreadProps(_objectSpread({}, policy), {
                    isApproved: state
                });
            } else return policy;
        });
        setPolicies(newPolicies);
        const isSelectedAllPolicies = newPolicies.every((v)=>v.policyTypeId === types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1 ? true : v.isApproved);
        setSelectAllOption(isSelectedAllPolicies);
    }, [
        policies
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpreadProps(_objectSpread({
        style: {
            textAlign: "left"
        }
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_6__/* .getTrackingData */ .O5)({
        isTrackContent: true,
        contentName: "showPrivacPolicy",
        regionName: "privacyContent",
        payload: JSON.stringify({
            screenName: trackingScreenName,
            policies
        })
    })), {
        children: displayPolicies.map((policy)=>{
            // find the outermost html tag of in the string
            const HTMLTag = policy.description[0] === "<" ? policy.description// start at 1 since we don't want to include '<'
            .substring(1, policy.description.indexOf(">"))// split by space in case html tag has attributes in it
            .split(" ") : "";
            switch(policy.policyTypeId){
                case types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1:
                    return !hideWarning ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(WarningPolicyWrapper, {
                        isMobile: isMobile,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .InforOutlined */ .l, {
                                size: 24,
                                color: "pending600",
                                style: {
                                    flex: "0 0 auto"
                                }
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)("Ch\xfang t\xf4i c\xf3 c\xe1c cập nhật li\xean quan đến việc xử l\xfd dữ liệu c\xe1 nh\xe2n. Vui l\xf2ng kiểm tra v\xe0 x\xe1c nhận. C\xe1c ch\xednh s\xe1ch c\xf3 đ\xe1nh dấu * l\xe0 bắt buộc x\xe1c nhận để tiếp tục sử dụng dịch vụ.")
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HTMLContentContainer, {
                                dangerouslySetInnerHTML: {
                                    __html: policy.description
                                }
                            })
                        ]
                    }, policy.id) : null;
                case types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_ALL */ .Y.TYPE_ALL:
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            hideWarning ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_8__/* .Divider */ .i, {
                                color: "border"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SelectablePolicyWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Checkbox */ .X, {
                                        height: "min-content",
                                        checked: selectAllOption,
                                        onChange: (state)=>{
                                            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_5__/* .trackManually */ .gu)(state ? "checkAllPrivacy" : "uncheckAllPrivacy", "privacyContent", "", JSON.stringify({
                                                screenName: trackingScreenName,
                                                policy: policy.description
                                            }));
                                            setSelectAllOption(state);
                                            setPolicies((prev)=>{
                                                return prev.map((policyValue)=>_objectSpreadProps(_objectSpread({}, policyValue), {
                                                        isApproved: policyValue.policyTypeId !== types__WEBPACK_IMPORTED_MODULE_2__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1 ? disableChangeApproval && policyValue.isApprovalRequired ? true : state : policyValue.isApproved
                                                    }));
                                            });
                                        },
                                        border: disableChangeApproval ? "" : "1px solid black",
                                        style: {
                                            borderRadius: "2px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: policy.description
                                    })
                                ]
                            })
                        ]
                    }, policy.id);
                default:
                    var ref;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SelectablePolicyWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Checkbox */ .X, {
                                height: "min-content",
                                checked: policy.isApproved,
                                onChange: (state)=>{
                                    var ref;
                                    return disableChangeApproval && policy.isApprovalRequired && ((ref = originalPolicies === null || originalPolicies === void 0 ? void 0 : originalPolicies.find((p)=>p.id === policy.id)) === null || ref === void 0 ? void 0 : ref.isApproved) ? null : changePolicyApproval(policy.id, state);
                                },
                                disabled: disableChangeApproval && policy.isApprovalRequired && ((ref = originalPolicies === null || originalPolicies === void 0 ? void 0 : originalPolicies.find((p)=>p.id === policy.id)) === null || ref === void 0 ? void 0 : ref.isApproved),
                                border: disableChangeApproval ? "" : "1px solid black",
                                style: {
                                    borderRadius: "2px"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HTMLContentContainer, {
                                isRequire: policy.isApprovalRequired,
                                HTMLTag: HTMLTag[0],
                                dangerouslySetInnerHTML: {
                                    __html: !!HTMLTag ? policy.description : "<div>".concat(policy.description, "</div>")
                                }
                            })
                        ]
                    }, policy.id);
            }
        })
    }));
};
const WarningPolicyWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__["default"].div((param)=>{
    let { theme , isMobile  } = param;
    return "\n    padding: 8px 12px;\n    background-color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.pending100, ";\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.pending600, ";\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: ").concat(isMobile ? "8px" : "16px", ";\n");
});
const SelectablePolicyWrapper = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__["default"].div(_templateObject());
const HTMLContentContainer = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__["default"].div((param)=>{
    let { theme , isRequire , HTMLTag  } = param;
    return "\n  display: inline-block;\n  & > p {\n    margin: 0px;\n  }\n  ".concat(isRequire ? !!HTMLTag ? "& > ".concat(HTMLTag, ':first-child::before {\n        content: "*";\n        margin-right: 0.5rem;\n        color: ').concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n      }") : '& > div:first-child::before {\n        content: "*";\n        margin-right: 0.5rem;\n        color: '.concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n      }") : "", "\n");
});


/***/ }),

/***/ 288257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ WishlistButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(983546);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(106454);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(743126);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(728873);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(512495);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(428247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(775002);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(643015);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(684443);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(508285);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










const WishlistButton = (param)=>{
    let { sku , size ="26"  } = param;
    var ref;
    const { user , setUser , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
    const { showModal  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .useModal */ .d)();
    const { userService  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    const [, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .useLoading */ .r$)("wishListButton");
    const { isMobile , appName  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const toast = (0,_contexts__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .p)(isMobile);
    const isWishList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        var ref, ref1;
        return !!(user === null || user === void 0 ? void 0 : (ref = user.metaData) === null || ref === void 0 ? void 0 : (ref1 = ref.wishList) === null || ref1 === void 0 ? void 0 : ref1.includes(sku));
    }, [
        sku,
        user === null || user === void 0 ? void 0 : (ref = user.metaData) === null || ref === void 0 ? void 0 : ref.wishList
    ]);
    const handleWhenNotLogin = ()=>{
        showModal({
            size: "m",
            title: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Th\xf4ng b\xe1o"),
            centeredTitle: true,
            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Đăng nhập"),
            cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Đ\xf3ng"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .k, {
                direction: "column",
                align: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .Body */ .uT, {
                    marginTop: "s4",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Vui l\xf2ng đăng nhập t\xe0i khoản {{appName}} để th\xeam sản phẩm y\xeau th\xedch", {
                        appName: appName || ""
                    })
                })
            }),
            onOk: ()=>authService.login()
        });
    };
    const onClickWishList = async ()=>{
        try {
            var ref;
            if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                handleWhenNotLogin();
                return;
            }
            setLoading(true);
            const previousMetaData = (user === null || user === void 0 ? void 0 : user.metaData) || {};
            const previousWishlist = (previousMetaData === null || previousMetaData === void 0 ? void 0 : previousMetaData.wishList) || [];
            const listSku = [
                sku,
                ...previousWishlist
            ];
            const diskListSku = previousWishlist.filter((item)=>item !== sku);
            const profile = await userService.updateProfile({
                metaData: _objectSpreadProps(_objectSpread({}, previousMetaData), {
                    wishList: isWishList ? diskListSku : listSku
                })
            });
            const updatedProfile = _objectSpread({}, user, (0,_teko_utils__WEBPACK_IMPORTED_MODULE_12__.cleanObject)(profile));
            setUser(updatedProfile);
            setLoading(false);
            if (updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref = updatedProfile.metaData) === null || ref === void 0 ? void 0 : ref.wishList.includes(sku)) {
                var ref1;
                (ref1 = toast.success) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                    title: "",
                    message: "",
                    duration: 3000,
                    closeable: false,
                    [isMobile ? "message" : "title"]: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                        level: 2,
                        children: [
                            (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)('Th\xeam th\xe0nh c\xf4ng v\xe0o mục "Sản phẩm y\xeau th\xedch". '),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/account/wish-list",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        color: _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .themeColor.link500 */ .E.link500
                                    },
                                    className: "text",
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Xem ngay")
                                })
                            })
                        ]
                    })
                });
            } else {
                var ref2;
                (ref2 = toast.success) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                    title: "",
                    message: "",
                    duration: 3000,
                    closeable: false,
                    [isMobile ? "message" : "title"]: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)('Xo\xe1 th\xe0nh c\xf4ng khỏi mục "Sản phẩm y\xeau th\xedch."')
                });
            }
        } catch (error) {
            var ref3;
            setLoading(false);
            (ref3 = toast.error) === null || ref3 === void 0 ? void 0 : ref3.call(toast, {
                title: "",
                message: "",
                duration: 3000,
                closeable: false,
                [isMobile ? "message" : "title"]: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("C\xf3 lỗi xảy ra")
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isWishList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__/* .FavouriteFilled */ .e, _objectSpread({
            onClick: (event)=>{
                event.preventDefault();
                onClickWishList();
            },
            size: size,
            color: "primary",
            style: {
                cursor: "pointer"
            }
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_15__/* .getTrackingData */ .O5)({
            isTrackContent: true,
            contentName: "removeWishlist",
            payload: sku
        }))) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_16__/* .FavouriteAlternativeOutlined */ .w, _objectSpread({
            onClick: (event)=>{
                event.preventDefault();
                onClickWishList();
            },
            size: size,
            color: "primary",
            style: {
                cursor: "pointer"
            }
        }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_15__/* .getTrackingData */ .O5)({
            isTrackContent: true,
            contentName: "addWishlist",
            payload: sku
        })))
    });
};


/***/ }),

/***/ 211888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ LanguageSelector; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(718024);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(280114);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(154686);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(788813);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(634655);







const LanguageSelector = ()=>{
    const { currentLanguage , availableLanguages  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const options = (availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.map((language)=>{
        switch(language){
            case "vi":
                return {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Tiếng Việt"),
                    value: language,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .VietnamColored */ .m, {})
                };
            case "en":
                return {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("English"),
                    value: language,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .UsaColored */ .E, {})
                };
            default:
                return {
                    text: (0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Ng\xf4n ngữ kh\xe1c"),
                    value: language,
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .VietnamColored */ .m, {})
                };
        }
    })) || [];
    const onSelectLanguage = (value)=>{
        // UX4BUYER-4531
        // make sure passed value is string
        const language = value.toString();
        const currentDate = new Date();
        const date = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDay());
        const expireDate = date.toUTCString();
        const newUrl = new URL(window.location.href);
        (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .setCookieByName */ .Re)("lang", language, expireDate, "/");
        newUrl.searchParams.set("lang", language);
        window.location.href = newUrl.href;
    };
    return !!currentLanguage && !!(availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.length) && availableLanguages.length > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_7__/* .TopbarDropdown */ .g, {
        value: currentLanguage,
        selectValue: onSelectLanguage,
        options: options
    }, 3) : null;
};


/***/ }),

/***/ 12800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ RelatedProductsBottomSheet; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(149933);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(676662);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(811495);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212808);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80912);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(480219);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(875547);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(185081);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(684443);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88837);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  min-height: 56px;\n  padding: 16px 12px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #fff;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







const RelatedProductsBottomSheet = (props)=>{
    const { sku , categoryId , imageUrl , name , closeBottomSheet , onBack  } = props;
    const { passSkuToReturnSimilarProducts , contactLink  } = (0,hooks__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    const searchRelatedProductsParams = !!sku && passSkuToReturnSimilarProducts ? {
        page: 1,
        pageSize: constants_index__WEBPACK_IMPORTED_MODULE_2__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl,
        filter: {
            skuToReturnSimilarProducts: sku
        }
    } : !!categoryId && !!sku ? {
        page: 1,
        pageSize: constants_index__WEBPACK_IMPORTED_MODULE_2__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl,
        filter: {
            excludedSkus: [
                sku
            ],
            categoryIds: [
                categoryId
            ]
        }
    } : {};
    const { result: searchRelatedProductsResult , isLoading  } = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useSearch */ .Rx)(searchRelatedProductsParams);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_4__/* .BottomSheet */ .R, {
        zIndex: 1051,
        show: !!sku,
        contentHeight: "80vh",
        showBottomSheetHeader: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .JX, {
            backgroundColor: "background",
            borderTop: "2px solid background",
            height: "100%",
            width: "100vw",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Header, {
                    align: "center",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .LeftOutlined */ .D, {
                            size: 20,
                            color: "black",
                            onClick: onBack
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderTitle, {
                            level: 1,
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Sản phẩm tương tự")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .CloseOutlined */ .X, {
                            size: 24,
                            color: "black",
                            onClick: closeBottomSheet
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .Loading */ .g, {
                    isLoading: isLoading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .k, {
                    backgroundColor: "white",
                    align: "center",
                    justify: "start",
                    margin: [
                        "s8",
                        "s8",
                        "s4",
                        "s8"
                    ],
                    padding: "s4",
                    borderRadius: "m",
                    gap: "s4",
                    children: [
                        imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_11__/* .LazyImage */ .w, {
                            width: "60px",
                            height: "60px",
                            src: imageUrl,
                            contain: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                flex: 1
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT, {
                                level: 1,
                                line: 2,
                                children: name
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT, {
                    level: 1,
                    paddingLeft: "s8",
                    marginBottom: "s4",
                    children: [
                        (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("T\xecm thấy"),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                            children: [
                                searchRelatedProductsResult.pagination.totalItems < constants_index__WEBPACK_IMPORTED_MODULE_2__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl ? searchRelatedProductsResult.pagination.totalItems : constants_index__WEBPACK_IMPORTED_MODULE_2__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl,
                                " "
                            ]
                        }),
                        (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("sản phẩm tương tự")
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_13__/* .ProductGrid */ .e, {
                    type: "grid",
                    products: searchRelatedProductsResult.products,
                    regionName: _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_14__/* .REGION_NAME.SIMILAR_PRODUCTS_POPUP */ .Gt.SIMILAR_PRODUCTS_POPUP,
                    contactLink: contactLink,
                    productsPerRow: 2,
                    itemsPerPage: constants_index__WEBPACK_IMPORTED_MODULE_2__/* .LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */ .Fl
                })
            ]
        })
    });
};
const Header = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .k)(_templateObject());
const HeaderTitle = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__["default"])(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_12__/* .Body */ .uT)(_templateObject1());


/***/ }),

/***/ 284587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ev": function() { return /* binding */ LOGIN_METHOD; },
/* harmony export */   "n6": function() { return /* binding */ DEFAULT_NUMBER_DISPLAY_FORMAT; }
/* harmony export */ });
/* unused harmony export INTERNAL_REQUEST_TIMEOUT_MS */















const INTERNAL_REQUEST_TIMEOUT_MS = 2000;
// please do not export ibank from here
// it would affect server code
// export * from './ibank';
const LOGIN_METHOD = {
    FACEBOOK: "FACEBOOK",
    GOOGLE: "GOOGLE",
    PHONE: "PHONE"
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
    thousandSeparator: ".",
    decimalSeparator: ","
};


/***/ }),

/***/ 479228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GX": function() { return /* binding */ SESSION_STORAGE_LOCATION_MESSAGE; },
/* harmony export */   "J0": function() { return /* binding */ SESSION_STORAGE_LOCATION_HINT_SHOWED; },
/* harmony export */   "Tp": function() { return /* binding */ userSelectedConstants; },
/* harmony export */   "h8": function() { return /* binding */ LOCALSTORAGE_SELECTED_PAYMENT_METHOD; },
/* harmony export */   "rw": function() { return /* binding */ ARROW_KEY_UP; },
/* harmony export */   "sf": function() { return /* binding */ ARROW_KEY_DOWN; }
/* harmony export */ });
/* unused harmony exports ARROW_KEY_RIGH, ARROW_KEY_LEFT, VNS_ORDER_MANAGEMENT_LOCATION, LOCALSTORAGE_CART_APPLY_COUPON, LOCALSTORAGE_CART_OPEN_COUPON_SELECTOR */
const ARROW_KEY_UP = 38;
const ARROW_KEY_DOWN = 40;
const ARROW_KEY_RIGH = 39;
const ARROW_KEY_LEFT = 37;
const VNS_ORDER_MANAGEMENT_LOCATION = "vns_order_mng_location";
const LOCALSTORAGE_CART_APPLY_COUPON = "CART_APPLY_COUPON";
const LOCALSTORAGE_CART_OPEN_COUPON_SELECTOR = "CART_OPEN_COUPON_SELECTOR";
const userSelectedConstants = {
    TERMINAL: "terminal",
    TERMINAL_ID: "terminal_id",
    LOCATION: "LOCATION_CODE",
    TERMINAL_NAME: "terminal_name",
    /**
   * allow setting a terminal_id from url query param.
   * the new terminal_id will override setting such as that of ecom-284
   * and will be honored even if it's not in the list of configured terminals
   */ OVERRIDE_TERMINAL_ID: "override_terminal_id",
    THREE_LEVEL_LOCATION: "three_level_location",
    USER_LOCATION: "user_location",
    TERMINALS: "terminals",
    IS_GET_GEOLOCATION: "isGetGeoLocation"
};
const LOCALSTORAGE_SELECTED_PAYMENT_METHOD = "selected-payment-method";
const SESSION_STORAGE_LOCATION_MESSAGE = "location-message";
const SESSION_STORAGE_LOCATION_HINT_SHOWED = "region-picker-suggestion-popover-closed";


/***/ }),

/***/ 451765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hg": function() { return /* binding */ LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY; },
/* harmony export */   "Lb": function() { return /* binding */ LOCAL_STORAGE_UNLOGGED_USER_PRIVACY_POLICIES; },
/* harmony export */   "Oc": function() { return /* binding */ LOCAL_STORAGE_PRIVACY_POLICIES; },
/* harmony export */   "i7": function() { return /* binding */ LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES; }
/* harmony export */ });
const LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES = "submit_privacy_policies";
const LOCAL_STORAGE_PRIVACY_POLICIES = "privacy_policies";
const LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY = "allowed_privacy_policy";
const LOCAL_STORAGE_UNLOGGED_USER_PRIVACY_POLICIES = "unlogged_user_privacy_policies";


/***/ }),

/***/ 185081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fl": function() { return /* binding */ LIMIT_ITEM_PER_PAGE_PRODUCT_LIST; },
/* harmony export */   "XH": function() { return /* binding */ SEARCH_ALGO; },
/* harmony export */   "_V": function() { return /* binding */ RECENTLY_VIEWED_PRODUCTS_KEY; },
/* harmony export */   "p9": function() { return /* binding */ ITEM_PER_PAGE_IN_LISTING_PAGE; }
/* harmony export */ });
/* unused harmony export SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE */
const LIMIT_ITEM_PER_PAGE_PRODUCT_LIST = 20;
const RECENTLY_VIEWED_PRODUCTS_KEY = "viewed-products";
const ITEM_PER_PAGE_IN_LISTING_PAGE = 40;
const SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE = 20;
const SEARCH_ALGO = {
    COOKIE: "search_algorithm_v2",
    EXPIRE_TIME: 4 * 60 * 60 * 1000,
    REPLACE_PATTERN: /['"]+/g
};


/***/ }),

/***/ 91326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ TERMINAL_TYPE; },
/* harmony export */   "Fk": function() { return /* binding */ USER_TERMINAL_CODE; },
/* harmony export */   "UE": function() { return /* binding */ USER_LOCATION_CODE; },
/* harmony export */   "pT": function() { return /* binding */ USER_TERMINAL_ID; }
/* harmony export */ });
const USER_TERMINAL_ID = "userTerminalId";
const USER_TERMINAL_CODE = "userTerminalCode";
const USER_LOCATION_CODE = "userLocationCode";
const TERMINAL_TYPE = {
    showroom: "SHR"
};


/***/ }),

/***/ 778046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ NOTIFICATION_TAB; }
/* harmony export */ });
var NOTIFICATION_TAB;
(function(NOTIFICATION_TAB) {
    NOTIFICATION_TAB[NOTIFICATION_TAB["UPDATE_TAB"] = 0] = "UPDATE_TAB";
    NOTIFICATION_TAB[NOTIFICATION_TAB["ORDER_TAB"] = 1] = "ORDER_TAB";
})(NOTIFICATION_TAB || (NOTIFICATION_TAB = {}));


/***/ }),

/***/ 186056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useCategories; },
/* harmony export */   "z": function() { return /* binding */ CategoriesProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);


const CategoriesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    isShowingCategory: false,
    setShowingCategory: ()=>{}
});
const useCategories = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CategoriesContext);
};
const CategoriesProvider = (param)=>{
    let { children ,  } = param;
    const { 0: isShowingCategory , 1: setShowingCategory  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CategoriesContext.Provider, {
        value: {
            isShowingCategory: isShowingCategory,
            setShowingCategory: setShowingCategory
        },
        children: children
    });
};


/***/ }),

/***/ 385365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ DistanceTerminalProvider; },
  "d": function() { return /* binding */ useDistanceTerminalContext; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/context.es.js
var context_es = __webpack_require__(106454);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.8.0-MOBCOMMON8504.1-aac718131a-360bd50b3e.zip/node_modules/@terra-js/terra-kit/dist/index.js
var dist = __webpack_require__(68706);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./assets/terminal-picker.png
/* harmony default export */ var terminal_picker = ("https://shopfront-cdn.tekoapis.com/_next/static/images/terminal-picker-336e66814eaacbc1c453155e0754cd27.png");
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(402374);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/index.es.js + 6 modules
var Form_index_es = __webpack_require__(977041);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/mobile/Select/Select.es.js
var Select_es = __webpack_require__(644797);
// EXTERNAL MODULE: ./helpers/translate.ts
var translate = __webpack_require__(858045);
// EXTERNAL MODULE: ./hooks/useLocation.ts
var useLocation = __webpack_require__(650725);
// EXTERNAL MODULE: ./hooks/useSuggestionAddress.ts
var useSuggestionAddress = __webpack_require__(308475);
// EXTERNAL MODULE: ./hooks/useLocationV2.ts
var useLocationV2 = __webpack_require__(650599);
// EXTERNAL MODULE: ./contexts/ToastContext.tsx
var ToastContext = __webpack_require__(508285);
;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/useGetDistanceTerminal.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var LocationStatus;
(function(LocationStatus) {
    LocationStatus["PROMPT"] = "prompt";
    LocationStatus["GRANTED"] = "granted";
    LocationStatus["DENIED"] = "denied";
    LocationStatus["NOT_SUPPORTED"] = "not-supported";
})(LocationStatus || (LocationStatus = {}));
const useGetDistanceTerminal = ()=>{
    const toast = (0,ToastContext/* useToast */.p)();
    const { epicOmni1589 , isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { getDistanceLocation , setIsModeEnterAddress , setMessageError , permissionGetLocationStatus , setTemporaryDataDistanceTerminal , temporaryDataDistanceTerminal ,  } = useDistanceTerminalContext();
    const handleErrorWhenNotExistTerminal = ()=>{
        setMessageError === null || setMessageError === void 0 ? void 0 : setMessageError((0,i18n.t)("Rất tiếc, ch\xfang t\xf4i chưa phục vụ giao h\xe0ng tại khu vực n\xe0y. Qu\xfd kh\xe1ch vui l\xf2ng chọn địa chỉ nhận h\xe0ng kh\xe1c. Cảm ơn qu\xfd kh\xe1ch!"));
    };
    const requestLocation = (callBack)=>{
        if (permissionGetLocationStatus === LocationStatus.PROMPT || permissionGetLocationStatus === LocationStatus.GRANTED) {
            callBack === null || callBack === void 0 ? void 0 : callBack();
        } else if (permissionGetLocationStatus === LocationStatus.DENIED) {
            setMessageError === null || setMessageError === void 0 ? void 0 : setMessageError((0,i18n.t)(isMobile ? "Vui l\xf2ng cấp quyền truy cập vị tr\xed cho tr\xecnh duyệt tại c\xe0i đặt của thiết bị." : "Vui l\xf2ng cấp quyền truy cập vị tr\xed cho tr\xecnh duyệt tại c\xe0i đặt của tr\xecnh duyệt đang sử dụng."));
        } else if (permissionGetLocationStatus === LocationStatus.NOT_SUPPORTED) {
            setMessageError === null || setMessageError === void 0 ? void 0 : setMessageError((0,i18n.t)("Định vị kh\xf4ng khả dụng tr\xean tr\xecnh duyệt của bạn"));
        }
    };
    const getDistanceTerminalsByGeoLocation = async ()=>{
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (position)=>{
                const terminals = await (getDistanceLocation === null || getDistanceLocation === void 0 ? void 0 : getDistanceLocation({
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                }));
                if (!!terminals && (terminals === null || terminals === void 0 ? void 0 : terminals.length) > 0) {
                    setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(false);
                    setTemporaryDataDistanceTerminal === null || setTemporaryDataDistanceTerminal === void 0 ? void 0 : setTemporaryDataDistanceTerminal(_objectSpreadProps(_objectSpread({}, temporaryDataDistanceTerminal), {
                        terminals
                    }));
                } else {
                    handleErrorWhenNotExistTerminal();
                }
            }, (err)=>{
                var ref;
                (ref = toast.error) === null || ref === void 0 ? void 0 : ref.call(toast, {
                    title: (0,i18n.t)("Lỗi"),
                    message: err.message
                });
            });
        } else {
            var ref;
            (ref = toast.error) === null || ref === void 0 ? void 0 : ref.call(toast, {
                title: (0,i18n.t)("Lỗi"),
                message: (0,i18n.t)("Geolocation kh\xf4ng được hỗ trợ tr\xean tr\xecnh duyệt của bạn.")
            });
        }
    };
    const getDistanceTerminalsByAddress = async (data)=>{
        const { provinceName , wardName , districtName , lat , long  } = data;
        const terminals = await (getDistanceLocation === null || getDistanceLocation === void 0 ? void 0 : getDistanceLocation({
            address: epicOmni1589 ? "".concat(data.address, ", ").concat(wardName, ", ").concat(provinceName) : "".concat(data.address, ", ").concat(wardName, ", ").concat(districtName, ", ").concat(provinceName),
            lat,
            long
        }));
        if (!!terminals && (terminals === null || terminals === void 0 ? void 0 : terminals.length) > 0) {
            setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(false);
            setTemporaryDataDistanceTerminal === null || setTemporaryDataDistanceTerminal === void 0 ? void 0 : setTemporaryDataDistanceTerminal(_objectSpreadProps(_objectSpread({}, temporaryDataDistanceTerminal), {
                location: _objectSpreadProps(_objectSpread({}, data), {
                    provinceName,
                    wardName,
                    districtName,
                    lat,
                    long
                }),
                terminals
            }));
        } else {
            handleErrorWhenNotExistTerminal();
        }
    };
    return {
        getDistanceTerminalsByGeoLocation,
        getDistanceTerminalsByAddress,
        requestLocation
    };
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Switch/Switch.es.js
var Switch_es = __webpack_require__(71638);
;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/mobile/SwitchGetByGeoLocation.tsx






const SwitchGetByGeoLocation = ()=>{
    const { isGetCurrentLocation , setIsGetCurrentLocation , setIsModeEnterAddress ,  } = useDistanceTerminalContext();
    const { requestLocation  } = useGetDistanceTerminal();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            align: "start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                            level: 1,
                            children: (0,i18n.t)("Bật định vị – nhận ưu đ\xe3i đ\xfang chỗ!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            level: 1,
                            children: (0,i18n.t)("Cho ph\xe9p truy cập vị tr\xed để t\xecm si\xeau thị gần nhất.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            level: 1,
                            children: (0,i18n.t)("Miễn ph\xed vận chuyển trong phạm vi 6km với đơn h\xe0ng từ 200.000 đồng.")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch_es/* Switch */.r, {
                        checked: isGetCurrentLocation,
                        onChange: ()=>{
                            if (isGetCurrentLocation) {
                                setIsGetCurrentLocation === null || setIsGetCurrentLocation === void 0 ? void 0 : setIsGetCurrentLocation(false);
                                setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(true);
                            } else {
                                requestLocation(()=>{
                                    return setIsGetCurrentLocation === null || setIsGetCurrentLocation === void 0 ? void 0 : setIsGetCurrentLocation(true);
                                });
                            }
                        }
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/mobile/ModeEnterAddress.tsx
function ModeEnterAddress_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ModeEnterAddress_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ModeEnterAddress_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ModeEnterAddress_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ModeEnterAddress_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ModeEnterAddress_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  height: 420px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  input {\n    border-radius: 4px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  position: fixed;\n  bottom: 16px;\n  padding-left: 16px;\n  padding-right: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  background-color: #fafafa;\n  border-radius: 12px;\n  padding: 8px;\n  margin-bottom: 15px;\n  max-height: 200px;\n  overflow-y: scroll;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 8px 10px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: 500;\n  color: #434657;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}











const COUNT_STRING_WITHOUT_STREET_ADDRESS = 4;
const ModeEnterAddress = ()=>{
    const { epicOmni1589  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchGetByGeoLocation, {}),
            epicOmni1589 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAddressV2, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAddressV1, {})
        ]
    });
};
const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject());
const SubTitle = emotion_styled_browser_esm["default"].span(_templateObject1());
const StyledSelect = (0,emotion_styled_browser_esm["default"])(Select_es/* Select */.P)(_templateObject2());
const StyledForm = (0,emotion_styled_browser_esm["default"])(Form_index_es/* Form */.l)(_templateObject3());
const StyledButtonWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(_templateObject4());
const Error = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n    padding-top: 0;\n    color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.error500, ";\n    font-size: 0.75rem;\n    line-height: 1rem;\n    transition: color 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n    margin-top: 0.5rem;\n  ");
});
const SuggestWrapper = emotion_styled_browser_esm["default"].div(_templateObject5());
const ItemSuggestion = emotion_styled_browser_esm["default"].div(_templateObject6());
const Text = emotion_styled_browser_esm["default"].span(_templateObject7());
const Spinner = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  border: 3px solid ".concat(theme.colors.blue100, ";\n  border-top-color: ").concat(theme.colors.blue500, ";\n  border-radius: 50%;\n  width: 1.5em;\n  height: 1.5em;\n  margin: 0 0.5rem;\n  animation: spin 1s linear infinite;\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n");
});
const FormAddressV1 = ()=>{
    var ref, ref1, ref2;
    const [form] = Form_index_es/* Form.useForm */.l.useForm();
    const { 0: missingRequiredField , 1: setMissingRequiredField  } = (0,react.useState)({
        province: "",
        ward: "",
        district: "",
        streetAddress: ""
    });
    const { 0: place , 1: setPlace  } = (0,react.useState)({
        lat: undefined,
        long: undefined
    });
    const { epicOmni1584Phase2SuggestAddress  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { locationGetDistanceTerminals , isLoadingGetDistanceTerminals , messageError , isGetCurrentLocation ,  } = useDistanceTerminalContext();
    const { getDistanceTerminalsByGeoLocation , getDistanceTerminalsByAddress  } = useGetDistanceTerminal();
    const { provinces =[] , wards =[] , province , ward , onProvinceChanged , onWardChanged , district , districts =[] , onDistrictChanged , setLocation ,  } = (0,useLocation/* useLocations */.Z)({
        provinceCode: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceCode,
        provinceName: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceName,
        districtCode: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtCode,
        districtName: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtName,
        wardCode: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardCode,
        wardName: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardName
    });
    const getDistanceTerminalsByAddressForm = async ()=>{
        var ref, ref1, ref2;
        const formData = await form.validateFields();
        if (!(province === null || province === void 0 ? void 0 : province.code) || !(ward === null || ward === void 0 ? void 0 : ward.code) || !(district === null || district === void 0 ? void 0 : district.code) || !formData.address) {
            return setMissingRequiredField({
                province: !(province === null || province === void 0 ? void 0 : province.code) ? (0,i18n.t)("Tỉnh/Th\xe0nh phố kh\xf4ng được bỏ trống") : "",
                ward: !(ward === null || ward === void 0 ? void 0 : ward.code) ? (0,i18n.t)("Phường/X\xe3 kh\xf4ng được bỏ trống") : "",
                district: !(district === null || district === void 0 ? void 0 : district.code) ? (0,i18n.t)("Quận/Huyện kh\xf4ng được bỏ trống") : "",
                streetAddress: !formData.address ? (0,i18n.t)("Địa chỉ chi tiết kh\xf4ng được bỏ trống") : ""
            });
        }
        const provinceName = ((ref = provinces === null || provinces === void 0 ? void 0 : provinces.find((p)=>{
            return p.code === (province === null || province === void 0 ? void 0 : province.code);
        })) === null || ref === void 0 ? void 0 : ref.name) || "";
        const districtName = ((ref1 = districts === null || districts === void 0 ? void 0 : districts.find((d)=>{
            return d.code === (district === null || district === void 0 ? void 0 : district.code);
        })) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
        const wardName = ((ref2 = wards === null || wards === void 0 ? void 0 : wards.find((w)=>w.code === ward.code)) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
        getDistanceTerminalsByAddress(ModeEnterAddress_objectSpreadProps(ModeEnterAddress_objectSpread({}, formData), {
            provinceName,
            wardName,
            provinceCode: province.code,
            wardCode: ward.code,
            districtName,
            districtCode: district.code,
            lat: place.lat,
            long: place.long
        }));
    };
    (0,react.useEffect)(()=>{
        if (!!locationGetDistanceTerminals) {
            form.setFieldsValue({
                provinceCode: locationGetDistanceTerminals.provinceCode || "",
                wardCode: locationGetDistanceTerminals.wardCode || "",
                districtCode: locationGetDistanceTerminals.districtCode || "",
                address: locationGetDistanceTerminals.address || ""
            });
            setLocation({
                provinceCode: locationGetDistanceTerminals.provinceCode,
                districtCode: locationGetDistanceTerminals.districtCode || "",
                wardCode: locationGetDistanceTerminals.wardCode
            });
            setPlace({
                lat: locationGetDistanceTerminals.lat,
                long: locationGetDistanceTerminals.long
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locationGetDistanceTerminals,
        JSON.stringify(provinces)
    ]);
    const { dataSuggestion , setSuggestInputText , openListSuggestion , setOpenListSuggestion , isLoadingSuggest , getPlaceDetails ,  } = (0,useSuggestionAddress/* useSuggestionAddress */.R)({
        province: (province === null || province === void 0 ? void 0 : province.name) || "",
        district: (district === null || district === void 0 ? void 0 : district.name) || "",
        ward: (ward === null || ward === void 0 ? void 0 : ward.name) || ""
    });
    const onClickSuggest = async (placeId)=>{
        var ref, ref1;
        const items = await getPlaceDetails(placeId);
        if (!items || !Array.isArray(items) || !items.length) {
            return;
        }
        // items là danh sách các placeDetail và cần lấy placeDetail đầu tiên
        // trong case này chỉ gửi 1 placeID lên nên chỉ có 1 placeDetail
        const item = items === null || items === void 0 ? void 0 : items[0];
        const address = ((ref1 = (ref = item.fullAddress.split(",")) === null || ref === void 0 ? void 0 : ref.splice(0, item.fullAddress.split(",").length - COUNT_STRING_WITHOUT_STREET_ADDRESS)) === null || ref1 === void 0 ? void 0 : ref1.join(",")) || item.fullAddress || "";
        setOpenListSuggestion(false);
        setPlace({
            lat: item.lat,
            long: item.long
        });
        const newValue = ModeEnterAddress_objectSpread({
            provinceCode: item.provinceCode || undefined
        }, item.districtCode ? {
            districtCode: item.districtCode
        } : {}, item.wardCode ? {
            wardCode: item.wardCode
        } : {});
        form.setFieldsValue(ModeEnterAddress_objectSpread({
            address
        }, newValue));
        if (!!item.provinceCode && !!item.districtCode && !!item.wardCode) {
            setLocation({
                provinceCode: item.provinceCode,
                districtCode: item.districtCode,
                wardCode: item.wardCode
            });
        }
    };
    const resetPosition = ()=>{
        setPlace({
            lat: undefined,
            long: undefined
        });
    };
    //
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledForm, {
                layout: "vertical",
                form: form,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    style: {
                        overflowY: "scroll"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                    style: {
                                        textAlign: "left"
                                    },
                                    children: (0,i18n.t)("Hoặc nhập địa chỉ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                    title: (0,i18n.t)("Tỉnh/Th\xe0nh phố"),
                                    wrapperBottomSheetHeight: "100dvh",
                                    placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Tỉnh/Th\xe0nh phố"),
                                    haveFilter: true,
                                    popupTitle: (0,i18n.t)("Tỉnh/Th\xe0nh phố"),
                                    selectKey: "text",
                                    required: true,
                                    disabled: isGetCurrentLocation,
                                    items: provinces === null || provinces === void 0 ? void 0 : provinces.map((param)=>{
                                        let { name , code  } = param;
                                        return {
                                            text: name,
                                            value: code
                                        };
                                    }),
                                    value: (province === null || province === void 0 ? void 0 : province.name) || ((ref = provinces === null || provinces === void 0 ? void 0 : provinces.find((p)=>{
                                        return p.code === (locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceCode);
                                    })) === null || ref === void 0 ? void 0 : ref.name) || "",
                                    onSelectChange: (param)=>{
                                        let { value  } = param;
                                        const location = provinces === null || provinces === void 0 ? void 0 : provinces.find((prov)=>prov.code === value);
                                        if (location) {
                                            onProvinceChanged(location.code);
                                            form.setFieldsValue({
                                                provinceCode: location.code
                                            });
                                            resetPosition();
                                        }
                                    },
                                    error: missingRequiredField.province
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                    title: (0,i18n.t)("Quận/Huyện"),
                                    wrapperBottomSheetHeight: "100dvh",
                                    placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Quận/Huyện"),
                                    haveFilter: true,
                                    popupTitle: (0,i18n.t)("Quận/Huyện"),
                                    selectKey: "text",
                                    disabled: isGetCurrentLocation,
                                    items: districts === null || districts === void 0 ? void 0 : districts.map((param)=>{
                                        let { name , code  } = param;
                                        return {
                                            text: name,
                                            value: code
                                        };
                                    }),
                                    required: true,
                                    value: (district === null || district === void 0 ? void 0 : district.name) || ((ref1 = districts === null || districts === void 0 ? void 0 : districts.find((p)=>{
                                        return p.code === (locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtCode);
                                    })) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
                                    onSelectChange: (param)=>{
                                        let { value  } = param;
                                        const location = districts === null || districts === void 0 ? void 0 : districts.find((ward)=>ward.code === value);
                                        if (location) {
                                            onDistrictChanged(location.code);
                                            form.setFieldsValue({
                                                districtCode: location.code
                                            });
                                            resetPosition();
                                        }
                                    },
                                    error: missingRequiredField.district
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                    title: (0,i18n.t)("Phường/X\xe3"),
                                    wrapperBottomSheetHeight: "100dvh",
                                    placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Phường/X\xe3"),
                                    haveFilter: true,
                                    popupTitle: (0,i18n.t)("Phường/X\xe3"),
                                    selectKey: "text",
                                    disabled: isGetCurrentLocation,
                                    items: wards === null || wards === void 0 ? void 0 : wards.map((param)=>{
                                        let { name , code  } = param;
                                        return {
                                            text: name,
                                            value: code
                                        };
                                    }),
                                    required: true,
                                    value: (ward === null || ward === void 0 ? void 0 : ward.name) || ((ref2 = wards === null || wards === void 0 ? void 0 : wards.find((p)=>{
                                        return p.code === (locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardCode);
                                    })) === null || ref2 === void 0 ? void 0 : ref2.name) || "",
                                    onSelectChange: (param)=>{
                                        let { value  } = param;
                                        const location = wards === null || wards === void 0 ? void 0 : wards.find((ward)=>ward.code === value);
                                        if (location) {
                                            onWardChanged(location.code);
                                            form.setFieldsValue({
                                                wardCode: location.code
                                            });
                                            resetPosition();
                                        }
                                    },
                                    error: missingRequiredField.ward
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                    label: (0,i18n.t)("Địa chỉ cụ thể"),
                                    name: "address",
                                    required: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
                                        disabled: isGetCurrentLocation || (!(province === null || province === void 0 ? void 0 : province.code) || !(district === null || district === void 0 ? void 0 : district.code) || !(ward === null || ward === void 0 ? void 0 : ward.code)) && epicOmni1584Phase2SuggestAddress,
                                        placeholder: (0,i18n.t)("Số nh\xe0, ng\xf5, t\xean đường..."),
                                        onChange: (text)=>{
                                            setSuggestInputText(text);
                                            setOpenListSuggestion(true);
                                            resetPosition();
                                        }
                                    })
                                }),
                                !!missingRequiredField.streetAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                                    children: missingRequiredField.streetAddress
                                })
                            ]
                        }),
                        epicOmni1584Phase2SuggestAddress && !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestWrapper, {
                            children: isLoadingSuggest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                justify: "center",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        style: {
                                            textAlign: "left"
                                        },
                                        children: (0,i18n.t)("Gợi \xfd")
                                    }),
                                    dataSuggestion.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSuggestion, {
                                            onClick: ()=>onClickSuggest(item.placeId),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                    style: {
                                                        textAlign: "left",
                                                        marginLeft: 8
                                                    },
                                                    children: item.fullAddress
                                                })
                                            ]
                                        }, item.fullAddress);
                                    })
                                ]
                            })
                        }),
                        !!messageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                            width: "100%",
                            borderRadius: "xl",
                            border: "1px solid warning",
                            backgroundColor: "pending100",
                            padding: "s8",
                            children: messageError
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    disabled: isLoadingGetDistanceTerminals,
                    block: true,
                    type: "submit",
                    variant: "primary",
                    onClick: isGetCurrentLocation ? getDistanceTerminalsByGeoLocation : getDistanceTerminalsByAddressForm,
                    width: "100%",
                    children: (0,i18n.t)("X\xe1c nhận")
                })
            })
        ]
    });
};
const FormAddressV2 = ()=>{
    var ref, ref1;
    const [form] = Form_index_es/* Form.useForm */.l.useForm();
    const { 0: missingRequiredField , 1: setMissingRequiredField  } = (0,react.useState)({
        province: "",
        ward: "",
        streetAddress: ""
    });
    const { 0: place , 1: setPlace  } = (0,react.useState)({
        lat: undefined,
        long: undefined
    });
    const { locationGetDistanceTerminals , isLoadingGetDistanceTerminals , messageError , isGetCurrentLocation ,  } = useDistanceTerminalContext();
    const { getDistanceTerminalsByGeoLocation , getDistanceTerminalsByAddress  } = useGetDistanceTerminal();
    const { epicOmni1584Phase2SuggestAddress  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { provinces =[] , wards =[] , province , ward , onProvinceChanged , onWardChanged ,  } = (0,useLocationV2/* useLocationsV2 */.W)(locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceCode, locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardCode);
    const getDistanceTerminalsByAddressForm = async ()=>{
        var ref, ref1;
        const formData = await form.validateFields();
        if (!(province === null || province === void 0 ? void 0 : province.code) || !(ward === null || ward === void 0 ? void 0 : ward.code) || !formData.address) {
            return setMissingRequiredField({
                province: !(province === null || province === void 0 ? void 0 : province.code) ? (0,i18n.t)("Tỉnh/Th\xe0nh phố kh\xf4ng được bỏ trống") : "",
                ward: !(ward === null || ward === void 0 ? void 0 : ward.code) ? (0,i18n.t)("Phường/X\xe3 kh\xf4ng được bỏ trống") : "",
                streetAddress: !formData.address ? (0,i18n.t)("Địa chỉ chi tiết kh\xf4ng được bỏ trống") : ""
            });
        }
        const provinceName = ((ref = provinces.find((p)=>{
            return p.code === (province === null || province === void 0 ? void 0 : province.code);
        })) === null || ref === void 0 ? void 0 : ref.title) || "";
        const wardName = ((ref1 = wards.find((w)=>w.code === ward.code)) === null || ref1 === void 0 ? void 0 : ref1.title) || "";
        getDistanceTerminalsByAddress(ModeEnterAddress_objectSpreadProps(ModeEnterAddress_objectSpread({}, formData), {
            provinceName,
            wardName,
            provinceCode: province.code,
            wardCode: ward.code,
            lat: place.lat,
            long: place.long
        }));
    };
    const { dataSuggestion , setSuggestInputText , openListSuggestion , setOpenListSuggestion , isLoadingSuggest , getPlaceDetails ,  } = (0,useSuggestionAddress/* useSuggestionAddress */.R)({
        province: (province === null || province === void 0 ? void 0 : province.title) || "",
        ward: (ward === null || ward === void 0 ? void 0 : ward.title) || ""
    });
    (0,react.useEffect)(()=>{
        if (!!locationGetDistanceTerminals) {
            form.setFieldsValue({
                provinceCode: locationGetDistanceTerminals.provinceCode || "",
                wardCode: locationGetDistanceTerminals.wardCode || "",
                address: locationGetDistanceTerminals.address || ""
            });
            onProvinceChanged(locationGetDistanceTerminals.provinceCode);
            onWardChanged(locationGetDistanceTerminals.wardCode);
            setPlace({
                lat: locationGetDistanceTerminals.lat,
                long: locationGetDistanceTerminals.long
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locationGetDistanceTerminals
    ]);
    const onClickSuggest = async (placeId)=>{
        var ref, ref1;
        const items = await getPlaceDetails(placeId);
        if (!items || !Array.isArray(items) || !items.length) {
            return;
        }
        // items là danh sách các placeDetail và cần lấy placeDetail đầu tiên
        // trong case này chỉ gửi 1 placeID lên nên chỉ có 1 placeDetail
        const item = items === null || items === void 0 ? void 0 : items[0];
        const address = ((ref1 = (ref = item.fullAddress.split(",")) === null || ref === void 0 ? void 0 : ref.splice(0, item.fullAddress.split(",").length - COUNT_STRING_WITHOUT_STREET_ADDRESS)) === null || ref1 === void 0 ? void 0 : ref1.join(",")) || item.fullAddress || "";
        setOpenListSuggestion(false);
        setPlace({
            lat: item.lat,
            long: item.long
        });
        const newValue = ModeEnterAddress_objectSpread({
            provinceCode: item.provinceCode || undefined
        }, item.wardCode ? {
            wardCode: item.wardCode
        } : {});
        form.setFieldsValue(ModeEnterAddress_objectSpread({
            address
        }, newValue));
    };
    const resetPosition = ()=>{
        setPlace({
            lat: undefined,
            long: undefined
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledForm, {
                layout: "vertical",
                form: form,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                    style: {
                                        textAlign: "left"
                                    },
                                    children: (0,i18n.t)("Hoặc nhập địa chỉ ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                    title: (0,i18n.t)("Tỉnh/Th\xe0nh phố"),
                                    wrapperBottomSheetHeight: "100dvh",
                                    placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Tỉnh/Th\xe0nh phố"),
                                    haveFilter: true,
                                    popupTitle: (0,i18n.t)("Tỉnh/Th\xe0nh phố"),
                                    selectKey: "text",
                                    required: true,
                                    disabled: isGetCurrentLocation,
                                    items: provinces === null || provinces === void 0 ? void 0 : provinces.map((param)=>{
                                        let { title , code  } = param;
                                        return {
                                            text: title,
                                            value: code
                                        };
                                    }),
                                    value: (province === null || province === void 0 ? void 0 : province.title) || ((ref = provinces === null || provinces === void 0 ? void 0 : provinces.find((p)=>{
                                        return p.code === (locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceCode);
                                    })) === null || ref === void 0 ? void 0 : ref.title) || "",
                                    onSelectChange: (param)=>{
                                        let { value  } = param;
                                        const location = provinces === null || provinces === void 0 ? void 0 : provinces.find((prov)=>prov.code === value);
                                        if (location) {
                                            onProvinceChanged(location.code);
                                            form.setFieldsValue({
                                                provinceCode: location.code
                                            });
                                            resetPosition();
                                        }
                                    },
                                    error: missingRequiredField.province
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, {
                                    title: (0,i18n.t)("Phường/X\xe3"),
                                    wrapperBottomSheetHeight: "100dvh",
                                    placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Phường/X\xe3"),
                                    haveFilter: true,
                                    disabled: isGetCurrentLocation,
                                    popupTitle: (0,i18n.t)("Phường/X\xe3"),
                                    selectKey: "text",
                                    items: wards === null || wards === void 0 ? void 0 : wards.map((param)=>{
                                        let { title , code  } = param;
                                        return {
                                            text: title,
                                            value: code
                                        };
                                    }),
                                    required: true,
                                    value: (ward === null || ward === void 0 ? void 0 : ward.title) || ((ref1 = wards === null || wards === void 0 ? void 0 : wards.find((p)=>{
                                        return p.code === (locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardCode);
                                    })) === null || ref1 === void 0 ? void 0 : ref1.title) || "",
                                    onSelectChange: (param)=>{
                                        let { value  } = param;
                                        const location = wards === null || wards === void 0 ? void 0 : wards.find((ward)=>ward.code === value);
                                        if (location) {
                                            onWardChanged(location.code);
                                            form.setFieldsValue({
                                                wardCode: location.code
                                            });
                                            resetPosition();
                                        }
                                    },
                                    error: missingRequiredField.ward
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                    required: true,
                                    label: (0,i18n.t)("Địa chỉ cụ thể"),
                                    name: "address",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
                                        disabled: isGetCurrentLocation,
                                        placeholder: (0,i18n.t)("Số nh\xe0, ng\xf5, t\xean đường..."),
                                        onChange: (text)=>{
                                            setSuggestInputText(text);
                                            setOpenListSuggestion(true);
                                        }
                                    })
                                }),
                                !!missingRequiredField.streetAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                                    children: missingRequiredField.streetAddress
                                })
                            ]
                        }),
                        epicOmni1584Phase2SuggestAddress && !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestWrapper, {
                            children: isLoadingSuggest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                justify: "center",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        style: {
                                            textAlign: "left"
                                        },
                                        children: (0,i18n.t)("Gợi \xfd")
                                    }),
                                    dataSuggestion.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemSuggestion, {
                                            onClick: ()=>onClickSuggest(item.placeId),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                    style: {
                                                        textAlign: "left",
                                                        marginLeft: 8
                                                    },
                                                    children: item.fullAddress
                                                })
                                            ]
                                        }, item.fullAddress);
                                    })
                                ]
                            })
                        }),
                        !!messageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                            width: "100%",
                            borderRadius: "xl",
                            border: "1px solid warning",
                            backgroundColor: "pending100",
                            padding: "s8",
                            children: messageError
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    disabled: isLoadingGetDistanceTerminals,
                    block: true,
                    type: "submit",
                    variant: "primary",
                    onClick: isGetCurrentLocation ? getDistanceTerminalsByGeoLocation : getDistanceTerminalsByAddressForm,
                    width: "100%",
                    children: (0,i18n.t)("X\xe1c nhận")
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/PencilOutlined.es.js
var PencilOutlined_es = __webpack_require__(181466);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/NavigationOutlined.es.js
var NavigationOutlined_es = __webpack_require__(844452);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/HomeLocationOutlined.es.js
var HomeLocationOutlined_es = __webpack_require__(767054);
;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/mobile/ModeListTerminal.tsx
function ModeListTerminal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ModeListTerminal_templateObject() {
    const data = ModeListTerminal_taggedTemplateLiteral([
        "\n  width: 100%;\n  position: fixed;\n  bottom: 16px;\n  padding-left: 16px;\n  padding-right: 16px;\n"
    ]);
    ModeListTerminal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







const ModeListTerminal = ()=>{
    var ref, ref1;
    const { currentTerminals =[] , currentTerminal , setNewTerminal , isLoadingGetDistanceTerminals , temporaryDataDistanceTerminal , setIsModeEnterAddress , isModeEnterAddress , isGetCurrentLocation ,  } = useDistanceTerminalContext();
    const { 0: terminal , 1: setTerminal  } = (0,react.useState)(undefined);
    const { location: locationGetDistanceTerminals  } = temporaryDataDistanceTerminal;
    (0,react.useEffect)(()=>{
        if (!!currentTerminals && Array.isArray(currentTerminals) && !!currentTerminals.length && !isModeEnterAddress) {
            setTerminal === null || setTerminal === void 0 ? void 0 : setTerminal(!!currentTerminal ? currentTerminals.find((t)=>t.terminalId === currentTerminal.terminalId) || (currentTerminals === null || currentTerminals === void 0 ? void 0 : currentTerminals[0]) : currentTerminals === null || currentTerminals === void 0 ? void 0 : currentTerminals[0]);
        }
    }, [
        currentTerminal,
        currentTerminals,
        isModeEnterAddress
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isGetCurrentLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchGetByGeoLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        align: "start",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                level: 3,
                                children: isGetCurrentLocation ? (0,i18n.t)("Đang sử dụng vị tr\xed hiện tại của bạn") : (0,i18n.t)("Địa chỉ:")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                align: "center",
                                onClick: ()=>{
                                    return setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(!isModeEnterAddress);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PencilOutlined_es/* PencilOutlined */.F, {
                                        color: "primary",
                                        size: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                        level: 3,
                                        weight: "regular",
                                        color: "primary",
                                        marginLeft: "s4",
                                        children: (0,i18n.t)("Thay đổi")
                                    })
                                ]
                            })
                        ]
                    }),
                    !isGetCurrentLocation && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* SubTitle */.DK, {
                        weight: "regular",
                        width: "75%",
                        children: [
                            locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.address,
                            ",",
                            " ",
                            locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardName,
                            ",",
                            " ",
                            locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                direction: "column",
                gap: "s8",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                        children: (0,i18n.t)("".concat(temporaryDataDistanceTerminal === null || temporaryDataDistanceTerminal === void 0 ? void 0 : (ref = temporaryDataDistanceTerminal.terminals) === null || ref === void 0 ? void 0 : ref.length, " si\xeau thị gần bạn:"))
                    }),
                    temporaryDataDistanceTerminal === null || temporaryDataDistanceTerminal === void 0 ? void 0 : (ref1 = temporaryDataDistanceTerminal.terminals) === null || ref1 === void 0 ? void 0 : ref1.map((item, index)=>{
                        var ref;
                        const isChoice = (terminal === null || terminal === void 0 ? void 0 : terminal.terminalId) === item.terminalId;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            padding: "s8",
                            border: isChoice ? "1px solid primary" : "1px solid border",
                            borderRadius: "l",
                            direction: "column",
                            gap: "s4",
                            onClick: ()=>setTerminal(item),
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    justify: "space-between",
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                            textTransform: "uppercase",
                                            children: item.terminalName
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                            gap: "s4",
                                            justify: "center",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                                    decoration: "underline",
                                                    color: "primary",
                                                    children: [
                                                        (ref = item.distance) === null || ref === void 0 ? void 0 : ref.toFixed(2),
                                                        " km"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationOutlined_es/* NavigationOutlined */.d, {
                                                        size: 16
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    gap: "s8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeLocationOutlined_es/* HomeLocationOutlined */.N, {
                                                size: 16
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                            level: 1,
                                            children: item.fullAddress
                                        })
                                    ]
                                })
                            ]
                        }, "".concat(index, " - ").concat(item.terminalId, " - ").concat(item.terminalCode));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal_StyledButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    block: true,
                    onClick: ()=>{
                        if (!!terminal) {
                            setNewTerminal === null || setNewTerminal === void 0 ? void 0 : setNewTerminal(terminal);
                        }
                    },
                    variant: "primary",
                    disabled: !terminal || isLoadingGetDistanceTerminals,
                    children: (0,i18n.t)("Mua sắm ngay")
                })
            })
        ]
    });
};
const ModeListTerminal_StyledButtonWrapper = (0,emotion_styled_browser_esm["default"])(index_es/* Shape */.b)(ModeListTerminal_templateObject());

;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/mobile/PopupTerminalPickerMobile.tsx
function PopupTerminalPickerMobile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PopupTerminalPickerMobile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupTerminalPickerMobile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PopupTerminalPickerMobile_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PopupTerminalPickerMobile_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PopupTerminalPickerMobile_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PopupTerminalPickerMobile_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PopupTerminalPickerMobile_templateObject() {
    const data = PopupTerminalPickerMobile_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    PopupTerminalPickerMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const PopupTerminalPickerMobile = (param)=>{
    let { showPopup , onClosePopup ,  } = param;
    const { isModeEnterAddress , currentTerminal , locationGetDistanceTerminals , currentTerminals , setTemporaryDataDistanceTerminal , temporaryDataDistanceTerminal ,  } = useDistanceTerminalContext();
    (0,react.useEffect)(()=>{
        if (!!showPopup) {
            setTemporaryDataDistanceTerminal === null || setTemporaryDataDistanceTerminal === void 0 ? void 0 : setTemporaryDataDistanceTerminal(PopupTerminalPickerMobile_objectSpread(PopupTerminalPickerMobile_objectSpreadProps(PopupTerminalPickerMobile_objectSpread({}, temporaryDataDistanceTerminal), {
                terminals: !!currentTerminals && Array.isArray(currentTerminals) ? currentTerminals : []
            }), locationGetDistanceTerminals ? {
                location: locationGetDistanceTerminals
            } : {}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentTerminals,
        locationGetDistanceTerminals,
        showPopup
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomSheet, {
        show: showPopup,
        position: "bottom",
        zIndex: 2000,
        closeBottomSheet: !!currentTerminal ? onClosePopup : undefined,
        contentHeight: "78vh",
        title: (0,i18n.t)("Chọn khu vực của bạn"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            padding: "s16",
            direction: "column",
            gap: "s12",
            align: "center",
            justify: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                    paddingBottom: "s16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                        height: "72px",
                        width: "116px",
                        src: terminal_picker
                    })
                }),
                isModeEnterAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal, {})
            ]
        })
    });
};
const StyledBottomSheet = (0,emotion_styled_browser_esm["default"])(BottomSheet_es/* BottomSheet */.R)(PopupTerminalPickerMobile_templateObject());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Select/Select.es.js
var Select_Select_es = __webpack_require__(296200);
;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/desktop/SwitchGetByGeoLocation.tsx
function SwitchGetByGeoLocation_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SwitchGetByGeoLocation_templateObject() {
    const data = SwitchGetByGeoLocation_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    SwitchGetByGeoLocation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwitchGetByGeoLocation_templateObject1() {
    const data = SwitchGetByGeoLocation_taggedTemplateLiteral([
        "\n  font-size: 16x;\n  font-weight: 500;\n"
    ]);
    SwitchGetByGeoLocation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






const SwitchGetByGeoLocation_SwitchGetByGeoLocation = ()=>{
    const { isGetCurrentLocation , setIsGetCurrentLocation , setIsModeEnterAddress ,  } = useDistanceTerminalContext();
    const { requestLocation  } = useGetDistanceTerminal();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: (0,i18n.t)("Bật định vị – nhận ưu đ\xe3i đ\xfang chỗ!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch_es/* Switch */.r, {
                        checked: isGetCurrentLocation,
                        onChange: ()=>{
                            if (isGetCurrentLocation) {
                                setIsGetCurrentLocation === null || setIsGetCurrentLocation === void 0 ? void 0 : setIsGetCurrentLocation(false);
                                setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(true);
                            } else {
                                requestLocation(()=>{
                                    return setIsGetCurrentLocation === null || setIsGetCurrentLocation === void 0 ? void 0 : setIsGetCurrentLocation(true);
                                });
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchGetByGeoLocation_SubTitle, {
                style: {
                    textAlign: "left",
                    overflowWrap: "break-word"
                },
                children: (0,i18n.t)("Cho ph\xe9p truy cập vị tr\xed để t\xecm si\xeau thị gần nhất.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginTop: 4,
                    marginBottom: 16
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchGetByGeoLocation_SubTitle, {
                    style: {
                        textAlign: "left"
                    },
                    children: (0,i18n.t)("Miễn ph\xed vận chuyển trong phạm vi 6km với đơn h\xe0ng từ 200.000 đồng.")
                })
            })
        ]
    });
};
const SwitchGetByGeoLocation_SubTitle = emotion_styled_browser_esm["default"].span(SwitchGetByGeoLocation_templateObject());
const Title = emotion_styled_browser_esm["default"].span(SwitchGetByGeoLocation_templateObject1());

;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/desktop/ModeEnterAddress.tsx
function desktop_ModeEnterAddress_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_ModeEnterAddress_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_ModeEnterAddress_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function desktop_ModeEnterAddress_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function desktop_ModeEnterAddress_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        desktop_ModeEnterAddress_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ModeEnterAddress_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ModeEnterAddress_templateObject() {
    const data = ModeEnterAddress_taggedTemplateLiteral([
        "\n  height: 33vh;\n  @media (max-width: 1600px) {\n    height: 300px;\n  }\n"
    ]);
    ModeEnterAddress_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModeEnterAddress_templateObject1() {
    const data = ModeEnterAddress_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 400;\n"
    ]);
    ModeEnterAddress_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModeEnterAddress_templateObject2() {
    const data = ModeEnterAddress_taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: 500;\n  color: #434657;\n"
    ]);
    ModeEnterAddress_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModeEnterAddress_templateObject3() {
    const data = ModeEnterAddress_taggedTemplateLiteral([
        "\n  background-color: #fafafa;\n  border-radius: 12px;\n  padding: 8px;\n  margin-bottom: 15px;\n  max-height: 200px;\n  overflow-y: scroll;\n"
    ]);
    ModeEnterAddress_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModeEnterAddress_templateObject4() {
    const data = ModeEnterAddress_taggedTemplateLiteral([
        "\n  padding: 8px 10px;\n  cursor: pointer;\n"
    ]);
    ModeEnterAddress_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










const ModeEnterAddress_COUNT_STRING_WITHOUT_STREET_ADDRESS = 4;
const ModeEnterAddress_ModeEnterAddress = ()=>{
    const { epicOmni1589  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchGetByGeoLocation_SwitchGetByGeoLocation, {}),
            epicOmni1589 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_FormAddressV2, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_FormAddressV1, {})
        ]
    });
};
const ModeEnterAddress_Wrapper = emotion_styled_browser_esm["default"].div(ModeEnterAddress_templateObject());
const ModeEnterAddress_SubTitle = emotion_styled_browser_esm["default"].span(ModeEnterAddress_templateObject1());
const ModeEnterAddress_Text = emotion_styled_browser_esm["default"].span(ModeEnterAddress_templateObject2());
const ModeEnterAddress_Spinner = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  border: 3px solid ".concat(theme.colors.blue100, ";\n  border-top-color: ").concat(theme.colors.blue500, ";\n  border-radius: 50%;\n  width: 1.5em;\n  height: 1.5em;\n  margin: 0 0.5rem;\n  animation: spin 1s linear infinite;\n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n");
});
const WrapperError = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid ".concat(theme.colors.warning, ";\n  background-color: #FFFBE6;\n  padding: 8px;\n");
});
const ModeEnterAddress_SuggestWrapper = emotion_styled_browser_esm["default"].div(ModeEnterAddress_templateObject3());
const ModeEnterAddress_ItemSuggestion = emotion_styled_browser_esm["default"].div(ModeEnterAddress_templateObject4());
const ModeEnterAddress_FormAddressV1 = ()=>{
    var ref, ref1, ref2;
    const [form] = Form_index_es/* Form.useForm */.l.useForm();
    const { epicOmni1584Phase2SuggestAddress  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: place , 1: setPlace  } = (0,react.useState)({
        lat: undefined,
        long: undefined
    });
    const { locationGetDistanceTerminals , isLoadingGetDistanceTerminals , messageError , isGetCurrentLocation ,  } = useDistanceTerminalContext();
    const { getDistanceTerminalsByGeoLocation , getDistanceTerminalsByAddress  } = useGetDistanceTerminal();
    const { provinces =[] , wards =[] , province , ward , onProvinceChanged , onWardChanged , district , districts =[] , onDistrictChanged , setLocation ,  } = (0,useLocation/* useLocations */.Z)({
        provinceCode: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceCode,
        provinceName: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceName,
        districtCode: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtCode,
        districtName: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtName,
        wardCode: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardCode,
        wardName: locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardName
    });
    const getDistanceTerminalsByAddressForm = async (data)=>{
        var ref, ref1, ref2;
        const provinceName = ((ref = provinces.find((province)=>province.code === data.provinceCode)) === null || ref === void 0 ? void 0 : ref.name) || "";
        const wardName = ((ref1 = wards.find((ward)=>ward.code === data.wardCode)) === null || ref1 === void 0 ? void 0 : ref1.name) || "";
        const districtName = ((ref2 = districts.find((district)=>district.code === data.districtCode)) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
        if (!provinceName || !wardName || !districtName) {
            const provinceError = !provinceName ? [
                {
                    name: "provinceCode",
                    errors: [
                        "".concat((0,i18n.t)("Tỉnh/th\xe0nh kh\xf4ng được bỏ trống"))
                    ]
                }, 
            ] : [];
            const districtError = !districtName ? [
                {
                    name: "districtCode",
                    errors: [
                        "".concat((0,i18n.t)("Phường/x\xe3 kh\xf4ng được bỏ trống"))
                    ]
                }, 
            ] : [];
            const wardError = !wardName ? [
                {
                    name: "wardCode",
                    errors: [
                        "".concat((0,i18n.t)("Quận/huyện kh\xf4ng được bỏ trống"))
                    ]
                }, 
            ] : [];
            form.setFields([
                ...provinceError,
                ...districtError,
                ...wardError
            ]);
            return;
        }
        getDistanceTerminalsByAddress(desktop_ModeEnterAddress_objectSpreadProps(desktop_ModeEnterAddress_objectSpread({}, data), {
            provinceName,
            wardName,
            districtName,
            lat: place.lat,
            long: place.long
        }));
    };
    const { dataSuggestion , setSuggestInputText , openListSuggestion , setOpenListSuggestion , isLoadingSuggest , getPlaceDetails ,  } = (0,useSuggestionAddress/* useSuggestionAddress */.R)({
        province: ((ref = provinces === null || provinces === void 0 ? void 0 : provinces.find((p)=>{
            return p.code === (province === null || province === void 0 ? void 0 : province.code);
        })) === null || ref === void 0 ? void 0 : ref.name) || "",
        district: ((ref1 = districts === null || districts === void 0 ? void 0 : districts.find((d)=>{
            return d.code === (district === null || district === void 0 ? void 0 : district.code);
        })) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
        ward: ((ref2 = wards === null || wards === void 0 ? void 0 : wards.find((w)=>{
            return w.code === (ward === null || ward === void 0 ? void 0 : ward.code);
        })) === null || ref2 === void 0 ? void 0 : ref2.name) || ""
    });
    (0,react.useEffect)(()=>{
        if (!!locationGetDistanceTerminals) {
            form.setFieldsValue({
                provinceCode: locationGetDistanceTerminals.provinceCode || "",
                districtCode: locationGetDistanceTerminals.districtCode || "",
                wardCode: locationGetDistanceTerminals.wardCode || "",
                address: locationGetDistanceTerminals.address || ""
            });
            setLocation({
                provinceCode: locationGetDistanceTerminals.provinceCode,
                districtCode: locationGetDistanceTerminals.districtCode || "",
                wardCode: locationGetDistanceTerminals.wardCode
            });
            setPlace({
                lat: locationGetDistanceTerminals.lat,
                long: locationGetDistanceTerminals.long
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locationGetDistanceTerminals
    ]);
    const onClickSuggest = async (placeId)=>{
        var ref, ref1;
        const items = await getPlaceDetails(placeId);
        if (!items || !Array.isArray(items) || !items.length) {
            return;
        }
        // items là danh sách các placeDetail và cần lấy placeDetail đầu tiên
        // trong case này chỉ gửi 1 placeID lên nên chỉ có 1 placeDetail
        const item = items === null || items === void 0 ? void 0 : items[0];
        const address = ((ref1 = (ref = item.fullAddress.split(",")) === null || ref === void 0 ? void 0 : ref.splice(0, item.fullAddress.split(",").length - ModeEnterAddress_COUNT_STRING_WITHOUT_STREET_ADDRESS)) === null || ref1 === void 0 ? void 0 : ref1.join(",")) || item.fullAddress || "";
        setOpenListSuggestion(false);
        setPlace({
            lat: item.lat,
            long: item.long
        });
        const newValue = desktop_ModeEnterAddress_objectSpread({
            provinceCode: item.provinceCode || undefined
        }, item.districtCode ? {
            districtCode: item.districtCode
        } : {}, item.wardCode ? {
            wardCode: item.wardCode
        } : {});
        form.setFieldsValue(desktop_ModeEnterAddress_objectSpreadProps(desktop_ModeEnterAddress_objectSpread({}, newValue), {
            address
        }));
        if (!!item.provinceCode && !!item.districtCode && !!item.wardCode) {
            setLocation({
                provinceCode: item.provinceCode,
                districtCode: item.districtCode,
                wardCode: item.wardCode
            });
        }
    };
    const resetPosition = ()=>{
        setPlace({
            lat: undefined,
            long: undefined
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form */.l, {
        layout: "vertical",
        form: form,
        onFinish: isGetCurrentLocation ? getDistanceTerminalsByGeoLocation : getDistanceTerminalsByAddressForm,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModeEnterAddress_Wrapper, {
            style: {
                height: !!dataSuggestion && !!openListSuggestion && !!dataSuggestion.length ? 546 : 346
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_SubTitle, {
                            style: {
                                textAlign: "left"
                            },
                            children: (0,i18n.t)("Hoặc nhập địa chỉ ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            justify: "space-between",
                            marginBottom: "s8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "49%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                        label: (0,i18n.t)("Tỉnh/Th\xe0nh phố"),
                                        trigger: "selectValue",
                                        name: "provinceCode",
                                        rules: [
                                            {
                                                required: !isGetCurrentLocation,
                                                message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                            }, 
                                        ],
                                        validateTrigger: "selectValue",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select_es/* Select */.P, {
                                            options: provinces === null || provinces === void 0 ? void 0 : provinces.map((param)=>{
                                                let { name , code  } = param;
                                                return {
                                                    text: name,
                                                    value: code
                                                };
                                            }),
                                            value: (province === null || province === void 0 ? void 0 : province.code) || "",
                                            maxPerView: 5,
                                            placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Tỉnh/Th\xe0nh phố"),
                                            selectValue: (value)=>{
                                                const location = provinces === null || provinces === void 0 ? void 0 : provinces.find((prov)=>prov.code === value);
                                                if (location) {
                                                    onProvinceChanged(location.code);
                                                    form.setFieldsValue({
                                                        provinceCode: location.code,
                                                        districtCode: "",
                                                        wardCode: ""
                                                    });
                                                    onDistrictChanged("");
                                                    onWardChanged("");
                                                    resetPosition();
                                                }
                                            },
                                            disabled: isGetCurrentLocation,
                                            onDelete: ()=>{
                                                form.setFieldsValue({
                                                    provinceCode: "",
                                                    wardCode: ""
                                                });
                                                onProvinceChanged("");
                                                resetPosition();
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "49%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                        label: (0,i18n.t)("Quận Huyện"),
                                        trigger: "selectValue",
                                        name: "districtCode",
                                        rules: [
                                            {
                                                required: !isGetCurrentLocation,
                                                message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                            }, 
                                        ],
                                        validateTrigger: "selectValue",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select_es/* Select */.P, {
                                            options: districts === null || districts === void 0 ? void 0 : districts.map((param)=>{
                                                let { name , code  } = param;
                                                return {
                                                    text: name,
                                                    value: code
                                                };
                                            }),
                                            value: (district === null || district === void 0 ? void 0 : district.code) || "",
                                            maxPerView: 5,
                                            placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Quận/ Huyện"),
                                            selectValue: (value)=>{
                                                const location = districts === null || districts === void 0 ? void 0 : districts.find((district)=>district.code === value);
                                                if (location) {
                                                    onDistrictChanged(location.code);
                                                    form.setFieldsValue({
                                                        districtCode: location.code,
                                                        wardCode: ""
                                                    });
                                                    onWardChanged("");
                                                    resetPosition();
                                                }
                                            },
                                            disabled: isGetCurrentLocation,
                                            onDelete: ()=>{
                                                form.setFieldsValue({
                                                    districtCode: ""
                                                });
                                                onWardChanged("");
                                                resetPosition();
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            justify: "space-between",
                            marginBottom: "s8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "49%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                        label: (0,i18n.t)("Phường/X\xe3"),
                                        trigger: "selectValue",
                                        name: "wardCode",
                                        rules: [
                                            {
                                                required: !isGetCurrentLocation,
                                                message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                            }, 
                                        ],
                                        validateTrigger: "selectValue",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select_es/* Select */.P, {
                                            options: wards === null || wards === void 0 ? void 0 : wards.map((param)=>{
                                                let { name , code  } = param;
                                                return {
                                                    text: name,
                                                    value: code
                                                };
                                            }),
                                            value: (ward === null || ward === void 0 ? void 0 : ward.code) || "",
                                            maxPerView: 5,
                                            placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Phường/X\xe3"),
                                            selectValue: (value)=>{
                                                const location = wards === null || wards === void 0 ? void 0 : wards.find((ward)=>ward.code === value);
                                                if (location) {
                                                    onWardChanged(location.code);
                                                    form.setFieldsValue({
                                                        wardCode: location.code
                                                    });
                                                    resetPosition();
                                                }
                                            },
                                            disabled: isGetCurrentLocation,
                                            onDelete: ()=>{
                                                form.setFieldsValue({
                                                    wardCode: ""
                                                });
                                                onWardChanged("");
                                                resetPosition();
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "49%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                        label: (0,i18n.t)("Địa chỉ cụ thể"),
                                        name: "address",
                                        rules: [
                                            {
                                                required: !isGetCurrentLocation,
                                                message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                            }, 
                                        ],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
                                            disabled: isGetCurrentLocation || (!(province === null || province === void 0 ? void 0 : province.code) || !(district === null || district === void 0 ? void 0 : district.code) || !(ward === null || ward === void 0 ? void 0 : ward.code)) && epicOmni1584Phase2SuggestAddress,
                                            placeholder: (0,i18n.t)("Số nh\xe0, ng\xf5, t\xean đường..."),
                                            onChange: (text)=>{
                                                setSuggestInputText(text);
                                                setOpenListSuggestion(true);
                                                resetPosition();
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                epicOmni1584Phase2SuggestAddress && !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_SuggestWrapper, {
                    children: isLoadingSuggest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Spinner, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Text, {
                                style: {
                                    textAlign: "left"
                                },
                                children: (0,i18n.t)("Gợi \xfd")
                            }),
                            dataSuggestion.map((item)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModeEnterAddress_ItemSuggestion, {
                                    onClick: ()=>onClickSuggest(item.placeId),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Text, {
                                            style: {
                                                textAlign: "left",
                                                marginLeft: 8
                                            },
                                            children: item.fullAddress
                                        })
                                    ]
                                }, item.fullAddress);
                            })
                        ]
                    })
                }),
                messageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperError, {
                    children: messageError
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                    disabled: isLoadingGetDistanceTerminals,
                    block: true,
                    type: "submit",
                    variant: "primary",
                    children: [
                        isLoadingGetDistanceTerminals && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Spinner, {}),
                        (0,i18n.t)("X\xe1c nhận")
                    ]
                })
            ]
        })
    });
};
const ModeEnterAddress_FormAddressV2 = ()=>{
    var ref, ref1;
    const [form] = Form_index_es/* Form.useForm */.l.useForm();
    const { 0: place , 1: setPlace  } = (0,react.useState)({
        lat: undefined,
        long: undefined
    });
    const { epicOmni1584Phase2SuggestAddress  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { locationGetDistanceTerminals , isLoadingGetDistanceTerminals , messageError , isGetCurrentLocation ,  } = useDistanceTerminalContext();
    const { getDistanceTerminalsByGeoLocation , getDistanceTerminalsByAddress  } = useGetDistanceTerminal();
    const { provinces =[] , wards =[] , province , ward , onProvinceChanged , onWardChanged ,  } = (0,useLocationV2/* useLocationsV2 */.W)(locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceCode, locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardCode);
    const getDistanceTerminalsByAddressForm = async (data)=>{
        var ref, ref1;
        const provinceName = ((ref = provinces.find((province)=>province.code === data.provinceCode)) === null || ref === void 0 ? void 0 : ref.title) || "";
        const wardName = ((ref1 = wards.find((ward)=>ward.code === data.wardCode)) === null || ref1 === void 0 ? void 0 : ref1.title) || "";
        getDistanceTerminalsByAddress(desktop_ModeEnterAddress_objectSpreadProps(desktop_ModeEnterAddress_objectSpread({}, data), {
            provinceName,
            wardName,
            lat: place.lat,
            long: place.long
        }));
    };
    (0,react.useEffect)(()=>{
        if (!!locationGetDistanceTerminals) {
            form.setFieldsValue({
                provinceCode: locationGetDistanceTerminals.provinceCode || "",
                wardCode: locationGetDistanceTerminals.wardCode || "",
                address: locationGetDistanceTerminals.address || ""
            });
            onProvinceChanged(locationGetDistanceTerminals.provinceCode);
            onWardChanged(locationGetDistanceTerminals.wardCode);
            setPlace({
                lat: locationGetDistanceTerminals.lat,
                long: locationGetDistanceTerminals.long
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locationGetDistanceTerminals
    ]);
    const { dataSuggestion , setSuggestInputText , openListSuggestion , setOpenListSuggestion , isLoadingSuggest , getPlaceDetails ,  } = (0,useSuggestionAddress/* useSuggestionAddress */.R)({
        province: ((ref = provinces.find((p)=>{
            return p.code === (province === null || province === void 0 ? void 0 : province.code);
        })) === null || ref === void 0 ? void 0 : ref.title) || "",
        ward: ((ref1 = wards.find((w)=>{
            return w.code === (ward === null || ward === void 0 ? void 0 : ward.code);
        })) === null || ref1 === void 0 ? void 0 : ref1.title) || ""
    });
    //
    const onClickSuggest = async (placeId)=>{
        var ref, ref1;
        const items = await getPlaceDetails(placeId);
        if (!items || !Array.isArray(items) || !items.length) {
            return;
        }
        // items là danh sách các placeDetail và cần lấy placeDetail đầu tiên
        // trong case này chỉ gửi 1 placeID lên nên chỉ có 1 placeDetail
        const item = items === null || items === void 0 ? void 0 : items[0];
        const address = ((ref1 = (ref = item.fullAddress.split(",")) === null || ref === void 0 ? void 0 : ref.splice(0, item.fullAddress.split(",").length - ModeEnterAddress_COUNT_STRING_WITHOUT_STREET_ADDRESS)) === null || ref1 === void 0 ? void 0 : ref1.join(",")) || item.fullAddress || "";
        setOpenListSuggestion(false);
        setPlace({
            lat: item.lat,
            long: item.long
        });
        const newValue = desktop_ModeEnterAddress_objectSpread({
            provinceCode: item.provinceCode || undefined
        }, item.wardCode ? {
            wardCode: item.wardCode
        } : {});
        form.setFieldsValue(desktop_ModeEnterAddress_objectSpread({
            address
        }, newValue));
    };
    const resetPosition = ()=>{
        setPlace({
            lat: undefined,
            long: undefined
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form */.l, {
        layout: "vertical",
        form: form,
        onFinish: isGetCurrentLocation ? getDistanceTerminalsByGeoLocation : getDistanceTerminalsByAddressForm,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModeEnterAddress_Wrapper, {
            style: {
                height: !!dataSuggestion && !!openListSuggestion && !!dataSuggestion.length ? 546 : 346
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_SubTitle, {
                            style: {
                                textAlign: "left"
                            },
                            children: (0,i18n.t)("Hoặc nhập địa chỉ ")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            justify: "space-between",
                            marginBottom: "s8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "49%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                        label: (0,i18n.t)("Tỉnh/Th\xe0nh phố"),
                                        trigger: "selectValue",
                                        name: "provinceCode",
                                        rules: [
                                            {
                                                required: !isGetCurrentLocation,
                                                message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                            }, 
                                        ],
                                        validateTrigger: "selectValue",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select_es/* Select */.P, {
                                            options: provinces === null || provinces === void 0 ? void 0 : provinces.map((param)=>{
                                                let { title , code  } = param;
                                                return {
                                                    text: title,
                                                    value: code
                                                };
                                            }),
                                            value: (province === null || province === void 0 ? void 0 : province.code) || "",
                                            maxPerView: 5,
                                            placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Tỉnh/Th\xe0nh phố"),
                                            selectValue: (value)=>{
                                                const location = provinces === null || provinces === void 0 ? void 0 : provinces.find((prov)=>prov.code === value);
                                                if (location) {
                                                    onProvinceChanged(location.code);
                                                    form.setFieldsValue({
                                                        provinceCode: location.code,
                                                        wardCode: ""
                                                    });
                                                    onWardChanged("");
                                                    resetPosition();
                                                }
                                            },
                                            disabled: isGetCurrentLocation,
                                            onDelete: ()=>{
                                                form.setFieldsValue({
                                                    provinceCode: "",
                                                    wardCode: ""
                                                });
                                                onProvinceChanged("");
                                                resetPosition();
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "49%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                        label: (0,i18n.t)("Phường/X\xe3"),
                                        trigger: "selectValue",
                                        name: "wardCode",
                                        rules: [
                                            {
                                                required: !isGetCurrentLocation,
                                                message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                            }, 
                                        ],
                                        validateTrigger: "selectValue",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_Select_es/* Select */.P, {
                                            options: wards.map((param)=>{
                                                let { title , code  } = param;
                                                return {
                                                    text: title,
                                                    value: code
                                                };
                                            }),
                                            value: (ward === null || ward === void 0 ? void 0 : ward.code) || "",
                                            maxPerView: 5,
                                            placeholder: (0,translate/* tSelectPlaceholder */.Kt)("Phường/X\xe3"),
                                            selectValue: (value)=>{
                                                const location = wards === null || wards === void 0 ? void 0 : wards.find((ward)=>ward.code === value);
                                                if (location) {
                                                    onWardChanged(location.code);
                                                    form.setFieldsValue({
                                                        wardCode: location.code
                                                    });
                                                    resetPosition();
                                                }
                                            },
                                            onDelete: ()=>{
                                                form.setFieldsValue({
                                                    wardCode: ""
                                                });
                                                onWardChanged("");
                                                resetPosition();
                                            },
                                            disabled: isGetCurrentLocation
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                            label: (0,i18n.t)("Địa chỉ cụ thể"),
                            name: "address",
                            rules: [
                                {
                                    required: !isGetCurrentLocation,
                                    message: (0,i18n.t)("${label} kh\xf4ng được bỏ trống")
                                }, 
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
                                disabled: isGetCurrentLocation,
                                placeholder: (0,i18n.t)("Số nh\xe0, ng\xf5, t\xean đường..."),
                                onChange: (text)=>{
                                    setSuggestInputText(text);
                                    setOpenListSuggestion(true);
                                }
                            })
                        }),
                        epicOmni1584Phase2SuggestAddress && !!dataSuggestion && !!openListSuggestion && (!!dataSuggestion.length || isLoadingSuggest) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_SuggestWrapper, {
                            children: isLoadingSuggest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                justify: "center",
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Spinner, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Text, {
                                        style: {
                                            textAlign: "left"
                                        },
                                        children: (0,i18n.t)("Gợi \xfd")
                                    }),
                                    dataSuggestion.map((item)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModeEnterAddress_ItemSuggestion, {
                                            onClick: ()=>onClickSuggest(item.placeId),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Text, {
                                                    style: {
                                                        textAlign: "left",
                                                        marginLeft: 8
                                                    },
                                                    children: item.fullAddress
                                                })
                                            ]
                                        }, item.fullAddress);
                                    })
                                ]
                            })
                        })
                    ]
                }),
                messageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperError, {
                    children: messageError
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                    disabled: isLoadingGetDistanceTerminals,
                    block: true,
                    type: "submit",
                    variant: "primary",
                    children: [
                        isLoadingGetDistanceTerminals && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Spinner, {}),
                        (0,i18n.t)("X\xe1c nhận")
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ./modules/terminal/desktop/TerminalPickerItem.tsx
var TerminalPickerItem = __webpack_require__(664638);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/PenColored.es.js
var PenColored_es = __webpack_require__(319027);
;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/desktop/ModeListTerminal.tsx
function desktop_ModeListTerminal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function desktop_ModeListTerminal_templateObject() {
    const data = desktop_ModeListTerminal_taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 500;\n"
    ]);
    desktop_ModeListTerminal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModeListTerminal_templateObject1() {
    const data = desktop_ModeListTerminal_taggedTemplateLiteral([
        "\n  height: 30vh;\n  overflow: auto;\n  margin-bottom: 16px;\n"
    ]);
    ModeListTerminal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModeListTerminal_templateObject2() {
    const data = desktop_ModeListTerminal_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n"
    ]);
    ModeListTerminal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









const ModeListTerminal_ModeListTerminal = ()=>{
    var ref, ref1;
    const { currentTerminal , setNewTerminal , isLoadingGetDistanceTerminals , setIsModeEnterAddress , isModeEnterAddress , isGetCurrentLocation , temporaryDataDistanceTerminal , currentTerminals =[] ,  } = useDistanceTerminalContext();
    const { colors  } = (0,Theme_es/* useTheme */.F)();
    const { 0: terminal , 1: setTerminal  } = (0,react.useState)(undefined);
    const { epicOmni1589  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { location: locationGetDistanceTerminals  } = temporaryDataDistanceTerminal;
    (0,react.useEffect)(()=>{
        if (!!currentTerminals && Array.isArray(currentTerminals) && !!currentTerminals.length && !isModeEnterAddress) {
            setTerminal === null || setTerminal === void 0 ? void 0 : setTerminal(!!currentTerminal ? currentTerminals.find((t)=>t.terminalId === currentTerminal.terminalId) || (currentTerminals === null || currentTerminals === void 0 ? void 0 : currentTerminals[0]) : currentTerminals === null || currentTerminals === void 0 ? void 0 : currentTerminals[0]);
        }
    }, [
        currentTerminal,
        currentTerminals,
        isModeEnterAddress
    ]);
    if (isLoadingGetDistanceTerminals) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal_Wrapper, {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_Spinner, {})
        });
    }
    const onUpdateAddress = ()=>{
        setIsModeEnterAddress === null || setIsModeEnterAddress === void 0 ? void 0 : setIsModeEnterAddress(!isModeEnterAddress);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isGetCurrentLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchGetByGeoLocation_SwitchGetByGeoLocation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                justify: "space-between",
                children: [
                    isGetCurrentLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal_Title, {
                        style: {
                            marginLeft: 4,
                            width: "75%"
                        },
                        children: (0,i18n.t)("Đang sử dụng vị tr\xed hiện tại của bạn")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModeListTerminal_Title, {
                        style: {
                            marginLeft: 4,
                            width: "75%"
                        },
                        children: [
                            "Địa chỉ: ",
                            locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.address,
                            ",",
                            " ",
                            locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.wardName,
                            ",",
                            " ",
                            !epicOmni1589 ? "".concat(locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.districtName, ", ") : "",
                            locationGetDistanceTerminals === null || locationGetDistanceTerminals === void 0 ? void 0 : locationGetDistanceTerminals.provinceName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        onClick: onUpdateAddress,
                        style: {
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PenColored_es/* PenColored */.$, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal_Title, {
                                style: {
                                    fontWeight: "initial",
                                    color: colors.primary,
                                    marginLeft: 8
                                },
                                children: (0,i18n.t)("Thay đổi")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModeListTerminal_Title, {
                children: [
                    temporaryDataDistanceTerminal === null || temporaryDataDistanceTerminal === void 0 ? void 0 : (ref = temporaryDataDistanceTerminal.terminals) === null || ref === void 0 ? void 0 : ref.length,
                    " ",
                    (0,i18n.t)("si\xeau thị gần bạn"),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal_Wrapper, {
                children: temporaryDataDistanceTerminal === null || temporaryDataDistanceTerminal === void 0 ? void 0 : (ref1 = temporaryDataDistanceTerminal.terminals) === null || ref1 === void 0 ? void 0 : ref1.map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TerminalPickerItem/* TerminalPickerItem */.m, {
                        onClick: ()=>setTerminal(item),
                        isChoice: (terminal === null || terminal === void 0 ? void 0 : terminal.terminalId) === item.terminalId,
                        terminalName: item.terminalName,
                        distance: item.distance,
                        terminalAddress: item.fullAddress
                    }, item.terminalId);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                block: true,
                onClick: ()=>{
                    if (!!terminal) {
                        setNewTerminal === null || setNewTerminal === void 0 ? void 0 : setNewTerminal(terminal);
                    }
                },
                variant: "primary",
                disabled: !terminal || isLoadingGetDistanceTerminals,
                children: (0,i18n.t)("Mua sắm ngay")
            })
        ]
    });
};
const ModeListTerminal_Title = emotion_styled_browser_esm["default"].span(desktop_ModeListTerminal_templateObject());
const ModeListTerminal_Wrapper = emotion_styled_browser_esm["default"].div(ModeListTerminal_templateObject1());
const Header = (0,emotion_styled_browser_esm["default"])(Row_es/* Row */.X)(ModeListTerminal_templateObject2());

;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/desktop/PopupTerminalPickerDesktop.tsx
function PopupTerminalPickerDesktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PopupTerminalPickerDesktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupTerminalPickerDesktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PopupTerminalPickerDesktop_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PopupTerminalPickerDesktop_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PopupTerminalPickerDesktop_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PopupTerminalPickerDesktop_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PopupTerminalPickerDesktop_templateObject() {
    const data = PopupTerminalPickerDesktop_taggedTemplateLiteral([
        "\n  padding: 32px 8px;\n"
    ]);
    PopupTerminalPickerDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const PopupTerminalPickerDesktop = (param)=>{
    let { onClosePopup , showPopup  } = param;
    const { isModeEnterAddress , locationGetDistanceTerminals , currentTerminals , setTemporaryDataDistanceTerminal , temporaryDataDistanceTerminal ,  } = useDistanceTerminalContext();
    (0,react.useEffect)(()=>{
        if (!!showPopup) {
            setTemporaryDataDistanceTerminal === null || setTemporaryDataDistanceTerminal === void 0 ? void 0 : setTemporaryDataDistanceTerminal(PopupTerminalPickerDesktop_objectSpread(PopupTerminalPickerDesktop_objectSpreadProps(PopupTerminalPickerDesktop_objectSpread({}, temporaryDataDistanceTerminal), {
                terminals: !!currentTerminals && Array.isArray(currentTerminals) ? currentTerminals : []
            }), locationGetDistanceTerminals ? {
                location: locationGetDistanceTerminals
            } : {}));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentTerminals,
        locationGetDistanceTerminals,
        showPopup
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
        visible: showPopup,
        onClose: onClosePopup,
        showCloseIcon: false,
        footer: false,
        width: 700,
        contentStyle: {
            borderRadius: "24px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupTerminalPickerDesktop_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginBottom: 12,
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                        src: terminal_picker,
                        width: 160,
                        height: 100
                    })
                }),
                isModeEnterAddress ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeEnterAddress_ModeEnterAddress, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeListTerminal_ModeListTerminal, {})
            ]
        })
    });
};
const PopupTerminalPickerDesktop_Wrapper = emotion_styled_browser_esm["default"].div(PopupTerminalPickerDesktop_templateObject());

;// CONCATENATED MODULE: ./components/Terminal/PopupTerminalPicker/index.tsx
function PopupTerminalPicker_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function PopupTerminalPicker_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupTerminalPicker_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const PopupTerminalPicker = (_param)=>{
    var props = _extends({}, _param);
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupTerminalPickerMobile, PopupTerminalPicker_objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupTerminalPickerDesktop, PopupTerminalPicker_objectSpread({}, props));
};

// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(353632);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(479228);
;// CONCATENATED MODULE: ./contexts/DistanceTerminalProvider/index.tsx










const defaultTemporaryData = {
    location: {
        address: "",
        provinceCode: "",
        wardCode: "",
        provinceName: "",
        wardName: "",
        districtCode: "",
        districtName: ""
    },
    terminals: []
};
const DistanceTerminalContext = /*#__PURE__*/ (0,react.createContext)({
    temporaryDataDistanceTerminal: defaultTemporaryData
});
const DistanceTerminalProvider = (param)=>{
    let { children  } = param;
    const { epicOmni1584Phase2 , isDmsFlow , platformId , isMobile , clearCacheAfterSwitchLocation , isAllowGetTerminalFromTerra , terminalId ,  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { orderService  } = (0,ServiceContext/* useServices */.Su)();
    const { 0: loading , 1: setLoading  } = (0,react.useState)(false);
    const [, setLoadingGetDistanceTerminal] = (0,context_es/* useLoading */.r$)("distanceTerminal");
    const { 0: currentTerminal , 1: setCurrentTerminal  } = (0,react.useState)(undefined);
    const { 0: currentTerminals , 1: setCurrentTerminals  } = (0,react.useState)([]);
    const { 0: showTerminalPicker , 1: setShowTerminalPicker  } = (0,react.useState)(false);
    const { 0: isGetCurrentLocation , 1: setIsGetCurrentLocation  } = (0,react.useState)(false);
    const { 0: isModeEnterAddress , 1: setIsModeEnterAddress  } = (0,react.useState)(true);
    const { 0: messageError , 1: setMessageError  } = (0,react.useState)("");
    const { 0: permissionStatus , 1: setPermissionStatus  } = (0,react.useState)("denied");
    const { 0: temporaryData , 1: setTemporaryData  } = (0,react.useState)(defaultTemporaryData);
    const { 0: location , 1: setLocation  } = (0,react.useState)({
        address: "",
        provinceCode: "",
        wardCode: "",
        provinceName: "",
        wardName: "",
        districtCode: "",
        districtName: ""
    });
    const onOpenTerminalPicker = ()=>{
        setShowTerminalPicker(true);
        setMessageError("");
    };
    const onCloseTerminalPicker = ()=>{
        if (!currentTerminal) {
            return;
        }
        setShowTerminalPicker(false);
    };
    const selectTerminal = (terminal)=>{
        var ref;
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, terminal.terminalCode, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, terminal.terminalName, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.terminalId) === null || ref === void 0 ? void 0 : ref.toString(), isMobile, true);
        (0,env/* setLocalStorageValue */.uN)(local/* userSelectedConstants.USER_LOCATION */.Tp.USER_LOCATION, JSON.stringify(temporaryData.location), isMobile);
        (0,env/* setLocalStorageValue */.uN)(local/* userSelectedConstants.TERMINALS */.Tp.TERMINALS, JSON.stringify(temporaryData.terminals), isMobile);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.IS_GET_GEOLOCATION */.Tp.IS_GET_GEOLOCATION, JSON.stringify(isGetCurrentLocation), isMobile, true);
        setCurrentTerminal(terminal);
    };
    const setNewTerminal = (terminal, noNeedReload, reloadUrl)=>{
        if (!terminal) {
            return;
        }
        selectTerminal(terminal);
        if (!noNeedReload) {
            if (clearCacheAfterSwitchLocation) {
                (0,helpers/* clearCacheAndReloadPage */.w5)(reloadUrl);
            } else {
                (0,helpers/* reloadPage */.sl)(reloadUrl);
            }
        }
    };
    const overrideTerminal = async (location, terminal, terminals, noNeedReload, reloadUrl)=>{
        var ref;
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, terminal.terminalCode, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, terminal.terminalName, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.terminalId) === null || ref === void 0 ? void 0 : ref.toString(), isMobile, true);
        (0,env/* setLocalStorageValue */.uN)(local/* userSelectedConstants.USER_LOCATION */.Tp.USER_LOCATION, JSON.stringify(location), isMobile);
        (0,env/* setLocalStorageValue */.uN)(local/* userSelectedConstants.TERMINALS */.Tp.TERMINALS, JSON.stringify(terminals), isMobile);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.IS_GET_GEOLOCATION */.Tp.IS_GET_GEOLOCATION, JSON.stringify(false), isMobile, true);
        setLocation(location);
        setCurrentTerminal(terminal);
        setCurrentTerminals(terminals);
        setIsGetCurrentLocation(false);
        if (!noNeedReload) {
            if (clearCacheAfterSwitchLocation) {
                (0,helpers/* clearCacheAndReloadPage */.w5)(reloadUrl);
            } else {
                (0,helpers/* reloadPage */.sl)(reloadUrl);
            }
        }
    };
    const getDistanceLocation = async (param)=>{
        let { address , lat , long  } = param;
        try {
            setLoading(true);
            const response = await orderService.getTerminalsByAddress({
                fullAddress: address,
                lat,
                long,
                platformId
            });
            setLoading(false);
            return response.data.terminals;
        } catch (error) {
            setLoading(false);
            return [];
        }
    };
    const getDataFromLocalStorage = ()=>{
        const terminalCodeFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, isMobile, true);
        const terminalsFromStorage = (0,env/* getLocalStorageValue */.jy)(local/* userSelectedConstants.TERMINALS */.Tp.TERMINALS, isMobile);
        const isGetGeoLocationFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.IS_GET_GEOLOCATION */.Tp.IS_GET_GEOLOCATION, isMobile, true);
        const jsonUserLocationFromStorage = (0,env/* getLocalStorageValue */.jy)(local/* userSelectedConstants.USER_LOCATION */.Tp.USER_LOCATION, isMobile);
        return {
            terminalCodeFromStorage,
            terminalsFromStorage,
            isGetGeoLocationFromStorage,
            jsonUserLocationFromStorage
        };
    };
    const getAndSaveTerminalFromStorage = async ()=>{
        (0,helper_es/* trackCustomEvent */.I)("Start get data from storage", {
            action: "get data from terra",
            label: "Huy Test"
        });
        if (dist/* default.isAvailable */.Z.isAvailable() && isAllowGetTerminalFromTerra) {
            (0,helper_es/* trackCustomEvent */.I)("Start get terminal Data FromApp when turn on flag 1584", {});
            const terminalDataFromApp = await dist/* default.erp */.Z.erp().getTerminal();
            (0,helper_es/* trackCustomEvent */.I)("Terminal Data FromApp when turn on flag 1584", {
                action: "get data from terra",
                label: JSON.stringify(terminalDataFromApp)
            });
            if (!!terminalDataFromApp && terminalId !== terminalDataFromApp.id) {
                (0,helper_es/* trackCustomEvent */.I)("Start save Terminal Data FromApp when turn on flag 1584", {
                    action: "get data from terra",
                    label: "".concat(terminalDataFromApp, " + ").concat(terminalDataFromApp.id)
                });
                setNewTerminal({
                    terminalCode: terminalDataFromApp.code,
                    terminalId: terminalDataFromApp.id,
                    terminalName: terminalDataFromApp.name || "",
                    siteId: 0,
                    fullAddress: "",
                    distance: 0,
                    provinceCode: ""
                });
            }
            return;
        }
        const { terminalCodeFromStorage , terminalsFromStorage , isGetGeoLocationFromStorage , jsonUserLocationFromStorage ,  } = getDataFromLocalStorage();
        if (!!isGetGeoLocationFromStorage) {
            setIsGetCurrentLocation((0,common/* getJson */.LK)(isGetGeoLocationFromStorage));
        }
        if (!!terminalsFromStorage) {
            setCurrentTerminals((0,common/* getJson */.LK)(terminalsFromStorage) || []);
        }
        if (!!jsonUserLocationFromStorage) {
            const userLocationFromStorage = (0,common/* getJson */.LK)(jsonUserLocationFromStorage);
            if (!!userLocationFromStorage) {
                setLocation(userLocationFromStorage);
            }
        }
        if (!!terminalCodeFromStorage && !!terminalsFromStorage) {
            const terminals = (0,common/* getJson */.LK)(terminalsFromStorage) || [];
            const terminal = terminals.find((item)=>item.terminalCode === terminalCodeFromStorage);
            setCurrentTerminal(terminal);
        }
        if (!!terminalsFromStorage && !!jsonUserLocationFromStorage) {
            const userLocationFromStorage1 = (0,common/* getJson */.LK)(jsonUserLocationFromStorage);
            const terminals1 = (0,common/* getJson */.LK)(terminalsFromStorage) || [];
            setTemporaryData({
                location: userLocationFromStorage1,
                terminals: terminals1 || []
            });
        }
    };
    (0,react.useEffect)(()=>{
        if ("geolocation" in navigator && "permissions" in navigator) {
            navigator.permissions.query({
                name: "geolocation"
            }).then((result)=>{
                setPermissionStatus(result.state); // 'granted', 'prompt', or 'denied'
            }).catch(()=>{
                setPermissionStatus("denied");
            });
        } else {
            setPermissionStatus("denied");
        }
    }, []);
    (0,react.useEffect)(()=>{
        const { jsonUserLocationFromStorage  } = getDataFromLocalStorage();
        if (!isDmsFlow && epicOmni1584Phase2) {
            getAndSaveTerminalFromStorage();
        } else {
            // only remove location & terminal info and reload page If level location is set before (epicOmni1584 were enabled before)
            if (!!jsonUserLocationFromStorage && !epicOmni1584Phase2) {
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.USER_LOCATION */.Tp.USER_LOCATION, isMobile);
                (0,helpers/* reloadPage */.sl)();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(()=>{
        const handleScrollOrClickWhenFirstTimeVisitWeb = ()=>{
            const { terminalCodeFromStorage , terminalsFromStorage , jsonUserLocationFromStorage ,  } = getDataFromLocalStorage();
            if ((!terminalCodeFromStorage || !terminalsFromStorage || !jsonUserLocationFromStorage) && !showTerminalPicker && !dist/* default.isAvailable */.Z.isAvailable()) {
                // trong TH la webview thi se khong can hien popup ma tuyen tu app xuong
                // duoc xu ly o ham getAndSaveTerminalFromStorage o tren
                onOpenTerminalPicker();
                (0,helper_es/* trackCustomEvent */.I)("visitWebsiteInTheFirstTime", {});
            }
        };
        window.addEventListener("scroll", handleScrollOrClickWhenFirstTimeVisitWeb);
        document.body.addEventListener("click", handleScrollOrClickWhenFirstTimeVisitWeb);
        return ()=>{
            window.removeEventListener("scroll", handleScrollOrClickWhenFirstTimeVisitWeb);
            document.body.removeEventListener("click", handleScrollOrClickWhenFirstTimeVisitWeb);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DistanceTerminalContext.Provider, {
        value: {
            setLoadingGetDistanceTerminals: setLoading,
            isLoadingGetDistanceTerminals: loading,
            setLocationGetDistanceTerminals: setLocation,
            locationGetDistanceTerminals: location,
            currentTerminal,
            currentTerminals,
            showTerminalPicker,
            onOpenTerminalPicker,
            onCloseTerminalPicker,
            isGetCurrentLocation,
            setIsGetCurrentLocation,
            getDistanceLocation,
            isModeEnterAddress,
            setIsModeEnterAddress,
            setNewTerminal,
            messageError,
            setMessageError,
            setLoadingGetDistanceTerminal,
            overrideTerminal,
            permissionGetLocationStatus: permissionStatus,
            temporaryDataDistanceTerminal: temporaryData,
            setTemporaryDataDistanceTerminal: setTemporaryData
        },
        children: [
            children,
            !isDmsFlow && !!epicOmni1584Phase2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupTerminalPicker, {
                showPopup: showTerminalPicker,
                onClosePopup: onCloseTerminalPicker
            })
        ]
    });
};
const useDistanceTerminalContext = ()=>{
    return (0,react.useContext)(DistanceTerminalContext);
};


/***/ }),

/***/ 723357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FeatureFlagProvider; },
  "g": function() { return /* binding */ useFeatureFlags; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./configs/featureFlags.ts
const FLAG_SUP_FEATURES = {
    WEBAPP_RETURN_REQUEST: true,
    epic_ecom_269: false,
    epic_pb_613: false,
    epic_omni_389: false,
    MML_NO_PAYMENT: false,
    epic_omni_677: false,
    epic_omni_964: true,
    epic_ecom_284: false,
    epic_ecom_460: false,
    omni_848_consumer: true,
    epic_ecom_315: false,
    epic_omni_1237: false,
    epic_ecom_479: false,
    epic_ecom_483: false,
    epic_ma_150: false,
    epic_omni_1034: false,
    epic_omni_1403: false,
    epic_omni_1358: false,
    epic_ma_229: false,
    epic_ma_79: false,
    epic_omni_1459: false,
    epic_omni_1552: false,
    epic_omni_1359: false
};

// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
;// CONCATENATED MODULE: ./contexts/FeatureFlagProvider.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const FeatureFlagContext = /*#__PURE__*/ (0,react.createContext)({
    flags: FLAG_SUP_FEATURES
});
const FeatureFlagProvider = (param)=>{
    let { children , flags  } = param;
    flags = flags || FLAG_SUP_FEATURES;
    const { disableEpicEcom284  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagContext.Provider, {
        value: {
            flags: _objectSpreadProps(_objectSpread({}, flags), {
                /**
            UX4BUYER-5240 additional platform flag.
            disableEpicEcom284 turns off the epic for a specific platform
          */ epic_ecom_284: flags.epic_ecom_284 && !disableEpicEcom284
            })
        },
        children: children
    });
};
const useFeatureFlags = ()=>{
    return (0,react.useContext)(FeatureFlagContext);
};


/***/ }),

/***/ 927890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ FrameProvider; },
/* harmony export */   "x": function() { return /* binding */ useFrame; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(700074);



const initialState = {
    frames: []
};
const FrameStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(initialState);
const FrameProvider = (param)=>{
    let { children  } = param;
    const { banners: listFrames  } = (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useBanners */ .U)("frame");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FrameStateContext.Provider, {
        value: {
            frames: listFrames
        },
        children: children
    });
};
function useFrame() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FrameStateContext);
    if (!context) {
        throw new Error("useFrame must be inside a FrameStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 684443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U5": function() { return /* binding */ useGlobalData; },
/* harmony export */   "Uw": function() { return /* binding */ GlobalDataProvider; },
/* harmony export */   "Wx": function() { return /* binding */ useTenantConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const GlobalDataContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const GlobalDataProvider = GlobalDataContext.Provider;
function useGlobalData() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GlobalDataContext);
    if (!context) {
        throw new Error("useGlobalData must be inside a GlobalDataProvider with a state value");
    }
    return context;
}
// for backward compatible
const useTenantConfig = ()=>{
    return useGlobalData();
};


/***/ }),

/***/ 329706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useHelper; },
/* harmony export */   "d": function() { return /* binding */ HelperProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(681889);



const HelperStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext({
    productHelper: helpers__WEBPACK_IMPORTED_MODULE_2__/* .productHelper */ .gU
});
const HelperProvider = (param)=>{
    let { children , freeShippingThreshold  } = param;
    const { 0: productHelper , 1: setProductHelper  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(helpers__WEBPACK_IMPORTED_MODULE_2__/* .productHelper */ .gU);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (typeof freeShippingThreshold === "number" && freeShippingThreshold >= 0) {
            setProductHelper(new helpers__WEBPACK_IMPORTED_MODULE_2__/* .ProductHelper */ .xZ(freeShippingThreshold));
        }
    }, [
        freeShippingThreshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelperStateContext.Provider, {
        value: {
            productHelper,
            setProductHelper
        },
        children: children
    });
};
function useHelper() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(HelperStateContext);
    if (!context) {
        throw new Error("useHelper must be inside a HelperStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 158610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useLocation; },
/* harmony export */   "v": function() { return /* binding */ LocationProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(150923);
/* harmony import */ var _FeatureFlagProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(723357);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(106454);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(621655);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(788813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(353632);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(479228);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);










const LocationPicker = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(85675), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(66328), __webpack_require__.e(27411), __webpack_require__.e(60397), __webpack_require__.e(38057)]).then(__webpack_require__.bind(__webpack_require__, 60397)).then((mod)=>mod.LocationPicker), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(60397)
            ]
    }
});
const LocationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    locations: [],
    onCloseRegionPickerSuggestionPopover: ()=>undefined,
    setShowed: ()=>{},
    showRegionPickerSuggestionPopover: false,
    loading: true
});
const useLocation = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LocationContext);
};
const LocationProvider = (param)=>{
    let { children ,  } = param;
    const { isMobile , location: selectedLocationCode , locations =[] , clearCacheAfterSwitchLocation ,  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalData */ .U5)();
    const [, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .useLoading */ .r$)("location");
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { flags  } = (0,_FeatureFlagProvider__WEBPACK_IMPORTED_MODULE_5__/* .useFeatureFlags */ .g)();
    const regionPickerSuggestionPopoverClosed = (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_HINT_SHOWED */ .J0));
    const showRegionPickerSuggestionPopover = !regionPickerSuggestionPopoverClosed && (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_MESSAGE */ .GX) === types__WEBPACK_IMPORTED_MODULE_8__/* .LocationMessageType.Hint */ .t.Hint && (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284);
    const hideSearchBox = locations.length <= 10;
    const onSelectLocation = (location)=>{
        if ((0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)()) {
            (0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_7__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, location.locationCode);
            setLoading(true);
            setShow(false);
            if (clearCacheAfterSwitchLocation) {
                (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .clearCacheAndReloadPage */ .w5)();
            } else {
                (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .reloadPage */ .sl)();
            }
        }
    };
    const enabled = locations.length > 1 && (flags === null || flags === void 0 ? void 0 : flags.epic_ecom_284);
    const loading = !(0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)();
    const onCloseRegionPickerSuggestionPopover = ()=>{
        sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_HINT_SHOWED */ .J0, "true");
    };
    const selectedLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>locations.find((param)=>{
            let { locationCode  } = param;
            return locationCode === selectedLocationCode;
        }), [
        locations,
        selectedLocationCode
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LocationContext.Provider, {
        value: {
            locations,
            isShowed: show,
            setShowed: setShow,
            onSelectLocation,
            showRegionPickerSuggestionPopover,
            onCloseRegionPickerSuggestionPopover,
            selectedLocation,
            enabled,
            loading
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u, {
                width: isMobile ? 300 : 400,
                visible: (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .isServerless */ .ep)() && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_LOCATION_MESSAGE */ .GX) === types__WEBPACK_IMPORTED_MODULE_8__/* .LocationMessageType.Error */ .t.Error,
                onOk: ()=>{
                    (0,helpers__WEBPACK_IMPORTED_MODULE_6__/* .reloadPage */ .sl)();
                },
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Thử lại"),
                cancelText: "",
                showCloseIcon: false,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Th\xf4ng b\xe1o"),
                centeredTitle: true,
                alignFooter: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .ModalBody */ .f, {
                    padding: [
                        "s0",
                        "s0"
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                        level: 1,
                        style: {
                            textAlign: "center"
                        },
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)("Hiện tại kh\xf4ng lấy được th\xf4ng tin địa điểm để hiển thị sản phẩm ph\xf9 hợp với bạn. Vui l\xf2ng thử lại hoặc quay lại sau gi\xe2y l\xe1t!")
                    })
                })
            }),
            children,
            show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LocationPicker, {
                isShowed: show,
                isMobile: isMobile,
                setShowed: setShow,
                locations: locations,
                onSelectLocation: onSelectLocation,
                selectedLocation: selectedLocation,
                hideSearchBox: hideSearchBox
            })
        ]
    });
};


/***/ }),

/***/ 261105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LoyaltyProvider; },
/* harmony export */   "m": function() { return /* binding */ useLoyalty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(983546);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(420577);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var _ServiceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(643015);






const LoyaltyContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
const useLoyalty = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(LoyaltyContext);
    if (context === undefined) {
        throw new Error("useLoyalty must be used within a LoyaltyProvider");
    }
    return context;
};
const LoyaltyProvider = (param)=>{
    let { children ,  } = param;
    const { needToCheckLoyaltyMemberId , notFetchLoyaltyMemberInfoGlobally  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { 0: loyaltyMemberInfo , 1: setLoyaltyMemberInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const { 0: triggerGetMemberInfo , 1: setTriggerGetMemberInfo  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    const { loyaltyBFFService  } = (0,_ServiceContext__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // call getLoyaltyInfo only when user account had phone number
        const shouldFetchLoyaltyInfo = !!needToCheckLoyaltyMemberId ? (user === null || user === void 0 ? void 0 : user.telephone) && (user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : user === null || user === void 0 ? void 0 : user.telephone;
        if (shouldFetchLoyaltyInfo) {
            const getLoyaltyInfo = async ()=>{
                try {
                    setLoading(true);
                    const loyaltyClientId = loyaltyBFFService.getClientId();
                    if (loyaltyClientId) {
                        if (!notFetchLoyaltyMemberInfoGlobally) {
                            const data = await loyaltyBFFService.getLoyaltyMemberInfo();
                            setLoyaltyMemberInfo(data);
                        }
                    }
                } catch (e) {
                    _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
                } finally{
                    setLoading(false);
                }
            };
            getLoyaltyInfo();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.telephone,
        triggerGetMemberInfo
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LoyaltyContext.Provider, {
        value: {
            loyaltyMemberInfo,
            loading,
            setTriggerGetMemberInfo
        },
        children: children
    });
};


/***/ }),

/***/ 868673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PopularKeywordProvider; },
/* harmony export */   "y": function() { return /* binding */ usePopularKeyword; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(964590);



const initialState = {
    terms: [],
    setStartCallApi: ()=>{}
};
const PopularKeywordStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(initialState);
const PopularKeywordProvider = (param)=>{
    let { children  } = param;
    const { 0: startCallApi , 1: setStartCallApi  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { result  } = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* .useRecommendedKeywords */ .o)(startCallApi);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PopularKeywordStateContext.Provider, {
        value: {
            terms: result,
            setStartCallApi
        },
        children: children
    });
};
function usePopularKeyword() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PopularKeywordStateContext);
    if (!context) {
        throw new Error("usePopularKeyword must be inside a PopularKeywordStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 990497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ PrivacyPolicyProvider; },
/* harmony export */   "q": function() { return /* binding */ usePrivacyPolicy; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _ServiceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(643015);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(420577);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(811495);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(291692);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(309110);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(634655);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(684443);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(983546);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(451765);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(284587);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(679376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(723357);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(788813);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(118042);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59181);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(446586);
/* harmony import */ var components_PrivacyPolicies__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(644525);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















const initialValues = {
    loading: false,
    policies: [],
    shouldShowSelector: false,
    showSelector: ()=>{},
    submitPoliciesApproval: async ()=>{},
    buildPrivacyPolicyList: ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
};
const PrivacyPolicyContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initialValues);
// currently cached submit payload is hardcoded to expire after 3 days.
const submitPayloadTTL = 3;
const PrivacyPolicyProvider = (param)=>{
    let { children  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { user , loading: authLoading , authService  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    const { privacyPolicyService , notificationService  } = (0,_ServiceContext__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    const { showModal  } = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_6__/* .useModal */ .d)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useFeatureFlags */ .g)();
    const { privacyPolicyCacheTTL =30 , isMobile , currentLanguage , notificationAppId ,  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)();
    const { partner  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_8__/* .useGlobalData */ .U5)();
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: policies , 1: setPolicies  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: shouldShowSelector , 1: setShouldShowSelector  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const submitCallback = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(()=>{});
    const { 0: userSelectedLoginMethod , 1: setUserSelectedLoginMethod  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const isLoginPage = !!router.pathname.endsWith("/login");
    const saveUserPoliciesSelectedToLocalStorage = (policies)=>{
        const LSKey = "".concat(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_UNLOGGED_USER_PRIVACY_POLICIES */ .Lb, "_").concat(currentLanguage || "vi");
        const privacyPolicies = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .parseJsonStringSafely */ .O)(localStorage.getItem(LSKey));
        const savingPolicies = policies.map((policy)=>({
                id: policy.id,
                isApprovalRequired: policy.isApprovalRequired,
                isApproved: policy.isApproved
            }));
        if (!!userSelectedLoginMethod && !!savingPolicies) {
            const { loginMethod , userPhone  } = userSelectedLoginMethod;
            const newPrivacyPolicies = _objectSpread({}, privacyPolicies || {}, loginMethod === _constants__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_METHOD.FACEBOOK */ .Ev.FACEBOOK && {
                facebookUserSelectedPolicies: savingPolicies
            }, loginMethod === _constants__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_METHOD.GOOGLE */ .Ev.GOOGLE && {
                googleUserSelectedPolicies: savingPolicies
            }, loginMethod === _constants__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_METHOD.PHONE */ .Ev.PHONE && !!userPhone && {
                phoneUserSelectedPolicies: _objectSpreadProps(_objectSpread({}, (privacyPolicies === null || privacyPolicies === void 0 ? void 0 : privacyPolicies.phoneUserSelectedPolicies) || {}), {
                    [userPhone]: savingPolicies
                })
            });
            localStorage.setItem(LSKey, JSON.stringify(newPrivacyPolicies));
        }
    };
    const submitPoliciesApproval = async (callback)=>{
        if (validateApproval(policies)) {
            try {
                setLoading(true);
                await internalSubmit(authService.isLoggedIn());
                if (!!userSelectedLoginMethod) {
                    // saving user policies selected to localStorage
                    saveUserPoliciesSelectedToLocalStorage(policies);
                }
            } catch (e) {
            // submit failed, cache saved for retry later so no need to do anything
            } finally{
                setShow(false);
                setLoading(false);
                callback === null || callback === void 0 ? void 0 : callback();
            }
        } else {
            showWarningModal();
        }
    };
    /**
   * Underlying logic to handle fetch policies from api and save to cache
   * */ const internalGetPolicies = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async (isAuthed)=>{
        const policies = await privacyPolicyService.getPolicies();
        const isUserAllowed = checkUserAllowed(policies);
        const now = new Date().toString();
        setPolicies(policies);
        setShouldShowSelector(policies.length > 0);
        // Dont cache user specified policies
        if (!isAuthed) {
            localStorage.setItem("".concat(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_PRIVACY_POLICIES */ .Oc, "_").concat(currentLanguage || "vi"), JSON.stringify({
                policies: policies,
                createdAt: now
            }));
        } else {
            localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY */ .Hg, JSON.stringify({
                isAllowed: isUserAllowed,
                createdAt: now
            }));
        }
    }, [
        currentLanguage,
        privacyPolicyService
    ]);
    /**
   * Underlying logic to submit approval to remote api and handle error
   * */ const internalSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async function(isAuthed, customPolicies) {
        let skipSave = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        // policy type 1 is only used to show to user
        const submitPolicies = customPolicies || policies.filter((policy)=>policy.policyTypeId !== types__WEBPACK_IMPORTED_MODULE_12__/* .PolicyTypeId.TYPE_1 */ .Y.TYPE_1).map((param)=>{
            let { id , version , language , isApproved  } = param;
            return {
                id,
                version,
                language,
                isApproved: isApproved || false
            };
        });
        try {
            // only submit when accessToken is available
            if (isAuthed) {
                await privacyPolicyService.submitPolicies(submitPolicies);
                localStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */ .i7);
            } else !skipSave && saveSubmitPolicies(submitPolicies);
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
            // saved for retry later
            if (!skipSave) saveSubmitPolicies(submitPolicies);
            throw e;
        }
    }, [
        policies,
        privacyPolicyService
    ]);
    /**
   * Submit if payload cached
   * @param {boolean} isAuthed - authenticate status
   * @param {LocalStorageSubmitPolicies} [savedSubmitPolicies] - saved submit payload in cached
   * */ const validateSubmitPolicies = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async (isAuthed, savedSubmitPolicies)=>{
        if (isAuthed && savedSubmitPolicies) {
            const { policies , isSubmitted  } = savedSubmitPolicies;
            if (!!policies && isSubmitted === false) {
                await internalSubmit(isAuthed, savedSubmitPolicies.policies, true);
            }
        }
    }, [
        internalSubmit
    ]);
    /**
   * Decide to using cache or fetch from api depend on authenticate status and saved values
   * @param {boolean} isAuthed - authenticate status
   * @param {LocalStoragePolicies} [savedGetPolicies] - saved GetPolicies response.
   * @param {LocalStorageAllowedStatus} [savedAllowedStatus] - saved user allow status.
   * */ const validatePolicies = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async (isAuthed, savedAllowedStatus)=>{
        try {
            if (!isAuthed) {
                const savedGetPoliciesKey = "".concat(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_PRIVACY_POLICIES */ .Oc, "_").concat(currentLanguage || "vi");
                const savedGetPolicies = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .parseJsonStringSafely */ .O)(localStorage.getItem(savedGetPoliciesKey));
                if (!savedGetPolicies || checkCacheExpired(savedGetPolicies === null || savedGetPolicies === void 0 ? void 0 : savedGetPolicies.createdAt, privacyPolicyCacheTTL)) {
                    await internalGetPolicies();
                    const newSavedGetPolicies = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .parseJsonStringSafely */ .O)(localStorage.getItem(savedGetPoliciesKey));
                    if (!!savedGetPolicies && !!newSavedGetPolicies && JSON.stringify(savedGetPolicies.policies) !== JSON.stringify(newSavedGetPolicies.policies)) {
                        localStorage.removeItem("".concat(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_UNLOGGED_USER_PRIVACY_POLICIES */ .Lb, "_").concat(currentLanguage || "vi"));
                    }
                } else {
                    const savedPolicies = savedGetPolicies.policies || [];
                    setPolicies(savedPolicies);
                    setShouldShowSelector(savedPolicies.length > 0);
                }
            } else if (!savedAllowedStatus || savedAllowedStatus && !savedAllowedStatus.isAllowed) {
                // fetch privacy policies specify to this user then skip cache step
                internalGetPolicies(true);
            }
        } catch (e) {
        // do nothing for now
        }
    }, [
        internalGetPolicies
    ]);
    const showSelector = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async (callback)=>{
        submitCallback.current = callback;
        setShow(true);
    }, []);
    /**
   * check for cache validation then remove it if expired and return it.
   * @return 3 saved value in form of array
   * */ const validateCaches = ()=>{
        return [
            [
                _constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */ .i7,
                submitPayloadTTL
            ],
            [
                _constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY */ .Hg,
                privacyPolicyCacheTTL
            ]
        ].map((param)=>{
            let [key, duration] = param;
            const value = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .parseJsonStringSafely */ .O)(localStorage.getItem(key));
            if (!value || checkCacheExpired(value.createdAt, duration)) {
                localStorage.removeItem(key);
                return undefined;
            }
            return value;
        });
    };
    /**
   * this effect only run once auth loaded.
   * 1. validate caches (return cached values if valid or remove otherwise).
   * 2. validate submit (submit to api if a submit payload saved which retrieved in previous step)
   * 3. if step 3 success (submitted or nothing to submit yet) then validate policies (decide using cache or fetch from api)
   * 4. app is not IBanking App
   * */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const isIBankingApp = partner ? (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* .isBankPartner */ .VC)(partner) : false;
        if (!authLoading && flags.epic_ecom_483 && !isIBankingApp) {
            const isAuthed = authService.isLoggedIn();
            const [savedSubmitPolicies, savedAllowedStatus] = validateCaches();
            validateSubmitPolicies(isAuthed, savedSubmitPolicies).then(()=>validatePolicies(isAuthed, savedAllowedStatus)).catch(()=>{}); // error handled
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user,
        authLoading,
        partner
    ]);
    const showWarningModal = ()=>{
        showModal === null || showModal === void 0 ? void 0 : showModal({
            title: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Th\xf4ng b\xe1o"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_15__/* .Body */ .uT, {
                children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Vui l\xf2ng x\xe1c nhận đồng \xfd với c\xe1c điều khoản v\xe0 điều kiện dịch vụ để tiếp tục")
            }),
            okText: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đ\xf3ng"),
            cancelButtonProps: {
                style: {
                    display: "none"
                }
            },
            showCloseIcon: false,
            closable: false
        });
    };
    const buildPrivacyPolicyList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_PrivacyPolicies__WEBPACK_IMPORTED_MODULE_16__/* .PrivacyPolicies */ .v, {
            policies: policies,
            setPolicies: setPolicies,
            trackingScreenName: "",
            isLoggedIn: (0,helpers__WEBPACK_IMPORTED_MODULE_13__/* .isServerless */ .ep)() && authService.isLoggedIn()
        });
    }, [
        authService,
        policies
    ]);
    const isByPassShowPoliciesForUnLoggerUser = (loginMethod, userPhone)=>{
        const LSKey = "".concat(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_UNLOGGED_USER_PRIVACY_POLICIES */ .Lb, "_").concat(currentLanguage || "vi");
        const privacyPolicies = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_10__/* .parseJsonStringSafely */ .O)(localStorage.getItem(LSKey));
        setUserSelectedLoginMethod({
            loginMethod,
            userPhone
        });
        if (privacyPolicies) {
            const { facebookUserSelectedPolicies , googleUserSelectedPolicies , phoneUserSelectedPolicies ,  } = privacyPolicies;
            const checkUserAlreadyByPassEnterPolicies = (savedPolicies)=>{
                // Return false if user uncheck every required policy
                return !savedPolicies.find((param)=>{
                    let { isApprovalRequired , isApproved  } = param;
                    return isApprovalRequired && !isApproved;
                });
            };
            switch(loginMethod){
                case _constants__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_METHOD.FACEBOOK */ .Ev.FACEBOOK:
                    if (!!facebookUserSelectedPolicies && checkUserAlreadyByPassEnterPolicies(facebookUserSelectedPolicies)) {
                        return true;
                    }
                    break;
                case _constants__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_METHOD.GOOGLE */ .Ev.GOOGLE:
                    if (!!googleUserSelectedPolicies && checkUserAlreadyByPassEnterPolicies(googleUserSelectedPolicies)) {
                        return true;
                    }
                    break;
                case _constants__WEBPACK_IMPORTED_MODULE_11__/* .LOGIN_METHOD.PHONE */ .Ev.PHONE:
                    if (userPhone && phoneUserSelectedPolicies) {
                        const userSelectedPolicy = phoneUserSelectedPolicies[userPhone];
                        if (!!userSelectedPolicy && checkUserAlreadyByPassEnterPolicies(userSelectedPolicy)) {
                            return true;
                        }
                    }
                    break;
            }
            return false;
        }
        return false;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(PrivacyPolicyContext.Provider, {
        value: {
            loading,
            policies,
            shouldShowSelector,
            showSelector,
            submitPoliciesApproval,
            buildPrivacyPolicyList,
            isByPassShowPoliciesForUnLoggerUser
        },
        children: [
            children,
            isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_17__/* .BottomSheet */ .R, {
                show: show,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Th\xf4ng b\xe1o"),
                closeBottomSheet: isLoginPage ? ()=>setShow(false) : undefined,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__/* .Shape */ .b, {
                    width: "100%",
                    padding: "s16",
                    style: {
                        marginBottom: "64px",
                        width: "100%"
                    },
                    children: [
                        buildPrivacyPolicyList(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_19__/* .BottomActionBar */ .G, {
                            style: {
                                display: "absolute",
                                gap: "8px"
                            },
                            children: [
                                !isLoginPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .z, {
                                    width: "100%",
                                    variant: "secondary",
                                    onClick: ()=>{
                                        setShow(false);
                                        setShouldShowSelector(false);
                                        if (policies.some((policy)=>policy.isApprovalRequired)) {
                                            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_21__/* .trackManually */ .gu)("logoutButton", "privacyMethod", "loginMethod", JSON.stringify({
                                                screenName: "userPrivacyPopup"
                                            }));
                                            (0,helpers__WEBPACK_IMPORTED_MODULE_22__/* .onSignOut */ .U)(authService, notificationService, notificationAppId);
                                        } else {
                                            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_21__/* .trackManually */ .gu)("quitButton", "privacyMethod", window.location.href, JSON.stringify({
                                                screenName: "userPrivacyPopup"
                                            }));
                                        }
                                    },
                                    children: policies.some((policy)=>policy.isApprovalRequired) ? (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng xuất") : (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Bỏ qua")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_20__/* .Button */ .z, {
                                    width: "100%",
                                    variant: "primary",
                                    onClick: ()=>{
                                        (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_21__/* .trackManually */ .gu)("confirmButton", "privacyMethod", window.location.href, JSON.stringify({
                                            screenName: "userPrivacyPopup"
                                        }));
                                        submitPoliciesApproval(submitCallback.current);
                                    },
                                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("X\xe1c nhận")
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_23__/* .Modal */ .u, {
                width: "600px",
                visible: show,
                showCloseIcon: false,
                closable: false,
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("X\xe1c nhận"),
                onOk: ()=>{
                    (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_21__/* .trackManually */ .gu)("confirmButton", "privacyMethod", window.location.href, JSON.stringify({
                        screenName: "userPrivacyPopup"
                    }));
                    submitPoliciesApproval();
                },
                cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Đăng xuất"),
                onCancel: ()=>{
                    setShow(false);
                    (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_21__/* .trackManually */ .gu)("logoutButton", "privacyMethod", "loginMethod", JSON.stringify({
                        screenName: "userPrivacyPopup"
                    }));
                    (0,helpers__WEBPACK_IMPORTED_MODULE_22__/* .onSignOut */ .U)(authService, notificationService, notificationAppId);
                },
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_14__.t)("Th\xf4ng b\xe1o"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_24__/* .ModalBody */ .f, {
                    style: {
                        padding: 0
                    },
                    children: buildPrivacyPolicyList()
                })
            })
        ]
    });
};
const usePrivacyPolicy = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(PrivacyPolicyContext);
    return context;
};
const validateApproval = (policies)=>{
    return !policies.some((policy)=>policy.isApprovalRequired && !policy.isApproved);
};
const saveSubmitPolicies = (policies, customCreatedAt)=>{
    localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_9__/* .LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */ .i7, JSON.stringify({
        policies: policies,
        isSubmitted: false,
        createdAt: customCreatedAt || new Date().toString()
    }));
};
const checkCacheExpired = (date, duration)=>{
    return !((new Date().getTime() - new Date(date).getTime()) / (24 * 3600 * 1000) <= duration);
};
const checkUserAllowed = (policies)=>!policies.some((policy)=>policy.isApprovalRequired);


/***/ }),

/***/ 679469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useRegionPicker; },
/* harmony export */   "k": function() { return /* binding */ RegionPickerProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(353632);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(788813);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(479228);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);







const RegionPickerContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    showPopup: false,
    setShowPopup: ()=>{},
    onOpenPopup: ()=>{},
    onClosePopup: ()=>{},
    selected: 0,
    setSelected: ()=>{},
    terminals: [],
    locationOptions: [],
    onSubmitNewLocation: ()=>{},
    useDropdownPicker: false,
    title: null,
    isShowLocationIcon: true
});
// TODO: replace useRegionPicker in ./hooks/useRegionPicker.tsx by this hook
const useRegionPicker = ()=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RegionPickerContext);
};
const RegionPickerProvider = (param)=>{
    let { children  } = param;
    var ref;
    const { isMobile , originalTerminal , clearCacheAfterSwitchLocation , isDmsFlow ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useGlobalData */ .U5)();
    const terminals = originalTerminal || [];
    const selectedTerminal = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, isMobile);
    const selectedLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, isMobile);
    const selectedTerminalId = (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getUserSelectedInfo */ .Sk)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, isMobile);
    const enableLocationFeature = terminals.every((item)=>!!item.locationCode);
    const confirmedOptionIndex = terminals.findIndex((item)=>{
        if (enableLocationFeature) {
            return item.code === selectedTerminal && item.locationCode === selectedLocation;
        }
        return item.code === selectedTerminal;
    });
    const { 0: showRegionPopup , 1: setShowRegionPopup  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: selected , 1: setSelected  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
    const isDisableUserSelectLocation = (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .isDisableUserSelectLocationAction */ .z9)({
        isDmsFlow
    });
    const selectTerminal = (terminal)=>{
        var ref;
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL */ .Tp.TERMINAL, terminal.code, isMobile);
        (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.TERMINAL_ID */ .Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.id) === null || ref === void 0 ? void 0 : ref.toString(), isMobile);
        enableLocationFeature && (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .setUserSelectedInfo */ .MA)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .userSelectedConstants.LOCATION */ .Tp.LOCATION, // remove after 284 --> ignore now
        // @ts-ignore
        terminal.locationCode, isMobile);
    };
    const onSubmitNewLocation = ()=>{
        selectTerminal(terminals[selected]);
        if (clearCacheAfterSwitchLocation) {
            (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .clearCacheAndReloadPage */ .w5)();
        } else {
            (0,_helpers__WEBPACK_IMPORTED_MODULE_5__/* .reloadPage */ .sl)();
        }
    };
    const activeLocation = confirmedOptionIndex || confirmedOptionIndex === 0 ? terminals[confirmedOptionIndex] : undefined;
    const textMsg = "Vui l\xf2ng chọn khu vực để ch\xfang t\xf4i sắp xếp giao h\xe0ng cho bạn nhanh nhất.";
    // temporarily rely on the location object present terminal
    const useDropdownPicker = !!((ref = terminals[0]) === null || ref === void 0 ? void 0 : ref.location);
    const onClosePopup = ()=>{
        if (activeLocation) {
            setShowRegionPopup(false);
            setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // terminalId is a new key added later
        // we want to deprecate terminalCode
        // so for site without terminalId, prompt region picker
        const isTerminalSelected = !!selectedTerminal && !!selectedTerminalId && // ensure id and code are included in the workload configuration
        !!terminals.find((param)=>{
            let { code , id  } = param;
            return code === selectedTerminal && id === parseInt(selectedTerminalId);
        });
        // if terminals include just one element --> auto set this element
        if (terminals.length === 1 && !isTerminalSelected) {
            selectTerminal(terminals[0]);
        } else {
            // add check !activeLocation in case the list of locations changes
            // on server-side, and user
            setShowRegionPopup(enableLocationFeature ? !isTerminalSelected || !selectedLocation || !activeLocation : !isTerminalSelected);
        }
    }, [
        selectedTerminal,
        selectedLocation,
        selectedTerminalId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegionPickerContext.Provider, {
        value: {
            showPopup: !isDisableUserSelectLocation && showRegionPopup,
            setShowPopup: setShowRegionPopup,
            onOpenPopup: ()=>setShowRegionPopup(true),
            onClosePopup,
            selected,
            setSelected,
            terminals,
            locationOptions: terminals.map((el, index)=>({
                    text: el.label,
                    value: index
                })),
            onSubmitNewLocation,
            activeLocation,
            useDropdownPicker,
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Body */ .uT, {
                level: 1,
                children: textMsg
            }),
            isShowLocationIcon: !isDisableUserSelectLocation
        },
        children: children
    });
};


/***/ }),

/***/ 725965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ RelatedProductProvider; },
  "I": function() { return /* binding */ useRelatedProduct; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(80912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/LeftOutlined.es.js
var LeftOutlined_es = __webpack_require__(149933);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCarousel/ProductCarousel.es.js
var ProductCarousel_es = __webpack_require__(414562);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/constants/index.es.js
var constants_index_es = __webpack_require__(875547);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./hooks/useDiscovery.tsx + 1 modules
var useDiscovery = __webpack_require__(88837);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./components/desktop/organisms/RelatedProductsModal.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  background: #f5f5f5;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  padding: 8px 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const RelatedProductsModal = (param)=>{
    let { productInfo , onBack , onCloseModal ,  } = param;
    const { passSkuToReturnSimilarProducts  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { sku , imageUrl , name , categoryId  } = productInfo;
    const searchRelatedProductsParams = !!sku && passSkuToReturnSimilarProducts ? {
        page: 1,
        pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
        filter: {
            skuToReturnSimilarProducts: sku
        }
    } : !!categoryId && !!sku ? {
        page: 1,
        pageSize: search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
        filter: {
            excludedSkus: [
                sku
            ],
            categoryIds: [
                categoryId
            ]
        }
    } : {};
    const { result: searchRelatedProductsResult , isLoading  } = (0,useDiscovery/* useSearch */.Rx)(searchRelatedProductsParams);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
        visible: !!sku,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            align: "center",
            gap: "s8",
            paddingLeft: "s16",
            paddingTop: "s20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftOutlined_es/* LeftOutlined */.D, {
                    size: 20,
                    color: "black",
                    onClick: onBack
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Title */.Dx, {
                    level: 3,
                    children: (0,i18n.t)("Sản phẩm tương tự")
                })
            ]
        }),
        onClose: onCloseModal,
        footer: null,
        width: "70%",
        zIndex: 1051,
        contentStyle: {
            padding: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
            padding: [
                "s0",
                "s0"
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledShape, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            backgroundColor: "white",
                            padding: "s8",
                            borderRadius: "m",
                            align: "center",
                            gap: "s8",
                            width: "360px",
                            children: [
                                !!imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    width: "60px",
                                    height: "60px",
                                    contain: true,
                                    src: imageUrl
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        flex: 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                        level: 1,
                                        line: 2,
                                        children: name
                                    })
                                })
                            ]
                        }),
                        typeof searchRelatedProductsResult.pagination.totalItems === "number" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                            level: 1,
                            marginTop: "s16",
                            marginBottom: "s16",
                            children: [
                                (0,i18n.t)("T\xecm thấy"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        children: [
                                            searchRelatedProductsResult.pagination.totalItems < search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl ? searchRelatedProductsResult.pagination.totalItems : search/* LIMIT_ITEM_PER_PAGE_PRODUCT_LIST */.Fl,
                                            " "
                                        ]
                                    })
                                }),
                                (0,i18n.t)("Sản phẩm tương tự")
                            ]
                        }) : null,
                        !!searchRelatedProductsResult.products.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel_es/* ProductCarousel */.G, {
                            products: searchRelatedProductsResult.products,
                            productsPerRow: 5,
                            regionName: constants_index_es/* REGION_NAME.SIMILAR_PRODUCTS_POPUP */.Gt.SIMILAR_PRODUCTS_POPUP,
                            virtual: (0,helpers/* isServerless */.ep)()
                        }) : null
                    ]
                })
            })
        })
    });
};
const StyledShape = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)(_templateObject());

// EXTERNAL MODULE: ./components/mobile/organisms/RelatedProductsBottomSheet.tsx
var RelatedProductsBottomSheet = __webpack_require__(12800);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./contexts/RelatedProductContext.tsx






const RelatedProductContext = /*#__PURE__*/ react.createContext({});
const RelatedProductProvider = (param)=>{
    let { children  } = param;
    var ref, ref1;
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: selectedProduct , 1: setSelectedProduct  } = (0,react.useState)();
    const router = (0,next_router.useRouter)();
    const handleCloseRelatedModal = ()=>{
        const parentOnCloseModal = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.parentOnCloseModal;
        setSelectedProduct(undefined);
        parentOnCloseModal === null || parentOnCloseModal === void 0 ? void 0 : parentOnCloseModal();
    };
    (0,react.useEffect)(()=>{
        // when user direct to new page --> close related products bottom sheet
        setSelectedProduct(undefined);
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RelatedProductContext.Provider, {
        value: {
            selectedProduct,
            setSelectedProduct
        },
        children: [
            children,
            !!selectedProduct && (isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProductsBottomSheet/* RelatedProductsBottomSheet */.a, {
                sku: selectedProduct.sku,
                imageUrl: selectedProduct.imageUrl,
                name: selectedProduct.name,
                categoryId: !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref = selectedProduct.categories) === null || ref === void 0 ? void 0 : ref.length) ? selectedProduct.categories[(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.categories.length) - 1].id : undefined,
                onBack: ()=>setSelectedProduct(undefined),
                closeBottomSheet: handleCloseRelatedModal
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProductsModal, {
                productInfo: {
                    sku: selectedProduct.sku,
                    imageUrl: selectedProduct.imageUrl,
                    name: selectedProduct.name,
                    categoryId: !!(selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref1 = selectedProduct.categories) === null || ref1 === void 0 ? void 0 : ref1.length) ? selectedProduct.categories[(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.categories.length) - 1].id : undefined
                },
                onBack: ()=>setSelectedProduct(undefined),
                onCloseModal: handleCloseRelatedModal
            }))
        ]
    });
};
function useRelatedProduct() {
    const context = (0,react.useContext)(RelatedProductContext);
    if (!context) {
        throw new Error("useRelatedProduct must be inside a useRelatedProduct with a state value");
    }
    return context;
}


/***/ }),

/***/ 266521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useRouterEffect; },
/* harmony export */   "p": function() { return /* binding */ RouterProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225290);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




const RouterContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
const useRouterEffect = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(RouterContext);
    if (context === undefined) {
        throw new Error("useRouterEffect must be used within a RouterProvider");
    }
    return context;
};
const RouterProvider = (param)=>{
    let { router , children ,  } = param;
    const { 0: scrollPos , 1: setScrollPos  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const addScrollPos = (url)=>{
        const newScrollPos = {
            x: window.scrollX,
            y: window.scrollY
        };
        setScrollPos((prev)=>{
            return _objectSpreadProps(_objectSpread({}, prev), {
                [url]: newScrollPos
            });
        });
    };
    const restoreScrollPos = (url)=>{
        if (scrollPos[url]) {
            window.scrollTo(scrollPos[url].x, scrollPos[url].y);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        next_router__WEBPACK_IMPORTED_MODULE_2___default().events.on("routeChangeStart", ()=>{
            nprogress__WEBPACK_IMPORTED_MODULE_3___default().start();
        });
        next_router__WEBPACK_IMPORTED_MODULE_2___default().events.on("routeChangeComplete", ()=>nprogress__WEBPACK_IMPORTED_MODULE_3___default().done());
        next_router__WEBPACK_IMPORTED_MODULE_2___default().events.on("routeChangeError", ()=>nprogress__WEBPACK_IMPORTED_MODULE_3___default().done());
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if ("scrollRestoration" in window.history) {
            let shouldScrollRestore = false;
            window.history.scrollRestoration = "manual";
            restoreScrollPos(router.asPath);
            const onRouteChangeStart = ()=>{
                addScrollPos(router.asPath);
            };
            const onRouteChangeComplete = (url)=>{
                if (shouldScrollRestore) {
                    shouldScrollRestore = false;
                    restoreScrollPos(url);
                }
            };
            next_router__WEBPACK_IMPORTED_MODULE_2___default().events.on("routeChangeStart", onRouteChangeStart);
            next_router__WEBPACK_IMPORTED_MODULE_2___default().events.on("routeChangeComplete", onRouteChangeComplete);
            next_router__WEBPACK_IMPORTED_MODULE_2___default().beforePopState(()=>{
                shouldScrollRestore = true;
                return true;
            });
            return ()=>{
                next_router__WEBPACK_IMPORTED_MODULE_2___default().events.off("routeChangeStart", onRouteChangeStart);
                next_router__WEBPACK_IMPORTED_MODULE_2___default().events.off("routeChangeComplete", onRouteChangeComplete);
                next_router__WEBPACK_IMPORTED_MODULE_2___default().beforePopState(()=>true);
            };
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RouterContext.Provider, {
        value: {
            restoreScrollPos
        },
        children: children
    });
};


/***/ }),

/***/ 933756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EV": function() { return /* binding */ useScreen; },
/* harmony export */   "nX": function() { return /* binding */ ScreenProvider; },
/* harmony export */   "uE": function() { return /* binding */ PRODUCT_DETAIL_PAGE; }
/* harmony export */ });
/* unused harmony exports BRAND_PAGE, MASTER_CATEGORY_PAGE, SELLER_PAGE, TRACKING_SCREEN_MAPPING */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);




const HOME_PAGE = "";
const SEARCH_PAGE = "/search";
const CATEGORY_PAGE = "/categories/[categoryId]";
const PRODUCT_DETAIL_PAGE = "/products/[sku]";
const LANDING_PAGE = "/landing/[id]";
const BRAND_PAGE = "/brands/[brandId]";
const MASTER_CATEGORY_PAGE = "/block-categories/[categoryId]";
const SELLER_CATEGORY_PAGE = "/seller-categories/[categoryId]";
const SELLER_PAGE = "/sellers/[sellerId]";
const COMBO_LIST = "/products/[sku]/combos";
const COMBO_DETAIL = "/products/[sku]/combos/[id]";
const PROVIDER_PAGE = "/cua-hang/[providerId]";
const LANDING_BUILDER_PAGE = "/p/[slug]";
const TRACKING_SCREEN_MAPPING = {
    [HOME_PAGE]: "homePage",
    [SEARCH_PAGE]: "searchProductResult",
    [CATEGORY_PAGE]: "category",
    [BRAND_PAGE]: "brandPage",
    [PRODUCT_DETAIL_PAGE]: "productDetail",
    [LANDING_PAGE]: "landingPage",
    [MASTER_CATEGORY_PAGE]: "masterCategoryPage",
    [SELLER_CATEGORY_PAGE]: "sellerCategoryPage",
    [SELLER_PAGE]: "sellerPage",
    [COMBO_LIST]: "comboList",
    [COMBO_DETAIL]: "comboDetail",
    [PROVIDER_PAGE]: "providerPage",
    [LANDING_BUILDER_PAGE]: "landingPage"
};
const getTrackingScreenName = (tenant, isMobile, pathname)=>{
    const platform = isMobile ? "mobile" : "desktop";
    const tenantPrefix = "/".concat(tenant, "/").concat(platform);
    const tenantPrefixDefault = "/default/".concat(platform);
    let actualRoute;
    if (pathname.includes(tenantPrefix)) actualRoute = pathname.replace(tenantPrefix, "");
    else actualRoute = pathname.replace(tenantPrefixDefault, "");
    return TRACKING_SCREEN_MAPPING[actualRoute];
};
const ScreenStateContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createContext({});
const ScreenProvider = (param)=>{
    let { children  } = param;
    const { 0: trackingScreenName , 1: setTrackingScreenName  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const { tenant , isMobile  } = (0,_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalData */ .U5)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setTrackingScreenName(getTrackingScreenName(tenant, isMobile, router.pathname));
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScreenStateContext.Provider, {
        value: {
            trackingScreenName,
            setTrackingScreenName
        },
        children: children
    });
};
function useScreen() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(ScreenStateContext);
    if (!context) {
        throw new Error("useScreen must be inside a ScreenStateContext with a state value");
    }
    return context;
}


/***/ }),

/***/ 643015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Su": function() { return /* binding */ useServices; },
/* harmony export */   "UT": function() { return /* binding */ ServiceProvider; },
/* harmony export */   "bl": function() { return /* binding */ initializeServices; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var helpers_service_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(291278);



const ServiceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
let serviceContainer = null;
// initialize services here
const initializeServices = (tenantConfig)=>{
    if (!serviceContainer) {
        serviceContainer = new helpers_service_provider__WEBPACK_IMPORTED_MODULE_2__/* .ServiceContainer */ .h(tenantConfig);
    }
    return serviceContainer;
};
const ServiceProvider = (param)=>{
    let { children , services  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ServiceContext.Provider, {
        value: services,
        children: children
    });
};
const useServices = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ServiceContext);
    if (!context) {
        throw new Error("useServices must be inside a ServiceProvider with a state value");
    }
    return context;
};


/***/ }),

/***/ 779454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rq": function() { return /* binding */ ThreeLevelLocationProvider; },
  "u0": function() { return /* binding */ useThreeLevelLocationContext; }
});

// UNUSED EXPORTS: StyledModalTitle, initThreeLevelLocation, threeLevelLocationReducer

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/context.es.js
var context_es = __webpack_require__(106454);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(80912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/BackOutlined.es.js
var BackOutlined_es = __webpack_require__(431529);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SearchOutlined.es.js
var SearchOutlined_es = __webpack_require__(877936);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CheckOutlined.es.js
var CheckOutlined_es = __webpack_require__(4247);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./constants/threeLevelLocation.ts
const UPDATE_VALUE_PROVINCE = "UPDATE_VALUE_PROVINCE";
const UPDATE_VALUE_DISTRICT = "UPDATE_VALUE_DISTRICT";
const UPDATE_VALUE_WARD = "UPDATE_VALUE_WARD";
const PROVINCE = "PROVINCE";
const DISTRICT = "DISTRICT";
const WARD = "WARD";

// EXTERNAL MODULE: ../../packages/location/dist/index.es.js + 2 modules
var dist_index_es = __webpack_require__(693497);
;// CONCATENATED MODULE: ./hooks/useThreeLevelLocation.ts






const filterLocationsV2 = (searchAreas, limits)=>{
    const areas = searchAreas.map((param)=>{
        let { id , code , title  } = param;
        return {
            id,
            code,
            title
        };
    });
    return limits && limits.length > 0 ? areas.filter((area)=>limits.some((allowDis)=>{
            const re = new RegExp("^".concat(allowDis, "$"));
            return re.test(area.code);
        })) : areas;
};
const useLevelThreeLevelLocation = (param)=>{
    let { threeLevelLocation , stepLocation , updateThreeLevelLocation , setStepLocation , onClosePopup , onSubmitNewLocation  } = param;
    var ref;
    const { locationService , locationServiceV3  } = (0,ServiceContext/* useServices */.Su)();
    const { epicOmni1589  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { 0: keyword , 1: setKeyword  } = (0,react.useState)("");
    const { showThreeLevelLocationPicker  } = useThreeLevelLocationContext();
    const { data: provinces , isValidating: isLoadingProvince  } = (0,index_esm/* default */.ZP)(!epicOmni1589 ? [
        "/provinces",
        stepLocation,
        showThreeLevelLocationPicker
    ] : null, async ()=>{
        const provinceResponse = await locationService.getProvinces();
        return provinceResponse.map((item)=>({
                value: item.code,
                label: item.name,
                id: item.id
            }));
    }, {
        fallbackData: [],
        revalidateOnFocus: false,
        isPaused: ()=>stepLocation !== PROVINCE
    });
    const { data: districts , isValidating: isLoadingDistricts  } = (0,index_esm/* default */.ZP)(!epicOmni1589 ? [
        "/districts",
        threeLevelLocation.province.code,
        showThreeLevelLocationPicker,
        stepLocation, 
    ] : null, async ()=>{
        const districtResponse = await locationService.getDistrictsByProvinceCode(threeLevelLocation.province.code);
        return districtResponse.map((item)=>({
                value: item.code,
                label: item.name,
                id: item.id
            }));
    }, {
        fallbackData: [],
        revalidateOnFocus: false,
        isPaused: ()=>!threeLevelLocation.province.code || !showThreeLevelLocationPicker || stepLocation !== DISTRICT
    });
    const { data: wards , isValidating: isLoadingWards  } = (0,index_esm/* default */.ZP)(!epicOmni1589 ? [
        "/wards",
        (ref = threeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.code,
        showThreeLevelLocationPicker,
        stepLocation, 
    ] : null, async ()=>{
        const wardResponse = !!threeLevelLocation.district ? await locationService.getWardsByDistrictCode(threeLevelLocation.district.code) : [];
        return wardResponse.map((item)=>({
                value: item.code,
                label: item.name,
                id: item.id
            }));
    }, {
        fallbackData: [],
        isPaused: ()=>{
            var ref;
            return !((ref = threeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.code) || !showThreeLevelLocationPicker || stepLocation !== WARD;
        },
        revalidateOnFocus: false
    });
    const { data: provincesV2 , isValidating: isLoadingProvincesV2  } = (0,index_esm/* default */.ZP)(epicOmni1589 ? [
        "provinces",
        stepLocation,
        showThreeLevelLocationPicker
    ] : null, async ()=>{
        const response = await locationServiceV3.getAreas({
            areaLayer: dist_index_es/* AreaLayer.province */.TV.province
        });
        return filterLocationsV2(response || [], []).map((item)=>({
                value: item.code,
                label: item.title,
                id: item.id
            }));
    }, {
        revalidateOnFocus: false,
        fallbackData: [],
        shouldRetryOnError: false,
        isPaused: ()=>stepLocation !== PROVINCE
    });
    const { data: wardsV2 , isValidating: isLoadingWardsV2  } = (0,index_esm/* default */.ZP)(epicOmni1589 ? [
        "wards",
        threeLevelLocation.province.id,
        stepLocation,
        showThreeLevelLocationPicker, 
    ] : null, async ()=>{
        const response = await locationServiceV3.getAreas({
            areaLayer: dist_index_es/* AreaLayer.ward */.TV.ward,
            parentAreaId: threeLevelLocation.province.id
        });
        return filterLocationsV2(response || [], []).map((item)=>({
                value: item.code,
                label: item.title,
                id: item.id
            }));
    }, {
        revalidateOnFocus: false,
        fallbackData: [],
        shouldRetryOnError: false,
        isPaused: ()=>!threeLevelLocation.province.code || !showThreeLevelLocationPicker || stepLocation !== WARD
    });
    const originalData = (0,react.useCallback)(()=>{
        if (stepLocation === PROVINCE) return epicOmni1589 ? provincesV2 : provinces;
        if (stepLocation === DISTRICT && !epicOmni1589) return districts;
        return epicOmni1589 ? wardsV2 : wards;
    }, [
        stepLocation,
        provinces,
        districts,
        wards,
        provincesV2,
        wardsV2,
        epicOmni1589, 
    ]);
    const filterLocations = (0,react.useMemo)(()=>{
        const data = originalData();
        if (!keyword || keyword === "") return data;
        return (data === null || data === void 0 ? void 0 : data.filter((option)=>{
            return option.label.toLowerCase().includes(keyword.toLowerCase());
        })) || [];
    }, [
        originalData,
        keyword
    ]);
    const onSelectLocation = (location)=>{
        if (stepLocation === PROVINCE) {
            updateThreeLevelLocation === null || updateThreeLevelLocation === void 0 ? void 0 : updateThreeLevelLocation({
                type: UPDATE_VALUE_PROVINCE,
                value: location
            });
            // reset district when change province
            updateThreeLevelLocation === null || updateThreeLevelLocation === void 0 ? void 0 : updateThreeLevelLocation({
                type: UPDATE_VALUE_DISTRICT,
                value: {
                    id: 0,
                    code: "",
                    label: ""
                }
            });
            setStepLocation === null || setStepLocation === void 0 ? void 0 : setStepLocation(epicOmni1589 ? WARD : DISTRICT);
            return;
        }
        if (!epicOmni1589 && stepLocation === DISTRICT) {
            updateThreeLevelLocation === null || updateThreeLevelLocation === void 0 ? void 0 : updateThreeLevelLocation({
                type: UPDATE_VALUE_DISTRICT,
                value: location
            });
            setStepLocation === null || setStepLocation === void 0 ? void 0 : setStepLocation(WARD);
            return;
        }
        updateThreeLevelLocation === null || updateThreeLevelLocation === void 0 ? void 0 : updateThreeLevelLocation({
            type: UPDATE_VALUE_WARD,
            value: location
        });
        onSubmitNewLocation === null || onSubmitNewLocation === void 0 ? void 0 : onSubmitNewLocation({
            province: threeLevelLocation.province,
            district: threeLevelLocation.district,
            ward: location
        });
    };
    const backToPreviousLevelLocation = ()=>{
        if (stepLocation === PROVINCE) {
            onClosePopup();
            return;
        }
        if (stepLocation === DISTRICT) {
            setStepLocation === null || setStepLocation === void 0 ? void 0 : setStepLocation(PROVINCE);
            return;
        }
        setStepLocation === null || setStepLocation === void 0 ? void 0 : setStepLocation(epicOmni1589 ? PROVINCE : DISTRICT);
    };
    const headerText = (0,react.useMemo)(()=>{
        var ref;
        if (stepLocation === PROVINCE) {
            return {
                title: (0,i18n.t)("Chọn khu vực giao h\xe0ng"),
                sutTitle: (0,i18n.t)("Để biết ch\xednh x\xe1c tồn kho v\xe0 thời gian giao h\xe0ng"),
                placeHolderSearch: (0,i18n.t)("T\xecm nhanh Tỉnh/ Th\xe0nh phố")
            };
        }
        if (stepLocation === DISTRICT && !epicOmni1589) {
            return {
                title: (0,i18n.t)("Chọn Quận, huyện"),
                sutTitle: "".concat((0,i18n.t)("tại"), " ").concat(threeLevelLocation.province.label),
                placeHolderSearch: (0,i18n.t)("T\xecm nhanh Quận/huyện")
            };
        }
        return {
            title: (0,i18n.t)("Chọn Phường, X\xe3"),
            sutTitle: "".concat((0,i18n.t)("tại"), "  ").concat(!epicOmni1589 ? ((ref = threeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.label) + ", " : "").concat(threeLevelLocation.province.label),
            placeHolderSearch: (0,i18n.t)("T\xecm nhanh Phường/x\xe3")
        };
    }, [
        threeLevelLocation,
        stepLocation,
        epicOmni1589
    ]);
    return {
        loadingLocation: isLoadingProvince || isLoadingDistricts || isLoadingWards || isLoadingProvincesV2 || isLoadingWardsV2,
        filterLocations,
        onSelectLocation,
        backToPreviousLevelLocation,
        setKeyword,
        keyword,
        headerText
    };
};

;// CONCATENATED MODULE: ./components/ThreeLevelLocation/PopupThreeLevelLocationPicker/mobile/PopupThreeLevelLocationPicker.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100vw;\n  min-height: 60vh;\n  text-align: center;\n  color: #000000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  font-weight: 500;\n  color: #000000;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  color: #82869e;\n  font-size: 13px;\n  font-weight: 400;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  padding: 0 1rem;\n  border-radius: 4px;\n  margin: 15px;\n  .input-container {\n    border: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: min(100vh, 28rem);\n  width: 100%;\n  padding-bottom: 0.75rem;\n  ::-webkit-scrollbar {\n    width: 0.75rem;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n    background-clip: content-box;\n    border-radius: 100px;\n    border: 0.25rem solid transparent;\n    width: 0.25rem;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-direction: row;\n  height: 3rem;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








const PopupThreeLevelLocationPickerMobile = (param)=>{
    let { showPopup , onClosePopup , threeLevelLocation , updateThreeLevelLocation , stepLocation , setStepLocation , onSubmitNewLocation , correctThreeLevelLocation ,  } = param;
    const listRef = (0,react.useRef)();
    const displayBackButton = stepLocation === DISTRICT || stepLocation === WARD;
    const { filterLocations , loadingLocation , onSelectLocation , backToPreviousLevelLocation , headerText , keyword , setKeyword ,  } = useLevelThreeLevelLocation({
        threeLevelLocation,
        stepLocation,
        updateThreeLevelLocation,
        setStepLocation,
        onClosePopup,
        onSubmitNewLocation
    });
    const theme = (0,Theme_es/* useTheme */.F)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet_es/* BottomSheet */.R, {
        show: showPopup,
        position: "bottom",
        zIndex: 2000,
        backdropClicked: onClosePopup,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    width: "100%",
                    direction: "row",
                    align: "center",
                    justify: "space-around",
                    marginTop: "s8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackOutlined_es/* BackOutlined */.Y, {
                            size: 28,
                            onClick: displayBackButton ? backToPreviousLevelLocation : undefined,
                            color: displayBackButton ? theme.colors.placeholder : theme.colors.white
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "column",
                            align: "center",
                            marginLeft: "s8",
                            marginRight: "s8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: headerText.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                    children: headerText.sutTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined_es/* CloseOutlined */.X, {
                            color: !!correctThreeLevelLocation ? theme.colors.placeholder : theme.colors.white,
                            size: 28,
                            onClick: onClosePopup
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined_es/* SearchOutlined */.l, {}),
                        placeholder: headerText.placeHolderSearch,
                        value: keyword,
                        onChange: setKeyword
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    ref: (ref)=>{
                        if (!ref) {
                            return;
                        }
                        // remove right padding when scrollbar is visible
                        if (ref.scrollHeight > ref.clientHeight) {
                            ref.style.paddingRight = "0";
                        }
                        listRef.current = ref;
                    },
                    children: filterLocations && Array.isArray(filterLocations) && filterLocations.length ? filterLocations.map((location)=>{
                        var ref;
                        const isSelected = stepLocation === PROVINCE && location.value === threeLevelLocation.province.code || stepLocation === DISTRICT && location.value === ((ref = threeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.code) || stepLocation === WARD && location.value === threeLevelLocation.ward.code;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem, {
                            onClick: ()=>{
                                onSelectLocation({
                                    code: location.value,
                                    label: location.label,
                                    id: location.id
                                });
                                setKeyword("");
                            },
                            active: isSelected,
                            children: [
                                location.label,
                                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckOutlined_es/* CheckOutlined */.b, {
                                    color: "primary500",
                                    size: "1.5rem"
                                })
                            ]
                        }, location.value);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                        justify: "center",
                        align: "middle",
                        children: loadingLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                            isLoading: loadingLocation
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            color: "placeholder",
                            level: 1,
                            weight: "regular",
                            children: (0,i18n.t)("Kh\xf4ng t\xecm thấy dữ liệu n\xe0o !!")
                        })
                    })
                })
            ]
        })
    });
};
const DefaultContent = emotion_styled_browser_esm["default"].div(_templateObject());
const Title = emotion_styled_browser_esm["default"].span(_templateObject1());
const SubTitle = emotion_styled_browser_esm["default"].span(_templateObject2());
const StyledInput = (0,emotion_styled_browser_esm["default"])(Input_es/* Input */.I)(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.background;
});
const List = emotion_styled_browser_esm["default"].div(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.disable;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.placeholder;
});
const ListItem = emotion_styled_browser_esm["default"].div(_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.divider;
}, (param)=>{
    let { theme , active  } = param;
    return active ? theme.colors.background : theme.colors.white;
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/organisms/Modal/Modal.es.js
var Modal_es = __webpack_require__(145000);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/organisms/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(188155);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/organisms/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(776609);
;// CONCATENATED MODULE: ./components/ThreeLevelLocation/PopupThreeLevelLocationPicker/desktop/PopupThreeLevelLocationPickerDesktop.tsx
function PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PopupThreeLevelLocationPickerDesktop_templateObject() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    PopupThreeLevelLocationPickerDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PopupThreeLevelLocationPickerDesktop_templateObject1() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    PopupThreeLevelLocationPickerDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PopupThreeLevelLocationPickerDesktop_templateObject2() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    PopupThreeLevelLocationPickerDesktop_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PopupThreeLevelLocationPickerDesktop_templateObject3() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  min-height: 60vh;\n  text-align: center;\n  color: #000000;\n"
    ]);
    PopupThreeLevelLocationPickerDesktop_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PopupThreeLevelLocationPickerDesktop_templateObject4() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  padding: 0 1rem;\n  margin-bottom: 15px;\n  border-radius: 4px;\n  .input-container {\n    border: none;\n  }\n"
    ]);
    PopupThreeLevelLocationPickerDesktop_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PopupThreeLevelLocationPickerDesktop_templateObject5() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: min(100vh, 28rem);\n  padding-bottom: 0.75rem;\n  ::-webkit-scrollbar {\n    width: 0.75rem;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n    background-clip: content-box;\n    border-radius: 100px;\n    border: 0.25rem solid transparent;\n    width: 0.25rem;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    PopupThreeLevelLocationPickerDesktop_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = PopupThreeLevelLocationPickerDesktop_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n  display: flex;\n  flex-direction: row;\n  height: 3rem;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 15px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









const PopupThreeLevelLocationPickerDesktop = (param)=>{
    let { onClosePopup , showPopup , threeLevelLocation , updateThreeLevelLocation , stepLocation , setStepLocation , onSubmitNewLocation , correctThreeLevelLocation ,  } = param;
    const listRef = (0,react.useRef)();
    const displayBackButton = stepLocation === DISTRICT || stepLocation === WARD;
    const theme = (0,Theme_es/* useTheme */.F)();
    const { filterLocations , loadingLocation , onSelectLocation , backToPreviousLevelLocation , headerText , keyword , setKeyword ,  } = useLevelThreeLevelLocation({
        threeLevelLocation,
        stepLocation,
        updateThreeLevelLocation,
        setStepLocation,
        onClosePopup,
        onSubmitNewLocation
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
        show: showPopup,
        onHide: onClosePopup,
        children: [
            displayBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftIcon, {
                onClick: backToPreviousLevelLocation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackOutlined_es/* BackOutlined */.Y, {
                    size: 32,
                    color: theme.colors.black
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                children: headerText.title
            }),
            !!correctThreeLevelLocation && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {
                onClick: onClosePopup,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined_es/* CloseOutlined */.X, {
                    size: 32,
                    color: theme.colors.black
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                marginBottom: 12,
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                level: 1,
                                children: headerText.sutTitle
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupThreeLevelLocationPickerDesktop_DefaultContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupThreeLevelLocationPickerDesktop_StyledInput, {
                                        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined_es/* SearchOutlined */.l, {}),
                                        placeholder: headerText.placeHolderSearch,
                                        value: keyword,
                                        onChange: setKeyword
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupThreeLevelLocationPickerDesktop_List, {
                                    ref: (ref)=>{
                                        if (!ref) {
                                            return;
                                        }
                                        // remove right padding when scrollbar is visible
                                        if (ref.scrollHeight > ref.clientHeight) {
                                            ref.style.paddingRight = "0";
                                        }
                                        listRef.current = ref;
                                    },
                                    children: filterLocations && Array.isArray(filterLocations) && filterLocations.length ? filterLocations.map((location)=>{
                                        var ref;
                                        const isSelected = stepLocation === PROVINCE && location.value === threeLevelLocation.province.code || stepLocation === DISTRICT && location.value === ((ref = threeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.code) || stepLocation === WARD && location.value === threeLevelLocation.ward.code;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopupThreeLevelLocationPickerDesktop_ListItem, {
                                            onClick: ()=>{
                                                onSelectLocation({
                                                    code: location.value,
                                                    label: location.label,
                                                    id: location.id
                                                });
                                                setKeyword("");
                                            },
                                            active: isSelected,
                                            children: [
                                                location.label,
                                                isSelected && /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckOutlined_es/* CheckOutlined */.b, {
                                                    color: "primary500",
                                                    size: "1.5rem"
                                                })
                                            ]
                                        }, location.value);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                        justify: "center",
                                        align: "middle",
                                        children: loadingLocation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                                            isLoading: loadingLocation
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            color: "placeholder",
                                            level: 1,
                                            weight: "regular",
                                            children: (0,i18n.t)("Kh\xf4ng t\xecm thấy dữ liệu n\xe0o !!")
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const CloseIcon = emotion_styled_browser_esm["default"].div(PopupThreeLevelLocationPickerDesktop_templateObject());
const LeftIcon = emotion_styled_browser_esm["default"].div(PopupThreeLevelLocationPickerDesktop_templateObject1());
const Wrapper = emotion_styled_browser_esm["default"].div(PopupThreeLevelLocationPickerDesktop_templateObject2());
const PopupThreeLevelLocationPickerDesktop_DefaultContent = emotion_styled_browser_esm["default"].div(PopupThreeLevelLocationPickerDesktop_templateObject3());
const PopupThreeLevelLocationPickerDesktop_StyledInput = (0,emotion_styled_browser_esm["default"])(Input_es/* Input */.I)(PopupThreeLevelLocationPickerDesktop_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.colors.background;
});
const PopupThreeLevelLocationPickerDesktop_List = emotion_styled_browser_esm["default"].div(PopupThreeLevelLocationPickerDesktop_templateObject5(), (param)=>{
    let { theme  } = param;
    return theme.colors.disable;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.placeholder;
});
const PopupThreeLevelLocationPickerDesktop_ListItem = emotion_styled_browser_esm["default"].div(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.divider;
}, (param)=>{
    let { theme , active  } = param;
    return active ? theme.colors.background : theme.colors.white;
});

;// CONCATENATED MODULE: ./components/ThreeLevelLocation/PopupThreeLevelLocationPicker/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const PopupThreeLevelLocationPicker = (_param)=>{
    var props = _extends({}, _param);
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupThreeLevelLocationPickerMobile, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupThreeLevelLocationPickerDesktop, _objectSpread({}, props));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var Modal_ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var Modal_ModalBody_es = __webpack_require__(309110);
;// CONCATENATED MODULE: ./components/ThreeLevelLocation/ModalErrorTerminal/index.tsx





const ModalErrorTerminal = (param)=>{
    let { onOK , showErrorTerminal , setShowErrorTerminal , onCancel  } = param;
    const { supportedPhone  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_Modal_es/* Modal */.u, {
        visible: showErrorTerminal,
        size: "s",
        okText: (0,i18n.t)("Thử lại"),
        onOk: ()=>{
            onOK === null || onOK === void 0 ? void 0 : onOK();
            setShowErrorTerminal(false);
        },
        showCloseIcon: false,
        alignFooter: "center",
        cancelText: (0,i18n.t)("Đ\xf3ng"),
        onCancel: onCancel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalHeader_es/* ModalHeader */.x, {
                padding: "s0",
                children: (0,i18n.t)("Th\xf4ng b\xe1o")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalBody_es/* ModalBody */.f, {
                paddingLeft: "s0",
                paddingRight: "s0",
                children: (0,i18n.t)("Kh\xf4ng lấy được th\xf4ng tin điểm b\xe1n để hiển thị. Vui l\xf2ng thử lại hoặc li\xean hệ {{supportedPhone}} để được hỗ trợ", {
                    supportedPhone
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ThreeLevelLocation/ModalUnAvailableTerminal/index.tsx





const ModalUnAvailableTerminal = (param)=>{
    let { onOK , oncancel , showErrorUnavailableTerminal , setShowErrorUnavailableTerminal , okText , cancelText  } = param;
    var ref, ref1;
    const { unavailableThreeLevelLocation ={
        ward: {
            label: ""
        },
        district: {
            label: ""
        },
        province: {
            label: ""
        }
    } ,  } = useThreeLevelLocationContext();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_Modal_es/* Modal */.u, {
        visible: showErrorUnavailableTerminal,
        size: "s",
        okText: okText || (0,i18n.t)("Đ\xf3ng"),
        onOk: ()=>{
            onOK === null || onOK === void 0 ? void 0 : onOK();
            setShowErrorUnavailableTerminal(false);
        },
        onCancel: ()=>{
            oncancel === null || oncancel === void 0 ? void 0 : oncancel();
            setShowErrorUnavailableTerminal(false);
        },
        okButtonProps: {
            style: {
                width: !!cancelText ? "50%" : "100%"
            }
        },
        cancelButtonProps: {
            style: {
                width: !!cancelText ? "50%" : "0%"
            }
        },
        showCloseIcon: false,
        alignFooter: "center",
        cancelText: cancelText || "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalHeader_es/* ModalHeader */.x, {
                padding: "s0",
                children: (0,i18n.t)("Th\xf4ng b\xe1o")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalBody_es/* ModalBody */.f, {
                paddingLeft: "s0",
                paddingRight: "s0",
                children: (0,i18n.t)("Hiện tại, qu\xfd kh\xe1ch đang chọn nhận h\xe0ng tại: {{ward}}".concat(((ref = unavailableThreeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.label) ? ", {{district}}" : "", ", {{province}}. Rất tiếc, ch\xfang t\xf4i chưa phục vụ giao h\xe0ng tại khu vực n\xe0y. Qu\xfd kh\xe1ch vui l\xf2ng chọn địa chỉ nhận h\xe0ng kh\xe1c. Cảm ơn qu\xfd kh\xe1ch!"), {
                    ward: unavailableThreeLevelLocation.ward.label,
                    district: (ref1 = unavailableThreeLevelLocation.district) === null || ref1 === void 0 ? void 0 : ref1.label,
                    province: unavailableThreeLevelLocation.province.label
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.8.0-MOBCOMMON8504.1-aac718131a-360bd50b3e.zip/node_modules/@terra-js/terra-kit/dist/index.js
var dist = __webpack_require__(68706);
;// CONCATENATED MODULE: ./contexts/ThreeLevelLocationProvider/reducer.ts
function reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const initThreeLevelLocation = {
    province: {
        code: "",
        label: "",
        id: 0
    },
    district: {
        code: "",
        label: "",
        id: 0
    },
    ward: {
        code: "",
        label: "",
        id: 0
    }
};
const threeLevelLocationReducer = (state, action)=>{
    switch(action.type){
        case UPDATE_VALUE_PROVINCE:
            return _objectSpreadProps(reducer_objectSpread({}, state), {
                province: action.value
            });
        case UPDATE_VALUE_DISTRICT:
            return _objectSpreadProps(reducer_objectSpread({}, state), {
                district: action.value
            });
        case UPDATE_VALUE_WARD:
            return _objectSpreadProps(reducer_objectSpread({}, state), {
                ward: action.value
            });
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(353632);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(479228);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
;// CONCATENATED MODULE: ./contexts/ThreeLevelLocationProvider/index.tsx
function ThreeLevelLocationProvider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ThreeLevelLocationProvider_templateObject() {
    const data = ThreeLevelLocationProvider_taggedTemplateLiteral([
        "\n  font-size: 1.2rem;\n"
    ]);
    ThreeLevelLocationProvider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














const ThreeLevelLocationContext = /*#__PURE__*/ (0,react.createContext)({
    showThreeLevelLocationPicker: false,
    onCloseThreeLevelLocationPopup: ()=>{},
    threeLevelLocation: initThreeLevelLocation
});
const ThreeLevelLocationProvider = (param)=>{
    let { children  } = param;
    const { isMobile , clearCacheAfterSwitchLocation , epicOmni1541 , epicOmni1584 , isDmsFlow , platformId , isAllowGetTerminalFromTerra , terminalId , epicOmni1584Phase2 ,  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { orderService  } = (0,ServiceContext/* useServices */.Su)();
    const [, setLoading] = (0,context_es/* useLoading */.r$)("threeLevelLocation");
    const { 0: showThreeLevelLocationPicker , 1: setShowThreeLevelLocationPicker  } = (0,react.useState)(false);
    const { 0: showErrorUnavailableTerminal , 1: setShowErrorUnavailableTerminal  } = (0,react.useState)(false);
    const { 0: unavailableThreeLevelLocation , 1: setUnavailableThreeLevelLocation  } = (0,react.useState)({
        ward: {
            code: "",
            label: "",
            id: 0
        },
        district: {
            code: "",
            label: "",
            id: 0
        },
        province: {
            code: "",
            label: "",
            id: 0
        }
    });
    const { 0: showErrorTerminal , 1: setShowErrorTerminal  } = (0,react.useState)(false);
    const { 0: threeLevelLocation , 1: dispatch  } = (0,react.useReducer)(threeLevelLocationReducer, initThreeLevelLocation);
    const { 0: correctThreeLevelLocation , 1: setCorrectThreeLevelLocation  } = (0,react.useState)(null);
    const { 0: currentTerminal , 1: setCurrentTerminal  } = (0,react.useState)(undefined);
    const { 0: currentSiteId , 1: setCurrentSiteId  } = (0,react.useState)(undefined);
    const { 0: stepLocation , 1: setStepLocation  } = (0,react.useState)(PROVINCE);
    const onCloseThreeLevelLocationPopup = ()=>{
        if (!correctThreeLevelLocation) {
            return;
        }
        setShowThreeLevelLocationPicker(false);
    };
    const onOpenThreeLevelLocationPopup = ()=>{
        if (!!correctThreeLevelLocation) {
            var ref, ref1, ref2;
            dispatch({
                type: UPDATE_VALUE_PROVINCE,
                value: {
                    label: correctThreeLevelLocation.province.label,
                    code: correctThreeLevelLocation.province.code,
                    id: correctThreeLevelLocation.province.id
                }
            });
            dispatch({
                type: UPDATE_VALUE_DISTRICT,
                value: {
                    label: ((ref = correctThreeLevelLocation.district) === null || ref === void 0 ? void 0 : ref.label) || "",
                    code: ((ref1 = correctThreeLevelLocation.district) === null || ref1 === void 0 ? void 0 : ref1.code) || "",
                    id: ((ref2 = correctThreeLevelLocation.district) === null || ref2 === void 0 ? void 0 : ref2.id) || 0
                }
            });
            dispatch({
                type: UPDATE_VALUE_WARD,
                value: {
                    label: correctThreeLevelLocation.ward.label,
                    code: correctThreeLevelLocation.ward.code,
                    id: correctThreeLevelLocation.ward.id
                }
            });
        }
        setShowThreeLevelLocationPicker(true);
    };
    const getAndSaveTerminalFromStorage = async ()=>{
        (0,helper_es/* trackCustomEvent */.I)("Start get data from storage", {
            action: "get data from terra",
            label: "Huy Test"
        });
        if (dist/* default.isAvailable */.Z.isAvailable() && isAllowGetTerminalFromTerra) {
            (0,helper_es/* trackCustomEvent */.I)("Start get terminal Data FromApp when turn on flag 1584", {});
            const terminalDataFromApp = await dist/* default.erp */.Z.erp().getTerminal();
            (0,helper_es/* trackCustomEvent */.I)("Terminal Data FromApp when turn on flag 1584", {
                action: "get data from terra",
                label: JSON.stringify(terminalDataFromApp)
            });
            if (!!terminalDataFromApp && terminalId !== terminalDataFromApp.id) {
                (0,helper_es/* trackCustomEvent */.I)("Start save Terminal Data FromApp when turn on flag 1584", {
                    action: "get data from terra",
                    label: "".concat(terminalDataFromApp, " + ").concat(terminalDataFromApp.id)
                });
                setNewSupermarketTerminal({
                    terminalCode: terminalDataFromApp.code,
                    terminalId: terminalDataFromApp.id,
                    terminalName: terminalDataFromApp.name || ""
                });
            }
            return;
        }
        const terminalCodeFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, isMobile, true);
        const terminalNameFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, isMobile, true);
        const terminalIdFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, isMobile, true);
        if (!!terminalCodeFromStorage && !!terminalIdFromStorage) {
            setCurrentTerminal({
                terminalCode: terminalCodeFromStorage,
                terminalId: (0,common/* getJson */.LK)(terminalIdFromStorage),
                terminalName: terminalNameFromStorage || ""
            });
        }
    };
    (0,react.useEffect)(()=>{
        const jsonThreeLevelLocationFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.THREE_LEVEL_LOCATION */.Tp.THREE_LEVEL_LOCATION, isMobile, true);
        const jsonTerminalIdFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, isMobile, true);
        const jsonTerminalFromStorage = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, isMobile, true);
        if (!isDmsFlow && epicOmni1541 && epicOmni1584) {
            getAndSaveTerminalFromStorage();
            if (!!jsonThreeLevelLocationFromStorage && !!jsonTerminalIdFromStorage && !!jsonTerminalFromStorage) {
                const threeLevelLocationFromStorage = (0,common/* getJson */.LK)(jsonThreeLevelLocationFromStorage);
                if (!!threeLevelLocationFromStorage) {
                    setCorrectThreeLevelLocation(threeLevelLocationFromStorage);
                    dispatch({
                        type: UPDATE_VALUE_PROVINCE,
                        value: threeLevelLocationFromStorage.province
                    });
                    dispatch({
                        type: UPDATE_VALUE_DISTRICT,
                        value: threeLevelLocationFromStorage.district
                    });
                    dispatch({
                        type: UPDATE_VALUE_WARD,
                        value: threeLevelLocationFromStorage.ward
                    });
                }
            } else {
                // trong TH la webview thi se khong can hien popup ma tuyen tu app xuong
                // duoc xu ly o ham getAndSaveTerminalFromStorage o tren
                if (!dist/* default.isAvailable */.Z.isAvailable()) {
                    onOpenThreeLevelLocationPopup();
                }
            }
        } else {
            // only remove location & terminal info and reload page If level location is set before (epicOmni1584 & epicOmni1541 were enabled before)
            if (!!jsonThreeLevelLocationFromStorage && !epicOmni1584Phase2) {
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.THREE_LEVEL_LOCATION */.Tp.THREE_LEVEL_LOCATION, isMobile);
                (0,env/* removeUserSelectedInfo */.iZ)(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, isMobile);
                (0,helpers/* reloadPage */.sl)();
            }
        }
    }, []);
    const selectTerminal = (terminal, newThreeLevelLocation)=>{
        var ref;
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, terminal.terminalCode, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, terminal.terminalName, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.terminalId) === null || ref === void 0 ? void 0 : ref.toString(), isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.THREE_LEVEL_LOCATION */.Tp.THREE_LEVEL_LOCATION, JSON.stringify(newThreeLevelLocation), isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, newThreeLevelLocation.ward.code, isMobile, true);
        setCorrectThreeLevelLocation(newThreeLevelLocation);
        setCurrentTerminal(terminal);
    };
    const handleUnAvailableTerminal = ()=>{
        setShowThreeLevelLocationPicker(false);
        setShowErrorUnavailableTerminal(true);
    };
    const handleErrorTerminal = ()=>{
        setShowThreeLevelLocationPicker(false);
        setShowErrorTerminal(true);
    };
    const setNewTerminal = (terminal, newThreeLevelLocation, noNeedReload, reloadUrl)=>{
        selectTerminal(terminal, newThreeLevelLocation);
        if (!noNeedReload) {
            if (clearCacheAfterSwitchLocation) {
                (0,helpers/* clearCacheAndReloadPage */.w5)(reloadUrl);
            } else {
                (0,helpers/* reloadPage */.sl)(reloadUrl);
            }
        }
    };
    const requestGetTerminal = async (wardCode)=>{
        if (epicOmni1584) {
            return await orderService.getPriorityTerminal({
                wardCode,
                platformId
            });
        }
        return await orderService.getTerminal({
            wardCode,
            platformId
        });
    };
    const onSubmitNewLocation = async (newThreeLevelLocation)=>{
        try {
            setLoading(true);
            const response = await requestGetTerminal(newThreeLevelLocation.ward.code);
            setLoading(false);
            if (!!response.data.terminalId) {
                setNewTerminal(response.data, newThreeLevelLocation);
            } else {
                setUnavailableThreeLevelLocation(newThreeLevelLocation);
                handleUnAvailableTerminal();
            }
        } catch (error) {
            setUnavailableThreeLevelLocation(newThreeLevelLocation);
            handleUnAvailableTerminal();
            setLoading(false);
        }
    };
    const setNewSupermarketTerminal = (terminal, noNeedReload, reloadUrl)=>{
        var ref;
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, terminal.terminalCode, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_NAME */.Tp.TERMINAL_NAME, terminal.terminalName, isMobile, true);
        (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, terminal === null || terminal === void 0 ? void 0 : (ref = terminal.terminalId) === null || ref === void 0 ? void 0 : ref.toString(), isMobile, true);
        setCurrentTerminal(terminal);
        if (!noNeedReload) {
            if (clearCacheAfterSwitchLocation) {
                (0,helpers/* clearCacheAndReloadPage */.w5)(reloadUrl);
            } else {
                (0,helpers/* reloadPage */.sl)(reloadUrl);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThreeLevelLocationContext.Provider, {
        value: {
            showThreeLevelLocationPicker: showThreeLevelLocationPicker,
            onCloseThreeLevelLocationPopup,
            onOpenThreeLevelLocationPopup,
            threeLevelLocation,
            updateThreeLevelLocation: dispatch,
            stepLocation,
            setStepLocation,
            onSubmitNewLocation,
            setLoadingThreeLevelLocation: setLoading,
            correctThreeLevelLocation,
            handleErrorTerminal,
            handleUnAvailableTerminal,
            setNewTerminal,
            setNewSupermarketTerminal,
            currentTerminal,
            requestGetTerminal,
            unavailableThreeLevelLocation,
            setUnavailableThreeLevelLocation,
            currentSiteId,
            setCurrentSiteId
        },
        children: [
            children,
            !isDmsFlow && !!epicOmni1541 && /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupThreeLevelLocationPicker, {
                showPopup: showThreeLevelLocationPicker,
                onClosePopup: onCloseThreeLevelLocationPopup,
                threeLevelLocation: threeLevelLocation,
                updateThreeLevelLocation: dispatch,
                stepLocation: stepLocation,
                setStepLocation: setStepLocation,
                onSubmitNewLocation: onSubmitNewLocation,
                correctThreeLevelLocation: correctThreeLevelLocation
            }),
            !isDmsFlow && !!epicOmni1541 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnAvailableTerminal, {
                showErrorUnavailableTerminal: showErrorUnavailableTerminal,
                setShowErrorUnavailableTerminal: setShowErrorUnavailableTerminal,
                onOK: ()=>{
                    setStepLocation(PROVINCE);
                    onOpenThreeLevelLocationPopup();
                }
            }),
            !isDmsFlow && !!epicOmni1541 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorTerminal, {
                showErrorTerminal: showErrorTerminal,
                setShowErrorTerminal: setShowErrorTerminal,
                onOK: ()=>{
                    setShowErrorTerminal(false);
                    onSubmitNewLocation(threeLevelLocation);
                },
                onCancel: ()=>setShowErrorTerminal(false)
            })
        ]
    });
};
const useThreeLevelLocationContext = ()=>{
    return (0,react.useContext)(ThreeLevelLocationContext);
};
const StyledModalTitle = (0,styled_es/* styled */.z)(index_es/* Title */.Dx)(ThreeLevelLocationProvider_templateObject());


/***/ }),

/***/ 508285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314408);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(500689);


const useToastContext = (isMobile)=>{
    return isMobile ? _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_0__/* .useToast */ .p : _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .useToast */ .p;
};
const useToast = (isMobile)=>{
    const hook = useToastContext(isMobile);
    const context = hook();
    if (!context) {
        throw new Error("useToast must be inside a ToastProvider with a showToast value");
    }
    return context;
};


/***/ }),

/***/ 997441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eo": function() { return /* binding */ cookDiscoveryFilter; },
/* harmony export */   "Ot": function() { return /* binding */ transformBlock; },
/* harmony export */   "Zj": function() { return /* binding */ getBlockDomId; },
/* harmony export */   "jx": function() { return /* binding */ convertObjectDiscoveryToQueryStringSearch; },
/* harmony export */   "yA": function() { return /* binding */ findBlockByType; }
/* harmony export */ });
/* unused harmony exports fetchSingleDataBlockSSRFromDiscoveryV2, fetchDataBlockSSRFromDiscoveryV2 */
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(875663);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(428247);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(775002);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








const listingAndDiscoveryKeysMap = {
    priceGte: "price_gte",
    priceLte: "price_lte"
};
const listingAndDiscoveryValuesMap = {
    ORDER_BY_DESCENDING: "DESC",
    ORDER_BY_ASCENDING: "ASC"
};
const convertObjectDiscoveryToQueryStringSearch = (params)=>{
    if (!params) return "/";
    const newParams = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)(_objectSpreadProps(_objectSpread({}, params), {
        router: "productListing"
    }));
    return "/search?" + Object.keys(newParams).map((key)=>{
        if (!newParams[key] || Array.isArray(newParams === null || newParams === void 0 ? void 0 : newParams[key]) && newParams[key].length === 0) {
            return;
        }
        return (listingAndDiscoveryKeysMap[key] || key) + "=" + (listingAndDiscoveryValuesMap[newParams[key]] || newParams[key]);
    }).filter((query)=>query).join("&");
};
const cookDiscoveryFilter = (filter)=>{
    if (!filter) return {};
    if (filter === null || filter === void 0 ? void 0 : filter.attributes.length) {
        filter.attributes.map((el)=>filter["attributes.".concat(el.code)] = el.optionIds.join());
        const { attributes: tbr  } = filter, newFilter = _objectWithoutProperties(filter, [
            "attributes"
        ]);
        return newFilter;
    }
    return filter;
};
const findBlockByType = (type, blocks)=>{
    return blocks && blocks.find((block)=>block.type === type);
};
const getUrl = (item)=>{
    var ref;
    const { url , redirectUrl , params  } = item || {};
    return redirectUrl ? redirectUrl : url || convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter), ((ref = item.params) === null || ref === void 0 ? void 0 : ref.sorting) || {}));
};
const getLinkHref = (url, paramsObject, title)=>{
    let href = null;
    if (url) {
        if (url.startsWith("/landing/")) {
            href = {
                pathname: "/landing/[id]",
                query: {
                    id: url.substring("/landing/".length)
                }
            };
        } else {
            href = url;
        }
    } else {
        // remove non-relevant flags from paramsObject
        // such as false param or empty array
        // we don't want them to appear on browser url
        /**
     *
     *  "sellingCodes": [],
        "priceLte": "0",
        "priceGte": "0",
        "brands": [],
        "flashSaleType": "",
        "masterCategories": [],
        "excludedSkus": [],
        "masterCategoryIds": [62],
      }
     */ const queryParams = {};
        for (const [key, value] of Object.entries(paramsObject)){
            if (value && (!Array.isArray(value) || value.length > 0) && (isNaN(value) || !!parseInt(value))) {
                queryParams[key] = value;
            }
        }
        href = {
            pathname: "/search",
            query: _objectSpreadProps(_objectSpread({}, queryParams), {
                pageTitle: title,
                router: "productListing"
            })
        };
    }
    return {
        href
    };
};
const transformBlockItemTypeSku = (block)=>{
    const { fetchParams , collectionSlug =""  } = block.content;
    block.cookedData = {
        queryString: convertObjectDiscoveryToQueryStringSearch(_objectSpread({}, cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter), fetchParams.sorting)),
        paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)({
            filter: collectionSlug ? undefined : cookDiscoveryFilter(fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.filter),
            sorting: collectionSlug ? {} : (fetchParams === null || fetchParams === void 0 ? void 0 : fetchParams.sorting) || {},
            slug: collectionSlug,
            blockId: block.id
        })
    };
    return block;
};
const transformBanner = (block)=>{
    const banners = block.content.items.map((item)=>{
        var ref, ref1;
        const paramsObject = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)(_objectSpreadProps(_objectSpread({}, cookDiscoveryFilter(item === null || item === void 0 ? void 0 : (ref = item.params) === null || ref === void 0 ? void 0 : ref.filter), ((ref1 = item.params) === null || ref1 === void 0 ? void 0 : ref1.sorting) || {}), {
            blockId: block.id,
            itemId: item.id
        }));
        return {
            id: item.id,
            targetPath: getUrl(item),
            image: item.imageUrl,
            campaignName: item.label,
            description: item.subLabel,
            paramsObject,
            url: item.url,
            thumbnail: item.thumbnail,
            link: getLinkHref(item.url || item.redirectUrl || "", paramsObject, item.label),
            imageSize: item.imageSize,
            as: item.url || item.redirectUrl || ""
        };
    });
    block.cookedData = banners || [];
    return block;
};
const transformBlockMixBanner = (block)=>{
    var ref, ref1;
    const firstItem = block === null || block === void 0 ? void 0 : (ref = block.content) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1[0];
    const trackingRegionName = "categoriesBlockBrand";
    block.cookedData = {
        header: {
            title: block.label,
            link: {
                href: getUrl(firstItem)
            }
        },
        banner: {
            src: firstItem.imageUrl,
            alt: firstItem.label || firstItem.subLabel,
            tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                regionName: trackingRegionName,
                contentName: firstItem.label,
                target: getUrl(firstItem)
            }),
            link: {
                href: getUrl(firstItem)
            }
        },
        contentItems: block.content.items.slice(1, 5).map((category)=>({
                name: category.label,
                description: category.subLabel,
                image: {
                    src: category.imageUrl,
                    alt: category.label || category.subLabel
                },
                link: {
                    href: getUrl(category)
                }
            })),
        bottomImages: block.content.items.slice(5, 11).map((brand, index)=>({
                src: brand.imageUrl,
                alt: brand.label || brand.subLabel,
                tracking: (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: trackingRegionName,
                    contentName: brand.label,
                    index,
                    target: getUrl(brand)
                }),
                link: {
                    href: getUrl(brand)
                }
            }))
    };
    return block;
};
const transformBlockHotDeal = (block)=>{
    block.cookedData = block.content.items.map((el)=>{
        const { collectionSlug , params , id  } = el;
        return _objectSpreadProps(_objectSpread({}, el), {
            name: el.label,
            url: el.redirectUrl || el.url,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
    });
    return block;
};
const transformBlockListingTab = (block)=>{
    const categoryList = [];
    block.content.items.forEach((item)=>{
        const { collectionSlug , params , id  } = item;
        const obj = _objectSpreadProps(_objectSpread({}, item), {
            id: item.id,
            name: item.label,
            paramsObject: (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.cleanObject)({
                filter: collectionSlug ? undefined : cookDiscoveryFilter(params === null || params === void 0 ? void 0 : params.filter),
                sorting: collectionSlug ? {} : (params === null || params === void 0 ? void 0 : params.sorting) || {},
                slug: collectionSlug,
                blockId: block.id,
                itemId: id
            })
        });
        categoryList.push(obj);
    });
    block.cookedData = categoryList;
    return block;
};
const transformBlock = (block)=>{
    if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.SKU */ .Nc.SKU) return transformBlockItemTypeSku(block);
    else if (block.itemType === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockItemType.BANNER */ .Nc.BANNER || [
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_HIGHLIGHTED_BANNER */ .kH.HORIZONTAL_HIGHLIGHTED_BANNER,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_CATEGORY */ .kH.RECOMMENDED_CATEGORY,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.RECOMMENDED_BRANDS */ .kH.RECOMMENDED_BRANDS,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.PROMOTE_CATEGORY_MENU */ .kH.PROMOTE_CATEGORY_MENU,
        _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.HORIZONTAL_2_BANNER_MOBILE */ .kH.HORIZONTAL_2_BANNER_MOBILE, 
    ].includes(block.type)) return transformBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.MIX_BANNER */ .kH.MIX_BANNER) return transformBlockMixBanner(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_BIG_SKU */ .kH.COUNT_DOWN_PROMO_BIG_SKU || block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.COUNT_DOWN_PROMO_TAB_MOBILE */ .kH.COUNT_DOWN_PROMO_TAB_MOBILE) return transformBlockHotDeal(block);
    else if (block.type === _teko_discovery__WEBPACK_IMPORTED_MODULE_3__/* .BlockType.LISTING_TAB */ .kH.LISTING_TAB) return transformBlockListingTab(block);
    else return block;
};
// fetch data for default block page (brand & seller page)
const fetchSingleDataBlockSSRFromDiscoveryV2 = async function(context, block) {
    let includeFilter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, optionalSortingParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const { req , query  } = context;
    const { tenantEnv , location  } = req;
    const { discoveryServiceV2 , discoveryHelper  } = new ServiceContainer(tenantEnv);
    const { sort , order  } = optionalSortingParams;
    try {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        const [{ products  }, resultFilter] = await Promise.all([
            discoveryServiceV2.search({
                page: parseInt((query.page || "1").toString()),
                pageSize: ITEM_PER_PAGE_IN_LISTING_PAGE,
                slug: block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : (ref1 = ref.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.filter, query)),
                sorting: convertToPayloadSorting(sort, order),
                location
            }),
            includeFilter ? await discoveryServiceV2.search({
                pageSize: 1,
                slug: block === null || block === void 0 ? void 0 : (ref4 = block.cookedData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : ref5.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref6 = block.cookedData) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.paramsObject) === null || ref7 === void 0 ? void 0 : ref7.filter)),
                returnFilterable: [
                    "FILTER_TYPE_ATTRIBUTE",
                    "FILTER_TYPE_BRAND",
                    "FILTER_TYPE_PRICE",
                    "FILTER_TYPE_CLEARANCE", 
                ],
                location
            }) : {}, 
        ]);
        return {
            ssrProducts: (products || []).map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product)),
            filters: resultFilter === null || resultFilter === void 0 ? void 0 : resultFilter.filter,
            filterPrice: {
                max: Number((ref8 = resultFilter.filter) === null || ref8 === void 0 ? void 0 : ref8.priceLte),
                min: Number((ref9 = resultFilter.filter) === null || ref9 === void 0 ? void 0 : ref9.priceGte)
            }
        };
    } catch (error) {
        logger.error(error);
        return {};
    }
};
const fetchDataBlockSSRFromDiscoveryV2 = async (context, blocks)=>{
    const { discoveryHelper , discoveryServiceV2  } = new ServiceContainer(context.req.tenantEnv);
    const simpleProductBlocks = blocks.filter((b)=>[
            BlockType.FLASH_SALE,
            BlockType.PROMOTE_SELLER,
            BlockType.BEST_SELLING_PRODUCT,
            BlockType.LIST_SKU_MOBILE,
            BlockType.MAIN_SKU_LIST,
            BlockType.COUNT_DOWN_PROMO_SKU,
            BlockType.HORIZONTAL_SKU_LIST, 
        ].includes(b.type) && b.itemType === BlockItemType.SKU);
    const partialRenderedBlocks = blocks.filter((b)=>[
            BlockType.COUNT_DOWN_PROMO_TAB_MOBILE,
            BlockType.COUNT_DOWN_PROMO_BIG_SKU,
            BlockType.LISTING_TAB, 
        ].includes(b.type));
    const mapProducts = await Promise.all([
        ...simpleProductBlocks.map(async (block)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            const products = await discoveryServiceV2.search({
                slug: block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : (ref1 = ref.paramsObject) === null || ref1 === void 0 ? void 0 : ref1.slug,
                filter: convertToPayloadFilter(_objectSpread({}, block === null || block === void 0 ? void 0 : (ref2 = block.cookedData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paramsObject) === null || ref3 === void 0 ? void 0 : ref3.filter, context.query)),
                sorting: convertToPayloadSorting(context.query.sort || (block === null || block === void 0 ? void 0 : (ref4 = block.cookedData) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.paramsObject) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.sorting) === null || ref6 === void 0 ? void 0 : ref6.sort), context.query.order || (block === null || block === void 0 ? void 0 : (ref7 = block.cookedData) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.paramsObject) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.sorting) === null || ref9 === void 0 ? void 0 : ref9.order)),
                pageSize: context.req.tenantEnv.isMobile ? ITEM_PER_PAGE_IN_LISTING_PAGE : SSR_DESKTOP_ITEM_PER_PAGE_IN_HOME_PAGE
            }).then((res)=>{
                return ((res === null || res === void 0 ? void 0 : res.products) || []).map((p)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(p, {
                        hideHighlightAttribute: true
                    }));
            }).catch((error)=>{
                logger.error("[discovery-v2]", error);
                return [];
            });
            return {
                [block.id]: products
            };
        }),
        ...partialRenderedBlocks.map(async (block)=>{
            var ref;
            // paramObject contant: blockId, itemId and other filter of discovery
            const firstItem = block === null || block === void 0 ? void 0 : (ref = block.cookedData) === null || ref === void 0 ? void 0 : ref[0];
            const blockId = block === null || block === void 0 ? void 0 : block.id;
            const itemId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
            const paramsObject = firstItem === null || firstItem === void 0 ? void 0 : firstItem.paramsObject;
            if (!paramsObject || !blockId || !itemId) {
                return {};
            }
            try {
                const result = await discoveryServiceV2.search(_objectSpreadProps(_objectSpread({}, paramsObject), {
                    pageSize: 20,
                    location: context.req.location
                }));
                const products = ((result === null || result === void 0 ? void 0 : result.products) || []).map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, {
                        hideHighlightAttribute: true
                    }));
                return {
                    ["".concat(blockId, "_").concat(itemId)]: products
                };
            } catch (error) {
                logger.error(error);
                return {};
            }
        }), 
    ]);
    return mapProducts.filter(Boolean).reduce((acc, curr)=>Object.assign(acc || {}, curr), {});
};
const getBlockDomId = (block)=>block.label ? (0,_teko_slug__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(block.label) : "".concat(block.name, "-").concat(block.id);


/***/ }),

/***/ 504133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bc": function() { return /* binding */ checkPathEqual; },
/* harmony export */   "GH": function() { return /* binding */ isHomepage; },
/* harmony export */   "I6": function() { return /* binding */ isAndroidDevice; },
/* harmony export */   "LK": function() { return /* binding */ getJson; },
/* harmony export */   "NL": function() { return /* binding */ checkPathInclude; },
/* harmony export */   "RN": function() { return /* binding */ checkCurrentPageIsExcluded; },
/* harmony export */   "Z2": function() { return /* binding */ checkExpiryDateTimestamp; },
/* harmony export */   "au": function() { return /* binding */ isIOSDevice; },
/* harmony export */   "l3": function() { return /* binding */ saveRecentlyProduct; },
/* harmony export */   "t1": function() { return /* binding */ filterBlockItems; },
/* harmony export */   "vf": function() { return /* binding */ getSearchAlgo; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; },
/* harmony export */   "xq": function() { return /* binding */ getBaseDomain; }
/* harmony export */ });
/* unused harmony export getRandomInt */
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(679376);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(535820);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(853675);
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(353632);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(284587);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185081);
/* eslint-disable @typescript-eslint/no-explicit-any */ 




const formatCurrency = function(money) {
    let isFull = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, numberDisplayFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_NUMBER_DISPLAY_FORMAT */ .n6;
    const valueWithFormatCurrency = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .formatCurrency */ .xG)(money, {
        hideCurrencySymbol: !isFull
    });
    if (!!numberDisplayFormat) {
        return valueWithFormatCurrency.replaceAll(".", numberDisplayFormat.thousandSeparator).replaceAll(",", numberDisplayFormat.decimalSeparator);
    }
    return valueWithFormatCurrency;
};
const saveRecentlyProduct = (sku, localKey)=>{
    const historyStorage = localStorage.getItem(localKey);
    if (!historyStorage) {
        localStorage.setItem(localKey, JSON.stringify([
            sku
        ]));
        return;
    }
    let histories = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__/* .parseJsonStringSafely */ .O)(historyStorage, []);
    histories = histories.filter((item)=>item !== sku);
    histories = [
        sku,
        ...histories
    ];
    if (histories.length > 20) {
        histories.pop();
    }
    localStorage.setItem(localKey, JSON.stringify(histories));
};
const isIOSDevice = ()=>{
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    return iOS;
};
const isAndroidDevice = ()=>{
    const android = /(android)/i.test(navigator.userAgent);
    return android;
};
// Check if path equals ...
const checkPathEqual = (router, path)=>{
    let pathname = router.asPath || router.pathname;
    pathname === "" ? "/" : pathname;
    const searchParam = pathname.indexOf("?");
    pathname = searchParam >= 0 ? pathname.substring(0, searchParam) : pathname;
    const rawPath = path.indexOf("?") >= 0 ? path.substring(0, path.indexOf("?")) : path;
    return pathname === rawPath;
};
// Check if path includes ...
const checkPathInclude = (router, acceptedPaths)=>{
    const pathName = router.asPath || router.pathname;
    return acceptedPaths.some((path)=>pathName.includes(path));
};
const checkExpiryDateTimestamp = (startDate, endDate)=>{
    const today = new Date().getTime();
    if (today - new Date(parseInt(startDate) * 1000).getTime() > 0 && new Date(parseInt(endDate) * 1000).getTime() - today > 0) return true;
    return false;
};
const isHomepage = (pathname)=>{
    // Old version
    // return ['', '/'].includes(pathname);
    // This's added for supporting multi-languages
    return !pathname || /^\/(\?lang=[a-zA-Z-]{2,5})?$/.test(pathname);
};
const filterBlockItems = (item, blockList)=>{
    const matchFormat = item.url.match(/^#\d+$/);
    if (!matchFormat) return false;
    const blockId = item.url.substring(1);
    const block = blockList.find((e)=>e.id === blockId);
    if (!block) return false;
    return true;
};
const getBaseDomain = ()=>{
    var ref, ref1;
    if (false) {}
    return "".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.protocol, "/").concat(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.host);
};
const getRandomInt = (min, max)=>{
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
};
const getSearchAlgo = ()=>{
    const envGenRanges = (0,_env__WEBPACK_IMPORTED_MODULE_3__/* .getEnv */ .dU)("SEARCH_ALGO_GENERATE_RANGES");
    const genRanges = typeof envGenRanges === "string" ? JSON.parse(envGenRanges) : undefined;
    if (!(0,_teko_utils__WEBPACK_IMPORTED_MODULE_4__/* .isEmptyObject */ .Q)(genRanges)) {
        // random integer number between 1 & 100
        const randomValue = getRandomInt(1, 100);
        let boundary = 0;
        let result = "";
        const listAlgoKeys = Object.keys(genRanges);
        for(let i = 0; i < listAlgoKeys.length; i++){
            boundary += genRanges[listAlgoKeys[i]];
            if (randomValue <= boundary) {
                result = listAlgoKeys[i];
                break;
            }
        }
        return result.replace(_constants__WEBPACK_IMPORTED_MODULE_5__/* .SEARCH_ALGO.REPLACE_PATTERN */ .XH.REPLACE_PATTERN, "");
    }
    return "";
};
const checkCurrentPageIsExcluded = (pathName)=>{
    // get excluded paths from config workload
    const envExcludedUrlPaths = (0,_env__WEBPACK_IMPORTED_MODULE_3__/* .getEnv */ .dU)("SEARCH_ALGO_EXCLUDE_URL_PATHS") || "";
    const excludedUrlPaths = typeof envExcludedUrlPaths === "string" ? envExcludedUrlPaths.split(" ") : [];
    // Check if current page is excluded
    return !!excludedUrlPaths.length ? excludedUrlPaths.some((path)=>pathName.includes(path)) : false;
};
const getJson = (str)=>{
    try {
        return !!str && JSON.parse(str);
    } catch (e) {
        return null;
    }
};


/***/ }),

/***/ 41796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ isAdultCategoryProduct; },
/* harmony export */   "P1": function() { return /* binding */ markUserIsOver18; },
/* harmony export */   "Sj": function() { return /* binding */ IS_OVER_18_KEY; },
/* harmony export */   "av": function() { return /* binding */ needConfirm18YearsOld; },
/* harmony export */   "bO": function() { return /* binding */ requiredConfirm18YearsOld; }
/* harmony export */ });
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(653028);
/* harmony import */ var _datetime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(505709);


const IS_LOGGED_USER_KEY = "is_logged_user";
const IS_OVER_18_KEY = "is_over_18";
const needConfirm18YearsOld = (isAlcoholicCategory)=>{
    const isOver18YearsOld = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__/* .getCookieOver18YearOld */ .Iv)();
    return !isOver18YearsOld && isAlcoholicCategory;
};
/**
 * @param productCategories
 * @description https://jira.teko.vn/browse/UX4BUYER-5311
 * @returns true if lastest category has isAdult = true. Else return false
 */ const isAdultCategoryProduct = (productCategories)=>{
    var ref;
    return (ref = productCategories === null || productCategories === void 0 ? void 0 : productCategories.at(-1)) === null || ref === void 0 ? void 0 : ref.isAdult;
};
/**
 * @param user
 * @description ECOM-315
 * @returns true if user confirmed their age > 18. Else return false
 */ const requiredConfirm18YearsOld = (user)=>{
    if (!!user) {
        // set is_logged_user = true
        // check user_age >= 18 => over 18 flow
        // else set is_over_18 = false => under 18 flow
        localStorage.setItem(IS_LOGGED_USER_KEY, "true");
        if (user.dob && (0,_datetime__WEBPACK_IMPORTED_MODULE_1__/* .isOver18YearOld */ .xW)(user === null || user === void 0 ? void 0 : user.dob)) {
            localStorage.setItem(IS_OVER_18_KEY, "true");
            return false;
        } else {
            localStorage.setItem(IS_OVER_18_KEY, "false");
            return true;
        }
    } else {
        // check is_logged_user
        if (localStorage.getItem(IS_LOGGED_USER_KEY) === "true") {
            // set is_logged_user = false
            // set is_over_18 = false
            // => under 18 flow
            localStorage.setItem(IS_LOGGED_USER_KEY, "false");
            localStorage.setItem(IS_OVER_18_KEY, "false");
            return true;
        } else {
            //  check is_over_18 = true => over 18 flow
            //  else => under 18 flow
            if (localStorage.getItem(IS_OVER_18_KEY) === "true") {
                return false;
            } else {
                return true;
            }
        }
    }
};
const markUserIsOver18 = ()=>{
    localStorage.setItem(IS_OVER_18_KEY, "true");
};


/***/ }),

/***/ 505709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TV": function() { return /* binding */ getMinimumTime; },
/* harmony export */   "bh": function() { return /* binding */ getExpireTime; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "xW": function() { return /* binding */ isOver18YearOld; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(189060);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(169802);

const getTime = (timeStampSec)=>{
    return new Date(parseInt(timeStampSec) * 1000);
};
/**
 * Get the minimum time from an array of timestamp second
 *
 * @returns The minimum time: Date | null (if array is empty)
 *
 * @param timestampSecList: Array<number as string>
 */ const getMinimumTime = (timestampSecList)=>{
    if (timestampSecList.length === 0) return null;
    let minimumTime = new Date();
    minimumTime.setHours(23, 59, 59);
    timestampSecList.forEach((timestampSec)=>{
        // convert to Date format
        const currentTime = new Date(parseInt(timestampSec) * 1000);
        if (currentTime < minimumTime) minimumTime = currentTime;
    });
    return minimumTime;
};
/**
 *
 * @param birthday The birthday in string format (YYYY-MM-DD)
 */ const isOver18YearOld = (birthday)=>{
    const currentDate = new Date();
    return !(0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(birthday), (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentDate, 18));
};
const getExpireTime = (duration)=>{
    const currentTime = new Date().getTime();
    const expireTime = new Date(currentTime + duration).toUTCString();
    return expireTime;
};


/***/ }),

/***/ 681889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LB": function() { return /* binding */ DiscoveryHelper; },
  "xZ": function() { return /* binding */ ProductHelper; },
  "yr": function() { return /* binding */ buildTreeCategoriesFilter; },
  "k6": function() { return /* binding */ convertCommonPromotion; },
  "px": function() { return /* binding */ convertDiscoveryFilter; },
  "Kx": function() { return /* binding */ convertGift; },
  "NP": function() { return /* binding */ convertProductDetail; },
  "JR": function() { return /* binding */ convertToPayloadFilter; },
  "EN": function() { return /* binding */ convertToPayloadSorting; },
  "D3": function() { return /* binding */ createHandleEventAndCtaButton; },
  "r0": function() { return /* binding */ getSearchVariables; },
  "gU": function() { return /* binding */ productHelper; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../packages/cart/dist/v2/types.es.js
var types_es = __webpack_require__(891004);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/constants.es.js
var constants_es = __webpack_require__(912885);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(19840);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Popover/Tooltip.es.js
var Tooltip_es = __webpack_require__(386877);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/ContactOutlined.es.js
var ContactOutlined_es = __webpack_require__(668809);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/EditOutlined.es.js
var EditOutlined_es = __webpack_require__(476127);
// EXTERNAL MODULE: ../../packages/tracking/dist/cart.es.js
var cart_es = __webpack_require__(446586);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ../../packages/utils/dist/polyfill.es.js
var polyfill_es = __webpack_require__(593859);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./contexts/ScreenContext.tsx
var ScreenContext = __webpack_require__(933756);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
;// CONCATENATED MODULE: ./types/discovery.ts
var PromotionApplyOnEnum;
(function(PromotionApplyOnEnum) {
    PromotionApplyOnEnum["product"] = "product";
    PromotionApplyOnEnum["partOrder"] = "part-order";
})(PromotionApplyOnEnum || (PromotionApplyOnEnum = {}));

// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./helpers/products.ts
var products = __webpack_require__(646130);
;// CONCATENATED MODULE: ./helpers/discovery.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    color: #0000000f;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}















const isExpired = (endTimestampSec)=>{
    const end = new Date(parseInt(endTimestampSec) * 1000).getTime();
    const now = new Date().getTime();
    return end < now;
};
const convertGift = (gift)=>{
    return _objectSpreadProps(_objectSpread({}, gift), {
        image: {
            alt: gift.name,
            src: gift.imageUrl || "/api/products/".concat(gift.sku, "/default_image")
        }
    });
};
const getRemainingTime = (endDate)=>{
    const remainingTime = (new Date(endDate).valueOf() - new Date().valueOf()) / 86400000;
    if (remainingTime < 6 && remainingTime >= 0) {
        if (remainingTime >= 1) {
            return "".concat(Math.floor(remainingTime), " ").concat((0,i18n.t)("ng\xe0y"));
        } else {
            const hours = Math.floor((new Date(endDate).valueOf() - new Date().valueOf()) / 3600000);
            if (hours >= 1) {
                return "".concat(hours, " ").concat((0,i18n.t)("giờ"));
            } else {
                return "1 ".concat((0,i18n.t)("giờ"));
            }
        }
    }
    return undefined;
};
const convertCommonPromotion = (promotion, price)=>{
    var ref, ref1, ref2, ref3;
    let milestoneMoney = price;
    const promo = {
        id: promotion.id,
        endedAt: new Date(parseInt(promotion.endTimestampSec) * 1000).toISOString(),
        description: promotion.description,
        name: promotion.name,
        remainingTime: getRemainingTime(parseInt(promotion.endTimestampSec) * 1000),
        type: (promotion === null || promotion === void 0 ? void 0 : (ref = promotion.condition) === null || ref === void 0 ? void 0 : ref.coupon) ? "coupon" : promotion.applyOn === "product" ? "product" : "order",
        condition: {
            orderValueMax: promotion.condition.orderValueMax,
            orderValueMin: promotion.condition.orderValueMin,
            coupon: promotion.condition.coupon,
            blockSize: promotion.condition.blockSize,
            minQuantity: promotion.condition.minQuantity,
            blockSizeDecimal: promotion.condition.blockSizeDecimal || 0,
            minQuantityDecimal: promotion.condition.minQuantityDecimal || 0
        },
        benefit: {
            money: [],
            items: [],
            voucher: promotion === null || promotion === void 0 ? void 0 : (ref1 = promotion.benefit) === null || ref1 === void 0 ? void 0 : ref1.voucher
        }
    };
    const gifts = promotion.benefit.gifts;
    if (gifts && Array.isArray(gifts)) {
        promo.benefit.items = gifts.map(convertGift);
    }
    const discount = promotion.benefit.discount;
    if (discount) {
        let discountMoney = 0;
        if (discount.percent) {
            if (milestoneMoney * discount.percent / 100 > discount.maxAmount) {
                discountMoney = discount.maxAmount;
            } else {
                discountMoney = milestoneMoney * discount.percent / 100;
            }
        } else {
            discountMoney = discount.flat;
        }
        const itemMoney = {
            discountType: discount.percent ? "percent" : "money",
            maxDiscount: discount.maxAmount,
            id: promotion.id,
            percent: discount.percent,
            money: Math.round(discountMoney)
        };
        milestoneMoney = milestoneMoney - discountMoney;
        promo.benefit.money = [
            itemMoney
        ];
    }
    promo.price = (promotion === null || promotion === void 0 ? void 0 : (ref2 = promotion.price) === null || ref2 === void 0 ? void 0 : ref2.sellPrice) ? +(promotion === null || promotion === void 0 ? void 0 : (ref3 = promotion.price) === null || ref3 === void 0 ? void 0 : ref3.sellPrice) : milestoneMoney;
    return {
        promotion: promo,
        price: milestoneMoney
    };
};
const convertProductStatus = (status)=>{
    switch(status === null || status === void 0 ? void 0 : status.sellingCode){
        case "hang_trung_bay":
            return {
                status: (0,i18n.t)("H\xe0ng trưng b\xe0y"),
                color: "#b4b4b4"
            };
        case "hang_khac":
            return {
                status: (0,i18n.t)("H\xe0ng qu\xe0 tặng"),
                color: "#b4b4b4"
            };
        default:
            return undefined;
    }
};
const sortVariant = (variants, configurations)=>{
    if (!variants || !configurations) {
        return [];
    }
    const configurationCodes = configurations.map((obj)=>obj.code);
    const sortedVariants = [];
    variants.forEach((variant)=>{
        const temp = {
            sku: variant.sku,
            attributeValues: []
        };
        configurationCodes.forEach((code)=>{
            const tmp = variant.attributeValues.findIndex((att)=>att.code === code);
            if (tmp !== -1) {
                temp.attributeValues.push(variant.attributeValues[tmp]);
            }
        });
        sortedVariants.push(temp);
    });
    return sortedVariants;
};
const convertConfigurations = (variants, configurations, sku)=>{
    if (!variants || !configurations) return [];
    const newVariants = [];
    const newConfigurations = [];
    variants.forEach((variant)=>{
        (variant.attributeValues || []).forEach((attributeValue)=>{
            newVariants.push(attributeValue);
        });
    });
    const productVariant = variants.find((variant)=>variant.sku === sku);
    configurations.forEach((item)=>{
        const optionsTmp = [];
        (item.options || []).forEach((option)=>{
            const tmp = newVariants.findIndex((variant)=>option.optionId === variant.optionId);
            if (tmp !== -1) {
                const defaultVariant = productVariant && productVariant.attributeValues.findIndex((att)=>att.optionId === option.optionId);
                optionsTmp.push({
                    value: option.value,
                    optionId: option.optionId,
                    visible: true,
                    selected: defaultVariant !== -1,
                    thumbnailUrl: option.thumbnailUrl || ""
                });
            }
        });
        // simple sort by values
        const sortedOptionsTmp = optionsTmp.sort((a, b)=>a.value < b.value ? -1 : 1);
        newConfigurations.push(_objectSpreadProps(_objectSpread({}, item), {
            options: sortedOptionsTmp
        }));
    });
    return newConfigurations;
};
const validateVisibleVariant = (selectedVariant, variants, configurations)=>{
    if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.length) || !(variants === null || variants === void 0 ? void 0 : variants.length) || !(configurations === null || configurations === void 0 ? void 0 : configurations.length)) {
        return [];
    }
    variants.forEach((variant)=>{
        var ref;
        if ((variant === null || variant === void 0 ? void 0 : (ref = variant.attributeValues) === null || ref === void 0 ? void 0 : ref[0]) && variant.attributeValues[0].optionId === selectedVariant[0].optionId) {
            let count = 0;
            variant.attributeValues.forEach((att, index)=>{
                var ref;
                if (att.optionId === ((ref = selectedVariant[index]) === null || ref === void 0 ? void 0 : ref.optionId)) {
                    count++;
                }
            });
            if (count >= variant.attributeValues.length - 1) {
                variant.attributeValues.forEach((att, index)=>{
                    const temp = configurations[index].options.find((config)=>config.optionId === att.optionId);
                    if (temp && !temp.visible) {
                        const pos = configurations[index].options.findIndex((config)=>config.optionId === att.optionId);
                        if (pos !== -1) configurations[index].options.splice(pos, 1, _objectSpreadProps(_objectSpread({}, temp), {
                            visible: true
                        }));
                    }
                });
            }
        }
    });
    return configurations;
};
const convertFlashSale = (flashSales)=>{
    const flashSale = !!flashSales.length && flashSales.find((fls)=>{
        return (0,common/* checkExpiryDateTimestamp */.Z2)(fls === null || fls === void 0 ? void 0 : fls.startTimestampSec, fls === null || fls === void 0 ? void 0 : fls.endTimestampSec) && ((fls === null || fls === void 0 ? void 0 : fls.type) === "HOT_DEAL" || (fls === null || fls === void 0 ? void 0 : fls.type) === "GOLDEN_TIME");
    });
    if (flashSale) return {
        total: flashSale.totalCount,
        used: flashSale.usedCount,
        endAt: new Date(parseInt(flashSale.endTimestampSec) * 1000).toISOString(),
        type: flashSale.type,
        endTimestampSec: flashSale.endTimestampSec
    };
    return undefined;
};
const getDefaultPromotions = (product)=>{
    var ref;
    const couponProductPromotion = (ref = (product.promotions || []).filter((promo)=>{
        const isTypeCoupon = promo.type === "coupon";
        const isApplyOnProduct = promo.applyOn === PromotionApplyOnEnum.product;
        const hasCoupon = !!promo.condition.coupon;
        return isTypeCoupon && isApplyOnProduct && hasCoupon;
    })) === null || ref === void 0 ? void 0 : ref[0];
    const defaultPromotions = (product.promotions || []).filter((promo)=>{
        const isTypeProduct = promo.type === "product";
        const isApplyOnProduct = promo.applyOn === PromotionApplyOnEnum.product;
        const isDefault = promo.isDefault;
        return isTypeProduct && isApplyOnProduct && isDefault;
    });
    return [
        ...defaultPromotions,
        couponProductPromotion
    ].filter(Boolean).filter((promo)=>{
        if (promo.endTimestampSec) {
            return !isExpired(promo.endTimestampSec);
        }
        return true;
    });
};
const getSelectionPromotions = (product)=>{
    // blockSizeDecimal and rounding float number
    // only divide when blockSizeDecimal is between 0 and 1 (not include 0 and 1)
    const promotions = (product.promotions || []).map((el)=>{
        var ref, ref1;
        const blockSizeDecimal = el === null || el === void 0 ? void 0 : (ref = el.condition) === null || ref === void 0 ? void 0 : ref.blockSizeDecimal;
        if (blockSizeDecimal === 0 || !blockSizeDecimal || blockSizeDecimal >= 1) return el;
        const discount = el === null || el === void 0 ? void 0 : (ref1 = el.benefit) === null || ref1 === void 0 ? void 0 : ref1.discount;
        let flat = discount === null || discount === void 0 ? void 0 : discount.flat;
        if (flat) {
            flat = flat / blockSizeDecimal;
        }
        return _objectSpreadProps(_objectSpread({}, el), {
            benefit: _objectSpreadProps(_objectSpread({}, el.benefit), {
                discount: discount && _objectSpreadProps(_objectSpread({}, discount), {
                    flat
                })
            })
        });
    });
    return promotions.filter((promo)=>{
        const isTypeProduct = promo.type === "product";
        const isApplyOnProduct = promo.applyOn === PromotionApplyOnEnum.product;
        const isDefault = promo.isDefault;
        return isTypeProduct && isApplyOnProduct && !isDefault;
    }).filter((promo)=>{
        if (promo.endTimestampSec) {
            return !isExpired(promo.endTimestampSec);
        }
        return true;
    });
};
const getImagesFromProduct = (product)=>{
    var ref, ref1;
    if (!!(product === null || product === void 0 ? void 0 : (ref = product.productDetail) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return product.productDetail.images.map((image)=>{
            var ref;
            return {
                src: image.url || "",
                alt: image.label || ((ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.displayName) || ""
            };
        });
    }
    if (!!product.productInfo.imageUrl) {
        var ref2;
        return [
            {
                src: product.productInfo.imageUrl,
                alt: ((ref2 = product.productInfo) === null || ref2 === void 0 ? void 0 : ref2.displayName) || ""
            }, 
        ];
    }
    return [];
};
const getVideosFromProduct = (product)=>{
    var ref, ref1;
    if (!!(product === null || product === void 0 ? void 0 : (ref = product.productDetail) === null || ref === void 0 ? void 0 : (ref1 = ref.videos) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        return product.productDetail.videos;
    }
    return [];
};
//#region
const convertProductDetail = (product)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    const status = convertProductStatus((product === null || product === void 0 ? void 0 : product.status) || {
        sellingCode: "",
        sellable: false
    });
    const productGroup = product.productDetail.productGroup || {};
    const variants = productGroup.variants || [];
    const configurations = productGroup.configurations || [];
    const sortedVariants = sortVariant(variants, configurations);
    const selected = ((ref = sortedVariants.find((variant)=>variant.sku === product.productInfo.sku)) === null || ref === void 0 ? void 0 : ref.attributeValues) || [];
    const convertedConfiguration = sortedVariants && convertConfigurations(variants, configurations, product.productInfo.sku);
    const validatedConfiguration = convertedConfiguration && validateVisibleVariant(selected, sortedVariants, convertedConfiguration);
    let selectionPromotions = product.selectionPromotions || [];
    if (!(product === null || product === void 0 ? void 0 : (ref1 = product.selectionPromotions) === null || ref1 === void 0 ? void 0 : ref1.length)) {
        selectionPromotions = product.promotions.filter((el)=>{
            var ref;
            return !el.isDefault && el.applyOn === "product" && !(el === null || el === void 0 ? void 0 : (ref = el.condition) === null || ref === void 0 ? void 0 : ref.coupon);
        });
    }
    const attributes = [];
    const newProduct = {
        sku: product.productInfo.sku,
        sellerSku: product.productInfo.sellerSku,
        flashSale: convertFlashSale(product.flashSales || []),
        status: product.status,
        images: getImagesFromProduct(product),
        videos: getVideosFromProduct(product),
        title: _objectSpread({
            name: product.productInfo.displayName || product.productInfo.name
        }, status && {
            status: {
                value: status.status,
                color: status.color
            }
        }),
        cookingRecipes: product.cookingRecipes,
        name: product.productInfo.displayName || product.productInfo.name,
        displayName: product.productInfo.displayName || product.productInfo.name,
        price: _objectSpread({
            terminalPrice: product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.terminalPrice,
            supplierRetailPrice: product === null || product === void 0 ? void 0 : (ref4 = product.prices) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.supplierRetailPrice,
            sellPrice: product === null || product === void 0 ? void 0 : (ref6 = product.prices) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.sellPrice,
            priceWithoutSelectionPromotion: product.priceWithoutSelectionPromotion,
            discountAmount: +(product === null || product === void 0 ? void 0 : (ref8 = product.prices) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.discountAmount)
        }, convertPrice(product)),
        seoInfo: product === null || product === void 0 ? void 0 : (ref10 = product.productDetail) === null || ref10 === void 0 ? void 0 : ref10.seoInfo,
        brand: product.productInfo.brand,
        brands: product.productInfo.brands || [],
        breadcrumbs: (ref11 = product.productInfo.breadcrumbs) === null || ref11 === void 0 ? void 0 : ref11.map((item)=>({
                name: item.label,
                link: item.url
            })),
        attributeGroups: product.productDetail.attributeGroups,
        attributes,
        needManageStock: product.totalAvailable !== null,
        totalAvailable: product.totalAvailable,
        selectionPromotions: product.selectionPromotions || getSelectionPromotions(product),
        categories: product.productInfo.categories,
        masterCategories: product.productInfo.masterCategories,
        attributeSet: product.productDetail.attributeSet,
        defaultPromotions: product.defaultPromotions || getDefaultPromotions(product),
        productGroup: !!product.productDetail.productGroup ? _objectSpreadProps(_objectSpread({}, product.productDetail.productGroup), {
            variants: sortedVariants || [],
            configurations: validatedConfiguration || []
        }) : undefined,
        orderCouponPromotions: (product.promotions || []).filter((el)=>el.applyOn === "order" && !el.isDefault),
        partOrderPromotions: (product.promotions || []).filter((el)=>el.applyOn === "part_order" && el.isDefault && !!el.condition.coupon),
        provider: product.provider,
        seller: product.productInfo.seller,
        selected,
        isBundle: false,
        tags: product.productInfo.tags,
        save: Number(product === null || product === void 0 ? void 0 : (ref12 = product.prices) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.discountAmount) || 0,
        saveWithoutSelectionPromotion: product.priceWithoutSelectionPromotion ? Number((product === null || product === void 0 ? void 0 : (ref14 = product.prices) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.supplierRetailPrice) || 0) - product.priceWithoutSelectionPromotion : Number(product === null || product === void 0 ? void 0 : (ref16 = product.prices) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.discountAmount),
        selectPromotionId: selectionPromotions === null || selectionPromotions === void 0 ? void 0 : (ref18 = selectionPromotions[0]) === null || ref18 === void 0 ? void 0 : ref18.id,
        isAlcoholicCategory: product.isAlcoholicCategory,
        uomName: product.productInfo.uomName,
        uomRatio: product.productInfo.uomRatio,
        uomCode: product.productInfo.uomCode,
        clearanceTypeDescription: product === null || product === void 0 ? void 0 : (ref19 = product.productDetail) === null || ref19 === void 0 ? void 0 : ref19.clearanceTypeDescription,
        productOptions: product.productOptions,
        barcode: product.productInfo.barcode
    };
    if (newProduct.price.price === newProduct.price.listedPrice) {
        newProduct.price.listedPrice = undefined;
    }
    return newProduct;
};
///#endregion
const isValidPrice = (product)=>{
    var ref, ref1, ref2, ref3;
    const sellPrice = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sellPrice;
    const latestPrice = product === null || product === void 0 ? void 0 : (ref2 = product.prices) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.latestPrice;
    if (sellPrice === null || latestPrice === null) return false;
    const sellPriceNumber = Number(sellPrice);
    const latestPriceNumber = Number(latestPrice);
    if (isNaN(sellPriceNumber) || isNaN(latestPriceNumber)) return false;
    return sellPriceNumber > 0 && latestPriceNumber >= 0;
};
const getDisplayPrice = (discoveryPrice, isFlashSale)=>{
    let priceRange;
    const minLatestPrice = parseFloat(discoveryPrice.minLatestPrice);
    const maxLatestPrice = parseFloat(discoveryPrice.maxLatestPrice);
    const latestPrice = parseFloat(discoveryPrice.latestPrice);
    if (!isNaN(minLatestPrice) && !isNaN(maxLatestPrice) && !isNaN(latestPrice)) {
        if (minLatestPrice !== 0 && maxLatestPrice !== 0 && (minLatestPrice !== latestPrice || maxLatestPrice !== latestPrice)) {
            priceRange = {
                min: minLatestPrice,
                max: maxLatestPrice
            };
        }
    }
    return (0,dist_index_es.cleanObject)({
        latestPrice: +discoveryPrice.latestPrice,
        supplierRetailPrice: discoveryPrice.discountPercent ? +discoveryPrice.supplierRetailPrice : undefined,
        discountPercent: discoveryPrice.discountPercent && !isFlashSale ? "-".concat(discoveryPrice.discountPercent, "%") : undefined,
        discountAmount: +discoveryPrice.discountAmount > 0 && !isFlashSale ? +discoveryPrice.discountAmount : undefined,
        priceRange
    });
};
class ProductHelper {
    hasGift(promotions) {
        let items = [];
        promotions.forEach((promotion)=>{
            if (Array.isArray(promotion.benefit.gifts)) {
                var ref;
                items = items.concat((promotion === null || promotion === void 0 ? void 0 : (ref = promotion.benefit) === null || ref === void 0 ? void 0 : ref.gifts) || []);
            }
        });
        return !!items.length;
    }
    convertProductDetail(product) {
        return convertProductDetail(product);
    }
    constructor(milestoneShippingFee){
        this.convertNewProductCard = (product, options)=>{
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            const { productInfo , promotions , totalAvailable , prices , flashSales , status , pos365StockInfo , productDetail ,  } = product;
            const { frames , cartV2 , showUom , contactLink , showCtaButton , showCtaButtons , showCtaButtonsRelevantProducts , showNewProductGift , wishlistButton , bestComboDiscount , benefitLabel , relatedProductHook ,  } = options || {};
            const gifts = [];
            let hasGift = false;
            let freeship = false;
            const productPrice = prices.length ? prices === null || prices === void 0 ? void 0 : prices[0] : undefined;
            // Hiển thị icon freeship nếu đơn hàng lớn hơn hoặc bằng milestoneShippingFee
            if (typeof this.milestoneShippingFee === "number" && this.milestoneShippingFee >= 0 && (productPrice === null || productPrice === void 0 ? void 0 : productPrice.latestPrice) && Number(productPrice === null || productPrice === void 0 ? void 0 : productPrice.latestPrice) >= this.milestoneShippingFee) freeship = true;
            promotions.forEach((el)=>{
                var ref;
                if (el.isDefault && el.applyOn === PromotionApplyOnEnum.product && ((el === null || el === void 0 ? void 0 : (ref = el.benefit) === null || ref === void 0 ? void 0 : ref.gifts) || []).length) {
                    var ref1;
                    hasGift = true;
                    gifts.push(...((el === null || el === void 0 ? void 0 : (ref1 = el.benefit) === null || ref1 === void 0 ? void 0 : ref1.gifts) || []).map((item)=>({
                            src: item.imageUrl,
                            alt: item.name,
                            sku: item.sku,
                            quantity: item.quantity
                        })));
                }
            });
            const optionPromotions = promotions.filter((el)=>!el.isDefault && el.applyOn === PromotionApplyOnEnum.product);
            const selectPromotionId = (ref = optionPromotions[0]) === null || ref === void 0 ? void 0 : ref.id;
            if (optionPromotions.length && optionPromotions[0] && ((ref1 = optionPromotions[0].benefit) === null || ref1 === void 0 ? void 0 : ref1.gifts.length)) {
                var ref8;
                hasGift = true;
                gifts.push(...(((ref8 = optionPromotions[0].benefit) === null || ref8 === void 0 ? void 0 : ref8.gifts) || []).map((item)=>({
                        src: item.imageUrl,
                        alt: item.name,
                        sku: item.sku,
                        quantity: item.quantity
                    })));
            }
            let flashSale;
            let isFlashSale = false;
            const flSale = flashSales[0];
            if (flashSales.length) {
                isFlashSale = true;
                const availableToFlSale = product.totalAvailable === null ? flSale.totalCount - flSale.usedCount : Math.min(flSale.totalCount - flSale.usedCount, product.totalAvailable);
                flashSale = (0,dist_index_es.cleanObject)({
                    endAt: parseInt(flSale.endTimestampSec) * 1000,
                    text: availableToFlSale > 0 ? (0,i18n.t)("C\xf2n lại {{var0}}", {
                        var0: availableToFlSale
                    }) : (0,i18n.t)("Ch\xe1y h\xe0ng"),
                    discountPercent: typeof (productPrice === null || productPrice === void 0 ? void 0 : productPrice.discountPercent) === "number" ? Math.round(productPrice === null || productPrice === void 0 ? void 0 : productPrice.discountPercent) : undefined
                });
            }
            const showContact = typeof product.totalAvailable === "number" && product.totalAvailable <= 0 || !isValidPrice(product) || !(product === null || product === void 0 ? void 0 : (ref2 = product.status) === null || ref2 === void 0 ? void 0 : ref2.sellable);
            let addToCart;
            let ctaButton;
            let ctaButtons;
            let contactButton;
            if (cartV2) {
                const currentOrderLine = cartV2.flattenItems.find((item)=>{
                    var ref;
                    return item.sku === productInfo.sku && ((ref = item.allowedUserActions) === null || ref === void 0 ? void 0 : ref.includes(types_es/* AllowedUserActionItem.CHANGE_QUANTITY */.rV.CHANGE_QUANTITY));
                });
                const optionPromotions1 = promotions.filter((el)=>!el.isDefault && el.applyOn === PromotionApplyOnEnum.product && el.type === "product");
                const quantityInCart = currentOrderLine && currentOrderLine.quantity || 0;
                addToCart = {
                    onAddToCart: async function() {
                        let quantity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                        var ref, ref1;
                        const res = await cartV2.onAddSingleItem({
                            sku: productInfo.sku,
                            sellerSku: productInfo.sellerSku,
                            quantity: quantity,
                            promotionId: (ref = optionPromotions1[0]) === null || ref === void 0 ? void 0 : ref.id
                        }, true);
                        const { trackAddToCart , AddToCartType  } = await __webpack_require__.e(/* import() */ 84601).then(__webpack_require__.bind(__webpack_require__, 759525));
                        const trackAddToCartParams = {
                            product: {
                                sku: productInfo.sellerSku,
                                name: productInfo.name,
                                brand: productInfo.brand,
                                categories: productInfo.categories,
                                price: parseInt(prices === null || prices === void 0 ? void 0 : prices[0].supplierRetailPrice),
                                addToCartPrice: parseFloat(product.prices[0].latestPrice || ""),
                                sellerSku: productInfo.sellerSku
                            },
                            selectedPromotionId: (ref1 = optionPromotions1[0]) === null || ref1 === void 0 ? void 0 : ref1.id,
                            type: AddToCartType.ADDTOCART
                        };
                        if (res) {
                            trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                                status: "success",
                                cartId: res.id
                            }));
                        } else {
                            trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                                status: "failed"
                            }));
                        }
                    },
                    onIncrease: async ()=>{
                        if (currentOrderLine) {
                            await cartV2.onIncrease(currentOrderLine);
                        }
                    },
                    onDecrease: async ()=>{
                        if (currentOrderLine) {
                            if (quantityInCart <= 1) {
                                await cartV2.onRemoveItem(currentOrderLine);
                            } else {
                                await cartV2.onDecrease(currentOrderLine);
                            }
                        }
                    },
                    onRemoveItem: async ()=>{
                        if (currentOrderLine) {
                            await cartV2.onRemoveItem(currentOrderLine);
                        }
                    },
                    onChangeQuantity: async (newQuantity)=>{
                        if (currentOrderLine) {
                            await cartV2.onChangeQuantity(currentOrderLine, newQuantity);
                        }
                    },
                    quantityInCart
                };
            }
            if (!showContact) {
                ctaButton = _objectSpread({
                    children: (0,i18n.t)("Th\xeam v\xe0o giỏ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        addToCart === null || addToCart === void 0 ? void 0 : addToCart.onAddToCart();
                    }
                } : {});
                // ctaButtons
                ctaButtons === null || ctaButtons === void 0 ? void 0 : ctaButtons.push(_objectSpread({
                    children: (0,i18n.t)("Th\xeam v\xe0o giỏ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        addToCart === null || addToCart === void 0 ? void 0 : addToCart.onAddToCart();
                    }
                } : {}));
            } else {
                if (contactLink) contactButton = _objectSpread({
                    children: (0,i18n.t)("Li\xean hệ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        window.open(contactLink);
                    }
                } : {});
                else ctaButton = {
                    children: (0,i18n.t)("Hết h\xe0ng"),
                    variant: "default",
                    disabled: true
                };
                // ctaButtons
                showCtaButtonsRelevantProducts ? ctaButtons === null || ctaButtons === void 0 ? void 0 : ctaButtons.push({
                    children: contactLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                        variant: "ghost",
                        size: "s",
                        block: true,
                        padding: "s0",
                        onClick: ()=>window.open(contactLink),
                        style: {
                            border: "none",
                            width: "min-content",
                            minWidth: "min-content"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactOutlined_es/* ContactOutlined */.B, {
                            size: 16,
                            color: "#0200BC"
                        })
                    }) : null
                }, _objectSpread({
                    children: (0,i18n.t)("Sản phẩm tương tự"),
                    variant: "secondary",
                    style: {
                        padding: "0px 4px"
                    }
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        var ref;
                        e.preventDefault();
                        relatedProductHook === null || relatedProductHook === void 0 ? void 0 : (ref = relatedProductHook.setSelectedProduct) === null || ref === void 0 ? void 0 : ref.call(relatedProductHook, productInfo);
                        (0,polyfill_es/* requestIdleCallback */.Kk)(()=>{
                            return (0,cart_es/* trackManually */.gu)("viewSimilarProducts", "productCard", "relatedProductList", JSON.stringify({
                                sku: productInfo === null || productInfo === void 0 ? void 0 : productInfo.sku
                            }));
                        });
                    }
                } : {})) : contactLink ? ctaButtons === null || ctaButtons === void 0 ? void 0 : ctaButtons.push(_objectSpread({
                    children: (0,i18n.t)("Li\xean hệ"),
                    variant: "secondary"
                }, (0,helpers/* isServerless */.ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        window.open(contactLink);
                    }
                } : {})) : ctaButtons === null || ctaButtons === void 0 ? void 0 : ctaButtons.push({
                    children: (0,i18n.t)("Hết h\xe0ng"),
                    variant: "default",
                    disabled: true
                });
            }
            let titleTag;
            const isOutOfStock = typeof product.totalAvailable === "number" && product.totalAvailable <= 0;
            if (isOutOfStock) {
                titleTag = {
                    variant: "link",
                    content: contactLink ? (0,i18n.t)("Li\xean hệ đặt h\xe0ng") : (0,i18n.t)("Hết h\xe0ng")
                };
            }
            const price = convertPrice(product);
            if (!(price === null || price === void 0 ? void 0 : price.price)) {
                titleTag = {
                    variant: "pending",
                    content: (0,i18n.t)("Li\xean hệ")
                };
            }
            const infoTags = [];
            if (status && status.sellingCode === "hang_khac") {
                infoTags.push({
                    content: (0,i18n.t)("H\xe0ng qu\xe0 tặng"),
                    variant: "default"
                });
            }
            const quantity = totalAvailable === null ? 1000 : isFlashSale ? Math.min(flSale.totalCount - flSale.usedCount, totalAvailable) : totalAvailable;
            const { name , code  } = (productInfo === null || productInfo === void 0 ? void 0 : productInfo.brand) || {
                name: "",
                code: ""
            };
            return _objectSpreadProps(_objectSpread(_objectSpreadProps(_objectSpread({
                sku: productInfo.sku,
                sellerSku: productInfo.sellerSku,
                name: productInfo.displayName || productInfo.name,
                imageUrl: productInfo.imageUrl,
                price: productPrice ? getDisplayPrice(productPrice, isFlashSale) : undefined,
                stockQuantity: quantity,
                warranty: ((ref3 = productInfo.warranty) === null || ref3 === void 0 ? void 0 : ref3.months) ? {
                    months: (ref4 = productInfo.warranty) === null || ref4 === void 0 ? void 0 : ref4.months
                } : undefined,
                freeship,
                flashSale: flashSale,
                addToCart,
                frame: (frames === null || frames === void 0 ? void 0 : frames.length) ? (0,products/* getFrame */.$)(productInfo.tags, frames || []) : undefined,
                hasGift,
                titleTag,
                infoTags,
                link: {
                    as: {
                        pathname: "/".concat(product === null || product === void 0 ? void 0 : (ref5 = product.productInfo) === null || ref5 === void 0 ? void 0 : ref5.canonical),
                        query: (product === null || product === void 0 ? void 0 : (ref6 = product.productInfo) === null || ref6 === void 0 ? void 0 : ref6.canonical) && (0,products/* isVariantUrlGrouped */.X)(product.productInfo.canonical) ? {
                            sku: productInfo.sku
                        } : {}
                    },
                    href: {
                        pathname: ScreenContext/* PRODUCT_DETAIL_PAGE */.uE,
                        query: {
                            sku: productInfo.sku
                        }
                    },
                    passHref: true
                },
                brand: {
                    name: name,
                    code
                },
                ctaButton: showCtaButton ? ctaButton : undefined,
                ctaButtons: showCtaButtons ? ctaButtons : undefined,
                contactButton
            }, showUom && {
                uom: productInfo.uomName
            }, pos365StockInfo), {
                showContact: isOutOfStock || !isValidPrice(product) || !(product === null || product === void 0 ? void 0 : (ref7 = product.status) === null || ref7 === void 0 ? void 0 : ref7.sellable)
            }), gifts.length > 0 && {
                gifts: {
                    label: (0,i18n.t)("QU\xc0 TẶNG"),
                    images: gifts
                }
            }), {
                selectPromotionId,
                categories: (productInfo === null || productInfo === void 0 ? void 0 : productInfo.categories) || [],
                isAlcoholicCategory: (product === null || product === void 0 ? void 0 : product.isAlcoholicCategory) || (0,confirm18YearsOld/* isAdultCategoryProduct */.C2)(productInfo === null || productInfo === void 0 ? void 0 : productInfo.categories),
                showNewProductGift,
                attributeGroups: productDetail === null || productDetail === void 0 ? void 0 : productDetail.attributeGroups,
                wishlistButton,
                bestComboDiscount: bestComboDiscount || undefined,
                benefitLabel: benefitLabel || undefined
            });
        };
        this.milestoneShippingFee = milestoneShippingFee;
    }
}
const productHelper = new ProductHelper();
const getSearchVariables = (param)=>{
    let { query , pos365StoreCode , location , returnFilter =true  } = param;
    const defaultVariables = _objectSpreadProps(_objectSpread({
        itemsPerPage: search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9,
        location
    }, query), {
        page: query.page || 1
    });
    if (pos365StoreCode) {
        defaultVariables.pos365StoreCode = pos365StoreCode;
    }
    if (returnFilter) {
        defaultVariables.returnFilterable = [
            "FILTER_TYPE_BRAND",
            "FILTER_TYPE_PRICE",
            "FILTER_TYPE_ATTRIBUTE",
            "FILTER_TYPE_CLEARANCE", 
        ];
    }
    return defaultVariables;
};
const convertPrice = (product)=>{
    var ref, ref1;
    const { prices  } = product;
    const price = parseInt(prices === null || prices === void 0 ? void 0 : (ref = prices[0]) === null || ref === void 0 ? void 0 : ref.latestPrice);
    const supplierRetailPrice = parseInt(prices === null || prices === void 0 ? void 0 : (ref1 = prices[0]) === null || ref1 === void 0 ? void 0 : ref1.supplierRetailPrice);
    const listedPrice = price > supplierRetailPrice ? null : supplierRetailPrice;
    const discount = listedPrice ? getDiscountPercent(price, listedPrice) : undefined;
    return {
        price: isNaN(price) ? undefined : price,
        listedPrice: listedPrice !== null && listedPrice !== void 0 ? listedPrice : undefined,
        discount: discount
    };
};
const getDiscountPercent = (finalPrice, oldPrice)=>{
    let discount = 0;
    if (oldPrice) {
        discount = 100 - Math.round(finalPrice * 100 / oldPrice);
    }
    return discount;
};
class DiscoveryHelper {
    /**
   * @discovery_v2
   *- clean discovery search product data
   *- convert to product card props
   */ cleanupDiscoveryV2SearchProduct(product, configs, omitKeys) {
        var ref, ref1, ref2, ref3;
        const { frames , cartV2 , hideHighlightAttribute  } = configs || {};
        const { isDisplayUom: showUom , isAllowATCFromListing: showCtaButton , contactLink , epicOmni1286 , showNewProductGift , numberDisplayFormat , uomCodeToDisplayDecimalQuantity , epicOmni1550 ,  } = this.tenantConfig;
        const getProductPrice = ()=>{
            const minLatestPrice = product.minLatestPrice ? parseFloat(product.minLatestPrice) : undefined;
            const maxLatestPrice = product.maxLatestPrice ? parseFloat(product.maxLatestPrice) : undefined;
            return (0,dist_index_es.cleanObject)(_objectSpread({
                latestPrice: Number(product.latestPrice) || undefined,
                supplierRetailPrice: parseInt(product.supplierRetailPrice || "0"),
                discountAmount: // not display save... incase there is config flash sale
                !parseInt(product.promotionEndTime || "0") && product.discountAmount ? parseInt(product.discountAmount) : undefined,
                discountPercent: product.discountPercent ? numberDisplayFormat ? "-".concat(product.discountPercent, "%").replace(".", numberDisplayFormat.decimalSeparator) : "-".concat(product.discountPercent, "%") : ""
            }, minLatestPrice && maxLatestPrice && minLatestPrice !== maxLatestPrice ? {
                priceRange: {
                    min: minLatestPrice,
                    max: maxLatestPrice
                }
            } : {}));
        };
        const price = getProductPrice();
        const getTitleTag = ()=>{
            const isOutOfStock = typeof product.totalAvailable === "number" && product.totalAvailable <= 0;
            if (isOutOfStock) {
                return {
                    variant: "link",
                    content: contactLink ? (0,i18n.t)("Li\xean hệ đặt h\xe0ng") : (0,i18n.t)("Hết h\xe0ng")
                };
            }
            if (!price.latestPrice) {
                return {
                    variant: "pending",
                    content: (0,i18n.t)("Li\xean hệ")
                };
            }
        };
        var _totalAvailable;
        const quantity = (_totalAvailable = product.totalAvailable) !== null && _totalAvailable !== void 0 ? _totalAvailable : 1000;
        const showContact = typeof product.totalAvailable === "number" && product.totalAvailable <= 0 || !price.latestPrice || !product.sellable;
        const getContactButton = ()=>{
            if (cartV2 && contactLink && showContact) return _objectSpread({
                children: (0,i18n.t)("Li\xean hệ"),
                variant: "secondary"
            }, (0,helpers/* isServerless */.ep)() ? {
                onClick: (e)=>{
                    e.preventDefault();
                    window.open(contactLink);
                }
            } : {});
        };
        const result = _objectSpreadProps(_objectSpread({
            sku: product.sku || "",
            sellerSku: product.sellerSku || "",
            name: product.name || "",
            imageUrl: product.imageUrl || "",
            price: price,
            stockQuantity: quantity,
            selectPromotionId: product.selectedPromotionId,
            freeship: typeof this._productHelper.milestoneShippingFee === "number" && this._productHelper.milestoneShippingFee >= 0 && ((price === null || price === void 0 ? void 0 : price.latestPrice) || 0) > 0 && Number(price === null || price === void 0 ? void 0 : price.latestPrice) >= this._productHelper.milestoneShippingFee,
            frame: (frames === null || frames === void 0 ? void 0 : frames.length) ? (0,products/* getFrame */.$)(product.tags || [], frames || []) : undefined,
            hasGift: (((ref = product.gifts) === null || ref === void 0 ? void 0 : ref.length) || 0) > 0,
            showNewProductGift,
            titleTag: showCtaButton ? undefined : getTitleTag(),
            link: {
                as: {
                    pathname: "/".concat(product === null || product === void 0 ? void 0 : product.canonical),
                    query: (0,products/* isVariantUrlGrouped */.X)(product.canonical || "") ? {
                        sku: product.sku
                    } : {}
                },
                href: {
                    pathname: ScreenContext/* PRODUCT_DETAIL_PAGE */.uE,
                    query: {
                        sku: product.sku
                    }
                },
                passHref: true
            },
            brand: {
                name: product.brandName || "",
                code: ((ref1 = product.brandCode) === null || ref1 === void 0 ? void 0 : ref1.toString()) || ""
            }
        }, showUom ? {
            uom: product.uomName
        } : {}), {
            contactButton: showCtaButton ? getContactButton() : undefined,
            gifts: ((ref2 = product.gifts) === null || ref2 === void 0 ? void 0 : ref2.length) ? {
                label: (0,i18n.t)("QU\xc0 TẶNG"),
                images: (ref3 = product.gifts) === null || ref3 === void 0 ? void 0 : ref3.map((gift)=>({
                        src: gift.imageUrl || "",
                        alt: gift.name || "",
                        sku: "",
                        quantity: gift.quantity
                    }))
            } : undefined,
            flashSale: parseInt(product.promotionEndTime || "0") ? (0,dist_index_es.cleanObject)({
                endAt: parseInt(product.promotionEndTime || "0") * 1000,
                text: (product.totalAvailable || 0) > 0 ? (0,i18n.t)("C\xf2n lại {{var0}}", {
                    var0: product.totalAvailable
                }) : (0,i18n.t)("Ch\xe1y h\xe0ng"),
                discountPercent: Math.round((product === null || product === void 0 ? void 0 : product.discountPercent) || 0),
                endTimestampSec: product.promotionEndTime
            }) : undefined,
            isAlcoholicCategory: product.isAdult,
            showContact: showContact,
            bestComboDiscount: epicOmni1286 ? product.bestComboDiscount : undefined,
            benefitLabel: product.benefitLabel,
            numberDisplayFormat,
            highlight: hideHighlightAttribute ? undefined : product.highlight,
            precisionToDisplayDecimalQuantity: uomCodeToDisplayDecimalQuantity === product.uomCode ? 3 : 0,
            materials: product.materials,
            averageRating: epicOmni1550 ? product.averageRating : undefined,
            categories: product.categories
        });
        const productResult = (0,utils_es/* omit */.CE)(result, omitKeys || []);
        return (0,dist_index_es.cleanObject)(productResult);
    }
    constructor(tenantConfig){
        this.tenantConfig = tenantConfig;
        this._productHelper = new ProductHelper(tenantConfig.freeShippingThreshold);
    }
}
/**
 * don't use this function in swr fetcher
 * because cartState sometimes be updated
 */ const createHandleEventAndCtaButton = (product, configs)=>{
    const { cartV2 , buildPCV2 , contactLink , showCtaButton , showCtaButtons , showCtaButtonsWithQuantity , showCtaButtonsRelevantProducts , isMobile =false , enableTrackOpenInNewTab =true , wishlistButton , relatedProductHook ,  } = configs || {};
    const getAddToCart = ()=>{
        if (cartV2) {
            const currentOrderLine = cartV2.flattenItems.find((item)=>{
                var ref;
                return item.sku === product.sku && ((ref = item.allowedUserActions) === null || ref === void 0 ? void 0 : ref.includes(types_es/* AllowedUserActionItem.CHANGE_QUANTITY */.rV.CHANGE_QUANTITY));
            });
            const quantityInCart = currentOrderLine && currentOrderLine.quantity || 0;
            if (!(0,helpers/* isServerless */.ep)()) return;
            return {
                onAddToCart: async function() {
                    let quantity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                    var ref, ref1, ref2;
                    const res = await cartV2.onAddSingleItem({
                        sku: product.sku || "",
                        sellerSku: product.sellerSku,
                        quantity: quantity,
                        promotionId: product.selectPromotionId !== 0 ? product.selectPromotionId : undefined
                    }, true);
                    const { trackAddToCart , AddToCartType  } = await __webpack_require__.e(/* import() */ 84601).then(__webpack_require__.bind(__webpack_require__, 759525));
                    const trackAddToCartParams = {
                        product: {
                            sku: product.sellerSku || "",
                            name: product.name || "",
                            price: (ref = product.price) === null || ref === void 0 ? void 0 : ref.latestPrice,
                            brand: {
                                name: ((ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name) || ""
                            },
                            addToCartPrice: ((ref2 = product.price) === null || ref2 === void 0 ? void 0 : ref2.supplierRetailPrice) || 0,
                            sellerSku: product.sellerSku
                        },
                        selectedPromotionId: product.selectPromotionId,
                        type: AddToCartType.ADDTOCART,
                        status: res ? "success" : "failed"
                    };
                    trackAddToCart(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                        cartId: res ? res.id : undefined
                    }));
                },
                onIncrease: async ()=>{
                    if (currentOrderLine) {
                        await cartV2.onIncrease(currentOrderLine);
                    }
                },
                onDecrease: async ()=>{
                    if (currentOrderLine) {
                        if (quantityInCart <= 1) {
                            await cartV2.onRemoveItem(currentOrderLine);
                        } else {
                            await cartV2.onDecrease(currentOrderLine);
                        }
                    }
                },
                onRemoveItem: async ()=>{
                    if (currentOrderLine) {
                        await cartV2.onRemoveItem(currentOrderLine);
                    }
                },
                onChangeQuantity: async (newQuantity)=>{
                    if (currentOrderLine) {
                        await cartV2.onChangeQuantity(currentOrderLine, newQuantity, false);
                    }
                },
                quantityInCart
            };
        }
    };
    const getCtaButton = ()=>{
        if (!product.showContact) return _objectSpread({
            children: (0,i18n.t)("Th\xeam v\xe0o giỏ"),
            variant: "secondary"
        }, (0,helpers/* isServerless */.ep)() ? {
            onClick: (e)=>{
                e.preventDefault();
                addToCart === null || addToCart === void 0 ? void 0 : addToCart.onAddToCart();
            }
        } : {});
        else {
            if (contactLink) return _objectSpread({
                children: (0,i18n.t)("Li\xean hệ"),
                variant: "secondary"
            }, (0,helpers/* isServerless */.ep)() ? {
                onClick: (e)=>{
                    e.preventDefault();
                    window.open(contactLink);
                }
            } : {});
            else return {
                children: (0,i18n.t)("Hết h\xe0ng"),
                variant: "default",
                disabled: true
            };
        }
    };
    const getCtaButtons = ()=>{
        var ref;
        const ctaButtons = [];
        const quantityInCart = (ref = getAddToCart()) === null || ref === void 0 ? void 0 : ref.quantityInCart;
        if (!!product.showContact) {
            showCtaButtonsRelevantProducts ? ctaButtons.push({
                children: contactLink ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                            variant: "ghost",
                            size: "s",
                            block: true,
                            padding: "s0",
                            onClick: ()=>window.open(contactLink),
                            style: {
                                border: "none",
                                width: "min-content",
                                minWidth: "min-content"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactOutlined_es/* ContactOutlined */.B, {
                                size: 16,
                                color: "#0200BC"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                    ]
                }) : null
            }, _objectSpread({
                children: (0,i18n.t)("Sản phẩm tương tự"),
                variant: "secondary",
                style: {
                    padding: "0px 4px"
                }
            }, (0,helpers/* isServerless */.ep)() ? {
                onClick: (e)=>{
                    var ref;
                    e.preventDefault();
                    relatedProductHook === null || relatedProductHook === void 0 ? void 0 : (ref = relatedProductHook.setSelectedProduct) === null || ref === void 0 ? void 0 : ref.call(relatedProductHook, product);
                    (0,polyfill_es/* requestIdleCallback */.Kk)(()=>{
                        return (0,cart_es/* trackManually */.gu)("viewSimilarProducts", "productCard", "relatedProductList", JSON.stringify({
                            sku: product === null || product === void 0 ? void 0 : product.sku
                        }));
                    });
                }
            } : {})) : contactLink ? ctaButtons.push(_objectSpread({
                children: (0,i18n.t)("Li\xean hệ"),
                variant: "secondary"
            }, (0,helpers/* isServerless */.ep)() ? {
                onClick: (e)=>{
                    e.preventDefault();
                    window.open(contactLink);
                }
            } : {})) : ctaButtons.push({
                children: (0,i18n.t)("Hết h\xe0ng"),
                variant: "default",
                disabled: true
            });
        } else {
            ctaButtons.push({
                children: !!showCtaButtonsWithQuantity ? isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    variant: "secondary",
                    size: "s",
                    block: true,
                    padding: "s0",
                    onClick: ()=>{
                        return buildPCV2 === null || buildPCV2 === void 0 ? void 0 : buildPCV2.onUpdateConfig(product);
                    },
                    width: "100%",
                    children: (0,i18n.t)("Sửa cấu h\xecnh")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_es/* Tooltip */.u, {
                    title: (0,i18n.t)("Sửa cấu h\xecnh"),
                    placement: "top",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                        variant: "secondary",
                        size: "s",
                        block: true,
                        padding: "s0",
                        onClick: ()=>{
                            return buildPCV2 === null || buildPCV2 === void 0 ? void 0 : buildPCV2.onUpdateConfig(product);
                        },
                        maxWidth: "40px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined_es/* EditOutlined */.p, {
                            style: {
                                minWidth: "max-content",
                                margin: "0 1.25rem"
                            }
                        })
                    })
                }) : null
            }, {
                children: (quantityInCart !== null && quantityInCart !== void 0 ? quantityInCart : 0) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    variant: // Display secondary for product cart not in buildPc
                    showCtaButtonsRelevantProducts && !showCtaButtonsWithQuantity ? "secondary" : "primary",
                    size: "s",
                    block: true,
                    padding: "s0",
                    onClick: (e)=>{
                        e.preventDefault();
                        addToCart === null || addToCart === void 0 ? void 0 : addToCart.onAddToCart();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Caption */.YS, {
                        level: 2,
                        line: 1,
                        children: (0,i18n.t)("Th\xeam v\xe0o giỏ")
                    })
                }) : null
            });
        }
        return ctaButtons;
    };
    const addToCart = showCtaButton || showCtaButtons ? getAddToCart() : undefined;
    const ctaButton = showCtaButton ? getCtaButton() : undefined;
    const ctaButtons = showCtaButtons ? getCtaButtons() : undefined;
    const contactButton = showCtaButton ? product.contactButton : undefined;
    const onWrapperAuxClick = !!enableTrackOpenInNewTab && !isMobile ? (event)=>{
        // check if button click is middle mouse button
        if (event.button === 1) {
            (0,helper_es/* trackCustomEvent */.I)("openInNewTab", {
                action: "middleClick",
                property: "productCard"
            });
        }
    } : undefined;
    const onWrapperClick = !!enableTrackOpenInNewTab && !isMobile ? (event)=>{
        // check if button click is left mouse button & ctrl key (Windows or Linux) or cmd key (Mac) is pressed
        if ((!!event.ctrlKey || !!event.metaKey) && event.buttons === 0) {
            (0,helper_es/* trackCustomEvent */.I)("openInNewTab", {
                action: !!event.ctrlKey ? "ctrlClick" : "cmdClick",
                property: "productCard"
            });
        }
    } : undefined;
    return _objectSpreadProps(_objectSpread({}, product), {
        ctaButton,
        ctaButtons,
        wishlistButton,
        addToCart,
        contactButton,
        showCtaButtonsWithQuantity,
        showCtaButtonsRelevantProducts,
        onWrapperAuxClick,
        onWrapperClick
    });
};
// helpers for search page
const convertDiscoveryFilter = (filters, displayFilterTypeCategory)=>{
    var ref, // attributes
    ref1, ref2, ref3;
    if (!filters) return [];
    const convertedFilters = [];
    // brands
    if ((ref = filters.brands) === null || ref === void 0 ? void 0 : ref.length) {
        convertedFilters.push({
            code: "brands",
            name: "Thương hiệu",
            options: filters.brands.map((brand)=>({
                    filterId: null,
                    filterCode: "brands",
                    optionId: brand.code || null,
                    optionName: brand.name || "",
                    selected: brand.selected || false
                }))
        });
    }
    (ref1 = filters.attributes) === null || ref1 === void 0 ? void 0 : ref1.forEach((attribute)=>{
        var ref;
        if ((ref = attribute.values) === null || ref === void 0 ? void 0 : ref.length) {
            convertedFilters.push({
                id: "attributes.id.".concat(attribute.id),
                code: "attributes.".concat(attribute.code),
                name: attribute.name || "",
                options: attribute.values.map((value)=>({
                        filterId: attribute.id !== undefined ? "attributes.id.".concat(attribute.id) : null,
                        filterCode: attribute.code ? "attributes.".concat(attribute.code) : null,
                        optionId: value.optionId || null,
                        optionName: value.value || "",
                        selected: value.selected || false
                    }))
            });
        }
    });
    // clearanceTypes
    if (filters === null || filters === void 0 ? void 0 : (ref2 = filters.clearanceTypes) === null || ref2 === void 0 ? void 0 : ref2.length) {
        convertedFilters.push({
            code: "clearanceTypeIds",
            name: "T\xecnh trạng sản phẩm",
            options: filters.clearanceTypes.map((clearanceType)=>({
                    filterId: null,
                    filterCode: "clearanceTypeIds",
                    optionId: clearanceType.id === undefined ? null : clearanceType.id,
                    optionName: clearanceType.name || "",
                    selected: clearanceType.selected || false
                }))
        });
    }
    // masterCategories
    if ((filters === null || filters === void 0 ? void 0 : (ref3 = filters.masterCategories) === null || ref3 === void 0 ? void 0 : ref3.length) && !displayFilterTypeCategory) {
        convertedFilters.push({
            code: "masterCategoryIds",
            name: "Danh mục sản phẩm",
            options: filters.masterCategories.map((category)=>({
                    filterId: null,
                    filterCode: "masterCategoryIds",
                    optionId: category.masterCategoryId === undefined ? null : category.masterCategoryId,
                    optionName: category.sellerCategoryName || "",
                    selected: category.selected || false
                }))
        });
    }
    return convertedFilters;
};
const convertToPayloadFilter = (filterParams)=>{
    const result = {};
    const attributes = [];
    const legacyListingToSearchMapping = new Map([
        [
            "price_lte",
            "priceLte"
        ],
        [
            "price_gte",
            "priceGte"
        ],
        [
            "sellerCategories",
            "masterCategoryIds"
        ], 
    ]);
    // alter old listing fields from filterParams by new search fields
    legacyListingToSearchMapping.forEach((searchField, listingField)=>{
        if (Object.hasOwn(filterParams, listingField)) {
            Object.assign(filterParams, {
                [searchField]: filterParams[listingField]
            });
            delete filterParams[listingField];
        }
    });
    Object.keys(filterParams).forEach((key)=>{
        // attributes
        if (key.startsWith("attributes.")) {
            if (key.startsWith("attributes.id.")) {
                attributes.push({
                    id: parseInt(key.replace("attributes.id.", "")),
                    optionIds: filterParams[key].split(",")
                });
            } else {
                attributes.push({
                    code: key.replace("attributes.", ""),
                    optionIds: filterParams[key].split(",")
                });
            }
        } else if (constants_es/* PRIMITIVE_PAYLOAD_FILTER.includes */.ct.includes(key)) {
            result[key] = filterParams[key];
        } else if (constants_es/* ARRAY_OF_NUMBER_PAYLOAD_FILTER.includes */.O4.includes(key)) {
            result[key] = typeof filterParams[key] === "string" ? filterParams[key].split(",").map((el)=>+el) : filterParams[key].map((el)=>+el);
        } else if (constants_es/* ARRAY_OF_STRING_PAYLOAD_FILTER.includes */.Jk.includes(key)) {
            result[key] = typeof filterParams[key] === "string" ? filterParams[key].split(",") : filterParams[key];
        }
    });
    if (filterParams["attributes"] || attributes.length) {
        result["attributes"] = [
            ...filterParams["attributes"] || [],
            ...attributes, 
        ];
    }
    return result;
};
const convertToPayloadSorting = (sort, order)=>{
    return {
        sort: sort !== null && sort !== void 0 ? sort : "SORT_BY_UNSPECIFIED",
        order: order && constants_es/* ORDER_PAYLOAD_SORTING */.rA[order] ? constants_es/* ORDER_PAYLOAD_SORTING */.rA[order] : "ORDER_BY_UNSPECIFIED"
    };
};
const buildTreeCategoriesFilter = (categories)=>{
    const rootCategories = categories.filter((param)=>{
        let { parentId  } = param;
        return !parentId;
    });
    const buildChildren = (root)=>{
        const children = categories.filter((param)=>{
            let { parentId  } = param;
            return parentId === root.id;
        });
        return _objectSpreadProps(_objectSpread({}, root), {
            children: children.map(buildChildren)
        });
    };
    return rootCategories.map((root)=>buildChildren(root));
};
const Divider = emotion_styled_browser_esm["default"].div(_templateObject());


/***/ }),

/***/ 353632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A7": function() { return /* binding */ getCookieByName; },
/* harmony export */   "BO": function() { return /* binding */ setSessionStorageIfNotExist; },
/* harmony export */   "MA": function() { return /* binding */ setUserSelectedInfo; },
/* harmony export */   "Sk": function() { return /* binding */ getUserSelectedInfo; },
/* harmony export */   "d7": function() { return /* binding */ setCookieValue; },
/* harmony export */   "dU": function() { return /* binding */ getEnv; },
/* harmony export */   "iZ": function() { return /* binding */ removeUserSelectedInfo; },
/* harmony export */   "jy": function() { return /* binding */ getLocalStorageValue; },
/* harmony export */   "uN": function() { return /* binding */ setLocalStorageValue; }
/* harmony export */ });
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(775002);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(788813);


const getCookieByName = (cname)=>{
    const match = document.cookie.match(new RegExp("(^| )" + cname + "=([^;]+)"));
    if (match) return match[2];
    return null;
};
const getEnv = (variable, defaultValue)=>{
    var ref;
    if (false) {}
    return ((ref = window.env) === null || ref === void 0 ? void 0 : ref[variable]) || defaultValue;
};
/**
 * For some tenant, there are multiple terminal codes (Nam, Bac, Trung ...)
 * Let user select the corresponding terminal
 * save it to localStorage and cookie
 */ const getUserSelectedInfo = function(key) {
    let isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isNeedDecode = arguments.length > 2 ? arguments[2] : void 0;
    if ( true && key) {
        // for backward compatible
        const cookieKey = isMobile ? "".concat(key, "_mobile") : key;
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        const dataLS = window.localStorage.getItem(lsKey);
        const dataCookie = getCookieByName(cookieKey);
        // https://jira.teko.vn/browse/CSFRONT-649
        // due Safari not allowing cookie in iframe
        // we will load data from local storage instead
        // and accept that location & terminal of SSR differs from
        // that being stored in localStorage.
        // For vnshop, vietin... there is only one terminal and multiple locations
        // so that won't cause many trouble.
        if ((0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__.inIframe)()) {
            // check if it's in iframe
            // we don't want to affect existing logic
            return dataCookie || dataLS;
        }
        const decodeDataCookie = isNeedDecode ? decodeURIComponent(dataCookie || "") : dataCookie;
        return dataCookie && dataLS === decodeDataCookie ? decodeDataCookie : null;
    }
    return null;
};
const setUserSelectedInfo = function(key, value) {
    let isMobile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isNeedEncodeCookie = arguments.length > 3 ? arguments[3] : void 0;
    if ( true && key) {
        // for backward compatible
        const cookieKey = isMobile ? "".concat(key, "_mobile") : key;
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        window.localStorage.setItem(lsKey, value);
        document.cookie = "".concat(cookieKey, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;");
        const isHttps = window.location.protocol === "https:";
        const date = new Date();
        date.setFullYear(date.getFullYear() + 2);
        const valueStorageCookie = isNeedEncodeCookie ? encodeURIComponent(value) : value;
        document.cookie = "".concat(cookieKey, "=").concat(valueStorageCookie, ";expires=").concat(date.toUTCString(), ";Path=/;").concat(isHttps ? "SameSite=None;Secure;" : "");
    }
};
const removeUserSelectedInfo = function(key) {
    let isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ( true && key) {
        // for backward compatible
        const cookieKey = isMobile ? "".concat(key, "_mobile") : key;
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        window.localStorage.removeItem(lsKey);
        const isHttps = window.location.protocol === "https:";
        const date = new Date();
        date.setFullYear(date.getFullYear() - 2);
        document.cookie = "".concat(cookieKey, "=;expires=").concat(date.toUTCString(), ";Path=/;").concat(isHttps ? "SameSite=None;Secure;" : "");
    }
};
const setSessionStorageIfNotExist = (key, value)=>{
    if ((0,_index__WEBPACK_IMPORTED_MODULE_1__/* .isServerless */ .ep)() && !sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, value);
    }
};
const setCookieValue = (key, value, options)=>{
    if ((0,_index__WEBPACK_IMPORTED_MODULE_1__/* .isServerless */ .ep)() && key) {
        const { maxAge =31536000 * 2 , path ="/" ,  } = options || {};
        document.cookie = "".concat(key, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;");
        const isHttps = window.location.protocol === "https:";
        const expires = new Date(Date.now() + maxAge * 1000).toUTCString();
        document.cookie = "".concat(key, "=").concat(value, ";expires=").concat(expires, ";Path=").concat(path, ";").concat(isHttps ? "SameSite=None;Secure;" : "");
    }
};
const setLocalStorageValue = function(key, value) {
    let isMobile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if ( true && key) {
        // for backward compatible
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        window.localStorage.setItem(lsKey, value);
    }
};
const getLocalStorageValue = function(key) {
    let isMobile = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ( true && key) {
        // for backward compatible
        const lsKey = isMobile ? "".concat(key.toUpperCase(), "_mobile") : key.toUpperCase();
        const dataLS = window.localStorage.getItem(lsKey);
        return dataLS;
    }
    return null;
};


/***/ }),

/***/ 788813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EU": function() { return /* binding */ isVnpay; },
/* harmony export */   "Hw": function() { return /* binding */ getLocalDomain; },
/* harmony export */   "N6": function() { return /* binding */ checkExpiryDate; },
/* harmony export */   "ON": function() { return /* binding */ checkExpiredOrder; },
/* harmony export */   "Re": function() { return /* binding */ setCookieByName; },
/* harmony export */   "VC": function() { return /* binding */ isBankPartner; },
/* harmony export */   "Y2": function() { return /* binding */ transformExtraPromotion; },
/* harmony export */   "ep": function() { return /* binding */ isServerless; },
/* harmony export */   "hH": function() { return /* binding */ buildSlugUrl; },
/* harmony export */   "nK": function() { return /* binding */ isObjectEmpty; },
/* harmony export */   "sl": function() { return /* binding */ reloadPage; },
/* harmony export */   "w$": function() { return /* binding */ isUseUserLocationCode; },
/* harmony export */   "w5": function() { return /* binding */ clearCacheAndReloadPage; },
/* harmony export */   "yz": function() { return /* binding */ formatPhoneNumberPrefix; },
/* harmony export */   "z9": function() { return /* binding */ isDisableUserSelectLocationAction; }
/* harmony export */ });
/* unused harmony export getMobileAppToWebTerminalIdMapping */
/* harmony import */ var _teko_discovery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(875663);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_slug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93512);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91326);
/* harmony import */ var _env__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(353632);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
























const transformExtraPromotion = (promotion)=>{
    return _objectSpreadProps(_objectSpread({}, promotion), {
        date: {
            endDate: new Date(promotion.date.endDate).toISOString(),
            startDate: new Date(promotion.date.startDate).toISOString()
        }
    });
};
const formatDateString = (date)=>{
    if (date.charAt(date.length - 1) == "Z") {
        return date;
    } else {
        return date.replace(/-/g, "/");
    }
};
const checkExpiryDate = (startDate, endDate)=>{
    const today = new Date().getTime();
    startDate = formatDateString(startDate);
    endDate = formatDateString(endDate);
    try {
        const startTime = new Date(startDate).getTime();
        const endTime = new Date(endDate).getTime();
        if (today - startTime > 0 && endTime - today > 0) return true;
        return false;
    } catch (e) {
        return false;
    }
};
const checkExpiredOrder = (predictCancelAt)=>{
    if (!predictCancelAt) return false;
    if (typeof predictCancelAt === "string") return new Date(/((\+\d{2}:\d{2})|Z)$/.test(predictCancelAt) // unknown timezone 2020-11-03T09:34:45 ???
     ? predictCancelAt : "".concat(predictCancelAt, "Z")) < new Date();
    return predictCancelAt < new Date();
};
const setCookieByName = (cname, cvalue, expireTime, path)=>{
    document.cookie = "".concat(cname, "=").concat(cvalue).concat(expireTime ? ";expires=".concat(expireTime) : "").concat(path ? ";path=".concat(path) : "");
};
const buildSlugUrl = function(pageType, name, id) {
    let isSellerCat = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref;
    const trimmedId = (ref = id === null || id === void 0 ? void 0 : id.toString()) === null || ref === void 0 ? void 0 : ref.trim();
    const trimmedName = name === null || name === void 0 ? void 0 : name.trim();
    if (!trimmedName || !trimmedName) return null;
    switch(pageType){
        case _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.CATEGORY */ .DZ.CATEGORY:
            if (isSellerCat) return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-scat.").concat(trimmedId);
            return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-cat.").concat(trimmedId);
        case _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.BRAND */ .DZ.BRAND:
            return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-brand.").concat(trimmedId);
        case _teko_discovery__WEBPACK_IMPORTED_MODULE_1__/* .PageTypeEnum.SELLER */ .DZ.SELLER:
            return "/".concat((0,_teko_slug__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(trimmedName), "-sel.").concat(trimmedId);
        default:
            return null;
    }
};
const isVnpay = (partner)=>[
        "vietin",
        "vcb",
        "vnmart",
        "icheck",
        "agri",
        "bidv",
        "vp",
        "ivb",
        "exim",
        "abb",
        // do not change priority of sacombank pay and sacombankmb
        "sacombankmb",
        "sacombank",
        "saigonbank",
        "namabank",
        "bidc",
        "vietabank",
        "kienlongbank",
        "vnptpay", 
    ].includes(partner);
const isBankPartner = (partner)=>[
        "vietin",
        "vcb",
        "vcb-loyalty",
        "vnmart",
        "icheck",
        "agri",
        "bidv",
        "bidv-vip",
        "vp",
        "tripi",
        "dinogo",
        "ivb",
        "exim",
        "abb",
        "sacombankmb",
        "sacombank",
        "wecare",
        "agent",
        "saigonbank",
        "namabank",
        "bidc",
        "vietabank",
        "coopbank",
        "kienlongbank",
        "vnptpay",
        "viviet",
        "hdbank",
        "tailoc68",
        "weluck",
        "baovietbank",
        "vietbank",
        "oceanbank",
        "publicbank",
        "mca",
        "vbsp",
        "scbmb", 
    ].includes(partner);
const isServerless = ()=>"object" !== "undefined";
/**
 *
 * @param hostname
 * @param env
 * @returns
 * convert [platform].localhost:3000 => [platform].[env].teko.vn
 */ const getLocalDomain = function(hostname) {
    let env = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "dev";
    if (/[^\.]*\.?localhost[^]*/g.test(hostname) === false) return hostname;
    return hostname.replace(/([^\.]*)\.?(localhost[^]*)/g, function(_) {
        let platform = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "vnshop";
        return (platform || "vnshop") + ".".concat(env, ".teko.vn");
    });
};
const reloadPage = (url)=>{
    if ( false || typeof window.location === "undefined") {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("This function seems to be executed on server or not to be supported in the current browser");
        return;
    }
    window.location.href = url || window.location.origin + window.location.pathname + window.location.search;
};
const clearCacheAndReloadPage = (url)=>{
    if ( true && typeof window.location !== "undefined") {
        setCookieByName("nocache", "true");
        url ? window.location.href = url : window.location.reload();
    }
};
const getMobileAppToWebTerminalIdMapping = ()=>{
    try {
        const mapping = getEnv("MOBILE_APP_TO_WEB_TERMINAL_ID_MAPPING");
        return typeof mapping === "string" ? JSON.parse(mapping) : null;
    } catch (e) {
        logger.error(e);
        return null;
    }
};
/**
 *
 * @param isDmsFlow
 * @description this function check and disable user select location action when user in Dms flow. Ref OMNI-1398
 * @returns Boolean
 */ const isDisableUserSelectLocationAction = (param)=>{
    let { isDmsFlow  } = param;
    return isServerless() && isDmsFlow && !!(0,_env__WEBPACK_IMPORTED_MODULE_3__/* .getCookieByName */ .A7)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .USER_TERMINAL_ID */ .pT);
};
const isUseUserLocationCode = (param)=>{
    let { isDmsFlow  } = param;
    return isServerless() && isDmsFlow && !!(0,_env__WEBPACK_IMPORTED_MODULE_3__/* .getCookieByName */ .A7)(_constants__WEBPACK_IMPORTED_MODULE_4__/* .USER_LOCATION_CODE */ .UE);
};
const isObjectEmpty = (obj)=>{
    return !Object.keys(obj).length;
};
/**
 *
 * @param phoneNumber
 * @description this function convert phone number from '0...' to '+84...'
 * @returns string
 */ const formatPhoneNumberPrefix = (phoneNumber)=>{
    return phoneNumber.startsWith("0") ? "+84" + phoneNumber.slice(1) : phoneNumber;
};


/***/ }),

/***/ 646130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getFrame; },
/* harmony export */   "X": function() { return /* binding */ isVariantUrlGrouped; }
/* harmony export */ });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(504133);

const getFrame = (tags, frames)=>{
    const ids = [];
    tags.forEach((el)=>{
        const matchReg = el.match(/^frame_(\d+)_.+/);
        if (matchReg && matchReg[1] && !isNaN(parseInt(matchReg[1]))) {
            ids.push(parseInt(matchReg[1]));
        }
    });
    const frame = frames.find((fr)=>ids.includes(parseInt(fr.id)) && fr.startDate && fr.endDate && (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .checkExpiryDateTimestamp */ .Z2)(fr.startDate, fr.endDate));
    return frame ? frame.image : undefined;
};
const isVariantUrlGrouped = (canonical)=>{
    // some product need to group all skus into a single url
    // we don't have that flag returned to client
    // so rely on url pattern for now, which may not be
    // very reliable in the future
    // for such product, canonical is /product-name--p<productId>
    return (canonical === null || canonical === void 0 ? void 0 : canonical.indexOf("--p")) >= 0;
};


/***/ }),

/***/ 291278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ServiceContainer; }
});

// EXTERNAL MODULE: ../../packages/auth/dist/service.es.js + 1 modules
var service_es = __webpack_require__(76500);
// EXTERNAL MODULE: ../../packages/cart/dist/service.es.js + 1 modules
var dist_service_es = __webpack_require__(384154);
// EXTERNAL MODULE: ../../packages/api/dist/index.es.js + 3 modules
var index_es = __webpack_require__(799278);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
;// CONCATENATED MODULE: ../../packages/cart/dist/v2/error.es.js


const getError = (resp) => {
  const message = resp.message;
  return new index_es.ApiError(message, resp.code, resp);
};



// EXTERNAL MODULE: ../../packages/cart/dist/v2/utils.es.js
var utils_es = __webpack_require__(916476);
;// CONCATENATED MODULE: ../../packages/cart/dist/v2/service.es.js







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const cartTokenHeaderKey = "x-cart-token";
const resolveValue = (value) => {
  return typeof value === "function" ? value() : value;
};
const parseToken = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};
const parseJWT = (token) => {
  try {
    const parsedToken = parseToken(token);
    if (!!parsedToken) {
      return parsedToken["cid"];
    }
    return null;
  } catch (e) {
    return null;
  }
};
const parseTerminalId = (token) => {
  try {
    const parsedToken = parseToken(token);
    if (!!parsedToken) {
      return parsedToken["tid"];
    }
    return void 0;
  } catch (e) {
    return void 0;
  }
};
class CartService {
  constructor(apiUrl, options) {
    this.cartApi = new index_es["default"](apiUrl, getError);
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.cartApi.addInterceptor((req) => {
      if (typeof window === "undefined" || req.headers.get(cartTokenHeaderKey) !== null)
        return;
      if (options == null ? void 0 : options.cartToken) {
        req.headers.set(cartTokenHeaderKey, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = typeof this.getCartToken === "function" ? this.getCartToken() : (0,utils_es/* getCartToken */.i)();
        if (cartToken) {
          req.headers.set(cartTokenHeaderKey, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", (options == null ? void 0 : options.language) || "*");
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("use-combo-v2", `${(options == null ? void 0 : options.useComboV2) || false}`);
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("use-exclusion-v2", `${(options == null ? void 0 : options.useExclusionV2) || false}`);
    });
    this.location = (options == null ? void 0 : options.location) || void 0;
    this.terminal = (options == null ? void 0 : options.terminal) || void 0;
    this.terminalId = (options == null ? void 0 : options.terminalId) || void 0;
    this.getFullCart = (options == null ? void 0 : options.getFullCart) || void 0;
    this.v1 = new dist_service_es/* CartService */.Ni(apiUrl);
    this.cartApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  getCartId(cartToken) {
    var _a;
    const token = cartToken || ((_a = this.getCartToken) == null ? void 0 : _a.call(this));
    return typeof token === "string" ? parseJWT(token) : void 0;
  }
  getParams(configs) {
    return {
      getFullCart: this.getFullCart,
      location: this.location,
      terminal: !(configs == null ? void 0 : configs.noTerminal) ? resolveValue(this.terminal) : void 0,
      terminalId: !(configs == null ? void 0 : configs.noTerminalId) ? resolveValue(this.terminalId) : void 0,
      hasAllApplicableOrderPromotions: this.hasAllApplicableOrderPromotions
    };
  }
  setParams({
    getFullCart,
    location,
    terminal,
    terminalId,
    getCartToken: getCartToken2,
    hasAllApplicableOrderPromotions
  }) {
    this.getFullCart = typeof getFullCart !== "undefined" ? getFullCart : this.getFullCart;
    this.location = typeof location !== "undefined" ? location : this.location;
    this.terminal = typeof terminal !== "undefined" ? terminal : this.terminal;
    this.terminalId = typeof terminalId !== "undefined" ? terminalId : this.terminalId;
    this.getCartToken = typeof getCartToken2 !== "undefined" ? getCartToken2 : this.getCartToken;
    this.hasAllApplicableOrderPromotions = typeof hasAllApplicableOrderPromotions !== "undefined" ? hasAllApplicableOrderPromotions : this.hasAllApplicableOrderPromotions;
  }
  async getCart(oldTerminalId) {
    const { data, headers } = await this.cartApi.get("/api/v2/carts", {
      params: __spreadProps(__spreadValues({}, this.getParams()), { oldTerminalId })
    });
    if (!!oldTerminalId) {
      const newToken = headers[cartTokenHeaderKey];
      const oldToken = typeof this.getCartToken === "function" ? this.getCartToken() : (0,utils_es/* getCartToken */.i)();
      if (oldToken)
        (0,utils_es/* setCartInfoToLocalStorage */.Bs)(this.getCartId(newToken), {
          newCartToken: newToken,
          oldCartToken: oldToken,
          terminalId: parseTerminalId(newToken),
          cartDiffDetails: data == null ? void 0 : data.message
        });
    }
    return __spreadProps(__spreadValues({}, data == null ? void 0 : data.data), {
      message: !!oldTerminalId ? data == null ? void 0 : data.message : void 0
    }) || utils_es/* defaultCart */.UH;
  }
  async applyPromotion(applyPromotionRequest) {
    const { ppmPromotionId, ppmCode, itemId, isForceApply, promotionSource } = applyPromotionRequest;
    const res = await this.cartApi.put("/api/v2/carts/promotions", {
      ppmPromotionId,
      ppmCode,
      itemId,
      isForceApply,
      promotionSource
    }, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data;
  }
  async removePromotion(removePromotionRequest) {
    const { cartPromotionId } = removePromotionRequest;
    const res = await this.cartApi.delete("/api/v2/carts/promotions", {
      cartPromotionId
    }, {
      params: this.getParams()
    });
    return res == null ? void 0 : res.data;
  }
  async recordOrder(recordOrderRequest, cartToken) {
    const res = await this.cartApi.post("/api/v2/carts/record", recordOrderRequest, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return res == null ? void 0 : res.data;
  }
  async getAllCartTokens(configs) {
    var _a, _b;
    const res = await this.cartApi.get("/api/v2/cart-tokens", {
      params: this.getParams(configs)
    });
    if (!Array.isArray((_a = res.data) == null ? void 0 : _a.data)) {
      return [];
    }
    return (_b = res.data) == null ? void 0 : _b.data;
  }
  async createNewCart({
    deviceSerialNumber
  }) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts", {}, {
      params: __spreadProps(__spreadValues({}, this.getParams()), {
        deviceSerialNumber
      })
    });
    const data = ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || { cart: utils_es/* defaultCart */.UH, cartToken: "" };
    return data;
  }
  async deleteCart(cartToken) {
    await this.cartApi.delete("/api/v2/carts", void 0, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
  }
  async loadConfirmationCart({
    deviceSerialNumber
  }) {
    var _a;
    const res = await this.cartApi.get("/api/v2/carts/confirmation", {
      params: __spreadProps(__spreadValues({}, this.getParams()), {
        deviceSerialNumber
      })
    });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async getDeliveryOptions({
    deliveryType,
    customerProfileId
  }) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts/delivery-options", { deliveryType, customerProfileId }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || {};
  }
  async setDeliveryInfo({
    address,
    addressId,
    deliveryType,
    districtId,
    districtName,
    email,
    fullAddress,
    name,
    phone,
    provinceId,
    provinceName,
    siteId,
    wardId,
    wardName,
    getAllApplicablePromotions
  }, optionalParams) {
    var _b;
    const { cartToken, terminalId } = optionalParams || {};
    const generatedFullAddress = [address, wardName, districtName, provinceName].filter(Boolean).join(", ");
    const _a = this.getParams(), { hasAllApplicableOrderPromotions } = _a, rest = __objRest(_a, ["hasAllApplicableOrderPromotions"]);
    const res = await this.cartApi.put("/api/v2/carts/delivery-info", (0,dist_index_es.cleanObject)({
      addressId,
      deliveryType,
      districtId,
      fullAddress: fullAddress || generatedFullAddress,
      name,
      phone,
      provinceId,
      siteId,
      wardId,
      email
    }), {
      params: __spreadProps(__spreadValues({}, rest), {
        getAllApplicablePromotions: getAllApplicablePromotions || hasAllApplicableOrderPromotions,
        terminalId: terminalId || rest.terminalId
      }),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return ((_b = res.data) == null ? void 0 : _b.data) || utils_es/* defaultCart */.UH;
  }
  async changeItemPrice({
    itemId,
    consultationFee,
    onDemandDiscount,
    onDemandDiscountReason,
    onDemandDiscountReasonId
  }) {
    var _a;
    const data = await this.cartApi.put("/api/v2/carts/items/price-manual", {
      itemId,
      consultationFee,
      onDemandDiscount,
      onDemandDiscountReason,
      onDemandDiscountReasonId
    }, {
      params: this.getParams()
    });
    return (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.data;
  }
  async applyDeliveryService({
    serviceId
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/delivery-services", { serviceId }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async applyAdditionalService({
    serviceId,
    isEnable
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/additional-services", { serviceId, isEnable }, { params: this.getParams() });
    return ((_a = res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async applyPaymentMethodToCart({
    paymentMethodCode
  }) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/payment-methods", { paymentMethodCode }, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async requestItemSku({
    name,
    quantity
  }) {
    const { data, headers } = await this.cartApi.post("api/v2/carts/items/sku-request", { name, quantity }, {
      params: this.getParams()
    });
    const token = headers[cartTokenHeaderKey];
    if (!!token) {
      (0,utils_es/* setCartToken */.rx)(token);
    }
    return (data == null ? void 0 : data.data) || utils_es/* defaultCart */.UH;
  }
  async checkoutOrder({
    order
  }, cartToken) {
    var _a;
    const res = await this.cartApi.post("/api/v2/carts/checkout", { order }, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return (_a = res.data) == null ? void 0 : _a.data;
  }
  async removeItem(removeItemRequest) {
    var _a;
    const { itemId } = removeItemRequest;
    const params = this.getParams();
    const res = await this.cartApi.delete("/api/v2/carts/items", { itemId }, { params });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async updateItemQuantity(updateItemQuantityRequest) {
    var _a;
    const { itemId, quantity } = updateItemQuantityRequest;
    const body = {
      itemId,
      quantity
    };
    const params = this.getParams();
    const res = await this.cartApi.put("/api/v2/carts/items/quantity", body, {
      params
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async updateItemNote(updateItemNoteRequest) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/items/note", updateItemNoteRequest, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async selectItems(selectItemsRequest) {
    var _a;
    const { itemIds, isSelected } = selectItemsRequest;
    const body = {
      itemIds,
      isSelected
    };
    const params = this.getParams();
    const res = await this.cartApi.put("/api/v2/carts/items/selection", body, {
      params
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async addItems(addItemsRequest, cartToken) {
    const {
      groups,
      override,
      overrideItemId,
      overrideTypes,
      isolatedCartType,
      isSkipHoldInventory
    } = addItemsRequest;
    const body = {
      groups,
      override,
      overrideTypes,
      overrideItemId,
      isolatedCartType,
      isSkipHoldInventory
    };
    const params = this.getParams();
    const { data, headers } = await this.cartApi.post("/api/v2/carts/items", body, {
      params,
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    const token = headers[cartTokenHeaderKey];
    if (!!token && !cartToken) {
      if (!isolatedCartType) {
        (0,utils_es/* setCartToken */.rx)(token);
      } else {
        (0,utils_es/* storeBuyNowCartKey */.e5)({
          key: (0,utils_es/* getBuyNowKey */.B2)(),
          createdAt: new Date().getTime(),
          cartToken: token
        });
        if (!!isSkipHoldInventory) {
          (0,utils_es/* removeOldBuyNowCart */.Ut)();
          (0,utils_es/* storeCartTokenHamper */.GN)(token);
        }
      }
    }
    return (data == null ? void 0 : data.data) || utils_es/* defaultCart */.UH;
  }
  async recordToPayment({
    payments,
    orderId
  }) {
    const body = { payments, orderId };
    const params = this.getParams();
    const { data } = await this.cartApi.post("/api/v2/carts/record-to-payment", body, {
      params
    });
    return data.data;
  }
  async reCheckout(orderToken) {
    const params = this.getParams();
    const { data } = await this.cartApi.post("/api/v2/carts/checkout-to-payment", { orderToken }, { params });
    return data.data;
  }
  async getOrderPaymentMethod(orderId) {
    var _a;
    const res = await this.cartApi.get("api/v2/orders/payment-info", {
      params: __spreadProps(__spreadValues({}, this.getParams()), { orderId })
    });
    return (_a = res.data) == null ? void 0 : _a.data;
  }
  async updateCartGeneralInfo(payload, cartToken) {
    const res = await this.cartApi.put("/api/v2/carts", payload, {
      params: this.getParams(),
      headers: cartToken ? { [cartTokenHeaderKey]: cartToken } : {}
    });
    return res == null ? void 0 : res.data.data;
  }
  async applyPaymentAmount(payload) {
    var _a;
    const res = await this.cartApi.put("/api/v2/carts/payment-amount", payload, {
      params: this.getParams()
    });
    return ((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.data) || utils_es/* defaultCart */.UH;
  }
  async getPriceAndPromotion(sku, params) {
    const { data } = await this.cartApi.get(`/api/v2/products/${sku}`, {
      params: __spreadValues(__spreadValues({}, this.getParams()), params)
    });
    return data.data;
  }
  async calculatePrice(body) {
    const { data } = await this.cartApi.post("/api/v2/products/calculate-price", body, { params: this.getParams() });
    return data.data;
  }
}



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/constants.es.js
var SORT_TYPE = /* @__PURE__ */ ((SORT_TYPE2) => {
  SORT_TYPE2["SORT_BY_UNSPECIFIED"] = "SORT_BY_UNSPECIFIED";
  SORT_TYPE2["SORT_BY_PUBLISH_AT"] = "SORT_BY_PUBLISH_AT";
  SORT_TYPE2["SORT_BY_PRICE"] = "SORT_BY_PRICE";
  SORT_TYPE2["SORT_BY_MOST_VIEW"] = "SORT_BY_MOST_VIEW";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY"] = "SORT_BY_TOP_SALE_QUANTITY";
  SORT_TYPE2["SORT_BY_DISCOUNT_PERCENT"] = "SORT_BY_DISCOUNT_PERCENT";
  SORT_TYPE2["SORT_BY_MOST_VIEW_3_DAYS"] = "SORT_BY_MOST_VIEW_3_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_7_DAYS"] = "SORT_BY_MOST_VIEW_7_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_30_DAYS"] = "SORT_BY_MOST_VIEW_30_DAYS";
  SORT_TYPE2["SORT_BY_MOST_VIEW_90_DAYS"] = "SORT_BY_MOST_VIEW_90_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_3_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_3_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_7_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_7_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_30_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_30_DAYS";
  SORT_TYPE2["SORT_BY_TOP_SALE_QUANTITY_90_DAYS"] = "SORT_BY_TOP_SALE_QUANTITY_90_DAYS";
  return SORT_TYPE2;
})(SORT_TYPE || {});
var SORT_ORDER = /* @__PURE__ */ ((SORT_ORDER2) => {
  SORT_ORDER2["ORDER_BY_UNSPECIFIED"] = "ORDER_BY_UNSPECIFIED";
  SORT_ORDER2["ORDER_BY_ASCENDING"] = "ORDER_BY_ASCENDING";
  SORT_ORDER2["ORDER_BY_DESCENDING"] = "ORDER_BY_DESCENDING";
  return SORT_ORDER2;
})(SORT_ORDER || {});
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(77829);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/service.es.js





var service_es_defProp = Object.defineProperty;
var service_es_defProps = Object.defineProperties;
var service_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var service_es_defNormalProp = (obj, key, value) => key in obj ? service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (service_es_hasOwnProp.call(b, prop))
      service_es_defNormalProp(a, prop, b[prop]);
  if (service_es_getOwnPropSymbols)
    for (var prop of service_es_getOwnPropSymbols(b)) {
      if (service_es_propIsEnum.call(b, prop))
        service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var service_es_spreadProps = (a, b) => service_es_defProps(a, service_es_getOwnPropDescs(b));
var service_es_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (service_es_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && service_es_getOwnPropSymbols)
    for (var prop of service_es_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && service_es_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class DiscoveryService {
  constructor(discoveryApiUrl, terminalId, terminalCode, language, getCustomAccessToken) {
    this._isArrayValue = [
      "sellerCodes",
      "brands",
      "categories",
      "categoryIds",
      "tags",
      "providerIds",
      "sellerIds",
      "skus",
      "masterCategories",
      "masterCategoryIds",
      "excludedSkus",
      "returnFilterable",
      "excludedSkus",
      "clearanceTypeIds"
    ];
    this._discoveryPayloadKeys = [
      "terminalCode",
      "terminalId",
      "query",
      "filter",
      "pagination",
      "sorting",
      "userId",
      "phoneNumber",
      "location",
      "returnFilterable",
      "block",
      "pos365StoreCode",
      "slug",
      "terminalId"
    ];
    this._discoveryBlockKeys = ["blockId", "itemId"];
    this._discoveryFilterKeys = [
      "sellingCodes",
      "priceLte",
      "priceGte",
      "brands",
      "categories",
      "categoryIds",
      "tags",
      "hasPromotions",
      "attributes",
      "providerIds",
      "sellerIds",
      "skus",
      "flashSaleType",
      "masterCategories",
      "masterCategoryIds",
      "excludedSkus",
      "clearanceTypeIds",
      "returnAllVariants"
    ];
    this._isBooleanValue = ["hasPromotions", "returnAllVariants"];
    this._isNumberValue = ["clearanceTypeIds", "categoryIds"];
    this._discoverySortingKeys = ["sort", "order"];
    this._discoveryPaginationKeys = ["pageNumber", "itemsPerPage"];
    this._orderValuesMap = {
      desc: SORT_ORDER.ORDER_BY_DESCENDING,
      asc: SORT_ORDER.ORDER_BY_ASCENDING,
      DESC: SORT_ORDER.ORDER_BY_DESCENDING,
      ASC: SORT_ORDER.ORDER_BY_ASCENDING
    };
    this._sortValuesMap = {
      new: "SORT_BY_PUBLISH_AT",
      bestPrice: "SORT_BY_PRICE",
      "view.last_3_day": SORT_TYPE.SORT_BY_MOST_VIEW,
      "view.last_7_day": SORT_TYPE.SORT_BY_MOST_VIEW_7_DAYS,
      "view.last_30_day": SORT_TYPE.SORT_BY_MOST_VIEW_30_DAYS,
      "view.last_90_day": SORT_TYPE.SORT_BY_MOST_VIEW_90_DAYS,
      "quantity.last_3_day": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY,
      "quantity.last_1_week": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY_7_DAYS,
      "quantity.last_1_month": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY_30_DAYS,
      "quantity.last_3_month": SORT_TYPE.SORT_BY_TOP_SALE_QUANTITY_90_DAYS,
      discountPercent: SORT_TYPE.SORT_BY_DISCOUNT_PERCENT,
      discount: SORT_TYPE.SORT_BY_DISCOUNT_PERCENT
    };
    this.discoveryApi = new index_es["default"](discoveryApiUrl);
    if (typeof getCustomAccessToken === "function") {
      this.discoveryApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.discoveryApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.discoveryApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    this.terminalId = terminalId;
    this.terminalCode = terminalCode;
    this.discoveryApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  _cookPayload(params) {
    const payload = service_es_spreadProps(service_es_spreadValues(service_es_spreadValues({
      filter: {},
      pagination: {},
      query: "",
      sorting: {},
      returnFilterable: [],
      block: {},
      slug: ""
    }, this.terminalCode ? { terminalCode: this.terminalCode } : {}), this.terminalId ? { terminalId: this.terminalId } : {}), {
      fieldMask: []
    });
    const normalizedParams = normalizeDiscoveryApiParams((0,helpers_es/* normalizePageBuilderToDiscoveryParams */.nS)(params));
    const attributes = [];
    Object.keys(normalizedParams).forEach((key) => {
      let data = this._isArrayValue.includes(key) ? convertArrayValue(normalizedParams[key], this._isNumberValue.includes(key) ? "number" : "string") : normalizedParams[key];
      if (key.startsWith("attributes.")) {
        attributes.push({
          code: key.replace("attributes.", ""),
          optionIds: data.split(",")
        });
      }
      if (this._isBooleanValue.includes(key)) {
        data = data === "true" || data === true;
      }
      if (this._discoveryPayloadKeys.includes(key)) {
        payload[key] = data;
      }
      if (this._discoveryBlockKeys.includes(key)) {
        payload.block[key] = data;
      }
      if (this._discoveryFilterKeys.includes(key)) {
        payload.filter = service_es_spreadProps(service_es_spreadValues({}, payload.filter), {
          [key]: data
        });
      }
      if (this._discoverySortingKeys.includes(key)) {
        payload.sorting = service_es_spreadValues(service_es_spreadValues({}, payload.sorting), {
          [key]: key === "order" ? this._orderValuesMap[data] || data || "ORDER_BY_UNSPECIFIED" : this._sortValuesMap[data] || data || "SORT_BY_UNSPECIFIED"
        });
      }
      if (this._discoveryPaginationKeys.includes(key)) {
        payload.pagination = service_es_spreadValues(service_es_spreadValues({}, payload.pagination), {
          [key]: data
        });
      }
    });
    payload["filter"]["attributes"] = [
      ...payload["filter"]["attributes"] || [],
      ...attributes
    ];
    if (!!params.fieldMask) {
      payload.fieldMask = params.fieldMask;
    }
    return payload;
  }
  setTerminal({
    terminalCode,
    terminalId
  }) {
    this.terminalCode = terminalCode;
    this.terminalId = terminalId;
  }
  getBaseUrl() {
    return this.discoveryApi.baseURL;
  }
  async search(params) {
    const searchParams = this._cookPayload(params);
    const { data } = await this.discoveryApi.post("/search", searchParams);
    return data;
  }
  async internalSearch(terminalCode, siteId, query, limit, sorting) {
    var _a;
    const { data } = await this.discoveryApi.post("/internal/search", {
      terminalCode,
      siteId,
      query,
      sorting,
      limit
    });
    if ((data == null ? void 0 : data.code) !== "0" || !((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.products)) {
      return [];
    }
    return data.data.products;
  }
  async getProductDetailBySkus(params) {
    const LIMIT_SKUS = 50;
    const promises = [];
    const _a = params, { skus } = _a, rest = service_es_objRest(_a, ["skus"]);
    const skuArray = typeof skus === "string" ? skus.split(",") : skus;
    for (let index = 0; index < skuArray.length; index += LIMIT_SKUS) {
      const subSkus = skuArray.slice(index, index + LIMIT_SKUS);
      promises.push(this.discoveryApi.get("/products", {
        params: service_es_spreadProps(service_es_spreadValues({
          skus: subSkus
        }, rest), {
          terminalCode: this.terminalCode || params.terminalCode,
          terminalId: this.terminalId || params.terminalId
        })
      }).then((response) => {
        var _a2, _b;
        return ((_b = (_a2 = response.data) == null ? void 0 : _a2.result) == null ? void 0 : _b.products) || [];
      }));
    }
    const products = await Promise.all(promises).then((values) => values.reduce((acc, curr) => [...acc, ...curr], []));
    return products;
  }
  async getProduct(params) {
    var _a;
    const { data } = await this.discoveryApi.get(`/product`, {
      params: service_es_spreadProps(service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.product;
  }
  async getKeyword(params) {
    const { data } = await this.discoveryApi.get("/keywords", {
      params: service_es_spreadProps(service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return data;
  }
  async getBlock(params, timeout) {
    const { data } = await this.discoveryApi.get(`/blocks`, {
      params: service_es_spreadProps(service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      }),
      timeout
    });
    return data;
  }
  async getPopularKeyword(params) {
    const { data } = await this.discoveryApi.get(`/recommended-search-terms`, {
      params: service_es_spreadProps(service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return data;
  }
  async getRecommendationProducts(sku) {
    const { data } = await this.discoveryApi.get(`/products/${sku}/recommendations`, {
      params: {
        terminalId: this.terminalId,
        terminalCode: this.terminalCode
      }
    });
    return data;
  }
  async getRecommendationCombos(sku, params) {
    const { data } = await this.discoveryApi.get(`/products/${sku}/combos`, {
      params: service_es_spreadProps(service_es_spreadValues({}, params), {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      })
    });
    return data;
  }
  async getDetailComboRecommendation(params) {
    const { data } = await this.discoveryApi.post(`/combos`, service_es_spreadProps(service_es_spreadValues({}, params), {
      terminalId: this.terminalId,
      terminalCode: this.terminalCode
    }));
    return data;
  }
  async getMenuItems(zone) {
    const result = await this.discoveryApi.get(`/menu-items`, {
      params: {
        terminalId: this.terminalId,
        terminal: this.terminalCode,
        zone,
        _limit: 1e3,
        _sort: "priority",
        _order: "asc",
        fieldMask: [
          "id",
          "name",
          "parentId",
          "icon",
          "isTargetBlank",
          "url",
          "targetPath",
          "urlType",
          "configs",
          "banners.{isActive|startDate|endDate|image|targetPath|urlType}",
          "level"
        ]
      }
    });
    return result.data;
  }
  async getMenuItemById(categoryId) {
    const { data } = await this.discoveryApi.get(`/menu-item/${categoryId}`);
    return data;
  }
  async searchProductsByBarcode(reqParams) {
    const { sku, barcode, sellerId, terminalCode } = reqParams;
    const params = {
      identifiers: [
        {
          sellerSkuIdentifier: {
            sellerId,
            sellerSku: sku
          }
        },
        {
          sellerBarcodeIdentifier: {
            barcode,
            sellerId
          }
        }
      ],
      terminalCode
    };
    const { data } = await this.discoveryApi.post(`/products`, params);
    return data;
  }
  async getCollectionsByPlatformId(params) {
    const { data } = await this.discoveryApi.get("/collections", { params: service_es_spreadValues({}, params) });
    return data;
  }
  async getRecommendedSkus(sku) {
    var _a, _b, _c;
    const { data } = await this.discoveryApi.get(`/products/${sku}/recommendations`, {
      params: {
        terminalCode: this.terminalCode,
        terminalId: this.terminalId
      }
    });
    return (_c = (_b = (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.productSets) == null ? void 0 : _b[0]) == null ? void 0 : _c.products;
  }
}
const normalizeDiscoveryApiParams = (params) => {
  const listingAndDiscoveryFieldsMap = {
    _sort: "sort",
    _order: "order",
    bestPrice_gte: "priceGte",
    bestPrice_lte: "priceLte",
    price_lte: "priceLte",
    price_gte: "priceGte",
    _limit: "itemsPerPage",
    limit: "itemsPerPage",
    sellerCategories: "masterCategories",
    _page: "pageNumber",
    page: "pageNumber",
    q: "query",
    keyword: "query",
    skus_ne: "excludedSkus",
    providerId: "providerIds"
  };
  const normalizedParams = {};
  Object.keys(params).forEach((field) => {
    if (listingAndDiscoveryFieldsMap[field]) {
      normalizedParams[listingAndDiscoveryFieldsMap[field]] = params[field];
    } else {
      normalizedParams[field] = params[field];
    }
  });
  return normalizedParams;
};
const convertArrayValue = (value, returnType = "string") => {
  if (typeof value === "string") {
    if (returnType === "string")
      return value.split(",");
    return value.split(",").map((el) => +el);
  }
  if (returnType === "string")
    return value;
  return value.map((el) => +el);
};



// EXTERNAL MODULE: ../../packages/tracking/dist/api.es.js
var api_es = __webpack_require__(683383);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/helpers.es.js
const isServerless = () => typeof window !== "undefined";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/service.es.js






var v2_service_es_defProp = Object.defineProperty;
var v2_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var v2_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var v2_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var v2_service_es_defNormalProp = (obj, key, value) => key in obj ? v2_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var v2_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (v2_service_es_hasOwnProp.call(b, prop))
      v2_service_es_defNormalProp(a, prop, b[prop]);
  if (v2_service_es_getOwnPropSymbols)
    for (var prop of v2_service_es_getOwnPropSymbols(b)) {
      if (v2_service_es_propIsEnum.call(b, prop))
        v2_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_SEARCH_DATA = {
  page: 0,
  pageSize: 0,
  total: 0
};
class service_es_DiscoveryService {
  constructor(discoveryApiUrl, terminalId, language, location) {
    this.location = location;
    this.discoveryApi = new index_es["default"](discoveryApiUrl);
    this.terminalId = terminalId;
    this.discoveryApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    this.discoveryApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    !!isServerless() && this.discoveryApi.addInterceptor(api_es/* requestDurationTrackingInterceptor */.V3);
    !!isServerless() && this.discoveryApi.addResponseInterceptor(api_es/* responseDurationTrackingInterceptor */.sb);
    this.discoveryApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  getTerminalId() {
    return this.terminalId;
  }
  get baseParams() {
    return (0,dist_index_es.cleanObject)({
      terminalId: this.terminalId,
      location: this.location
    });
  }
  async search(payload, searchAlgoHeaderValue) {
    const { data } = await this.discoveryApi.post("/search-skus-v2", v2_service_es_spreadValues(v2_service_es_spreadValues({}, this.baseParams), payload), {
      headers: !!searchAlgoHeaderValue ? {
        "X-Enable-Search-Algorithm": searchAlgoHeaderValue
      } : {}
    });
    return (data == null ? void 0 : data.data) || DEFAULT_SEARCH_DATA;
  }
}



// EXTERNAL MODULE: ../../packages/location/dist/index.es.js + 2 modules
var location_dist_index_es = __webpack_require__(693497);
;// CONCATENATED MODULE: ../../packages/notification/dist/services.es.js



var services_es_defProp = Object.defineProperty;
var services_es_defProps = Object.defineProperties;
var services_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var services_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var services_es_hasOwnProp = Object.prototype.hasOwnProperty;
var services_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var services_es_defNormalProp = (obj, key, value) => key in obj ? services_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var services_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (services_es_hasOwnProp.call(b, prop))
      services_es_defNormalProp(a, prop, b[prop]);
  if (services_es_getOwnPropSymbols)
    for (var prop of services_es_getOwnPropSymbols(b)) {
      if (services_es_propIsEnum.call(b, prop))
        services_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var services_es_spreadProps = (a, b) => services_es_defProps(a, services_es_getOwnPropDescs(b));
const getJson = (str) => {
  try {
    return !!str && JSON.parse(str);
  } catch (e) {
    return null;
  }
};
class NotificationService {
  constructor(notificationApiUrl, getCustomAccessToken) {
    this.getNotification = async (params) => {
      var _a;
      const paramsString = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== void 0 && value !== null) {
          if (key === "externalTypes" && Array.isArray(value)) {
            value.forEach((item) => {
              paramsString.append("externalTypes", item);
            });
          } else {
            paramsString.append(key, value);
          }
        }
      });
      const { data } = params.externalTypes ? await this.notificationApi.get(`/notifications?${paramsString.toString()}`) : await this.notificationApi.get(`/notifications`, {
        params: services_es_spreadValues({}, params)
      });
      const formattedNotis = ((_a = data.data.notifications) == null ? void 0 : _a.map((noti) => {
        const parsedLink = getJson(noti.link);
        const parsedData = typeof noti.data === "string" ? getJson(noti.data) : noti.data;
        const link = parsedLink ? parsedLink : "";
        const notificationType = noti.type || link.type;
        const notificationData = parsedData || (link == null ? void 0 : link.data);
        if (notificationType && ["order", "noti"].includes(notificationType)) {
          return services_es_spreadProps(services_es_spreadValues({}, noti), {
            order: notificationType === "order" ? notificationData : null,
            deepLink: notificationType === "noti" ? notificationData == null ? void 0 : notificationData.deeplink : null
          });
        }
      }).filter((noti) => !!noti)) || [];
      return services_es_spreadProps(services_es_spreadValues({}, data.data), {
        notifications: formattedNotis
      });
    };
    this.markNotificationAsRead = async (notificationId, token) => {
      const { data } = await this.notificationApi.put(`/notification/${notificationId}/mark-read`, {
        token
      });
      return data;
    };
    this.unreadCount = async (params) => {
      const { data } = await this.notificationApi.get("/notification/count-unread", {
        params: services_es_spreadValues({}, params)
      });
      return data == null ? void 0 : data.data;
    };
    this.registerToken = async (params) => {
      await this.notificationApi.post("notification/register-token", params);
    };
    this.unRegisterToken = async (params) => {
      await this.notificationApi.post("notification/unregister-token", params);
    };
    this.markReadAll = async (params) => {
      await this.notificationApi.put("notification/mark-read-all", params);
    };
    this.notificationApi = new index_es["default"](notificationApiUrl);
    if (typeof getCustomAccessToken === "function") {
      this.notificationApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.notificationApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.notificationApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
}



;// CONCATENATED MODULE: ../../packages/pin/dist/service.es.js



class PinService {
  constructor(iamIdentityApiUrl, getCustomAccessToken) {
    this.pinApi = new index_es["default"](iamIdentityApiUrl);
    if (typeof getCustomAccessToken === "function") {
      this.pinApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.pinApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.pinApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  async initPinSetup(params) {
    const { data } = await this.pinApi.post("/v1/pin/setup", params);
    return data;
  }
  async confirmAndSavePin(params) {
    const { data } = await this.pinApi.post("/v1/pin/confirm", params);
    return data;
  }
  async verifyPin(params) {
    const { data } = await this.pinApi.post("/v1/pin/verify", params);
    return data;
  }
}



;// CONCATENATED MODULE: ../../packages/privacy-policy/dist/service.es.js



class PrivacyPolicyService {
  constructor(privacyPolicyApiUrl, platformId, language) {
    this.privacyPolicyApi = new index_es["default"](privacyPolicyApiUrl);
    this.platformId = platformId;
    this.privacyPolicyApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    this.privacyPolicyApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    this.privacyPolicyApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  async getPolicies(policyFilter) {
    var _a;
    const { data } = await this.privacyPolicyApi.get("/users/policies", {
      params: { sellerPlatformId: this.platformId, policyFilter }
    });
    return ((_a = data.data) == null ? void 0 : _a.policies) || [];
  }
  async submitPolicies(policies) {
    await this.privacyPolicyApi.post("/users/policies", {
      submitPolicies: policies
    });
  }
}



;// CONCATENATED MODULE: ../../packages/user/dist/error.es.js


const error_es_getError = (res) => {
  return new index_es.ApiError("", 400, res);
};



;// CONCATENATED MODULE: ../../packages/user/dist/service.es.js




var dist_service_es_defProp = Object.defineProperty;
var dist_service_es_defProps = Object.defineProperties;
var dist_service_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var dist_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var dist_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var dist_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var dist_service_es_defNormalProp = (obj, key, value) => key in obj ? dist_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var dist_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (dist_service_es_hasOwnProp.call(b, prop))
      dist_service_es_defNormalProp(a, prop, b[prop]);
  if (dist_service_es_getOwnPropSymbols)
    for (var prop of dist_service_es_getOwnPropSymbols(b)) {
      if (dist_service_es_propIsEnum.call(b, prop))
        dist_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var dist_service_es_spreadProps = (a, b) => dist_service_es_defProps(a, dist_service_es_getOwnPropDescs(b));
const normalizeData = (responseAddresses) => {
  return responseAddresses.map((addr) => dist_service_es_spreadProps(dist_service_es_spreadValues({}, addr), { addressId: addr.id }));
};
class UserService {
  constructor(userServiceUrl, platformCode, platformId, getCustomAccessToken) {
    this.myProfile = async (params = {}) => {
      var _a;
      const { data } = await this.userApi.get("/profiles", {
        params: this.getParams(params)
      });
      return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.profile;
    };
    this.updateProfile = async (body) => {
      var _a;
      const { data } = await this.userApi.patch("/profiles", body, {
        params: this.getParams({})
      });
      return (_a = data == null ? void 0 : data.result) == null ? void 0 : _a.profile;
    };
    this.getClient = async () => {
      var _a;
      const { data } = await this.userApi.get(`/clients?platformIds=${this.platformId}`);
      return (_a = data.result) == null ? void 0 : _a.clients;
    };
    this.updateBillings = async (body) => {
      const { data } = await this.userApi.post("/billings", body, {
        params: this.getParams({})
      });
      return data;
    };
    this.getMyAddresses = async () => {
      const {
        data: {
          result: { addresses }
        }
      } = await this.userApi.get("/addresses", {
        params: this.getParams({})
      });
      return normalizeData(addresses);
    };
    this.createAddress = async (address) => {
      const {
        data: {
          result: { address: addressResp }
        }
      } = await this.userApi.post("/addresses", dist_service_es_spreadProps(dist_service_es_spreadValues({}, address), {
        platformId: this.platformId
      }));
      return addressResp;
    };
    this.updateAddress = async (addressId, address) => {
      await this.userApi.patch(`/addresses/${addressId}`, dist_service_es_spreadProps(dist_service_es_spreadValues({}, address), {
        platformId: this.platformId
      }));
    };
    this.getAddress = async (addressId) => {
      const {
        data: {
          result: { address }
        }
      } = await this.userApi.get(`/addresses/${addressId}`);
      return address;
    };
    this.deleteAddress = async (addressId) => {
      const { data } = await this.userApi.delete(`/addresses/${addressId}`);
      return data;
    };
    this.viewPoint = async () => {
      return await this.userApi.get("/loyalty/viewpoint", {
        params: this.getParams({})
      });
    };
    this.registerLoyaltyMember = async (data) => {
      return await this.userApi.post("/loyalty/members", data, {
        params: this.getParams({})
      });
    };
    this.getRefCodeInfo = async (refCode) => {
      return this.userApi.get(`/dealer_farmer/ref/${refCode}`).then((res) => res.data);
    };
    this.confirmFarmer = async (refCode) => {
      return this.userApi.post("/dealer_farmer/confirm", {
        referenceCode: refCode
      });
    };
    this.upsertProfile = async (profileUpsertObject) => {
      const { data } = await this.userApi.post("/profiles/upsert", profileUpsertObject, {
        params: this.getParams({})
      });
      return data == null ? void 0 : data.data;
    };
    this.searchProfile = async (params = {}) => {
      const { data } = await this.userApi.get("/profiles/search", {
        params: this.getParams(params)
      });
      return data == null ? void 0 : data.data;
    };
    this.customerTypes = async (params = {}) => {
      const { data } = await this.userApi.get("/customer-types", {
        params: this.getParams(params)
      });
      return data;
    };
    this.getProfileDetail = async (profileId) => {
      const { data } = await this.userApi.get(`/profiles/${profileId}`, {
        params: this.getParams({})
      });
      return data == null ? void 0 : data.data;
    };
    this.userApi = new index_es["default"](userServiceUrl, error_es_getError);
    this.platformCode = platformCode;
    this.platformId = platformId;
    if (typeof getCustomAccessToken === "function") {
      this.userApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.userApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.userApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  getParams(params) {
    return dist_service_es_spreadValues(dist_service_es_spreadValues(dist_service_es_spreadValues({}, !!this.platformCode ? { platformCode: this.platformCode } : {}), !!this.platformId ? { platformId: this.platformId } : {}), params);
  }
}



;// CONCATENATED MODULE: ../../packages/warehouse/dist/service.es.js



var warehouse_dist_service_es_defProp = Object.defineProperty;
var warehouse_dist_service_es_defProps = Object.defineProperties;
var warehouse_dist_service_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var warehouse_dist_service_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var warehouse_dist_service_es_hasOwnProp = Object.prototype.hasOwnProperty;
var warehouse_dist_service_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var warehouse_dist_service_es_defNormalProp = (obj, key, value) => key in obj ? warehouse_dist_service_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var warehouse_dist_service_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (warehouse_dist_service_es_hasOwnProp.call(b, prop))
      warehouse_dist_service_es_defNormalProp(a, prop, b[prop]);
  if (warehouse_dist_service_es_getOwnPropSymbols)
    for (var prop of warehouse_dist_service_es_getOwnPropSymbols(b)) {
      if (warehouse_dist_service_es_propIsEnum.call(b, prop))
        warehouse_dist_service_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var warehouse_dist_service_es_spreadProps = (a, b) => warehouse_dist_service_es_defProps(a, warehouse_dist_service_es_getOwnPropDescs(b));
class WarehouseService {
  constructor(apiUrl) {
    this.getReturnRequests = async ({
      orderId,
      terminalCode,
      discoveryService,
      platformId
    }) => {
      const { data } = await this.warehouseApi.get(`/return-requests`, {
        params: {
          orderIds: orderId,
          sortLatest: true,
          platformId
        }
      });
      const res = data == null ? void 0 : data.request;
      const allItemSkus = (res == null ? void 0 : res.reduce((skus, req) => {
        skus.push(...req.items.map((item) => item.sku));
        return skus;
      }, [])) || [];
      if (allItemSkus.length > 0) {
        const products = await discoveryService.getProductDetailBySkus({
          skus: Array.from(new Set(allItemSkus)),
          terminalCode
        });
        return res.map((req) => {
          return warehouse_dist_service_es_spreadProps(warehouse_dist_service_es_spreadValues({}, req), {
            items: req.items.map((item) => {
              var _a;
              const product = products.find((product2) => product2.productInfo.sku === item.sku);
              return warehouse_dist_service_es_spreadProps(warehouse_dist_service_es_spreadValues({}, item), {
                imageUrl: ((_a = product == null ? void 0 : product.productInfo) == null ? void 0 : _a.imageUrl) || ""
              });
            })
          });
        });
      }
      return res;
    };
    this.getReturnReasons = async (platformId, isStaffOnly) => {
      const { data } = await this.warehouseApi.get(`/return-reasons`, {
        params: {
          platformId,
          status: "RETURN_REASON_STATUS_ACTIVE",
          isStaffOnly,
          limit: 200
        }
      });
      return (data == null ? void 0 : data.reasons) || [];
    };
    this.addReturnRequest = async (orderId, requestPayload) => {
      const payload = warehouse_dist_service_es_spreadValues({
        orderId
      }, requestPayload);
      return await this.warehouseApi.post(`/return-request`, {
        data: payload
      });
    };
    this.warehouseApi = new index_es["default"](apiUrl);
    this.warehouseApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    this.warehouseApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
}



;// CONCATENATED MODULE: ../../packages/warehouse/dist/index.es.js


// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
;// CONCATENATED MODULE: ./lazy-modules/order.ts
class OrderServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            this.servicePromise = __webpack_require__.e(/* import() */ 56100).then(__webpack_require__.bind(__webpack_require__, 856100)).then((mod)=>new mod.OrderService(this.baseUrl, this.language));
        }
        return this.servicePromise;
    }
    async getOrder(params) {
        const service = await this.initializeService();
        return service.getOrder(params);
    }
    async getOrders(params) {
        const service = await this.initializeService();
        return service.getOrders(params);
    }
    async getOrderDetail(params) {
        const service = await this.initializeService();
        return service.getOrderDetail(params);
    }
    async importOrder(orderId) {
        const service = await this.initializeService();
        return service.importOrder(orderId);
    }
    async updateVatInfo(orderId, vatInfo) {
        const service = await this.initializeService();
        return service.updateVatInfo(orderId, vatInfo);
    }
    async updateOrderVatInfo(orderId, vatInfo) {
        const service = await this.initializeService();
        return service.updateOrderVatInfo(orderId, vatInfo);
    }
    async getPromotions(params) {
        const service = await this.initializeService();
        return service.getPromotions(params);
    }
    async getOrderDetailV2(orderId, platformId) {
        const service = await this.initializeService();
        return service.getOrderDetailV2(orderId, platformId);
    }
    async getOrdersV2(params) {
        const service = await this.initializeService();
        return service.getOrdersV2(params);
    }
    async getUserTerminal(params) {
        const service = await this.initializeService();
        return service.getUserTerminal(params);
    }
    async getTerminal(params) {
        const service = await this.initializeService();
        return service.getTerminal(params);
    }
    async getPriorityTerminal(params) {
        const service = await this.initializeService();
        return service.getPriorityTerminal(params);
    }
    async getListOfTerminals(params) {
        const service = await this.initializeService();
        return service.getListOfTerminals(params);
    }
    async getListOfTerminalsByLocation(params) {
        const service = await this.initializeService();
        return service.getListOfTerminalsByLocation(params);
    }
    async getTerminalsByAddress(params) {
        const service = await this.initializeService();
        return service.getTerminalsByAddress(params);
    }
    async getReturnReasonsList(platformId) {
        const service = await this.initializeService();
        return service.getReturnReasonsList(platformId);
    }
    async requestCancelOrder(body) {
        const service = await this.initializeService();
        return service.requestCancelOrder(body);
    }
    constructor(baseUrl, language){
        this.baseUrl = baseUrl;
        this.language = language;
    }
}
/* harmony default export */ var order = (OrderServiceWrapper);

;// CONCATENATED MODULE: ./lazy-modules/payment.ts
class PaymentBffServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            const baseUrl = this.baseUrl;
            this.servicePromise = Promise.all(/* import() */[__webpack_require__.e(502), __webpack_require__.e(47523), __webpack_require__.e(9599), __webpack_require__.e(67452), __webpack_require__.e(88512)]).then(__webpack_require__.bind(__webpack_require__, 886687)).then((mod)=>new mod.PaymentBffService(baseUrl, this.language));
        }
        return this.servicePromise;
    }
    async createPaymentAIO(request) {
        const service = await this.initializeService();
        return service.createPaymentAIO(request);
    }
    async getInstallmentTerms(merchantMethodCode, amount) {
        const service = await this.initializeService();
        return service.getInstallmentTerms(merchantMethodCode, amount);
    }
    constructor(baseUrl, language){
        this.baseUrl = baseUrl;
        this.language = language;
    }
}
class PaymentServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            const params = this.constructorParams;
            this.servicePromise = Promise.all(/* import() */[__webpack_require__.e(502), __webpack_require__.e(47523), __webpack_require__.e(9599), __webpack_require__.e(67452), __webpack_require__.e(88512)]).then(__webpack_require__.bind(__webpack_require__, 886687)).then((mod)=>new mod.PaymentService(params.baseUrl, params.secretKey, params.paymentSettingUrl));
        }
        return this.servicePromise;
    }
    async initPaymentAIOOffline(body) {
        const service = await this.initializeService();
        return service.initPaymentAIOOffline(body);
    }
    async initPaymentAIOnline(body) {
        const service = await this.initializeService();
        return service.initPaymentAIOnline(body);
    }
    async getBanks() {
        const service = await this.initializeService();
        return service.getBanks();
    }
    async getBankAccounts() {
        const service = await this.initializeService();
        return service.getBankAccounts();
    }
    async requestCreateToken(merchantCode, userId, cartType, successUrl, cancelUrl) {
        const service = await this.initializeService();
        return service.requestCreateToken(merchantCode, userId, cartType, successUrl, cancelUrl);
    }
    async requestRemoveToken(merchantMethodCode, userId, token) {
        const service = await this.initializeService();
        return service.requestRemoveToken(merchantMethodCode, userId, token);
    }
    constructor(params){
        this.constructorParams = params;
    }
}


;// CONCATENATED MODULE: ./lazy-modules/loyalty.ts
class LoyaltyBFFServiceWrapper {
    async initializeService() {
        if (!this.service) {
            const { LoyaltyBFFService  } = await __webpack_require__.e(/* import() */ 19277).then(__webpack_require__.bind(__webpack_require__, 19277));
            this.service = new LoyaltyBFFService(this.baseUrl, this.clientId, this.language);
        }
        this.service.setClientId(this.clientId);
    }
    async setClientId(clientId) {
        this.clientId = clientId;
        if (!this.service) {
            await this.initializeService();
        } else {
            this.service.setClientId(clientId);
        }
    }
    getClientId() {
        return this.clientId;
    }
    async createMember(params) {
        await this.initializeService();
        return this.service.createMember(params);
    }
    async getExistedMemberCardsByPhone() {
        await this.initializeService();
        return this.service.getExistedMemberCardsByPhone();
    }
    async linkExistedMembership(params) {
        await this.initializeService();
        return this.service.linkExistedMembership(params);
    }
    async getLinkProfileSendOTP(params) {
        await this.initializeService();
        return this.service.getLinkProfileSendOTP(params);
    }
    async getLinkProfileVerifyOTP(params) {
        await this.initializeService();
        return this.service.getLinkProfileVerifyOTP(params);
    }
    async getLoyaltyMemberInfo() {
        await this.initializeService();
        return this.service.getLoyaltyMemberInfo();
    }
    async getTransactionsHistory(txnType, pageNumber, pageSize, fromTime, toTime) {
        await this.initializeService();
        return this.service.getTransactionsHistory(txnType, pageNumber, pageSize, fromTime, toTime);
    }
    async getNetworkConfig() {
        await this.initializeService();
        return this.service.getNetworkConfig();
    }
    async registerMember(payload) {
        await this.initializeService();
        return this.service.registerMember(payload);
    }
    async getListExpiryRules(params) {
        await this.initializeService();
        return this.service.getListExpiryRules(params);
    }
    async unlinkProfile() {
        await this.initializeService();
        return this.service.unlinkProfile();
    }
    constructor(baseUrl, clientId, language){
        this.baseUrl = baseUrl;
        this.clientId = clientId;
        this.language = language || "*";
    }
}
/* harmony default export */ var loyalty = (LoyaltyBFFServiceWrapper);

;// CONCATENATED MODULE: ./lazy-modules/quotation.ts
class QuotationServiceWrapper {
    async initializeService() {
        if (!this.servicePromise) {
            this.servicePromise = __webpack_require__.e(/* import() */ 61493).then(__webpack_require__.bind(__webpack_require__, 561493)).then((mod)=>new mod.QuotationService());
        }
        return this.servicePromise;
    }
    async getOrderDetailByToken(params) {
        const service = await this.initializeService();
        return service.getOrderDetailByToken(params);
    }
}
/* harmony default export */ var quotation = (QuotationServiceWrapper);

;// CONCATENATED MODULE: ./helpers/service-provider.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













class ServiceContainer {
    get authService() {
        if (!this._authService) {
            const iamApiUrl = this.tenantConfig.getProcessEnv("IAM_API_URL");
            const iamClientId = this.tenantConfig.iamClientId || this.tenantConfig.getProcessEnv("NEXT_PUBLIC_IAM_CLIENT_ID");
            const iamOauthDomain = this.tenantConfig.iamOauthDomain || this.tenantConfig.getProcessEnv("NEXT_PUBLIC_IAM_OAUTH_DOMAIN");
            this._authService = new service_es/* AuthService */.e(iamApiUrl, iamClientId, iamOauthDomain);
        }
        return this._authService;
    }
    get userService() {
        if (!this._userService) {
            this._userService = new UserService(this.tenantConfig.getProcessEnv("NEXT_PUBLIC_BASE_USER_SERVICE_URL"), undefined, this.tenantConfig.platformId);
        }
        return this._userService;
    }
    get discoveryService() {
        if (!this._discoveryService) {
            const publicDiscoveryEndpoint = this.tenantConfig.getProcessEnv("BASE_DISCOVERY_URL");
            const internalDiscoveryEndpoint = this.tenantConfig.getProcessEnv("INTERNAL_DISCOVERY_URL");
            const useTerminalId = this.tenantConfig.getProcessEnv("EPIC_ECOM_284") || !!this.tenantConfig.useTerminalId;
            // use internal discovery endpoint
            // for server side rendering
            this._discoveryService = new DiscoveryService( false ? 0 : publicDiscoveryEndpoint, useTerminalId ? this.tenantConfig.terminalId : undefined, !useTerminalId ? this.tenantConfig.terminal : undefined, this.tenantConfig.currentLanguage);
        }
        return this._discoveryService;
    }
    get discoveryServiceV2() {
        if (!this._disicoveryServiceV2) {
            const publicDiscoveryEndpoint = this.tenantConfig.getProcessEnv("BASE_DISCOVERY_V2_URL");
            const internalDiscoveryEndpoint = this.tenantConfig.getProcessEnv("INTERNAL_DISCOVERY_V2_URL");
            // use internal discovery endpoint
            // for server side rendering
            this._disicoveryServiceV2 = new service_es_DiscoveryService( false ? 0 : publicDiscoveryEndpoint, this.tenantConfig.terminalId, this.tenantConfig.currentLanguage, this.tenantConfig.location);
        }
        return this._disicoveryServiceV2;
    }
    get discoveryPos365Service() {
        if (!this._discoveryPos365Service) {
            const useTerminalId = this.tenantConfig.getProcessEnv("EPIC_ECOM_284") || !!this.tenantConfig.useTerminalId;
            this._discoveryPos365Service = new DiscoveryService(this.tenantConfig.getProcessEnv("BASE_POS365_DISCOVERY_URL"), useTerminalId ? this.tenantConfig.terminalId : undefined, !useTerminalId ? this.tenantConfig.terminal : undefined, this.tenantConfig.currentLanguage);
        }
        return this._discoveryPos365Service;
    }
    get cartService() {
        if (!this._cartService) {
            this._cartService = new dist_service_es/* CartService */.Ni(this.tenantConfig.getProcessEnv("BASE_CART_API_URL"), undefined, this.tenantConfig.currentLanguage);
        }
        return this._cartService;
    }
    get cartServiceV2() {
        if (!this._cartServiceV2) {
            var ref;
            const useTerminalId = this.tenantConfig.getProcessEnv("EPIC_ECOM_284") || !!this.tenantConfig.useTerminalId;
            const endpoint = (0,helpers/* isServerless */.ep)() ? this.tenantConfig.getProcessEnv("BASE_CART_API_URL") : this.tenantConfig.getProcessEnv("INTERNAL_CART_API_URL");
            this._cartServiceV2 = new CartService(endpoint, _objectSpread({
                language: this.tenantConfig.currentLanguage,
                location: this.tenantConfig.location,
                useComboV2: !!this.tenantConfig.epicOmni1286,
                useExclusionV2: !!((ref = this.tenantConfig.featureFlags) === null || ref === void 0 ? void 0 : ref.epic_omni_1403) && !!this.tenantConfig.epicOmni1403
            }, useTerminalId ? {
                terminalId: this.tenantConfig.terminalId
            } : {
                terminal: this.tenantConfig.terminal
            }));
        }
        return this._cartServiceV2;
    }
    get locationService() {
        if (!this._locationService) {
            this._locationService = new location_dist_index_es/* LocationService */.aU(this.tenantConfig.getProcessEnv("BASE_LOCATION_URL"));
        }
        return this._locationService;
    }
    get locationServiceV2() {
        if (!this._locationServiceV2) {
            this._locationServiceV2 = new location_dist_index_es/* LocationService */.aU(this.tenantConfig.getProcessEnv("BASE_LOCATION_V2_URL"));
        }
        return this._locationServiceV2;
    }
    get locationServiceV3() {
        if (!this._locationServiceV3) {
            this._locationServiceV3 = new location_dist_index_es/* LocationService */.aU(this.tenantConfig.getProcessEnv("BASE_LOCATION_V3_URL"));
        }
        return this._locationServiceV3;
    }
    get orderService() {
        if (!this._orderService) {
            this._orderService = new order(this.tenantConfig.getProcessEnv("BASE_COV_URL"), this.tenantConfig.currentLanguage);
        }
        return this._orderService;
    }
    get pinService() {
        if (!this._pinService) {
            this._pinService = new PinService(this.tenantConfig.getProcessEnv("IAM_API_URL"));
        }
        return this._pinService;
    }
    get notificationService() {
        if (!this._notificationService) {
            this._notificationService = new NotificationService(this.tenantConfig.getProcessEnv("BASE_NOTIFICATIONS_API"));
        }
        return this._notificationService;
    }
    get warehouseService() {
        if (!this._warehouseService) {
            this._warehouseService = new WarehouseService(this.tenantConfig.getProcessEnv("BASE_WAREHOUSE_CONSUMER_API_URL"));
        }
        return this._warehouseService;
    }
    get paymentService() {
        if (!this._paymentService) {
            this._paymentService = new PaymentServiceWrapper({
                baseUrl: this.tenantConfig.getProcessEnv("BASE_PAYMENT_API_URL"),
                secretKey: this.tenantConfig.paymentSecretKey || this.tenantConfig.getProcessEnv("PAYMENT_SECRET_KEY"),
                paymentSettingUrl: this.tenantConfig.getProcessEnv("BASE_MAIN_PAYMENT_API_URL")
            });
        }
        return this._paymentService;
    }
    get paymentBffService() {
        if (!this._paymentBffService) {
            this._paymentBffService = new PaymentBffServiceWrapper(this.tenantConfig.getProcessEnv("BASE_PAYMENT_BFF_API_URL"), this.tenantConfig.currentLanguage);
        }
        return this._paymentBffService;
    }
    get loyaltyBFFService() {
        if (!this._loyaltyBFFService) {
            this._loyaltyBFFService = new loyalty(this.tenantConfig.getProcessEnv("BASE_LOYALTY_BFF_API_URL"), this.tenantConfig.getProcessEnv("LOYALTY_CLIENT_ID"), this.tenantConfig.currentLanguage);
        }
        return this._loyaltyBFFService;
    }
    get publicQuotataionOrderService() {
        if (!this._publicQuotationOrderService) {
            this._publicQuotationOrderService = new quotation();
        }
        return this._publicQuotationOrderService;
    }
    get discoveryHelper() {
        if (!this._discoveryHelper) {
            this._discoveryHelper = new discovery/* DiscoveryHelper */.LB(this.tenantConfig);
        }
        return this._discoveryHelper;
    }
    get privacyPolicyService() {
        if (!this._privacyPolicyService) {
            this._privacyPolicyService = new PrivacyPolicyService(this.tenantConfig.getProcessEnv("BASE_PRIVACY_POLICY_API_URL"), this.tenantConfig.platformId, this.tenantConfig.currentLanguage);
        }
        return this._privacyPolicyService;
    }
    constructor(tenantConfig){
        this.tenantConfig = tenantConfig;
    }
}


/***/ }),

/***/ 118042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ onSignOut; },
/* harmony export */   "h": function() { return /* binding */ clearStorageOnSignout; }
/* harmony export */ });
/* harmony import */ var _modules_notification_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(907276);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(451765);


const clearStorageOnSignout = ()=>{
    [
        _constants__WEBPACK_IMPORTED_MODULE_0__/* .LOCAL_STORAGE_SUBMIT_PRIVACY_POLICIES */ .i7,
        _constants__WEBPACK_IMPORTED_MODULE_0__/* .LOCAL_STORAGE_ALLOWED_PRIVACY_POLICY */ .Hg, 
    ].forEach((lsKey)=>localStorage.removeItem(lsKey));
};
const onSignOut = async (authService, notificationService, notificationAppId, redirectUrl)=>{
    (0,_modules_notification_helper__WEBPACK_IMPORTED_MODULE_1__/* .unregisterUNS */ .$l)(notificationService, notificationAppId);
    authService.logout(redirectUrl);
    clearStorageOnSignout();
};


/***/ }),

/***/ 858045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iq": function() { return /* binding */ tInputPlaceholder; },
/* harmony export */   "Kt": function() { return /* binding */ tSelectPlaceholder; },
/* harmony export */   "bb": function() { return /* binding */ translateObject; }
/* harmony export */ });
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(634655);

// @ts-ignore
function translateObject(o) {
    if (typeof o === "string" && !ignorePrefixes.some((prefix)=>o.startsWith(prefix))) {
        return (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)(o);
    }
    if (typeof o === "object") {
        // handle Array
        if (Array.isArray(o)) {
            // @ts-ignore
            return o.map((item)=>translateObject(item));
        }
        // handle object
        const newObject = {};
        for (const [k, v] of Object.entries(o)){
            newObject[k] = translateObject(v);
        }
        return newObject;
    }
    return o;
}
// if value is string and starts with one of these texts, return original value
const ignorePrefixes = [
    "http",
    "tel:",
    "mailto:"
];
const tInputPlaceholder = function(text) {
    let originFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)("EnterPlaceholder", {
        field: originFormat ? (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)(text) : (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)(text).toLowerCase()
    });
};
const tSelectPlaceholder = function(text) {
    let originFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)("SelectPlaceholder", {
        field: originFormat ? (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)(text) : (0,i18n__WEBPACK_IMPORTED_MODULE_0__.t)(text).toLowerCase()
    });
};


/***/ }),

/***/ 700074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useBanners; }
/* harmony export */ });
/* harmony import */ var _services_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(427342);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);




const useBanners = (zone)=>{
    const { terminal  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { data , error , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)([
        "/banner/search",
        zone,
        terminal
    ], async ()=>{
        return await _services_search__WEBPACK_IMPORTED_MODULE_3__/* .searchService.getBannerByZone */ .u.getBannerByZone(zone, terminal);
    }, {
        fallbackData: [],
        onError: (e)=>{
            _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e, "getBannerByZone error");
            return [];
        }
    });
    return {
        banners: data || [],
        loading: !zone || !terminal ? false : !error && !data || isValidating
    };
};


/***/ }),

/***/ 886091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useDebounceValue; }
/* harmony export */ });
/* unused harmony export useDebounce */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useDebounce = (callback, delay)=>{
    const latestCallback = useRef();
    const latestTimeout = useRef();
    useEffect(()=>{
        latestCallback.current = callback;
    }, [
        callback
    ]);
    return ()=>{
        if (latestTimeout.current) {
            clearTimeout(latestTimeout.current);
        }
        latestTimeout.current = setTimeout(()=>{
            var ref;
            (ref = latestCallback.current) === null || ref === void 0 ? void 0 : ref.call(latestCallback);
        }, delay);
    };
};
// debounce value can be anything
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebounceValue = (value, delay)=>{
    const { 0: debouncedValue , 1: setDebouncedValue  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};


/***/ }),

/***/ 88837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uD": function() { return /* binding */ useDiscovery_useDiscoveryProduct; },
  "b9": function() { return /* binding */ useDiscovery_useDiscoverySearch; },
  "nC": function() { return /* binding */ useInfiniteSearch; },
  "yz": function() { return /* binding */ useDiscovery_usePersonalizeBlocks; },
  "lR": function() { return /* binding */ useRecommendationComboDetail; },
  "jG": function() { return /* binding */ useRecommendationCombosData; },
  "mF": function() { return /* binding */ useRecommendationProductsData; },
  "Rx": function() { return /* binding */ useSearch; },
  "TA": function() { return /* binding */ useDiscovery_useSkus; }
});

// UNUSED EXPORTS: useInfiniteDiscoverySearch

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/infinite/dist/index.esm.js
var dist_index_esm = __webpack_require__(382725);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/helpers.es.js
var helpers_es = __webpack_require__(77829);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/types.es.js
var types_es = __webpack_require__(875663);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/hooks.es.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearch = (discoveryService, params, location, options) => {
  const _a = params || {}, searchParams = __objRest(_a, ["sorting"]);
  const _b = options || {}, {
    transformProduct = (data2) => data2
  } = _b, swrConfigs = __objRest(_b, [
    "transformProduct"
  ]);
  const keyAPI = (0,helpers_es/* getKeyAPI */.jG)(params, discoveryService.getBaseUrl());
  const normalizedParams = (0,helpers_es/* normalizePageBuilderToDiscoveryParams */.nS)(searchParams);
  const { data, error } = (0,index_esm/* default */.ZP)(keyAPI, async () => {
    const { sellerIds } = params;
    let newSellerIds = sellerIds;
    if (Array.isArray(sellerIds) && typeof sellerIds[0] === "number") {
      newSellerIds = sellerIds.map((id) => id.toString());
    }
    const response = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      sellerIds: newSellerIds,
      location
    }));
    return __spreadProps(__spreadValues({}, response), {
      result: __spreadProps(__spreadValues({}, response.result), {
        products: response.result.products.map(transformProduct)
      })
    });
  }, __spreadProps(__spreadValues({}, swrConfigs), {
    revalidateOnFocus: false
  }));
  const result = data == null ? void 0 : data.result;
  return {
    result: {
      products: (result == null ? void 0 : result.products) || [],
      filters: (result == null ? void 0 : result.filter) || {},
      pagination: (data == null ? void 0 : data.pagination) || {},
      cookedFilters: (0,helpers_es/* cookFilter */.BR)(result == null ? void 0 : result.filter, normalizedParams, result == null ? void 0 : result.masterCategories)
    },
    isLoading: !params ? false : !error && !data,
    isError: error
  };
};
const useInfiniteDiscoverySearch = (discoveryService, params, options) => {
  var _c;
  const _a = options || {}, {
    transformProduct = (data2) => data2
  } = _a, swrOptions = __objRest(_a, [
    "transformProduct"
  ]);
  const getKey = (pageIndex) => {
    const _a2 = params, rest2 = __objRest(_a2, ["page"]);
    return [rest2, pageIndex];
  };
  const convertSearchResponse = (response) => {
    var _a2, _b2;
    return {
      products: (((_a2 = response.result) == null ? void 0 : _a2.products) || []).map(transformProduct),
      suggestedKeyword: (_b2 = response.result) == null ? void 0 : _b2.suggestedKeyword,
      pagination: response.pagination
    };
  };
  const _b = useSWRInfinite(getKey, async (_params, index) => {
    const response = await discoveryService.search(__spreadProps(__spreadValues({}, params), {
      page: parseInt(params.page || "1") + index
    }));
    return convertSearchResponse(response);
  }, swrOptions), { data, isValidating, size, setSize } = _b, rest = __objRest(_b, ["data", "isValidating", "size", "setSize"]);
  const isEmpty = data && data[0].products.length === 0;
  const hasMore = !(isEmpty || data && data[data.length - 1] && data[data.length - 1].products.length < (params.itemsPerPage || 10));
  const products = data ? data.reduce((acc, curr) => {
    return [...acc, ...curr.products];
  }, []) : [];
  const cookedData = data == null ? void 0 : data[0];
  const pagination = (data == null ? void 0 : data.length) ? (_c = data[data.length - 1]) == null ? void 0 : _c.pagination : void 0;
  return __spreadValues({
    isEmpty: !!isEmpty,
    isLoading: isValidating,
    hasMore,
    size,
    setSize,
    products,
    suggestedKeyword: cookedData == null ? void 0 : cookedData.suggestedKeyword,
    isValidating,
    pagination
  }, rest);
};
const useDiscoveryProduct = (discoveryService, sku, location) => {
  const { data, error } = useSWR(!!sku ? [`${discoveryService.getBaseUrl}/product`, sku, location] : null, async (_, sku2, location2) => {
    return await discoveryService.getProduct({
      sku: sku2,
      location: location2
    });
  });
  return {
    result: {
      product: data || null
    },
    isLoading: !error && !data,
    isError: !!error
  };
};
const usePersonalizeBlocks = (discoveryService, blockParams, transformBlock) => {
  var _a, _b;
  const { pageTypeEnum, category, seller, brand, sellerCategory } = blockParams;
  const params = (0,index_es.cleanObject)(__spreadValues({}, blockParams));
  const conditionFetching = pageTypeEnum === types_es/* PageTypeEnum.HOME */.DZ.HOME || types_es/* PageTypeEnum.NOTIFICATION */.DZ.NOTIFICATION || pageTypeEnum === types_es/* PageTypeEnum.CATEGORY */.DZ.CATEGORY && (category || sellerCategory) || pageTypeEnum === types_es/* PageTypeEnum.BRAND */.DZ.BRAND && brand || pageTypeEnum === types_es/* PageTypeEnum.SELLER */.DZ.SELLER && seller;
  const { data, error } = (0,index_esm/* default */.ZP)(conditionFetching ? [`${discoveryService.getBaseUrl}/blocks`, JSON.stringify(params)] : null, async (_, paramsJson) => {
    return await discoveryService.getBlock(JSON.parse(paramsJson));
  }, {
    revalidateOnFocus: false
  });
  return {
    result: (((_a = data == null ? void 0 : data.result) == null ? void 0 : _a.blocks) || []).map(transformBlock),
    seoInfo: ((_b = data == null ? void 0 : data.result) == null ? void 0 : _b.seoInfo) || {},
    isLoading: !error && !data,
    isError: error
  };
};
const useSkus = (discoveryService, skus, location) => {
  const { data, error } = (0,index_esm/* default */.ZP)(skus ? [`${discoveryService.getBaseUrl}/products`, skus.join(","), location] : null, async (_, skus2, location2) => {
    return await discoveryService.getProductDetailBySkus({
      skus: skus2,
      location: location2
    });
  });
  return {
    result: {
      products: data || []
    },
    isLoading: !skus ? false : !error && !data,
    isError: error
  };
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/useDiscoverySearch.es.js
var useDiscoverySearch_es = __webpack_require__(232771);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-discovery-virtual-9984fbafec/1/packages/discovery/dist/v2/useInfiniteDiscoverySearch.es.js
var useInfiniteDiscoverySearch_es = __webpack_require__(14643);
// EXTERNAL MODULE: ./components/WishlistButton.tsx
var WishlistButton = __webpack_require__(288257);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./contexts/RelatedProductContext.tsx + 1 modules
var RelatedProductContext = __webpack_require__(725965);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./helpers/block.ts
var block = __webpack_require__(997441);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts + 2 modules
var useHandlerUnderEighteenYearOld = __webpack_require__(725530);
;// CONCATENATED MODULE: ./hooks/useDiscovery.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}













const checkAlcoholicProduct = (product)=>{
    var ref, ref1;
    if (!product) return product;
    let sellerCatCodes = [];
    const categories = (product === null || product === void 0 ? void 0 : (ref = product.productInfo) === null || ref === void 0 ? void 0 : ref.categories) || [];
    const masterCategories = (product === null || product === void 0 ? void 0 : (ref1 = product.productInfo) === null || ref1 === void 0 ? void 0 : ref1.masterCategories) || [];
    sellerCatCodes = categories.concat(masterCategories);
    return _objectSpreadProps(_objectSpread({}, product), {
        isAlcoholicCategory: sellerCatCodes.some((item)=>item.isAdult)
    });
};
const useDiscovery_useDiscoverySearch = (params, options)=>{
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const resultRef = (0,react.useRef)((options === null || options === void 0 ? void 0 : options.fallbackData) ? options === null || options === void 0 ? void 0 : options.fallbackData : {
        products: [],
        pagination: {
            totalItems: 0,
            totalPages: 1
        },
        filters: {}
    });
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService , discoveryPos365Service  } = (0,ServiceContext/* useServices */.Su)();
    const _ref = useDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, location, _objectSpreadProps(_objectSpread({}, options), {
        fallbackData: null,
        transformProduct: options === null || options === void 0 ? void 0 : options.transformProduct
    })), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const { isLoading  } = rest;
    const persistentData = isLoading ? resultRef.current : result;
    resultRef.current = persistentData;
    return _objectSpread({
        result: _objectSpreadProps(_objectSpread({}, persistentData), {
            products: persistentData === null || persistentData === void 0 ? void 0 : persistentData.products
        })
    }, rest);
};
const useDiscovery_useInfiniteDiscoverySearch = (params, options)=>{
    const { discoveryService , discoveryPos365Service  } = useServices();
    const _ref = useEcomInfiniteDiscoverySearch((params === null || params === void 0 ? void 0 : params.pos365StoreCode) ? discoveryPos365Service : discoveryService, params, _objectSpreadProps(_objectSpread({}, options), {
        transformProduct: options === null || options === void 0 ? void 0 : options.transformProduct
    })), { products  } = _ref, rest = _objectWithoutProperties(_ref, [
        "products"
    ]);
    return _objectSpread({
        products
    }, rest);
};
const useDiscovery_useDiscoveryProduct = (sku, productId, options)=>{
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const productRef = (0,react.useRef)((options === null || options === void 0 ? void 0 : options.fallbackData) ? options === null || options === void 0 ? void 0 : options.fallbackData : null);
    const { data , mutate , error , isValidating: isLoading ,  } = (0,index_esm/* default */.ZP)(!!sku ? [
        sku,
        location,
        productId
    ] : null, async (sku, location, productId)=>{
        const params = {
            productId,
            sku,
            location
        };
        return discoveryService.getProduct(params);
    }, _objectSpreadProps(_objectSpread({}, options), {
        fallbackData: null,
        revalidateOnFocus: false
    }));
    const product = isLoading || !data ? productRef.current : data;
    productRef.current = product;
    return {
        result: {
            product: product && checkAlcoholicProduct(product)
        },
        isLoading,
        isError: !!error,
        mutate
    };
};
const useDiscovery_usePersonalizeBlocks = (blockParams)=>{
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return usePersonalizeBlocks(discoveryService, blockParams, block/* transformBlock */.Ot);
};
const useDiscovery_useSkus = (skus)=>{
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    return useSkus(discoveryService, skus, location);
};
const useRecommendationProductsData = (sku)=>{
    var ref;
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku ? [
        "".concat(discoveryService.getBaseUrl, "/products_recommendation"),
        sku
    ] : null, async (_, sku)=>{
        return await discoveryService.getRecommendationProducts(sku);
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            productSets: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.productSets) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationCombosData = (sku)=>{
    var ref;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const { data , error  } = (0,index_esm/* default */.ZP)(!!sku ? [
        "".concat(discoveryService.getBaseUrl, "/products_combo"),
        sku,
        location
    ] : null, async (_, sku, location)=>{
        return await discoveryService.getRecommendationCombos(sku, {
            location
        });
    }, {
        revalidateOnFocus: false
    });
    return {
        result: {
            combos: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.combos) || []
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useRecommendationComboDetail = function(payloadCombo) {
    let call = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const { location  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryService  } = (0,ServiceContext/* useServices */.Su)();
    const skus = ((payloadCombo === null || payloadCombo === void 0 ? void 0 : payloadCombo.comboLineItems) || []).map((el)=>el.sku);
    const { data , error  } = (0,index_esm/* default */.ZP)(payloadCombo && call ? [
        "".concat(discoveryService.getBaseUrl, "/detail-combo"),
        JSON.stringify(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            location
        })), 
    ] : null, (_)=>{
        return discoveryService.getDetailComboRecommendation(_objectSpreadProps(_objectSpread({}, payloadCombo), {
            location
        })).then((res)=>{
            var ref;
            return res === null || res === void 0 ? void 0 : (ref = res.result) === null || ref === void 0 ? void 0 : ref.combo;
        });
    }, {
        revalidateOnFocus: false
    });
    const reorderProductInCombo = ()=>{
        if (!data) return null;
        const { products  } = data;
        const newProducts = skus.map((el)=>{
            const product = products.find((p)=>p.product.productInfo.sku === el);
            return product;
        });
        return _objectSpreadProps(_objectSpread({}, data), {
            products: newProducts
        });
    };
    return {
        result: {
            combo: reorderProductInCombo()
        },
        isLoading: !error && !data,
        isError: error
    };
};
const useSearch = (params, fallbackData, swrConfigOptions, searchAlgoHeaderValue, showCtaButton, options)=>{
    var ref;
    const { contactLink , isAllowATCFromListing , isDisplayUom , showNewProductGift , epicOmni1821 ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T6)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const router = (0,next_router.useRouter)();
    const { parentOnCloseModal  } = options || {};
    const baseRelatedProductHook = (0,RelatedProductContext/* useRelatedProduct */.I)();
    // When useSearch is called inside a parent modal, and pass option parentOnCloseModal to close parent modal.
    // Inject parentOnCloseModal into related product hook (selectedProduct), so it can close parent modal if needed.
    const relatedProductHook = (0,react.useMemo)(()=>{
        if (!parentOnCloseModal) {
            return baseRelatedProductHook;
        }
        const setSelectedProduct = (value)=>{
            var ref;
            if (typeof value === "function") {
                var ref1;
                (ref1 = baseRelatedProductHook.setSelectedProduct) === null || ref1 === void 0 ? void 0 : ref1.call(baseRelatedProductHook, (prev)=>{
                    const nextValue = value(prev);
                    return nextValue ? _objectSpreadProps(_objectSpread({}, nextValue), {
                        parentOnCloseModal
                    }) : nextValue;
                });
                return;
            }
            (ref = baseRelatedProductHook.setSelectedProduct) === null || ref === void 0 ? void 0 : ref.call(baseRelatedProductHook, value ? _objectSpreadProps(_objectSpread({}, value), {
                parentOnCloseModal
            }) : value);
        };
        return _objectSpreadProps(_objectSpread({}, baseRelatedProductHook), {
            setSelectedProduct
        });
    }, [
        baseRelatedProductHook,
        parentOnCloseModal
    ]);
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing || showCtaButton,
        showCtaButtons: !!epicOmni1821,
        showCtaButtonsRelevantProducts: epicOmni1821,
        cartV2,
        frames,
        showNewProductGift,
        hideHighlightAttribute: (0,common/* isHomepage */.GH)(router.asPath),
        // Enable tracking open in new tab (middle click or ctrl/cmd + left click)
        enableTrackOpenInNewTab: router.asPath.includes("/search") || router.asPath.includes("/c/"),
        relatedProductHook
    };
    var _quantity;
    const totalCartItems = (0,react.useMemo)(()=>cartV2.flattenItems.reduce((acc, curr)=>acc + ((_quantity = curr.quantity) !== null && _quantity !== void 0 ? _quantity : 0), 0), [
        cartV2.flattenItems
    ]);
    // eslint-disable-next-line no-undef
    const transformProduct = (0,react.useCallback)((product)=>{
        return transformProductWhenUserUnder18((0,discovery/* createHandleEventAndCtaButton */.D3)(product, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
            wishlistButton: {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistButton/* WishlistButton */.s, {
                    sku: product.sku
                })
            }
        })));
    }, [
        totalCartItems,
        authLoading
    ]);
    const defaultFallbackData = {
        products: [],
        pagination: {
            totalItems: 0,
            totalPages: 1
        },
        filters: {}
    };
    //swr turns result into null or fallbackData when validating. using ref as workaround to keep data persistent between swr validations
    const resultRef = (0,react.useRef)(fallbackData ? fallbackData : defaultFallbackData);
    const { error , loading , result  } = (0,useDiscoverySearch_es/* useDiscoverySearchV2 */.t)(discoveryServiceV2, _objectSpread({}, params), _objectSpreadProps(_objectSpread({
        transform: (data)=>{
            var ref;
            return {
                products: (data === null || data === void 0 ? void 0 : (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig)))) || [],
                filters: data === null || data === void 0 ? void 0 : data.filter,
                pagination: {
                    totalItems: data.total,
                    totalPages: Math.ceil(data.total / search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9)
                },
                seoInfo: data.seoInfo,
                cookedFilters: {}
            };
        }
    }, swrConfigOptions), {
        // disable most of revalidating mechanisms
        revalidateOnFocus: false,
        shouldRetryOnError: false
    }), typeof searchAlgoHeaderValue === "string" ? searchAlgoHeaderValue.replace(search/* SEARCH_ALGO.REPLACE_PATTERN */.XH.REPLACE_PATTERN, "") : searchAlgoHeaderValue);
    const persistentData = loading ? resultRef.current : result || defaultFallbackData;
    resultRef.current = persistentData;
    return {
        isError: !!error,
        isLoading: loading || false,
        result: _objectSpreadProps(_objectSpread({}, persistentData), {
            products: persistentData === null || persistentData === void 0 ? void 0 : (ref = persistentData.products) === null || ref === void 0 ? void 0 : ref.map(transformProduct)
        }),
        transformProduct
    };
};
const useInfiniteSearch = (params, fallbackData)=>{
    const { isDisplayUom , contactLink , isAllowATCFromListing , epicOmni1821  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { discoveryServiceV2 , discoveryHelper  } = (0,ServiceContext/* useServices */.Su)();
    const { frames  } = (0,FrameContext/* useFrame */.x)();
    const cartV2 = (0,CartContextV2/* useCartV2 */.T6)();
    const { loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const { transformProductWhenUserUnder18  } = (0,useHandlerUnderEighteenYearOld/* useHandlerUnderEighteenYearOld */.x)();
    const discoveryCleanUpConfig = {
        showUom: isDisplayUom,
        contactLink,
        showCtaButton: isAllowATCFromListing,
        showCtaButtons: !!epicOmni1821,
        showCtaButtonsRelevantProducts: !!epicOmni1821,
        cartV2,
        frames
    };
    var _quantity;
    const totalCartItems = (0,react.useMemo)(()=>cartV2.flattenItems.reduce((acc, curr)=>acc + ((_quantity = curr.quantity) !== null && _quantity !== void 0 ? _quantity : 0), 0), [
        cartV2.flattenItems
    ]);
    // eslint-disable-next-line no-undef
    const transformProduct = (0,react.useCallback)((product)=>{
        return transformProductWhenUserUnder18((0,discovery/* createHandleEventAndCtaButton */.D3)(product, _objectSpreadProps(_objectSpread({}, discoveryCleanUpConfig), {
            wishlistButton: {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistButton/* WishlistButton */.s, {
                    sku: product.sku
                })
            }
        })));
    }, [
        totalCartItems,
        authLoading
    ]);
    const _ref = (0,useInfiniteDiscoverySearch_es/* useInfiniteDiscoverySearchV2 */.x)(discoveryServiceV2, _objectSpread({}, params), {
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, _objectSpread({}, discoveryCleanUpConfig))),
                total: data.total
            };
        },
        fallbackData: [
            {
                products: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.products,
                total: 0
            }, 
        ]
    }), { data , loadmore , loading: isLoading  } = _ref, rest = _objectWithoutProperties(_ref, [
        "data",
        "loadmore",
        "loading"
    ]);
    const products = (data === null || data === void 0 ? void 0 : data.map((el)=>el.products || []).flat()) || [];
    return _objectSpread({
        products: products === null || products === void 0 ? void 0 : products.map(transformProduct),
        onNextPage: loadmore,
        isLoading
    }, rest);
};


/***/ }),

/***/ 725530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ useHandlerUnderEighteenYearOld; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
;// CONCATENATED MODULE: ./assets/18+.svg
/* harmony default export */ var _18_ = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./assets/sgc_img_18+.svg
/* harmony default export */ var sgc_img_18_ = ("https://shopfront-cdn.tekoapis.com/_next/static/images/sgc_img_18+-20719fc2d35a93e724582b34140f32a0.svg");
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./helpers/confirm18YearsOld.ts
var confirm18YearsOld = __webpack_require__(41796);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./hooks/useHandlerUnderEighteenYearOld.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






const useHandlerUnderEighteenYearOld = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { isBot , tenant  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const { user , loading: authLoading  } = (0,context_es/* useAuth */.aC)();
    const { handleUnder18  } = props;
    const isSGC = tenant === "sgc";
    // EPIC-315: effect replace images when user is under 18 years old
    const convertProduct = (0,react.useCallback)((product)=>{
        var ref;
        const { addToCart  } = product;
        const emptyImages = (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref.map((image)=>_objectSpreadProps(_objectSpread({}, image), {
                src: ""
            }))) || [];
        // if bot or product doesn't has adult category, no need to check age
        if (!flags.epic_ecom_315 || isBot || !(0,confirm18YearsOld/* isAdultCategoryProduct */.C2)(product.categories)) return {
            images: (product === null || product === void 0 ? void 0 : product.images) || [],
            imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || "",
            actionReady: true,
            addToCart
        };
        // if isn't serverless, no need to check age
        if (!(0,helpers/* isServerless */.ep)() || authLoading) {
            return {
                images: emptyImages,
                imageUrl: "",
                actionReady: false
            };
        } else {
            const requireCheckAge = (0,confirm18YearsOld/* requiredConfirm18YearsOld */.bO)(user);
            if (!requireCheckAge) {
                return {
                    images: (product === null || product === void 0 ? void 0 : product.images) || [],
                    imageUrl: (product === null || product === void 0 ? void 0 : product.imageUrl) || "",
                    actionReady: true,
                    addToCart
                };
            } else {
                var ref1;
                handleUnder18 === null || handleUnder18 === void 0 ? void 0 : handleUnder18();
                return {
                    images: (product === null || product === void 0 ? void 0 : (ref1 = product.images) === null || ref1 === void 0 ? void 0 : ref1.map((image)=>_objectSpreadProps(_objectSpread({}, image), {
                            src: isSGC ? sgc_img_18_ : _18_
                        }))) || [],
                    imageUrl: isSGC ? sgc_img_18_ : _18_,
                    actionReady: false
                };
            }
        }
    }, [
        user,
        authLoading,
        isBot
    ]);
    const transformProductWhenUserUnder18 = (0,react.useCallback)((product)=>{
        // if bot or product doesn't has adult category, no need to check age
        if (!flags.epic_ecom_315 || isBot || !product.isAlcoholicCategory) return _objectSpread({}, product);
        // if isn't serverless, no need to check age
        if (!(0,helpers/* isServerless */.ep)() || authLoading) {
            return _objectSpreadProps(_objectSpread({}, product), {
                imageUrl: "",
                // Hidden all button in this case
                addToCart: undefined,
                ctaButton: undefined,
                ctaButtons: undefined,
                contactButton: undefined
            });
        } else {
            const requireCheckAge = (0,confirm18YearsOld/* requiredConfirm18YearsOld */.bO)(user);
            if (!requireCheckAge) {
                return _objectSpread({}, product);
            } else {
                handleUnder18 === null || handleUnder18 === void 0 ? void 0 : handleUnder18();
                return _objectSpreadProps(_objectSpread({}, product), {
                    imageUrl: isSGC ? sgc_img_18_ : _18_,
                    // Hidden all button in this case
                    addToCart: undefined,
                    ctaButton: undefined,
                    ctaButtons: undefined,
                    contactButton: undefined
                });
            }
        }
    }, [
        user,
        authLoading,
        isBot
    ]);
    return {
        convertProduct,
        transformProductWhenUserUnder18
    };
};


/***/ }),

/***/ 964590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useKeywords; },
/* harmony export */   "o": function() { return /* binding */ useRecommendedKeywords; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(859676);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(983546);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(643015);
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(886091);




const SUGGESTION_TYPE = {
    KEYWORD: "SUGGESTION_TYPE_KEYWORD",
    PRODUCT: "SUGGESTION_TYPE_PRODUCT"
};
const useKeywords = function(keyword) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    var ref, ref1;
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useServices */ .Su)();
    const debouncedKeyword = (0,_useDebounce__WEBPACK_IMPORTED_MODULE_2__/* .useDebounceValue */ .n)(keyword, 300);
    const params = {
        q: debouncedKeyword === null || debouncedKeyword === void 0 ? void 0 : debouncedKeyword.trim(),
        limit
    };
    const { data , error  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(!!(debouncedKeyword === null || debouncedKeyword === void 0 ? void 0 : debouncedKeyword.trim()) ? [
        "".concat(discoveryService.getBaseUrl, "/keywords"),
        JSON.stringify(params)
    ] : null, async (_, paramsJson)=>{
        return await discoveryService.getKeyword(JSON.parse(paramsJson));
    }, {
        revalidateOnFocus: false
    });
    const suggestionsKeyword = ((data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.keywords) || []).filter((el)=>el.type === SUGGESTION_TYPE.KEYWORD);
    const suggestionsProduct = ((data === null || data === void 0 ? void 0 : (ref1 = data.result) === null || ref1 === void 0 ? void 0 : ref1.keywords) || []).filter((el)=>el.type === SUGGESTION_TYPE.PRODUCT);
    return {
        result: (suggestionsProduct === null || suggestionsProduct === void 0 ? void 0 : suggestionsProduct.length) ? suggestionsProduct : suggestionsKeyword,
        isLoading: !error && !data,
        isError: error,
        isSuggestProduct: !!(suggestionsProduct === null || suggestionsProduct === void 0 ? void 0 : suggestionsProduct.length)
    };
};
const useRecommendedKeywords = (startCallApi)=>{
    var ref;
    const { discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useServices */ .Su)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
    const phoneNumber = user === null || user === void 0 ? void 0 : user.telephone;
    const userId = user === null || user === void 0 ? void 0 : user.userId;
    const params = {
        userId,
        phoneNumber,
        limit: 10
    };
    const { data , error  } = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(startCallApi ? [
        "".concat(discoveryService.getBaseUrl, "/recommended-search-terms"),
        JSON.stringify(params), 
    ] : null, async (_, paramsJson)=>{
        return await discoveryService.getPopularKeyword(JSON.parse(paramsJson));
    }, {
        revalidateOnFocus: false
    });
    return {
        result: (data === null || data === void 0 ? void 0 : (ref = data.result) === null || ref === void 0 ? void 0 : ref.terms) || [],
        isLoading: !error && !data,
        isError: error
    };
};


/***/ }),

/***/ 650725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocations; }
/* harmony export */ });
/* unused harmony export filterLocations */
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(643015);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const useLocations = function(defaultAddress) {
    let limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { locationService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useServices */ .Su)();
    const { 0: provinces , 1: setProvinces  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { 0: districts , 1: setDistricts  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { 0: wards , 1: setWards  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const { 0: province , 1: setProvince  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultAddress.provinceCode ? {
        code: defaultAddress.provinceCode,
        name: defaultAddress.provinceName || ""
    } : null);
    const { 0: district , 1: setDistrict  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultAddress.districtCode ? {
        code: defaultAddress.districtCode,
        name: defaultAddress.districtName || ""
    } : null);
    const { 0: ward , 1: setWard  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultAddress.wardCode ? {
        code: defaultAddress.wardCode || "",
        name: defaultAddress.wardName || ""
    } : null);
    const { provinces: limitProvinces = [] , districts: limitDistricts = [] , wards: limitWards = [] ,  } = limit;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        locationService.getProvinces().then((provs)=>{
            setProvinces(filterLocations(provs, limitProvinces));
        });
        const { provinceCode , districtCode  } = defaultAddress;
        if (provinceCode) {
            locationService.getDistrictsByProvinceCode(provinceCode).then((allDistricts)=>{
                setDistricts(filterLocations(allDistricts, limitDistricts));
            });
        }
        if (districtCode) {
            locationService.getWardsByDistrictCode(districtCode).then((allWards)=>{
                setWards(filterLocations(allWards, limitWards));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // computed value to check address filling status
    const isValidLocation = ()=>{
        return (province === null || province === void 0 ? void 0 : province.code) && (district === null || district === void 0 ? void 0 : district.code) && ((ward === null || ward === void 0 ? void 0 : ward.code) || !wards.length);
    };
    const onProvinceChanged = async (code)=>{
        const item = provinces.find((province)=>province.code === code);
        if (item) {
            setProvince(item);
            setDistrict(null);
            setWard(null);
            // reset list district and ward = []
            const allDistricts = await locationService.getDistrictsByProvinceCode(item.code);
            setDistricts(filterLocations(allDistricts, limitDistricts));
            setWards([]);
        } else {
            setProvince(null);
            setDistricts([]);
            setWards([]);
        }
    };
    const onDistrictChanged = async (code)=>{
        const item = districts.find((district)=>district.code === code);
        if (item) {
            setDistrict(item);
            setWard(null);
            // reset list ward;
            const allWards = await locationService.getWardsByDistrictCode(item.code);
            setWards(filterLocations(allWards, limitWards));
        } else {
            setDistrict(null);
            setWards([]);
        }
    };
    const onWardChanged = (code)=>{
        const item = wards.find((ward)=>ward.code === code);
        if (item) setWard(item);
    };
    const setLocation = (param)=>{
        let { provinceCode , districtCode , wardCode  } = param;
        const province = provinces.find((p)=>p.code === provinceCode);
        if (!province) return;
        (async function getDetailAndSetLocation() {
            const [districts = [], wards = []] = await Promise.all([
                locationService.getDistrictsByProvinceCode(provinceCode),
                locationService.getWardsByDistrictCode(districtCode), 
            ]);
            const district = districts.find((d)=>d.code === districtCode);
            const ward = wards.find((w)=>w.code === wardCode);
            setDistricts(districts);
            if (!!district) {
                setDistrict(district);
            }
            setWards(wards);
            if (!!ward) {
                setWard(ward);
            }
            setProvince(province);
        })();
    };
    return {
        isValidLocation,
        wards,
        provinces,
        districts,
        ward,
        province,
        district,
        onProvinceChanged,
        onDistrictChanged,
        onWardChanged,
        setLocation
    };
};
const filterLocations = (locations, limits)=>{
    return limits && limits.length > 0 ? locations.filter((location)=>limits.some((allowDis)=>{
            const re = new RegExp("^".concat(allowDis, "$"));
            return re.test(location.code);
        })) : locations;
};


/***/ }),

/***/ 650599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useLocationsV2; }
/* harmony export */ });
/* harmony import */ var _teko_location__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(693497);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(859676);




const filterLocations = (searchAreas, limits)=>{
    const areas = searchAreas.map((param)=>{
        let { id , code , title  } = param;
        return {
            id,
            code,
            title
        };
    });
    return limits && limits.length > 0 ? areas.filter((area)=>limits.some((allowDis)=>{
            const re = new RegExp("^".concat(allowDis, "$"));
            return re.test(area.code);
        })) : areas;
};
const useLocationsV2 = function(defaultProvinceCode, defaultWardCode) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const { locationServiceV3  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useServices */ .Su)();
    const { epicOmni1589  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useTenantConfig */ .Wx)();
    const { 0: province , 1: setProvince  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const { 0: ward , 1: setWard  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const { data: provinces = []  } = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(epicOmni1589 ? [
        "provinces"
    ] : null, async ()=>{
        const response = await locationServiceV3.getAreas({
            areaLayer: _teko_location__WEBPACK_IMPORTED_MODULE_0__/* .AreaLayer.province */ .TV.province
        });
        return filterLocations(response || [], limit.provinces || []);
    }, {
        revalidateOnFocus: false,
        fallbackData: [],
        shouldRetryOnError: false
    });
    const { data: wards = [] , mutate: refetchWards  } = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(epicOmni1589 && (province === null || province === void 0 ? void 0 : province.id) ? [
        "wards",
        province.id
    ] : null, async ()=>{
        const response = await locationServiceV3.getAreas({
            areaLayer: _teko_location__WEBPACK_IMPORTED_MODULE_0__/* .AreaLayer.ward */ .TV.ward,
            parentAreaId: province === null || province === void 0 ? void 0 : province.id
        });
        return filterLocations(response || [], limit.wards || []);
    }, {
        revalidateOnFocus: false,
        fallbackData: [],
        shouldRetryOnError: false
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (defaultProvinceCode && provinces.length > 0) {
            const defaultProv = provinces.find((p)=>p.code === defaultProvinceCode);
            if (defaultProv) setProvince(defaultProv);
        }
    }, [
        provinces,
        defaultProvinceCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (defaultWardCode && wards.length > 0) {
            const defaultW = wards.find((w)=>w.code === defaultWardCode);
            if (defaultW) setWard(defaultW);
        }
    }, [
        wards,
        defaultWardCode
    ]);
    const onProvinceChanged = (code)=>{
        const selected = provinces.find((p)=>p.code === code);
        if (selected) {
            setProvince(selected);
            setWard(undefined);
        } else {
            setProvince(undefined);
            setWard(undefined);
        }
    };
    const onWardChanged = (code)=>{
        const selected = wards.find((w)=>w.code === code);
        if (selected) {
            setWard(selected);
        } else {
            setWard(undefined);
        }
    };
    const isValidLocation = ()=>{
        return !!(province === null || province === void 0 ? void 0 : province.code) && (!!(ward === null || ward === void 0 ? void 0 : ward.code) || wards.length === 0);
    };
    const setLocation = async (param)=>{
        let { provinceId , wardId  } = param;
        const province = provinces.find((p)=>p.id === Number(provinceId));
        if (!province) return;
        await refetchWards();
        const ward = wards.find((w)=>w.id === Number(wardId));
        setProvince(province);
        setWard(ward);
    };
    return {
        provinces,
        wards,
        province,
        ward,
        setProvince,
        setWard,
        onProvinceChanged,
        onWardChanged,
        isValidLocation,
        setLocation
    };
};


/***/ }),

/***/ 268055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ usePos365StoreCode; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);


const STORE_KEY = "storeId";
const usePos365StoreCode = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const setPos365StoreCode = ()=>{
        const storeId = router.query[STORE_KEY];
        if (typeof sessionStorage !== "undefined" && storeId) sessionStorage.setItem(STORE_KEY, storeId);
    };
    const getPos365StoreCode = ()=>{
        if (typeof sessionStorage !== "undefined") return sessionStorage.getItem(STORE_KEY);
        return router.query[STORE_KEY];
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setPos365StoreCode();
    // eslint-disable-next-line
    }, [
        JSON.stringify(router.query)
    ]);
    return {
        pos365StoreCode: getPos365StoreCode()
    };
};


/***/ }),

/***/ 946818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zp": function() { return /* binding */ StringParam; },
/* harmony export */   "aM": function() { return /* binding */ useQuery; },
/* harmony export */   "vl": function() { return /* binding */ getQueryParams; },
/* harmony export */   "yz": function() { return /* binding */ NumberParam; }
/* harmony export */ });
/* unused harmony exports getQueryString, ArrayParams */
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(788813);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



const getQueryString = (params)=>{
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key)=>params[key] && searchParams.append(key, params[key]));
    return searchParams.toString();
};
function paramsToObject(searchParams, config) {
    const result = {};
    for (const [key, value] of searchParams.entries()){
        var ref;
        result[key] = (config === null || config === void 0 ? void 0 : config[key]) ? (ref = config[key]) === null || ref === void 0 ? void 0 : ref.call(config, value) : value;
    }
    return result;
}
const getQueryParams = (searchString, config)=>{
    if (!searchString) {
        return {};
    }
    const urlParams = new URLSearchParams(searchString);
    const params = paramsToObject(urlParams, config);
    return params;
};
/**
 * @fact
 * next-router is cache by nginx and return in `getServerSideProps`, `getInitialProps`
 * when we use useRouter hook, this means `router.query` is fetched from cache
 *
 * @solution
 * get the correct query from current URL instead of cache.
 */ const useQuery = (config)=>{
    var ref;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(); /** use in server */ 
    const search = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isServerless */ .ep)() ? window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search : getQueryString(router.query);
    const query = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        try {
            return getQueryParams(search, config);
        } catch (e) {
            return {};
        }
    }, [
        search
    ]);
    return query;
};
const NumberParam = (value)=>{
    try {
        if (!value) return null;
        return Number(value);
    } catch (e) {
        return;
    }
};
const StringParam = (value)=>value;
const ArrayParams = (func)=>function(value) {
        let splitChar = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
        return value.split(splitChar).map(func);
    };


/***/ }),

/***/ 308475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useSuggestionAddress; }
/* harmony export */ });
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);
/* harmony import */ var _useDebounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(886091);




const MIN_LENGTH_SUGGESTION_TEXT = 4;
const useSuggestionAddress = (param)=>{
    let { province: defaultProvince , district: defaultDistrict , ward: defaultWard  } = param;
    const { 0: suggestInputText , 1: setSuggestInputText  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
    const { 0: openListSuggestion , 1: setOpenListSuggestion  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const { 0: province , 1: setProvince  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultProvince);
    const { 0: district , 1: setDistrict  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultDistrict);
    const { 0: ward , 1: setWard  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultWard);
    const { 0: isLoadingGetPlaceDetail , 1: setIsLoadingGetPlaceDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const { locationServiceV2  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useServices */ .Su)();
    const { mutate  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* .useSWRConfig */ .kY)();
    const { epicOmni1589 , epicOmni1584Phase2SuggestAddress  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const debounceSuggestInputText = (0,_useDebounce__WEBPACK_IMPORTED_MODULE_4__/* .useDebounceValue */ .n)(suggestInputText, 500);
    const { data: dataSuggestion = [] , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(!!debounceSuggestInputText && debounceSuggestInputText.length >= MIN_LENGTH_SUGGESTION_TEXT && epicOmni1584Phase2SuggestAddress ? [
        "suggestInputText",
        debounceSuggestInputText
    ] : null, async ()=>{
        const res = await locationServiceV2.getAddressSuggestions({
            inputAddress: epicOmni1589 ? "".concat(debounceSuggestInputText).concat(ward ? ", ".concat(ward) : "").concat(province ? ", ".concat(province) : "") : "".concat(debounceSuggestInputText).concat(ward ? ", ".concat(ward) : "").concat(district ? ", ".concat(district) : "").concat(province ? ", ".concat(province) : "")
        });
        return res;
    }, {
        revalidateOnFocus: false,
        fallbackData: [],
        shouldRetryOnError: false
    });
    const getPlaceDetails = async (placeID)=>{
        try {
            setIsLoadingGetPlaceDetail(true);
            const placeDetail = await mutate("/location/place-detail/".concat(placeID), locationServiceV2.getPlaceDetails({
                placeIds: placeID
            }));
            setIsLoadingGetPlaceDetail(false);
            return placeDetail;
        } catch (error) {
            setIsLoadingGetPlaceDetail(false);
            return null;
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!!defaultProvince) {
            setProvince(defaultProvince);
        }
        if (!!defaultDistrict) {
            setDistrict(defaultDistrict);
        }
        if (!!defaultWard) {
            setWard(defaultWard);
        }
    }, [
        defaultProvince,
        defaultDistrict,
        defaultWard
    ]);
    return {
        setSuggestInputText,
        dataSuggestion: !!dataSuggestion.length ? dataSuggestion : [],
        openListSuggestion,
        setOpenListSuggestion,
        setProvince,
        setDistrict,
        setWard,
        isLoadingSuggest: isValidating || isLoadingGetPlaceDetail,
        getPlaceDetails
    };
};


/***/ }),

/***/ 634655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D0": function() { return /* binding */ changeLanguage; },
/* harmony export */   "k$": function() { return /* binding */ DEFAULT_LANGUAGE; },
/* harmony export */   "t": function() { return /* binding */ t; },
/* harmony export */   "zw": function() { return /* binding */ initLanguage; }
/* harmony export */ });
/* unused harmony exports NAMESPACE, loadLanguages */
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(396556);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

const NAMESPACE = "shopfront";
const DEFAULT_LANGUAGE = "vi";
const t = (keys, options)=>{
    const text = i18next__WEBPACK_IMPORTED_MODULE_0__["default"].t(keys, _objectSpreadProps(_objectSpread({}, options), {
        ns: NAMESPACE,
        interpolation: {
            escapeValue: false
        }
    }));
    return text || keys;
};
const loadLanguages = async (code)=>{
    const modules = await Promise.all([
        Promise.all(/* import() */[__webpack_require__.e(71245), __webpack_require__.e(86514)]).then(__webpack_require__.bind(__webpack_require__, 986514)),
        __webpack_require__.e(/* import() */ 79689).then(__webpack_require__.bind(__webpack_require__, 779689)),
        __webpack_require__.e(/* import() */ 11953).then(__webpack_require__.bind(__webpack_require__, 511953)),
        Promise.all(/* import() */[__webpack_require__.e(84868), __webpack_require__.e(94975), __webpack_require__.e(44925), __webpack_require__.e(69309)]).then(__webpack_require__.bind(__webpack_require__, 69309)),
        __webpack_require__.e(/* import() */ 92750).then(__webpack_require__.bind(__webpack_require__, 692750)),
        __webpack_require__.e(/* import() */ 56100).then(__webpack_require__.bind(__webpack_require__, 856100)),
        Promise.all(/* import() */[__webpack_require__.e(502), __webpack_require__.e(47523), __webpack_require__.e(9599), __webpack_require__.e(67452), __webpack_require__.e(88512)]).then(__webpack_require__.bind(__webpack_require__, 886687)),
        __webpack_require__.e(/* import() */ 53478).then(__webpack_require__.bind(__webpack_require__, 153478)),
        Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(33687), __webpack_require__.e(23580), __webpack_require__.e(51357), __webpack_require__.e(52400), __webpack_require__.e(23728), __webpack_require__.e(86735), __webpack_require__.e(76417), __webpack_require__.e(77365), __webpack_require__.e(52660), __webpack_require__.e(58392), __webpack_require__.e(6312)]).then(__webpack_require__.bind(__webpack_require__, 489593)),
        Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(85675), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(66328), __webpack_require__.e(27411), __webpack_require__.e(60397), __webpack_require__.e(38057)]).then(__webpack_require__.bind(__webpack_require__, 60397)),
        Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(33687), __webpack_require__.e(92699), __webpack_require__.e(77641), __webpack_require__.e(23666), __webpack_require__.e(81224), __webpack_require__.e(1105)]).then(__webpack_require__.bind(__webpack_require__, 81224)),
        Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(33687), __webpack_require__.e(92699), __webpack_require__.e(77641), __webpack_require__.e(23666), __webpack_require__.e(55885)]).then(__webpack_require__.bind(__webpack_require__, 698636)),
        Promise.all(/* import() */[__webpack_require__.e(38597), __webpack_require__.e(60064)]).then(__webpack_require__.bind(__webpack_require__, 860064)),
        Promise.resolve({
            NAMESPACE,
            lang: {
                vi: (await __webpack_require__.e(/* import() */ 17254).then(__webpack_require__.t.bind(__webpack_require__, 517254, 19))).default,
                en: (await __webpack_require__.e(/* import() */ 64798).then(__webpack_require__.t.bind(__webpack_require__, 964798, 19))).default
            }
        }), 
    ]);
    const resources = {};
    if (!code) {
        for (const mod of modules){
            for (const langName of Object.keys(mod.lang)){
                if (!resources[langName]) resources[langName] = {};
                resources[langName] = _objectSpreadProps(_objectSpread({}, resources[langName]), {
                    [mod.NAMESPACE]: mod.lang[langName]
                });
            }
        }
        return resources;
    }
    return {
        [code]: modules.reduce((prev, curr)=>_objectSpreadProps(_objectSpread({}, prev), {
                [curr.NAMESPACE]: curr.lang[code]
            }), {})
    };
};
const changeLanguage = async (lng)=>{
    return i18next__WEBPACK_IMPORTED_MODULE_0__["default"].changeLanguage(lng);
};
const initLanguage = async (resources, lng)=>{
    return i18next__WEBPACK_IMPORTED_MODULE_0__["default"].init({
        lng,
        resources,
        initImmediate: false
    });
};


/***/ }),

/***/ 534090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gj": function() { return /* binding */ cartErrorCode; },
/* harmony export */   "T6": function() { return /* binding */ useCartV2; },
/* harmony export */   "q": function() { return /* binding */ CartProviderV2; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(983546);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(916476);
/* harmony import */ var _teko_cart_v2__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(891004);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(314408);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(106454);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(339674);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(500689);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(425336);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(420577);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68706);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(933756);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(723357);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(246845);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(391547);
/* harmony import */ var dompurify__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dompurify__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(788813);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(634655);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}















var cartErrorCode;
(function(cartErrorCode) {
    cartErrorCode[cartErrorCode["APPLY_EXCLUSION_PROMOTION"] = 409001] = "APPLY_EXCLUSION_PROMOTION";
    cartErrorCode[cartErrorCode["ADD_PRODUCT_WITH_EXCLUSION_PROMOTION"] = 409002] = "ADD_PRODUCT_WITH_EXCLUSION_PROMOTION";
    cartErrorCode[cartErrorCode["EXPIRE_ACCESS_TOKEN"] = 401001] = "EXPIRE_ACCESS_TOKEN";
})(cartErrorCode || (cartErrorCode = {}));
const defaultCartContext = {
    loading: false,
    cart: _teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .defaultCart */ .UH,
    flattenItems: [],
    getCart: ()=>Promise.resolve(),
    onAddSingleItem: ()=>Promise.resolve(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .defaultCart */ .UH),
    onAddComboItems: ()=>Promise.resolve(),
    onAddMultipleItems: ()=>Promise.resolve(),
    onRemoveItem: ()=>Promise.resolve(),
    onIncrease: ()=>Promise.resolve(),
    onDecrease: ()=>Promise.resolve(),
    onChangeQuantity: ()=>Promise.resolve(),
    onUpdateItemNote: ()=>Promise.resolve(),
    onSelectItem: ()=>Promise.resolve(),
    onSelectSeller: ()=>Promise.resolve(),
    onDeleteCart: ()=>Promise.resolve(),
    onChangeItemPrice: ()=>Promise.resolve(),
    isEmpty: true,
    onApplyPromotion: ()=>Promise.resolve(undefined),
    onRemovePromotion: ()=>Promise.resolve(undefined),
    onApplyVoucher: ()=>Promise.resolve(undefined),
    onRequestItemSku: ()=>Promise.resolve(),
    totalCartItems: 0,
    onApplyPromotionInCartPage: ()=>Promise.resolve(undefined),
    onApplyVoucherInCartPage: ()=>Promise.resolve(undefined),
    isUpdatingItemQuantity: {},
    validateCartToken: ()=>Promise.resolve()
};
const CartContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_6__.createContext(defaultCartContext);
const CartProviderV2 = (param)=>{
    let { children  } = param;
    const desktopToast = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .useToast */ .p)();
    const mobileToast = (0,_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_9__/* .useToast */ .p)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    const { query  } = router;
    const [loading, setLoading] = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .useLoading */ .r$)("CartContextV2");
    const { showModal  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .useModal */ .d)();
    const { 0: cart , 1: setCart  } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .defaultCart */ .UH);
    const tokenPromise = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    const { 0: errorMessage , 1: setErrorMessage  } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("");
    const { 0: isUpdatingItemQuantity , 1: setIsUpdatingItemQuantity  } = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({});
    const { cartToken: queryCartToken  } = query;
    const { user , loading: authLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_12__/* .useAuth */ .aC)();
    const { terminal , isMobile , getProcessEnv , partner , iamClientId , requireLogin , pushTrackingForAdvanceTransform ,  } = (0,hooks__WEBPACK_IMPORTED_MODULE_13__/* .useTenantConfig */ .Wx)();
    const { cartServiceV2 , authService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_14__/* .useServices */ .Su)();
    const { trackingScreenName  } = (0,contexts__WEBPACK_IMPORTED_MODULE_15__/* .useScreen */ .EV)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_16__/* .useFeatureFlags */ .g)();
    const showErrorToast = (message)=>{
        if (isMobile) {
            var ref;
            (ref = mobileToast.error) === null || ref === void 0 ? void 0 : ref.call(mobileToast, {
                message,
                customStyle: {
                    zIndex: 2050
                }
            });
        } else {
            var ref1;
            (ref1 = desktopToast.error) === null || ref1 === void 0 ? void 0 : ref1.call(desktopToast, {
                title: message,
                message: null
            });
        }
    };
    // common handler for handling Error in most Cart functions
    const handleError = (error, suppressThrowError, suppressShowingErrorToast, onOk)=>{
        _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error);
        const errorCode = error.code === error.response.code ? error.code : error.response.code;
        const { EXPIRE_ACCESS_TOKEN , APPLY_EXCLUSION_PROMOTION , ADD_PRODUCT_WITH_EXCLUSION_PROMOTION ,  } = cartErrorCode;
        switch(errorCode){
            case EXPIRE_ACCESS_TOKEN:
                if (sessionStorage.getItem(_teko_auth_react__WEBPACK_IMPORTED_MODULE_12__/* .RELOAD_DUE_TO_MISSING_ACCESS_TOKEN */ .g6) !== "1") {
                    setErrorMessage(error.message);
                }
                break;
            case APPLY_EXCLUSION_PROMOTION:
            case ADD_PRODUCT_WITH_EXCLUSION_PROMOTION:
                var ref;
                showModal === null || showModal === void 0 ? void 0 : showModal({
                    title: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Th\xf4ng b\xe1o"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_mobile__WEBPACK_IMPORTED_MODULE_18__/* .Shape */ .b, {
                        dangerouslySetInnerHTML: {
                            __html: (dompurify__WEBPACK_IMPORTED_MODULE_4___default()) === null || (dompurify__WEBPACK_IMPORTED_MODULE_4___default()) === void 0 ? void 0 : (ref = (dompurify__WEBPACK_IMPORTED_MODULE_4___default().sanitize)) === null || ref === void 0 ? void 0 : ref.call((dompurify__WEBPACK_IMPORTED_MODULE_4___default()), "".concat(error.message, "\n").concat((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Bạn c\xf3 chắc chắn muốn thay đổi khuyến mại?")))
                        }
                    }),
                    okText: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("X\xe1c nhận"),
                    cancelText: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Quay lại"),
                    onOk: ()=>{
                        onOk === null || onOk === void 0 ? void 0 : onOk();
                    },
                    zIndex: 1051
                });
                break;
            default:
                if (!suppressShowingErrorToast) {
                    showErrorToast(error.message);
                }
                if (!suppressThrowError) throw error;
        }
    };
    const showSuccessToast = (message)=>{
        if (isMobile) {
            var ref;
            (ref = mobileToast.success) === null || ref === void 0 ? void 0 : ref.call(mobileToast, {
                message,
                customStyle: {
                    zIndex: 2050
                }
            });
        } else {
            var ref1;
            (ref1 = desktopToast.success) === null || ref1 === void 0 ? void 0 : ref1.call(desktopToast, {
                title: message,
                message: null
            });
        }
    };
    // getCart when login success
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(()=>{
        const fetchCart = async ()=>{
            const cartToken = _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable() && flags.epic_ecom_479 ? await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].cart */ .Z.cart().getCartToken() : queryCartToken;
            if (!!cartToken) {
                (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .setCartToken */ .rx)(cartToken);
            }
            // loadingIAMState somehow doesn't work here
            // use localStorage instead
            const clientId = iamClientId || getProcessEnv("NEXT_PUBLIC_IAM_CLIENT_ID");
            const isUserInfoInLS = localStorage.getItem("tekoid.user.".concat(clientId));
            if (authLoading) return;
            if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable() && flags.epic_ecom_479) {
                // alway get cart in embeded webview
                getCart({
                    withLoading: false,
                    removeToken: false
                });
            } else if ((user === null || user === void 0 ? void 0 : user.id) || //user is not logged with partner
            !isUserInfoInLS && !partner && !_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable()) {
                getCart({
                    withLoading: router.pathname.includes("/cart"),
                    removeToken: false
                });
            }
        };
        fetchCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.id,
        queryCartToken,
        authLoading,
        _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable()
    ]);
    const flattenItems = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(()=>cart.items.reduce((prev, curr)=>[
                ...prev,
                ...curr.items
            ], []), [
        cart.items
    ]);
    // check for cartToken, if cartToken is empty then create new one.
    const validateCartToken = async ()=>{
        if (!(0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .getCartToken */ .i)() && !tokenPromise.current) {
            tokenPromise.current = createCart().finally(()=>tokenPromise.current = null);
        }
        await tokenPromise.current;
    };
    // create new cart from cart service v2
    const createCart = async ()=>{
        try {
            const { cartToken  } = await cartServiceV2.createNewCart({});
            if (cartToken) {
                (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .setCartToken */ .rx)(cartToken);
            }
        } catch (error) {
            handleError(error);
        }
    };
    // get Cart from Cart Service V2
    const getCart = async (param)=>{
        let { withLoading =false , removeToken =true ,  } = param;
        try {
            var ref;
            if (!terminal) return;
            if (withLoading) setLoading(true);
            await validateCartToken();
            const cart = await cartServiceV2.getCart();
            setCart(cart);
            if (removeToken && (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) === 0) (0,_teko_cart_v2__WEBPACK_IMPORTED_MODULE_7__/* .removeCartToken */ .ng)();
        } catch (error) {
            if (!withLoading) {
                // without explicit loading,
                // do not show the error toast
                // since it cause confusion to users
                // in page such as condition
                handleError(error, false, true);
            } else {
                handleError(error);
            }
        } finally{
            setLoading(false);
        }
    };
    const updateNativeAppCart = async (cartResponse)=>{
        try {
            if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isAvailable */ .Z.isAvailable() && flags.epic_ecom_479 && cartResponse) {
                await _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_2__/* ["default"].cart */ .Z.cart().updateCartSuccess(JSON.stringify(cartResponse));
            }
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(e);
        }
    };
    const onAddToCart = async function(body) {
        let fromProductCard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 ? arguments[2] : void 0;
        const { isSkipUpdateNativeAppCart =false , isSkipSetLoading =false  } = options !== null && options !== void 0 ? options : {};
        // force login when add to card with tenant require login
        if (requireLogin && !user) {
            if (!authLoading) {
                authService.login();
            }
            return null;
        }
        const { groups , override , isolatedCartType , overrideItemId , isSkipHoldInventory ,  } = body;
        try {
            if (!isSkipSetLoading) {
                setLoading(true);
            }
            const { trackAddToCartManually , trackPVFormAddToCart  } = await __webpack_require__.e(/* import() */ 84601).then(__webpack_require__.bind(__webpack_require__, 759525));
            if (fromProductCard && trackingScreenName) {
                setTimeout(()=>{
                    groups.forEach((group)=>{
                        group.products.forEach((product)=>{
                            trackAddToCartManually(trackingScreenName, product.sellerSku || "");
                        });
                    });
                }, 0);
            }
            await validateCartToken();
            const res = await cartServiceV2.addItems({
                groups,
                override,
                overrideItemId,
                isolatedCartType,
                isSkipHoldInventory
            });
            if (!!user && pushTrackingForAdvanceTransform) {
                const emailSha256 = !!user.email ? crypto_js__WEBPACK_IMPORTED_MODULE_3___default().SHA256(user.email).toString() : undefined;
                const phoneSha256 = !!user.telephone ? crypto_js__WEBPACK_IMPORTED_MODULE_3___default().SHA256((0,helpers__WEBPACK_IMPORTED_MODULE_19__/* .formatPhoneNumberPrefix */ .yz)(user.telephone)).toString() : undefined;
                trackPVFormAddToCart(res.grandTotalAmount, emailSha256, phoneSha256);
            }
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đ\xe3 th\xeam sản phẩm v\xe0o giỏ h\xe0ng"));
            if (!isolatedCartType) {
                setCart(res);
            }
            if (!isSkipUpdateNativeAppCart) {
                updateNativeAppCart(res);
            }
            return res;
        } catch (error) {
            handleError(error, false, false, ()=>onAddToCart(_objectSpreadProps(_objectSpread({}, body), {
                    override: true
                }), fromProductCard));
            return null;
        } finally{
            if (!isSkipSetLoading) {
                setLoading(false);
            }
        }
    };
    // handle user add an item to cart
    const onAddSingleItem = async function(param) {
        let { sku , sellerSku , quantity , promotionId , isPrimary  } = param, fromProductCard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isolatedCartType = arguments.length > 2 ? arguments[2] : void 0, options = arguments.length > 3 ? arguments[3] : void 0;
        const { isSkipUpdateNativeAppCart =false , isSkipSetLoading =false  } = options !== null && options !== void 0 ? options : {};
        const body = {
            groups: [
                {
                    products: [
                        {
                            sku,
                            sellerSku,
                            quantity,
                            promotionId,
                            isPrimary
                        }
                    ]
                }, 
            ],
            override: false,
            isolatedCartType: isolatedCartType
        };
        return await onAddToCart(body, fromProductCard, {
            isSkipUpdateNativeAppCart,
            isSkipSetLoading
        });
    };
    // handle user add multiple item to cart
    const onAddMultipleItems = async (productList, options)=>{
        const _ref = options || {}, { isSkipUpdateNativeAppCart  } = _ref, restOptions = _objectWithoutProperties(_ref, [
            "isSkipUpdateNativeAppCart"
        ]);
        const body = _objectSpread({
            groups: [
                {
                    products: productList
                }
            ],
            override: false
        }, restOptions);
        await onAddToCart(body, false, {
            isSkipUpdateNativeAppCart
        });
    };
    // handle user add combo to cart
    const onAddComboItems = async function(body) {
        let fromProductCard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 ? arguments[2] : void 0;
        const { isSkipSetLoading =false  } = options !== null && options !== void 0 ? options : {};
        await onAddToCart(body, fromProductCard, {
            isSkipSetLoading
        });
    };
    // handle when user remove an item
    const onRemoveItem = async (item)=>{
        const { trackRemoveFromCart  } = await __webpack_require__.e(/* import() */ 84601).then(__webpack_require__.bind(__webpack_require__, 759525));
        try {
            trackRemoveFromCart(item, cart.id);
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.removeItem({
                itemId: item.id
            });
            setCart(res);
            updateNativeAppCart(res);
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    // handle when user click add button on an item
    const onIncrease = async (item)=>{
        return onChangeQuantity(item, item.quantity + 1);
    };
    // handle when user click subtract button on an item
    const onDecrease = async (item)=>{
        return onChangeQuantity(item, item.quantity - 1);
    };
    // handle when user change quantity of an item
    const onChangeQuantity = async function(item, newQuantity) {
        let showLoading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        try {
            if (showLoading) {
                setLoading(true);
            } else {
                setIsUpdatingItemQuantity({
                    [item.id]: true
                });
            }
            await validateCartToken();
            const { trackChangeQuantityProduct  } = await __webpack_require__.e(/* import() */ 84601).then(__webpack_require__.bind(__webpack_require__, 759525));
            trackChangeQuantityProduct(item, newQuantity, cart.id);
            const res = await cartServiceV2.updateItemQuantity({
                itemId: item.id,
                quantity: newQuantity
            });
            setCart(res);
            updateNativeAppCart(res);
        } catch (error) {
            handleError(error);
        } finally{
            if (showLoading) {
                setLoading(false);
            } else {
                setIsUpdatingItemQuantity({
                    [item.id]: false
                });
            }
        }
    };
    const onUpdateItemNote = async (item, note)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.updateItemNote({
                itemId: item.id,
                note
            });
            setCart(res);
            updateNativeAppCart(res);
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    const onSelectItems = async (itemIdList, isSelected)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.selectItems({
                isSelected,
                itemIds: itemIdList
            });
            setCart(res);
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    // handle when user click checkbox of an item
    const onSelectItem = async (item)=>{
        const { trackSelectProduct  } = await __webpack_require__.e(/* import() */ 84601).then(__webpack_require__.bind(__webpack_require__, 759525));
        trackSelectProduct(item, !item.isSelected, cart.id);
        return onSelectItems([
            item.id
        ], !item.isSelected);
    };
    // handle when user click on Checkbox of a seller
    const onSelectSeller = async (sellerItems, selected)=>{
        // only toggle items which its allowedUserActions contains TOGGLE value
        const canToggleCartItems = (sellerItems || []).filter((item)=>(item.allowedUserActions || []).includes(_teko_cart_v2__WEBPACK_IMPORTED_MODULE_20__/* .AllowedUserActionItem.TOGGLE */ .rV.TOGGLE));
        return onSelectItems(canToggleCartItems.map((item)=>item.id), selected);
    };
    // handle when user click delete all cart
    const onDeleteCart = async ()=>{
        try {
            setLoading(true);
            await validateCartToken();
            await cartServiceV2.deleteCart();
            await getCart({
                withLoading: true
            });
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    const onChangeItemPrice = async (priceEditorData)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const { id , editedPrice , price  } = priceEditorData;
            const newCart = await cartServiceV2.changeItemPrice({
                itemId: id,
                consultationFee: Number(editedPrice) - price
            });
            if (newCart) {
                setCart(newCart);
                showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Sửa gi\xe1 sản phẩm th\xe0nh c\xf4ng"));
            }
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    // function to handle apply promotion
    const onApplyPromotion = async (applyPromotionParams, isBuyNow, isForceApply)=>{
        const { productId , promotionCode , promotionId , promotionSource  } = applyPromotionParams;
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.applyPromotion(_objectSpreadProps(_objectSpread({}, !!productId && {
                itemId: productId
            }), {
                ppmPromotionId: promotionId,
                ppmCode: promotionCode,
                isForceApply,
                promotionSource
            }));
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("\xc1p dụng khuyến m\xe3i th\xe0nh c\xf4ng"));
            // Keep original cart data since buyNow flow use a separate cart.
            if (!isBuyNow) {
                setCart(res.data);
            }
            return res.data;
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error);
            throw error;
        } finally{
            setLoading(false);
        }
    };
    const onApplyPromotionInCartPage = async (applyPromotionParams, isBuyNow, isForceApply)=>{
        try {
            const res = await onApplyPromotion(applyPromotionParams, isBuyNow, isForceApply);
            return res;
        } catch (error) {
            handleError(error, false, false, ()=>onApplyPromotionInCartPage(applyPromotionParams, isBuyNow, true));
        }
    };
    // function to handle remove promotion
    const onRemovePromotion = async (cartPromotionId, isBuyNow)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const req = {
                cartPromotionId
            };
            const res = await cartServiceV2.removePromotion(req);
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Bỏ \xe1p dụng khuyến m\xe3i th\xe0nh c\xf4ng"));
            // Keep original cart data since buyNow flow use a separate cart.
            if (!isBuyNow) {
                setCart(res.data);
            }
            return res.data;
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    const onApplyVoucher = async (applyVoucherParams, isBuyNow, isForceApply)=>{
        try {
            setLoading(true);
            await validateCartToken();
            const { ppmCode , promotionSource  } = applyVoucherParams;
            const res = await cartServiceV2.applyPromotion({
                ppmCode,
                isForceApply,
                promotionSource
            });
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("\xc1p dụng m\xe3 giảm gi\xe1/phiếu mua h\xe0ng th\xe0nh c\xf4ng"));
            // Keep original cart data since buyNow flow use a separate cart.
            if (!isBuyNow) {
                setCart(res.data);
            }
            return res.data;
        } catch (error) {
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(error);
            throw error;
        } finally{
            setLoading(false);
        }
    };
    const onApplyVoucherInCartPage = async (applyVoucherParams, isBuyNow, isForceApply)=>{
        try {
            const res = await onApplyVoucher(applyVoucherParams, isBuyNow, isForceApply);
            return res;
        } catch (error) {
            handleError(error, false, false, ()=>onApplyVoucherInCartPage(applyVoucherParams, isBuyNow, true));
        }
    };
    const onRequestItemSku = async function(name) {
        let quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        // force login when add to card with tenant require login
        if (requireLogin && !user) {
            if (!authLoading) {
                authService.login();
            }
            return;
        }
        try {
            setLoading(true);
            await validateCartToken();
            const res = await cartServiceV2.requestItemSku({
                name,
                quantity
            });
            showSuccessToast((0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Đ\xe3 th\xeam sản phẩm v\xe0o giỏ h\xe0ng"));
            setCart(res);
        } catch (error) {
            handleError(error);
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CartContext.Provider, {
        value: {
            loading,
            cart,
            flattenItems,
            getCart,
            onAddSingleItem,
            onAddMultipleItems,
            onAddComboItems,
            onRemoveItem,
            onIncrease,
            onDecrease,
            onChangeQuantity,
            onUpdateItemNote,
            onSelectItem,
            onSelectSeller,
            onDeleteCart,
            get isEmpty () {
                var ref;
                return (cart === null || cart === void 0 ? void 0 : (ref = cart.items) === null || ref === void 0 ? void 0 : ref.length) === 0;
            },
            onChangeItemPrice,
            onApplyPromotion,
            onRemovePromotion,
            onApplyVoucher,
            onRequestItemSku,
            get totalCartItems () {
                return (flattenItems || []).length;
            },
            onApplyPromotionInCartPage,
            onApplyVoucherInCartPage,
            isUpdatingItemQuantity,
            validateCartToken
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Modal */ .u, {
                visible: !!errorMessage,
                title: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Th\xf4ng b\xe1o"),
                okText: (0,i18n__WEBPACK_IMPORTED_MODULE_17__.t)("Tải lại trang"),
                onOk: ()=>{
                    window.location.reload();
                    sessionStorage.setItem(_teko_auth_react__WEBPACK_IMPORTED_MODULE_12__/* .RELOAD_DUE_TO_MISSING_ACCESS_TOKEN */ .g6, "1");
                },
                zIndex: 2000,
                showCloseIcon: false,
                alignFooter: "center",
                cancelText: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .SubTitle */ .DK, {
                    level: 1,
                    weight: "regular",
                    children: errorMessage
                })
            })
        ]
    });
};
function useCartV2() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(CartContext);
    if (!context) {
        throw new Error("useCartV2 must be inside a CartProviderV2 with a state value");
    }
    return context;
}


/***/ }),

/***/ 397338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JB": function() { return /* binding */ NotificationProvider; },
/* harmony export */   "k7": function() { return /* reexport safe */ containers__WEBPACK_IMPORTED_MODULE_9__.k; },
/* harmony export */   "lm": function() { return /* binding */ useNotification; },
/* harmony export */   "ti": function() { return /* binding */ PageStatus; },
/* harmony export */   "uj": function() { return /* binding */ NotificationContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(983546);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(684443);
/* harmony import */ var _teko_notification__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(771633);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(643015);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(907276);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(420577);
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68706);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var containers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(778046);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(859676);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var PageStatus;
(function(PageStatus) {
    PageStatus["LOADING"] = "loading";
    PageStatus["LOADED"] = "loaded";
    PageStatus["EMPTY"] = "empty";
    PageStatus["FAILED"] = "failed";
})(PageStatus || (PageStatus = {}));
const NotificationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(undefined);
const useNotification = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(NotificationContext);
    if (context === undefined) {
        throw new Error("useNotification must be used in NotificationProvider");
    }
    return context;
};
const NotificationProvider = (param)=>{
    let { children  } = param;
    const { user , loading: userLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_6__/* .useAuth */ .aC)();
    const { notificationService , discoveryService  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useServices */ .Su)();
    const { notificationAppId , iamClientId , partner , getProcessEnv , serviceWorkerScripts , epicOmni948 ,  } = (0,hooks__WEBPACK_IMPORTED_MODULE_8__/* .useTenantConfig */ .Wx)();
    const { 0: status , 1: setStatus  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(PageStatus.LOADED);
    const { 0: notifications , 1: setNotifications  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: checkpoint , 1: setCheckpoint  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined);
    const { 0: loading , 1: setLoading  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: markAllReadLoading , 1: setLoadingMarkReadAll  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: unRead , 1: setUnread  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { 0: currentTab , 1: setCurrentTab  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(containers__WEBPACK_IMPORTED_MODULE_9__/* .NOTIFICATION_TAB.UPDATE_TAB */ .k.UPDATE_TAB);
    const { 0: isInstallNotificationSuccess , 1: setIsInstallNotificationSuccess  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const notiExternalTypes = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return (0,_helper__WEBPACK_IMPORTED_MODULE_10__/* .getExternalTypesByPath */ .KX)(router.query, currentTab);
    }, [
        router.query,
        currentTab
    ]);
    const getMoreNotifications = async function() {
        let limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, checkpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        if (!notificationAppId) return;
        const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_11__/* .FCM_TOKEN */ .ut);
        const params = {
            app_id: notificationAppId,
            limit,
            ignore_pending_send: 0,
            check_point: checkpoint,
            token: token !== null && token !== void 0 ? token : undefined,
            externalTypes: epicOmni948 ? notiExternalTypes : undefined
        };
        setLoading(true);
        try {
            const notificationData = await notificationService.getNotification(params);
            return (0,_helper__WEBPACK_IMPORTED_MODULE_10__/* .convertNotification */ .Et)(notificationData, discoveryService);
        } catch (err) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(err);
        } finally{
            setLoading(false);
        }
    };
    // Notification với full type
    const { data: notificationData  } = (0,swr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)([
        "/notification",
        notificationAppId,
        _teko_notification__WEBPACK_IMPORTED_MODULE_11__/* .FCM_TOKEN */ .ut
    ], async ()=>{
        const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_11__/* .FCM_TOKEN */ .ut);
        const allExternalTypes = [
            "noti",
            "debt",
            "order"
        ];
        const params = {
            app_id: notificationAppId,
            limit: 10,
            ignore_pending_send: 0,
            token: token !== null && token !== void 0 ? token : undefined,
            externalTypes: epicOmni948 ? allExternalTypes : undefined
        };
        const notificationResponse = await notificationService.getNotification(params);
        const notificationData = await (0,_helper__WEBPACK_IMPORTED_MODULE_10__/* .convertNotification */ .Et)(notificationResponse, discoveryService);
        return {
            total: 3,
            records: (notificationData === null || notificationData === void 0 ? void 0 : notificationData.notifications) || []
        };
    }, {
        fallbackData: {
            total: 0,
            records: []
        }
    });
    const getNotifications = async function() {
        let checkpoint = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10, isNew = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, overrideData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        const { checkpoint: newCheckpoint , notifications: newNotifications = [] , unRead: newUnread ,  } = await getMoreNotifications(limit, checkpoint) || {};
        // if epic OMNI-948 flag is enabled
        // if user is not logged in, and access orders noti screen
        // do not call api to get notifications --> set notifications to empty & unread to 0
        if (epicOmni948 && !(user === null || user === void 0 ? void 0 : user.userId) && JSON.stringify(notiExternalTypes) === JSON.stringify([
            "order"
        ])) {
            setNotifications([]);
            setUnread(0);
            return;
        }
        if (!isNew) {
            setCheckpoint(()=>newCheckpoint);
            !!overrideData ? setNotifications(newNotifications) : setNotifications((notifications)=>[
                    ...notifications,
                    ...newNotifications, 
                ]);
        } else {
            setNotifications(epicOmni948 ? newNotifications : (notifications)=>[
                    ...newNotifications,
                    ...notifications
                ]);
        }
        setUnread(()=>newUnread || 0);
    };
    const installWebPushNotification = async ()=>{
        const firebaseOptions = {
            apiKey: getProcessEnv("FIREBASE_CLOUD_MESSAGING_API_KEY"),
            authDomain: getProcessEnv("FIREBASE_CLOUD_MESSAGING_AUTH_DOMAIN"),
            databaseURL: getProcessEnv("FIREBASE_CLOUD_MESSAGING_DATABASE_URL"),
            projectId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_PROJECT_ID"),
            storageBucket: getProcessEnv("FIREBASE_CLOUD_MESSAGING_STORAGE_BUCKET"),
            messagingSenderId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_MESSAGING_SENDER_ID"),
            appId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_APP_ID"),
            measurementId: getProcessEnv("FIREBASE_CLOUD_MESSAGING_MEASUREMENT_ID")
        };
        const vapidKey = getProcessEnv("FIREBASE_VAPID_KEY");
        await (0,_helper__WEBPACK_IMPORTED_MODULE_10__/* .installNotification */ .bL)({
            user,
            unsAppId: notificationAppId,
            notificationService,
            firebaseOptions,
            vapidKey,
            externalScripts: serviceWorkerScripts,
            onMessage: ()=>getNotifications(undefined, 1, true),
            markReadNotification
        });
        setIsInstallNotificationSuccess(true);
        !epicOmni948 && getNotifications(checkpoint);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const clientId = iamClientId || getProcessEnv("NEXT_PUBLIC_IAM_CLIENT_ID");
        const isUserInfoInLS = localStorage.getItem("tekoid.user.".concat(clientId));
        if (!userLoading && (user || // user is not logged with partner
        !isUserInfoInLS && !partner && !_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isAvailable */ .Z.isAvailable())) {
            installWebPushNotification();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        userLoading
    ]);
    // if enable epic OMNI-948 flag
    // call getNotifications api to get data when switching screen type (`promotion & update` and `orders`)
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        epicOmni948 && isInstallNotificationSuccess && getNotifications(undefined, 10, false, true);
    }, [
        notiExternalTypes,
        epicOmni948,
        isInstallNotificationSuccess
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!loading) {
            if (notifications.length === 0) {
                setStatus(PageStatus.EMPTY);
            } else {
                setStatus(PageStatus.LOADED);
            }
        } else {
            setStatus(PageStatus.LOADING);
        }
    }, [
        loading,
        notifications
    ]);
    const markReadNotification = async (notification)=>{
        if (!notification.is_read) {
            const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_11__/* .FCM_TOKEN */ .ut);
            try {
                const { status  } = await notificationService.markNotificationAsRead(notification.id, token !== null && token !== void 0 ? token : undefined);
                if (status === "success") {
                    setNotifications((prev)=>prev.map((noti)=>{
                            if (noti.id === notification.id) {
                                return _objectSpreadProps(_objectSpread({}, noti), {
                                    is_read: true
                                });
                            }
                            return noti;
                        }));
                    if (!notification.is_read) setUnread((count)=>count ? count - 1 : 0);
                }
            } catch (e) {
                _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
            }
        }
    };
    const markReadAll = async (externalTypes)=>{
        try {
            if (!notificationAppId) return;
            setLoadingMarkReadAll(true);
            const token = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_11__/* .FCM_TOKEN */ .ut);
            const params = {
                app_id: notificationAppId,
                token: token !== null && token !== void 0 ? token : undefined,
                externalTypes: epicOmni948 ? externalTypes : undefined
            };
            await notificationService.markReadAll(params);
            setNotifications((notifications)=>notifications.map((noti)=>_objectSpreadProps(_objectSpread({}, noti), {
                        is_read: true
                    })));
            setUnread(0);
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e);
        } finally{
            setLoadingMarkReadAll(false);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotificationContext.Provider, {
        value: {
            status,
            notifications,
            checkpoint,
            loading,
            getNotifications,
            markReadNotification,
            markReadAll,
            markAllReadLoading,
            unRead,
            currentTab,
            setCurrentTab,
            allNotifications: (notificationData === null || notificationData === void 0 ? void 0 : notificationData.records) || []
        },
        children: children
    });
};



/***/ }),

/***/ 907276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ unregisterUNS; },
/* harmony export */   "Et": function() { return /* binding */ convertNotification; },
/* harmony export */   "KX": function() { return /* binding */ getExternalTypesByPath; },
/* harmony export */   "LK": function() { return /* binding */ getJson; },
/* harmony export */   "bL": function() { return /* binding */ installNotification; },
/* harmony export */   "hC": function() { return /* binding */ onNotificationClick; },
/* harmony export */   "vX": function() { return /* binding */ registerUNS; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(771633);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(446586);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const getJson = (str)=>{
    try {
        return !!str && JSON.parse(str);
    } catch (e) {
        return null;
    }
};
const getCookieByName = (cname)=>{
    const match = document.cookie.match(new RegExp("(^| )" + cname + "=([^;]+)"));
    if (match) return match[2];
    return null;
};
const registerUNS = async (param)=>{
    let { fcmToken , user , unsAppId , notificationService  } = param;
    const lsToken = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TOKEN */ .ut);
    const lsUserId = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz);
    const lsUNSAppId = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .UNS_APP_ID */ .Bb);
    const trackingId = getCookieByName(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .TRACKING_ID_KEY */ .tO) || localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .TRACKING_ID_KEY */ .tO);
    const lsRegisterTokenSuccess = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_REGISTER_TOKEN_SUCCESS */ .pX);
    const registerCondition = // when firebase updates token, when first time users using the app
    fcmToken !== lsToken || // when update notificationAppId config
    unsAppId !== lsUNSAppId || // When the user logs in
    (user === null || user === void 0 ? void 0 : user.userId) && user.userId !== lsUserId || // When registration failed last time
    lsRegisterTokenSuccess === "false";
    if (registerCondition) {
        try {
            var ref, ref1, ref2;
            await notificationService.registerToken({
                app_id: unsAppId,
                user_id: (ref = user === null || user === void 0 ? void 0 : user.userId) !== null && ref !== void 0 ? ref : undefined,
                transport: _teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TRANSPORT */ .n8,
                token: fcmToken,
                email: (ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : undefined,
                phone: (ref2 = user === null || user === void 0 ? void 0 : user.telephone) !== null && ref2 !== void 0 ? ref2 : undefined,
                userTrackingId: trackingId !== null && trackingId !== void 0 ? trackingId : undefined
            });
            localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_REGISTER_TOKEN_SUCCESS */ .pX, "true");
            if (user === null || user === void 0 ? void 0 : user.userId) {
                localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz, user.userId);
            }
        } catch (e) {
            localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_REGISTER_TOKEN_SUCCESS */ .pX, "false");
        }
    }
    localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TOKEN */ .ut, fcmToken);
    localStorage.setItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .UNS_APP_ID */ .Bb, unsAppId);
};
const unregisterUNS = async (notificationService, unsAppId)=>{
    try {
        const lsToken = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TOKEN */ .ut);
        const lsUserId = localStorage.getItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz);
        await notificationService.unRegisterToken({
            user_id: lsUserId !== null && lsUserId !== void 0 ? lsUserId : undefined,
            app_id: unsAppId,
            transport: _teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_TRANSPORT */ .n8,
            token: lsToken !== null && lsToken !== void 0 ? lsToken : undefined
        });
    } finally{
        localStorage.removeItem(_teko_notification__WEBPACK_IMPORTED_MODULE_1__/* .FCM_USER_ID */ .tz);
    }
};
const registerServiceWorker = async (param)=>{
    let { firebaseOptions , externalScripts , onMessage , markReadNotification  } = param;
    var ref;
    // Remove pushdy service worker
    try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        const pushdyUrl = location.protocol + "//" + location.host + "/sw.js";
        registrations.forEach((reg)=>{
            var ref;
            if ((reg === null || reg === void 0 ? void 0 : (ref = reg.active) === null || ref === void 0 ? void 0 : ref.scriptURL) === pushdyUrl) {
                reg.unregister();
            }
        });
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
    }
    const configs = new URLSearchParams(_objectSpreadProps(_objectSpread({}, firebaseOptions), {
        externalScripts: (ref = externalScripts || []) === null || ref === void 0 ? void 0 : ref.join(",")
    })).toString();
    const serviceWorker = await navigator.serviceWorker.register("/firebase-messaging-sw.js?".concat(configs));
    // Listener for message comes from service worker
    navigator.serviceWorker.addEventListener("message", (event)=>{
        const { action , msgId , traceId  } = event.data;
        const payload = JSON.stringify({
            msg_id: msgId === null || msgId === void 0 ? void 0 : msgId.toString(),
            trace_id: traceId === null || traceId === void 0 ? void 0 : traceId.toString()
        });
        switch(action){
            case "click":
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_2__/* .trackManually */ .gu)("notification", "browserNotification", "notification", payload, msgId);
                markReadNotification === null || markReadNotification === void 0 ? void 0 : markReadNotification({
                    id: parseInt(msgId),
                    is_read: false
                });
                break;
            case "backgroundMessage":
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .trackVisibleManually */ .UC)({
                    regionName: "browserNotification",
                    contentName: "notification",
                    payload: payload,
                    index: msgId
                });
                onMessage === null || onMessage === void 0 ? void 0 : onMessage();
                break;
            default:
                break;
        }
    });
    return serviceWorker;
};
const initFirebaseApp = async (param)=>{
    let { firebaseAppName , firebaseOptions  } = param;
    const { getApp , initializeApp  } = await Promise.all(/* import() */[__webpack_require__.e(502), __webpack_require__.e(47523), __webpack_require__.e(9599), __webpack_require__.e(67452), __webpack_require__.e(28053)]).then(__webpack_require__.bind(__webpack_require__, 701113));
    let firebaseNotiApp;
    try {
        // try to get app by name
        // it will throw exception otherwise
        firebaseNotiApp = getApp(firebaseAppName);
    } catch (_) {
        // initialize if not exist yet
        firebaseNotiApp = initializeApp(firebaseOptions, firebaseAppName);
    }
    return firebaseNotiApp;
};
const registerFCM = async (firebaseApp, serviceWorker, param)=>{
    let { vapidKey , onMessage  } = param;
    const { getMessaging , getToken , onMessage: addMessageEvent ,  } = await Promise.all(/* import() */[__webpack_require__.e(502), __webpack_require__.e(47523), __webpack_require__.e(9599), __webpack_require__.e(67452), __webpack_require__.e(49349)]).then(__webpack_require__.bind(__webpack_require__, 249349));
    const messaging = getMessaging(firebaseApp);
    const token = await getToken(messaging, {
        vapidKey,
        serviceWorkerRegistration: serviceWorker !== null && serviceWorker !== void 0 ? serviceWorker : undefined
    });
    if (onMessage) {
        addMessageEvent(messaging, onMessage);
    }
    return token;
};
const installNotification = async (param)=>{
    let { user , unsAppId , notificationService , firebaseOptions , vapidKey , firebaseAppName ="notification" , externalScripts , onMessage , markReadNotification  } = param;
    try {
        if ("serviceWorker" in navigator && typeof window.Notification !== "undefined") {
            const permission = await window.Notification.requestPermission();
            if (permission === "granted") {
                // Step 1: register new Service Worker to handle message in background
                const serviceWorker = await registerServiceWorker({
                    firebaseOptions,
                    externalScripts,
                    onMessage,
                    markReadNotification
                });
                // Step 2: Init firebase app
                const firebaseApp = await initFirebaseApp({
                    firebaseOptions,
                    firebaseAppName
                });
                // Step 3: register firebase cloud messaging
                const fcmToken = await registerFCM(firebaseApp, serviceWorker, {
                    vapidKey,
                    onMessage
                });
                // Step 4: Register FCM token to UNS
                registerUNS({
                    fcmToken,
                    user,
                    unsAppId,
                    notificationService
                });
            }
        }
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error(e);
    }
};
const convertNotification = async (notification, discoveryService)=>{
    if (!notification) return;
    const { notifications: data , check_point: checkpoint , unread: unRead ,  } = notification;
    let apiResultNotifications = data;
    if (!!apiResultNotifications.length) {
        // call API discovery to get image of order notification
        // array of order notification's order items
        const notificationOrderItemsArr = apiResultNotifications.filter((noti)=>!!noti.order).map((noti)=>{
            var ref, ref1;
            return typeof noti.order === "string" ? (ref = getJson(noti.order)) === null || ref === void 0 ? void 0 : ref.orderItems : ((ref1 = noti.order) === null || ref1 === void 0 ? void 0 : ref1.orderItems) || "";
        });
        if (notificationOrderItemsArr.length) {
            const products = await discoveryService.getProductDetailBySkus({
                skus: notificationOrderItemsArr
            });
            const imageMapping = products.reduce((prev, curr)=>{
                var ref, ref1;
                return _objectSpreadProps(_objectSpread({}, prev), {
                    [(ref = curr.productInfo) === null || ref === void 0 ? void 0 : ref.sku]: (ref1 = curr.productInfo) === null || ref1 === void 0 ? void 0 : ref1.imageUrl
                });
            }, {});
            apiResultNotifications = apiResultNotifications.map((noti)=>{
                var ref, ref1;
                const orderItems = typeof noti.order === "string" ? (ref = getJson(noti.order)) === null || ref === void 0 ? void 0 : ref.orderItems : ((ref1 = noti.order) === null || ref1 === void 0 ? void 0 : ref1.orderItems) || "";
                return _objectSpread({}, noti, !noti.order ? {} : {
                    order: _objectSpreadProps(_objectSpread({}, typeof noti.order === "string" ? getJson(noti.order) : noti.order), {
                        imageUrl: imageMapping[orderItems] || ""
                    })
                });
            });
        }
    }
    return {
        notifications: apiResultNotifications,
        checkpoint,
        unRead
    };
};
const onNotificationClick = async (notification, router)=>{
    if (notification.deepLink) {
        router.push(notification.deepLink);
    } else if (notification.order) {
        router.push({
            pathname: "/account/orders/[orderId]",
            query: {
                orderId: notification.order.orderId
            }
        }, {
            pathname: "/account/orders/".concat(notification.order.orderId)
        });
    }
};
const getExternalTypesByPath = (query, tabNotification)=>{
    if ((query === null || query === void 0 ? void 0 : query.type) === "orders" || // NOTIFICATION_TAB.ORDER_TAB === 1
    !!tabNotification && tabNotification === 1) {
        return [
            "order"
        ];
    }
    return [
        "noti",
        "debt"
    ];
};


/***/ }),

/***/ 664638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ TerminalPickerItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(855271);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(348855);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(408797);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(985481);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(966212);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  font-weight: 500;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





const TerminalPickerItem = (param)=>{
    let { isChoice , terminalName , distance , terminalAddress , onClick  } = param;
    const { colors  } = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .F)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        backgroundColor: isChoice ? colors.primary50 : colors.white,
        borderColor: isChoice ? colors.primary : "#0000000f",
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                    children: terminalName
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SubTitle, {
                            style: {
                                color: colors.primary,
                                textDecoration: "underline",
                                marginRight: 4
                            },
                            children: [
                                distance === null || distance === void 0 ? void 0 : distance.toFixed(2),
                                " km"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .LocationColored */ .P, {
                            size: 20
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
                    justify: "start",
                    style: {
                        marginTop: 8,
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .HomeLocationColored */ .V, {
                            size: 20
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubTitle, {
                            style: {
                                marginLeft: 8,
                                width: "90%"
                            },
                            children: terminalAddress
                        })
                    ]
                })
            ]
        })
    });
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.div */ .z.div((param)=>{
    let { backgroundColor ="#ffff" , borderColor ="#0000000f"  } = param;
    return "\n  border-radius: 8px;\n  background-color: ".concat(backgroundColor, ";\n  padding: 8px;\n  width: 100%;\n  max-height: 400px;\n  border: 1px solid ").concat(borderColor, ";\n  margin-top: 8px;\n  cursor: pointer\n");
});
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.span */ .z.span(_templateObject());
const SubTitle = _teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .styled.span */ .z.span(_templateObject1());


/***/ }),

/***/ 159702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_app; },
  "reportWebVitals": function() { return /* reexport */ reportWebVitals; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/helpers/utils.es.js
var utils_es = __webpack_require__(19840);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/contexts/Theme.es.js
var Theme_es = __webpack_require__(348855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/context.es.js
var Loading_context_es = __webpack_require__(106454);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/contexts/ThemeProvider.es.js
var ThemeProvider_es = __webpack_require__(580871);
// EXTERNAL MODULE: ../../packages/utils/dist/polyfill.es.js
var polyfill_es = __webpack_require__(593859);
// EXTERNAL MODULE: ../../.yarn/cache/@terra-js-terra-kit-npm-1.8.0-MOBCOMMON8504.1-aac718131a-360bd50b3e.zip/node_modules/@terra-js/terra-kit/dist/index.js
var dist = __webpack_require__(68706);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/SmartBanner.tsx




// lazy import
const SmartComponent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(84868), __webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(33687), __webpack_require__.e(58640), __webpack_require__.e(71798), __webpack_require__.e(96179), __webpack_require__.e(10837), __webpack_require__.e(28105), __webpack_require__.e(47891), __webpack_require__.e(75958), __webpack_require__.e(57502), __webpack_require__.e(70293), __webpack_require__.e(10959), __webpack_require__.e(54726), __webpack_require__.e(81379), __webpack_require__.e(31518), __webpack_require__.e(56996), __webpack_require__.e(13289), __webpack_require__.e(84650), __webpack_require__.e(43437), __webpack_require__.e(21514), __webpack_require__.e(89041), __webpack_require__.e(89442), __webpack_require__.e(57325), __webpack_require__.e(64685), __webpack_require__.e(32666), __webpack_require__.e(78348), __webpack_require__.e(51513), __webpack_require__.e(27189), __webpack_require__.e(83692), __webpack_require__.e(14050), __webpack_require__.e(63443), __webpack_require__.e(68745), __webpack_require__.e(40274), __webpack_require__.e(72078), __webpack_require__.e(8746), __webpack_require__.e(76115), __webpack_require__.e(67128), __webpack_require__.e(1359), __webpack_require__.e(69343), __webpack_require__.e(35738), __webpack_require__.e(47402), __webpack_require__.e(17459), __webpack_require__.e(87015), __webpack_require__.e(74913), __webpack_require__.e(44876), __webpack_require__.e(59559), __webpack_require__.e(5603), __webpack_require__.e(71184), __webpack_require__.e(59033), __webpack_require__.e(20400), __webpack_require__.e(15577), __webpack_require__.e(39314), __webpack_require__.e(80832), __webpack_require__.e(73169), __webpack_require__.e(6826), __webpack_require__.e(38711), __webpack_require__.e(28178), __webpack_require__.e(42001), __webpack_require__.e(72964), __webpack_require__.e(39979), __webpack_require__.e(20892), __webpack_require__.e(89568), __webpack_require__.e(98555), __webpack_require__.e(30040), __webpack_require__.e(27223), __webpack_require__.e(30974), __webpack_require__.e(99466), __webpack_require__.e(61058), __webpack_require__.e(17786), __webpack_require__.e(47173), __webpack_require__.e(14945), __webpack_require__.e(37437), __webpack_require__.e(35437), __webpack_require__.e(73259), __webpack_require__.e(54668), __webpack_require__.e(77586), __webpack_require__.e(73579), __webpack_require__.e(10524), __webpack_require__.e(10790), __webpack_require__.e(79407), __webpack_require__.e(10943), __webpack_require__.e(36484), __webpack_require__.e(36539), __webpack_require__.e(56917), __webpack_require__.e(91693), __webpack_require__.e(21034), __webpack_require__.e(72975), __webpack_require__.e(40942), __webpack_require__.e(38535), __webpack_require__.e(92150), __webpack_require__.e(70342), __webpack_require__.e(23439), __webpack_require__.e(5916), __webpack_require__.e(63466), __webpack_require__.e(87924), __webpack_require__.e(14438), __webpack_require__.e(58431), __webpack_require__.e(56336), __webpack_require__.e(51123), __webpack_require__.e(75441), __webpack_require__.e(92589), __webpack_require__.e(39687), __webpack_require__.e(83147), __webpack_require__.e(29135), __webpack_require__.e(25773), __webpack_require__.e(30617), __webpack_require__.e(14554), __webpack_require__.e(98479), __webpack_require__.e(95043), __webpack_require__.e(36811), __webpack_require__.e(43216), __webpack_require__.e(21501), __webpack_require__.e(76630), __webpack_require__.e(76120), __webpack_require__.e(55375), __webpack_require__.e(9873), __webpack_require__.e(22209), __webpack_require__.e(90219), __webpack_require__.e(50307), __webpack_require__.e(40153), __webpack_require__.e(9395), __webpack_require__.e(81365), __webpack_require__.e(62455), __webpack_require__.e(7469), __webpack_require__.e(16357), __webpack_require__.e(30543), __webpack_require__.e(94905), __webpack_require__.e(57970), __webpack_require__.e(81147), __webpack_require__.e(50726), __webpack_require__.e(69603), __webpack_require__.e(41144), __webpack_require__.e(31282), __webpack_require__.e(48292), __webpack_require__.e(80300), __webpack_require__.e(55842), __webpack_require__.e(30176), __webpack_require__.e(14789), __webpack_require__.e(57569)]).then(__webpack_require__.bind(__webpack_require__, 472241)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(472241)
            ]
    }
});
const TekfaceSmartComponent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(84868), __webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(33687), __webpack_require__.e(58640), __webpack_require__.e(96179), __webpack_require__.e(10837), __webpack_require__.e(28105), __webpack_require__.e(47891), __webpack_require__.e(75958), __webpack_require__.e(57502), __webpack_require__.e(70293), __webpack_require__.e(10959), __webpack_require__.e(54726), __webpack_require__.e(84650), __webpack_require__.e(43437), __webpack_require__.e(21514), __webpack_require__.e(89041), __webpack_require__.e(89442), __webpack_require__.e(57325), __webpack_require__.e(64685), __webpack_require__.e(32666), __webpack_require__.e(78348), __webpack_require__.e(51513), __webpack_require__.e(27189), __webpack_require__.e(83692), __webpack_require__.e(14050), __webpack_require__.e(63443), __webpack_require__.e(68745), __webpack_require__.e(40274), __webpack_require__.e(72078), __webpack_require__.e(8746), __webpack_require__.e(76115), __webpack_require__.e(67128), __webpack_require__.e(1359), __webpack_require__.e(69343), __webpack_require__.e(35738), __webpack_require__.e(47402), __webpack_require__.e(17459), __webpack_require__.e(87015), __webpack_require__.e(74913), __webpack_require__.e(44876), __webpack_require__.e(59559), __webpack_require__.e(5603), __webpack_require__.e(71184), __webpack_require__.e(59033), __webpack_require__.e(20400), __webpack_require__.e(15577), __webpack_require__.e(39314), __webpack_require__.e(80832), __webpack_require__.e(73169), __webpack_require__.e(6826), __webpack_require__.e(38711), __webpack_require__.e(28178), __webpack_require__.e(42001), __webpack_require__.e(72964), __webpack_require__.e(39979), __webpack_require__.e(20892), __webpack_require__.e(89568), __webpack_require__.e(98555), __webpack_require__.e(30040), __webpack_require__.e(27223), __webpack_require__.e(30974), __webpack_require__.e(99466), __webpack_require__.e(61058), __webpack_require__.e(17786), __webpack_require__.e(47173), __webpack_require__.e(14945), __webpack_require__.e(37437), __webpack_require__.e(35437), __webpack_require__.e(73259), __webpack_require__.e(54668), __webpack_require__.e(77586), __webpack_require__.e(73579), __webpack_require__.e(10524), __webpack_require__.e(10790), __webpack_require__.e(79407), __webpack_require__.e(10943), __webpack_require__.e(36484), __webpack_require__.e(36539), __webpack_require__.e(91693), __webpack_require__.e(21034), __webpack_require__.e(72975), __webpack_require__.e(40942), __webpack_require__.e(38535), __webpack_require__.e(92150), __webpack_require__.e(1180), __webpack_require__.e(84702), __webpack_require__.e(69896), __webpack_require__.e(80739), __webpack_require__.e(18706), __webpack_require__.e(90872), __webpack_require__.e(46806), __webpack_require__.e(48814), __webpack_require__.e(49073), __webpack_require__.e(62250), __webpack_require__.e(22589), __webpack_require__.e(4696), __webpack_require__.e(8504), __webpack_require__.e(27168), __webpack_require__.e(55375), __webpack_require__.e(9873), __webpack_require__.e(22209), __webpack_require__.e(90219), __webpack_require__.e(50307), __webpack_require__.e(40153), __webpack_require__.e(9395), __webpack_require__.e(81365), __webpack_require__.e(62455), __webpack_require__.e(7469), __webpack_require__.e(16357), __webpack_require__.e(30543), __webpack_require__.e(94905), __webpack_require__.e(57970), __webpack_require__.e(81147), __webpack_require__.e(50726), __webpack_require__.e(69603), __webpack_require__.e(41144), __webpack_require__.e(31282), __webpack_require__.e(48292), __webpack_require__.e(26884)]).then(__webpack_require__.bind(__webpack_require__, 536646)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(536646)
            ]
    }
});
const SmartBanner = ()=>{
    const { getProcessEnv , smartActivationConfig  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { user , loading: profileLoading  } = (0,context_es/* useAuth */.aC)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const trackingAppId = getProcessEnv("TRACKER_APP_ID");
    const landingBuilderEnv = getProcessEnv("LANDING_BUILDER_ENV");
    const { appId , sessionPeriodMinutes  } = smartActivationConfig || {};
    // user has to login before show smart banner
    const showSmartBanner = !profileLoading && appId;
    if (!showSmartBanner) return null;
    return flags.epic_ma_150 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TekfaceSmartComponent, {
        configs: {
            appId,
            trackingAppId,
            iamId: user === null || user === void 0 ? void 0 : user.userId,
            sessionPeriodMinutes
        },
        env: landingBuilderEnv,
        flagsup: {
            epic_ma_79: flags.epic_ma_79
        },
        track: flags.epic_ma_229 ? (event, data)=>{
            window.track(event, data);
        } : undefined
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartComponent, {
        env: landingBuilderEnv,
        configs: {
            appId,
            trackingAppId,
            iamId: user === null || user === void 0 ? void 0 : user.userId,
            sessionPeriodMinutes
        }
    });
};

// EXTERNAL MODULE: ./components/desktop/organisms/LanguageSelector.tsx
var LanguageSelector = __webpack_require__(211888);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/head.js
var head = __webpack_require__(979894);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ./components/mobile/organisms/MetaHead.tsx




function MetaHead(param) {
    let { theme , config , meta  } = param;
    const { tenant , logoUrl , schemaWebsite , organizationSchema  } = config;
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const getIconUrl = (size)=>"".concat(logoUrl, "=w").concat(size);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: meta === null || meta === void 0 ? void 0 : meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: logoUrl ? getIconUrl(16) : "/".concat(tenant, "/favicon.ico?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: logoUrl ? getIconUrl(180) : "/".concat(tenant, "/apple-touch-icon.png?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: logoUrl ? getIconUrl(32) : "/".concat(tenant, "/favicon-32x32.png?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: logoUrl ? getIconUrl(16) : "/".concat(tenant, "/favicon-16x16.png?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: theme.brand.primary || "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: theme.brand.primary || "#ffffff"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1.0, shrink-to-fit=no"
            }),
            schemaWebsite && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaWebsite)
                }
            }),
            organizationSchema && !query.slug && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(organizationSchema)
                }
            })
        ]
    });
}
/* harmony default export */ var organisms_MetaHead = (MetaHead);

// EXTERNAL MODULE: ./constants/terminal.ts
var terminal = __webpack_require__(91326);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./contexts/RegionPickerProvider.tsx
var RegionPickerProvider = __webpack_require__(679469);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(353632);
;// CONCATENATED MODULE: ./helpers/mockStorage.ts
class MockStorage {
    setItem(key, value) {
        this.storage[key] = value;
    }
    getItem(key) {
        return this.storage[key] || null;
    }
    removeItem(key) {
        delete this.storage[key];
    }
    key(index) {
        return Object.keys(this.storage).at(index) || null;
    }
    clear() {
        this.storage = {};
    }
    constructor(){
        this.storage = {};
    }
}
// only used in _app component
const storageAvailable = (type)=>{
    try {
        const storage = type == "localStorage" ? window === null || window === void 0 ? void 0 : window.localStorage : window === null || window === void 0 ? void 0 : window.sessionStorage;
        const key = "__storage_test__";
        storage.setItem(key, key);
        storage.removeItem(key);
        return true;
    } catch (error) {
        return false;
    }
};

// EXTERNAL MODULE: ./helpers/datetime.ts
var datetime = __webpack_require__(505709);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(504133);
// EXTERNAL MODULE: ./helpers/translate.ts
var translate = __webpack_require__(858045);
// EXTERNAL MODULE: ./hooks/usePos365StoreCode.ts
var usePos365StoreCode = __webpack_require__(268055);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/notification/NotificationProvider.tsx
var NotificationProvider = __webpack_require__(397338);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-tracker-virtual-8eef9107c2/0/cache/next-tracker-npm-1.2.3-c57dd13924-44db98d112.zip/node_modules/next-tracker/dist/index.js
var next_tracker_dist = __webpack_require__(361226);
var dist_default = /*#__PURE__*/__webpack_require__.n(next_tracker_dist);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/app.js
var app = __webpack_require__(596289);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/config.js
var config = __webpack_require__(327490);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./tenants/_template/desktop/_helpers/RightMenu/RightMenu.tsx + 1 modules
var RightMenu = __webpack_require__(794416);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(773717);
// EXTERNAL MODULE: ./contexts/PrivacyPolicyContext.tsx
var PrivacyPolicyContext = __webpack_require__(990497);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-lazy-hydration-virtual-bff429a9c1/0/cache/react-lazy-hydration-npm-0.1.0-52f4d8c753-1140b9a082.zip/node_modules/react-lazy-hydration/dist/index.browser.esm.js
var index_browser_esm = __webpack_require__(767937);
// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ./contexts/LanguageProvider.tsx





const LanguageProvider = (param)=>{
    let { code , children  } = param;
    const languageResolved = new Promise((resolve)=>i18next["default"].on("initialized", resolve));
    (0,react.useEffect)(()=>{
        const init = async ()=>{
            const { lang  } = window;
            await (0,i18n/* initLanguage */.zw)(lang, code);
            await (0,i18n/* changeLanguage */.D0)(code);
        };
        init();
    }, [
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_browser_esm/* default */.Z, {
        promise: languageResolved,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};

// EXTERNAL MODULE: ./contexts/RouterProvider.tsx
var RouterProvider = __webpack_require__(266521);
// EXTERNAL MODULE: ./contexts/HelperContext.tsx
var HelperContext = __webpack_require__(329706);
// EXTERNAL MODULE: ./contexts/LocationProvider.tsx
var LocationProvider = __webpack_require__(158610);
// EXTERNAL MODULE: ./contexts/FrameContext.tsx
var FrameContext = __webpack_require__(927890);
// EXTERNAL MODULE: ./contexts/PopularKeywordContext.tsx
var PopularKeywordContext = __webpack_require__(868673);
// EXTERNAL MODULE: ./contexts/ScreenContext.tsx
var ScreenContext = __webpack_require__(933756);
// EXTERNAL MODULE: ./contexts/LoyaltyProvider.tsx
var LoyaltyProvider = __webpack_require__(261105);
// EXTERNAL MODULE: ./modules/cart/CartContextV2.tsx
var CartContextV2 = __webpack_require__(534090);
// EXTERNAL MODULE: ./contexts/ThreeLevelLocationProvider/index.tsx + 8 modules
var ThreeLevelLocationProvider = __webpack_require__(779454);
// EXTERNAL MODULE: ./contexts/DistanceTerminalProvider/index.tsx + 11 modules
var DistanceTerminalProvider = __webpack_require__(385365);
// EXTERNAL MODULE: ./contexts/CategoriesProvider.tsx
var CategoriesProvider = __webpack_require__(186056);
// EXTERNAL MODULE: ./contexts/RelatedProductContext.tsx + 1 modules
var RelatedProductContext = __webpack_require__(725965);
;// CONCATENATED MODULE: ./contexts/HistoryContext.tsx



const HistoryContext = /*#__PURE__*/ react.createContext(undefined);
const HistoryProvider = (param)=>{
    let { children  } = param;
    const { 0: prevUrl , 1: setPrevUrl  } = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const handleRouteChange = ()=>{
            setPrevUrl(window.location.href);
        };
        next_router.Router.events.on("routeChangeStart", handleRouteChange);
        return ()=>{
            next_router.Router.events.off("routeChangeStart", handleRouteChange);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistoryContext.Provider, {
        value: {
            prevUrl
        },
        children: children
    });
};
function usePrevUrl() {
    const context = useContext(HistoryContext);
    if (!context) {
        throw new Error("usePrevUrl must be inside a HistoryContext with a state value");
    }
    return context.prevUrl;
}

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dist/shared/lib/router/utils/remove-trailing-slash.js
var remove_trailing_slash = __webpack_require__(881928);
// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(479228);
// EXTERNAL MODULE: ./types/config.ts
var types_config = __webpack_require__(150923);
// EXTERNAL MODULE: ./hooks/useQuery.tsx
var useQuery = __webpack_require__(946818);
// EXTERNAL MODULE: ./utils/iframe.ts
var iframe = __webpack_require__(198116);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var utils_dist_index_es = __webpack_require__(775002);
;// CONCATENATED MODULE: ./tenants/_env.ts






class ClientTenantEnvImpl {
    getProcessEnv(env) {
        var ref;
        return window === null || window === void 0 ? void 0 : (ref = window.env) === null || ref === void 0 ? void 0 : ref[env];
    }
    constructor(config){
        // allow users to set terminalId via query parameter
        // use a new storage key to avoid being overwritten by ecom-284 logic
        const isEcom284 = (0,env/* getEnv */.dU)("EPIC_ECOM_284") === "enabled" && !config.disableEpicEcom284;
        if ((0,helpers/* isServerless */.ep)()) {
            var ref;
            const { terminalCode , locationCode , terminalId  } = (0,useQuery/* getQueryParams */.vl)(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search, {
                terminalCode: useQuery/* StringParam */.Zp,
                locationCode: useQuery/* StringParam */.Zp,
                terminalId: useQuery/* NumberParam */.yz
            });
            // set this value to localstorage
            if (!!terminalCode) {
                (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, terminalCode, config.isMobile);
            }
            if (!!locationCode) {
                (0,env/* setUserSelectedInfo */.MA)(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, locationCode, config.isMobile);
            }
            if (!!terminalId) {
                // after ecom-284, use the a new storage key
                // as TERMINAL_ID is ignored by the new flow and should be removed
                (0,env/* setUserSelectedInfo */.MA)(isEcom284 ? local/* userSelectedConstants.OVERRIDE_TERMINAL_ID */.Tp.OVERRIDE_TERMINAL_ID : local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, terminalId.toString(), isEcom284 ? false : config.isMobile);
            }
            if ((0,utils_dist_index_es.inIframe)()) {
                const { clientId: iframeIamClientId , oauthDomain: iframeOauthDomain  } = (0,iframe/* getDataFromIframe */.b)();
                // only use these 2 values to init authService if Iframe pass both clientId and oathDomain
                if (!!iframeIamClientId && !!iframeOauthDomain) {
                    config.iamClientId = iframeIamClientId;
                    config.iamOauthDomain = iframeOauthDomain;
                }
            }
            if (!!config.enableSearchAlgoABTesting) {
                var ref1, ref2, ref3, ref4;
                // find search algo in local storage
                const localSearchAlgo = (0,env/* getCookieByName */.A7)(search/* SEARCH_ALGO.COOKIE */.XH.COOKIE);
                const envNoDefaultSortAlgos = (0,env/* getEnv */.dU)("SEARCH_ALGO_NO_DEFAULT_SORT_OPTION") || "";
                const noDefaultSortAlgos = typeof envNoDefaultSortAlgos === "string" ? envNoDefaultSortAlgos.split(" ") : [];
                /**
         * flag support remove default sort option for A/B testing search algo
         * - check for feature flag enableSearchAlgoABTesting in platform config
         * - if page is not excluded from remove sort option in config workload
         * - if cookie has SEARCH_ALGO field
         * - if SEARCH_ALGO field value (after remove single/double quotes) is v3
         */ const shouldRemoveDefaultSortOption = !!config.enableSearchAlgoABTesting && !!(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname) && !(0,common/* checkCurrentPageIsExcluded */.RN)(window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.pathname) && !!localSearchAlgo && noDefaultSortAlgos.includes(((ref3 = localSearchAlgo.match(new RegExp("(^| )".concat(search/* SEARCH_ALGO.COOKIE */.XH.COOKIE, "=([^;]+)")))) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[2]) === null || ref4 === void 0 ? void 0 : ref4.replace(search/* SEARCH_ALGO.REPLACE_PATTERN */.XH.REPLACE_PATTERN, "")) || "");
                if (!!shouldRemoveDefaultSortOption) {
                    delete config.defaultSortOptionCode;
                }
            }
        }
        if (isEcom284) {
            // From ecom 284, shop proxy no longer caches responses by terminal or by location,
            // so the terminal and location returned by server are unchanged for every requests.
            // This statement handles re-assigning these configs based on the chosen one of the users.
            // It also sets some variables to storages for showing some necessary popups.
            if ((0,helpers/* isServerless */.ep)()) {
                var ref5;
                if (!((ref5 = config.locations) === null || ref5 === void 0 ? void 0 : ref5.length)) {
                    // Show the error popup when locations aren't found
                    (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.Error */.t.Error);
                } else if (config.locations.length === 1 && config.locations[0].locationCode === "0") {
                    // With the above condition, don't show any messages.
                    (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.None */.t.None);
                } else {
                    // Use the location that chose by users and stored in localStorage.
                    const locationCodeFromLS = localStorage.getItem(local/* userSelectedConstants.LOCATION */.Tp.LOCATION);
                    if (!locationCodeFromLS) {
                        // If the location in localStorage is not exist, use the default one returned by the server.
                        // Show the hint for this case
                        (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.Hint */.t.Hint);
                        var _location;
                        // Set the default location to localStorage
                        localStorage.setItem(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, (_location = config.location) !== null && _location !== void 0 ? _location : "");
                    } else {
                        // If the user has chosen a location that stored in localStorage, verify it in the list returned by server.
                        const locationOptionFromConfig = config.locations.find((param)=>{
                            let { locationCode  } = param;
                            return locationCode === locationCodeFromLS;
                        });
                        if (!locationOptionFromConfig) {
                            // If the chosen of user is not valid, handle it as the case of the location not being chosen
                            (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.Hint */.t.Hint);
                            var _location1;
                            localStorage.setItem(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, (_location1 = config.location) !== null && _location1 !== void 0 ? _location1 : "");
                        } else {
                            // If the chosen of user is valid, don't show any messages also.
                            // Re-assign the configs by the chosen one of the user.
                            (0,env/* setSessionStorageIfNotExist */.BO)(local/* SESSION_STORAGE_LOCATION_MESSAGE */.GX, types_config/* LocationMessageType.None */.t.None);
                            config.location = locationOptionFromConfig.locationCode;
                            // Ecom 284 do not distinguish terminal between mobile and desktop,
                            // so we still need to hard code the mobile one in workload config.
                            // This step will get the right terminal based on device types.
                            if (!config.isMobile) {
                                config.terminalId = locationOptionFromConfig.terminalId;
                                config.terminal = locationOptionFromConfig.terminalCode;
                            } else {
                                var ref6;
                                const terminalForMobile = (ref6 = config.mobileTerminalIdMapping) === null || ref6 === void 0 ? void 0 : ref6[locationOptionFromConfig.terminalId.toString()];
                                config.terminalId = (terminalForMobile === null || terminalForMobile === void 0 ? void 0 : terminalForMobile.terminalId) || locationOptionFromConfig.terminalId;
                                config.terminal = (terminalForMobile === null || terminalForMobile === void 0 ? void 0 : terminalForMobile.terminalCode) || locationOptionFromConfig.terminalCode;
                            }
                        }
                    }
                }
                var ref7;
                // if there is a overriding terminal id set
                // honor it.
                config.terminalId = parseInt((ref7 = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.OVERRIDE_TERMINAL_ID */.Tp.OVERRIDE_TERMINAL_ID)) !== null && ref7 !== void 0 ? ref7 : "") || config.terminalId;
            }
        } else {
            // Get terminal from cookie in case tenant has terminal by region (ex: karavan, umbala)
            // This help avoid disk cache from browser when change location
            // More detail: https://jira.teko.vn/browse/UX4BUYER-2566
            if (Array.isArray(config.originalTerminal)) {
                if (!(0,helpers/* isDisableUserSelectLocationAction */.z9)({
                    isDmsFlow: config.isDmsFlow
                })) {
                    config.terminal = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL */.Tp.TERMINAL, config.isMobile) || config.terminal;
                    var ref8;
                    config.terminalId = parseInt((ref8 = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.TERMINAL_ID */.Tp.TERMINAL_ID, config.isMobile)) !== null && ref8 !== void 0 ? ref8 : "") || config.terminalId;
                }
                if (!(0,helpers/* isUseUserLocationCode */.w$)({
                    isDmsFlow: config.isDmsFlow
                })) {
                    config.location = (0,env/* getUserSelectedInfo */.Sk)(local/* userSelectedConstants.LOCATION */.Tp.LOCATION, config.isMobile) || config.location;
                }
            }
        }
        Object.assign(this, config);
        // assign the object to window
        // this a trick to persist the
        // config object for client-side only pages
        window.__tenantConfig = config;
    }
}


;// CONCATENATED MODULE: ./tenants/_layouts.ts
/* eslint no-use-before-define: 0 */ /* AUTO GENERATE FILE - DO NOT EDIT */ 
// collections of all tenants' layout
const layouts = new Map();
layouts.set("phongvu_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(85675), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(34607), __webpack_require__.e(88002), __webpack_require__.e(760), __webpack_require__.e(53687), __webpack_require__.e(90588), __webpack_require__.e(95046), __webpack_require__.e(54607)]).then(__webpack_require__.bind(__webpack_require__, 254607)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(254607)
            ]
    }
}));
layouts.set("phongvu_mobile", dynamic_default()(()=>__webpack_require__.e(/* import() */ 50877).then(__webpack_require__.bind(__webpack_require__, 250877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(250877)
            ]
    }
}));
layouts.set("sgc_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(85675), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(34607), __webpack_require__.e(88002), __webpack_require__.e(760), __webpack_require__.e(53687), __webpack_require__.e(90588), __webpack_require__.e(95046), __webpack_require__.e(54607)]).then(__webpack_require__.bind(__webpack_require__, 254607)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(254607)
            ]
    }
}));
layouts.set("sgc_mobile", dynamic_default()(()=>__webpack_require__.e(/* import() */ 50877).then(__webpack_require__.bind(__webpack_require__, 250877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(250877)
            ]
    }
}));
layouts.set("soibien_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(85675), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(34607), __webpack_require__.e(88002), __webpack_require__.e(760), __webpack_require__.e(53687), __webpack_require__.e(90588), __webpack_require__.e(95046), __webpack_require__.e(54607)]).then(__webpack_require__.bind(__webpack_require__, 254607)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(254607)
            ]
    }
}));
layouts.set("soibien_mobile", dynamic_default()(()=>__webpack_require__.e(/* import() */ 50877).then(__webpack_require__.bind(__webpack_require__, 250877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(250877)
            ]
    }
}));
layouts.set("umbala_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(85675), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(34607), __webpack_require__.e(88002), __webpack_require__.e(760), __webpack_require__.e(53687), __webpack_require__.e(90588), __webpack_require__.e(95046), __webpack_require__.e(54607), __webpack_require__.e(64174)]).then(__webpack_require__.bind(__webpack_require__, 64174)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(64174)
            ]
    }
}));
layouts.set("umbala_mobile", dynamic_default()(()=>__webpack_require__.e(/* import() */ 50877).then(__webpack_require__.bind(__webpack_require__, 250877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(250877)
            ]
    }
}));
layouts.set("vnshop_desktop", dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(85675), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(34607), __webpack_require__.e(88002), __webpack_require__.e(760), __webpack_require__.e(53687), __webpack_require__.e(90588), __webpack_require__.e(95046), __webpack_require__.e(54607), __webpack_require__.e(83741)]).then(__webpack_require__.bind(__webpack_require__, 983741)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(983741)
            ]
    }
}));
layouts.set("vnshop_mobile", dynamic_default()(()=>__webpack_require__.e(/* import() */ 50877).then(__webpack_require__.bind(__webpack_require__, 250877)).then((mod)=>mod.Layout), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(250877)
            ]
    }
}));
/* harmony default export */ var _layouts = (layouts);
const templates = {
    "desktop": [
        {
            "pathname": "/[slug].tsx",
            "query": "slug",
            "regex": "/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/orders/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/orders/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/quotation/[token].tsx",
            "query": "token",
            "regex": "/account/quotation/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/return-order/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/return-order/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/block-categories/[categoryId].tsx",
            "query": "categoryId",
            "regex": "/block-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/brands/[brandId].tsx",
            "query": "brandId",
            "regex": "/brands/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/c/[slug].tsx",
            "query": "slug",
            "regex": "/c/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/confirm-payment/[orderId].tsx",
            "query": "orderId",
            "regex": "/confirm-payment/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/cua-hang/[providerId].tsx",
            "query": "providerId",
            "regex": "/cua-hang/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/landing/[id].tsx",
            "query": "id",
            "regex": "/landing/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/p/[slug].tsx",
            "query": "slug",
            "regex": "/p/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/products/detail/[productId].tsx",
            "query": "productId",
            "regex": "/products/detail/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/seller-categories/[sellerCategoryId].tsx",
            "query": "sellerCategoryId",
            "regex": "/seller-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/sellers/[sellerId].tsx",
            "query": "sellerId",
            "regex": "/sellers/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/tin-tuc/[slug].tsx",
            "query": "slug",
            "regex": "/tin-tuc/([^/\\[\\]]+)$"
        }
    ],
    "mobile": [
        {
            "pathname": "/[slug].tsx",
            "query": "slug",
            "regex": "/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/cancel-order/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/cancel-order/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/orders/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/orders/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/quotation/[token].tsx",
            "query": "token",
            "regex": "/account/quotation/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/account/return-order/[orderId].tsx",
            "query": "orderId",
            "regex": "/account/return-order/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/block-categories/[categoryId].tsx",
            "query": "categoryId",
            "regex": "/block-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/brands/[brandId].tsx",
            "query": "brandId",
            "regex": "/brands/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/c/[slug].tsx",
            "query": "slug",
            "regex": "/c/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/confirm-payment/[orderId].tsx",
            "query": "orderId",
            "regex": "/confirm-payment/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/cua-hang/[providerId].tsx",
            "query": "providerId",
            "regex": "/cua-hang/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/landing/[id].tsx",
            "query": "id",
            "regex": "/landing/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/my/address/[id].tsx",
            "query": "id",
            "regex": "/my/address/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/p/[slug].tsx",
            "query": "slug",
            "regex": "/p/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/products/[sku]/combos/[id].tsx",
            "query": "id",
            "regex": "/products/[sku]/combos/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/products/detail/[productId].tsx",
            "query": "productId",
            "regex": "/products/detail/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/seller-categories/[sellerCategoryId].tsx",
            "query": "sellerCategoryId",
            "regex": "/seller-categories/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/sellers/[sellerId].tsx",
            "query": "sellerId",
            "regex": "/sellers/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/tin-tuc/[slug].tsx",
            "query": "slug",
            "regex": "/tin-tuc/([^/\\[\\]]+)$"
        },
        {
            "pathname": "/vat/[orderId].tsx",
            "query": "orderId",
            "regex": "/vat/([^/\\[\\]]+)$"
        }
    ]
};

;// CONCATENATED MODULE: ./tenants/_routes.ts
/* harmony default export */ var _routes = ([
    {
        path: "/account/addresses",
        exact: true,
        screenName: "addressManager",
        contentType: "others"
    },
    {
        path: "/my/address-book",
        exact: true,
        screenName: "addressManager",
        contentType: "others"
    },
    {
        path: "/account",
        exact: true,
        screenName: "accountManager",
        contentType: "others"
    },
    {
        path: "/account/orders/:orderId",
        exact: true,
        screenName: "orderDetail",
        contentType: "others"
    },
    {
        path: "/account/orders",
        exact: true,
        screenName: "orderList",
        contentType: "others"
    },
    {
        path: /.*-\d+.cat/,
        exact: true,
        screenName: "categoryListProduct",
        contentType: "product_category"
    },
    {
        path: "/checkout",
        exact: true,
        screenName: "confirmOrder",
        contentType: "checkout"
    },
    {
        path: "/confirm-payment/:orderId",
        exact: true,
        screenName: "confirmPayment",
        contentType: "others"
    },
    {
        path: "/p/:slug",
        exact: true,
        screenName: "landingPage",
        contentType: "others"
    },
    {
        path: "/",
        exact: true,
        screenName: "homePage",
        contentType: "homepage"
    },
    {
        path: "/login",
        exact: true,
        screenName: "loginMethod",
        contentType: "others"
    },
    {
        path: "/order-result",
        exact: true,
        screenName: "orderResult",
        contentType: "checkout"
    },
    {
        path: /.*-s([\w.\-]{1,20})\.html/,
        exact: true,
        screenName: "productDetail",
        parser: (url)=>{
            // extract skuId from url
            const urlArray = url.split("-s");
            const skuPart = urlArray[urlArray.length - 1];
            const result = skuPart.match(/([\w.\-]{1,20})\.html/);
            return {
                skuId: result && result[1] ? result[1] : null
            };
        },
        contentType: "product_detail"
    },
    {
        path: /.*--s([\w.\-]{1,20})/,
        exact: true,
        screenName: "productDetail",
        parser: (url)=>{
            const result = url.match(/--s([\w.\-]{1,20})/);
            return {
                skuId: result && result[1] ? result[1] : null
            };
        },
        contentType: "product_detail"
    },
    {
        path: "/search",
        exact: true,
        screenName: "searchProductResult",
        contentType: "product_category"
    },
    {
        path: "/buildpc",
        exact: true,
        screenName: "buildPCSelfBuild",
        contentType: "others"
    },
    {
        path: "/auth/vnpay/login",
        exact: true,
        screenName: "loginMethod",
        contentType: "others"
    },
    {
        path: "/cart",
        exact: true,
        screenName: "cart",
        contentType: "checkout"
    },
    {
        path: /.*-brand\..*/,
        exact: true,
        screenName: "brandPage",
        contentType: "other"
    },
    {
        path: /.*-sel\.\d+/,
        exact: true,
        screenName: "sellerPage",
        contentType: "other"
    },
    {
        path: "/cua-hang/:providerId",
        exact: true,
        screenName: "providerPage",
        contentType: "other"
    },
    {
        path: /.*-cat\.\d+/,
        exact: true,
        screenName: "masterCategory",
        contentType: "other"
    },
    {
        path: /.*-scat\..*/,
        exact: true,
        screenName: "sellerCategory",
        contentType: "other"
    },
    {
        path: "/landing/:slug",
        exact: true,
        screenName: "landingPage",
        contentType: "other"
    }, 
]);

;// CONCATENATED MODULE: ./tenants/_app.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}































const ProfileWithAddressMobile = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(45876), __webpack_require__.e(62350), __webpack_require__.e(78554), __webpack_require__.e(34457), __webpack_require__.e(44304)]).then(__webpack_require__.bind(__webpack_require__, 344304)).then((mod)=>mod.ProfileWithAddressMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(344304)
            ]
    }
});
const ProfileWithAddressDesktop = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(45876), __webpack_require__.e(62350), __webpack_require__.e(78554), __webpack_require__.e(34457), __webpack_require__.e(77301)]).then(__webpack_require__.bind(__webpack_require__, 877301)).then((mod)=>mod.ProfileWithAddressDesktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(877301)
            ]
    }
});
const ProfileUpdateModal = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(78967)]).then(__webpack_require__.bind(__webpack_require__, 710662)).then((mod)=>mod.ProfileUpdateModal), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(710662)
            ]
    }
});
const ProfileFormMobile = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(53197), __webpack_require__.e(79539), __webpack_require__.e(31642), __webpack_require__.e(42433), __webpack_require__.e(25941), __webpack_require__.e(41998), __webpack_require__.e(73317), __webpack_require__.e(37104), __webpack_require__.e(64986), __webpack_require__.e(41021), __webpack_require__.e(97803)]).then(__webpack_require__.bind(__webpack_require__, 623114)).then((mod)=>mod.ProfileForm), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(623114)
            ]
    }
});
const serverless = (0,helpers/* isServerless */.ep)();
const Layout = (_param)=>{
    var { Component  } = _param, props = _objectWithoutProperties(_param, [
        "Component"
    ]);
    var ref, ref1;
    const { children , banners , menuItems , liteLogo , layoutAreas , layoutConfig , pageProps , inlineBanners ,  } = props;
    const { isMobile , template , tenant , footerDataConfig ={} , rightMenuTopBarButtonConfigs =[] , leftMenuTopBarButtonConfigs =[] , availableLanguages , requireLogin , profileRequiredAfterLogin , isDmsFlow , supportedPhone , isNeedToUpdateProfile , forceUpdatePhoneNumber ,  } = (0,GlobalDataContext/* useGlobalData */.U5)();
    const { user , loading: isLoadingUser , showProfileModal , setShowProfileModal ,  } = (0,context_es/* useAuth */.aC)();
    const router = (0,next_router.useRouter)();
    const { shouldShowSelector: shouldShowPrivacyPolicySelector , showSelector: showPrivacyPolicySelector ,  } = (0,PrivacyPolicyContext/* usePrivacyPolicy */.q)();
    const { orderService  } = (0,ServiceContext/* useServices */.Su)();
    const { showModal  } = (0,hook_es/* useModal */.d)();
    // load a language resource on the client
    (0,react.useEffect)(()=>{
        if (serverless && window.track) {
            var ref, ref1, ref2;
            const userId = (user === null || user === void 0 ? void 0 : user.userId) || ((ref2 = (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.getUserInfo()) === null || ref2 === void 0 ? void 0 : ref2.sub);
            if (userId) {
                window.track("setUserId", userId);
            }
        // comment out because link tracking
        // sends duplicate events
        // window.track('enableLinkClick');
        }
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        serverless && !!((ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.getUserInfo())
    ]);
    const showDmsFlowError = function() {
        let showCloseButton = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        showModal(_objectSpreadProps(_objectSpread({
            title: (0,i18n.t)("Th\xf4ng b\xe1o"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                children: (0,i18n.t)("Kh\xf4ng lấy được th\xf4ng tin để hiển thị sản phẩm d\xe0nh cho bạn. Vui l\xf2ng thử lại hoặc li\xean hệ {{phone}} để được hỗ trợ", {
                    phone: supportedPhone
                })
            }),
            okText: (0,i18n.t)("Thử lại"),
            onOk: ()=>{
                window.location.reload();
            }
        }, showCloseButton ? {
            cancelText: (0,i18n.t)("Đ\xf3ng"),
            onCancel () {
                var ref, ref1;
                window === null || window === void 0 ? void 0 : (ref = window.TekoID) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.logout();
            }
        } : {
            cancelText: ""
        }), {
            closable: false,
            showCloseIcon: false,
            width: 400
        }));
    };
    (0,react.useEffect)(()=>{
        if (isDmsFlow && serverless && !isLoadingUser) {
            const currentUserTerminalId = (0,env/* getCookieByName */.A7)(terminal/* USER_TERMINAL_ID */.pT);
            const currentUserTerminalCode = (0,env/* getCookieByName */.A7)(terminal/* USER_TERMINAL_CODE */.Fk);
            const currentUserLocationCode = (0,env/* getCookieByName */.A7)(terminal/* USER_LOCATION_CODE */.UE);
            if (user) {
                const loadUserLocationAndTerminal = async ()=>{
                    let needReloadPage = false;
                    // if user has not default address => throw error
                    if (!user.address) {
                        // Display error
                        showDmsFlowError(true);
                        return;
                    } else {
                        // set location = detail level location of user
                        const userLocation = user.address.wardCode || user.address.districtCode || user.address.provinceCode;
                        if (!!userLocation && userLocation !== currentUserLocationCode) {
                            (0,env/* setCookieValue */.d7)(terminal/* USER_LOCATION_CODE */.UE, userLocation);
                            needReloadPage = true;
                        }
                    }
                    try {
                        const customerTypeId = user.customerTypeId;
                        if (customerTypeId) {
                            const { terminalId , terminalCode  } = await orderService.getUserTerminal({
                                customerTypeId
                            });
                            if (!!terminalId && !!terminalCode && currentUserTerminalId !== terminalId.toString() && currentUserTerminalCode !== terminalCode) {
                                (0,env/* setCookieValue */.d7)(terminal/* USER_TERMINAL_ID */.pT, terminalId.toString());
                                (0,env/* setCookieValue */.d7)(terminal/* USER_TERMINAL_CODE */.Fk, terminalCode);
                                needReloadPage = true;
                            }
                        }
                    } catch (error) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        switch(error === null || error === void 0 ? void 0 : error.code){
                            case 404:
                                // case 404 user unassign terminal => allow user select location
                                if (!!currentUserTerminalCode && !!currentUserTerminalId) {
                                    (0,env/* setCookieValue */.d7)(terminal/* USER_TERMINAL_ID */.pT, "");
                                    (0,env/* setCookieValue */.d7)(terminal/* USER_TERMINAL_CODE */.Fk, "");
                                    needReloadPage = true;
                                }
                                break;
                            default:
                                showDmsFlowError();
                        }
                    } finally{
                        if (needReloadPage) {
                            window.location.reload();
                        }
                    }
                };
                loadUserLocationAndTerminal();
            }
        }
    }, [
        user,
        isDmsFlow,
        serverless,
        isLoadingUser
    ]);
    (0,react.useEffect)(()=>{
        // login page has it's own show pivacy policy logic
        if (shouldShowPrivacyPolicySelector && !router.pathname.endsWith("/login") && !!(user === null || user === void 0 ? void 0 : user.userId)) showPrivacyPolicySelector(()=>{});
    }, [
        shouldShowPrivacyPolicySelector
    ]);
    // Trigger show profile modal in case forceUpdatePhoneNumber = false (for SGC)
    (0,react.useEffect)(()=>{
        if (isNeedToUpdateProfile && !forceUpdatePhoneNumber && (user === null || user === void 0 ? void 0 : user.userId) && !(user === null || user === void 0 ? void 0 : user.telephone)) {
            setShowProfileModal(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.telephone
    ]);
    // Get showProfileModal info is saved from step confirm account success to show profile modal (for SGC)
    (0,react.useEffect)(()=>{
        const value = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("showProfileModal")) === "true";
        if (value) setShowProfileModal(value);
    }, []);
    //@TODO: remove tenant in here
    const tpl = template || tenant;
    const defaultTemplate = "vnshop";
    const footerData = (0,translate/* translateObject */.bb)(footerDataConfig);
    const rightMenu = (0,RightMenu/* renderTopBarMenu */.O)((0,translate/* translateObject */.bb)(rightMenuTopBarButtonConfigs), !!availableLanguages ? [
        LanguageSelector/* LanguageSelector */.$
    ] : []);
    const leftMenu = (0,RightMenu/* renderTopBarMenu */.O)((0,translate/* translateObject */.bb)(leftMenuTopBarButtonConfigs));
    const showProfileWithAddressUpdate = profileRequiredAfterLogin && !!user && (!(user === null || user === void 0 ? void 0 : user.name) || !(user === null || user === void 0 ? void 0 : user.dob) || !(user === null || user === void 0 ? void 0 : user.sex) || !(user === null || user === void 0 ? void 0 : user.address));
    // In case, need to update profile after login (SGC) and user does not have a phone number (showProfileModal state is checked in auth context - after confirm phone number in case login with social)
    const showProfileUpdateModal = isNeedToUpdateProfile && !!user && showProfileModal;
    const handleCloseProfileModal = ()=>{
        setShowProfileModal(false);
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.removeItem("showProfileModal");
    };
    if (isMobile) {
        const MobileLayout = _layouts.get("".concat(tpl, "_mobile")) || _layouts.get("".concat(defaultTemplate, "_mobile"));
        return showProfileWithAddressUpdate ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileWithAddressMobile, {}) : showProfileUpdateModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileFormMobile, {
            phone: (user === null || user === void 0 ? void 0 : user.telephone) || "",
            onCloseForm: handleCloseProfileModal,
            profileId: user === null || user === void 0 ? void 0 : user.id
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLayout, {
            forceLogin: requireLogin,
            layoutAreas: layoutAreas,
            getLayout: Component === null || Component === void 0 ? void 0 : Component.getLayout,
            layoutConfig: layoutConfig,
            pageProps: pageProps,
            menuItems: menuItems,
            inlineBanners: inlineBanners,
            children: children
        });
    } else {
        const DesktopLayout = _layouts.get("".concat(tpl, "_desktop")) || _layouts.get("".concat(defaultTemplate, "_desktop"));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "minWidthWrapper",
            style: {
                minWidth: "945px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DesktopLayout, {
                banners: banners,
                menuItems: menuItems,
                liteLogo: liteLogo,
                footerData: footerData,
                rightMenu: rightMenu,
                leftMenu: leftMenu,
                // hotfix the forceLogin for karavan
                // will refractor this in ECOM-362
                forceLogin: requireLogin,
                layoutAreas: layoutAreas,
                layoutConfig: layoutConfig,
                pageProps: pageProps,
                inlineBanners: inlineBanners,
                children: [
                    children,
                    showProfileWithAddressUpdate && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileWithAddressDesktop, {}),
                    showProfileUpdateModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileUpdateModal, {
                        visible: showProfileModal,
                        onCloseModal: handleCloseProfileModal,
                        phone: (user === null || user === void 0 ? void 0 : user.telephone) || "",
                        profileId: user === null || user === void 0 ? void 0 : user.id
                    })
                ]
            })
        });
    }
};
const MyApp = (param)=>{
    let { Component , pageProps , globalData , banners , menuItems , featureFlags , liteLogo , layoutAreas , tempiLayout , inlineBanners  } = param;
    var ref, ref1, ref2;
    if (!globalData || Object.keys(globalData).length === 0) {
        // as getInitialProps function now fallback to an empty object
        // we throw exception when object is empty
        dist_index_es/* logger.error */.k.error("Empty global data when render ".concat(Component.name, ". Probably unable to detect tenant from hostname."));
        throw new Error("Missing global data when rendering component");
    }
    // alter localStorage and sessionStorage with a simple storage in case storages are not available
    if ( true && !storageAvailable("localStorage")) {
        Object.defineProperty(window, "localStorage", {
            value: new MockStorage()
        });
    }
    if ( true && !storageAvailable("sessionStorage")) {
        Object.defineProperty(window, "sessionStorage", {
            value: new MockStorage()
        });
    }
    // menuItems, banners and layoutAreas (custom page)
    // are fetched in Document.getInitialProps
    // and passed to MyApp in renderPage function.
    // For client-side transition,
    // get them from window object instead.
    banners = banners || (serverless ? window.banners : []);
    menuItems = menuItems || (serverless ? window.menuItems : []);
    layoutAreas = layoutAreas || (serverless ? window.layoutAreas : []);
    tempiLayout = tempiLayout || (serverless ? window.tempiLayout : undefined);
    pageProps = _objectSpreadProps(_objectSpread({}, pageProps), {
        menu: (tempiLayout === null || tempiLayout === void 0 ? void 0 : tempiLayout.menu) || []
    });
    featureFlags = featureFlags || (serverless ? window.featureFlags : null);
    inlineBanners = inlineBanners || (serverless ? window.inlineBanners : null);
    const { publicRuntimeConfig  } = config_default()();
    const { tenant , isMobile , scopes , terminal , currentLanguage , trackingId , enableSearchAlgoABTesting , disableATCFromListingPageRegexes =[] ,  } = globalData;
    // object fetched by getInitialProps does not
    // preserve function getProcessEnv when comes to client-side
    // re-initialize the object for that
    // if (epicOmni1584) {
    //   const { terminal: terminalCookie, terminalId } =
    //     getTerminalFromCookie(isMobile);
    //   globalData = {
    //     ...globalData,
    //     terminal:
    //       epicOmni1584 &&
    //       !!terminalCookie &&
    //       terminalCookie !== globalData.terminal
    //         ? terminalCookie
    //         : globalData.terminal,
    //     terminalId:
    //       epicOmni1584 &&
    //       !!terminalId &&
    //       Number(terminalId) !== globalData.terminalId
    //         ? Number(terminalId)
    //         : globalData.terminalId,
    //   };
    // }
    if (!globalData.getProcessEnv) {
        globalData = new ClientTenantEnvImpl(globalData);
    }
    const languageCode = currentLanguage || i18n/* DEFAULT_LANGUAGE */.k$;
    if (!serverless) {
        (0,i18n/* changeLanguage */.D0)(languageCode);
    }
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const { 0: history , 1: setHistory  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        setHistory((prev)=>{
            if (prev[prev.length - 1] === router.asPath) return prev;
            const newHistory = prev.length >= 20 ? prev.slice(1) : prev;
            return [
                ...newHistory,
                router.asPath
            ];
        });
    }, [
        router.asPath
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (router && !router.intercepted) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const customizedRouter = router;
        // the singleton router object created
        // intercept call to this method
        // this code ensure that when a next/link is clicked on the client-side
        // and navigation happens, the actual data fetched is prefixed with <tenant> path
        // Under the hood, next/link calls next/router to trigger page navigation
        // and it populates "as" field by default with the same value as "path";
        [
            "replace",
            "push",
            "prefetch"
        ].forEach((method)=>{
            const originalMethod = customizedRouter[method];
            customizedRouter[method] = function(path, asPath) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var ref;
                // turn off client-side routing for websites embedded in apps
                if ((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.epic_ecom_479) && dist/* default.isAvailable */.Z.isAvailable()) {
                    if ([
                        "replace",
                        "push"
                    ].includes(method)) {
                        window.location.href = (asPath === null || asPath === void 0 ? void 0 : asPath.toString()) || (path === null || path === void 0 ? void 0 : path.toString()) || window.location.href;
                    }
                    return;
                }
                const { buildId  } = window.__NEXT_DATA__;
                const defaultTenant = publicRuntimeConfig.defaultTenantDir;
                const { pathname  } = (0,native_url.parse)(typeof path === "string" ? path : path.pathname);
                if (pathname === null || pathname === void 0 ? void 0 : pathname.match(/\/([\w\d\-]+)\/(mobile|desktop)(.*)/)) {
                    return originalMethod.call(router, path, asPath, ...args);
                }
                const platform = isMobile ? "mobile" : "desktop";
                const pages = ((ref = window.__BUILD_MANIFEST) === null || ref === void 0 ? void 0 : ref.sortedPages) || [];
                const customizedPath = (0,remove_trailing_slash.removeTrailingSlash)("/".concat(tenant, "/").concat(platform).concat(pathname));
                const defaultPath = (0,remove_trailing_slash.removeTrailingSlash)("/".concat(defaultTenant, "/").concat(platform).concat(pathname));
                let finalTenant = "";
                if (buildId === "development") {
                    finalTenant = pages.includes(customizedPath) ? tenant : pages.includes(defaultPath) ? defaultTenant : tenant;
                } else {
                    finalTenant = pages.includes(customizedPath) ? tenant : defaultTenant;
                }
                const param = typeof path === "string" ? (0,remove_trailing_slash.removeTrailingSlash)("/".concat(finalTenant, "/").concat(platform).concat(path)) : _objectSpreadProps(_objectSpread({}, path), {
                    pathname: (0,remove_trailing_slash.removeTrailingSlash)("/".concat(finalTenant, "/").concat(platform).concat(path.pathname))
                });
                asPath = asPath || path;
                return originalMethod.call(router, param, asPath, ...args);
            };
        });
        const originalMethod = customizedRouter["back"];
        // method call arguments can be anything
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        customizedRouter["back"] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (!history.length) return router.push("/");
            return originalMethod.call(...args);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        router.intercepted = true;
    }
    (0,usePos365StoreCode/* usePos365StoreCode */.c)();
    (0,react.useEffect)(()=>{
        const initTracker = (trackerAppId)=>{
            if (trackerAppId) {
                new (dist_default())({
                    host: globalData.getProcessEnv("TRACKER_HOST_URL"),
                    urlServeJsFile: globalData.getProcessEnv("TRACKER_SERVER_JS_URL"),
                    appId: trackerAppId,
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    routes: _routes,
                    injectScript: false
                });
                window.track("enableTrackVisibleContentImpressions");
                window.track("setTerminal", terminal);
                /**
         * because tracking is low priority so they should be
         * executed in idle cycle to avoid blocking user handler
         * TEMPORARILY COMMENT OUT BECAUSE IT CAUSING A BUG
         */ // const trackOrigin = window.track;
                // window.track = function (...args: any[]) {
                //   function _track(deadline: IdleDeadline) {
                //     if (deadline.timeRemaining() > 0 || deadline.didTimeout) {
                //       if (args.length === 1) {
                //         const [event] = args;
                //         trackOrigin(event);
                //       } else if (args.length === 2) {
                //         const [event, data] = args;
                //         trackOrigin(event, data);
                //       } else {
                //         const [eventType, eventName, data] = args;
                //         trackOrigin(eventType, eventName, data);
                //       }
                //       return;
                //     }
                //     requestIdleCallback(_track);
                //   }
                //   requestIdleCallback(_track);
                // };
                if (serverless) {
                    const originalFetch = window.fetch;
                    window.fetch = function initTracker() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return originalFetch.apply(this, args).then(async function(data) {
                            if (data.status >= 400) {
                                data.clone().json().then((res)=>{
                                    var ref;
                                    window.track("error", {
                                        errorSource: "http",
                                        apiCall: data.url,
                                        apiPayload: JSON.stringify(args),
                                        httpResponseCode: "".concat(data.status),
                                        responseJson: JSON.stringify(res),
                                        errorCode: "".concat(res.code) || "unknown",
                                        errorMessage: res.message || (res === null || res === void 0 ? void 0 : (ref = res.error) === null || ref === void 0 ? void 0 : ref.message) || "unknown"
                                    });
                                });
                            }
                            return data;
                        });
                    };
                }
            } else {
                if (serverless) {
                    // polyfill with a dummy tracking function
                    // to avoid undefined fn errors somewhere else
                    window.track = ()=>{};
                }
            }
        };
        if ((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.epic_ecom_479) && dist/* default.isAvailable */.Z.isAvailable()) {
            dist/* default.tracker */.Z.tracker().getTrackingAppId().then((trackerAppId)=>initTracker(trackerAppId));
        } else {
            initTracker(globalData.getProcessEnv("TRACKER_APP_ID") || trackingId);
        }
        saveUtmCookie(query);
        if (query === null || query === void 0 ? void 0 : query.referral) {
            (0,helpers/* setCookieByName */.Re)("referral", "".concat(query.referral.toString(), ";SameSite=None;Secure;"));
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (serverless && !!enableSearchAlgoABTesting) {
            // find search algo in local storage
            const localSearchAlgo = (0,env/* getCookieByName */.A7)(search/* SEARCH_ALGO.COOKIE */.XH.COOKIE);
            // if no local search algo version found
            if (!localSearchAlgo && localSearchAlgo !== "") {
                // generate cookie expire time
                const expireTime = (0,datetime/* getExpireTime */.bh)(search/* SEARCH_ALGO.EXPIRE_TIME */.XH.EXPIRE_TIME);
                // random a new algo & set to cookie
                (0,helpers/* setCookieByName */.Re)(search/* SEARCH_ALGO.COOKIE */.XH.COOKIE, (0,common/* getSearchAlgo */.vf)(), expireTime, "/");
            }
            // override search_algorithm value in cookie if user override in url
            if (!!Object.keys(router.query).length && !!router.query.hasOwnProperty(search/* SEARCH_ALGO.COOKIE */.XH.COOKIE)) {
                // generate cookie expire time
                const expireTime1 = (0,datetime/* getExpireTime */.bh)(search/* SEARCH_ALGO.EXPIRE_TIME */.XH.EXPIRE_TIME);
                (0,helpers/* setCookieByName */.Re)(search/* SEARCH_ALGO.COOKIE */.XH.COOKIE, JSON.stringify(router.query[search/* SEARCH_ALGO.COOKIE */.XH.COOKIE]), expireTime1, "/");
            }
        }
    }, [
        enableSearchAlgoABTesting,
        router.query
    ]);
    const services = (0,ServiceContext/* initializeServices */.bl)(globalData);
    const uiTheme = globalData.theme;
    const dsTheme = (0,react.useMemo)(()=>{
        const theme = (0,utils_es/* generateTheme */.I0)({
            primary: uiTheme.brand.primary,
            secondary: uiTheme.brand.secondary
        });
        theme.colors = _objectSpread({}, theme.colors, uiTheme.colors);
        return theme;
    }, [
        uiTheme.brand.primary,
        uiTheme.brand.secondary,
        uiTheme.colors
    ]);
    const isAllowATCFromListing = disableATCFromListingPageRegexes.every((regex)=>!new RegExp(regex).test(router.asPath));
    globalData.isAllowATCFromListing = isAllowATCFromListing;
    var _partner;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageProvider, {
        code: languageCode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RouterProvider/* RouterProvider */.p, {
            router: router,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider_es/* ThemeProvider */.f, {
                theme: uiTheme,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Theme_es/* ThemeProvider */.f, {
                    theme: dsTheme,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Loading_context_es/* LoadingProvider */.PK, {
                        logo: (ref2 = ((ref = globalData.logo) === null || ref === void 0 ? void 0 : ref.loading) || ((ref1 = globalData.logo) === null || ref1 === void 0 ? void 0 : ref1.lite)) === null || ref2 === void 0 ? void 0 : ref2.path,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_MetaHead, {
                                theme: uiTheme,
                                config: globalData,
                                meta: globalData.meta
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalDataContext/* GlobalDataProvider */.Uw, {
                                value: globalData,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ServiceContext/* ServiceProvider */.UT, {
                                    services: services,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperContext/* HelperProvider */.d, {
                                        discoveryPos365Service: services.discoveryPos365Service,
                                        freeShippingThreshold: globalData === null || globalData === void 0 ? void 0 : globalData.freeShippingThreshold,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context_es/* AuthContextProvider */.HD, {
                                            partner: (_partner = globalData.partner) !== null && _partner !== void 0 ? _partner : "",
                                            scopes: scopes || [
                                                "openid",
                                                "profile",
                                                "us",
                                                "om",
                                                "ppm",
                                                "loyalty-consumer-bff",
                                                "payment-consumer-bff",
                                                "staff-bff", 
                                            ],
                                            userService: services.userService,
                                            authService: services.authService,
                                            router: router,
                                            showConfirmModalAfterLogin: globalData === null || globalData === void 0 ? void 0 : globalData.showConfirmModalAfterLogin,
                                            forceUpdatePhoneNumber: globalData === null || globalData === void 0 ? void 0 : globalData.forceUpdatePhoneNumber,
                                            isNeedToUpdateProfile: globalData === null || globalData === void 0 ? void 0 : globalData.isNeedToUpdateProfile,
                                            otpRequestCountDown: globalData === null || globalData === void 0 ? void 0 : globalData.otpRequestCountDown,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagProvider/* FeatureFlagProvider */.O, {
                                                flags: featureFlags,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationProvider/* LocationProvider */.v, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FrameContext/* FrameProvider */.r, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularKeywordContext/* PopularKeywordProvider */.$, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenContext/* ScreenProvider */.nX, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoyaltyProvider/* LoyaltyProvider */.Q, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartContextV2/* CartProviderV2 */.q, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider/* NotificationProvider */.JB, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeviceContext_es/* DeviceProvider */.Y, {
                                                                                value: {
                                                                                    isMobile
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicyContext/* PrivacyPolicyProvider */.p, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeLevelLocationProvider/* ThreeLevelLocationProvider */.rq, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DistanceTerminalProvider/* DistanceTerminalProvider */.S, {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionPickerProvider/* RegionPickerProvider */.k, {
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesProvider/* CategoriesProvider */.z, {
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedProductContext/* RelatedProductProvider */.P, {
                                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                                                                                                            Component: Component,
                                                                                                            banners: banners,
                                                                                                            menuItems: menuItems,
                                                                                                            liteLogo: liteLogo,
                                                                                                            layoutAreas: layoutAreas,
                                                                                                            layoutConfig: tempiLayout === null || tempiLayout === void 0 ? void 0 : tempiLayout.layoutConfig,
                                                                                                            pageProps: pageProps,
                                                                                                            inlineBanners: inlineBanners,
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HistoryProvider, {
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartBanner, {}),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpreadProps(_objectSpread({}, pageProps), {
                                                                                                                        menuItems: menuItems,
                                                                                                                        inlineBanners: inlineBanners
                                                                                                                    }))
                                                                                                                ]
                                                                                                            })
                                                                                                        })
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
MyApp.getInitialProps = async (appContext)=>{
    var ref, ref1;
    // note this function is called every time
    // page transition happen,
    // so please think twice before adding any data-fetching logic
    // here.
    // Ideally, we would like to remove this function altogether.
    // But Nextjs's static optimization does not call
    // Document.getInitialProps for pages like /404,
    // which prevents the page from getting platform config.
    let globalTenantEnv;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (((ref = appContext.ctx.req) === null || ref === void 0 ? void 0 : (ref1 = ref.tenantEnv) === null || ref1 === void 0 ? void 0 : ref1.tenant) === "sgc") {
        dist_index_es/* logger.info */.k.info(appContext.ctx.req, "appContext.ctx.req");
    }
    if (appContext.ctx.req) {
        var ref2, ref3;
        // for pages that are SSR
        // this function is triggered on server-side
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        globalTenantEnv = appContext.ctx.req.tenantEnv;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (((ref2 = appContext.ctx.req) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.tenantEnv) === null || ref3 === void 0 ? void 0 : ref3.tenant) === "sgc") {
            dist_index_es/* logger.info */.k.info(globalTenantEnv, "globalTenantEnv");
        }
        // normally, this should not happen
        // but server log has issues with this otherwise
        // adding log to detect issues
        if (!globalTenantEnv) {
            dist_index_es/* logger.error */.k.error("Could not find tenant config for request " + appContext.ctx.req.url);
        }
    } else {
        // for client-side only page, get this value from window
        // since req object is not set
        //@ts-ignore
        globalTenantEnv = window.__tenantConfig;
        dist_index_es/* logger.info */.k.info(globalTenantEnv, "window.__tenantConfig");
    }
    var _asPath;
    const liteLogo = !(0,common/* isHomepage */.GH)((_asPath = appContext.ctx.asPath) !== null && _asPath !== void 0 ? _asPath : "");
    const appProps = await app["default"].getInitialProps(appContext);
    return _objectSpreadProps(_objectSpread({}, appProps), {
        globalData: omitServerFields(globalTenantEnv),
        liteLogo
    });
};
// omit some fields without using in clients, ex: updatedUrlMap
function omitServerFields(tenantConfig) {
    if (!tenantConfig) {
        return {};
    }
    const serverFields = new Set([
        "updatedUrlMap"
    ]);
    return Object.fromEntries(Object.entries(tenantConfig || {}).filter((param)=>{
        let [k] = param;
        return !serverFields.has(k);
    }));
}
function reportWebVitals(metric) {
    if (!serverless || metric.label !== "web-vital") return;
    (0,polyfill_es/* requestIdleCallback */.Kk)(()=>{
        var ref;
        (ref = window.track) === null || ref === void 0 ? void 0 : ref.call(window, "customEvent", "web-vital", {
            category: metric.name,
            label: metric.label,
            value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value)
        });
    });
}
/* harmony default export */ var _app = (MyApp);
const saveUtmCookie = (query)=>{
    const { utm_source ="" , utm_campaign ="" , utm_term ="" , utm_content ="" , utm_medium ="" , gclid ="" , fbclid ="" ,  } = query;
    const currentDate = new Date();
    const date = new Date(currentDate.getFullYear() + 2, currentDate.getMonth(), currentDate.getDay());
    const expireTime = date.toUTCString();
    if (utm_source) {
        (0,helpers/* setCookieByName */.Re)("utmSource", utm_source, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmCampaign", utm_campaign, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmTerm", utm_term, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmContent", utm_content, expireTime);
        (0,helpers/* setCookieByName */.Re)("utmMedium", utm_medium, expireTime);
    }
    if (gclid) (0,helpers/* setCookieByName */.Re)("gclid", gclid, expireTime);
    if (fbclid) (0,helpers/* setCookieByName */.Re)("fbclid", fbclid, expireTime);
}; // const getTerminalFromCookie = (
 //   isMobile: boolean,
 // ): { terminal: string; terminalId: string } => {
 //   const terminalCodeFromStorage = getUserSelectedInfo(
 //     userSelectedConstants.TERMINAL,
 //     isMobile,
 //     true,
 //   );
 //   const terminalIdFromStorage = getUserSelectedInfo(
 //     userSelectedConstants.TERMINAL_ID,
 //     isMobile,
 //     true,
 //   );
 //   return {
 //     terminal: terminalCodeFromStorage || '',
 //     terminalId: terminalIdFromStorage || '',
 //   };
 // };

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/ds-desktop.css
var ds_desktop = __webpack_require__(156607);
// EXTERNAL MODULE: ./styles/global.css
var global = __webpack_require__(556418);
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-select-virtual-edcfb48413/0/cache/rc-select-npm-14.16.8-2451a0ef4e-c2eabac8cb.zip/node_modules/rc-select/assets/index.less
var assets = __webpack_require__(155670);
;// CONCATENATED MODULE: ./pages/_app.tsx
// AUTO GENERATED FILE. DO NOT EDIT.





/* harmony default export */ var pages_app = (_app);


/***/ }),

/***/ 44844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ ppmApi; },
/* harmony export */   "I1": function() { return /* binding */ serverApi; },
/* harmony export */   "Ue": function() { return /* binding */ searchApi; },
/* harmony export */   "Wk": function() { return /* binding */ publicSettingApi; },
/* harmony export */   "_6": function() { return /* binding */ magentoApi; },
/* harmony export */   "hS": function() { return /* binding */ consumerBffApi; }
/* harmony export */ });
/* unused harmony exports wordpressPVApi, wordpressApi */
/* harmony import */ var _teko_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(799278);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(353632);


const magentoApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_EXTRA_SERVICE_URL"));
const serverApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]("/api");
const searchApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]( false ? 0 : (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_SEARCH_URL"));
const wordpressPVApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_WORDPRESS_URL"));
const ppmApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_PPM_URL"));
const publicSettingApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_PUBLIC_SETTING_API"));
const wordpressApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_WORDPRESS_API"));
const consumerBffApi = new _teko_api__WEBPACK_IMPORTED_MODULE_0__["default"]((0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getEnv */ .dU)("BASE_COV_URL"));


/***/ }),

/***/ 427342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ searchService; }
/* harmony export */ });
/* harmony import */ var _clients_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44844);
/* harmony import */ var _helpers_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(353632);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(775002);



const transformBanner = (banner)=>({
        id: banner.id.toString(),
        image: banner.image,
        priority: banner.priority,
        campaignName: banner.campaign_name,
        zone: banner.zone,
        targetPath: banner.target_path,
        urlType: banner.url_type,
        thumbnail: banner.thumbnail,
        description: banner.description,
        startDate: banner.start_date,
        endDate: banner.end_date
    });
const transformNews = (news)=>(0,_teko_utils__WEBPACK_IMPORTED_MODULE_0__.cleanObject)({
        metaDescription: news.meta_description,
        isActive: news.is_active,
        metaTitle: news.meta_title,
        updateAt: news.updated_at,
        imageUrl: news.image_url,
        isMagazine: news.is_magazine,
        metaKeyword: news.meta_keyword,
        name: news.name,
        id: news.id,
        terminals: news.terminals,
        content: news.content,
        urlKey: news.url_key
    });
const cookBanners = (param)=>{
    let { data  } = param;
    return (data.documents || []).map(transformBanner);
};
const cookNews = (param)=>{
    let { data  } = param;
    return ((data === null || data === void 0 ? void 0 : data.documents) || []).map(transformNews);
};
_clients_api__WEBPACK_IMPORTED_MODULE_1__/* .searchApi.addInterceptor */ .Ue.addInterceptor((request)=>{
    request.headers.set("x-tk-access-token", (0,_helpers_env__WEBPACK_IMPORTED_MODULE_2__/* .getEnv */ .dU)("SEARCH_API_ACCESS_TOKEN"));
});
class SearchService {
    async getBanner(body) {
        const res = await _clients_api__WEBPACK_IMPORTED_MODULE_1__/* .searchApi.post */ .Ue.post("/v1/banner/search", body);
        return cookBanners(res.data);
    }
    async getBannerByZone(zone, terminal) {
        const filter = {
            filters: [
                {
                    key: "terminals",
                    value: terminal
                },
                {
                    key: "is_active",
                    value: true
                },
                {
                    key: "zone",
                    value: zone
                }, 
            ],
            page_size: 15,
            sorts: [
                {
                    field: "priority",
                    type: "ASC"
                }, 
            ]
        };
        return await this.getBanner(filter);
    }
    async getNewsFeed(terminal, slug) {
        let page = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, pageSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 15;
        var ref, ref1, ref2, ref3, ref4, ref5;
        const filters = [
            {
                key: "terminals",
                value: terminal
            },
            {
                key: "is_active",
                value: 1
            }, 
        ];
        if (slug) {
            filters.push({
                key: "url_key",
                value: slug
            });
        }
        const res = await _clients_api__WEBPACK_IMPORTED_MODULE_1__/* .searchApi.post */ .Ue.post("/v1/pb_news/search", {
            filters,
            page_size: pageSize,
            page: page
        });
        return {
            news: cookNews((res === null || res === void 0 ? void 0 : res.data) || []),
            totalItems: (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.page_response) === null || ref2 === void 0 ? void 0 : ref2.total_items) || 0,
            totalPages: (res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.page_response) === null || ref5 === void 0 ? void 0 : ref5.total_page) || 0
        };
    }
}
const searchService = new SearchService();


/***/ }),

/***/ 794416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ renderTopBarMenu; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/TopbarDropdown.es.js
var TopbarDropdown_es = __webpack_require__(154686);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/Topbar/TopbarButton.es.js
var TopbarButton_es = __webpack_require__(652966);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_helpers/RightMenu/TopBarButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





const BusinessCustomerOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.BusinessCustomerOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const HeadphoneOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.HeadphoneOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const ShowroomOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.ShowroomOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const TvNewOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.TvNewOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const PromoOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.PromoOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const BuildPcOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.BuildPcOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const MailOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.MailOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const FacebookFilled = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.FacebookFilled), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const ShopOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.ShopOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const PhoneOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.PhoneOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
const BriefCaseOutlined = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(94787), __webpack_require__.e(44573), __webpack_require__.e(48482), __webpack_require__.e(67285), __webpack_require__.e(321), __webpack_require__.e(99611)]).then(__webpack_require__.bind(__webpack_require__, 300321)).then((mod)=>mod.BriefCaseOutlined), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(300321)
            ]
    }
});
/* map from iconName to component icon */ const iconMap = new Map([
    [
        "BusinessCustomerOutlined",
        BusinessCustomerOutlined
    ],
    [
        "HeadphoneOutlined",
        HeadphoneOutlined
    ],
    [
        "TvNewOutlined",
        TvNewOutlined
    ],
    [
        "ShowroomOutlined",
        ShowroomOutlined
    ],
    [
        "BuildPcOutlined",
        BuildPcOutlined
    ],
    [
        "PromoOutlined",
        PromoOutlined
    ],
    [
        "MailOutlined",
        MailOutlined
    ],
    [
        "FacebookFilled",
        FacebookFilled
    ],
    [
        "ShopOutlined",
        ShopOutlined
    ],
    [
        "PhoneOutlined",
        PhoneOutlined
    ],
    [
        "BriefCaseOutlined",
        BriefCaseOutlined
    ], 
]);
const renderTopBarIcon = (iconData)=>{
    const { iconName  } = iconData, rest = _objectWithoutProperties(iconData, [
        "iconName"
    ]);
    const Comp = iconMap.get(iconName);
    return Comp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Comp, _objectSpread({}, rest)) : null;
};
/* render top bar button by its config */ const renderTopBarButton = (topBarButtonConfig)=>{
    const { children , key , icon , menu  } = topBarButtonConfig, rest = _objectWithoutProperties(topBarButtonConfig, [
        "children",
        "key",
        "icon",
        "menu"
    ]);
    const props = _objectSpread({}, !!icon ? {
        icon: renderTopBarIcon(icon)
    } : {}, rest);
    if (menu === null || menu === void 0 ? void 0 : menu.length) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarDropdown_es/* TopbarDropdown */.g, _objectSpreadProps(_objectSpread({
            text: children
        }, props), {
            theme: TopbarDropdown_es/* DropdownTheme.MENU */.I.MENU,
            options: menu.map((param)=>{
                let { children , href , icon  } = param;
                return {
                    text: typeof children === "string" ? children : "",
                    value: href || "#",
                    icon: icon ? (ref = renderTopBarIcon(icon)) !== null && ref !== void 0 ? ref : undefined : undefined
                };
            }),
            selectValue: (href)=>{
                if (typeof href === "string") {
                    window.location.href = href;
                }
            }
        }), key);
    }
    return /*#__PURE__*/ (0,react.createElement)(TopbarButton_es/* TopbarButton */.S, _objectSpreadProps(_objectSpread({}, props), {
        key: key
    }), children);
};

;// CONCATENATED MODULE: ./tenants/_template/desktop/_helpers/RightMenu/RightMenu.tsx
function RightMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RightMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RightMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function RightMenu_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function RightMenu_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        RightMenu_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/*
 * render the top bar menu from button configs
 * topBarButtonConfigs: array of button configs to render
 * extras: array of other components
 * */ const renderTopBarMenu = function(topBarButtonConfigs) {
    let extras = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        ...topBarButtonConfigs.map((config, index)=>{
            const data = RightMenu_objectSpreadProps(RightMenu_objectSpread({}, config), {
                key: index
            });
            return renderTopBarButton(data);
        }),
        ...extras.map((Com, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Com, {}, topBarButtonConfigs.length + index)), 
    ];
};


/***/ }),

/***/ 150923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LocationMessageType; },
/* harmony export */   "u": function() { return /* binding */ ICON_DISPLAY_PRIORITY; }
/* harmony export */ });
var LocationMessageType;
(function(LocationMessageType) {
    LocationMessageType["None"] = "0";
    LocationMessageType["Hint"] = "1";
    LocationMessageType["Error"] = "2";
})(LocationMessageType || (LocationMessageType = {}));
const ICON_DISPLAY_PRIORITY = {
    PHONE: "phone",
    ZALO: "zalo",
    MESSENGER: "messenger",
    SCROLL_TOP: "scroll-top",
    CHATBOT: "chatbot"
};


/***/ }),

/***/ 59181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ PolicyTypeId; }
/* harmony export */ });
var PolicyTypeId;
(function(PolicyTypeId) {
    PolicyTypeId[PolicyTypeId["TYPE_1"] = 1] = "TYPE_1";
    PolicyTypeId[PolicyTypeId["TYPE_2"] = 2] = "TYPE_2";
    PolicyTypeId[PolicyTypeId["TYPE_3"] = 3] = "TYPE_3";
    PolicyTypeId[PolicyTypeId["TYPE_ALL"] = -1] = "TYPE_ALL";
})(PolicyTypeId || (PolicyTypeId = {}));


/***/ }),

/***/ 198116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ sendOrderPostMessage; },
/* harmony export */   "b": function() { return /* binding */ getDataFromIframe; }
/* harmony export */ });
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(420577);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(775002);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(788813);



/**
 * Get data passed from container (staff admin) to iframe (current app)
 */ const getDataFromIframe = ()=>{
    try {
        return JSON.parse(window.name);
    } catch (e) {
        _teko_log__WEBPACK_IMPORTED_MODULE_0__/* .logger.error */ .k.error("An error occurred when getting data from Iframe", e);
        return {};
    }
};
const sendOrderPostMessage = (param)=>{
    let { orderId  } = param;
    // only send if being on client side and in an iframe
    if (!(0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isServerless */ .ep)() || !(0,_teko_utils__WEBPACK_IMPORTED_MODULE_2__.inIframe)() || !orderId) {
        return;
    }
    const existedOrderId = localStorage.getItem(SENT_POST_MESSAGE_ORDER_ID) || "";
    // only send if orderId is different than existed order Id in local storage
    if (existedOrderId === orderId) {
        return;
    }
    const message = JSON.stringify({
        status: OrderStatus.SUCCESS,
        orderId
    });
    // send the message to the parent iframe
    window.parent.postMessage(message, "*");
    // save to local storage (avoid sending multiple postMessage)
    localStorage.setItem(SENT_POST_MESSAGE_ORDER_ID, orderId);
};
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["SUCCESS"] = "ORDER_SUCCESS";
})(OrderStatus || (OrderStatus = {}));
const SENT_POST_MESSAGE_ORDER_ID = "sent-post-message-order-id";


/***/ }),

/***/ 156607:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 556418:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 799278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Api": function() { return /* reexport */ Api; },
  "ApiError": function() { return /* reexport */ ApiError; },
  "default": function() { return /* reexport */ Api; },
  "fetchWithTimeout": function() { return /* reexport */ fetchWithTimeout; },
  "normalizeSlashUrl": function() { return /* reexport */ normalizeSlashUrl; }
});

;// CONCATENATED MODULE: ../../packages/api/dist/error.es.js
class ApiError {
  constructor(message, code, response) {
    this.message = message;
    this.response = response;
    this.code = code;
  }
  get reason() {
    return this.response;
  }
  get statusCode() {
    return this.code;
  }
  get extra() {
    var _a;
    return (_a = this.response) == null ? void 0 : _a.extra;
  }
  get error() {
    var _a;
    return (_a = this.response) == null ? void 0 : _a.error;
  }
}



;// CONCATENATED MODULE: ../../packages/api/dist/helpers.es.js
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function fetchWithTimeout(input, init, timeout) {
  init = init || {};
  if (!init.body) {
    init.body = null;
  }
  if (!timeout) {
    return fetch(input, init);
  }
  const controller = new AbortController();
  const fetcher = fetch(input, __spreadProps(__spreadValues({}, init), {
    signal: controller.signal
  }));
  const cancel = new Promise((_, reject) => {
    setTimeout(() => {
      controller.abort();
      reject("Request timeout");
    }, timeout);
  });
  return Promise.race([fetcher, cancel]);
}
const normalizeSlashUrl = (baseURL = "", url) => {
  const normalizedBaseUrl = baseURL.endsWith("/") ? baseURL.slice(0, -1) : baseURL;
  const normalizedPath = url.startsWith("/") ? url.slice(1) : url;
  return `${normalizedBaseUrl}/${normalizedPath}`;
};



;// CONCATENATED MODULE: ../../packages/api/dist/api.es.js





var api_es_defProp = Object.defineProperty;
var api_es_defProps = Object.defineProperties;
var api_es_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var api_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var api_es_hasOwnProp = Object.prototype.hasOwnProperty;
var api_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var api_es_defNormalProp = (obj, key, value) => key in obj ? api_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var api_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (api_es_hasOwnProp.call(b, prop))
      api_es_defNormalProp(a, prop, b[prop]);
  if (api_es_getOwnPropSymbols)
    for (var prop of api_es_getOwnPropSymbols(b)) {
      if (api_es_propIsEnum.call(b, prop))
        api_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var api_es_spreadProps = (a, b) => api_es_defProps(a, api_es_getOwnPropDescs(b));
const DEFAULT_ERROR_MESSAGE = "\u0110\xE3 c\xF3 l\u1ED7i x\u1EA3y ra, vui l\xF2ng th\u1EED l\u1EA1i sau!";
class Api {
  constructor(url, getError, defaultConfig = {}) {
    this.baseURL = url;
    this.requestInterceptors = [];
    this.responseInterceptors = [];
    this.getError = getError;
    this.defaultConfig = defaultConfig;
  }
  _parseJson(response) {
    return response.text().then((text) => text ? JSON.parse(text) : null);
  }
  addInterceptor(interceptFn) {
    this.requestInterceptors.push(interceptFn);
  }
  addResponseInterceptor(interceptFn) {
    this.responseInterceptors.push(interceptFn);
  }
  appendParamsToURL(url, params, flattenArray = false) {
    if (params) {
      const paramsArr = [];
      for (const k of Object.keys(params)) {
        if (params[k] !== null && params[k] !== void 0) {
          const paramK = params[k];
          if (Array.isArray(paramK) && flattenArray) {
            const flattenArrayString = paramK.map((element) => `${k}=${encodeURIComponent(element)}`).join("&");
            paramsArr.push(flattenArrayString);
          } else {
            paramsArr.push(`${k}=${encodeURIComponent(params[k])}`);
          }
        }
      }
      if (paramsArr.length > 0)
        url = `${url}?${paramsArr.join("&")}`;
    }
    return url;
  }
  async request(path, body, method, config = {}, flattenArray = false) {
    var _a, _b;
    const {
      headers: configHeaders,
      params: configParams,
      timeout: configTimeout
    } = config;
    let headers = api_es_spreadValues(api_es_spreadValues({}, this.defaultConfig.headers), configHeaders);
    const url = this.appendParamsToURL(path, configParams || {}, flattenArray);
    let serializedBody = null;
    if (body) {
      if (typeof body !== "string") {
        if ("append" in body) ; else {
          serializedBody = JSON.stringify(body);
          headers = api_es_spreadValues({
            "Content-Type": "application/json"
          }, headers);
        }
      } else {
        serializedBody = body;
      }
    }
    const fetchUrl = url.startsWith("http") ? url : normalizeSlashUrl(this.baseURL, url);
    const requestObj = api_es_spreadProps(api_es_spreadValues({}, this.defaultConfig), {
      method,
      headers: new Headers(headers),
      body: serializedBody
    });
    this.requestInterceptors.forEach((fn) => fn(requestObj));
    try {
      const res = await fetchWithTimeout(fetchUrl, requestObj, configTimeout);
      const respHeaders = {};
      if (res.status >= 400) {
        try {
          const resp = await res.json();
          res.headers.forEach((val, key) => respHeaders[key] = val);
          const responseObj2 = api_es_spreadValues({
            code: res.status,
            message: res.statusText,
            data: null,
            headers: respHeaders
          }, resp);
          this.responseInterceptors.forEach((fn) => fn(api_es_spreadProps(api_es_spreadValues({}, requestObj), { url: fetchUrl }), responseObj2));
          const error = ((_a = this.getError) == null ? void 0 : _a.call(this, resp)) || new ApiError(`(${fetchUrl}) ${DEFAULT_ERROR_MESSAGE}`, res.status, responseObj2);
          return Promise.reject(error);
        } catch (e) {
          res.headers.forEach((val, key) => respHeaders[key] = val);
          const failedRes = {
            code: res.status,
            message: res.statusText,
            data: null,
            headers: respHeaders
          };
          this.responseInterceptors.forEach((fn) => fn(api_es_spreadProps(api_es_spreadValues({}, requestObj), { url: fetchUrl }), failedRes));
          const error = ((_b = this.getError) == null ? void 0 : _b.call(this, failedRes)) || new ApiError(`(${fetchUrl}) ${DEFAULT_ERROR_MESSAGE}`, res.status, failedRes);
          return Promise.reject(error);
        }
      }
      const parsedData = await this._parseJson(res);
      res.headers.forEach((val, key) => respHeaders[key] = val);
      const responseObj = {
        code: res.status,
        data: parsedData,
        headers: respHeaders
      };
      this.responseInterceptors.forEach((fn) => fn(api_es_spreadProps(api_es_spreadValues({}, requestObj), { url: fetchUrl }), responseObj));
      return responseObj;
    } catch (e) {
      throw e;
    }
  }
  async get(url, config = {}, flattenArray = false) {
    return await this.request(url, null, "GET", config, flattenArray);
  }
  async post(url, body, config = {}) {
    return await this.request(url, body, "POST", config);
  }
  async patch(url, body, config = {}) {
    return await this.request(url, body, "PATCH", config);
  }
  async put(url, body, config = {}) {
    return await this.request(url, body, "PUT", config);
  }
  async delete(url, body = null, config = {}) {
    return await this.request(url, body, "DELETE", config);
  }
}



;// CONCATENATED MODULE: ../../packages/api/dist/index.es.js






/***/ }),

/***/ 847143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EK": function() { return /* binding */ accessTokenInterceptor; },
/* harmony export */   "NM": function() { return /* binding */ handleResponseUnauthorizedInterceptor; },
/* harmony export */   "hP": function() { return /* binding */ getAccessToken; }
/* harmony export */ });
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(936303);
/* harmony import */ var _user_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(799002);



const accessTokenInterceptor = (request) => {
  if (typeof window === "undefined")
    return;
  const accessToken = _user_es_js__WEBPACK_IMPORTED_MODULE_1__/* .userManager.getAccessToken */ .Z.getAccessToken();
  if (accessToken) {
    request.headers.set("Authorization", `Bearer ${accessToken}`);
  }
};
const getAccessToken = () => _user_es_js__WEBPACK_IMPORTED_MODULE_1__/* .userManager.getAccessToken */ .Z.getAccessToken();
const handleResponseUnauthorizedInterceptor = (_request, response) => {
  const { code } = response;
  if (typeof window !== "undefined" && code === 401 && _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
    _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].auth */ .Z.auth().refreshAccessToken();
    window.alert("Phi\xEAn \u0111\u0103ng nh\u1EADp v\u1EEBa \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt. Vui l\xF2ng th\u1EF1c hi\u1EC7n l\u1EA1i thao t\xE1c");
  }
};




/***/ }),

/***/ 76500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ AuthService; }
});

// EXTERNAL MODULE: ../../packages/api/dist/index.es.js + 3 modules
var index_es = __webpack_require__(799278);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ../../.yarn/cache/teko-oauth2-npm-1.8.4-889eaf4080-03bb426ce2.zip/node_modules/teko-oauth2/dist/index.js
var dist = __webpack_require__(31069);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
;// CONCATENATED MODULE: ../../packages/auth/dist/jwt.es.js
function jwtDecode(jwtToken) {
  const chunks = jwtToken.split(".");
  return {
    header: JSON.parse(atob(chunks[0])),
    payload: JSON.parse(atob(chunks[1]))
  };
}



// EXTERNAL MODULE: ../../packages/auth/dist/user.es.js
var user_es = __webpack_require__(799002);
;// CONCATENATED MODULE: ../../packages/auth/dist/service.es.js







var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
let tekoOAuthPromise = null;
const IAM_ERRORS_MAP = {
  "1019": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c",
  "1020": "\u0110\u1ECBa ch\u1EC9 email \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 \u0111\u0103ng k\xFD m\u1ED9t t\xE0i kho\u1EA3n kh\xE1c.",
  "1021": "\u0110\u1ECBa ch\u1EC9 email kh\xE1c \u0111\xE3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho t\xE0i kho\u1EA3n n\xE0y",
  "1040": "M\xE3 OTP kh\xF4ng ch\xEDnh x\xE1c",
  "1015": "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7",
  "1800": "\u0110\xE3 g\u1EEDi qu\xE1 nhi\u1EC1u y\xEAu c\u1EA7u, vui l\xF2ng quay l\u1EA1i sau"
};
class AuthService {
  constructor(iamUrl, iamClientId, iamOauthDomain) {
    this.initialize = async (scopes) => {
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        if (!tekoOAuthPromise) {
          tekoOAuthPromise = dist/* default.init */.Z.init({
            clientId: this.iamClientId,
            scopes,
            oauthDomain: this.iamOauthDomain,
            postLogoutRedirectUri: window.location.origin
          });
        }
        return tekoOAuthPromise.then(() => {
          var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
          tekoOAuthPromise = null;
          (_d = (_c = (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.events) == null ? void 0 : _c.addSilentRenewError) == null ? void 0 : _d.call(_c, (err) => {
            var _a2;
            window.track("customEvent", "silentRenewError", {
              action: "silentRenew",
              category: "customer",
              label: JSON.stringify({
                message: err == null ? void 0 : err.message,
                stack: err == null ? void 0 : err.stack
              }),
              property: "tekoid-js"
            });
            (_a2 = this.tekoID.user) == null ? void 0 : _a2.loginSilent().catch((retryErr) => {
              dist_index_es/* logger.error */.k.error(retryErr);
            });
          });
          (_g = (_f = (_e = this.tekoID) == null ? void 0 : _e.user) == null ? void 0 : _f.events) == null ? void 0 : _g.addAccessTokenExpiring(() => {
            window.track("customEvent", "accessTokenExpiring", {
              action: "accessTokenExpiring",
              category: "customer",
              property: "tekoid-js"
            });
          });
          (_j = (_i = (_h = this.tekoID) == null ? void 0 : _h.user) == null ? void 0 : _i.events) == null ? void 0 : _j.addAccessTokenExpired(() => {
            window.track("customEvent", "accessTokenExpired", {
              action: "silentRenew",
              category: "customer",
              property: "tekoid-js"
            });
          });
        }).catch((error) => {
          dist_index_es/* logger.error */.k.error(error);
          tekoOAuthPromise = null;
        });
      } else {
        return Promise.resolve();
      }
    };
    this.requestLogin = async (challenge) => {
      try {
        const { data } = await this.authApi.get(`/v1/requests/login/${challenge}`, {});
        return data;
      } catch (er) {
        dist_index_es/* logger.error */.k.error(er);
        if (typeof window !== "undefined")
          window.location.href = "/";
      }
    };
    this.login = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.login(redirectUrl || (window.location.pathname === "/" ? void 0 : window.location.href));
    };
    this.logout = (redirectUrl) => {
      var _a, _b;
      (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.logout(redirectUrl);
      user_es/* userManager.onLoggedOut */.Z.onLoggedOut();
    };
    this.requestLogout = async (challenge) => {
      const {
        data: { redirect_to: redirectTo }
      } = await this.authApi.post(`/v1/requests/logout/${challenge}`, {
        challenge,
        confirmed: true
      });
      user_es/* userManager.onLoggedOut */.Z.onLoggedOut();
      if (redirectTo)
        window.location.assign(redirectTo);
    };
    this.loginSocialIAM = async (challenge, accessToken, authorizer) => {
      return await this.authApi.post("/v1/social/login", {
        challenge,
        access_token: accessToken,
        authorizer
      });
    };
    this.sendOTP = async (challenge, phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/passwordless/send", __spreadValues({
        challenge,
        phone_number: phone,
        client_id: this.iamClientId
      }, recaptchaToken && { recaptcha_token: recaptchaToken }));
      return data;
    };
    this.sendOTPUpdatePhone = async (phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", __spreadValues({
        phone_number: phone
      }, recaptchaToken && { recaptcha_token: recaptchaToken }));
      return data;
    };
    this.register = async ({
      phone,
      name,
      password,
      recaptchaToken
    }) => {
      const { data } = await this.authApi.post(`/v1/users/register`, __spreadProps(__spreadValues({
        username: phone,
        password: password || Math.random().toString(36).slice(-16),
        name
      }, recaptchaToken && { recaptcha_token: recaptchaToken }), {
        client_id: this.iamClientId
      }));
      return data;
    };
    this.loginIAMWithPhone = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/passwordless/login", {
        challenge,
        phone_number: phone,
        code: otp
      });
      return data;
    };
    this.activeIAMPhoneAccount = async (challenge, phone, otp) => {
      const { data } = await this.authApi.post("/v1/users/confirm", {
        challenge,
        username: phone,
        code: otp,
        client_id: this.iamClientId
      });
      return data;
    };
    this.resendOTP = async (phone, mode, challenge = "", recaptchaToken) => {
      if (mode === "login")
        return await this.sendOTP(challenge, phone, recaptchaToken);
      const { data } = await this.authApi.post("/v1/users/activation/resend", {
        username: phone,
        client_id: this.iamClientId,
        recaptcha_token: recaptchaToken
      });
      return data;
    };
    this.refreshToken = async (refreshToken) => {
      const queries = `grant_type=refresh_token&client_id=${this.iamClientId}&refresh_token=${refreshToken}`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithFederation = async (idToken, authorizer) => {
      const queries = `grant_type=federated_idp&client_id=${this.iamClientId}&jwt_token=${idToken}&authorizer=${authorizer}&scope=openid profile read:permissions us ps ppm om`;
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub
      });
      return responseData;
    };
    this.loginWithIBanking = async (data) => {
      const { partner_code } = data;
      let queries = `grant_type=ibanking&client_id=${this.iamClientId}&data=${data.data}&signature=${data.signature}&scope=openid profile read:permissions us ps ppm om`;
      if (partner_code) {
        queries = `${queries}&partner_code=${partner_code}`;
      }
      const { data: responseData } = await this.authApi.post(`${this.iamOauthDomain}/oauth/token`, queries, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      const { ibanking_info } = responseData;
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        accessToken: responseData.access_token,
        refreshToken: responseData.refresh_token,
        userId: jwtDecode(responseData.access_token).payload.sub,
        bankCode: ibanking_info == null ? void 0 : ibanking_info.bankcode,
        phone: ibanking_info == null ? void 0 : ibanking_info.mobile
      });
      return responseData;
    };
    this.loginWithTerra = (loginInfo) => {
      user_es/* userManager.onPartnerLoggedIn */.Z.onPartnerLoggedIn({
        userId: loginInfo.userId,
        name: loginInfo.name,
        accessToken: loginInfo.accessToken,
        phone: loginInfo.phone,
        picture: loginInfo.picture,
        email: loginInfo.email
      });
      return user_es/* userManager.getLSInfo */.Z.getLSInfo();
    };
    this.getLoginInfo = () => {
      return user_es/* userManager.getInfo */.Z.getInfo();
    };
    this.isLoggedIn = () => {
      return !!user_es/* userManager.getAccessToken */.Z.getAccessToken();
    };
    this.verifyPhone = async (phoneNumber) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/verify", {
        phone_number: phoneNumber
      });
      return data;
    };
    this.verifyEmail = async (email) => {
      const { data } = await this.authApi.post("/v1/me/email/verify", { email });
      return data;
    };
    this.updatePhone = async (phoneNumber, otp) => {
      const { data } = await this.authApi.post("/v1/me/phoneNumber/update", {
        phone_number: phoneNumber,
        code: otp
      });
      return data;
    };
    this.updateEmail = async (email, otp) => {
      const { data } = await this.authApi.post("/v1/me/email/update", {
        email,
        code: otp
      });
      return data;
    };
    this.errorMsg = (err) => {
      var _a;
      const errorCode = typeof err === "string" ? err : (_a = err == null ? void 0 : err.error) == null ? void 0 : _a.code;
      return IAM_ERRORS_MAP[errorCode];
    };
    this.loginWithPassword = async ({
      challenge,
      phone,
      password,
      recaptchaToken
    }) => {
      const { data } = await this.authApi.post("/v1/users/login", __spreadProps(__spreadValues({
        challenge,
        username: phone,
        password
      }, recaptchaToken && { recaptcha_token: recaptchaToken }), {
        client_id: this.iamClientId
      }));
      return data;
    };
    this.recoverPassword = async (phone, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/password/recover", {
        username: phone,
        recaptcha_token: recaptchaToken,
        client_id: this.iamClientId
      });
      return data;
    };
    this.resetPassword = async (phone, password, otp, recaptchaToken) => {
      const { data } = await this.authApi.post("/v1/password/reset", {
        username: phone,
        password,
        code: otp,
        recaptcha_token: recaptchaToken,
        client_id: this.iamClientId
      });
      return data;
    };
    this.iamUrl = iamUrl;
    this.iamClientId = iamClientId;
    this.iamOauthDomain = iamOauthDomain;
    this.authApi = new index_es["default"](iamUrl, (error) => error);
    this.authApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    this.authApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  get tekoID() {
    return window.TekoID;
  }
}




/***/ }),

/***/ 799002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ userManager; }
/* harmony export */ });
const LOCALSTORAGE_ACCESS_TOKEN = "ACCESS_TOKEN";
const LOCALSTORAGE_REFRESH_TOKEN = "REFRESH_TOKEN";
const LOCALSTORAGE_USER_PHONE = "userPhone";
const LOCALSTORAGE_USER_ID = "userId";
const LOCALSTORAGE_USER_EMAIL = "userEmail";
const LOCALSTORAGE_SITE_ID = "siteId";
const LOCALSTORAGE_SELLER_ID = "sellerId";
const LOCALSTORAGE_BANK_CODE = "bankCode";
const getLSUserInfo = () => {
  return {
    accessToken: localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN) || void 0,
    userId: localStorage.getItem(LOCALSTORAGE_USER_ID) || "",
    phone: localStorage.getItem(LOCALSTORAGE_USER_PHONE) || void 0,
    bankCode: localStorage.getItem(LOCALSTORAGE_BANK_CODE) || void 0,
    refreshToken: localStorage.getItem(LOCALSTORAGE_REFRESH_TOKEN) || void 0,
    email: localStorage.getItem(LOCALSTORAGE_USER_EMAIL) || void 0,
    siteId: localStorage.getItem(LOCALSTORAGE_SITE_ID) || void 0,
    sellerId: localStorage.getItem(LOCALSTORAGE_SELLER_ID) || void 0
  };
};
const setLSUserInfo = (user) => {
  localStorage.setItem(LOCALSTORAGE_ACCESS_TOKEN, user.accessToken || "");
  localStorage.setItem(LOCALSTORAGE_REFRESH_TOKEN, user.refreshToken || "");
  localStorage.setItem(LOCALSTORAGE_BANK_CODE, user.bankCode || "");
  localStorage.setItem(LOCALSTORAGE_USER_PHONE, user.phone || "");
  localStorage.setItem(LOCALSTORAGE_USER_ID, user.userId);
  localStorage.setItem(LOCALSTORAGE_USER_EMAIL, user.email || "");
  localStorage.setItem(LOCALSTORAGE_SITE_ID, user.siteId || "");
  localStorage.setItem(LOCALSTORAGE_SELLER_ID, user.sellerId || "");
};
class UserManager {
  get tekoID() {
    return window.TekoID;
  }
  onPartnerLoggedIn(userInfo) {
    setLSUserInfo(userInfo);
  }
  onLoggedOut() {
    [
      LOCALSTORAGE_ACCESS_TOKEN,
      LOCALSTORAGE_REFRESH_TOKEN,
      LOCALSTORAGE_BANK_CODE,
      LOCALSTORAGE_USER_PHONE,
      LOCALSTORAGE_USER_ID,
      LOCALSTORAGE_USER_EMAIL,
      LOCALSTORAGE_SITE_ID,
      LOCALSTORAGE_SELLER_ID
    ].forEach((lsKey) => localStorage.removeItem(lsKey));
  }
  getAccessToken() {
    var _a, _b, _c, _d;
    let accessToken, isLoggedIn = false;
    accessToken = (_b = (_a = this.tekoID) == null ? void 0 : _a.user) == null ? void 0 : _b.getAccessToken();
    if (!accessToken) {
      accessToken = localStorage == null ? void 0 : localStorage.getItem(LOCALSTORAGE_ACCESS_TOKEN);
      isLoggedIn = true;
    } else {
      isLoggedIn = !!((_d = (_c = this.tekoID) == null ? void 0 : _c.user) == null ? void 0 : _d.isLoggedIn());
    }
    if (accessToken && isLoggedIn)
      return accessToken;
  }
  getInfo() {
    if (this.tekoID.user) {
      const userInfo = this.tekoID.user.getUserInfo();
      return (userInfo == null ? void 0 : userInfo.sub) ? {
        userId: userInfo == null ? void 0 : userInfo.sub,
        phone: userInfo == null ? void 0 : userInfo.phone_number,
        name: userInfo == null ? void 0 : userInfo.name,
        picture: userInfo == null ? void 0 : userInfo.picture,
        email: userInfo == null ? void 0 : userInfo.email
      } : null;
    } else {
      const userInfo = getLSUserInfo();
      return (userInfo == null ? void 0 : userInfo.userId) ? {
        userId: userInfo == null ? void 0 : userInfo.userId,
        phone: userInfo == null ? void 0 : userInfo.phone,
        bankCode: userInfo == null ? void 0 : userInfo.bankCode,
        email: userInfo == null ? void 0 : userInfo.email,
        siteId: userInfo == null ? void 0 : userInfo.siteId,
        sellerId: userInfo == null ? void 0 : userInfo.sellerId
      } : null;
    }
  }
  getLSInfo() {
    return getLSUserInfo();
  }
  loadUser() {
    var _a;
    return (_a = this.tekoID.user) == null ? void 0 : _a.loadUser();
  }
  unloadUser() {
    var _a;
    return (_a = this.tekoID.user) == null ? void 0 : _a.unloadUser();
  }
}
const userManager = new UserManager();




/***/ }),

/***/ 384154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ni": function() { return /* binding */ CartService; },
  "vO": function() { return /* binding */ defaultCartValue; },
  "JW": function() { return /* binding */ parseJWT; },
  "rx": function() { return /* binding */ setCartToken; }
});

// EXTERNAL MODULE: ../../packages/api/dist/index.es.js + 3 modules
var index_es = __webpack_require__(799278);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
;// CONCATENATED MODULE: ../../packages/cart/dist/error.es.js


const getError = (resp) => {
  const message = resp.message;
  return new index_es.ApiError(message, resp.statusCode, resp);
};



;// CONCATENATED MODULE: ../../packages/cart/dist/service.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const LS_CART_TOKEN = "cart_token";
const cartTokenHeader = "x-cart-token";
const getCartToken = (localStorageKey) => localStorage.getItem(localStorageKey);
const setCartToken = (token, localStorageKey = LS_CART_TOKEN) => localStorage.setItem(localStorageKey, token);
const defaultCartValue = {
  id: "",
  grandTotal: 0,
  orderCoupons: {
    applicableCoupons: [],
    inapplicableCoupons: []
  },
  orderLines: [],
  promotions: [],
  shippingFee: 0,
  subTotal: 0,
  totalDiscount: 0,
  eVouchers: [],
  allowToRequestOnDemandDiscount: false
};
const parseJWT = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload)["cid"];
  } catch (e) {
    return null;
  }
};
class CartService {
  constructor(cartApiUrl, localStorageKey = LS_CART_TOKEN, language, options) {
    this.getCart = async (params) => {
      const cartToken = getCartToken(this.localStorageKey);
      const accessToken = (0,interceptor_es/* getAccessToken */.hP)();
      return !cartToken && !accessToken ? Promise.resolve(defaultCartValue) : this.cartApi.get("/api/v1/cart", { params: __spreadValues({}, params) }).then(({ data }) => data.result);
    };
    this.addToCart = async (params, body) => {
      const { data, headers } = await this.cartApi.post("api/v1/cart/add-to-cart", body, { params: __spreadValues({}, params) });
      const token = headers[cartTokenHeader];
      if (!!token) {
        localStorage.setItem(this.localStorageKey, token);
      }
      return __spreadProps(__spreadValues({}, data.result), { cartId: parseJWT(token) });
    };
    this.applyCoupon = async (params, body) => {
      const { data } = await this.cartApi.post("api/v1/cart/apply-coupon", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.removeCoupon = (params, body) => {
      return this.cartApi.delete("api/v1/cart/clear-coupon", body, { params: __spreadValues({}, params) });
    };
    this.clearCart = (params) => {
      return this.cartApi.delete("api/v1/cart", null, {
        params: __spreadValues({}, params)
      });
    };
    this.updateOrderLine = async (params, id, body) => {
      return this.cartApi.put(`api/v1/cart/order-lines/${id}`, body, {
        params: __spreadProps(__spreadValues({}, params), { graceful: true })
      }).then(({ data }) => Promise.resolve(data.result));
    };
    this.updateSellerItems = (params, sellerId, selected) => {
      return this.cartApi.put("api/v1/cart/order-items", { selected }, { params: __spreadProps(__spreadValues({}, params), { sellerId }) });
    };
    this.removeOrderLine = async (params, id) => {
      return (await this.cartApi.delete)(`api/v1/cart/order-lines/${id}`, null, {
        params: __spreadValues({}, params)
      });
    };
    this.setShippingAddress = (params, selectedAddress) => {
      const fullAddress = [
        selectedAddress.address,
        selectedAddress.wardName,
        selectedAddress.districtName,
        selectedAddress.provinceName
      ].filter(Boolean).join(", ");
      const infoSetShippingAddr = __spreadProps(__spreadValues({
        addressId: selectedAddress.addressId || selectedAddress.id,
        wardCode: (selectedAddress == null ? void 0 : selectedAddress.wardCode) || "",
        districtCode: selectedAddress == null ? void 0 : selectedAddress.districtCode,
        provinceCode: selectedAddress == null ? void 0 : selectedAddress.provinceCode,
        wardName: (selectedAddress == null ? void 0 : selectedAddress.wardName) || "",
        districtName: selectedAddress == null ? void 0 : selectedAddress.districtName,
        provinceName: selectedAddress == null ? void 0 : selectedAddress.provinceName,
        address: selectedAddress == null ? void 0 : selectedAddress.address,
        name: selectedAddress == null ? void 0 : selectedAddress.name
      }, (selectedAddress == null ? void 0 : selectedAddress.email) && { email: selectedAddress.email }), {
        telephone: selectedAddress == null ? void 0 : selectedAddress.telephone,
        addressNote: "",
        fullAddress: selectedAddress.fullAddress || fullAddress
      });
      return this.cartApi.post(`api/v1/cart/shipping-address`, infoSetShippingAddr, { params: __spreadValues({}, params) });
    };
    this.getPaymentMethod = async (params, orderCode) => {
      const { data } = await this.cartApi.get("api/v1/cart/payment-methods-v2", {
        params: __spreadValues(__spreadValues({}, params), orderCode ? { orderCode } : {})
      });
      return data.result;
    };
    this.checkout = async (params, body) => {
      var _a, _b, _c, _d;
      const { data } = await this.cartApi.post("api/v1/cart/checkout", body, {
        params: __spreadValues({}, params)
      });
      return __spreadProps(__spreadValues({}, data.result), {
        orderId: ((_a = data.result) == null ? void 0 : _a.orderIdString) || ((_b = data.result) == null ? void 0 : _b.orderId),
        id: ((_c = data.result) == null ? void 0 : _c.orderIdString) || ((_d = data.result) == null ? void 0 : _d.orderId),
        get remainPayment() {
          return parseFloat(data.result.grandTotal.toString()) - data.result.totalPaid;
        }
      });
    };
    this.getOrderByCode = async (params, code) => {
      const { data } = await this.cartApi.get(`/api/v1/orders/${code}`, {
        params: __spreadValues({}, params)
      });
      const order = data.result;
      return __spreadProps(__spreadValues({}, order), {
        orderId: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        id: (order == null ? void 0 : order.idString) || (order == null ? void 0 : order.id),
        grandTotal: parseInt(order.grandTotal),
        get remainPayment() {
          var _a;
          const prevPayment = ((_a = order == null ? void 0 : order.payments) == null ? void 0 : _a.reduce((amount, currentPayment) => amount + currentPayment.amount, 0)) || 0;
          return parseFloat(order.grandTotal.toString()) - prevPayment;
        }
      });
    };
    this.getApplicableServices = async (params) => {
      const { data } = await this.cartApi.get("api/v1/cart/applicable-services", {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.findApplicableServices = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/applicable-services", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.getDeliveryOptions = async (params, body) => {
      const { data } = await this.cartApi.post("/api/v1/cart/delivery-options", body, {
        params: __spreadValues({}, params)
      });
      return data.result;
    };
    this.applyServiceToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-service", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.applyPaymentMethodToCart = async (params, body) => {
      const { data } = await this.cartApi.put("/api/v1/cart/apply-payment-method", body, { params: __spreadValues({}, params) });
      return data.result;
    };
    this.importOrder = async (payload, query) => {
      const { data } = await this.cartApi.post("/api/v1/orders", payload, {
        params: __spreadValues({}, query)
      });
      return data.result;
    };
    this.cartApi = new index_es["default"](cartApiUrl, getError);
    this.localStorageKey = localStorageKey;
    if (typeof (options == null ? void 0 : options.getCustomAccessToken) === "function") {
      this.cartApi.addInterceptor((request) => {
        var _a;
        request.headers.set("Authorization", `Bearer ${(_a = options.getCustomAccessToken) == null ? void 0 : _a.call(options)}`);
      });
    } else {
      this.cartApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.cartApi.addInterceptor((request) => {
      var _a;
      if (typeof window === "undefined" && !(options == null ? void 0 : options.isSyncCartOffline))
        return;
      if (options == null ? void 0 : options.cartToken) {
        request.headers.set(cartTokenHeader, options == null ? void 0 : options.cartToken);
      } else {
        const cartToken = ((_a = this.getCartToken) != null ? _a : getCartToken)(localStorageKey);
        if (cartToken) {
          request.headers.set(cartTokenHeader, cartToken);
        }
      }
    });
    this.cartApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    this.cartApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
  setParams({ getCartToken: getCartToken2 }) {
    this.getCartToken = getCartToken2;
  }
}




/***/ }),

/***/ 891004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RN": function() { return /* binding */ CartDeliveryType; },
/* harmony export */   "VM": function() { return /* binding */ PromotionGroupType; },
/* harmony export */   "b2": function() { return /* binding */ RequiredInfoToCheckout; },
/* harmony export */   "bQ": function() { return /* binding */ DeliveryTimeSlotType; },
/* harmony export */   "cv": function() { return /* binding */ UserActionType; },
/* harmony export */   "dK": function() { return /* binding */ CheckoutAllowedUserActions; },
/* harmony export */   "rV": function() { return /* binding */ AllowedUserActionItem; }
/* harmony export */ });
/* unused harmony export CustomerType */
var AllowedUserActionItem = /* @__PURE__ */ ((AllowedUserActionItem2) => {
  AllowedUserActionItem2["TOGGLE"] = "TOGGLE";
  AllowedUserActionItem2["DELETE"] = "DELETE";
  AllowedUserActionItem2["CHANGE_QUANTITY"] = "CHANGE_QUANTITY";
  AllowedUserActionItem2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  AllowedUserActionItem2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  AllowedUserActionItem2["OPEN_PRODUCT_DETAIL"] = "OPEN_PRODUCT_DETAIL";
  AllowedUserActionItem2["ADD_NOTE"] = "ADD_NOTE";
  return AllowedUserActionItem2;
})(AllowedUserActionItem || {});
var UserActionType = /* @__PURE__ */ ((UserActionType2) => {
  UserActionType2["REQUEST_ON_DEMAND_DISCOUNT"] = "REQUEST_ON_DEMAND_DISCOUNT";
  UserActionType2["REQUEST_CONSULTATION_FEE"] = "REQUEST_CONSULTATION_FEE";
  UserActionType2["USE_DEFERRED_PAYMENT"] = "USE_DEFERRED_PAYMENT";
  UserActionType2["USE_DEPOSIT"] = "USE_DEPOSIT";
  UserActionType2["ADD_CONSULTANT"] = "ADD_CONSULTANT";
  UserActionType2["REQUEST_NEW_SKU"] = "REQUEST_NEW_SKU";
  UserActionType2["CREATE_QUOTATION"] = "CREATE_QUOTATION";
  return UserActionType2;
})(UserActionType || {});
var CartDeliveryType = /* @__PURE__ */ ((CartDeliveryType2) => {
  CartDeliveryType2["DELIVERY_TYPE_UNSPECIFIED"] = "DELIVERY_TYPE_UNSPECIFIED";
  CartDeliveryType2["DELIVERY_TYPE_AT_HOME"] = "DELIVERY_TYPE_AT_HOME";
  CartDeliveryType2["DELIVERY_TYPE_PICKUP"] = "DELIVERY_TYPE_PICKUP";
  CartDeliveryType2["DELIVERY_TYPE_HANDOVER"] = "DELIVERY_TYPE_HANDOVER";
  return CartDeliveryType2;
})(CartDeliveryType || {});
var CheckoutAllowedUserActions = /* @__PURE__ */ ((CheckoutAllowedUserActions2) => {
  CheckoutAllowedUserActions2["PAYMENT"] = "PAYMENT";
  CheckoutAllowedUserActions2["FINISH"] = "FINISH";
  CheckoutAllowedUserActions2["ORDER_LIST"] = "ORDER_LIST";
  CheckoutAllowedUserActions2["QUOTATION_POPUP"] = "QUOTATION_POPUP";
  return CheckoutAllowedUserActions2;
})(CheckoutAllowedUserActions || {});
var DeliveryTimeSlotType = /* @__PURE__ */ ((DeliveryTimeSlotType2) => {
  DeliveryTimeSlotType2["REQUIRED"] = "REQUIRED";
  DeliveryTimeSlotType2["OPTIONAL"] = "OPTIONAL";
  DeliveryTimeSlotType2["NONE"] = "NONE";
  return DeliveryTimeSlotType2;
})(DeliveryTimeSlotType || {});
var CustomerType = /* @__PURE__ */ ((CustomerType2) => {
  CustomerType2["INDIVIDUAL"] = "INDIVIDUAL";
  CustomerType2["FOREIGN"] = "FOREIGN";
  CustomerType2["BUSINESS"] = "BUSINESS";
  CustomerType2["STATE_BUDGET_UNIT"] = "STATE_BUDGET_UNIT";
  return CustomerType2;
})(CustomerType || {});
var PromotionGroupType = /* @__PURE__ */ ((PromotionGroupType2) => {
  PromotionGroupType2["GROUP_TYPE_DEFAULT"] = "GROUP_TYPE_DEFAULT";
  PromotionGroupType2["GROUP_TYPE_SELECTABLE"] = "GROUP_TYPE_SELECTABLE";
  PromotionGroupType2["GROUP_TYPE_EXCLUSIVE"] = "GROUP_TYPE_EXCLUSIVE";
  PromotionGroupType2["GROUP_TYPE_TIER_PROMOTIONS"] = "GROUP_TYPE_TIER_PROMOTIONS";
  return PromotionGroupType2;
})(PromotionGroupType || {});
var RequiredInfoToCheckout = /* @__PURE__ */ ((RequiredInfoToCheckout2) => {
  RequiredInfoToCheckout2["DELIVERY_EMAIL"] = "DELIVERY_EMAIL";
  RequiredInfoToCheckout2["DELIVERY_PHONE"] = "DELIVERY_PHONE";
  return RequiredInfoToCheckout2;
})(RequiredInfoToCheckout || {});




/***/ }),

/***/ 916476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B2": function() { return /* binding */ getBuyNowKey; },
/* harmony export */   "Bs": function() { return /* binding */ setCartInfoToLocalStorage; },
/* harmony export */   "GN": function() { return /* binding */ storeCartTokenHamper; },
/* harmony export */   "UH": function() { return /* binding */ defaultCart; },
/* harmony export */   "Ut": function() { return /* binding */ removeOldBuyNowCart; },
/* harmony export */   "XN": function() { return /* binding */ BUY_NOW_CARTS_KEY; },
/* harmony export */   "e5": function() { return /* binding */ storeBuyNowCartKey; },
/* harmony export */   "i": function() { return /* binding */ getCartToken; },
/* harmony export */   "ng": function() { return /* binding */ removeCartToken; },
/* harmony export */   "oG": function() { return /* binding */ IsolatedCartType; },
/* harmony export */   "rx": function() { return /* binding */ setCartToken; },
/* harmony export */   "xz": function() { return /* binding */ BUY_NOW_CART_EXPIRED_ERROR_CODE; }
/* harmony export */ });
/* unused harmony exports BUY_NOW_CART_KEY_LENGTH, BUY_NOW_ISOLATED_CART_TYPE */
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(175915);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const cartTokenLSKey = "cart_token";
const BUY_NOW_ISOLATED_CART_TYPE = "buy_now";
var IsolatedCartType = /* @__PURE__ */ ((IsolatedCartType2) => {
  IsolatedCartType2["BUY_NOW"] = "buy_now";
  IsolatedCartType2["INSTALLMENT"] = "installment_vnpay";
  return IsolatedCartType2;
})(IsolatedCartType || {});
const BUY_NOW_CARTS_KEY = "buy-now-carts";
const BUY_NOW_CART_KEY_LENGTH = 6;
const BUY_NOW_CART_EXPIRED_ERROR_CODE = 404101;
const getCartToken = () => {
  return localStorage.getItem(cartTokenLSKey);
};
const setCartToken = (value) => {
  localStorage.setItem(cartTokenLSKey, value);
};
const removeCartToken = () => localStorage.removeItem(cartTokenLSKey);
const defaultCart = {
  id: "",
  items: [],
  priceSummary: [
    {
      name: "T\u1ED5ng ti\u1EC1n",
      value: "0\u0111"
    },
    {
      name: "Th\xE0nh ti\u1EC1n",
      value: "0\u0111"
    }
  ],
  grandTotalAmount: 0,
  paidAmount: 0,
  remainingAmount: 0,
  onDemandDiscount: 0,
  allowedUserActions: [],
  promotions: [],
  paymentMethods: [],
  orderTerminalCode: ""
};
const generateRandomString = (length) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
let lastBuyNowKey = "";
const getBuyNowKey = (isReuse) => {
  if (isReuse) {
    return lastBuyNowKey;
  }
  const newBuyNowKey = generateRandomString(BUY_NOW_CART_KEY_LENGTH);
  lastBuyNowKey = newBuyNowKey;
  return newBuyNowKey;
};
const storeBuyNowCartKey = (newBuyNowCart) => {
  if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__["default"].isAvailable())
    return;
  const buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts.push(newBuyNowCart);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};
const removeOldBuyNowCart = () => {
  if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__["default"].isAvailable())
    return;
  const hamperData = JSON.parse(localStorage.getItem("buildHamper") || "{}");
  const oldCartToken = hamperData.cartToken;
  if (!oldCartToken)
    return;
  let buyNowCarts = JSON.parse(localStorage.getItem(BUY_NOW_CARTS_KEY) || "[]");
  buyNowCarts = buyNowCarts.filter((item) => item.cartToken !== oldCartToken);
  localStorage.setItem(BUY_NOW_CARTS_KEY, JSON.stringify(buyNowCarts));
};
const storeCartTokenHamper = (cartToken) => {
  const hamperLocalStorageKey = _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__["default"].isAvailable() ? "buildHamperApp" : "buildHamper";
  let hamperData = JSON.parse(localStorage.getItem(hamperLocalStorageKey) || "{}");
  hamperData = __spreadProps(__spreadValues({}, hamperData), { cartToken });
  localStorage.setItem(hamperLocalStorageKey, JSON.stringify(hamperData));
};
const setCartInfoToLocalStorage = (cartId, data) => {
  const { newCartToken, oldCartToken, terminalId, cartDiffDetails } = data;
  localStorage.setItem(`cart.${cartId}`, JSON.stringify(__spreadValues(__spreadValues({
    token: newCartToken,
    referencedToken: oldCartToken
  }, terminalId && { terminalId }), cartDiffDetails && { cartDiffDetails })));
};




/***/ }),

/***/ 693497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TV": function() { return /* reexport */ AreaLayer; },
  "aU": function() { return /* reexport */ LocationService; }
});

// UNUSED EXPORTS: LocalGovernmentModel

// EXTERNAL MODULE: ../../packages/api/dist/index.es.js + 3 modules
var index_es = __webpack_require__(799278);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
;// CONCATENATED MODULE: ../../packages/location/dist/service.es.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class LocationService {
  constructor(locationApiUrl, defaultConfig, getCustomAccessToken, countryCode) {
    this.getProvinces = async () => {
      return this.locationApi.get(`/location/provinces${!!this.country ? `?country=${this.country}` : ""}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.provinces);
      });
    };
    this.getDistrictsByProvinceCode = async (provinceCode) => {
      return this.locationApi.get(`/location/districts?provinceCode=${provinceCode}${!!this.country ? `&country=${this.country}` : ""}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.districts);
      });
    };
    this.getWardsByDistrictCode = async (districtCode) => {
      return this.locationApi.get(`/location/wards?districtCode=${districtCode}${!!this.country ? `&country=${this.country}` : ""}`).then(({ data }) => {
        var _a;
        return Promise.resolve((_a = data.result) == null ? void 0 : _a.wards);
      });
    };
    this.getAddressSuggestions = async (params) => {
      return this.locationApi.get("/location/addresses/suggest", { params }).then((res) => {
        var _a, _b;
        return ((_b = (_a = res.data) == null ? void 0 : _a.data) == null ? void 0 : _b.addresses) || [];
      });
    };
    this.getPlaceDetails = async (params) => {
      return this.locationApi.get("/location/place-detail", { params }).then((res) => {
        var _a, _b;
        return ((_b = (_a = res.data) == null ? void 0 : _a.data) == null ? void 0 : _b.places) || [];
      });
    };
    this.getAreas = async (params) => {
      var _a;
      const { data } = await this.locationApi.get("/location/areas", {
        params: __spreadValues({}, params)
      });
      return (_a = data.data) == null ? void 0 : _a.areas;
    };
    this.getAreasV2 = async (params, country) => {
      var _a;
      const { data } = await this.locationApi.get(`/location/areas${!!country ? `?country=${country}` : ""}`, {
        params: __spreadValues({}, params)
      });
      return (_a = data.data) == null ? void 0 : _a.areas;
    };
    this.getDistanceMatrix = async (origins, destinations) => {
      const { data } = await this.locationApi.post("/location/distance-matrix", {
        origins,
        destinations
      });
      return data;
    };
    this.locationApi = new index_es["default"](locationApiUrl, void 0, defaultConfig);
    this.country = countryCode;
    if (typeof getCustomAccessToken === "function") {
      this.locationApi.addInterceptor((request) => {
        request.headers.set("Authorization", `Bearer ${getCustomAccessToken()}`);
      });
    } else {
      this.locationApi.addInterceptor(interceptor_es/* accessTokenInterceptor */.EK);
    }
    this.locationApi.addResponseInterceptor(interceptor_es/* handleResponseUnauthorizedInterceptor */.NM);
  }
}



;// CONCATENATED MODULE: ../../packages/location/dist/types.es.js
var AreaLayer = /* @__PURE__ */ ((AreaLayer2) => {
  AreaLayer2["province"] = "province";
  AreaLayer2["ward"] = "ward";
  return AreaLayer2;
})(AreaLayer || {});
var LocalGovernmentModel = /* @__PURE__ */ ((LocalGovernmentModel2) => {
  LocalGovernmentModel2["THREE_LEVEL"] = "three_level";
  LocalGovernmentModel2["TWO_LEVEL"] = "two_level";
  return LocalGovernmentModel2;
})(LocalGovernmentModel || {});



;// CONCATENATED MODULE: ../../packages/location/dist/index.es.js




/***/ }),

/***/ 420577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ logger; }
});

// EXTERNAL MODULE: ../../.yarn/cache/pino-npm-6.13.3-50e2aceb53-a580decd47.zip/node_modules/pino/browser.js
var browser = __webpack_require__(43238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ../../packages/log/dist/logger.es.js
/* provided dependency */ var process = __webpack_require__(960387);


const logger = browser_default()({
  prettyPrint: "production" === "development",
  level: process.env.LOG_LEVEL || "info",
  serializers: {
    err: (browser_default()).stdSerializers.err,
    req: (browser_default()).stdSerializers.req
  },
  browser: {
    transmit: {
      level: "error",
      send: (_level, logEvent) => {
        if (typeof window !== "undefined" && window.track) {
          let eventDetails = null;
          for (const message of logEvent.messages) {
            if (message.msg && message.stack) {
              eventDetails = {
                message: message.msg,
                stack: message.stack
              };
            }
          }
          eventDetails = eventDetails || {
            message: JSON.stringify(logEvent.messages),
            stack: JSON.stringify(logEvent.bindings)
          };
          window.track("exception", eventDetails);
        }
      }
    }
  }
});



;// CONCATENATED MODULE: ../../packages/log/dist/index.es.js



/***/ }),

/***/ 771633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bb": function() { return /* binding */ UNS_APP_ID; },
/* harmony export */   "n8": function() { return /* binding */ FCM_TRANSPORT; },
/* harmony export */   "pX": function() { return /* binding */ FCM_REGISTER_TOKEN_SUCCESS; },
/* harmony export */   "tO": function() { return /* binding */ TRACKING_ID_KEY; },
/* harmony export */   "tz": function() { return /* binding */ FCM_USER_ID; },
/* harmony export */   "ut": function() { return /* binding */ FCM_TOKEN; }
/* harmony export */ });
const FCM_TOKEN = "fcmToken";
const FCM_USER_ID = "fcmUserId";
const FCM_TRANSPORT = "fcm";
const FCM_REGISTER_TOKEN_SUCCESS = "fcmRegisterTokenSuccess";
const UNS_APP_ID = "fcmUNSAppId";
const TRACKING_ID_KEY = "_track__track";




/***/ }),

/***/ 93512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ slug; }
/* harmony export */ });
const vnRegexes = [
  /à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g,
  /è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g,
  /ì|í|ị|ỉ|ĩ|Ì|Í|Ị|Ỉ|Ĩ/g,
  /ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g,
  /ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g,
  /ỳ|ý|ỵ|ỷ|ỹ|Ỳ|Ý|Ỵ|Ỷ|Ỹ/g,
  /đ|Đ/g,
  /\u0300|\u0301|\u0303|\u0309|\u0323/g,
  /\u02C6|\u0306|\u031B/g,
  /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g
];
const replacement = ["a", "e", "i", "o", "u", "y", "d", "", "", " "];
const slug = (str) => {
  vnRegexes.forEach((value, index) => {
    str = str.replace(value, replacement[index]);
  });
  str = str.toLowerCase().trim();
  return str.replace(/\s+/g, "-");
};




/***/ }),

/***/ 683383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V3": function() { return /* binding */ requestDurationTrackingInterceptor; },
/* harmony export */   "iB": function() { return /* binding */ trackResponseTimeWithStartAt; },
/* harmony export */   "j3": function() { return /* binding */ trackResponseTimeAsync; },
/* harmony export */   "sb": function() { return /* binding */ responseDurationTrackingInterceptor; }
/* harmony export */ });
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(428247);


var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const API_RESPONSE_TIME_BUCKETS = [
  {
    value: 200,
    label: "0 - 200"
  },
  {
    value: 500,
    label: "200 - 500"
  },
  {
    value: 800,
    label: "500 - 800"
  },
  {
    value: 1e3,
    label: "800 - 1000"
  },
  {
    value: 1500,
    label: "1000 - 1500"
  },
  {
    value: 2e3,
    label: "1500 - 2000"
  },
  {
    value: 3e3,
    label: "2000 - 3000"
  },
  {
    value: 4e3,
    label: "3000 - 4000"
  },
  {
    value: 5e3,
    label: "4000 - 5000"
  },
  {
    value: 8e3,
    label: "5000 - 8000"
  },
  {
    value: 1e4,
    label: "8000 - 10000"
  },
  {
    value: 11e3,
    label: "> 10000"
  }
];
const getBucket = (responseTime) => {
  let low = 0;
  let high = API_RESPONSE_TIME_BUCKETS.length - 1;
  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    if (responseTime <= API_RESPONSE_TIME_BUCKETS[mid].value) {
      high = mid;
    } else {
      low = mid + 1;
    }
  }
  return API_RESPONSE_TIME_BUCKETS[low].label;
};
const trackResponseTimeAsync = (contentName, duration, property) => {
  setTimeout(() => {
    (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackCustomEvent */ .I)(contentName, {
      action: "apiCallTime",
      category: "teko-web",
      label: getBucket(duration),
      value: duration,
      property: property ? typeof property === "string" ? property : JSON.stringify(property) : void 0
    });
  }, 0);
};
const trackInvalidResponseTimeAsync = (contentName, property) => {
  setTimeout(() => {
    (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackCustomEvent */ .I)(contentName, {
      action: "invalid-apiCallTime",
      category: "teko-web",
      property: property ? typeof property === "string" ? property : JSON.stringify(property) : void 0
    });
  }, 0);
};
const trackResponseTimeWithStartAt = (url, startAt, property) => {
  const contentName = String(url) || "undefined_url";
  const startAtNum = Number(startAt);
  if (!!startAt && !isNaN(startAtNum)) {
    const duration = Math.round(performance.now()) - startAtNum;
    trackResponseTimeAsync(contentName, duration, property);
  } else {
    trackInvalidResponseTimeAsync(contentName, property);
  }
};
const requestDurationTrackingInterceptor = (request) => {
  request.headers.set("meta_data", JSON.stringify({
    start_at: Math.round(performance.now())
  }));
};
const responseDurationTrackingInterceptor = (request, response) => {
  var _a;
  const { code, data } = response;
  const { body, method, params, url, headers: requestHeaders } = request;
  const headers = Object.fromEntries(new Headers(requestHeaders).entries());
  const traceId = data.traceId || "not_available";
  const message = data.message;
  const startAt = !!(headers == null ? void 0 : headers.meta_data) ? JSON.parse(headers.meta_data).start_at : void 0;
  const dataTracking = {
    headers: __spreadProps(__spreadValues({}, headers), {
      authorization: !!((_a = headers == null ? void 0 : headers.authorization) == null ? void 0 : _a.length) ? "token" : ""
    }),
    body,
    params,
    method,
    traceId,
    message,
    code,
    isFulfilled: !(code >= 400)
  };
  trackResponseTimeWithStartAt(url, startAt, dataTracking);
};




/***/ }),

/***/ 446586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "TT": function() { return /* binding */ trackPVFormAddToCart; },
/* harmony export */   "_g": function() { return /* binding */ trackChangeQuantityProduct; },
/* harmony export */   "bz": function() { return /* binding */ trackSelectProduct; },
/* harmony export */   "gu": function() { return /* binding */ trackManually; },
/* harmony export */   "ih": function() { return /* binding */ trackDecreaseQuantityProduct; },
/* harmony export */   "lM": function() { return /* binding */ trackIncreaseQuantityProduct; },
/* harmony export */   "wr": function() { return /* binding */ trackAddToCartManually; }
/* harmony export */ });
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(428247);
/* harmony import */ var _interface_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(141873);
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(437618);




const trackAddToCart = (trackAddToCartParams, isIdleCallback = false) => {
  const {
    product,
    selectedPromotionId,
    status,
    cartId,
    type = _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART
  } = trackAddToCartParams;
  const { defaultPromotions = [] } = product;
  const trackingData = {
    cartId,
    skuId: product.sku,
    skuName: product.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: product.price,
    promotionPrice: product.addToCartPrice
  };
  const track = () => {
    var _a, _b;
    if (type === _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART) {
      window.track(_interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART, trackingData);
    } else {
      (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_1__/* .trackCustomEvent */ .I)(_interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.BUYNOW */ .h.BUYNOW, {
        action: "click",
        category: "cart",
        label: JSON.stringify(trackingData),
        property: "product"
      });
    }
    (_a = window.dataLayer) == null ? void 0 : _a.push({
      event: type,
      ecommerce: {
        currencyCode: "VND",
        add: {
          products: [
            {
              name: product.name,
              id: product.sku,
              price: product.addToCartPrice,
              quantity: 1,
              category: product.categories,
              brand: product.brand,
              sellerSku: product.sellerSku
            }
          ]
        }
      }
    });
    if (!!window.fbq && status === "success" && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
      (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_2__/* .trackMetaPixelAddToCart */ .Ug)({
        content_ids: [product.sku],
        content_name: product.name,
        content_type: "product",
        contents: [{ id: product.sku, quantity: 1 }],
        currency: "VND",
        value: product.price
      });
    }
  };
  if (isIdleCallback) {
    requestIdleCallback(() => {
      track();
    });
  } else {
    track();
  }
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a, _b, _c, _d, _e;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price,
    comboPromotion: (_d = (_c = (_b = (_a = item.promotions) == null ? void 0 : _a[0]) == null ? void 0 : _b.promotions) == null ? void 0 : _c[0]) == null ? void 0 : _d.promotionId
  });
  (_e = window.dataLayer) == null ? void 0 : _e.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: "",
            sellerSku: item.displaySku
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a, _b, _c, _d;
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price,
    comboPromotion: (_d = (_c = (_b = (_a = item.promotions) == null ? void 0 : _a[0]) == null ? void 0 : _b.promotions) == null ? void 0 : _c[0]) == null ? void 0 : _d.promotionId
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a, _b, _c;
  window.track("removeFromCart", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.sellPrice,
    promotionPrice: item.price,
    promotionId: `${(_a = item.promotions) == null ? void 0 : _a.map((promo) => promo.promotions.map((promo2) => promo2.promotionId).join(",")).join(",")}`,
    promotionsCode: `${(_b = item.promotions) == null ? void 0 : _b.map((promo) => promo.promotions.map((promo2) => promo2.promotionCode).join(",")).join(",")}`
  });
  (_c = window.dataLayer) == null ? void 0 : _c.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: "",
            sellerSku: item.displaySku
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload, index) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload,
    index
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.displaySku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};
const trackPVFormAddToCart = (value, emailSha256, phoneSha256) => {
  var _a;
  const data = {
    event: "pv_formaddtocart",
    currency: "VND",
    value
  };
  if (!!emailSha256) {
    data.sha256_email = emailSha256;
  }
  if (!!phoneSha256) {
    data.sha256_phone_number = phoneSha256;
  }
  (_a = window.dataLayer) == null ? void 0 : _a.push(data);
};




/***/ }),

/***/ 428247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ trackCustomEvent; },
/* harmony export */   "O5": function() { return /* binding */ getTrackingData; },
/* harmony export */   "UC": function() { return /* binding */ trackVisibleManually; },
/* harmony export */   "bo": function() { return /* binding */ trackLinkClicked; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getTrackingData = ({
  isTrackContent,
  contentName,
  index,
  regionName,
  target,
  payload,
  ignoreinteraction
}) => {
  return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, regionName && { "data-content-region-name": regionName }), isTrackContent && { "data-track-content": true }), contentName && { "data-content-name": contentName }), (index || index === 0) && { "data-content-index": index }), target && { "data-content-target": target }), payload && { "data-content-payload": payload }), ignoreinteraction && { "data-content-ignoreinteraction": true });
};
const trackCustomEvent = (eventName, payload) => {
  return window.track("customEvent", eventName, payload);
};
const trackLinkClicked = (eventName, payload) => {
  return window.track("linkClick", eventName, payload);
};
const trackVisibleManually = ({
  regionName,
  contentName,
  index,
  payload
}) => {
  return window.track("manualTrackVisibleContentImpressions", {
    regionName,
    contentName,
    payload,
    index
  });
};




/***/ }),

/***/ 141873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AddToCartType; }
/* harmony export */ });
var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buy_now";
  AddToCartType2["INSTALLMENT"] = "installment";
  return AddToCartType2;
})(AddToCartType || {});




/***/ }),

/***/ 437618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ trackMetaPixelPurchase; },
/* harmony export */   "SI": function() { return /* binding */ trackMetaPixelViewContent; },
/* harmony export */   "Ug": function() { return /* binding */ trackMetaPixelAddToCart; },
/* harmony export */   "tO": function() { return /* binding */ trackMetaPixelCheckout; }
/* harmony export */ });
const trackStandardEvent = (eventName, payload) => {
  var _a;
  (_a = window.fbq) == null ? void 0 : _a.call(window, "track", eventName, payload);
};
const trackMetaPixelAddToCart = (payload) => {
  return trackStandardEvent("AddToCart" /* ADD_TO_CART */, payload);
};
const trackMetaPixelCheckout = (payload) => {
  return trackStandardEvent("InitiateCheckout" /* INITIATE_CHECKOUT */, payload);
};
const trackMetaPixelPurchase = (payload) => {
  return trackStandardEvent("Purchase" /* PURCHASE */, payload);
};
const trackMetaPixelViewContent = (payload) => {
  return trackStandardEvent("ViewContent" /* VIEW_CONTENT */, payload);
};




/***/ }),

/***/ 77322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ trackViewProductDetail; },
/* harmony export */   "u": function() { return /* binding */ trackViewProductList; }
/* harmony export */ });
/* harmony import */ var _meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(437618);


const trackViewProductDetail = (product) => {
  var _a, _b;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewDetail",
    ecommerce: {
      detail: {
        products: [product]
      }
    }
  });
  if (!!window.fbq && !!((_b = window.env) == null ? void 0 : _b.FB_PIXEL_ID)) {
    const value = typeof product.price === "number" ? product.price : parseFloat(product.price) || 0;
    (0,_meta_pixel_es_js__WEBPACK_IMPORTED_MODULE_0__/* .trackMetaPixelViewContent */ .SI)({
      content_ids: [product.sku],
      content_category: product.category || "",
      content_name: product.name || "",
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value
    });
  }
};
const trackViewProductList = (products) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewListing",
    ecommerce: {
      impressions: products
    }
  });
};




/***/ }),

/***/ 285212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vz": function() { return /* reexport */ ButtonShapeEnum; },
  "mO": function() { return /* reexport */ SizeEnum; }
});

// UNUSED EXPORTS: LinkType

;// CONCATENATED MODULE: ../../packages/types/dist/ds/button.es.js
var ButtonShapeEnum = /* @__PURE__ */ ((ButtonShapeEnum2) => {
  ButtonShapeEnum2["circle"] = "circle";
  ButtonShapeEnum2["round"] = "round";
  return ButtonShapeEnum2;
})(ButtonShapeEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/ds/link.es.js
var LinkType = /* @__PURE__ */ ((LinkType2) => {
  LinkType2["inPage"] = "inPage";
  LinkType2["external"] = "external";
  LinkType2["email"] = "email";
  LinkType2["phone"] = "phone";
  LinkType2["internal"] = "internal";
  return LinkType2;
})(LinkType || {});



;// CONCATENATED MODULE: ../../packages/types/dist/ds/common.es.js
var SizeEnum = /* @__PURE__ */ ((SizeEnum2) => {
  SizeEnum2["xs"] = "xs";
  SizeEnum2["s"] = "s";
  SizeEnum2["m"] = "m";
  SizeEnum2["l"] = "l";
  SizeEnum2["xl"] = "xl";
  return SizeEnum2;
})(SizeEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/ds/index.es.js





/***/ }),

/***/ 184019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v2": function() { return /* reexport */ Alignment; },
  "hT": function() { return /* reexport */ DSSize; },
  "fd": function() { return /* reexport */ DividerStyleEnum; }
});

// UNUSED EXPORTS: DividerTypeEnum, Variant, VerticalAlignment

;// CONCATENATED MODULE: ../../packages/types/dist/shared/enum.es.js
var Variant = /* @__PURE__ */ ((Variant2) => {
  Variant2["primary"] = "primary";
  Variant2["secondary"] = "secondary";
  Variant2["ghost"] = "ghost";
  Variant2["link"] = "link";
  return Variant2;
})(Variant || {});
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["left"] = "left";
  Alignment2["center"] = "center";
  Alignment2["right"] = "right";
  Alignment2["justify"] = "justify";
  return Alignment2;
})(Alignment || {});
var VerticalAlignment = /* @__PURE__ */ ((VerticalAlignment2) => {
  VerticalAlignment2["top"] = "top";
  VerticalAlignment2["center"] = "center";
  VerticalAlignment2["bottom"] = "bottom";
  return VerticalAlignment2;
})(VerticalAlignment || {});
var DSSize = /* @__PURE__ */ ((DSSize2) => {
  DSSize2["small"] = "small";
  DSSize2["medium"] = "medium";
  DSSize2["default"] = "default";
  DSSize2["large"] = "large";
  return DSSize2;
})(DSSize || {});
var DividerTypeEnum = /* @__PURE__ */ ((DividerTypeEnum2) => {
  DividerTypeEnum2["text"] = "text";
  DividerTypeEnum2["icon"] = "icon";
  return DividerTypeEnum2;
})(DividerTypeEnum || {});
var DividerStyleEnum = /* @__PURE__ */ ((DividerStyleEnum2) => {
  DividerStyleEnum2["solid"] = "solid";
  DividerStyleEnum2["double"] = "double";
  DividerStyleEnum2["dotted"] = "dotted";
  DividerStyleEnum2["dashed"] = "dashed";
  return DividerStyleEnum2;
})(DividerStyleEnum || {});



;// CONCATENATED MODULE: ../../packages/types/dist/shared/index.es.js



/***/ }),

/***/ 889104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(883667);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380175);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(531537);



function formatDate(date, locale, fmt) {
  if (!date) {
    date = Date.now();
  }
  return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(!(date instanceof Date) ? new Date(date) : date, fmt || "HH:mm, EEEE dd/MM/yyyy", {
    locale: locale === "en" ? date_fns_locale__WEBPACK_IMPORTED_MODULE_1__["default"] : date_fns_locale__WEBPACK_IMPORTED_MODULE_2__["default"]
  });
}




/***/ }),

/***/ 531439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ htmlEncode; },
/* harmony export */   "l": function() { return /* binding */ htmlDecode; }
/* harmony export */ });
const htmlEncode = (html) => {
  return html.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
    return "&#" + i.charCodeAt(0) + ";";
  });
};
const htmlDecode = (str) => {
  const e = document.createElement("textarea");
  e.innerHTML = str;
  if (e.childNodes.length === 0) {
    return "";
  }
  const firstChildNode = e.childNodes[0];
  return firstChildNode.nodeValue;
};




/***/ }),

/***/ 775002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Browser": function() { return /* reexport */ Browser; },
  "COOKIE_OVER_18_YEARS_OLD": function() { return /* reexport */ storage_es/* COOKIE_OVER_18_YEARS_OLD */.kH; },
  "ConditionalWrapper": function() { return /* reexport */ tsx_es/* ConditionalWrapper */.M; },
  "ConditionalWrapperUsingCallback": function() { return /* reexport */ tsx_es/* ConditionalWrapperUsingCallback */.H; },
  "PATTERN_VALIDATION": function() { return /* reexport */ validators_es/* PATTERN_VALIDATION */.o0; },
  "cancelIdleCallback": function() { return /* reexport */ polyfill_es/* cancelIdleCallback */.GK; },
  "cleanObject": function() { return /* binding */ cleanObject; },
  "customizedMessage": function() { return /* binding */ customizedMessage; },
  "debounce": function() { return /* binding */ debounce; },
  "extractFromPath": function() { return /* reexport */ url_es/* extractFromPath */.FY; },
  "formatCurrency": function() { return /* binding */ formatCurrency; },
  "formatDate": function() { return /* reexport */ date_es/* formatDate */.p; },
  "getBrowser": function() { return /* reexport */ getBrowser; },
  "getCookieOver18YearOld": function() { return /* reexport */ storage_es/* getCookieOver18YearOld */.Iv; },
  "getObjFromQueryString": function() { return /* reexport */ url_es/* getObjFromQueryString */.r4; },
  "getUrlObject": function() { return /* reexport */ url_es/* getUrlObject */.Bi; },
  "getVersionBrowser": function() { return /* reexport */ getVersionBrowser; },
  "htmlDecode": function() { return /* reexport */ html_es/* htmlDecode */.l; },
  "htmlEncode": function() { return /* reexport */ html_es/* htmlEncode */.A; },
  "inIframe": function() { return /* binding */ inIframe; },
  "isChrome": function() { return /* reexport */ isChrome; },
  "isEdge": function() { return /* reexport */ isEdge; },
  "isEmptyObject": function() { return /* reexport */ object_es/* isEmptyObject */.Q; },
  "isFireFox": function() { return /* reexport */ isFireFox; },
  "isFloat": function() { return /* reexport */ number_es/* isFloat */.Q; },
  "isNotSupportRegexHasLookbehind": function() { return /* reexport */ isNotSupportRegexHasLookbehind; },
  "isSafari": function() { return /* reexport */ isSafari; },
  "isValidCitizenIdNumber": function() { return /* reexport */ validators_es/* isValidCitizenIdNumber */.cC; },
  "isValidEmailFormat": function() { return /* reexport */ validators_es/* isValidEmailFormat */.HY; },
  "isValidNewTaxCode": function() { return /* reexport */ validators_es/* isValidNewTaxCode */.y1; },
  "isValidPassportNumber": function() { return /* reexport */ validators_es/* isValidPassportNumber */.S7; },
  "isValidPhoneFormat": function() { return /* reexport */ validators_es/* isValidPhoneFormat */.Ew; },
  "isValidStateBudgetUnitCode": function() { return /* reexport */ validators_es/* isValidStateBudgetUnitCode */.PX; },
  "isValidTaxCode": function() { return /* reexport */ validators_es/* isValidTaxCode */.ss; },
  "normalizePhone": function() { return /* binding */ normalizePhone; },
  "normalizeText": function() { return /* reexport */ string_es/* normalizeText */.b; },
  "parseJsonStringSafely": function() { return /* reexport */ string_es/* parseJsonStringSafely */.O; },
  "requestIdleCallback": function() { return /* reexport */ polyfill_es/* requestIdleCallback */.Kk; },
  "resolveTekoPathname": function() { return /* reexport */ link_es/* resolveTekoPathname */.K; },
  "scheduleTaskInIdleTime": function() { return /* reexport */ polyfill_es/* scheduleTaskInIdleTime */.D_; },
  "setCookieOver18YearOld": function() { return /* reexport */ storage_es/* setCookieOver18YearOld */.zr; },
  "stringToInteger": function() { return /* reexport */ number_es/* stringToInteger */.C; },
  "toFixed": function() { return /* binding */ toFixed; },
  "toObject": function() { return /* binding */ toObject; }
});

// EXTERNAL MODULE: ../../packages/utils/dist/url.es.js
var url_es = __webpack_require__(987900);
// EXTERNAL MODULE: ../../packages/utils/dist/validators.es.js
var validators_es = __webpack_require__(432054);
// EXTERNAL MODULE: ../../packages/utils/dist/date.es.js
var date_es = __webpack_require__(889104);
// EXTERNAL MODULE: ../../packages/utils/dist/html.es.js
var html_es = __webpack_require__(531439);
// EXTERNAL MODULE: ../../packages/utils/dist/number.es.js
var number_es = __webpack_require__(927250);
// EXTERNAL MODULE: ../../packages/utils/dist/storage.es.js
var storage_es = __webpack_require__(653028);
// EXTERNAL MODULE: ../../packages/utils/dist/polyfill.es.js
var polyfill_es = __webpack_require__(593859);
// EXTERNAL MODULE: ../../packages/utils/dist/string.es.js
var string_es = __webpack_require__(679376);
// EXTERNAL MODULE: ../../packages/utils/dist/tsx.es.js
var tsx_es = __webpack_require__(974108);
// EXTERNAL MODULE: ../../packages/utils/dist/object.es.js
var object_es = __webpack_require__(535820);
// EXTERNAL MODULE: ../../packages/utils/dist/link.es.js
var link_es = __webpack_require__(350495);
;// CONCATENATED MODULE: ../../packages/utils/dist/browser.es.js
var Browser = /* @__PURE__ */ ((Browser2) => {
  Browser2["CHROME"] = "Chrome";
  Browser2["SAFARI"] = "Safari";
  Browser2["FIREFOX"] = "Firefox";
  Browser2["EDGE"] = "Edge";
  return Browser2;
})(Browser || {});
const getBrowser = () => {
  if (typeof window === "undefined") {
    return void 0;
  }
  if (navigator.userAgent.indexOf("Chrome" /* CHROME */) != -1) {
    return "Chrome" /* CHROME */;
  } else if (navigator.userAgent.indexOf("Edge" /* EDGE */) != -1) {
    return "Edge" /* EDGE */;
  } else if (navigator.userAgent.indexOf("Firefox" /* FIREFOX */) != -1) {
    return "Firefox" /* FIREFOX */;
  } else if (navigator.userAgent.indexOf("Safari" /* SAFARI */) != -1) {
    return "Safari" /* SAFARI */;
  } else {
    return void 0;
  }
};
const isChrome = getBrowser() === "Chrome" /* CHROME */;
const isEdge = getBrowser() === "Edge" /* EDGE */;
const isFireFox = getBrowser() === "Firefox" /* FIREFOX */;
const isSafari = getBrowser() === "Safari" /* SAFARI */;
const getVersionBrowser = () => {
  if (typeof window === "undefined") {
    return void 0;
  }
  const userAgent = navigator.userAgent;
  let match = userAgent.match(/Version\/(\d+)\.(\d+)/);
  if (isChrome) {
    match = userAgent.match(/Chrome\/(\d+)/) || userAgent.match(/CriOS\/(\d+)/);
  }
  if (isFireFox) {
    match = userAgent.match(/Firefox\/(\d+)/);
  }
  if (isEdge) {
    match = userAgent.match(/Edg\/(\d+)/);
  }
  if (match) {
    const majorVersion = parseInt(match[1], 10);
    const minorVersion = parseInt(match[2], 10);
    return { majorVersion, minorVersion };
  }
  return void 0;
};
const isNotSupportRegexHasLookbehind = () => {
  const version = getVersionBrowser();
  if (!version) {
    return false;
  }
  const { majorVersion, minorVersion } = version;
  if (isChrome) {
    return majorVersion <= 61;
  }
  if (isEdge) {
    return majorVersion <= 18;
  }
  if (isFireFox) {
    return majorVersion >= 77;
  }
  if (isSafari) {
    return majorVersion < 16 || majorVersion === 16 && minorVersion <= 3;
  }
  return false;
};



;// CONCATENATED MODULE: ../../packages/utils/dist/index.es.js













var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const normalizePhone = (rawphone) => {
  const phone = rawphone.trim();
  if (phone.length > 10) {
    if (phone.startsWith("84"))
      return phone.replace("84", "0");
    if (phone.startsWith("+84"))
      return phone.replace("+84", "0");
    return phone;
  }
  return phone;
};
const customizedMessage = (message, fields) => {
  let resultMessage = message;
  fields.forEach(({ name, value }) => {
    const regex = new RegExp(`{${name}}`, "g");
    resultMessage = resultMessage.replace(regex, value);
  });
  return resultMessage;
};
const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
const toObject = (arr, keyField) => {
  let newArr = {};
  if (Array.isArray(arr)) {
    for (let i = 0; i < arr.length; i++) {
      const curr = arr[i];
      newArr = __spreadProps(__spreadValues({}, newArr), {
        [curr[keyField]]: curr
      });
    }
  }
  return newArr;
};
const cleanObject = (object) => {
  if (!object) {
    return object;
  }
  const newObj = {};
  const currentKeys = Object.keys(object);
  currentKeys.forEach((key) => {
    if (object[key] || object[key] === false || object[key] === 0) {
      newObj[key] = object[key];
    }
  });
  return newObj;
};
const formatCurrency = (money, isFull = true, thousandSeparator = ".") => {
  return `${money || money == 0 ? money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`) : money}${isFull ? "\u0111" : ""}`;
};
function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}
const toFixed = ({
  value,
  precision,
  shouldRoundValue = true
}) => {
  return (!!shouldRoundValue ? Math.round(value * Math.pow(10, precision)) : Math.floor(value * Math.pow(10, precision))) / Math.pow(10, precision);
};




/***/ }),

/***/ 350495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ resolveTekoPathname; }
/* harmony export */ });
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(897914);
/* harmony import */ var next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(925726);
/* harmony import */ var next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_dist_shared_lib_router_utils_route_regex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1311);
/* harmony import */ var next_dist_shared_lib_router_utils_route_matcher__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(394665);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pagePaths = [];
async function resolveTekoPathname(url) {
  var _a;
  const newHref = { pathname: "", query: {} };
  const pageList = getSortedPages(await (0,next_dist_client_route_loader__WEBPACK_IMPORTED_MODULE_0__.getClientBuildManifest)());
  for (let i = 0; i < (customizedRoutes == null ? void 0 : customizedRoutes.length); ++i) {
    const { as, href } = customizedRoutes[i];
    const keys = [];
    const regex = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_3__/* .pathToRegexp */ .Bo)(as, keys);
    if (regex.test(url.pathname)) {
      const params = regex.exec(url.pathname);
      const combinedObject = Object.fromEntries(keys.map((k, i2) => [k.name, params == null ? void 0 : params[i2 + 1]]));
      const filteredObject = {};
      for (const k in combinedObject) {
        if (!/^[0-9]*$/g.test(k.toString())) {
          filteredObject[k] = combinedObject[k];
        }
      }
      const query = filteredObject;
      newHref.pathname = href;
      newHref.query = __spreadValues(__spreadValues(__spreadValues({}, query), getQuerystringObject(url.searchParams)), url.query);
      return newHref;
    }
  }
  for (let i = 0; i < pageList.length; ++i) {
    const normalizedRoute = (_a = /\/(.*)\/(mobile|desktop)(.*)/.exec(pageList[i])) == null ? void 0 : _a[3];
    if (normalizedRoute) {
      const routeRegex = (0,next_dist_shared_lib_router_utils_route_regex__WEBPACK_IMPORTED_MODULE_1__.getRouteRegex)(normalizedRoute);
      const matcher = (0,next_dist_shared_lib_router_utils_route_matcher__WEBPACK_IMPORTED_MODULE_2__.getRouteMatcher)(routeRegex)(url.pathname);
      if (matcher) {
        newHref.pathname = pageList[i];
        newHref.query = __spreadValues(__spreadValues(__spreadValues({}, matcher), getQuerystringObject(url.searchParams)), url.query);
        return newHref;
      }
    }
  }
  return newHref;
}
function getSortedPages(clientBuildManifest) {
  const pages = clientBuildManifest.sortedPages || [];
  if (pagePaths.length === 0) {
    const defaultPaths = pages.filter((p) => p.includes("/default/"));
    const customPaths = pages.filter((p) => !p.includes("/default/"));
    pagePaths.push(...customPaths, ...defaultPaths);
  }
  return pagePaths;
}
function getQuerystringObject(qs) {
  const ret = {};
  if (!qs)
    return ret;
  for (const p of qs) {
    ret[p[0]] = p[1];
  }
  return ret;
}
const contentSlugs = [
  "chinh-sach-bao-hanh",
  "huong-dan-xem-bao-cao-danh-cho-bo-cong-thuong",
  "chinh-sach-bao-mat",
  "chinh-sach-bao-mat-thanh-toan",
  "chinh-sach-bao-mat-thong-tin",
  "chinh-sach-bao-mat-thong-tin-ca-nhan",
  "chinh-sach-bao-mat-va-chia-se-thong-tin",
  "chinh-sach-bao-mat-va-su-dung",
  "chinh-sach-chiet-khau-uu-dai-mua-sam",
  "chinh-sach-doi-tra",
  "chinh-sach-doi-tra-va-hoan-tien",
  "chinh-sach-giai-quyet-khieu-nai",
  "chinh-sach-giao-hang",
  "chinh-sach-giao-nhan",
  "chinh-sach-kiem-hang",
  "chinh-sach-thanh-toan",
  "chinh-sach-thanh-vien",
  "chinh-sach-the-thanh-vien",
  "chinh-sach-uu-dai",
  "chinh-sach-van-chuyen",
  "chinh-sach-van-chuyen-va-giao-nhan",
  "co-che-dang-tai-thong-tin",
  "danh-sach-cua-hang",
  "dieu-khoan-su-dung",
  "dieu-khoan-va-dieu-kien-giao-dich",
  "gioi-thieu",
  "he-thong-thoi-vang-tich-luy",
  "hinh-thuc-giao-hang",
  "hinh-thuc-thanh-toan",
  "huong-dan-dang-ky-tai-khoan",
  "huong-dan-dat-hang",
  "huong-dan-dat-hang-tren-website",
  "huong-dan-dat-hang-va-dieu-khoan-hop-dong",
  "huong-dan-su-dung",
  "huong-dan-thanh-toan-vnpayqr",
  "quan-ly-chat-luong",
  "quy-che-cung-cap-dich-vu",
  "quy-dinh-va-hinh-thuc-thanh-toan",
  "thong-tin-lien-he",
  "thong-tin-san-pham",
  "thong-tin-ve-dieu-kien-giao-dich"
];
const customizedRoutes = [
  {
    as: "/landing/:id.html",
    href: "/landing/[id]"
  },
  {
    as: "/(.*)-cat.:categoryId([A-Za-z0-9._-]{1,20})",
    href: "/block-categories/[categoryId]"
  },
  {
    as: "/(.*)-scat.:sellerCategoryId([A-Za-z0-9._-]{1,20})",
    href: "/seller-categories/[sellerCategoryId]"
  },
  {
    as: "/(.*)-sel.:sellerId([A-Za-z0-9._-]{1,20})",
    href: "/sellers/[sellerId]"
  },
  {
    as: "/(.*)-brand.:brandId([A-Za-z0-9._-]{1,20})",
    href: "/brands/[brandId]"
  },
  {
    as: "/(.*)-s:sku([A-Za-z0-9._-]{1,20}).html",
    href: "/products/[sku]"
  },
  {
    as: "/(.*)--s:sku([A-Za-z0-9._-]{1,20})",
    href: "/products/[sku]"
  },
  {
    as: "/(.*)--p:productId([A-Za-z0-9._-]{1,20})",
    href: "/products/detail/[productId]"
  },
  {
    as: "/(.*)-:menuItemId.cat",
    href: "/categories/[menuItemId]"
  },
  {
    as: "/(.*)-c:menuItemId([0-9]{1,})",
    href: "/categories/[menuItemId]"
  },
  {
    as: `/:id(${contentSlugs.join("|")})`,
    href: "/content/[id]"
  }
];




/***/ }),

/***/ 927250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ stringToInteger; },
/* harmony export */   "Q": function() { return /* binding */ isFloat; }
/* harmony export */ });
const isFloat = (n) => Number(n) === n && n % 1 !== 0;
const stringToInteger = (value, fallback) => {
  try {
    return Number.parseInt(value);
  } catch (_) {
    return fallback || void 0;
  }
};




/***/ }),

/***/ 535820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ isEmptyObject; }
/* harmony export */ });
const isEmptyObject = (obj) => {
  return !obj || Object.keys(obj).length === 0;
};




/***/ }),

/***/ 593859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D_": function() { return /* binding */ scheduleTaskInIdleTime; },
/* harmony export */   "GK": function() { return /* binding */ cancelIdleCallback; },
/* harmony export */   "Kk": function() { return /* binding */ requestIdleCallback; }
/* harmony export */ });
function requestIdleCallback(callback, options = { timeout: 2e3 }) {
  if (typeof window !== "undefined") {
    if ("requestIdleCallback" in window) {
      return window.requestIdleCallback(callback, options);
    } else {
      return _requestIdleCallback(callback);
    }
  } else {
    return _requestIdleCallback(callback);
  }
}
function cancelIdleCallback(id) {
  if (typeof window !== "undefined") {
    if ("cancelIdleCallback" in window) {
      window.cancelIdleCallback(id);
    } else {
      _cancelIdleCallback(id);
    }
  }
}
function _requestIdleCallback(cb) {
  const start = Date.now();
  return window.setTimeout(function() {
    cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
}
function _cancelIdleCallback(id) {
  clearTimeout(id);
}
function scheduleTaskInIdleTime(cb, timeout, minTimeForProcessing = 0) {
  const deadline = Date.now() + timeout;
  const schedule = (timeout2) => requestIdleCallback((idleData) => {
    const now = Date.now();
    if (now >= deadline || idleData.timeRemaining() > minTimeForProcessing)
      return cb();
    schedule(deadline - now);
  }, { timeout: timeout2 });
  schedule(timeout);
}




/***/ }),

/***/ 653028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iv": function() { return /* binding */ getCookieOver18YearOld; },
/* harmony export */   "kH": function() { return /* binding */ COOKIE_OVER_18_YEARS_OLD; },
/* harmony export */   "zr": function() { return /* binding */ setCookieOver18YearOld; }
/* harmony export */ });
const COOKIE_OVER_18_YEARS_OLD = "over_18_years_old";
const setCookieOver18YearOld = (value, exTime = 720) => {
  if (typeof document !== "undefined") {
    const d = new Date();
    d.setTime(d.getTime() + exTime * 60 * 60 * 1e3);
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${COOKIE_OVER_18_YEARS_OLD}=${value};${expires};path=/`;
  }
};
const getCookieOver18YearOld = () => {
  if (typeof document !== "undefined") {
    const name = `${COOKIE_OVER_18_YEARS_OLD}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length) === "true";
      }
    }
  }
  return false;
};




/***/ }),

/***/ 679376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ parseJsonStringSafely; },
/* harmony export */   "b": function() { return /* binding */ normalizeText; }
/* harmony export */ });
const parseJsonStringSafely = (value, fallback) => {
  try {
    if (!value)
      return fallback || void 0;
    return JSON.parse(value);
  } catch (e) {
    return fallback || void 0;
  }
};
const normalizeText = (text, withoutSpaces = false) => {
  let str = text.toLowerCase().trim();
  str = str.replace(/\s+/g, withoutSpaces ? "" : " ");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  return str;
};




/***/ }),

/***/ 974108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ConditionalWrapperUsingCallback; },
/* harmony export */   "M": function() { return /* binding */ ConditionalWrapper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function ConditionalWrapper(_a) {
  var _b = _a, {
    children,
    condition,
    wrapper: Wrapper
  } = _b, wrapperProps = __objRest(_b, [
    "children",
    "condition",
    "wrapper"
  ]);
  return condition ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, wrapperProps), children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
}
const ConditionalWrapperUsingCallback = ({ children, condition, wrapperCallback }) => {
  return condition ? wrapperCallback(children) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
};




/***/ }),

/***/ 987900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ getUrlObject; },
/* harmony export */   "FY": function() { return /* binding */ extractFromPath; },
/* harmony export */   "r4": function() { return /* binding */ getObjFromQueryString; }
/* harmony export */ });
const getObjFromQueryString = (str) => {
  const urlParams = new URLSearchParams(str);
  const result = {};
  for (const pair of urlParams.entries()) {
    result[pair[0]] = pair[1];
  }
  return result;
};
const regexes = [
  {
    regex: /-s([A-Za-z0-9._-]{1,20})\.html/,
    pathname: "/products/[sku]",
    paramName: "sku"
  },
  {
    regex: /--s([A-Za-z0-9._-]{1,20})/,
    pathname: "/products/[sku]",
    paramName: "sku"
  },
  {
    regex: /-(.*)\.cat/,
    pathname: "/categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-c([0-9]{1,})/,
    pathname: "/categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-cat\.(.*)/,
    pathname: "/block-categories/[categoryId]",
    paramName: "categoryId"
  },
  {
    regex: /-sel\.(.*)/,
    pathname: "/sellers/[sellerId]",
    paramName: "sellerId"
  },
  {
    regex: /-brand\.(.*)/,
    pathname: "/brands/[brandId]",
    paramName: "brandId"
  }
];
const extractFromPath = (path) => {
  for (const reg of regexes) {
    const matchResult = path.match(reg.regex);
    if (matchResult) {
      return {
        pathname: reg.pathname,
        query: {
          [reg.paramName]: matchResult[1]
        }
      };
    }
  }
  return path;
};
function getUrlObject(href) {
  try {
    return new URL(href);
  } catch (e) {
    if (!href.startsWith("/")) {
      href = "/" + href;
    }
    return new URL(`https://fake.com${href}`);
  }
}




/***/ }),

/***/ 432054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ew": function() { return /* binding */ isValidPhoneFormat; },
/* harmony export */   "HY": function() { return /* binding */ isValidEmailFormat; },
/* harmony export */   "PX": function() { return /* binding */ isValidStateBudgetUnitCode; },
/* harmony export */   "S7": function() { return /* binding */ isValidPassportNumber; },
/* harmony export */   "cC": function() { return /* binding */ isValidCitizenIdNumber; },
/* harmony export */   "o0": function() { return /* binding */ PATTERN_VALIDATION; },
/* harmony export */   "ss": function() { return /* binding */ isValidTaxCode; },
/* harmony export */   "y1": function() { return /* binding */ isValidNewTaxCode; }
/* harmony export */ });
const PATTERN_VALIDATION = {
  email: /^[a-zA-Z0-9_][a-zA-Z0-9_.+-]{1,32}@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,7}$/,
  emailEdu: /^[a-zA-Z0-9_][a-zA-Z0-9_.+-]{1,32}@[A-Za-z0-9.-]+\.edu(\.[A-Z|a-z]{2,7})?$/,
  phone: /^([+84|84|0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b$/,
  vietnameseName: /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵýỷỹ\s\w|_]+$/,
  taxCode: /^[A-Za-z0-9]{10}(-[A-Za-z0-9]{3})?$/,
  newTaxCode: /^([A-Za-z0-9]{10}(-[A-Za-z0-9]{3})?|[0-9]{12})$/
};
const isValidEmailFormat = (email) => {
  return PATTERN_VALIDATION.email.test(email);
};
const isValidPhoneFormat = (number) => {
  return !!number.match(/^((\+84|0)(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})$/);
};
const isValidTaxCode = (code) => {
  return PATTERN_VALIDATION.taxCode.test(code);
};
const isValidNewTaxCode = (code) => {
  return PATTERN_VALIDATION.newTaxCode.test(code);
};
const isValidCitizenIdNumber = (code) => {
  return /^(\d{9}|\d{12})$/.test(code);
};
const isValidPassportNumber = (code) => {
  return code !== "" && code.length <= 20;
};
const isValidStateBudgetUnitCode = (code) => {
  return /^[12378]\d{6}$/.test(code);
};




/***/ }),

/***/ 77104:
/***/ (function(module) {

"use strict";
module.exports = crypto;

/***/ }),

/***/ 482909:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [97270,57645,98348,91961,300,14560,40179], function() { return __webpack_exec__(546580), __webpack_exec__(874272); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);